let languagePack;
languagePack = {
  supportedLocales: [
    "en-GB",
    "en-US",
    "jp-JP",
    "zh-CN",
    "de-DE",
    "fr-FR",
    "it-IT",
    "pt-PT",
    "es-ES",
    "ru-RU",
    "pl-PL"
  ],
  packs: {
    login_login: [
      "Login",
      "Login",
      "ログイン",
      "登录",
      "Anmelden",
      "S'identifier",
      "Accedi",
      "Iniciar sessão",
      "Entrar",
      "Вход",
      "Login",
      "login_login"
    ],
    login_welcome: [
      "<strong>TREND</strong> AnyWARE",
      "<strong>TREND</strong> AnyWARE",
      "<strong>TREND</strong> AnyWARE",
      "<strong>TREND</strong> AnyWARE",
      "<strong>TREND</strong> AnyWARE",
      "<strong>TREND</strong> AnyWARE",
      "<strong>TREND</strong> AnyWARE",
      "<strong>TREND</strong> AnyWARE",
      "<strong>TREND</strong> AnyWARE",
      "<strong>TREND</strong> AnyWARE",
      "<mocne>TREND</mocne> AnyWARE",
      "login_welcome"
    ],
    signup_welcome: [
      "About <strong>TREND</strong> AnyWARE",
      "About <strong>TREND</strong> AnyWARE",
      "<strong>TREND</strong> AnyWAREについて",
      "关于 <strong>TREND</strong> AnyWARE",
      "Über <strong>TREND</strong> AnyWARE",
      "À propos d'<strong>TREND</strong> AnyWARE",
      "Informazioni su <strong>TREND</strong> AnyWARE",
      "Sobre o <strong>TREND</strong> AnyWARE",
      "About <strong>TREND</strong> AnyWARE E",
      "Сведения об устройстве <strong>TREND</strong> AnyWARE",
      "O<mocne>TREND</mocne> AnyWARE",
      "signup_welcome"
    ],
    signup_welcome_text: [
      "TREND AnyWARE™ Cloud test management system makes managing, editing and sharing reports easier than ever for installers and technicians using TREND's range of certification, qualification and verification testers.",
      "TREND AnyWARE™ Cloud test management system makes managing, editing and sharing reports easier than ever for installers and technicians using TREND's range of certification, qualification and verification testers.",
      "TREND AnyWARE™ クラウド テスト管理システムは、TREND のさまざまな認定、資格、および検証テスターを使用して、設置者と技術者がレポートを管理、編集、共有することをこれまで以上に簡単にします。",
      "当TREND AnyWARE™ Cloud测试管理系统让使用 TREND的电缆认证测试仪，传输测试仪，验证测试仪的安装和技术人员更轻松的管理，编辑和分享测试报告。",
      "Das Testmanagementsystem der TREND AnyWARE™ Cloud macht das Verwalten, Bearbeiten und Freigeben von Berichten für Installateure und Techniker einfacher als je zuvor. Nutzen Sie daher unsere Zertifizierungs-, Qualifizierungs- und Verifizierungstester für ihre nächste Installation.",
      "Le système TREND AnyWARE™ Cloud de gestion des tests, permet de partager dans le Cloud les mesures réalisées puis d’éditer des rapports PDF, pour différents appareils de la gamme TREND Networks dont les certificateurs, qualificateurs et vérificateurs.",
      "Il sistema di gestione dei test TREND AnyWARE™ Cloud semplifica più che mai la gestione, la modifica e la condivisione dei rapporti dei test per installatori e tecnici utilizzando la gamma di tester per certificazione, qualifica e verifica di TREND.",
      "O sistema de gerenciamento de testes TREND AnyWARE™ Cloud torna a gestão, edição e compartilhamento de relatórios mais fácil do que nunca para os instaladores e técnicos que utilizam a gama de testadores de certificação, qualificação e verificação da TREND.",
      "El sistema de administración de pruebas TREND AnyWARE™ Cloud hace que administrar, editar y compartir informes sea más fácil que nunca para los instaladores y técnicos que utilizan la gama de probadores de certificación, calificación y verificación de TREND.",
      "Система управления испытаниями TREND AnyWARE™ Cloud упрощает управление, редактирование и совместное использование отчетов для установщиков и технических специалистов, использующих линейку сертификационных, квалификационных и проверочных тестеров TREND.",
      "System zarządzania testami TREND AnyWARE™ Cloud sprawia, że zarządzanie, edytowanie i udostępnianie raportów jest łatwiejsze niż kiedykolwiek dla instalatorów i techników korzystających z gamy testerów certyfikacyjnych, kwalifikacyjnych i weryfikacyjnych TREND.",
      "signup_welcome_text"
    ],
    signup_here: [
      "sign up",
      "sign up",
      "サインアップ",
      "注册",
      "Registrieren",
      "S'enregistrer",
      "registrati",
      "Cadastrar-se",
      "Registrarse",
      "Зарегистрироваться",
      "zapisz się",
      "signup_here"
    ],
    login_username: [
      "Email Address",
      "Email Address",
      "メールアドレス",
      "电子邮件地址",
      "E-Mail-Adresse",
      "Adresse email",
      "Indirizzo e-mail",
      "Endereço de e-mail",
      "Correo electrónico",
      "Адрес электронной почты",
      "Adres e-mail",
      "login_username"
    ],
    login_password: [
      "Password",
      "Password",
      "パスワード",
      "密码",
      "Passwort",
      "Mot de passe",
      "Password",
      "Senha",
      "Contraseña",
      "Пароль",
      "Hasło",
      "login_password"
    ],
    login_message: [
      "Enter your log in details below to proceed",
      "Enter your log in details below to proceed",
      "続行するには以下にログイン情報を入力してください",
      "在下面输入您的登录信息以继续",
      "Bitte tragen Sie Ihre Anmeldedaten ein",
      "Veuillez saisir vos identifiants ci-dessous pour continuer",
      "Per continuare, inserisci in basso i tuoi dettagli di accesso",
      "Informe seus dados de acesso para continuar",
      "Ingrese datos de acceso abajo para continuar",
      "Для продолжения введите учетные данные",
      "Zaloguj się, aby kontynuować",
      "login_message"
    ],
    login_error: [
      "There was a problem with your details",
      "There was a problem with your details",
      "入力した情報に問題があります",
      "您的详细信息存在问题",
      "Es ist ein Fehler aufgetreten",
      "Un problème est survenu lors de la saisie de vos identifiants",
      "Si è verificato un problema con i tuoi dettagli",
      "Houve um problema com suas informações",
      "”Hubo un problema con sus datos",
      "Возникла проблема с вашими данными",
      "Wystąpił problem z logowaniem",
      "login_error"
    ],
    login_invalid: [
      "Your username, password or both are invalid",
      "Your username, password or both are invalid",
      "ユーザー名かパスワードのいずれか、または両方が無効です",
      "您的用户名或密码无效",
      "Der Benutzername und/oder das Passwort sind ungültig",
      "Votre identifiant, mot de passe, ou les deux sont incorrects",
      "Il tuo nome utente, la password o entrambi non sono validi",
      "Nome de usuário, senha ou ambos são inválidos",
      "Nombre de usuario o contraseña inválidos",
      "Имя пользователя и/или пароль введены неверно",
      "Nazwa użytkownika, hasło lub jedno i drugie są nieprawidłowe",
      "login_invalid"
    ],
    login_failed: [
      "There was a problem trying to login",
      "There was a problem trying to login",
      "ログインを試みる際に問題が発生しました",
      "登录时出现问题",
      "Die Anmeldung konnte nicht durchgeführt werden",
      "Un problème est survenu lors de votre identification",
      "Si è verificato un problema durante il tentativo di accesso",
      "Houve um problema ao tentar iniciar a sessão",
      "Hubo un problema al intentar acceder",
      "Ошибка входа",
      "Wystąpił problem z logowaniem",
      "login_failed"
    ],
    forgot_password_help: [
      "Forgot password?",
      "Forgot password?",
      "パスワードを忘れた場合",
      "忘记密码？",
      "Passwort vergessen?",
      "Vous avez oublié votre mot de passe ?",
      "Hai dimenticato la password?",
      "Esqueceu a senha?",
      "¿Olvidó la contraseña?",
      "Забыли пароль?",
      "Zapomniałeś hasło?",
      "forgot_password_help"
    ],
    password_reset_check_mail: [
      "Please check your mail",
      "Please check your mail",
      "メールを確認してください",
      "请检查您的邮件",
      "Bitte prüfen Sie Ihre E-Mail",
      "Veuillez vérifier svp votre adresse email",
      "Controlla le tue e-mail",
      "Verifique sua caixa de e-mail",
      "Compruebe su correo",
      "Проверьте почту",
      "Sprawdź skrzynkę e-mail",
      "password_reset_check_mail"
    ],
    reset_welcome: [
      "TREND AnyWARE Password Reset",
      "TREND AnyWARE Password Reset",
      "TREND AnyWAREパスワードのリセット",
      "TREND AnyWARE 密码重置",
      "Passwort von TREND AnyWARE zurücksetzen",
      "Réinitialisation du mot de passe TREND AnyWARE",
      "Ripristino della password di TREND AnyWARE",
      "Redefinição da senha do TREND AnyWARE",
      "Resetear contraseña de TREND AnyWARE",
      "Сброс пароля TREND AnyWARE",
      "Resetowanie hasła do TREND AnyWARE ",
      "reset_welcome"
    ],
    reset_message: [
      "Please reset your password",
      "Please reset your password",
      "パスワードをリセットしてください",
      "请重置您的密码",
      "Bitte setzen Sie Ihr Passwort zurück",
      "Veuillez réinitialiser svp votre mot de passe",
      "Ripristina la tua password",
      "Por favor, redefina sua senha",
      "Resetear contraseña",
      "Выполните сброс пароля",
      "Resetuj hasło",
      "reset_message"
    ],
    reset_error: [
      "There was a problem resetting your password",
      "There was a problem resetting your password",
      "パスワードをリセットする際に問題が発生しました",
      "重置您的密码时出错",
      "Beim Zurücksetzen des Passworts ist ein Fehler aufgetreten",
      "Un problème est survenu lors de la réinitialisation de votre mot de passe",
      "Si è verificato un problema con il ripristino della password",
      "Houve um problema ao redefinir sua senha",
      "Hubo un problema al resetear su contraseña",
      "Ошибка сброса пароля",
      "Wystąpił problem z resetowaniem hasła",
      "reset_error"
    ],
    reset_weak: [
      "Password too weak",
      "Password too weak",
      "パスワードが脆弱すぎます",
      "密码安全性太弱",
      "Das Passwort ist zu schwach",
      "Le mot de passe est trop faible",
      "La password non è abbastanza sicura",
      "Senha muito fraca",
      "Contraseña no segura",
      "Пароль слишком простой",
      "Hasło zbyt słabe",
      "reset_weak"
    ],
    reset_match: [
      "Passwords do not match",
      "Passwords do not match",
      "パスワードが一致しません",
      "密码不匹配",
      "Die Passwörter stimmen nicht überein",
      "Les mots de passe ne correspondent pas",
      "Le password non corrispondono",
      "As senhas não correspondem",
      "Las contraseñas no coinciden",
      "Пароли не совпадают",
      "Hasła nie pasują do siebie",
      "reset_match"
    ],
    reset_password: [
      "Password",
      "Password",
      "パスワード",
      "密码",
      "Passwort",
      "Mot de passe",
      "Password",
      "Senha",
      "Contraseña",
      "Пароль",
      "Hasło",
      "reset_password"
    ],
    reset_password_confirm: [
      "Confirm Password",
      "Confirm Password",
      "パスワードの確認",
      "确认密码",
      "Passwort bestätigen",
      "Confirmer svp le mot de passe",
      "Conferma password",
      "Confirme a senha",
      "Confirmar contraseña",
      "Подтверждение пароля",
      "Zatwierdź hasło",
      "reset_password_confirm"
    ],
    reset_reset: [
      "Reset",
      "Reset",
      "リセット",
      "重置",
      "Zurücksetzen",
      "Réinitialiser",
      "Reimposta",
      "Redefinir",
      "Resetear",
      "Сброс",
      "Resetuj",
      "reset_reset"
    ],
    password_reset_successfull_toast: [
      "Password reset successful",
      "Password reset successful",
      "パスワードのリセットに成功しました",
      "密码重置成功",
      "Das Passwort wurde erfolgreich zurückgesetzt",
      "Le mot de passe a été réinitialisé avec succès",
      "Ripristino della password effettuato correttamente",
      "Senha redefinida com sucesso",
      "Contraseña reseteada",
      "Пароль сброшен",
      "Resetowanie hasła powiodło się",
      "password_reset_successfull_toast"
    ],
    password_reset_failed_toast: [
      "Password Reset Failed",
      "Password Reset Failed",
      "パスワードのリセットに失敗しました",
      "密码重置失败",
      "Das Passwort konnte nicht zurückgesetzt werden",
      "Échec de la réinitialisation du mot de passe",
      "Ripristino della password non riuscito",
      "Falha ao redefinir a senha",
      "Reseteo fallido",
      "Ошибка сброса пароля",
      "Resetowanie hasła nie powiodło się",
      "password_reset_failed_toast"
    ],
    set_password_welcome: [
      "Welcome to AnyWARE",
      "Welcome to AnyWARE",
      "AnyWAREへようこそ",
      "欢迎使用 AnyWARE",
      "Herzlich willkommen bei AnyWARE",
      "Bienvenue sur AnyWARE",
      "Benvenuto a AnyWARE",
      "Bem-vindo ao AnyWARE",
      "Bienvenido a AnyWARE",
      "Вас приветствует AnyWARE",
      "Witamy w AnyWARE",
      "set_password_welcome"
    ],
    set_password_password: [
      "Password",
      "Password",
      "パスワード",
      "密码",
      "Passwort",
      "Mot de passe",
      "Password",
      "Senha",
      "Contraseña",
      "Пароль",
      "Hasło",
      "set_password_password"
    ],
    set_password_confirm: [
      "Confirm Password",
      "Confirm Password",
      "パスワードの確認",
      "确认密码",
      "Passwort bestätigen",
      "Confirmer svp le mot de passe",
      "Conferma password",
      "Confirme a senha",
      "Confirmar Contraseña",
      "Подтверждение пароля",
      "Zatwierdź hasło",
      "set_password_confirm"
    ],
    set_password_set: [
      "Set",
      "Set",
      "設定",
      "设置",
      "Festlegen",
      "Définir",
      "Imposta",
      "Definir",
      "Establecer",
      "Установить",
      "Ustal",
      "set_password_set"
    ],
    set_password_message: [
      "Please Set Your Password",
      "Please Set Your Password",
      "パスワードを設定してください",
      "请设置您的密码",
      "Bitte legen Sie Ihr Passwort fest",
      "Veuillez définir svp votre mot de passe",
      "Imposta la tua password",
      "Por favor, defina sua senha",
      "Establecer Contraseña",
      "Установите пароль",
      "Ustal hasło",
      "set_password_message"
    ],
    password_set_successfull_toast: [
      "Password set successful",
      "Password set successful",
      "パスワードの設定に成功しました",
      "密码设置成功",
      "Das Passwort wurde erfolgreich festgelegt",
      "Mot de passe défini avec succès",
      "Impostazione della password effettuata correttamente",
      "Senha definida com sucesso",
      "Contraseña establecida",
      "Пароль установлен",
      "Ustalenie hasła powiodło się",
      "password_set_successfull_toast"
    ],
    password_set_failed_toast: [
      "Password Set Failed",
      "Password Set Failed",
      "パスワードの設定に失敗しました",
      "密码设置失败",
      "Fehler beim Festlegen des Passworts",
      "Échec de la configuration du mot de passe",
      "Impostazione della password non riuscita",
      "Falha ao definir a senha",
      "Establecimiento fallido",
      "Ошибка установки пароля",
      "Ustalenie hasła nie powiodło się",
      "password_set_failed_toast"
    ],
    password_set_invalid_token: [
      "Invalid Token",
      "Invalid Token",
      "無効なトークン",
      "令牌无效",
      "Ungültige Eingabe",
      "Saisie non valide",
      "Token non valido",
      "Símbolo inválido",
      "Token inválido",
      "Недопустимый знак",
      "Nieprawidłowy token",
      "password_set_invalid_token"
    ],
    forgot_welcome: [
      "Forgotten Password",
      "Forgotten Password",
      "パスワードを忘れた場合",
      "忘记密码",
      "Passwort vergessen",
      "Mot de passe oublié",
      "Password dimenticata",
      "Senha esquecida",
      "Contraseña olvidada",
      "Забыли пароль",
      "Zapomniane hasło",
      "forgot_welcome"
    ],
    forgot_message: [
      "Complete the form to receive an email with a password reset link",
      "Complete the form to receive an email with a password reset link",
      "フォームに入力すると、パスワードをリセットするためのリンクが記載されたメールが届きます",
      "填写该表格，以便收到带有密码重置链接的电子邮件",
      "Bitte füllen Sie das Formular aus, damit wir Ihnen einen E-Mail mit einem Link zum Zurücksetzen des Passworts zusenden können",
      "Veuillez remplir svp le formulaire pour recevoir un email avec un lien de réinitialisation du mot de passe",
      "Compila il modulo per ricevere un'e-mail con un collegamento di ripristino della password",
      "Preencha o formulário para receber um e-mail com o link de redefinição da senha",
      "Rellene el form. para recibir un enlace de reseteo de contraseña por correo",
      "Заполните форму, чтобы получить по электронной почте ссылку для сброса пароля",
      "Wypełnij formularz, aby otrzymać wiadomość e-mail z linkiem do resetowania hasła",
      "forgot_message"
    ],
    forgot_email: [
      "Enter your email",
      "Enter your email",
      "メールアドレスを入力してください",
      "输入您的电子邮件地址",
      "Tragen Sie hier Ihre E-Mail-Adresse ein",
      "Entrez votre email",
      "Inserisci il tuo indirizzo e-mail",
      "Informe seu e-mail",
      "Introducir correo electrónico",
      "Введите адрес электронной почты",
      "Wprowadź e-mail",
      "forgot_email"
    ],
    forgot_error: [
      "There was a problem with the form",
      "There was a problem with the form",
      "フォームに問題があります",
      "表格有问题",
      "Es ist ein Fehler aufgetreten",
      "Un problème est survenu avec le formulaire",
      "Si è verificato un problema con il modulo",
      "Houve um problema com o formulário",
      "Hubo un problema con el formulario",
      "Возникла проблема с формой",
      "Wystąpił problem z wysłaniem formularza",
      "forgot_error"
    ],
    forgot_forgot: [
      "Send",
      "Send",
      "送信",
      "发送",
      "Absenden",
      "Envoyer",
      "Invia",
      "Enviar",
      "Enviar",
      "Отправить",
      "Wyślij",
      "forgot_forgot"
    ],
    forgot_password_error_nouser: [
      "User doesn't exist",
      "User doesn't exist",
      "ユーザーが存在しません",
      "用户不存在",
      "Diesen Benutzernamen gibt es nicht",
      "L'utilisateur n'existe pas",
      "L'utente non esiste",
      "Usuário inexistente",
      "El usuario no existe",
      "Пользователь не существует",
      "Użytkownik nie istnieje",
      "forgot_password_error_nouser"
    ],
    signup_welcome_title: [
      "Create <strong>TREND</strong> AnyWARE account",
      "Create <strong>TREND</strong> AnyWARE account",
      "<strong>TREND</strong> AnyWAREアカウントを作成",
      "创建 <strong>TREND</strong> AnyWARE 帐户",
      "Erstellen Sie ein neues <strong>TREND</strong> AnyWARE Konto",
      "Créer un compte <strong>TREND</strong> AnyWARE",
      "Crea un account <strong>TREND</strong> AnyWARE",
      "Criar conta do <strong>TREND</strong> AnyWARE",
      "Crear cuenta <strong>TREND</strong> AnyWARE",
      "Создать учетную запись <strong>TREND</strong> AnyWARE",
      "Utwórz konto <mocne>TREND</mocne> AnyWARE",
      "signup_welcome_title"
    ],
    signup_title: [
      "Title",
      "Title",
      "タイトル",
      "称谓",
      "Titel",
      "Titre",
      "Titolo",
      "Tratamento",
      "Título",
      "Звание",
      "Tytuł",
      "signup_title"
    ],
    signup_firstname: [
      "First name",
      "First name",
      "名",
      "名字",
      "Vorname",
      "Prénom",
      "Nome",
      "Nome",
      "Nombre",
      "Имя",
      "Imię",
      "signup_firstname"
    ],
    signup_lastname: [
      "Last Name",
      "Last Name",
      "姓",
      "姓氏",
      "Nachname",
      "Nom",
      "Cognome",
      "Sobrenome",
      "Apellido",
      "Фамилия",
      "Nazwisko",
      "signup_lastname"
    ],
    signup_emailaddress: [
      "Email address",
      "Email address",
      "メールアドレス",
      "电子邮件地址",
      "E-Mail-Adresse",
      "Adresse email",
      "Indirizzo e-mail",
      "Endereço de e-mail",
      "Correo electrónico",
      "Адрес электронной почты",
      "Adres e-mail",
      "signup_emailaddress"
    ],
    signup_contactnumber: [
      "Contact number",
      "Contact number",
      "連絡先番号",
      "联系人电话",
      "Kontaktnummer",
      "Numéro de téléphone",
      "Numero di contatto",
      "Telefone de contato",
      "Núm. contacto",
      "Контактный номер",
      "Numer kontaktowy",
      "signup_contactnumber"
    ],
    signup_companyname: [
      "Company name",
      "Company name",
      "会社名",
      "公司名称",
      "Firmenname",
      "Nom de l'entreprise",
      "Nome della società",
      "Nome da empresa",
      "Nombre de empresa",
      "Название компании",
      "Nazwa firmy",
      "signup_companyname"
    ],
    signup_password: [
      "Password",
      "Password",
      "パスワード",
      "密码",
      "Passwort",
      "Mot de passe",
      "Password",
      "Senha",
      "Contraseña",
      "Пароль",
      "Hasło",
      "signup_password"
    ],
    signup_confirmpassword: [
      "Confirm password",
      "Confirm password",
      "パスワードの確認",
      "确认密码",
      "Passwort bestätigen",
      "Confirmer svp le mot de passe",
      "Conferma password",
      "Confirmar senha",
      "Confirmar contraseña",
      "Подтверждение пароля",
      "Zatwierdź hasło",
      "signup_confirmpassword"
    ],
    signup_terms_and_conditions: [
      "I agree to the Terms & Conditions",
      "I agree to the Terms & Conditions",
      "利用規約に同意します",
      "我同意本条款与条件",
      "Ich erkläre mich mit den allgemeinen Geschäftsbedingungen einverstanden",
      "J'accepte les termes et conditions",
      "Accetto Termini e condizioni",
      "Eu concordo com os Termos e Condições",
      "Acepto las condiciones de uso",
      "Принимаю условия использования",
      "Zgadzam się z Regulaminem",
      "signup_terms_and_conditions"
    ],
    already_have_an_account: [
      "Already have an account?",
      "Already have an account?",
      "既にアカウントをお持ちの場合",
      "已经有帐户？",
      "Sie besitzen bereits ein Konto?",
      "Vous possédez déjà un compte ?",
      "Hai già un account?",
      "Já possui uma conta?",
      "¿Ya tiene una cuenta?",
      "Уже есть учетная запись?",
      "Masz już konto?",
      "already_have_an_account"
    ],
    sign_in_here: [
      "Sign in here",
      "Sign in here",
      "ここからサインイン",
      "在此注册",
      "Melden Sie sich hier an",
      "Identifiez-vous ici svp",
      "Accedi qui",
      "Cadastre-se aqui",
      "Entrar aquí",
      "Выполните вход",
      "Zaloguj się",
      "sign_in_here"
    ],
    error_duplicateuser: [
      "Email address already exists",
      "Email address already exists",
      "メールアドレスは既に存在します",
      "电子邮件地址已存在",
      "Die E-Mail-Adresse ist bereits vorhanden",
      "Cette adresse email existe déjà",
      "L'indirizzo e-mail esiste già",
      "Este endereço de e-mail já está cadastrado",
      "El correo electrónico ya existe",
      "Адрес электронной почты уже используется",
      "Adres e-mail już istnieje",
      "error_duplicateuser"
    ],
    signup_ok: [
      "Sign up",
      "Sign up",
      "サインアップ",
      "注册",
      "Melden Sie sich an",
      "S'enregistrer",
      "Registrati",
      "Cadastrar",
      "Registrar",
      "Регистрация",
      "Zarejestruj się",
      "signup_ok"
    ],
    user_invalidemail_error: [
      "Invalid email address",
      "Invalid email address",
      "無効なメールアドレス",
      "电子邮件地址无效",
      "Ungültige E-Mail-Adresse",
      "Adresse email incorrecte",
      "Indirizzo e-mail non valido",
      "Endereço de e-mail inválido",
      "Correo electrónico inválido",
      "Некорректный адрес электронной почты",
      "Nieprawidłowy adres e-mail",
      "user_invalidemail_error"
    ],
    header_title: [
      "TREND AnyWARE",
      "TREND AnyWARE",
      "TREND AnyWARE",
      "TREND AnyWARE",
      "TREND AnyWARE",
      "TREND AnyWARE",
      "TREND AnyWARE",
      "TREND AnyWARE",
      "TREND AnyWARE",
      "TREND AnyWARE",
      "TREND AnyWARE",
      "header_title"
    ],
    navigation_title: [
      "NAVIGATION",
      "NAVIGATION",
      "ナビゲーション",
      "导航菜单",
      "NAVIGATION",
      "NAVIGATION",
      "NAVIGAZIONE",
      "NAVEGAÇÃO",
      "NAVEGACIÓN",
      "НАВИГАЦИЯ",
      "NAWIGACJA",
      "navigation_title"
    ],
    context_title: [
      "Menu",
      "Menu",
      "メニュー",
      "菜单",
      "Menü",
      "Menu",
      "Menu",
      "Menu",
      "Menú",
      "Меню",
      "Menu",
      "context_title"
    ],
    context_header_choose_column: [
      "Choose Columns",
      "Choose Columns",
      "列の選択",
      "选择列",
      "Wählen Sie die Spalten aus",
      "Choisir les colonnes",
      "Scegli le colonne",
      "Escolha as colunas",
      "Seleccione columnas",
      "Выберите столбцы",
      "Wybierz kolumny",
      "context_header_choose_column"
    ],
    context_subheader_add_remove: [
      "Add or remove table columns by selecting from the list below.",
      "Add or remove table columns by selecting from the list below.",
      "以下のリストから選択して、表の列を追加/削除します。",
      "通过从以下列表中选择表格列进行添加或移除。",
      "Wählen Sie die hinzuzufügenden oder zu entfernenden Spalten der Tabelle aus der untenstehenden Liste aus.",
      "Ajouter ou retirer des colonnes en utilisant la liste ci-dessous.",
      "Aggiungi o rimuovi le colonne della tabella effettuando la selezione dall'elenco in basso.",
      "Adicione ou remova colunas selecionando-as na lista abaixo.",
      "Agregar/quitar columnas seleccionándolas a continuación",
      "Добавьте или удалите столбцы таблицы, выбрав их из списка ниже.",
      "Dodaj lub usuń kolumny tabeli, wybierając z poniższej listy.",
      "context_subheader_add_remove"
    ],
    general_table_page: [
      "Page",
      "Page",
      "ページ",
      "页码",
      "Seite",
      "Page",
      "Pagina",
      "Página",
      "Pág.",
      "Страница",
      "Strona",
      "general_table_page"
    ],
    general_table_rows: [
      "Rows",
      "Rows",
      "行",
      "行",
      "Reihen",
      "Lignes",
      "Righe",
      "Linhas",
      "Filas",
      "Строки",
      "Rzędy",
      "general_table_rows"
    ],
    general_table_of: [
      "of",
      "of",
      "/",
      "/",
      "von",
      "de",
      "di",
      "de",
      "de",
      "из",
      "z",
      "general_table_of"
    ],
    general_table_previous: [
      "Previous",
      "Previous",
      "前へ",
      "上一页",
      "Vorherige",
      "Précédent",
      "Precedente",
      "Anterior",
      "Anterior",
      "Назад",
      "Poprzedni",
      "general_table_previous"
    ],
    general_table_next: [
      "Next",
      "Next",
      "次へ",
      "下一页",
      "Nächste",
      "Suivant",
      "Successivo",
      "Próximo",
      "Siguiente",
      "Далее",
      "Następny",
      "general_table_next"
    ],
    general_impersonating: [
      "Impersonating",
      "Impersonating",
      "偽装",
      "模仿",
      "Impersonierung - Ersatz",
      "Remplacement",
      "Che impersona",
      "Personificando",
      "Suplantación",
      "Администрирование",
      "Personifikowanie",
      "general_impersonating"
    ],
    general_impersonate: [
      "Impersonate",
      "Impersonate",
      "偽装",
      "模仿",
      "Impersonieren - Ersetzen",
      "Remplacer",
      "Impersona",
      "Personificar",
      "Suplantar",
      "Администрировать",
      "Personifikuj",
      "general_impersonate"
    ],
    general_jobs: [
      "Jobs",
      "Jobs",
      "ジョブ",
      "作业",
      "Projekte",
      "Dossiers",
      "Lavori",
      "Trabalhos",
      "Trabajos",
      "Задания",
      "Zlecenia",
      "general_jobs"
    ],
    general_reports: [
      "Reports",
      "Reports",
      "レポート",
      "报告",
      "Berichte",
      "Rapports",
      "Report",
      "Relatórios",
      "Informes",
      "Отчеты",
      "Raporty",
      "general_reports"
    ],
    general_job: [
      "Job",
      "Job",
      "ジョブ",
      "作业",
      "Projekt",
      "Dossier",
      "Lavoro",
      "Trabalho",
      "Trabajo",
      "Задание",
      "Zlecenie",
      "general_job"
    ],
    general_warning: [
      "Warning",
      "Warning",
      "警告",
      "警告",
      "Warnung",
      "Avertissement",
      "Attenzione",
      "Aviso",
      "Aviso",
      "Предупреждение",
      "Ostrzeżenie",
      "general_warning"
    ],
    general_import: [
      "Import",
      "Import",
      "インポート",
      "导入",
      "Importieren",
      "Importer",
      "Importa",
      "Importar",
      "Importar",
      "Импорт",
      "Importuj",
      "general_import"
    ],
    general_showall: [
      "Show ALL",
      "Show ALL",
      "すべてを表示",
      "显示全部",
      "ALLE anzeigen",
      "Afficher TOUT",
      "Mostra TUTTO",
      "Exibir TUDO",
      "Mostrar TODO",
      "Показать ВСЕ",
      "Pokaż WSZYSTKIE",
      "general_showall"
    ],
    general_report: [
      "Report",
      "Report",
      "レポート",
      "报告",
      "Bericht",
      "Rapport",
      "Rapporto",
      "Relatório",
      "Informe",
      "Отчет",
      "Raport",
      "general_report"
    ],
    status: [
      "Status",
      "Status",
      "ステータス",
      "状态",
      "Status",
      "Statut",
      "Stato",
      "Status",
      "Estado",
      "Состояние",
      "Status",
      "status"
    ],
    report_type_singleline: [
      "Single Line",
      "Single Line",
      "1行表示",
      "单行",
      "Übersicht",
      "Synthèse",
      "Riga singola",
      "Simples",
      "Línea única",
      "Одна строка",
      "Pojedyncza linia",
      "report_type_singleline"
    ],
    report_type_brief: [
      "Brief",
      "Brief",
      "簡易表示",
      "概要",
      "Kurz",
      "Classique",
      "Breve",
      "Breve",
      "Corto",
      "Кратко",
      "Streszczenie",
      "report_type_brief"
    ],
    report_type_detail: [
      "Detailed",
      "Detailed",
      "詳細表示",
      "详细",
      "Voll",
      "Complet",
      "Dettagliato",
      "Detalhado",
      "Detallado",
      "Подробно",
      "Szczegółowo",
      "report_type_detail"
    ],
    report_status_in_progress: [
      "In progress",
      "In progress",
      "実行中",
      "正在进行",
      "Wird bearbeitet",
      "En cours",
      "In corso",
      "Em andamento",
      "En curso",
      "Выполняется",
      "W trakcie",
      "report_status_in_progress"
    ],
    report_status_completed: [
      "Completed",
      "Completed",
      "完了",
      "已完成",
      "Fertig",
      "Terminé",
      "Completato",
      "Concluído",
      "Completado",
      "Завершено",
      "Ukończono",
      "report_status_completed"
    ],
    report_status_failed: [
      "Failed",
      "Failed",
      "失敗",
      "未通过",
      "Fehlgeschlagen",
      "Échec",
      "Error",
      "Reprovado",
      "Fallido",
      "Неудачно",
      "Nie powiodło się",
      "report_status_failed"
    ],
    formfield_error_general_required: [
      "Required",
      "Required",
      "必須",
      "要求",
      "Obligatorisch - Erforderlich",
      "Requis",
      "Necessario",
      "Exigido",
      "Requerido",
      "Необходимо",
      "Wymagane",
      "formfield_error_general_required"
    ],
    formfield_error_name_special_character_restricted: [
      "Report name cannot contain '#', '\\', '/', '%', '?', '&', '|' or '='",
      "Report name cannot contain '#', '\\', '/', '%', '?', '&', '|' or '='",
      "レポート名に次を含めることはできません: 「#」, 「\\」, 「/」, 「%」, 「?」, 「&」, 「|」 又は 「=」",
      "报告名称不得包含 '#'、'\\'、'/'、'%'、'?'、'&'、' |' 或 '=' 等字符",
      "Der Berichtsname darf kein '#', '\\', '/', '%', '?', '&', '|' oder '=' enthalten",
      "Les signes suivants : '#',' \\','/', '%', '?', '&', '|' ou '=' ne peuvent pas être utilisés dans le nom du rapport.",
      "Il nome del rapporto non può contenere '#', '\\', '/', '%', '?', '&', '|' oppure '='",
      "O nome do relatório não pode conter os caracteres '#', '\\', '/', '%', '?', '&', '|' ou '='",
      "No utilice '#', '\\', '/', '%', '?', '&', '|' o '=’ en el nombre de informe",
      "Имя отчета не может содержать символы '#', '\\', '/', '%', '?', '&', '|'|и '='",
      "Raport nie może zawierać '#', '\\', '/', '%', '?', '&', '|' lub '='",
      "formfield_error_name_special_character_restricted"
    ],
    formfield_error_general_email: [
      "Invalid Email Id",
      "Invalid Email Id",
      "無効なメールID",
      "电子邮件 ID 无效",
      "Ungültige E-Mail-ID",
      "ID de l'email invalide",
      "Id e-mail non valido",
      "Endereço de e-mail inválido",
      "ID de correo inválida",
      "Некорректный адрес электронной почты ",
      "Nieprawidłowy identyfikator e-mail",
      "formfield_error_general_email"
    ],
    formfield_error_general_length: [
      "Length should be ${value}",
      "Length should be ${value}",
      "長さを${value}にしてください",
      "长度应为 ${value}",
      "Die Länge muss ${value} betragen.",
      "La longueur doit être de ${value}",
      "La lunghezza deve essere ${value}",
      "O tamanho deve ser ${value}",
      "Long. permitida ${value}",
      "Длина должна быть равна ${value}",
      "Długość powinna wynosić ${value}",
      "formfield_error_general_length"
    ],
    formfield_error_general_minlength: [
      "Minimum Length should be ${value}",
      "Minimum Length should be ${value}",
      "最小長さを${value}にしてください",
      "最小长度应为 ${value}",
      "Die Länge muss mindestens ${value} behalten",
      "La longueur minimum doit être de ${value}",
      "La lunghezza minima deve essere ${value}",
      "O tamanho mínimo deve ser ${value}",
      "Long. mín. permitida ${value}",
      "Минимальная длина должна быть равна ${value}",
      "Minimalna długość powinna wynosić ${value}",
      "formfield_error_general_minlength"
    ],
    formfield_error_general_maxlength: [
      "Maximum Length should be ${value}",
      "Maximum Length should be ${value}",
      "最大長さを${value}にしてください",
      "最大长度应为 ${value}",
      "Die Länge darf maximal  ${value} behalten.",
      "La longueur maximum doit être de ${value}",
      "La lunghezza massima deve essere ${value}",
      "O tamanho máximo deve ser ${value}",
      "Long. máx. permitida  ${value}",
      "Максимальная длина должна быть равна ${value}",
      "Maksymalna długość powinna wynosić ${value}",
      "formfield_error_general_maxlength"
    ],
    formfield_error_general_type_numeric: [
      "Should be numeric",
      "Should be numeric",
      "数値である必要があります",
      "应为数字",
      "Muss numerisch sein",
      "Doit être composé de chiffres",
      "Deve essere numerico",
      "Deve ser numérico",
      "Debe ser numérico",
      "Должно быть числом",
      "Powinien zawierać cyfry",
      "formfield_error_general_type_numeric"
    ],
    formfield_error_general_type_chars: [
      "Should be characters",
      "Should be characters",
      "文字である必要があります",
      "应为字符",
      "Müssen Zeichen sein",
      "Doit être composé de lettres",
      "Devono essere caratteri",
      "Devem ser caracteres",
      "Deben ser caracteres",
      "Должно содержать символы",
      "Powinien zawierać znaki specjalne",
      "formfield_error_general_type_chars"
    ],
    formfield_error_general_type_alphanumeric: [
      "Should be alphanumeric",
      "Should be alphanumeric",
      "英数字である必要があります",
      "应为字母数字",
      "Muss alphanumerisch sein",
      "Doit être composé de caractères alphanumériques",
      "Deve essere alfanumerico",
      "Deve ser alfanumérico",
      "Debe ser alfanumérico",
      "Должно содержать буквы и цифры",
      "Powinien zawierać znaki alfanumeryczne",
      "formfield_error_general_type_alphanumeric"
    ],
    formfield_error_general_pattern: [
      "Invalid Pattern",
      "Invalid Pattern",
      "無効なパターン",
      "模式无效",
      "Ungültiges Muster",
      "Elément non valide",
      "Motivo non valido",
      "Padrão inválido",
      "Patrón inválido",
      "Некорректный шаблон",
      "Nieprawidłowy wzór",
      "formfield_error_general_pattern"
    ],
    job_load_more: [
      "Load More Jobs",
      "Load More Jobs",
      "さらにジョブを読み込む",
      "加载更多工作",
      "Mehr Projekte laden",
      "Importer plus de dossiers",
      "Carica più lavori",
      "Carregar mais trabalhos",
      "Cargar más trabajos",
      "Загрузить еще задания",
      "Pobierz więcej zleceń",
      "job_load_more"
    ],
    jobs_context_filter_description: [
      "Filter jobs by selecting from the list below.",
      "Filter jobs by selecting from the list below.",
      "以下のリストから選択して、ジョブにフィルタを適用します。",
      "从以下列表中选择工作以进行筛选。",
      "Projekte nach der untenstehenden Liste filtern",
      "Filtrez les dossiers en les sélectionnant dans la liste ci-dessous",
      "Filtra i lavori selezionando dall'elenco in basso.",
      "Filtre os trabalhos selecionando-os na lista abaixo.",
      "Filtrar trabajos de la sig. lista.",
      "Фильтруйте задания, выбирая их в списке ниже.",
      "Filtruj zlecenia wybierając z poniższej listy.",
      "jobs_context_filter_description"
    ],
    jobs_context_filter_jobname: [
      "Job Name",
      "Job Name",
      "ジョブ名",
      "作业名称",
      "Projektname",
      "Nom du dossier",
      "Nome lavoro",
      "Nome do Trabalho",
      "Nombre de trabajo",
      "Имя задания",
      "Nazwa zlecenia",
      "jobs_context_filter_jobname"
    ],
    jobs_context_all_customers: [
      "All Customers",
      "All Customers",
      "すべてのカスタマー",
      "所有客户",
      "Alle Kunden",
      "Tous les clients",
      "Tutti i clienti",
      "Todos os Clientes",
      "Todos los clientes",
      "Все заказчики",
      "Wszyscy klienci",
      "jobs_context_all_customers"
    ],
    jobs_context_filter_customers_panel: [
      "Customers",
      "Customers",
      "カスタマー",
      "客户",
      "Kunden",
      "Clients",
      "Clienti",
      "Clientes",
      "Clientes",
      "Заказчики",
      "Klienci",
      "jobs_context_filter_customers_panel"
    ],
    jobs_context_filter_job_sync_panel: [
      "Job Sync",
      "Job Sync",
      "ジョブの同期",
      "作业同步",
      "Projekt-Sync",
      "Synchroniser dossier",
      "Sincronizzazione lavoro",
      "Sincronizar trabalhos",
      "Sincronizar trabajos",
      "Синхронизация заданий",
      "Synchronizacja zleceń",
      "jobs_context_filter_job_sync_panel"
    ],
    jobs_context_filter_job_synced: [
      "Synced",
      "Synced",
      "同期済み",
      "已同步",
      "Synchr.",
      "Synchronisé",
      "Sincronizzato",
      "Sincronizado",
      "Sincronizar",
      "Синхронизировано",
      "Zsynchronizowano",
      "jobs_context_filter_job_synced"
    ],
    jobs_context_filter_job_not_synced: [
      "Not Synced",
      "Not Synced",
      "未同期",
      "未同步",
      "Nicht synchr.",
      "Non synchronisé",
      "Non sincronizzato",
      "Não sincronizado",
      "No sincronizar",
      "Не синхронизировано",
      "Nie zsynchronizowano",
      "jobs_context_filter_job_not_synced"
    ],
    jobs_context_filter_created_at_panel: [
      "Created At",
      "Created At",
      "作成先",
      "创建时间",
      "Erstellt am",
      "Créé à",
      "Creato a",
      "Criado em",
      "Creado",
      "Дата создания",
      "Utworzono w",
      "jobs_context_filter_created_at_panel"
    ],
    job_add: [
      "Create Job",
      "Add Job",
      "ジョブの追加",
      "创建作业",
      "Projekt erstellen",
      "Créer un dossier",
      "Crea lavoro",
      "Criar Trabalho",
      "Crear trabajo",
      "Создать задание",
      "Utwórz zlecenie",
      "job_add"
    ],
    job_edit: [
      "Edit Job",
      "Edit Job",
      "ジョブの編集",
      "编辑作业",
      "Projekt bearbeiten",
      "Éditer un dossier",
      "Modifica lavoro",
      "Editar Trabalho",
      "Editar trabajo",
      "Изменить задание",
      "Edytuj zlecenie",
      "job_edit"
    ],
    job_details: [
      "Details",
      "Details",
      "詳細",
      "详细信息",
      "Angaben",
      "Détails",
      "Dettagli",
      "Detalhes",
      "Detalles",
      "Подробности",
      "Szczegóły",
      "job_details"
    ],
    job_metadata: [
      "Job identifiers",
      "Job identifiers",
      "ジョブ識別子",
      "作业标识符",
      "Projekt-IDs",
      "Identifiants du dossier",
      "Identificatori lavoro",
      "Identificadores do trabalho",
      "IDs del trabajo",
      "Идентификаторы заданий",
      "Identyfikatory zlecenia",
      "job_metadata"
    ],
    job_settings: [
      "Settings",
      "Settings",
      "設定",
      "设置",
      "Einstellungen",
      "Réglages",
      "Impostazioni",
      "Configurações",
      "Opciones",
      "Параметры",
      "Ustawienia",
      "job_settings"
    ],
    job_published: [
      "Can be published",
      "Can be published",
      "パブリッシュできます",
      "可以发布",
      "Kann angezeigt werden",
      "Prêt pour être publié",
      "Può essere pubblicato",
      "Pode ser publicado",
      "Puede ser publicado",
      "Может быть опубликовано",
      "Może być publikowane",
      "job_published"
    ],
    job_embargo: [
      "Inactive until further notice",
      "Inactive until further notice",
      "さらに通知があるまで非アクティブ",
      "在进一步通知前保持非活动状态",
      "Bis auf weiteres inaktiv",
      "Inactif jusqu'à nouvel ordre",
      "Non attivo fino ad avviso futuro",
      "Inativo até novo aviso",
      "Inactivo hasta próximo aviso”",
      "Неактивно до последующего уведомления",
      "Nieaktywny do odwołania",
      "job_embargo"
    ],
    job_enablesync: [
      "Enable Sync",
      "Enable Sync",
      "同期を有効化",
      "启用同步",
      "Synchr. aktivieren",
      "Activer la synchronisation",
      "Abilita sincronizzazione",
      "Habilitar sincronização",
      "Habilitar sincronizado",
      "Включить синхронизацию",
      "Włącz synchronizację",
      "job_enablesync"
    ],
    job_completed: [
      "Job Completed",
      "Job Completed",
      "ジョブが完了しました",
      "作业已完成",
      "Projekt abgeschlossen",
      "Dossier complété",
      "Lavoro completato",
      "Trabalho Concluído",
      "Trabajo completo",
      "Задание завершено",
      "Zlecenie wykonane",
      "job_completed"
    ],
    job_name: [
      "Job name",
      "Job name",
      "ジョブ名",
      "作业名称",
      "Projektname",
      "Nom du dossier",
      "Nome lavoro",
      "Nome do trabalho",
      "Nombr de trabajo",
      "Имя задания",
      "Nazwa zlecenia",
      "job_name"
    ],
    job_name_help: [
      "Job name",
      "Job name",
      "ジョブ名",
      "作业名称",
      "Projektname",
      "Nom du dossier",
      "Nome lavoro",
      "Nome do trabalho",
      "Nombr de trabajo",
      "Имя задания",
      "Nazwa zlecenia",
      "job_name_help"
    ],
    job_device: [
      "Device",
      "Device",
      "デバイス",
      "设备",
      "Gerät",
      "Appareil",
      "Dispositivo",
      "Dispositivo",
      "Equipo",
      "Устройство",
      "Urządzenie",
      "job_device"
    ],
    job_device_help: [
      "Device Type",
      "Device Type",
      "デバイスタイプ",
      "设备类型",
      "Gerätetyp",
      "Type d'appareil",
      "Tipo dispositivo",
      "Tipo de dispositivo",
      "Tipo equipo",
      "Тип устройства",
      "Typ urządzenia",
      "job_device_help"
    ],
    job_customer: [
      "Job customer",
      "Job customer",
      "ジョブカスタマー",
      "客户名称",
      "Projekt-Kunde",
      "Client du dossier",
      "Cliente lavoro",
      "Cliente do trabalho",
      "Cliente del trabajo",
      "Заказчик задания",
      "Klient zlecenia",
      "job_customer"
    ],
    job_customer_help: [
      "Job customer",
      "Job customer",
      "ジョブカスタマー",
      "客户名称",
      "Projekt-Kunde",
      "Client du dossier",
      "Cliente lavoro",
      "Cliente do trabalho",
      "Cliente del trabajo",
      "Заказчик задания",
      "Klient zlecenia",
      "job_customer_help"
    ],
    job_add_customer: [
      "Add customer",
      "Add customer",
      "カスタマーを追加",
      "添加客户",
      "Kunden hinzufügen",
      "Ajouter client",
      "Aggiungi cliente",
      "Incluir cliente",
      "Agregar cliente",
      "Добавить заказчика",
      "Dodaj klienta",
      "job_add_customer"
    ],
    job_metadata_help: [
      "Job identifiers",
      "Job identifiers",
      "ジョブ識別子",
      "作业标识符",
      "Projekt-IDs",
      "Identifiants du dossier",
      "Identificatori lavoro",
      "Identificadores do trabalho",
      "IDs del trabajo",
      "Идентификаторы заданий",
      "Identyfikatory zlecenia",
      "job_metadata_help"
    ],
    job_metadata_not_required: [
      "Not Required",
      "Not Required",
      "不要",
      "不要求",
      "Nicht erforderlich",
      "Non requis",
      "Non necessario",
      "Não Exigido",
      "No requerido",
      "Не требуется",
      "Nie wymagane",
      "job_metadata_not_required"
    ],
    job_delete_confirm_title: [
      "DELETE JOB",
      "DELETE JOB",
      "ジョブの削除",
      "删除作业",
      "PROJEKT LÖSCHEN",
      "EFFACER DOSSIER",
      "ELIMINA LAVORO",
      "EXCLUIR TRABALHO",
      "ELIMINAR TRABAJO",
      "УДАЛИТЬ ЗАДАНИЕ",
      "USUŃ ZLECENIE",
      "job_delete_confirm_title"
    ],
    job_delete_confirm_text: [
      "Are you sure you want to delete job <b>${name}</b>?",
      "Are you sure you want to delete job <b>${name}</b>?",
      "ジョブ「<b>${name}</b>」を削除してもよろしいですか?",
      "您是否确定要删除作业 <b>${name}</b>？",
      "Wollen Sie das Projekt <b>${name}</b>? wirklich löschen?",
      "Êtes-vous sûr de vouloir effacer le dossier <b>${name}</b>?",
      "Eliminare il lavoro <b>${name}</b>?",
      "Tem certeza de que deseja excluir o trabalho <b>${name}</b>?",
      "¿Eliminar el trabajo <b>${name}</b>?",
      "Действительно удалить задание <b>${name}</b>?",
      "Czy na pewno chcesz usunąć zlecenie <b>${name}</b>?",
      "job_delete_confirm_text"
    ],
    job_header_total: [
      "TOTAL",
      "TOTAL",
      "総計",
      "总计",
      "GESAMT",
      "TOTAL",
      "TOTALE",
      "TOTAL",
      "TOTAL",
      "ВСЕГО",
      "SUMA",
      "job_header_total"
    ],
    job_header_passed: [
      "PASS",
      "PASS",
      "成功",
      "已通过",
      "BESTANDEN",
      "SUCCÈS",
      "PASSATO",
      "APROVADO",
      "PASA",
      "ПРОЙДЕНО",
      "POWIODŁO SIĘ",
      "job_header_passed"
    ],
    job_header_failed: [
      "FAIL",
      "FAIL",
      "失敗",
      "未通过",
      "FEHLER",
      "ÉCHEC",
      "FALLITO",
      "REPROVADO",
      "FALLA",
      "НЕ ПРОЙДЕНО",
      "NIE POWIODŁO SIĘ",
      "job_header_failed"
    ],
    job_create_successfull_toast: [
      "Job successfully created.",
      "Job successfully created.",
      "ジョブが正常に作成されました。",
      "已成功创建作业。 ",
      "Projekt erfolgreich erstellt",
      "Le dossier a été créé avec succès",
      "Lavoro creato correttamente.",
      "Trabalho criado com sucesso.",
      "Trabajo creado",
      "Задание создано.",
      "Utworzenie zlecenia powiodło się.",
      "job_create_successfull_toast"
    ],
    job_update_successfull_toast: [
      "Job successfully updated.",
      "Job successfully updated.",
      "ジョブが正常に更新されました。",
      "已成功更新作业。",
      "Projekt erfolgreich aktualisiert",
      "Le dossier a été mis à jour avec succès",
      "Lavoro aggiornato correttamente.",
      "Trabalho atualizado com sucesso.",
      "Trabajo actualizado.",
      "Задание обновлено.",
      "Aktualizacja zlecenia powiodła się.",
      "job_update_successfull_toast"
    ],
    job_delete_successfull_toast: [
      "Job successfully deleted.",
      "Job successfully deleted.",
      "ジョブが正常に削除されました。",
      "已成功删除作业。",
      "Projekt erfolgreich gelöscht",
      "Le dossier a été effacé avec succès",
      "Lavoro eliminato correttamente.",
      "Trabalho excluído com sucesso.",
      "Trabajo eliminado",
      "Задание удалено.",
      "Usunięcie zlecenia powiodło się.",
      "job_delete_successfull_toast"
    ],
    job_upload_lantek_title: [
      "IMPORT LanTEK TESTS",
      "IMPORT LanTEK TESTS",
      " jp-JP",
      "导入 LanTEK 测试",
      "LanTEK-TESTS IMPORTIEREN",
      "IMPORTER des TESTS du LanTEK",
      "IMPORTA TEST LanTEK",
      "Importar Testes do LanTEK",
      "IMPORTAR PRUEBAS LanTEK",
      "ИМПОРТ ТЕСТОВ LanTEK",
      "IMPORTUJ TESTY LanTEK ",
      "job_upload_lantek_title"
    ],
    job_upload_lantek_warn_nojob: [
      'Uploaded tests will be added to "Default Job" where any test not associated with jobs are uploaded to.',
      'Uploaded tests will be added to "Default Job" where any test not associated with jobs are uploaded to.',
      "アップロードしたテストは <デフォルトのジョブ> に追加されます。ここには、ジョブに関連付けられていないテストがアップロードされます。",
      '已上传的测试将添加至"默认作业"，任何与作业不相关的测试均会被上传至此处。',
      'Hochgeladene Tests werden "Standard-Projekte" hinzugefügt, wo alle Tests ohne zugeordnete Projekte gespeichert sind.',
      'Les tests téléchargés seront ajoutés à "Tâche par défaut" où les tests qui ne sont pas associés à des tâches seront téléchargés sur.',
      'I test caricati saranno aggiunti a "Lavoro predefinito", dove sono caricati tutti i test non associati ai lavori.',
      'Os testes carregados serão incluídos em "Trabalho Padrão" que é para onde testes não associados a um trabalho são enviados.',
      'Las pruebas cargadas se añadirán al "Trabajo por defecto" donde se cargan las pruebas que no están asociadas a ningún trabajo.',
      'Отправленные тесты будут добавлены в раздел "«Задание по умолчанию»", где хранятся тесты, не связанные с заданиями, которые загружены на.',
      "Przesłane testy zostaną dodane do „Zadania domyślnego”, do którego przesyłane są wszystkie testy niezwiązane ze zleceniami.",
      "job_upload_lantek_warn_nojob"
    ],
    job_upload_lantek_helptext: [
      "Please Select Multiple Test Files and Jobname File.",
      "Please Select Multiple Test Files and Jobname File.",
      "複数テストファイルとジョブ名ファイルを選択してください。",
      "请选择多个测试文件和作业名称文件。 ",
      "Bitte mehrere Testdateien und Projektnamen-Datei auswählen.",
      "Veuillez sélectionner les tests et le nom du dossier.",
      "Selezionare diversi file di test e file del nome lavoro.",
      "Selecione múltiplos arquivos de teste e o arquivo do Trabalho.",
      "Seleccione archivos de múltiples pruebas y el archivo de nombre de trabajo",
      "Выберите несколько тестовых файлов и файл задания.",
      "Wybierz wiele plików testowych i plik z nazwą zlecenia.",
      "job_upload_lantek_helptext"
    ],
    job_upload_lantek_tests_file_label: [
      "TESTS TO BE IMPORTED",
      "TESTS TO BE IMPORTED",
      "テストをインポートする必要があります",
      "要导入的测试",
      "ZU IMPORTIERENDE TESTS",
      "TESTS À IMPORTER",
      "TEST DA IMPORTARE",
      "TESTES PARA IMPORTAR",
      "PRUEBAS PARA IMPORTAR",
      "ИМПОРТИРУЕМЫЕ ТЕСТЫ",
      "TESTY DO IMPORTU",
      "job_upload_lantek_tests_file_label"
    ],
    job_upload_lantek_tests_file_total: [
      "TOTAL",
      "TOTAL",
      "総計",
      "总计",
      "GESAMT",
      "TOTAL",
      "TOTALE",
      "TOTAL",
      "TOTAL",
      "ВСЕГО",
      "SUMA",
      "job_upload_lantek_tests_file_total"
    ],
    job_upload_lantek_job_file_label: [
      "JOB DATA FILE",
      "JOB DATA FILE",
      "ジョブのデータファイル",
      "作业数据文件",
      "PROJEKTDATEN-DATEI",
      "FICHIERS DE TESTS DU DOSSIER",
      "FILE DEI DATI LAVORO",
      "ARQUIVO DE DADOS DO TRABALHO",
      "ARCHIVO DE TRABAJO",
      "ФАЙЛ ДАННЫХ ЗАДАНИЯ",
      "PLIK Z DANYMI ZLECENIA",
      "job_upload_lantek_job_file_label"
    ],
    jobs_upload_lantek_files_successfull_toast: [
      "Test results are being processed and will be available in a few minutes,  You will receive an email when results are ready.",
      "Test results are being processed and will be available in a few minutes,  You will receive an email when results are ready.",
      "テスト結果は現在処理中で、あと数分で利用可能になります。テスト結果が用意できるとメール通知が届きます。",
      "测试结果正在处理，将在几分钟内完成，  结果准备就绪后会向您发送一封电子邮件。",
      "Die Testergebnisse werden verarbeitet und stehen in wenigen Minuten zur Verfügung. Sie erhalten eine E-Mail, wenn die Ergebnisse fertig sind.",
      "Traitement des résultats en cours : ils seront disponibles dans quelques minutes. Vous recevrez un email quand les résultats seront prêts.",
      "I risultati del test sono in fase di elaborazione e saranno disponibili tra pochi minuti. Riceverai un’e-mail appena i risultati saranno pronti.",
      "Os resultados estão sendo processados e estarão disponíveis em alguns minutos. Você receberá um e-mail quando estiverem prontos.",
      "Los resultados del test están curso y estarán disponibles en unos minutos. Recibirá un correo electrónico cuando estén listos.",
      "Результаты тестов обрабатываются и будут готовы через несколько минут. Когда результаты будут готовы, вы получите письмо с уведомлением по электронной почте.",
      "Wyniki testu są przetwarzane i będą dostępne za kilka minut. Gdy wyniki będą gotowe, otrzymasz wiadomość e-mail.",
      "jobs_upload_lantek_files_successfull_toast"
    ],
    jobs_upload_comet_files_successfull_toast: [
      "Test results are being processed and will be available in a few minutes",
      "Test results are being processed and will be available in a few minutes",
      "テスト結果は現在処理中で、あと数分で利用可能になります。",
      "测试结果正在处理，将在几分钟内完成",
      "Die Testergebnisse werden verarbeitet und stehen in wenigen Minuten zur Verfügung.",
      "Traitement des résultats en cours : ils seront disponibles dans quelques minutes.",
      "I risultati del test sono in fase di elaborazione e saranno disponibili tra pochi minuti.",
      "Os resultados estão sendo processados e estarão disponíveis em alguns minutos.",
      "Los resultados del test están curso y estarán disponibles en unos minutos.",
      "Результаты тестов обрабатываются и будут готовы через несколько минут.",
      "Wyniki testu są przetwarzane i będą dostępne za kilka minut",
      "jobs_upload_comet_files_successfull_toast"
    ],
    jobs_upload_lantek_files_unsuccessfull_toast: [
      "File could not be uploaded",
      "File could not be uploaded",
      "ファイルをアップロードできませんでした",
      "无法上传文件",
      "Fehler beim Hochladen der Datei",
      "Le fichier n'a pas pu être téléchargé",
      "Impossibile caricare Il file",
      "O arquivo não pôde ser carregado",
      "No se pudo subir el archivo",
      "Не удалось отправить файл",
      "Przesłanie pliku nie powiodło się",
      "jobs_upload_lantek_files_unsuccessfull_toast"
    ],
    job_attachments: [
      "Attachments",
      "Attachments",
      "添付ファイル",
      "附件",
      "Anhänge",
      "Fichiers joints",
      "Allegati",
      "Anexos",
      "Adjuntos",
      "Вложения",
      "Załączniki",
      "job_attachments"
    ],
    job_upload_attachments: [
      "Upload attachment",
      "Upload attachment",
      "添付ファイルをアップロード",
      "上传附件",
      "Anhang hochladen",
      "Télécharger le fichier joint",
      "Carica allegato",
      "Carregar anexo",
      "Subir adjunto",
      "Отправить вложение",
      "Prześlij załącznik",
      "job_upload_attachments"
    ],
    upload_attachment_label: [
      "Select file to upload",
      "Select file to upload",
      "アップロードするファイルを選択",
      "选择要上传的文件",
      "Wählen Sie die hochzuladende Datei aus",
      "Sélectionnez le fichier à télécharger",
      "Selezionare file da caricare",
      "Selecione o arquivo a ser carregado",
      "Seleccionar archivo a subir",
      "Выберите файл для отправки",
      "Wybierz plik do przesłania",
      "upload_attachment_label"
    ],
    upload_attachment_help: [
      "Should be a valid file except .exe and file names should not contain '#', '%', '/' or '\\'",
      "Should be a valid file except .exe and file names should not contain '#', '%', '/' or '\\'",
      "有効なファイル (.exe を除く) である必要があります。ファイル名には「#」、「%」、「/」、または「\\」を含めることはできません。",
      "除 .exe 格式外的有效文件，文件名不得包含 '#'、'%'、'/' 或 '\\' ",
      "Jede gültige Datei außer .exe. Dateinamen dürfen kein '#', '%', '/' oder '\\' enthalten.",
      "Un fichier ne doit pas avoir d'extension au format .exe et son nom ne doit pas contenir de caractères tels que '#', '%', '/' ou '\\'",
      "Deve essere un file valido tranne .exe e i nomi dei file non devono contenere '#', '%', '/' o '\\'",
      "Deve ser um arquivo válido (exceto .exe) e os nomes dos arquivos não devem conter '#', '%', '/' ou '\\'",
      "Debe ser un archivo válido, no .exe, y el nombre no debe contener '#', '%', '/' o '\\'",
      "Это должен быть действительный файл, отличный от .exe, а имена файлов не должны содержать символы '#', '%', '/' и '\\')",
      "Powinien to być odpowiedni plik z wyjątkiem .exe, a nazwa pliku nie może zawierać znaków '#', '%', '/' lub '\\'",
      "upload_attachment_help"
    ],
    attachment_delete_confirm_title: [
      "Delete attachment",
      "Delete attachment",
      "添付ファイルを削除",
      "删除附件",
      "Anhang löschen",
      "Effacer le fichier joint",
      "Elimina allegato",
      "Excluir anexo",
      "Eliminar adjunto",
      "Удалить вложение",
      "Usuń załącznik",
      "attachment_delete_confirm_title"
    ],
    attachment_delete_successfull_toast: [
      "Attachment successfully deleted.",
      "Attachment successfully deleted.",
      "添付ファイルが正常に削除されました。",
      "附件已成功删除。",
      "Anhang erfolgreich gelöscht",
      "Le fichier joint a été effacé avec succès",
      "Allegato eliminato correttamente.",
      "Anexo excluído com sucesso.",
      "Archivo adjunto eliminado.",
      "Вложение удалено.",
      "Usunięcie załącznika powiodło się.",
      "attachment_delete_successfull_toast"
    ],
    attachment_delete_confirm_text: [
      "Are you sure you want to delete the attachment: <b>${file}</b>",
      "Are you sure you want to delete the attachment: <b>${file}</b>",
      "次の添付ファイルを削除してもよろしいですか:  <b>${file}</b>",
      "您是否确定要删除附件：<b>${file}</b>",
      "Wollen Sie den Anhang <b>${file}</b> wirklich löschen",
      "Êtes-vous sûr de vouloir effacer le fichier joint : <b>${file}</b>",
      "Eliminare l'allegato: <b>${file}</b>",
      "Você tem certeza de que deseja excluir o anexo: <b>${file}</b>",
      "¿Eliminar el archivo adjunto <b>${file}</b>",
      "Действительно удалить вложение: <b>${file}</b>",
      "Czy na pewno chcesz usunąć załącznik: <b>${file}</b>",
      "attachment_delete_confirm_text"
    ],
    jobs_tests_upload_file_successfull_toast: [
      "File upload successful",
      "File upload successful",
      "ファイルのアップロードに成功しました",
      "文件已成功上传",
      "Datei erfolgreich hochgeladen",
      "Fichier téléchargé avec succès",
      "File caricato correttamente",
      "Arquivo carregado com sucesso",
      "Subido con éxito",
      "Файл отправлен",
      "Przesłanie pliku powiodło się",
      "jobs_tests_upload_file_successfull_toast"
    ],
    jobs_tests_upload_file_unsuccessfull_toast: [
      "File could not be uploaded",
      "File could not be uploaded",
      "ファイルをアップロードできませんでした",
      "无法上传文件",
      "Fehler beim Hochladen der Datei",
      "Le fichier n'a pas pu être téléchargé",
      "Impossibile caricare Il file",
      "O arquivo não pôde ser carregado",
      "No se pudo subir el archivo",
      "Не удалось отправить файл",
      "Przesłanie pliku nie powiodło się",
      "jobs_tests_upload_file_successfull_toast"
    ],
    test_details: [
      "Details",
      "Details",
      "詳細",
      "详细信息",
      "Angaben",
      "Détails",
      "Dettagli",
      "Detalhes",
      "Detalles",
      "Подробности",
      "Szczegóły",
      "test_details"
    ],
    test_standards: [
      "Standards",
      "Standards",
      "規格",
      "标准",
      "Normen",
      "Normes",
      "Standard",
      "Normas",
      "Estándar",
      "Стандарты",
      "Standardy",
      "test_standards"
    ],
    test_metadata: [
      "Identifiers",
      "Identifiers",
      "識別子",
      "标识符",
      "ID-Optionen",
      "Identifiants",
      "Identificatori",
      "Identificadores",
      "Identificador",
      "Идентификаторы",
      "Identyfikatory",
      "test_metadata"
    ],
    test_add: [
      "Create tests",
      "Create tests",
      "テストを作成",
      "创建测试",
      "Tests erstellen",
      "Créer des tests",
      "Crea test",
      "Criar testes",
      "Crear Pruebas",
      "Создать тесты",
      "Utwórz testy",
      "test_add"
    ],
    test_custom: [
      "Custom",
      "Custom",
      "カスタム",
      "自定义",
      "Kundenspezifisch",
      "Personnalisation",
      "Personalizzato",
      "Personalizado",
      "Personalizar",
      "Настраиваемый",
      "Dopasowane",
      "test_custom"
    ],
    test_custom_prefix: [
      "Custom Prefix",
      "Custom Prefix",
      "カスタムプレフィックス",
      "自定义前缀",
      "Spezifisch-Präfix",
      "Préfixe personnalisé",
      "Prefisso personalizzato",
      "Prefixo personalizado",
      "Prefijo personalizado",
      "Настраиваемый префикс",
      "Dopasowany prefiks",
      "test_custom_prefix"
    ],
    test_custom_prefix_help: [
      "Custom Prefix",
      "Custom Prefix",
      "カスタムプレフィックス",
      "自定义前缀",
      "Spezifisch-Präfix",
      "Préfixe personnalisé",
      "Prefisso personalizzato",
      "Prefixo personalizado",
      "Prefijo personalizado",
      "Настраиваемый префикс",
      "Dopasowany prefiks",
      "test_custom_prefix_help"
    ],
    test_name: [
      "Test Name",
      "Test Name",
      "テスト名",
      "测试名称",
      "Test-Name",
      "Nom du test",
      "Nome test",
      "Nome do teste",
      "Nombre de Prueba",
      "Имя теста",
      "Nazwa testu",
      "test_name"
    ],
    test_name_help: [
      "Test Name",
      "Test Name",
      "テスト名",
      "测试名称",
      "Test-Name",
      "Nom du test",
      "Nome test",
      "Nome do teste",
      "Nombre de Prueba",
      "Имя теста",
      "Nazwa testu",
      "test_name_help"
    ],
    test_prefix: [
      "Test Prefix",
      "Test Prefix",
      "テストプレフィックス",
      "测试前缀",
      "Test-Präfix",
      "Préfixe du test",
      "Prefisso test",
      "Prefixo do teste",
      "Prefijo de Prueba",
      "Префикс теста",
      "Prefiks testu",
      "test_prefix"
    ],
    test_prefix_help: [
      "Test Prefix",
      "Test Prefix",
      "テストプレフィックス",
      "测试前缀",
      "Test-Präfix",
      "Préfixe du test",
      "Prefisso test",
      "Prefixo do teste",
      "Prefijo de Prueba",
      "Префикс теста",
      "Prefiks testu",
      "test_prefix_help"
    ],
    test_startvalue: [
      "Start Value",
      "Start Value",
      "開始値",
      "初始值",
      "Startwert",
      "Valeur de départ",
      "Valore iniziale",
      "Valor inicial",
      "Valor inicial",
      "Начальное значение",
      "Wartość początkowa",
      "test_startvalue"
    ],
    test_startvalue_help: [
      "Start Value",
      "Start Value",
      "開始値",
      "初始值",
      "Startwert",
      "Valeur de départ",
      "Valore iniziale",
      "Valor inicial",
      "Valor inicial",
      "Начальное значение",
      "Wartość początkowa",
      "test_startvalue_help"
    ],
    test_endvalue: [
      "End Value",
      "End Value",
      "終了値",
      "结束值",
      "Endwert",
      "Valeur de fin",
      "Valore finale",
      "Valor final",
      "Valor final",
      "Конечное значение",
      "Wartość końcowa",
      "test_endvalue"
    ],
    test_endvalue_help: [
      "End Value",
      "End Value",
      "終了値",
      "结束值",
      "Endwert",
      "Valeur de fin",
      "Valore finale",
      "Valor final",
      "Valor final",
      "Конечное значение",
      "Wartość końcowa",
      "test_endvalue_help"
    ],
    test_invalid_range: [
      "Invaild Range",
      "Invaild Range",
      "無効な範囲",
      "范围无效",
      "Ungültiger Bereich",
      "Série invalide",
      "Intervallo non valido",
      "Faixa inválida",
      "Rango no válido",
      "Недопустимый диапазон",
      "Nieprawidłowy przedział",
      "test_invalid_range"
    ],
    test_ranges: [
      "TEST RANGES TO BE CREATED",
      "TEST RANGES TO BE CREATED",
      "テスト範囲を作成する必要があります",
      "需要创建的测试范围",
      "ZU ERSTELLENDE TESTBEREICHE",
      "SÉRIES DE TESTS À CRÉER",
      "INTERVALLI DEI TEST DA CREARE",
      "FAIXAS DE TESTE A SEREM CRIADAS",
      "RANGOS DE PRUEBA PARA CREAR",
      "ДИАПАЗОН ТЕСТА БУДЕТ СОЗДАН",
      "PRZEDZIAŁY TESTU DO UTWORZENIA",
      "test_ranges"
    ],
    test_ranges_total: [
      "TOTAL",
      "TOTAL",
      "総計",
      "总计",
      "GESAMT",
      "TOTAL",
      "TOTALE",
      "TOTAL",
      "TOTAL",
      "ВСЕГО",
      "SUMA",
      "test_ranges_total"
    ],
    test_floor: [
      "Floor",
      "Floor",
      "フロア",
      "层",
      "Etage",
      "Niveau",
      "Piano",
      "Andar",
      "Planta",
      "Этаж",
      "Piętro",
      "test_floor"
    ],
    test_floor_help: [
      "Floor",
      "Floor",
      "フロア",
      "层",
      "Etage",
      "Niveau",
      "Piano",
      "Andar",
      "Planta",
      "Этаж",
      "Piętro",
      "test_floor_help"
    ],
    test_telecommunicationspace: [
      "Telecommunications Space",
      "Telecommunications Space",
      "通信スペース",
      "电信空间",
      "Telekommunikationsraum",
      "Salle info",
      "Spazio telecomunicazioni",
      "Espaço de telecomunicações",
      "Espacio de telecom.",
      "Телекоммуникационное пространство",
      "Przestrzeń telekomunikacyjna",
      "test_telecommunicationspace"
    ],
    test_telecommunicationspace_help: [
      "Telecommunications space",
      "Telecommunications space",
      "通信スペース",
      "电信空间",
      "Telekommunikationsraum",
      "Salle info",
      "Spazio telecomunicazioni",
      "Espaço de telecomunicações",
      "Espacio de telecom.",
      "Телекоммуникационное пространство",
      "Przestrzeń telekomunikacyjna",
      "test_telecommunicationspace_help"
    ],
    test_panel: [
      "Panel",
      "Panel",
      "パネル",
      "面板",
      "Verteiler",
      "Panneau",
      "Pannello",
      "Painel",
      "Panel",
      "Панель",
      "Panel",
      "test_panel"
    ],
    test_panel_help: [
      "Panel",
      "Panel",
      "パネル",
      "面板",
      "Verteiler",
      "Panneau",
      "Pannello",
      "Painel",
      "Panel",
      "Панель",
      "Panel",
      "test_panel_help"
    ],
    test_portstartvalue: [
      "Port Start Value",
      "First Port Number",
      "最初のポート番号",
      "端口起始值",
      "Port-Startwert",
      "Valeur de départ du panneau",
      "Valore iniziale della porta",
      "Valor inicial da porta",
      "Valor inicial prto",
      "Начальное значение порта",
      "Wartość początkowa wejścia",
      "test_portstartvalue"
    ],
    test_portstartvalue_help: [
      "Port Start Value",
      "First Port Number",
      "最初のポート番号",
      "端口起始值",
      "Port-Startwert",
      "Valeur de départ du panneau",
      "Valore iniziale della porta",
      "Valor inicial da porta",
      "Valor inicial prto",
      "Начальное значение порта",
      "Wartość początkowa wejścia",
      "test_portstartvalue_help"
    ],
    test_portendvalue: [
      "Port End Value",
      "Last Port Number",
      "最後のポート番号",
      "端口结束值",
      "Port-Endwert",
      "Valeur de sortie du panneau",
      "Valore finale della porta",
      "Valor final da porta",
      "Valor final prto",
      "Конечное значение порта",
      "Wartość końcowa wejścia",
      "test_portendvalue"
    ],
    test_portendvalue_help: [
      "Port End Value",
      "Last Port Number",
      "最後のポート番号",
      "端口结束值",
      "Port-Endwert",
      "Valeur de sortie du panneau",
      "Valore finale della porta",
      "Valor final da porta",
      "Valor final prto",
      "Конечное значение порта",
      "Wartość końcowa wejścia",
      "test_portendvalue_help"
    ],
    test_cable_standard: [
      "Test Standard",
      "Test Standard",
      "テストの規格",
      "测试标准",
      "Testnorm",
      "Norme de test",
      "Standard test",
      "Norma do Teste",
      "Estándar Prueba",
      "Стандарт теста",
      "Standard testu",
      "test_cable_standard"
    ],
    test_cable_standard_help: [
      "Test Standard",
      "Test Standard",
      "テストの規格",
      "测试标准",
      "Testnorm",
      "Norme de test",
      "Standard test",
      "Norma do Teste",
      "Estándar Prueba",
      "Стандарт теста",
      "Standard testu",
      "test_cable_standard_help"
    ],
    test_link_model: [
      "Link Model",
      "Link Model",
      "リンクモデル",
      "链接模式",
      "Link-Modell",
      "Modèle du lien",
      "Modello collegamento",
      "Tipo de link",
      "Modelo Enlace",
      "Тип канала",
      "Model połączenia",
      "test_link_model"
    ],
    test_link_model_help: [
      "Link Model",
      "Link Model",
      "リンクモデル",
      "链接模式",
      "Link-Modell",
      "Modèle du lien",
      "Modello collegamento",
      "Tipo de link",
      "Modelo Enlace",
      "Тип канала",
      "Model połączenia",
      "test_link_model_help"
    ],
    test_cable_type: [
      "Test Limit",
      "Test Limit",
      "テストの制限",
      "测试极限值",
      "Test-Grenzwert",
      "Limite du test",
      "Limite test",
      "Limite do teste",
      "Límite Prueba",
      "Предел теста",
      "Limit testu",
      "test_cable_type"
    ],
    test_cable_type_help: [
      "Test Limit",
      "Test Limit",
      "テストの制限",
      "测试极限值",
      "Test-Grenzwert",
      "Limite du test",
      "Limite test",
      "Limite do teste",
      "Límite Prueba",
      "Предел теста",
      "Limit testu",
      "test_cable_type_help"
    ],
    test_cable_brand: [
      "Cable Manufacturer",
      "Cable Manufacturer",
      "ケーブルのメーカー",
      "线缆制造商",
      "Kabelhersteller",
      "Fabricant du câblage",
      "Produttore cavo",
      "Fabricante do cabo",
      "Fabricante del cable",
      "Марка кабеля",
      "Producent okablowania",
      "test_cable_brand"
    ],
    test_cable_brand_help: [
      "Cable Manufacturer",
      "Cable Manufacturer",
      "ケーブルのメーカー",
      "线缆制造商",
      "Kabelhersteller",
      "Fabricant du câblage",
      "Produttore cavo",
      "Fabricante do cabo",
      "Fabricante del cable",
      "Марка кабеля",
      "Producent okablowania",
      "test_cable_brand_help"
    ],
    test_connector_brand_near: [
      "Near-end Connector Manufacturer",
      "Near-end Connector Manufacturer",
      "近端コネクタのメーカー",
      "近端连接器品牌",
      "Hersteller des nahen Steckverbinders",
      "Fabricant du connecteur proche du boitier principal",
      "Produttore connettore estremità vicina",
      "Fabricante do conector da extremidade local",
      "Fabricante conector extremo cercano",
      "Марка разъема ближнего конца",
      "Producent złącza zbliżnego",
      "test_connector_brand_near"
    ],
    test_connector_brand_near_help: [
      "Near End Connector Manufacturer",
      "Near End Connector Manufacturer",
      "近端コネクタのメーカー",
      "近端连接器品牌",
      "Hersteller des nahen Steckverbinders",
      "Fabricant du connecteur proche du boitier principal",
      "Produttore connettore estremità vicina",
      "Fabricante do conector da extremidade local",
      "Fabricante conector extremo cercano",
      "Марка разъема ближнего конца",
      "Producent złącza zbliżnego",
      "test_connector_brand_near_help"
    ],
    test_connector_brand_far: [
      "Far End Connector Manufacturer",
      "Far End Connector Manufacturer",
      "遠端コネクタのメーカー",
      "远端连接器品牌",
      "Hersteller des fernen Steckverbinders",
      "Fabricant du connecteur du boitier récepteur",
      "Produttore connettore estremità remota",
      "Fabricante do conector da extremidade remota",
      "Fabricante conector extremo remoto",
      "Марка разъема дальнего конца",
      "Producent złącza zdalnego",
      "test_connector_brand_far"
    ],
    test_connector_brand_far_help: [
      "Far End Connector Manufacturer",
      "Far End Connector Manufacturer",
      "遠端コネクタのメーカー",
      "远端连接器品牌",
      "Hersteller des fernen Steckverbinders",
      "Fabricant du connecteur du boitier récepteur",
      "Produttore connettore estremità remota",
      "Fabricante do conector da extremidade remota",
      "Fabricante conector extremo remoto",
      "Марка разъема дальнего конца",
      "Producent złącza zdalnego",
      "test_connector_brand_far_help"
    ],
    test_nvp: [
      "NVP %",
      "NVP %",
      "NVP %",
      "NVP %",
      "NVP %",
      "NVP %",
      "NVP %",
      "NVP %",
      "NVP %",
      "NVP %",
      "NVP %",
      "test_nvp"
    ],
    test_nvp_out_of_range: [
      "NVP out of range",
      "NVP out of range",
      "NVP範囲外",
      "NVP 值超出范围",
      "NVP außerhalb des Bereichs",
      "NVP hors limite",
      "NVP fuori intervallo",
      "NVP fora da faixa",
      "NVP fuera de rango",
      "NVP вне диапазона",
      "NVP poza przedziałem",
      "test_nvp_out_of_range"
    ],
    test_nvp_out_of_range_desc: [
      "NVP should be in range of ${min}-${max}",
      "NVP should be in range of ${min}-${max}",
      "NVPは${min}-${max}の範囲である必要があります",
      "NVP 值应该在 ${min}-${max} 内",
      "NVP sollte im Bereich von ${min}-${max} liegen.",
      "NVP doit être compris entre ${min} et ${max}",
      "Il valore di NVP deve essere compreso fra ${min} e ${max}",
      "O NVP deve estar entre ${min} e ${max}",
      "NVP debe estar en el rango de ${min}-${max}",
      "Значение NVP должно быть в пределах от ${min} до ${max}",
      "Wartość NVP powinna zawierać się w przedziale ${min}-${max}",
      "test_nvp_out_of_range_desc"
    ],
    test_nvp_help: [
      "NVP %",
      "NVP %",
      "NVP %",
      "NVP %",
      "NVP %",
      "NVP %",
      "NVP %",
      "NVP %",
      "NVP %",
      "NVP %",
      "NVP %",
      "test_nvp_help"
    ],
    test_cable_shielding: [
      "Cable Shielding",
      "Cable Shielding",
      "ケーブルのシールディング",
      "电缆屏蔽",
      "Kabelschirm",
      "Blindage du câble",
      "Schermatura cavo",
      "Blindagem do cabo",
      "Apantallado del cable",
      "Экранирование кабеля",
      "Osłona okablowania",
      "test_cable_shielding"
    ],
    test_cable_shielding_uutp: [
      "U/UTP",
      "U/UTP",
      "U/UTP",
      "U/UTP",
      "U/UTP",
      "U/UTP",
      "U/UTP",
      "U/UTP",
      "U/UTP",
      "U/UTP",
      "U/UTP",
      "test_cable_shielding_uutp"
    ],
    test_cable_shielding_uftp: [
      "U/FTP",
      "U/FTP",
      "U/FTP",
      "U/FTP",
      "U/FTP",
      "U/FTP",
      "U/FTP",
      "U/FTP",
      "U/FTP",
      "U/FTP",
      "U/FTP",
      "test_cable_shielding_uftp"
    ],
    test_cable_shielding_futp: [
      "F/UTP",
      "F/UTP",
      "F/UTP",
      "F/UTP",
      "F/UTP",
      "F/UTP",
      "F/UTP",
      "F/UTP",
      "F/UTP",
      "F/UTP",
      "F/UTP",
      "test_cable_shielding_futp"
    ],
    test_cable_shielding_sfutp: [
      "SF/UTP",
      "SF/UTP",
      "SF/UTP",
      "SF/UTP",
      "SF/UTP",
      "SF/UTP",
      "SF/UTP",
      "SF/UTP",
      "SF/UTP",
      "SF/UTP",
      "SF/UTP",
      "test_cable_shielding_sfutp"
    ],
    test_cable_shielding_fstp: [
      "F/STP",
      "F/STP",
      "F/STP",
      "F/STP",
      "F/STP",
      "F/STP",
      "F/STP",
      "F/STP",
      "F/STP",
      "F/STP",
      "F/STP",
      "test_cable_shielding_fstp"
    ],
    test_cable_shielding_sftp: [
      "S/STP",
      "S/STP",
      "S/STP",
      "S/STP",
      "S/STP",
      "S/STP",
      "S/STP",
      "S/STP",
      "S/STP",
      "S/STP",
      "S/STP",
      "test_cable_shielding_sftp"
    ],
    test_add_metadata_item: [
      "Show all identifier options",
      "Show all identifier options",
      "すべての識別子オプションを表示",
      "显示所有标识符选项",
      "Alle ID-Optionen anzeigen",
      "Afficher toutes les options d'identifiant",
      "Mostra tutte le opzioni dell'identificatore",
      "Exibir todas as opções de identificadores",
      "Mostrar todas las opciones de ID",
      "Показать все параметры идентификатора",
      "Pokaż wszystkie opcje identyfikatorów",
      "test_add_metadata_item"
    ],
    test_create: [
      "Create",
      "Create",
      "作成",
      "创建",
      "Erstellen",
      "Créer",
      "Crea",
      "Criar",
      "Crear",
      "Создать",
      "Utwórz",
      "test_create"
    ],
    test_edit_title: [
      "Edit Test",
      "Edit Test",
      "テストの編集",
      "编辑测试",
      "Test bearbeiten",
      "Éditer le test",
      "Modifica test",
      "Editar teste",
      "Editar prueba",
      "Изменить тест",
      "Edytuj test",
      "test_edit_title"
    ],
    test_edit: [
      "Submit",
      "Submit",
      "送信",
      "提交",
      "einreichen",
      "Soumettre",
      "Sottoscrivi",
      "Enviar",
      "Enviar",
      "Отправить",
      "Prześlij",
      "test_edit"
    ],
    test_duplicate_error: [
      "Duplicate tests found",
      "Duplicate tests found",
      "テストの重複が見つかりました",
      "已发现重复测试",
      "Doppelter Test gefunden",
      "Dupliquer les tests trouvés",
      "Trovato test duplicati",
      "Testes duplicados encontrados",
      "Prueba Duplicada encontrada",
      "Найдены дублирующиеся тесты",
      "Znaleziono duplikaty testów",
      "test_duplicate_error"
    ],
    test_duplicate_error_desc: [
      "Tests with this identifier already exist",
      "Tests with this identifier already exist",
      "この識別子のテストは既に存在します",
      "已存在具有该标识符的测试",
      "Tests mit dieser ID bereits vorhanden",
      "Des tests avec ces identifiants existent déjà",
      "Test con questo identificatore esistono già",
      "Já existem testes com este identificador",
      "ID de Prueba ya existe",
      "Тесты с таким идентификатором уже существуют",
      "Testy z tym identyfikatorem już istnieją",
      "test_duplicate_error_desc"
    ],
    tests_delete_confirm_title: [
      "Delete Tests",
      "Delete Tests",
      "テストを削除",
      "删除测试",
      "Tests löschen",
      "Effacer les tests",
      "Elimina test",
      "Excluir testes",
      "Eliminar prueba",
      "Удалить тесты",
      "Usuń testy",
      "tests_delete_confirm_title"
    ],
    test_move_title: [
      "Move Tests",
      "Move Tests ",
      "テストを移動",
      "移动测试",
      "Tests verschieben",
      "Déplacer les tests",
      "Sposta test",
      "Mover testes",
      "Mover pruebas",
      "Переместить тесты",
      "Przenieś testy",
      "test_move_title"
    ],
    test_move_text: [
      "Move ${number} Selected Tests from <b>${name}</b>",
      "Move ${number} Selected Tests from <b>${name}</b>",
      "選択した${number}個のテストを「<b>${name}</b>」から移動します",
      "从 ${name} 处移动 ${number} <b>个选定测试</b>",
      "${number} ausgewählte Tests von <b>${name}</b> verschieben",
      "Déplacer ${number} tests sélectionnés depuis <b>${name}</b>",
      "Sposta ${number} test selezionati da <b>${name}</b>",
      "Mover ${number} testes selecionados de <b>${name}</b>",
      "Mover ${number}  pruebas seleccionadas desde <b>${name}</b>",
      "Переместить ${number} выбранных тестов из <b>${name}</b>",
      "Przenieś ${number} wybranych testów z <b>${name}</b>",
      "test_move_text"
    ],
    test_move_no_jobs_text: [
      "No relevant jobs found to move selected tests",
      "No relevant jobs found to move selected tests",
      "選択したテストを移動するための該当するジョブが見つかりません",
      "无法将选定测试移至相关作业",
      "Es wurden keine relevanten Projekte gefunden, um die ausgewählten Tests zu verschieben.",
      "Aucune tâche pertinente pour déplacer les tests sélectionnés",
      "Non sono stati trovati lavori rilevanti su cui spostare i test selezionati",
      "Nenhum trabalho relevante foi encontrado para mover os testes selecionados",
      "No se ha encontrado ningún trabajo relevante para mover las pruebas seleccionadas",
      "Заданий для перемещения выбранных тестов не найдено",
      "Nie znaleziono odpowiednich zleceń, aby przenieść wybrane testy",
      "test_move_no_jobs_text"
    ],
    test_move_confirm: [
      "Move",
      "Move",
      "移動",
      "移动",
      "Verschieben",
      "Déplacer",
      "Sposta",
      "Mover",
      "Mover",
      "Переместить",
      "Przenieś",
      "test_move_confirm"
    ],
    test_recertify_title: [
      "Re-certify Tests",
      "Re-certify Tests",
      "テストを再認証",
      "重新认证测试",
      "Tests erneut zertifizieren",
      "Re-certifier les liens",
      "Ricertifica test",
      "Recertificar Testes",
      "Recertificar pruebas",
      "Повторно сертифицировать тесты",
      "Ponownie certyfikuj testy",
      "test_recertify_title"
    ],
    test_recertify: [
      "Re-certify",
      "Re-certify",
      "再認証",
      "重新认证",
      "Neu zertifizieren",
      "Re-certifier",
      "Ricertifica",
      "Recertificar",
      "Recertificar",
      "Повторно сертифицировать",
      "Ponownie certyfikuj",
      "test_recertify"
    ],
    tests_delete_confirm_text: [
      "Are you sure you want to delete selected <b>${number}</b> test(s)?",
      "Are you sure you want to delete selected <b>${number}</b> test(s)?",
      "選択した<b>${number}</b>個のテストを削除してもよろしいですか?",
      "您是否确定要删除选定的 <b>${number}</b> 个测试？",
      "Wollen Sie die ausgewählten <b>${number}</b> Tests wirklich löschen?",
      "Êtes-vous sûr de vouloir effacer le(s) <b>${number}</b> test(s) sélectionnés ?",
      "Eliminare i <b>${number}</b> test selezionati?",
      "Tem certeza de que deseja excluir o(s) <b>${number}</b> teste(s) selecionado(s)?",
      "¿Eliminar las <b>${number}</b>  pruebas seleccionadas?",
      "Выбранно тестов <b>${number}</b> шт.  Действительно удалить?",
      "Czy na pewno chcesz usunąć wybrane <b>${number}</b>test(y)?",
      "tests_delete_confirm_text"
    ],
    test_create_successfull_taost: [
      "Test successfully created.",
      "Test successfully created.",
      "テストが正常に作成されました。",
      "已成功创建测试。",
      "Test erfolgreich erstellt",
      "Le test a été créé avec succès.",
      "Test creato correttamente.",
      "Teste criado com sucesso.",
      "Prueba creada",
      "Тесты созданы.",
      "Utworzenie testu powiodło się.",
      "test_create_successfull_taost"
    ],
    tests_move_successfull_taost: [
      "Tests successfully moved.",
      "Tests successfully moved.",
      "テストが正常に移動されました。",
      "已成功移动测试。",
      "Test erfolgreich verschoben",
      "Les tests ont été déplacés avec succès.",
      "Test spostati correttamente.",
      "Testes movidos com sucesso.",
      "Prueba movida",
      "Тесты перемещены.",
      "Przeniesienie testów powiodło się.",
      "tests_move_successfull_taost"
    ],
    tests_move_unsuccessfull_type_taost: [
      "LanTEK III test(s) cannot be moved to LanTEK IV job OR LanTEK IV test(s) cannot be moved to LanTEK III job.",
      "LanTEK III test(s) cannot be moved to LanTEK IV job OR LanTEK IV test(s) cannot be moved to LanTEK III job.",
      "LanTEK IIIテストをLanTEK IVジョブに移動することも、LanTEK IVテストをLanTEK IIIジョブに移動することもできません。",
      "LanTEK III 测试无法移动至 LanTEK IV 作业或 LanTEK IV 测试无法移动至 LanTEK III 作业。",
      "LanTEK III-Test(s) kann/können nicht zu LanTEK IV-Projekt verschoben werden ODER LanTEK IV-Test(s) kann/können nicht zu LanTEK III-Projekt verschoben werden.",
      "Les tests des LanTEK III ne peuvent pas être déplacés vers un dossier LanteK IV, et réciproquement - et ceux des SignalTEK vers les LanTEK non plus ni l'inverse,",
      "Il/I test LanTEK III non può/possono essere spostato/i su un lavoro LanTEK IV O il/i test LanTEK IV non può/possono essere spostato/i su un lavoro LanTEK III.",
      "Testes do LanTEK III não podem ser movidos para um trabalho do LanTEK IV nem testes do LanTEK IV podem ser movidos para um trabalho do LanTEK III.",
      "La(s) prueba(s) de LanTEK III no puede(n) moverse a la carpeta de Trabajo LanTEK IV O la(s) prueba(s) de LanTEK IV no puede(n) moverse a la Carpeta de Trabajo de LanTEK III.",
      "Тесты LanTEK III не могут быть перемещены в задание LanTEK IV ИЛИ тесты LanTEK IV не могут быть перемещены в задание LanTEK III.",
      "Test(y) LanTEK III nie mogą być przeniesione do zlecenia LanTEK IV LUB test(y) LanTEK IV nie mogą być przeniesione do zlecenia LanTEK III.",
      "tests_move_unsuccessfull_type_taost"
    ],
    tests_delete_successfull_taost: [
      "Tests successfully deleted.",
      "Tests successfully deleted.",
      "テストが正常に削除されました。",
      "已成功删除测试。",
      "Test erfolgreich gelöscht",
      "Les tests ont été effacés avec succès.",
      "Test eliminati correttamente.",
      "Testes excluídos com sucesso.",
      "Pruebas eliminadas",
      "Тесты удалены.",
      "Usunięcie testów powiodło się.",
      "tests_delete_successfull_taost"
    ],
    test_update_successfull_taost: [
      "Tests successfully updated.",
      "Tests successfully updated.",
      "テストが正常に更新されました。",
      "已成功更新测试。",
      "Test erfolgreich aktualisiert",
      "Les tests ont été mis à jour avec succès.",
      "Test aggiornati correttamente.",
      "Testes atualizados com sucesso.",
      "Pruebas actualizadas",
      "Тесты обновлены.",
      "Aktualizacja testów powiodła się.",
      "test_update_successfull_taost"
    ],
    test_update_unsuccessfull_taost: [
      "Tests update unsuccessful.",
      "Tests update unsuccessful.",
      "テストの更新に失敗しました。",
      "测试更新不成功。",
      "Fehler beim Aktualisieren der Tests",
      "Échec de la mise à jour des tests.",
      "Aggiornamento test non riuscito.",
      "Falha na atualização dos testes.",
      "Pruebas no actualizadas",
      "Не удалось обновить тесты.",
      "Aktualizacja testów nie powiodła się.",
      "test_update_unsuccessfull_taost"
    ],
    test_recert_successfull_taost: [
      "Tests recertification is in progress.",
      "Tests recertification is in progress.",
      "テストの再認定が進行中です。",
      "测试的重新认证正在进行中。",
      "Die Rezertifizierung von Tests ist im Gange.",
      "La recertification des tests est en cours.",
      "È in corso la ricertificazione dei test.",
      "A recertificação dos testes está em andamento.",
      "La recertificación de las pruebas está en progreso.",
      "Проводится переаттестация испытаний.",
      "Trwa recertyfikacja testów.",
      "test_recert_successfull_taost"
    ],
    test_recert_successfull_taost1: [
      "Tests successfully recertified.",
      "Tests successfully recertified.",
      "テストが正常に再認証されました。",
      "已成功重新认证测试。",
      "Tests erfolgreich neu zertifiziert",
      "Les liens ont été re-certifiés avec succès.",
      "Test ricertificati correttamente.",
      "Testes recertificados com sucesso.",
      "Pruebas recertificadas",
      "Тесты сертифицированы повторно.",
      "Recertyfikacja testów powiodła się.",
      "test_recert_successfull_taost1"
    ],
    test_recert_unsuccessfull_toast: [
      "Tests re-certification unsuccessful.",
      "Tests re-certification unsuccessful.",
      "テストの再認証に失敗しました。",
      "测试重新认证不成功。",
      "Fehler beim Neuzertifizieren der Tests",
      "Échec de la re-certification des liens.",
      "Ricertificazione test non riuscita.",
      "Falha na recertificação dos testes.",
      "Recertificación de pruebas fallida",
      "Не удалось повторно сертифицировать тесты.",
      "Recertyfikacja testów nie powiodła się.",
      "test_recert_unsuccessfull_toast"
    ],
    test_recert_max_count_exceeded_toast: [
      "Too many tests selected. Recertification is limited to ${value} tests.",
      "Too many tests selected. Recertification is limited to ${value} tests.",
      "選択したテストが多すぎます。再認定は${value}のテストに制限されています。",
      "选择了太多的测试。重新认证仅限于${value}个测试。",
      "Zu viele ausgewählte Tests. Die Rezertifizierung ist auf ${value} Tests begrenzt.",
      "Trop de tests sélectionnés. La recertification est limitée à ${value} tests.",
      "Troppi test selezionati. La ricertificazione è limitata a ${value} test.",
      "Muitos testes selecionados. A recertificação é limitada a ${value} testes.",
      "Demasiadas pruebas seleccionadas. La recertificación se limita a ${value} pruebas.",
      "Слишком много тестов выбран. Рецидивация ограничена ${value} тестами.",
      "Wybrano zbyt wiele testów. Ponowna rekiza jest ograniczona do ${value} testów.",
      "test_recert_max_count_exceeded_toast"
    ],
    cablestandardname: [
      "Standard",
      "Standard",
      "標準",
      "标准",
      "Standard",
      "Norme",
      "Standard",
      "Padrão",
      "Estándar",
      "Стандарт",
      "Standardowy",
      "cablestandardname"
    ],
    linkmodelname: [
      "Link model",
      "Link model",
      "リンクモデル",
      "链接模式",
      "Link-Modell",
      "Modèle de lien",
      "Modello collegamento",
      "Tipo de link",
      "Modelo enlace",
      "Тип канала",
      "Model połączenia",
      "linkmodelname"
    ],
    cabletypename: [
      "Limits",
      "Limits",
      "限界",
      "限制",
      "Grenzen",
      "Limites",
      "Limiti",
      "Limites",
      "Límites",
      "Пределы",
      "Limity",
      "cabletypename"
    ],
    cablemodelname: [
      "Cable model",
      "Cable model",
      "ケーブルモデル",
      "电缆型号",
      "Kabelmodell",
      "Modèle de câble",
      "Modello di cavo",
      "Modelo do cabo",
      "Modelo de cable",
      "Модель кабеля",
      "Model okablowania",
      "cablemodelname"
    ],
    "Test Limit": [
      "Test Limit",
      "Test Limit",
      "テストの制限",
      "测试极限值",
      "Test-Grenzwert",
      "Limite du test",
      "Limite test",
      "Limite do teste",
      "Límite prueba",
      "Предел теста",
      "Limit testu",
      "Test Limit"
    ],
    cablebrandname: [
      "Cable Manufacturer",
      "Cable Manufacturer",
      "ケーブルのメーカー",
      "线缆制造商",
      "Kabelhersteller",
      "Fabricant du câblage",
      "Produttore cavo",
      "Fabricante do cabo",
      "Fabricante del cable",
      "Производитель кабеля",
      "Producent okablowania",
      "cablebrandname"
    ],
    connectorbrand: [
      "Connector brand",
      "Connector brand",
      "コネクタブランド",
      "连接器品牌",
      "Verbinder-Marke",
      "Marque du connecteur",
      "Marca connettore",
      "Marca do conector",
      "Marca conector",
      "Бренд разъема",
      "Marka złącza",
      "connectorbrand"
    ],
    result_connectormanufacturer: [
      "Cable Manufacturer",
      "Cable Manufacturer",
      "ケーブルのメーカー",
      "线缆制造商",
      "Kabelhersteller",
      "Fabricant du câblage",
      "Produttore cavo",
      "Fabricante do cabo",
      "Fabricante del cable",
      "Производитель кабеля",
      "Producent okablowania",
      "result_connectormanufacturer"
    ],
    result_headroom: [
      "Headroom (dB)",
      "Headroom (dB)",
      "ヘッドルーム (dB)",
      "净空 (dB)",
      "Reserve (dB)",
      "Marge (dB)",
      "Margine (dB)",
      "Área de margem (dB)",
      "Margen (dB)",
      "Запас (дБ)",
      "Margines (dB)",
      "result_headroom"
    ],
    HeadRoom: [
      "HeadRoom",
      "HeadRoom",
      "ヘッドルーム",
      "净空",
      "Reserve",
      "Marge",
      "Margine",
      "Área de Margem",
      "Margen",
      "Запас",
      "Margines",
      "HeadRoom"
    ],
    result_psacrnworst: [
      "Worst PS ACR-N (dB)",
      "Worst PS ACR-N (dB)",
      "ワーストPS ACR-N (dB)",
      "最差 PS ACR-N (dB)",
      "Schlechtester PS ACR-N (dB)",
      "Pire PS ACR-N (dB)",
      "Peggiore PS ACR-N (dB)",
      "Pior PS ACR-N (dB)",
      "PS ACR-N peor (dB)",
      "Худший PS ACR-N (дБ)",
      "Najgorszy PS ACR-N (dB)",
      "result_psacrnworst"
    ],
    result_psacrfworst: [
      "Worst PS ACR-F (dB)",
      "Worst PS ACR-F (dB)",
      "ワーストPS ACR-F (dB)",
      "最差 PS ACR-F (dB)",
      "Schlechtester PS ACR-F (dB)",
      "Pire PS ACR-F (dB)",
      "Peggiore PS ACR-F (dB)",
      "Pior PS ACR-F (dB)",
      "PS ACR-F peor (dB)",
      "Худший PS ACR-F (дБ)",
      "Najgorszy PS ACR-F (dB)",
      "result_psacrfworst"
    ],
    result_psnextworst: [
      "Worst PS NEXT (dB)",
      "Worst PS NEXT (dB)",
      "ワーストPS NEXT (dB)",
      "最差 PS NEXT (dB)",
      "Schlechtester PS NEXT (dB)",
      "Pire PS NEXT (dB)",
      "Peggiore PS NEXT (dB)",
      "Pior PS NEXT (dB)",
      "PS NEXT peor (dB)",
      "Худший PS NEXT (дБ)",
      "Najgorszy PS NEXT (dB)",
      "result_psnextworst"
    ],
    result_standard: [
      "Test Standard",
      "Test Standard",
      "テストの規格",
      "测试标准",
      "Test-Standard",
      "Norme du test",
      "Standard test",
      "Norma do Teste",
      "Norma de prueba",
      "Стандарт теста",
      "Standard testu",
      "result_standard"
    ],
    result_cablename: [
      "Test Limit LTIII",
      "Test Limit LTIII",
      "テストの制限 LTIII",
      "测试极限值 LTIII",
      "Test-Grenzwert LTIII",
      "Limite du test LTIII",
      "Limite test LTIII",
      "Limite do teste LTIII",
      "Límite prueba LTIII",
      "Предел теста LTIII",
      "Limit testu LTIII",
      "result_cablename"
    ],
    nvp: [
      "NVP %",
      "NVP %",
      "NVP %",
      "NVP %",
      "NVP %",
      "NVP %",
      "NVP %",
      "NVP %",
      "NVP %",
      "NVP %",
      "NVP %",
      "nvp"
    ],
    nvp_or_pFm: [
      "NVP %<br />pF/m",
      "NVP %<br />pF/m",
      "NVP %<br />pF/m",
      "NVP %<br />pF/m",
      "NVP %<br />pF/m",
      "NVP %<br />pF/m",
      "NVP %<br />pF/m",
      "NVP %<br />pF/m",
      "NVP %<br />pF/m",
      "NVP %<br />pF/m",
      "NVP %<br />pF/m",
      "nvp_or_pFm"
    ],
    nvp_or_pFft: [
      "NVP %<br />pF/ft",
      "NVP %<br />pF/ft",
      "NVP %<br />pF/ft",
      "NVP %<br />pF/ft",
      "NVP %<br />pF/ft",
      "NVP %<br />pF/ft",
      "NVP %<br />pF/ft",
      "NVP %<br />pF/ft",
      "NVP %<br />pF/ft",
      "NVP %<br />pF/ft",
      "NVP %<br />pF/ft",
      "nvp_or_pFft"
    ],
    pF_m: [
      "pF/m",
      "pF/m",
      "pF/m",
      "pF/m",
      "pF/m",
      "pF/m",
      "pF/m",
      "pF/m",
      "pF/m",
      "pF/m",
      "pF/m",
      "pF_m"
    ],
    pF_ft: [
      "pF/ft",
      "pF/ft",
      "pF/ft",
      "pF/ft",
      "pF/ft",
      "pF/ft",
      "pF/ft",
      "pF/ft",
      "pF/ft",
      "pF/ft",
      "pF/ft",
      "pF_ft"
    ],
    id: [
      "ID",
      "ID",
      "ID",
      "ID",
      "ID",
      "ID",
      "ID",
      "ID",
      "ID",
      "Идентификатор",
      "Identyfikator",
      "id"
    ],
    tests_smartflagstatus: [
      "SF",
      "SF",
      "SF",
      "SF",
      "SF",
      "SF",
      "SF",
      "SF",
      "SF",
      "SF",
      "SF",
      "tests_smartflagstatus"
    ],
    tests_name: [
      "Test Name",
      "Test Name",
      "テスト名",
      "测试名称",
      "Test-Name",
      "Nom du test,",
      "Nome test",
      "Nome do Teste",
      "Nombre de prueba",
      "Имя теста",
      "Nazwa testu",
      "tests_name"
    ],
    result_testdate: [
      "Date",
      "Date",
      "日付",
      "日期",
      "Datum",
      "Date",
      "Data",
      "Data",
      "Fecha",
      "Дата",
      "Data",
      "result_testdate"
    ],
    result_testtime: [
      "Time",
      "Time",
      "時間",
      "时间",
      "Uhrzeit",
      "Heure",
      "Ora",
      "Hora",
      "Hora",
      "Время",
      "Godzina",
      "result_testtime"
    ],
    result_nvp: [
      "NVP (%)",
      "NVP (%)",
      "NVP (%)",
      "NVP (%)",
      "NVP (%)",
      "NVP (%)",
      "NVP (%)",
      "NVP (%)",
      "NVP (%)",
      "NVP (%)",
      "NVP (%)",
      "result_nvp"
    ],
    result_returnlossmargin: [
      "Return Loss Margin (dB)",
      "Return Loss Margin (dB)",
      "反射損失マージン (dB)",
      "回波损耗余量 (dB)",
      "RL-Reserve (dB)",
      "Marge de la perte par retour (dB)",
      "Margine di perdita del ritorno (dB)",
      "Margem de Perda de Retorno (dB)",
      "Margen Pérdida Retorno (dB)",
      "Запас обратных потерь (дБ)",
      "Margines straty powrotu (dB)",
      "result_returnlossmargin"
    ],
    result_nextmargin: [
      "NEXT Margin (dB)",
      "NEXT Margin (dB)",
      "NEXTマージン (dB)",
      "NEXT 余量 (dB)",
      "NEXT-Reserve (dB)",
      "Marge de paradiaphonie (dB)",
      "Margine NEXT (dB)",
      "Margem de NEXT (dB)",
      "Margen NEXT (dB)",
      "Запас NEXT (дБ)",
      "Margines NEXT (dB)",
      "result_nextmargin"
    ],
    result_insertionlossmargin: [
      "Insertion Loss Margin (dB)",
      "Insertion Loss Margin (dB)",
      "挿入損失マージン (dB)",
      "插入损耗余量 (dB)",
      "IL-Reserve (dB)",
      "Marge de la perte d'insertion (dB)",
      "Margine di perdita per inserzione (dB)",
      "Margem de Perda de Inserção (dB)",
      "Margen Atenuación (dB)",
      "Запас вносимых потерь (дБ)",
      "Margines straty wtrąceniowej (dB)",
      "result_insertionlossmargin"
    ],
    result_dcresistance: [
      "DC Resistance (ohms)",
      "DC Resistance (ohms)",
      "直流抵抗 (オーム)",
      "直流电阻 (ohms)",
      "DC-Widerstand (Ohm)",
      "Résistance DC (ohms)",
      "Resistenza C.C. (ohm)",
      "Resistência CC (ohms)",
      "Resistencia en CC (ohms)",
      "Сопротивление постоянного тока (Ом)",
      "Rezystancja DC (omy)",
      "result_dcresistance"
    ],
    result_length_m: [
      "Length (m)",
      "Length (m)",
      "長さ (m)",
      "长度 (m)",
      "Länge (m)",
      "Longueur (m)",
      "Lunghezza (m)",
      "Comprimento (m)",
      "Longitud (m)",
      "Длина (м)",
      "Długość (metry)",
      "result_length_m"
    ],
    result_length_f: [
      "Length",
      "Length",
      "長さ",
      "长度",
      "Länge",
      "Longueur",
      "Lunghezza",
      "Comprimento",
      "Longitud",
      "Длина",
      "Długość",
      "result_length_f"
    ],
    result_teststatus: [
      "Test Status",
      "Test Status",
      "テストステータス",
      "测试状态",
      "Test-Status",
      "Statut du test",
      "Stato del test",
      "Status do Teste",
      "Estado prueba",
      "Состояние теста",
      "Status testu",
      "result_teststatus"
    ],
    result_psnextmargin: [
      "PS NEXT Margin (dB)",
      "PS NEXT Margin (dB)",
      "PS NEXTマージン (dB)",
      "PS NEXT 余量 (dB)",
      "PS-NEXT Reserve (dB)",
      "Marge PS NEXT (dB)",
      "Margine PS NEXT (dB)",
      "Margem de PS NEXT (dB)",
      "Margen PS NEXT (dB)",
      "Запас PS NEXT (дБ)",
      "Margines PS NEXT (dB)",
      "result_psnextmargin"
    ],
    result_psacrnmargin: [
      "PS ACR-N Margin (dB)",
      "PS ACR-N Margin (dB)",
      "PS ACR-Nマージン (dB)",
      "PS ACR-N 余量 (dB)",
      "PS-ACR-N Reserve (dB)",
      "Marge PS ACR-N (dB)",
      "Margine PS ACR-N (dB)",
      "Margem de PS ACR-N (dB)",
      "Margen PS ACR-N (dB)",
      "Запас PS ACR-N (дБ)",
      "Margines PS ACR-N (dB)",
      "result_psacrnmargin"
    ],
    result_psacrfmargin: [
      "PS ACR-F Margin (dB)",
      "PS ACR-F Margin (dB)",
      "PS ACR-Fマージン (dB)",
      "PS ACR-F 余量 (dB)",
      "PS-ACR-F Reserve (dB)",
      "Marge PS ACR-F (dB)",
      "Margine PS ACR-F (dB)",
      "Margem de PS ACR-F (dB)",
      "Margen PS ACR-F (dB)",
      "Запас PS ACR-F (дБ)",
      "Margines PS ACR-F (dB)",
      "result_psacrfmargin"
    ],
    result_delayskew: [
      "Delay Skew (ns)",
      "Delay Skew (ns)",
      "遅延スキュー (ns)",
      "延迟偏差 (ns)",
      "Laufzeitdifferenz (ns)",
      "Delay Skew (ns)",
      "Differenza di ritardo (ns)",
      "Desvio do Atraso (ns)",
      "Diferencia Retardo (ns)",
      "Смещение задержки (нс)",
      "Odchylenie opóźnienia (ns)",
      "result_delayskew"
    ],
    result_propagationdelay: [
      "Propagation Delay (ns)",
      "Propagation Delay (ns)",
      "伝播遅延 (ns)",
      "传播延迟 (ns)",
      "Laufzeit (ns)",
      "Temps de propagation (ns),",
      "Ritardo di propagazione (ns)",
      "Atraso de Propagação (ns)",
      "Retardo propagación (ns)",
      "Задержка распространения (нс)",
      "Opóźnienie propagacji (ns)",
      "result_propagationdelay"
    ],
    result_startfrequency: [
      "Start Frequency (MHz)",
      "Start Frequency (MHz)",
      "開始周波数 (MHz)",
      "起始频率 (MHz)",
      "Start-Frequenz (MHz)",
      "Fréquence de démarrage (MHz)",
      "Frequenza iniziale (MHz)",
      "Frequência Inicial (MHz)",
      "Frecuencia inicial (MHz)",
      "Начальная частота (МГц)",
      "Częstotliwość początkowa (MHz)",
      "result_startfrequency"
    ],
    result_stopfrequency: [
      "Stop Frequency (MHz)",
      "Stop Frequency (MHz)",
      "停止周波数 (MHz)",
      "停止频率 (MHz)",
      "Stopp-Frequenz (MHz)",
      "Fréquence de fin (MHz)",
      "Frequenza finale (MHz)",
      "Frequência Final (MHz)",
      "Frecuencia final (MHz)",
      "Конечная частота (МГц)",
      "Częstotliwość końcowa (MHz)",
      "result_stopfrequency"
    ],
    result_acrnmargin: [
      "ACR-N Margin (dB)",
      "ACR-N Margin (dB)",
      "ACR-Nマージン (dB)",
      "ACR-N 余量 (dB)",
      "ACR-N Reserve (dB)",
      "Marge ACR-N (dB)",
      "Margine ACR-N (dB)",
      "Margem de ACR-N (dB)",
      "Margen ACR-N (dB)",
      "Запас ACR-N (дБ)",
      "Margines ACR-N (dB)",
      "result_acrnmargin"
    ],
    result_acrfmargin: [
      "ACR-F Margin (dB)",
      "ACR-F Margin (dB)",
      "ACR-Fマージン (dB)",
      "ACR-F 余量 (dB)",
      "ACR-F Reserve (dB)",
      "Marge ACR-F (dB)",
      "Margine ACR-F (dB)",
      "Margem de ACR-F (dB)",
      "Margen ACR-F (dB)",
      "Запас ACR-F (дБ)",
      "Margines ACR-F (dB)",
      "result_acrfmargin"
    ],
    result_nextworst: [
      "Worst NEXT  (dB)",
      "Worst NEXT  (dB)",
      "ワーストNEXT (dB)",
      "最差 NEXT (dB)",
      "Schlechtester  NEXT  (dB)",
      "Pire paradiaphonie (dB)",
      "Peggiore NEXT  (dB)",
      "Pior NEXT (dB)",
      "Peor NEXT (dB)",
      "Худший NEXT (дБ)",
      "Najgorszy NEXT (dB)",
      "result_nextworst"
    ],
    result_returnlossworst: [
      "Worst Return Loss (dB)",
      "Worst Return Loss (dB)",
      "ワースト反射損失 (dB)",
      "最差回波损耗 (dB)",
      "Schlechteste Return Loss (dB)",
      "Pire perte par retour (dB)",
      "Peggiore perdita di ritorno (dB)",
      "Pior Perda de Retorno (dB)",
      "Peor Pérdida Retorno (dB)",
      "Худшие обратные потери (дБ)",
      "Najgorsza strata powrotu (dB)",
      "result_returnlossworst"
    ],
    result_insertionlossworst: [
      "Worst Insertion Loss value(dB)",
      "Worst Insertion Loss value(dB)",
      "ワースト挿入損失値 (dB)",
      "最差插入损耗值 (dB)",
      "Schlechteste Insertion Loss value(dB)",
      "Pire valeur de perte d'insertion (dB)",
      "Valore della Peggiore perdita di ritorno (dB)",
      "Pior valor de Perda de Inserção (dB)",
      "Peor valor Atenuación (dB)",
      "Худшее значение вносимых потерь (дБ)",
      "Wartość najgorszej straty wtrąceniowej (dB)",
      "result_insertionlossworst"
    ],
    result_acrnworst: [
      "Worst ACR-N (dB)",
      "Worst ACR-N (dB)",
      "ワーストACR-N (dB)",
      "最差 ACR-N (dB)",
      "Schlechtester ACR-N (dB)",
      "Pire ACR-N (dB)",
      "Peggiore ACR-N (dB)",
      "Pior ACR-N (dB)",
      "Peor ACR-N (dB)",
      "Худший ACR-N (дБ)",
      "Najgorszy ACR-N (dB)",
      "result_acrnworst"
    ],
    result_acrfworst: [
      "Worst ACR-F (dB)",
      "Worst ACR-F (dB)",
      "ワーストACR-F (dB)",
      "最差 ACR-F (dB)",
      "Schlechtester ACR-F (dB)",
      "Pire ACR-F (dB)",
      "Peggiore ACR-F (dB)",
      "Pior ACR-F (dB)",
      "Peor ACR-F (dB)",
      "Худший ACR-F (дБ)",
      "Najgorszy ACR-F (dB)",
      "result_acrfworst"
    ],
    result_cabletype: [
      "Cable Type",
      "Cable Type",
      "ケーブルのタイプ",
      "线缆类型",
      "Kabeltyp",
      "Type de câble",
      "Tipo di cavo",
      "Tipo de Cabo",
      "Tipo de cable",
      "Тип кабеля",
      "Typ okablowania",
      "result_cabletype"
    ],
    result_tester: [
      "Tester",
      "Tester",
      "テスター",
      "测试仪",
      "Tester",
      "Testeur",
      "Tester",
      "Testador",
      "Equipo",
      "Тестер",
      "Testujący",
      "result_tester"
    ],
    result_neserialnumber: [
      "Serial #",
      "Serial #",
      "シリアルナンバー",
      "序列号",
      "Seriennummer",
      "Numéro de série",
      "Numero di serie",
      "Número de série",
      "Número de serie",
      "Серийный номер",
      "Numer seryjny",
      "result_neserialnumber"
    ],
    result_organisation: [
      "Organisation",
      "Organization",
      "組織",
      "组织",
      "Firma",
      "Installateur",
      "Organizzazione",
      "Organização",
      "Organización",
      "Организация",
      "Organizacja",
      "result_organisation"
    ],
    result_customer: [
      "Customer",
      "Customer",
      "カスタマー",
      "客户",
      "Kunde",
      "Client",
      "Cliente",
      "Cliente",
      "Cliente",
      "Заказчик",
      "Klient",
      "result_customer"
    ],
    result_createdat: [
      "Imported on",
      "Imported on",
      "インポート日",
      "进口",
      "Importiert am",
      "Importé le",
      "Importato su",
      "Importado em",
      "Importado en",
      "Импортировано",
      "Importowano na",
      "result_createdat"
    ],
    connectorbrandnearname: [
      "Connector Manufacturer Near",
      "Connector Manufacturer Near",
      "コネクタメーカー (近端)",
      "近端连接器制造商",
      "Hersteller naher Steckverbinder",
      "Fabricant du connecteur proche",
      "Produttore connettore estremità vicina",
      "Fabricante do conector da extremidade local",
      "Fabricante conector extremo cercano",
      "Производитель ближнего разъема",
      "Producent złącza zbliżnego",
      "connectorbrandnearname"
    ],
    connectorbrandfarname: [
      "Connector Manufacturer Far",
      "Connector Manufacturer Far",
      "コネクタメーカー (遠端)",
      "远端连接器制造商",
      "Hersteller ferner Steckverbinder",
      "Fabricant du connecteur lointain",
      "Produttore connettore estremità remota",
      "Fabricante do conector da extremidade remota",
      "Fabricante conector extremo remoto",
      "Производитель дальнего разъема",
      "Producent złącza zdalnego",
      "connectorbrandfarname"
    ],
    result_technician: [
      "Engineer",
      "Technician",
      "技術者",
      "工程师",
      "Techniker",
      "Opérateur",
      "Ingegnere",
      "Técnico",
      "Técnico",
      "Инженер",
      "Technik",
      "result_technician"
    ],
    result_resunbalworstintrapair: [
      "Resistance Balance Worst IntraPair",
      "Resistance Balance Worst IntraPair",
      "抵抗平衡ワーストペア内",
      "对内电阻平衡最差",
      "Schlechteste Widerstandssymmetrie im Adernpaar",
      "Pire équilibre de la résistance entre paires",
      "Equilibrio di resistenza non accoppiato peggiore",
      "Pior desequilíbrio de resistência no par",
      "Peor Balance de Resistencia de par",
      "Худший внутрипарный баланс сопротивления",
      "Najgorsza równowaga rezystancji wewnątrz pary",
      "result_resunbalworstintrapair"
    ],
    result_resunbalworstp2p: [
      "Resistance Unbalance Worst Pair to Pair",
      "Resistance Unbalance Worst Pair to Pair",
      "抵抗不平衡ワーストペア間",
      "对间电阻不平衡最差",
      "Schlechteste Widerstandsunsymmetrie Paar-zu-Paar",
      "Pire déséquilibre de résistance paire à paire",
      "Squilibrio di resistenza accoppiato peggiore",
      "Pior desequilíbrio de resistência par-a-par",
      "Peor Balance de Resistencia entre pares",
      "Худший дисбаланс сопротивления между парами",
      "Najgorsza nierównowaga rezystancji między parami",
      "result_resunbalworstp2p"
    ],
    result_tclmargin: [
      "TCL Margin",
      "TCL Margin",
      "TCLマージン",
      "TCL 余量",
      "TCL Reserve",
      "TCL Marge",
      "TCL Margine",
      "Margem TCL",
      "Margen TCL",
      "TCL Разность",
      "Margines TCL",
      "result_tclmargin"
    ],
    result_eltctlmargin: [
      "ELTCTL Margin",
      "ELTCTL Margin",
      "ELTCTLマージン",
      "ELTCTL 余量",
      "ELTCTL Reserve",
      "ELTCTL Marge",
      "ELTCTL Margine",
      "Margem ELTCTL",
      "Margen ELTCTL",
      "ELTCTL Разность",
      "Margines ELTCTL",
      "result_eltctlmargin"
    ],
    result_cmrlmargin: [
      "CMRL Margin",
      "CMRL Margin",
      "CMRLマージン",
      "CMRL 余量",
      "CMRL Reserve",
      "CMRL Marge",
      "CMRL Margine",
      "Margem CMRL",
      "Margen CMRL",
      "CMRL Разность",
      "Margines CMRL",
      "result_cmrlmargin"
    ],
    result_cdnextmargin: [
      "CD NEXT Margin",
      "CD NEXT Margin",
      "CD NEXTマージン",
      "CD NEXT 余量",
      "CD NEXT Reserve",
      "CD NEXT Marge",
      "CD NEXT Margine",
      "Margem CD NEXT",
      "Margen CD NEXT",
      "CD NEXT Разность",
      "Margines CD NEXT",
      "result_cdnextmargin"
    ],
    result_tclworst: [
      "Worst TCL",
      "Worst TCL",
      "ワーストTCL",
      "最差 TCL",
      "Schlechteste TCL",
      "Pire TCL",
      "Peggiore TCL",
      "Pior TCL",
      "Peor TCL",
      "Худший TCL",
      "Najgorszy TCL",
      "result_tclworst"
    ],
    result_eltctlworst: [
      "Worst ELTCTL",
      "Worst ELTCTL",
      "ワーストELTCTL",
      "最差 ELTCTL",
      "Schlechteste ELTCTL",
      "Pire ELTCTL",
      "Peggiore ELTCTL",
      "Pior ELTCTL",
      "Peor ELTCTL",
      "Худший ELTCTL",
      "Najgorszy ELTCTL",
      "result_eltctlworst"
    ],
    result_cmrlworst: [
      "Worst CMRL",
      "Worst CMRL",
      "ワーストCMRL",
      "最差 CMRL",
      "Schlechteste CMRL",
      "Pire CMRL",
      "Peggiore CMRL",
      "Pior CMRL",
      "Peor CMRL",
      "Худший CMRL",
      "Najgorszy CMRL",
      "result_cmrlworst"
    ],
    result_cdnextworst: [
      "Worst CD NEXT",
      "Worst CD NEXT",
      "ワーストCD NEXT",
      "最差 CD NEXT",
      "Schlechteste CD NEXT",
      "Pire CD NEXT",
      "Peggiore CD NEXT",
      "Pior CD NEXT",
      "Peor CD NEXT",
      "Худший CD NEXT",
      "Najgorszy CD NEXT",
      "result_cdnextworst"
    ],
    result_usernotes: [
      "User Notes",
      "User Notes",
      "ユーザーメモ",
      "用户备注",
      "Anmerkungen",
      "Notes de l'utilisateur",
      "Note utente",
      "Notas do Usuário",
      "Notas",
      "Примечания пользователя",
      "Notatki użytkownika",
      "result_usernotes"
    ],
    result_firmware: [
      "Software",
      "Software",
      "ソフトウェア",
      "软件",
      "Software",
      "Logiciel",
      "Software",
      "Software",
      "Software",
      "Программное обеспечение",
      "Oprogramowanie",
      "result_firmware"
    ],
    result_suspicious: [
      "Suspicious records",
      "Suspicious records",
      "疑わしいレコード",
      "可疑记录",
      "Auffällige Datensätze",
      "Enregistrements suspects",
      "Registrazioni sospette",
      "Registros suspeitos",
      "Registros sospechosos",
      "Необходимые параметры",
      "Podejrzane zapisy",
      "result_suspicious"
    ],
    test_suspicious_successfull_taost: [
      "Suspicious filter activated",
      "Suspicious filter activated",
      "疑わしいフィルタが有効化されました",
      "已激活可疑过滤器",
      "Filter für auffällige Datensätze aktiv",
      "Filtre d'éléments suspects activé",
      "Filtro sospetto attivato",
      "Filtro suspeito ativado",
      "Filtro sospechoso activado",
      "Активирован фильтр необходимых параметров",
      "Aktywowano podejrzany filtr",
      "test_suspicious_successfull_taost"
    ],
    test_suspicious_unsuccessfull_taost: [
      "Suspicious filter could not be activated",
      "Suspicious filter could not be activated",
      "疑わしいフィルタを有効化できませんでした",
      "无法激活可疑过滤器",
      "Fehler beim Aktivieren des Filters für auffällige Datensätze",
      "Le filtre d'éléments suspects n'a pas pu être activé",
      "Non è stato possibile attivare il filtro sospetto",
      "Não foi possível ativar o filtro suspeito",
      "No se pudo activar filtro sospechoso",
      "Не удалось активировать фильтр необходимых параметров",
      "Aktywowanie podejrzanego filtra nie powiodło się",
      "test_suspicious_unsuccessfull_taost"
    ],
    suspicious_filter: [
      "Suspicious filter",
      "Suspicious filter",
      "疑わしいフィルタ",
      "可疑过滤器",
      "Auffällig-Filter",
      "Filtre d'éléments suspects",
      "Filtro sospetto",
      "Filtro suspeito",
      "Filtro sospechoso",
      "Фильтр необходимых параметров",
      "Podejrzany filtr",
      "suspicious_filter"
    ],
    summary: [
      "Summary",
      "Summary",
      "サマリー",
      "概要",
      "Zusammenfassung",
      "Résumé",
      "Riepilogo",
      "Resumo",
      "Resumen",
      "Сводка",
      "Podsumowanie",
      "summary"
    ],
    Wiremap: [
      "Wiremap",
      "Wiremap",
      "ワイヤーマップ",
      "接线图",
      "Verdrahtungsplan",
      "Câblage",
      "Mappa dei Fili",
      "Mapa de Fios",
      "Wiremap",
      "Схема разводки кабеля",
      "Mapa okablowania",
      "Wiremap"
    ],
    voltage_diagram: [
      "Voltage Diagram",
      "Voltage Diagram",
      "電圧図",
      "电压图",
      "Spannungs Diagramm",
      "Diagramme Tension",
      "Diagramma di Tensione",
      "Diagrama de Tensão",
      "Diagrama Voltaje",
      "Диаграмма напряжения",
      "Diagram napięcia",
      "voltage_diagram"
    ],
    Resistance: [
      "Resistance",
      "Resistance",
      "抵抗",
      "电阻",
      "Widerstand",
      "Résistance",
      "Resistenza",
      "Resistência",
      "Resistencia",
      "Сопротивление",
      "Rezystancja",
      "Resistance"
    ],
    customername: [
      "Customer Name",
      "Customer Name",
      "カスタマー名",
      "客户名称",
      "Kunden-Name",
      "Nom du client",
      "Nome cliente",
      "Nome do Cliente",
      "Nombre de cliente",
      "Имя заказчика",
      "Imię i nazwisko klienta",
      "customername"
    ],
    type: [
      "Type",
      "Type",
      "タイプ",
      "类型",
      "Typ",
      "Type",
      "Tipo",
      "Tipo",
      "Tipo",
      "Тип",
      "Typ",
      "type"
    ],
    totaltest: [
      "Total Tests",
      "Total Tests",
      "合計テスト",
      "测试总计",
      "Tests gesamt",
      "Tous les tests",
      "Test totali",
      "Total de testes",
      "Pruebas totales",
      "Всего тестов",
      "Suma testów",
      "totaltest"
    ],
    filesize: [
      "File Size",
      "File Size",
      "ファイルサイズ",
      "文件大小",
      "Datei-Größe",
      "Taille du fichier",
      "Dimensioni del file",
      "Tamanho do arquivo",
      "Tamaño archivo",
      "Размер файла",
      "Rozmiar pliku",
      "filesize"
    ],
    createdat: [
      "Created at",
      "Created at",
      "作成先",
      "创建时间",
      "Erstellt am",
      "Crée à",
      "Creato a",
      "Criado em",
      "Creado",
      "Дата создания",
      "Utworzono w",
      "createdat"
    ],
    Length: [
      "Length",
      "Length",
      "長さ",
      "长度",
      "Länge",
      "Longueur",
      "Lunghezza",
      "Comprimento",
      "Longitud",
      "Длина",
      "Długość ",
      "Length"
    ],
    PropagationDelay: [
      "Propagation Delay",
      "Propagation Delay",
      "伝播遅延",
      "传播延迟",
      "Laufzeit",
      "Délai de propagation",
      "Ritardo di propagazione",
      "Atraso de Propagação",
      "Retardo de propagación",
      "Задержка распространения",
      "Opóźnienie propagacji ",
      "PropagationDelay"
    ],
    DelaySkew: [
      "Delay Skew",
      "Delay Skew",
      "遅延スキュー",
      "延迟偏差",
      "Laufzeitdifferenz",
      "Delay Skew",
      "Differenza di ritardo",
      "Desvio do Atraso",
      "Diferencia de Retardo",
      "Смещение задержки",
      "Odchylenie opóźnienia ",
      "DelaySkew"
    ],
    Capacitance: [
      "Capacitance",
      "Capacitance",
      "キャパシタンス",
      "电容",
      "Kapazität",
      "Capacitance",
      "Capacità",
      "Capacitância",
      "Capacitancia",
      "Емкость",
      "Pojemność elektryczna",
      "Capacitance"
    ],
    Impedance: [
      "Impedance",
      "Impedance",
      "インピーダンス",
      "阻抗",
      "Impedanz",
      "Impédance",
      "Impedenza",
      "Impedância",
      "Impedancia",
      "Импеданс",
      "Impedancja",
      "Impedance"
    ],
    NEXT: [
      "NEXT",
      "NEXT",
      "NEXT",
      "NEXT",
      "NEXT",
      "NEXT",
      "NEXT",
      "NEXT",
      "NEXT",
      "NEXT",
      "NEXT ",
      "NEXT"
    ],
    qualification_next: [
      "NEXT",
      "NEXT",
      "NEXT",
      "NEXT",
      "NEXT",
      "NEXT",
      "NEXT",
      "NEXT",
      "NEXT",
      "NEXT",
      "NEXT ",
      "qualification_next"
    ],
    PSNEXT: [
      "PS NEXT",
      "PS NEXT",
      "PS NEXT",
      "PS NEXT",
      "PS NEXT",
      "PS NEXT",
      "PS NEXT",
      "PS NEXT",
      "PS NEXT",
      "PS NEXT",
      "PS NEXT",
      "PSNEXT"
    ],
    ACRN: [
      "ACR-N",
      "ACR-N",
      "ACR-N",
      "ACR-N",
      "ACR-N",
      "ACR-N",
      "ACR-N",
      "ACR-N",
      "ACR-N",
      "ACR-N",
      "ACR-N",
      "ACRN"
    ],
    PSACRN: [
      "PS-ACR-N",
      "PS-ACR-N",
      "PS-ACR-N",
      "PS-ACR-N",
      "PS-ACR-N",
      "PS-ACR-N",
      "PS-ACR-N",
      "PS-ACR-N",
      "PS-ACR-N",
      "PS-ACR-N",
      "PS-ACR-N",
      "PSACRN"
    ],
    ACRF: [
      "ACR-F",
      "ACR-F",
      "ACR-F",
      "ACR-F",
      "ACR-F",
      "ACR-F",
      "ACR-F",
      "ACR-F",
      "ACR-F",
      "ACR-F",
      "ACR-F",
      "ACRF"
    ],
    PSACRF: [
      "PS-ACR-F",
      "PS-ACR-F",
      "PS-ACR-F",
      "PS-ACR-F",
      "PS-ACR-F",
      "PS-ACR-F",
      "PS-ACR-F",
      "PS-ACR-F",
      "PS-ACR-F",
      "PS-ACR-F",
      "PS-ACR-F",
      "PSACRF"
    ],
    RTNLOSS: [
      "Return Loss",
      "Return Loss",
      "反射損失",
      "回波损耗",
      "Rückflussdämpfung",
      "Perte par retour",
      "Perdita di ritorno",
      "Perda de Retorno",
      "Pérdida Retorno",
      "Обратные потери",
      "Strata powrotu",
      "RTNLOSS"
    ],
    qualification_rl: [
      "Return Loss",
      "Return Loss",
      "反射損失",
      "回波损耗",
      "Rückflussdämpfung",
      "Perte par retour",
      "Perdita di ritorno",
      "Perda de Retorno",
      "Pérdida Retorno",
      "Обратные потери",
      "Strata powrotu",
      "qualification_rl"
    ],
    TDRTNLOSS: [
      "Time Domain RL",
      "Time Domain RL",
      "タイムドメイン RL",
      "时域 RL",
      "TD-RL",
      "Echomètre Return Loss",
      "Dominio del tempo RL",
      "Time Domain RL",
      "TDR - RL",
      "TDR Обратных потерь",
      "Domena czasu RL",
      "TDRTNLOSS"
    ],
    TDNEXT: [
      "Time Domain NEXT",
      "Time Domain NEXT",
      "タイムドメイン NEXT",
      "时域 NEXT",
      "TD-NEXT",
      "Echomètre Next",
      "Dominio del tempo NEXT",
      "Time Domain NEXT",
      "TDR - NEXT",
      "TDR NEXT",
      "Domena czasu NEXT",
      "TDNEXT"
    ],
    ATTEN: [
      "Insertion Loss",
      "Insertion Loss",
      "挿入損失",
      "插入损耗",
      "Einfügedämpfung",
      "Perte d'insertion",
      "Perdita d'inserzione",
      "Perda de Inserção",
      "Atenuación",
      "Вносимые потери",
      "Strata wtrąceniowa",
      "ATTEN"
    ],
    qualification_il: [
      "Insertion Loss",
      "Insertion Loss",
      "挿入損失",
      "插入损耗",
      "Einfügedämpfung",
      "Perte d'insertion",
      "Perdita d'inserzione",
      "Perda de Inserção",
      "Atenuación",
      "Вносимые потери",
      "Strata wtrąceniowa",
      "qualification_il"
    ],
    ResistanceUnBalancedPair: [
      "Resistance Unbalance",
      "Resistance Unbalance",
      "抵抗不平衡",
      "电阻不平衡",
      "Widerstand-Unsymmetrie",
      "Résistance asymétrique",
      "Sbilanciamento della resistenza",
      "Desequilíbrio de Resistência",
      "Desbalance de Resistencia",
      "Омическая асимметрия",
      "Nierównowaga rezystancji",
      "ResistanceUnBalancedPair"
    ],
    ResistanceUnBalancedP2P: [
      "Resistance Pair to Pair Unbalance",
      "Resistance Pair to Pair Unbalance",
      "抵抗ペア間不平衡",
      "电阻对间不平衡",
      "Widerstandsunsymmetrie Paar-zu-Paar",
      "Résistance paire à paire déséquilibrée",
      "Squilibrio di resistenza accoppiato",
      "Desequilíbrio de Resistência Par-a-Par",
      "Desbalance de Resistencia par a par",
      "Дисбаланс сопротивления между парами",
      "Nierównowaga rezystancji między parami",
      "ResistanceUnBalancedP2P"
    ],
    Capacitence: [
      "Capacitance",
      "Capacitance",
      "キャパシタンス",
      "电容",
      "Kapazität",
      "Capacitance",
      "Capacità",
      "Capacitância",
      "Capacitancia",
      "Емкость",
      "Pojemność elektryczna",
      "Capacitence"
    ],
    TCL: [
      "TCL",
      "TCL",
      "TCL",
      "TCL",
      "TCL",
      "TCL",
      "TCL",
      "TCL",
      "TCL",
      "TCL",
      "TCL",
      "TCL"
    ],
    ELTCTL: [
      "ELTCTL",
      "ELTCTL",
      "ELTCTL",
      "ELTCTL",
      "ELTCTL",
      "ELTCTL",
      "ELTCTL",
      "ELTCTL",
      "ELTCTL",
      "ELTCTL",
      "ELTCTL",
      "ELTCTL"
    ],
    CDNEXT: [
      "CDNEXT",
      "CDNEXT",
      "CDNEXT",
      "CDNEXT",
      "CDNEXT",
      "CDNEXT",
      "CDNEXT",
      "CDNEXT",
      "CDNEXT",
      "CDNEXT",
      "CDNEXT",
      "CDNEXT"
    ],
    CMRL: [
      "CMRL",
      "CMRL",
      "CMRL",
      "CMRL",
      "CMRL",
      "CMRL",
      "CMRL",
      "CMRL",
      "CMRL",
      "CMRL",
      "CMRL",
      "CMRL"
    ],
    TDR: [
      "TDR",
      "TDR",
      "TDR",
      "TDR",
      "TDR",
      "TDR",
      "TDR",
      "TDR",
      "TDR",
      "TDR",
      "TDR (REFLEKTOMETR DOMENY CZASU)",
      "TDR"
    ],
    general_test: [
      "Test",
      "Test",
      "テスト",
      "测试",
      "Testen",
      "Test",
      "Test",
      "Teste",
      "Prueba",
      "Тест",
      "Test",
      "general_test"
    ],
    general_devices: [
      "Devices",
      "Devices",
      "デバイス",
      "设备",
      "Geräte",
      "Appareils",
      "Dispositivi",
      "Dispositivos",
      "Equipos",
      "Устройства",
      "Urządzenia",
      "general_devices"
    ],
    general_device: [
      "Device Management",
      "Device Management",
      "デバイス管理",
      "设备管理",
      "Gerätemanagement",
      "Gestion de l'appareil",
      "Gestione dispositivo",
      "Gerenciamento de Dispositivos",
      "Gestión de equipos",
      "Управление устройствами",
      "Zarządzanie urządzeniem",
      "general_device"
    ],
    general_customers: [
      "Customers",
      "Customers",
      "カスタマー",
      "客户",
      "Kunden",
      "Clients",
      "Clienti",
      "Clientes",
      "Clientes",
      "Заказчики",
      "Klienci",
      "general_customers"
    ],
    general_organisations: [
      "Organisations",
      "Organizations",
      "組織",
      "组织",
      "Firmen",
      "Installateurs",
      "Organizzazioni",
      "Organizações",
      "Organizaciones",
      "Организации",
      "Organizacje",
      "general_organisations"
    ],
    general_users: [
      "User Accounts",
      "User Accounts",
      "ユーザーアカウント",
      "用户帐户",
      "Benutzerkonten",
      "Comptes utilisateurs",
      "Account utente",
      "Contas de Usuários",
      "Cuentas",
      "Учетные записи пользователей",
      "Konta użytkównika",
      "general_users"
    ],
    general_support: [
      "Support",
      "Support",
      "サポート",
      "支持",
      "Support",
      "Support",
      "Supporto",
      "Suporte",
      "Soporte",
      "Поддержка",
      "Wsparcie",
      "general_support"
    ],
    general_settings: [
      "Settings",
      "Settings",
      "設定",
      "设置",
      "Einstellungen",
      "Paramètres",
      "Impostazioni",
      "Configurações",
      "Opciones",
      "Параметры",
      "Ustawienia",
      "general_settings"
    ],
    general_profile: [
      "Profile",
      "Profile",
      "プロフィール",
      "简介",
      "Profil",
      "Profil",
      "Profilo",
      "Perfil",
      "Perfil",
      "Профиль",
      "Profil",
      "general_profile"
    ],
    idealadmin: [
      "TREND Admin",
      "TREND Admin",
      "TREND管理者",
      "TREND 管理员",
      "TREND-Admin",
      "Admin TREND",
      "Ammin. TREND",
      "Administrador TREND",
      "Admin. TREND",
      "Администратор TREND",
      "Administracja TREND",
      "idealadmin"
    ],
    idealsupport: [
      "TREND Support",
      "TREND Support",
      "TRENDサポート",
      "TREND 支持",
      "TREND-Support",
      "Support TREND",
      "Supporto TREND",
      "Suporte TREND",
      "Soporte TREND",
      "Поддержка TREND",
      "Wsparcie TREND",
      "idealsupport"
    ],
    clientadmin: [
      "Client Admin",
      "Client Admin",
      "クライアント管理者",
      "用户 管理员 ",
      "Kunden-Admin",
      "Admin Client",
      "Ammin. client",
      "Administrador do cliente",
      "Admin. cliente",
      "Администратор клиента",
      "Administracja klienta",
      "clientadmin"
    ],
    clientmanager: [
      "Client Manager",
      "Client Manager",
      "クライアントマネージャー",
      "用户 管理员",
      "Kunden-Manager",
      "Manager Client",
      "Manager client",
      "Gerente do cliente",
      "Gestor cliente",
      "Менеджер клиента",
      "Manager klienta",
      "clientmanager"
    ],
    clientuser: [
      "Client User",
      "Client User",
      "クライアントユーザー",
      "用户 使用者",
      "Kunden-Nutzer",
      "Utilisateur Client",
      "Client User",
      "Usuário do cliente",
      "Usuario cliente",
      "Статус",
      "Użytkownik klienta",
      "clientuser"
    ],
    firstname: [
      "First Name",
      "First Name",
      "名",
      "名字",
      "Vorname",
      "Prénom",
      "Nome",
      "Nome",
      "Nombre",
      "Имя",
      "Imię ",
      "firstname"
    ],
    lastname: [
      "Last Name",
      "Last Name",
      "姓",
      "姓氏",
      "Nachname",
      "Nom",
      "Cognome",
      "Sobrenome",
      "Apellido",
      "Фамилия",
      "Nazwisko",
      "lastname"
    ],
    enabled: [
      "Enabled",
      "Enabled",
      "有効",
      "已启用",
      "Aktiviert",
      "Activé",
      "Abilitato",
      "Habilitado",
      "Activado",
      "Включено",
      "Włączono",
      "enabled"
    ],
    disabled: [
      "Disabled",
      "Disabled",
      "無効",
      "取消",
      "Deaktiviert",
      "Désactivé",
      "Disabilitata",
      "Desabilitado",
      "Deshabilitado",
      "Отключено",
      "Nieaktywny",
      "disabled"
    ],
    customerid: [
      "Customer ID",
      "Customer ID",
      "カスタマーID",
      "客户 ID",
      "Kunden-ID",
      "ID client",
      "ID cliente",
      "ID do Cliente",
      "ID cliente",
      "ИД заказчика",
      "Identyfikator klienta",
      "customerid"
    ],
    language: [
      "Language",
      "Language",
      "言語",
      "语言",
      "Sprache",
      "Langue",
      "Lingua",
      "Idioma",
      "Idioma",
      "Язык",
      "Język",
      "language"
    ],
    customer_name: [
      "Customer Name",
      "Customer Name",
      "カスタマー名",
      "客户名称",
      "Kunden-Name",
      "Nom du client",
      "Nome cliente",
      "Nome do cliente",
      "Nombre de cliente",
      "Имя заказчика",
      "Imię i nazwisko klienta",
      "customer_name"
    ],
    email: [
      "Email",
      "Email",
      "メール",
      "电子邮件",
      "E-Mail",
      "Email",
      "E-mail",
      "E-mail",
      "Correo electrónico",
      "Электронная почта",
      "E-mail",
      "email"
    ],
    phonenumber: [
      "Phone number",
      "Phone number",
      "電話番号",
      "电话号码",
      "Telefonnummer",
      "Numéro de téléphone",
      "Numero di telefono",
      "Telefone",
      "Teléfono",
      "Номер телефона",
      "Numer telefonu",
      "phonenumber"
    ],
    modifiedat: [
      "Modified date",
      "Modified date",
      "修正日",
      "已修改日期",
      "Änderungsdatum",
      "Date modifiée",
      "Data della modifica",
      "Data de modificação",
      "Fecha modificado",
      "Дата изменения",
      "Zmieniona data",
      "modifiedat"
    ],
    role: [
      "Role",
      "Role",
      "ロール",
      "角色",
      "Rolle",
      "Fonction",
      "Funzione",
      "Função",
      "Rol",
      "Роль",
      "Rola",
      "role"
    ],
    roles: [
      "Roles",
      "Roles",
      "ロール",
      "角色",
      "Rolle",
      "Fonctions",
      "Funzioni",
      "Funções",
      "Roles",
      "Роли",
      "Role",
      "roles"
    ],
    action: [
      "Action",
      "Action",
      "アクション",
      "行动",
      "Aktion",
      "Action",
      "Azione",
      "Ação",
      "Acción",
      "Действие",
      "Czynność",
      "action"
    ],
    add_customer: [
      "Add Customer",
      "Add Customer",
      "カスタマーを追加",
      "添加客户",
      "Kunden hinzufügen",
      "Ajouter client",
      "Aggiungi cliente",
      "Incluir Cliente",
      "Agregar cliente",
      "Добавить заказчика",
      "Dodaj klienta",
      "add_customer"
    ],
    edit_customer: [
      "Edit Customer",
      "Edit Customer",
      "カスタマーを編集",
      "编辑客户",
      "Kunden bearbeiten",
      "Éditer Installateur",
      "Modifica cliente",
      "Editar Cliente",
      "Editar cliente",
      "Изменить заказчика",
      "Edytuj klienta",
      "edit_customer"
    ],
    add_organisation: [
      "Add Organisation",
      "Add Organization",
      "組織を追加",
      "添加组织",
      "Firma hinzufügen",
      "Ajouter Installateur",
      "Aggiungi organizzazione",
      "Incluir Organização",
      "Agregar Organización",
      "Добавить организацию",
      "Dodaj organizację",
      "add_organisation"
    ],
    edit_organisation: [
      "Edit Organisation",
      "Edit Organization",
      "組織を編集",
      "编辑组织",
      "Firma bearbeiten",
      "Éditer Installateur",
      "Modifica organizzazione",
      "Editar Organização",
      "Editar Organización",
      "Изменить организацию",
      "Edytuj organizację",
      "edit_organisation"
    ],
    general_language: [
      "Language",
      "Language",
      "言語",
      "语言",
      "Sprache",
      "Langue",
      "Lingua",
      "Idioma",
      "Idioma",
      "Язык",
      "Język",
      "general_language"
    ],
    general_language_help: [
      "Please Select Language",
      "Please Select Language",
      "言語を選択してください",
      "请选择语言",
      "Bitte Sprache auswählen",
      "Veuillez choisir une langue",
      "Seleziona lingua",
      "Selecione o idioma",
      "Seleccionar idioma",
      "Выберите язык",
      "Wybierz język",
      "general_language_help"
    ],
    set_language: [
      "Set the langauge",
      "Set the langauge",
      "言語を設定",
      "设置语言",
      "Sprache festlegen",
      "Choisir la langue",
      "Imposta la lingua",
      "Definir idioma",
      "Establecer idioma",
      "Установить язык",
      "Ustaw język",
      "set_language"
    ],
    organisation_name: [
      "Organisation Name",
      "Organization Name",
      "組織名",
      "组织名称",
      "Firmenname",
      "Nom de l'installateur",
      "Nome dell'organizzazione",
      "Nome da Organização",
      "Nombre de organización",
      "Название организации",
      "Nazwa organizacji",
      "organisation_name"
    ],
    organisation_name_help: [
      "Please enter the organisation name",
      "Please enter the organization name",
      "組織名を入力してください",
      "请输入组织名称",
      "Bitte tragen Sie den Firmennamen ein",
      "Veuillez entrer le nom de l'installateur",
      "Inserisci il nome dell'organizzazione",
      "Informe o nome da organização",
      "Introducir nombre organización",
      "Введите название организации",
      "Wprowadź nazwę organizacji",
      "organisation_name_help"
    ],
    org_create_successfull_toast: [
      "Organisation successfully created.",
      "Organization successfully created.",
      "組織が正常に作成されました。",
      "已成功创建组织。",
      "Firma erfolgreich erstellt",
      "L'installateur a été créé avec succès",
      "Organizzazione creata correttamente.",
      "Organização criada com sucesso.",
      "Organización creada",
      "Организация создана.",
      "Utworzenie organizacji powiodło się.",
      "org_create_successfull_toast"
    ],
    org_update_successfull_toast: [
      "Organisation successfully updated.",
      "Organization successfully updated.",
      "組織が正常に更新されました。",
      "已成功更新组织。",
      "Firma erfolgreich aktualisiert",
      "L'installateur a été mis à jour avec succès",
      "Organizzazione aggiornata correttamente.",
      "Organização atualizada com sucesso.",
      "Organización actualizada",
      "Организация обновлена.",
      "Aktualizacja organizacji powiodła się.",
      "org_update_successfull_toast"
    ],
    org_update_failed_unauthoriseduser_toast: [
      "Only Admin or Manager can be the organisation owner",
      "Only Admin or Manager can be the organization owner",
      "管理者またはマネージャーのみが組織の所有者になることができます",
      "只有管​​理员或经理才能成为组织所有者",
      "Nur Administrator oder Manager kann der Organisationseigentümer sein",
      "Seul l'administrateur ou le gestionnaire peut être le propriétaire de l'organisation",
      "Solo l'amministratore o il manager possono essere il proprietario dell'organizzazione",
      "Somente administrador ou gerente pode ser o proprietário da organização",
      "Solo el administrador o gerente puede ser el propietario de la organización",
      "Только администратор или менеджер может быть владельцем организации",
      "Tylko administrator lub menedżer może być właścicielem organizacji",
      "org_update_failed_unauthoriseduser_toast"
    ],
    org_update_failed_nouser_toast: [
      "Only existing user can be the organisation owner",
      "Only existing user can be the organization owner",
      "既存のユーザーのみが組織の所有者になることができます",
      "只有现有用户才能是组织所有者",
      "Nur vorhandener Benutzer kann der Organisationseigentümer sein",
      "Seul l'utilisateur existant peut être le propriétaire de l'organisation",
      "Solo l'utente esistente può essere il proprietario dell'organizzazione",
      "Somente o usuário existente pode ser o proprietário da organização",
      "Solo el usuario existente puede ser el propietario de la organización",
      "Только существующий пользователь может быть владельцем организации",
      "Tylko istniejący użytkownik może być właścicielem organizacji",
      "org_update_failed_nouser_toast"
    ],
    org_upload_logo_successfull_toast: [
      "Organisation logo successfully uploaded.",
      "Organization logo successfully uploaded.",
      "組織のロゴが正常にアップロードされました。",
      "已成功上传组织徽标。",
      "Firmen-Logo erfolgreich hochgeladen",
      "Le logo de l'installateur a été téléchargé avec succès",
      "Logo dell'organizzazione caricato correttamente.",
      "Logo da organização carregado com sucesso.",
      "Logo de organización subido",
      "Логотип организации отправлен.",
      "Logo organizacji zostało przesłane.",
      "org_upload_logo_successfull_toast"
    ],
    org_remove_logo_successfull_toast: [
      "Organisation logo successfully removed.",
      "Organization logo successfully removed.",
      "組織のロゴが正常に削除されました。",
      "已成功移除组织徽标。",
      "Firmen-Logo erfolgreich entfernt",
      "Le logo de l'installateur a été effacé avec succès",
      "Logo dell'organizzazione rimosso correttamente.",
      "Logo da organização excluído com sucesso.",
      "Logo de organización eliminado",
      "Логотип организации удален.",
      "Logo organizacji zostało usunięte.",
      "org_remove_logo_successfull_toast"
    ],
    org_delete_successfull_toast: [
      "Organisation successfully deleted.",
      "Organization successfully deleted.",
      "組織が正常に削除されました。",
      "已成功删除组织。",
      "Firma erfolgreich gelöscht",
      "L'installateur a été effacée avec succès",
      "Organizzazione eliminata correttamente.",
      "Organização excluída com sucesso.",
      "Organización eliminada",
      "Организация удалена.",
      "Usunięcie organizacji powiodło się.",
      "org_delete_successfull_toast"
    ],
    customer_name_help: [
      "Please enter the customer name",
      "Please enter the customer name",
      "カスタマー名を入力してください",
      "请输入客户名称",
      "Bitte tragen Sie den Kundennamen ein",
      "Veuillez entrer un nom de client",
      "Inserire il nome del cliente",
      "Informe o nome do cliente",
      "Introducir nombre de cliente",
      "Введите имя заказчика",
      "Wprowadź imię i nazwisko klienta",
      "customer_name_help"
    ],
    contact_name: [
      "Contact name",
      "Contact name",
      "連絡先の名前",
      "联系人姓名",
      "Kontaktname",
      "Nom du contact",
      "Nome del contatto",
      "Nome do Contato",
      "Nombre contacto",
      "Имя контакта",
      "Imię i nazwisko osoby do kontaktu",
      "contact_name"
    ],
    customer_contact_first_name_help: [
      "Please enter a contact first name",
      "Please enter a contact first name",
      "連絡先の「名」を入力してください",
      "请输入联系人名字",
      "Bitte geben Sie einen Vornamen ein",
      "Veuillez saisir un prénom de contact",
      "Inserisci il nome di un contatto",
      "Informe o nome de um contato",
      "Introduzca el nombre del contacto",
      "Введите имя контактного лица",
      "Wprowadź imię osoby do kontaktu",
      "customer_contact_first_name_help"
    ],
    customer_contact_last_name_help: [
      "Please enter a contact last name",
      "Please enter a contact last name",
      "連絡先の「姓」を入力してください",
      "请输入联系人姓氏",
      "Bitte geben Sie einen Nachnamen ein",
      "Veuillez saisir un nom de contact",
      "Inserisci il cognome di un contatto",
      "Informe o sobrenome de um contato",
      "Introduzca el apellido del contacto",
      "Введите фамилию контактного лица",
      "Wprowadź nazwisko osoby do kontaktu",
      "customer_contact_last_name_help"
    ],
    customer_flat: [
      "Flat",
      "Building Number",
      "建物番号",
      "公寓号",
      "Hausnummer",
      "Appartement",
      "Appartamento",
      "Complemento",
      "Puerta edificio",
      "Квартира",
      "Mieszkanie",
      "customer_flat"
    ],
    customer_flat_help: [
      "Please Enter Flat",
      "Building Number",
      "建物番号",
      "请输入公寓号",
      "Bitte tragen Sie die Hausnummer ein",
      "Veuillez entrer le nom de l'appartement",
      "Inserire appartamento",
      "Informe o complemento",
      "Introduzca nro. puerta",
      "Введите квартиру",
      "Wprowadź numer mieszkania",
      "customer_flat_help"
    ],
    customer_street: [
      "Street",
      "Street",
      "番地",
      "街道",
      "Straße",
      "Rue",
      "Via",
      "Endereço",
      "Calle",
      "Улица",
      "Ulica",
      "customer_street"
    ],
    customer_street_help: [
      "Please Enter Street",
      "Please Enter Street",
      "番地を入力してください",
      "请输入街道",
      "Bitte tragen Sie die Straße ein",
      "Veuillez entrer le nom de la rue",
      "Inserire via",
      "Informe o endereço",
      "Introduzca calle",
      "Введите улицу",
      "Wprowadź nazwę ulicy",
      "customer_street_help"
    ],
    customer_contact: [
      "Telephone",
      "Telephone",
      "電話番号",
      "电话",
      "Telefon",
      "Téléphone",
      "Telefono",
      "Telefone",
      "Teléfono",
      "Телефон",
      "Telefon",
      "customer_contact"
    ],
    customer_contact_help: [
      "Please enter a contact telephone number",
      "Please enter a contact telephone number",
      "連絡先の電話番号を入力してください",
      "请输入联系电话",
      "Bitte tragen Sie die Telefonnummer des Kontakts ein",
      "Veuillez entrer le numéro de téléphone du contact",
      "Inserire un numero di telefono di contatto",
      "Informe um telefone de contato",
      "Introduzca teléfono de contacto",
      "Введите контактный номер телефона",
      "Wprowadź numer telefonu osoby do kontaktu",
      "customer_contact_help"
    ],
    customer_email: [
      "Email",
      "Email",
      "メール",
      "电子邮件",
      "E-Mail",
      "Email",
      "E-mail",
      "E-mail",
      "Correo electrónico",
      "Электронная почта",
      "E-mail",
      "customer_email"
    ],
    customer_email_help: [
      "Please enter a contact email address",
      "Please enter a contact email address",
      "連絡先のメールアドレスを入力してください",
      "请输入联系人电子邮件地址",
      "Bitte tragen Sie die E-Mail-Adresse des Kontakts ein",
      "Veuillez entrer l'adresse email du contact",
      "Inserire l’indirizzo e-mail di contatto",
      "Informe um e-mail de contato",
      "Introduzca un correo-e de contacto",
      "Введите контактный адрес электронной почты",
      "Wprowadź adres e-mail osoby do kontaktu",
      "customer_email_help"
    ],
    customer_address: [
      "Building Number / Name",
      "Building Number / Name",
      "建物名 / 番号",
      "建筑门牌号/名称",
      "Hausnummer / Name",
      "Numéro / nom du bâtiment",
      "Numero/nome dell'edificio",
      "Número/Nome do Edifício",
      "Núm. de edificio / nombre",
      "Номер/название здания",
      "Numer budynku / nazwa",
      "customer_address"
    ],
    customer_address_help: [
      "Please enter the address",
      "Please enter the address",
      "住所を入力してください",
      "请输入地址",
      "Bitte tragen Sie die Adresse ein",
      "Veuillez entrer l'adresse",
      "Inserire l’indirizzo",
      "Informe o endereço",
      "Introduzca dirección",
      "Введите адрес",
      "Wprowadź adres",
      "customer_address_help"
    ],
    customer_city: [
      "City",
      "City",
      "市町村区",
      "城市",
      "Ort",
      "Ville",
      "Città",
      "Cidade",
      "Ciudad",
      "Город",
      "Miasto",
      "customer_city"
    ],
    customer_city_help: [
      "Please enter the city",
      "Please enter the city",
      "市町村区を入力してください",
      "请输入城市",
      "Bitte tragen Sie den Ort ein",
      "Veuillez entrer le nom de la ville",
      "Inserire la città",
      "Informe a cidade",
      "Introduzca ciudad",
      "Введите город",
      "Wprowadź nazwę miasta",
      "customer_city_help"
    ],
    customer_state_county: [
      "State / County",
      "State / County",
      "都道府県",
      "州/县",
      "Bundesland / Bezirk",
      "Etat / Département",
      "Stato / Paese",
      "Estado / região",
      "Estado / Provincia",
      "Штат / Округ",
      "Stan / hrabstwo",
      "customer_state_county"
    ],
    customer_state_county_help: [
      "Please enter the county",
      "Please enter the state",
      "都道府県を入力してください",
      "请输入州",
      "Bitte tragen Sie den Bundesstaat ein",
      "Veuillez entrer le nom du département",
      "Inserire lo stato",
      "Informe o Estado",
      "Introduzca estado",
      "Введите субъект",
      "Wprowadź nazwę powiatu",
      "customer_state_county_help"
    ],
    customer_country: [
      "Country",
      "Country",
      "国",
      "国家/地区",
      "Land",
      "Pays",
      "Paese",
      "País",
      "País",
      "Страна",
      "Kraj",
      "customer_country"
    ],
    customer_country_help: [
      "Please select the country",
      "Please select the country",
      "国を入力してください",
      "请选择国家",
      "Bitte wählen Sie das Land",
      "Sélectionnez le pays",
      "Seleziona il Paese",
      "Selecione o país",
      "Selecciona el país",
      "Выберите страну",
      "Wprowadź nazwę kraju",
      "customer_country_help"
    ],
    customer_zipcode: [
      "Postal Code",
      "ZIP",
      "郵便番号",
      "邮政编码",
      "PLZ",
      "Code postal",
      "Codice postale",
      "CEP",
      "Código postal",
      "Почтовый индекс",
      "Kod pocztowy",
      "customer_zipcode"
    ],
    customer_zipcode_help: [
      "Please enter the postal code",
      "Please enter the ZIP code",
      "郵便番号を入力してください",
      "请输入邮政编码",
      "Bitte tragen Sie die Postleitzahl ein",
      "Veuillez entrer le code postal",
      "Inserire il codice postale",
      "Informe o CEP",
      "Introduzca código postal",
      "Введите почтовый индекс",
      "Wprowadź kod pocztowy",
      "customer_zipcode_help"
    ],
    customer_chartmeasurement: [
      "Report Measurement Unit",
      "Report Measurement Unit",
      "レポート測定単位",
      "报告测量单位",
      "Bericht-Maßeinheit",
      "Unité de mesure",
      "Unità di misura del rapporto",
      "Unidade de medida do relatório",
      "Unidad de medida del informe",
      "Единица измерения отчета",
      "Zgłoś jednostkę miary",
      "customer_chartmeasurement"
    ],
    customer_chartmeasurement_help: [
      "Please select report measurement unit",
      "Please select report measurement unit",
      "レポート測定単位を選択してください",
      "请选择报告测量单位",
      "Bitte wählen Sie die Maßeinheit für den Bericht aus",
      "Veuillez choisir l'unité de mesure",
      "Selezionare l'unità di misura del rapporto",
      "Selecione a unidade de medida do relatório",
      "Seleccione unidad de medida del informe",
      "Выберите единицу измерения отчета",
      "Wybierz jednostkę miary raportu",
      "customer_chartmeasurement_help"
    ],
    customer_chartlinestyle: [
      "Report Chart Line Style",
      "Report Chart Line Style",
      "レポートグラフ: 線のスタイル",
      "报表图表线型",
      "Berichtsdiagramm-Linienstil",
      "Type de graphe",
      "Stile delle linee del diagramma del rapporto",
      "Estilo do gráfico do relatório",
      "Tipo de Gráfica del informe",
      "Стиль линии диаграммы в отчете",
      "Styl wykresu raportu",
      "customer_chartlinestyle"
    ],
    customer_chartlinestyle_help: [
      "Please select report chart line style",
      "Please select report chart line style",
      "レポートグラフの線のスタイルを選択してください",
      "请选择报表图表线型",
      "Bitte wählen Sie den Linienstil des Berichtsdiagramms aus",
      "Veuillez sélectionner un type de graphe",
      "Selezionare lo stile delle linee del diagramma del rapporto",
      "Selecione o estilo do gráfico do relatório",
      "Seleccione tipo de línea de las gráficas",
      "Выберите стиль линии диаграммы в отчете",
      "Wybierz styl wykresu raportu",
      "customer_chartlinestyle_help"
    ],
    customer_chart_feet: [
      "Feet",
      "Feet",
      "フィート",
      "英尺",
      "Fuß",
      "Pieds",
      "Piedi",
      "Pés",
      "Pies",
      "Футы",
      "Stopy",
      "customer_chart_feet"
    ],
    customer_chart_meter: [
      "Meter",
      "Meter",
      "メートル",
      "米",
      "Meter",
      "Mètre",
      "Metri",
      "Metros",
      "Metros",
      "Метры",
      "Metry",
      "customer_chart_meter"
    ],
    customer_chart_standard: [
      "Standard",
      "Standard",
      "標準",
      "标准",
      "Standard",
      "Norme",
      "Standard",
      "Padrão",
      "Estándar",
      "Стандарт",
      "Standardowy",
      "customer_chart_standard"
    ],
    customer_chart_inverted: [
      "Inverted",
      "Inverted",
      "反転",
      "颠倒",
      "Invertiert",
      "Inversé",
      "Invertito",
      "Invertido",
      "Invertido",
      "Инвертированный",
      "Odwrócony",
      "customer_chart_inverted"
    ],
    customer_ask_logo: [
      "Do you want to add a logo?",
      "Do you want to add a logo?",
      "ロゴを追加しますか?",
      "您想添加徽标吗？",
      "Möchten Sie ein Logo hinzufügen?",
      "Voulez-vous ajouter un logo ?",
      "Aggiungere un logo?",
      "Deseja incluir um logotipo?",
      "¿Desea agregar un logo?",
      "Добавить логотип?",
      "Czy chcesz dodać logo?",
      "customer_ask_logo"
    ],
    customer_delete_title: [
      "Delete Customer",
      "Delete Customer",
      "カスタマーを削除",
      "删除客户",
      "Kunden löschen",
      "Effacer client",
      "Elimina cliente",
      "Excluir cliente",
      "Eliminar cliente",
      "Удалить заказчика",
      "Usuń klienta",
      "customer_delete_title"
    ],
    customer_create_successfull_toast: [
      "Customer successfully created.",
      "Customer successfully created.",
      "カスタマーが正常に作成されました。",
      "已成功创建客户。",
      "Kunde erfolgreich erstellt",
      "Le client a été crée avec succès.",
      "Cliente creato correttamente.",
      "Cliente criado com sucesso.",
      "Cliente creado",
      "Заказчик создан.",
      "Utworzenie klienta powiodło się.",
      "customer_create_successfull_toast"
    ],
    customer_update_successfull_toast: [
      "Customer successfully updated.",
      "Customer successfully updated.",
      "カスタマーが正常に更新されました。",
      "已成功更新客户。",
      "Kunde erfolgreich aktualisiert",
      "Le client a été mis à jour avec succès",
      "Cliente aggiornato correttamente.",
      "Cliente atualizado com sucesso.",
      "Cliente actualizado",
      "Заказчик обновлен.",
      "Aktualizacja klienta powiodła się.",
      "customer_update_successfull_toast"
    ],
    customer_upload_logo_successfull_toast: [
      "Customer logo successfully uploaded.",
      "Customer logo successfully uploaded.",
      "カスタマーのロゴが正常にアップロードされました。",
      "已成功上传客户徽标。",
      "Kunden-Logo erfolgreich hochgeladen",
      "Le logo du client a été téléchargé avec succès",
      "Logo del cliente caricato correttamente.",
      "Logotipo do cliente carregado com sucesso.",
      "Logo de cliente subido",
      "Логотип заказчика отправлен.",
      "Logo klienta zostało przesłane.",
      "customer_upload_logo_successfull_toast"
    ],
    customer_remove_logo_successfull_toast: [
      "Customer logo successfully removed.",
      "Customer logo successfully removed.",
      "カスタマーのロゴが正常に削除されました。",
      "已成功移除客户徽标。",
      "Kunden-Logo erfolgreich entfernt",
      "Le logo du client a été effacé avec succès",
      "Logo del cliente rimosso correttamente.",
      "Logotipo do cliente removido com sucesso.",
      "Logo de cliente eliminado",
      "Логотип заказчика удален.",
      "Logo klienta zostało usunięte.",
      "customer_remove_logo_successfull_toast"
    ],
    customer_delete_successfull_toast: [
      "Customer successfully deleted.",
      "Customer successfully deleted.",
      "カスタマーが正常に削除されました。",
      "已成功删除客户。",
      "Kunde erfolgreich gelöscht",
      "Le client a été effacé avec succès.",
      "Cliente eliminato correttamente.",
      "Cliente excluído com sucesso.",
      "Cliente eliminado",
      "Заказчик удален.",
      "Usunięcie klienta powiodło się.",
      "customer_delete_successfull_toast"
    ],
    customer_delete_confirm_text: [
      "Are you sure you want to delete the customer <b>${name}</b>?",
      "Are you sure you want to delete the customer <b>${name}</b>?",
      "カスタマー「<b>${name}</b>」を削除してもよろしいですか?",
      "您是否确定要删除客户 <b>${name}</b>？",
      "Sind Sie sicher, dass Sie den Kunden <b>${name}</b> löschen möchten?",
      "Êtes-vous sûr de vouloir effacer le client <b>${name}</b>?",
      "Vuoi davvero eliminare il cliente <b>${name}</b>?",
      "Você tem certeza de que deseja excluir o cliente <b>${name}</b>?",
      "¿Eliminar el cliente <b>${name}</b>?",
      "Действительно удалить заказчика <b>${name}</b>?",
      "Czy na pewno chcesz usunąć klienta <b>${name}</b>?",
      "customer_delete_confirm_text"
    ],
    customer_jobarchiveperiod: [
      "Job Archive Period",
      "Job Archive Period",
      "ジョブのアーカイブ期間",
      "作业归档期限",
      "Aufbewahrungszeitraum für Aufträge",
      "Période d’archivage des dossiers",
      "Periodo di archiviazione dei lavori",
      "Período de arquivo de trabalhos",
      "Período de archivo de trabajos",
      "Срок архивирования заданий",
      "Okres archiwizacji zleceń",
      "customer_jobarchiveperiod"
    ],
    customer_reportarchiveperiod: [
      "Report Deletion Period",
      "Report Deletion Period",
      "レポートのアーカイブ期間",
      "报告归档期限",
      "Archivierungszeitraum für Berichte",
      "Période d’archivage des rapports",
      "Periodo di archiviazione dei report",
      "Período de arquivo de relatórios",
      "Período de archivo de informes",
      "Срок архивирования отчетов",
      "Okres archiwizacji raportów",
      "customer_reportarchiveperiod"
    ],
    customer_never: [
      "Never",
      "Never",
      "なし",
      "从不",
      "Nie",
      "Jamais",
      "Mai",
      "Nunca",
      "Nunca",
      "Никогда",
      "Nigdy",
      "customer_never"
    ],
    customer_month: [
      "month",
      "month",
      "月",
      "月",
      "monat",
      "mois",
      "mese",
      "mês",
      "mes",
      "месяц",
      "miesiąc",
      "customer_month"
    ],
    customer_months: [
      "months",
      "months",
      "か月",
      "个月",
      "monate",
      "mois",
      "mesi",
      "meses",
      "meses",
      "месяцы",
      "miesiące",
      "customer_months"
    ],
    error_duplicatecustomer_title: [
      "Duplicate Customer Found",
      "Duplicate Customer Found",
      "カスタマーの重複が見つかりました",
      "已发现重复的客户",
      "Kunde mehrfach gefunden",
      "Un client identique à été trouvé",
      "Trovato cliente duplicato",
      "Cliente duplicado encontrado",
      "Cliente duplicado encontrado",
      "Найден дублирующийся заказчик",
      "Znaleziono duplikat klienta",
      "error_duplicatecustomer_title"
    ],
    error_duplicatecustomer_desc: [
      "Customer with name (${name}) already exists",
      "Customer with name (${name}) already exists",
      "この名前 (${name}) のカスタマーは既に存在します",
      "已存在具有该名称 (${name}) 的客户",
      "Ein Kunde mit dem Namen (${name}) ist bereits vorhanden",
      "Un client avec ce nom (${name}) existe déjà",
      "Cliente con nome (${name}) esiste già",
      "O cliente (${name}) já existe",
      "Cliente con nombre (${name}) ya existe",
      "Заказчик с именем (${name}) уже существует",
      "Klient o nazwisku ($ {name}) już istnieje",
      "error_duplicatecustomer_desc"
    ],
    error_duplicateorganisation_title: [
      "Duplicate Organisation Found",
      "Duplicate Organisation Found",
      "重複する組織が見つかりました",
      "发现重复的组织",
      "Organisation mehrfach gefunden",
      "Une organisation identique a été trouvée",
      "Organizzazione duplicata trovata",
      "Organização duplicada encontrada",
      "Organización duplicada encontrada",
      "Обнаружена повторяющаяся организация",
      "Znaleziono zduplikowaną organizację",
      "error_duplicateorganisation_title"
    ],
    error_duplicateorganisation_desc: [
      "Organisation with name (${name}) already exists",
      "Organisation with name (${name}) already exists",
      "この名前 (${name}) の組織はすでに存在します",
      "具有该名称 (${name}) 的组织已存在",
      "Eine Organisation mit dem Namen (${name}) existiert bereits",
      "Une organisation portant ce nom (${name}) existe déjà",
      "L'organizzazione con il nome (${name}) esiste già",
      "A organização (${name}) já existe",
      "La organización con nombre (${name}) ya existe",
      "Организация с названием (${name}) уже существует.",
      "Organizacja o nazwie (${name}) już istnieje",
      "error_duplicateorganisation_desc"
    ],
    organisation_delete_title: [
      "Delete Organisation",
      "Delete Organization",
      "組織を削除",
      "删除组织",
      "Firma löschen",
      "Effacer l'installateur",
      "Elimina organizzazione",
      "Excluir organização",
      "Eliminar organización",
      "Удалить организацию",
      "Usuń organizację",
      "organisation_delete_title"
    ],
    organisation_delete_confirm_text: [
      "Be aware, deleting an organisation will also delete all jobs and tests associated with that organisation. Are you sure you want to delete the organisation <b>${name}</b>?",
      "Be aware, deleting an organization will also delete all jobs and tests associated with that organization. Are you sure you want to delete the organization <b>${name}</b>?",
      "組織を削除すると、その組織に関連付けられたすべてのジョブとテストも削除されることにご注意ください。組織「<b>${name}</b>」を削除してもよろしいですか?",
      "请注意，删除组织也会删除与该组织关联的所有工作和测试。您是否确定要删除组织 <b>${name}</b>？",
      "Bitte beachten Sie, dass mit der Firma auch sämtliche Projekte und Tests, die dieser Firma zugeordnet sind, gelöscht werden. Wollen Sie die Firma <b>${name}</b>? wirklich löschen?",
      "Attention, effacer un installateur effacera aussi tous les dossiers et tests associés à celui-ci. Êtes-vous sûr de vouloir effacer l'installateur <b>${name}</b>?",
      "Prestare attenzione. L'eliminazione di un'organizzazione eliminerà anche tutti i lavori e i test associati a tale organizzazione. Eliminare l'organizzazione <b>${name}</b>?",
      "Esteja ciente de que excluir uma organização também excluirá todos os trabalhos e testes relacionados. Você tem certeza de que deseja excluir a organização <b>${name}</b>?",
      "Recuerde: al eliminar una organización también se eliminan todos los trabajos y pruebas asociadas. ¿Eliminar organización <b>${name}</b>?",
      "При удалении организации будут удалены и все связанные с ней задания и тесты. Действительно удалить организацию <b>${name}</b>?",
      "Pamiętaj, że usunięcie organizacji spowoduje również usunięcie wszystkich zadań i testów powiązanych z tą organizacją. Czy na pewno chcesz usunąć organizację <b>${name}</b>?",
      "organisation_delete_confirm_text"
    ],
    user_title_add: [
      "Add User",
      "Add User",
      "ユーザーを追加",
      "添加用户",
      "Benutzer hinzufügen",
      "Ajouter un utilisateur",
      "Aggiungi utente",
      "Incluir usuário",
      "Agregar usuario",
      "Добавить пользователя",
      "Dodaj użytkownika",
      "user_title_add"
    ],
    user_title_edit: [
      "Edit User",
      "Edit User",
      "ユーザーを編集",
      "编辑用户",
      "Benutzer bearbeiten",
      "Éditer un utilisateur",
      "Modifica utente",
      "Editar usuário",
      "Editar usuario",
      "Изменить пользователя",
      "Edytuj użytkownika",
      "user_title_edit"
    ],
    user_email: [
      "Email",
      "Email",
      "メール",
      "电子邮件",
      "E-Mail",
      "Email",
      "E-mail",
      "E-mail",
      "Correo-e",
      "Электронная почта",
      "E-mail",
      "user_email"
    ],
    user_email_help: [
      "Please enter email",
      "Please enter email",
      "メールアドレスを入力してください",
      "请输入电子邮件",
      "Bitte geben Sie eine E-Mail an",
      "S'il vous plaît entrer email",
      "Si prega di inserire e-mail",
      "Informe o e-mail",
      "Por favor ingrese su correo-e",
      "Введите email",
      "Wprowadź adres e-mail",
      "user_email_help"
    ],
    user_email_error: [
      "Please enter valid email",
      "Please enter valid email",
      "有効なメールアドレスを入力してください",
      "请输入有效的电子邮件",
      "Bitte geben Sie eine gültige E-Mail-Adrresse ein",
      "Veuillez entrer un email valide",
      "Inserire un'e-mail valida",
      "Informe um e-mail válido",
      "Introduzca un correo-e vál.",
      "Введите допустимый адрес электронной почты",
      "Wprowadź prawidłowy adres e-mail",
      "user_email_error"
    ],
    user_firstname: [
      "First Name",
      "First Name",
      "名",
      "名字",
      "Vorname",
      "Prénom",
      "Nome",
      "Nome",
      "Nombre",
      "Имя",
      "Imię",
      "user_firstname"
    ],
    user_firstname_help: [
      "Enter your First Name",
      "Enter your First Name",
      "「名」を入力してください",
      "输入您的名字",
      "Bitte geben Sie Ihren Vornamen ein",
      "Entrez votre prénom",
      "Inserisci il tuo nome",
      "Informe seu nome",
      "Introduzca su nombre",
      "Введите ваше имя",
      "Wprowadź swoje imię",
      "user_firstname_help"
    ],
    user_lastname: [
      "Last Name",
      "Last Name",
      "姓",
      "姓氏",
      "Nachname",
      "Nom",
      "Cognome",
      "Sobrenome",
      "Apellido",
      "Фамилия",
      "Nazwisko",
      "user_lastname"
    ],
    user_lastname_help: [
      "Enter your Last Name",
      "Enter your Last Name",
      "「姓」を入力してください",
      "输入您的姓氏",
      "Bitte geben Sie Ihren Nachnamen ein",
      "Entrez votre nom",
      "Inserisci il tuo cognome",
      "Informe seu sobrenome",
      "Introduzca su apellido",
      "Введите вашу фамилию",
      "Wprowadź swoje nazwisko",
      "user_lastname_help"
    ],
    user_roles: [
      "User Roles",
      "User Roles",
      "ユーザーロール",
      "用户角色",
      "Benutzer-Rollen",
      "Fonction de l'utilisateur",
      "Funzioni dell'utente",
      "Funções do Usuário",
      "Roles usuario",
      "Роли пользователей",
      "Role użytkownika",
      "user_roles"
    ],
    user_roles_help: [
      "Please Select a Role",
      "Please Select a Role",
      "ロールを選択してください",
      "请选择一个角色",
      "Bitte wählen Sie eine Rolle aus",
      "Veuillez sélectionner une fonction",
      "Seleziona una funzione",
      "Selecione uma função",
      "Seleccionar rol",
      "Выберите роль",
      "Wybierz rolę",
      "user_roles_help"
    ],
    user_language: [
      "Language",
      "Language",
      "言語",
      "语言",
      "Sprache",
      "Langue",
      "Lingua",
      "Idioma",
      "Idioma",
      "Язык",
      "Język",
      "user_language"
    ],
    user_language_help: [
      "Please Select a Language",
      "Please Select a Language",
      "言語を選択してください",
      "请选择语言",
      "Bitte wählen Sie eine Sprache aus",
      "Veuillez sélectionner une langue",
      "Seleziona una lingua",
      "Selecione um idioma",
      "Seleccionar idioma",
      "Выберите язык",
      "Wybierz język",
      "user_language_help"
    ],
    user_metric: [
      "Measurement Units",
      "Measurement Units",
      "測定単位",
      "测量单位",
      "Maßeinheiten",
      "Unités de mesure",
      "Unità di misura",
      "Unidade de Medida",
      "Unidad de medida",
      "Единицы измерения",
      "Jednostki miary",
      "user_metric"
    ],
    user_metric_feet: [
      "Feet",
      "Feet",
      "フィート",
      "英尺",
      "Fuß",
      "Pieds",
      "Piedi",
      "Pés",
      "Pies",
      "Футы",
      "Stopy",
      "user_metric_feet"
    ],
    user_metric_meter: [
      "Meters",
      "Meters",
      "メートル",
      "米",
      "Meter",
      "Mètres",
      "Metri",
      "Metros",
      "Metros",
      "Метры",
      "Metry",
      "user_metric_meter"
    ],
    user_metric_help: [
      "Please select a measurement unit",
      "Please select a measurement unit",
      "測定単位を選択してください",
      "请选择测量单位",
      "Bitte wählen Sie eine Maßeinheit aus",
      "Veuillez choisir une unité de mesure",
      "Selezionare un'unità di misura",
      "Selecione uma unidade de medida",
      "Seleccionar unidad de medida",
      "Выберите единицу измерения",
      "Wybierz jednostkę miary",
      "user_metric_help"
    ],
    user_enable_confirm_title: [
      "Enable User Account",
      "Enable User Account",
      "ユーザーアカウントを有効化",
      "启用用户帐户",
      "Benutzerkonto aktivieren",
      "Activer le compte utilisateur",
      "Abilita account utente",
      "Habilitar Conta do Usuário",
      "Habilitar cuenta usuario",
      "Включить учетную запись пользователя",
      "Włącz konto użytkownika",
      "user_enable_confirm_title"
    ],
    user_enable_confirm_text: [
      "Are you sure you want to enable the user <b>${firstname} ${lastname} (${email})</b>?",
      "Are you sure you want to enable the user <b>${firstname} ${lastname} (${email})</b>?",
      "ユーザー「<b>${firstname} ${lastname} (${email})</b>」を有効化しますか?",
      "您是否确定要启用用户 <b>${firstname} ${lastname} (${email})</b>？",
      "Sind Sie sicher, dass Sie die den Benutzer <b>${firstname} ${lastname} (${email})</b> aktivieren möchten?",
      "Êtes-vous sûr de vouloir activer l'utilisateur <b>${firstname} ${lastname} (${email})</b>?",
      "Abilitare l'utente <b>${firstname} ${lastname} (${email})</b>?",
      "Você tem certeza de que deseja habilitar o usuário <b>${firstname} ${lastname} (${email})</b>?",
      "¿Habilitar usuario <b>${firstname} ${lastname} (${email})</b>?",
      "Действительно включить пользователя <b>${firstname} ${lastname} (${email})</b>?",
      "Czy na pewno chcesz włączyć konto użytkownika <b>${firstname} ${lastname} (${e-mail})</b>?",
      "user_enable_confirm_text"
    ],
    user_disable_confirm_title: [
      "Disable User Account",
      "Disable User Account",
      "ユーザーアカウントを無効化",
      "禁用用户帐户",
      "Benutzerkonto deaktivieren",
      "Désactiver le compte utilisateur",
      "Disabilita account utente",
      "Desabilitar Conta do Usuário",
      "Deshabilitar cuenta usuario",
      "Отключить учетную запись пользователя",
      "Wyłącz konto użytkownika",
      "user_disable_confirm_title"
    ],
    user_disable_confirm_text: [
      "Are you sure you want to disable the user <b>${firstname} ${lastname} (${email})</b>?",
      "Are you sure you want to disable the user <b>${firstname} ${lastname} (${email})</b>?",
      "ユーザー「<b>${firstname} ${lastname} (${email})</b>」を無効化しますか?",
      "您是否确定要禁用用户 <b>${firstname} ${lastname} (${email})</b>？",
      "Sind Sie sicher, dass Sie die den Benutzer <b>${firstname} ${lastname} (${email})</b>  deaktivieren möchten?",
      "Êtes-vous sûr de vouloir désactiver l'utilisateur <b>${firstname} ${lastname} (${email})</b>?",
      "Disabilitare l'utente <b>${firstname} ${lastname} (${email})</b>?",
      "Você tem certeza de que deseja desabilitar o usuário <b>${firstname} ${lastname} (${email})</b>?",
      "¿Deshabilitar usuario <b>${firstname} ${lastname} (${email})</b>?",
      "Действительно отключить пользователя <b>${firstname} ${lastname} (${email})</b>?",
      "Czy na pewno chcesz wyłączyć konto użytkownika <b>${firstname} ${lastname} (${e-mail})</b>?",
      "user_disable_confirm_text"
    ],
    user_delete_confirm_text: [
      "Are you sure you want to delete the user <b>${firstname} ${lastname} (${email})</b>?",
      "Are you sure you want to delete the user <b>${firstname} ${lastname} (${email})</b>?",
      "ユーザー「<b>${firstname} ${lastname} (${email})</b>」を削除しますか?",
      "您是否确定要删除用户 <b>${firstname} ${lastname} (${email})</b>？",
      "Möchten Sie den Benutzer wirklich löschen <b>${firstname} ${lastname} (${email})</b>?",
      "Êtes-vous sûr de vouloir effacer l'utilisateur <b>${firstname} ${lastname} (${email})</b>?",
      "Vuoi davvero eliminare l'utente <b>${firstname} ${lastname} (${email})</b>?",
      "Você tem certeza de que deseja excluir o usuário <b>${firstname} ${lastname} (${email})</b>?",
      "¿Eliminar usuario <b>${firstname} ${lastname} (${email})</b>?",
      "Действительно удалить пользователя <b>${firstname} ${lastname} (${email})</b>?",
      "Czy na pewno chcesz usunąć konto użytkownika <b>${firstname} ${lastname} (${e-mail})</b>?",
      "user_delete_confirm_text"
    ],
    user_delete_confirm_title: [
      "Delete User Account",
      "Delete User Account",
      "ユーザーアカウントを削除",
      "删除用户帐户",
      "Benutzerkonto löschen",
      "Effacer le compte utilisateur",
      "Elimina account utente",
      "Excluir Conta do Usuário",
      "Eliminar cta de usuario",
      "Удалить учетную запись пользователя",
      "Usuń konto użytkownika",
      "user_delete_confirm_title"
    ],
    error_duplicateuser_title: [
      "Duplicate User Found",
      "Duplicate User Found",
      "ユーザーの重複が見つかりました",
      "已发现重复用户",
      "Doppelten Benutzer gefunden",
      "Dupliquer l'utilisateur trouvé",
      "Trovato utente duplicato",
      "Usuário duplicado encontrado",
      "Usuario duplicado encontrado",
      "Найден дублирующийся пользователь",
      "Znaleziono duplikat użytkownika",
      "error_duplicateuser_title"
    ],
    error_duplicateuser_desc: [
      "User with email (${email}) already exists in another organisation",
      "User with email (${email}) already exists in another organisation",
      "この電子メール アドレス (${email}) を持つユーザーはすでに別の組織に存在します",
      "具有此电子邮件地址 (${email}) 的用户已存在于另一个组织中",
      "Ein Benutzer mit der E-Mail-Adresse (${email}) existiert bereits in einer anderen Organisation",
      "L'utilisateur avec l'e-mail (${email}) existe déjà dans une autre organisation",
      "Un utente con indirizzo email (${email}) esiste già in un'altra organizzazione",
      "Já existe um usuário com o endereço de e-mail (${email}) em outra organização",
      "El usuario con correo electrónico (${email}) ya existe en otra organización",
      "Пользователь с адресом (${email}) уже существует в другой организации.",
      "Użytkownik z adresem e-mail (${email}) istnieje już w innej organizacji",
      "error_duplicateuser_desc"
    ],
    org_user_imp_confirm_title: [
      "Impersonate User",
      "Impersonate User",
      "ユーザーを偽装",
      "模仿用户",
      "Benutzer impersonieren",
      "Prendre la place de l'utilisateur",
      "Impersona utente",
      "Personificar Usuário",
      "Suplantar usuario",
      "Администрирование пользователя",
      "Personifikuj użytkownika",
      "org_user_imp_confirm_title"
    ],
    org_user_imp_confirm_text: [
      "You are about to impersonate the user <b>${firstname} ${lastname} (${email})</b> in the <b>${customer_name}</b> organisation.",
      "You are about to impersonate the user <b>${firstname} ${lastname} (${email})</b> in the <b>${customer_name}</b> organisation.",
      "組織「<b>${customer_name}</b>」のユーザー「<b>${firstname} ${lastname} (${email})</b>」を偽装しようとしています。",
      "您将要模仿 ${customer_name} 组织中的用户 <b>${firstname} ${lastname} (${email})</b>。",
      "Sie sind dabei, den Benutzer <b>${firstname} ${lastname} (${email})</b> in der Firma <b>${customer_name}</b> zu imitieren",
      "Vous êtes sur le point de prendre la place de l'utilisateur <b>${firstname} ${lastname}</b> (${email}) de l'installateur <b>${customer_name}</b>",
      "Stai per impersonare l'utente <b>${firstname} ${lastname} (${email})</b> nell’organizzazione <b>${customer_name}</b>.",
      "Você está prestes a personificar o usuário <b>${firstname} ${lastname} (${email})</b> na organização <b>${customer_name}</b>.",
      "Está a punto de suplantar al usuario <b>${firstname} ${lastname} (${email})</b>  en la organización <b>${customer_name}</b>",
      "Вы собираетесь включить администрирование пользователя <b>${firstname} ${lastname} (${email})</b> организации <b>${customer_name}</b>",
      "Masz zamiar personifikować użytkownika <b>${firstname} ${lastname} (${e-mail})</b> w organizacji <b>${customer_name}</b>.",
      "org_user_imp_confirm_text"
    ],
    user_create_successfull_toast: [
      "User account successfully created",
      "User account successfully created",
      "ユーザーアカウントが正常に作成されました",
      "已成功创建用户帐户",
      "Benutzerkonto erfolgreich erstellt",
      "Le compte utilisateur a été crée avec succès",
      "Account utente creato correttamente",
      "Conta de usuário criada com sucesso",
      "Cuenta de usuario creada",
      "Учетная запись пользователя создана",
      "Utworzenie konta użytkownika powiodło się",
      "user_create_successfull_toast"
    ],
    user_update_successfull_toast: [
      "User account successfully updated",
      "User account successfully updated",
      "ユーザーアカウントが正常に更新されました",
      "已成功更新用户帐户",
      "Benutzerkonto erfolgreich aktualisiert",
      "Le compte utilisateur a été mis à jour avec succès",
      "Account utente aggiornato correttamente",
      "Conta de usuário atualizada com sucesso",
      "Cuenta de usuario actualizada",
      "Учетная запись пользователя обновлена",
      "Aktualizacja konta użytkownika powiodła się",
      "user_update_successfull_toast"
    ],
    user_update_duplicate_user_toast: [
      "Email address could not be updated",
      "Email address could not be updated",
      "メールアドレスを更新できませんでした",
      "电子邮件地址无法更新",
      "E-Mail-Adresse konnte nicht aktualisiert werden.",
      "L’adresse e-mail n’a pas pu être mise à jour",
      "Impossibile aggiornare l’indirizzo e-mail",
      "O endereço de e-mail não pôde ser atualizado",
      "No se encontró la dirección de correo electrónico",
      "Не удается обновить адрес электронной почты",
      "Aktualizacja adresu e-mail nie powiodła się",
      "user_update_duplicate_user_toast"
    ],
    user_delete_successfull_toast: [
      "User account successfully deleted",
      "User account successfully deleted",
      "ユーザーアカウントが正常に削除されました",
      "已成功删除用户帐户",
      "Benutzerkonto erfolgreich gelöscht",
      "Le compte utilisateur a été effacé avec succès",
      "Account utente eliminato correttamente",
      "Conta de usuário excluída com sucesso",
      "Cuenta de usuario eliminada",
      "Учетная запись пользователя удалена",
      "Usunięcie konta użytkownika powiodło się",
      "user_delete_successfull_toast"
    ],
    user_delete_failure_toast: [
      "Cannot delete logged in user",
      "Cannot delete logged in user",
      "ログインしているユーザーを削除することはできません",
      "无法删除登录用户",
      "Angemeldeter Benutzer kann nicht gelöscht werden",
      "Impossible de supprimer l’utilisateur connecté",
      "Impossibile eliminare un utente che ha eseguito l’accesso",
      "Não é possível excluir um usuário conectado",
      "No es posible eliminar al usuario conectado",
      "Невозможно удалить пользователя, вошедшего в систему",
      "Nie można usunąć zalogowanego użytkownika",
      "user_delete_failure_toast"
    ],
    user_toggle_disable_successfull_toast: [
      "User account successfully disabled",
      "User account successfully disabled",
      "ユーザーアカウントが正常に無効化されました",
      "已成功禁用用户帐户",
      "Benutzerkonto erfolgreich deaktiviert",
      "Le compte utilisateur a été désactivé avec succès",
      "Account utente disabilitato correttamente",
      "Conta de usuário desabilitada com sucesso",
      "Cuenta de usuario bloqueada",
      "Учетная запись пользователя отключена",
      "Wyłączenie konta użytkownika powiodło się",
      "user_toggle_disable_successfull_toast"
    ],
    user_toggle_disable_failure_toast: [
      "Cannot disable logged in user",
      "Cannot disable logged in user",
      "ログインしているユーザーを無効化することはできません",
      "无法禁用登录用户",
      "Angemeldeter Benutzer kann nicht deaktiviert werden",
      "Impossible de désactiver l’utilisateur connecté",
      "Impossibile disabilitare un utente che ha eseguito l’accesso",
      "Não é possível desativar um usuário conectado",
      "No es posible deshabilitar al usuario conectado",
      "Невозможно отключить пользователя, вошедшего в систему",
      "Nie można wyłączyć zalogowanego użytkownika",
      "user_toggle_disable_failure_toast"
    ],
    user_toggle_enable_successfull_toast: [
      "User account successfully enabled",
      "User account successfully enabled",
      "ユーザーアカウントが正常に有効化されました",
      "已成功启用用户帐户",
      "Benutzerkonto erfolgreich aktiviert",
      "Le compte utilisateur a été activé avec succès",
      "Account utente abilitato correttamente",
      "Conta de usuário habilitada com sucesso",
      "Cuenta de usuario habilitada",
      "Учетная запись пользователя включена",
      "Włączenie konta użytkownika powiodło się",
      "user_toggle_enable_successfull_toast"
    ],
    general_ok: [
      "OK",
      "OK",
      "OK",
      "确定",
      "OK",
      "OK",
      "OK",
      "OK",
      "OK",
      "ОК",
      "OK",
      "general_ok"
    ],
    general_cancel: [
      "Cancel",
      "Cancel",
      "キャンセル",
      "取消",
      "Abbrechen",
      "Annuler",
      "Annulla",
      "Cancelar",
      "Cancelar",
      "Отмена",
      "Anuluj",
      "general_cancel"
    ],
    general_close: [
      "Close",
      "Close",
      "閉じる",
      "关闭",
      "Schliessen",
      "Fermer",
      "Chiudi",
      "Fechar",
      "Cerrar",
      "Закрыть",
      "Zamknij",
      "general_close"
    ],
    general_submit: [
      "Submit",
      "Submit",
      "送信",
      "提交",
      "Abschicken",
      "Soumettre",
      "Invia",
      "Enviar",
      "Enviar",
      "Отправить",
      "Prześlij",
      "general_submit"
    ],
    general_continue: [
      "Continue",
      "Continue",
      "続行",
      "继续",
      "Weiter",
      "Continuer",
      "Continua",
      "Continuar",
      "Continuar",
      "Продолжить",
      "Dalej",
      "general_continue"
    ],
    general_view: [
      "View",
      "View",
      "表示",
      "查看",
      "Anzeigen",
      "Voir",
      "Visualizza",
      "Visualizar",
      "Ver",
      "Просмотр",
      "Zobacz",
      "general_view"
    ],
    general_edit: [
      "Edit",
      "Edit",
      "編集",
      "编辑",
      "Bearbeiten",
      "Éditer",
      "Modifica",
      "Editar",
      "Editar",
      "Изменить",
      "Edytuj",
      "general_edit"
    ],
    general_delete: [
      "Delete",
      "Delete",
      "削除",
      "删除",
      "Löschen",
      "Effacer",
      "Elimina",
      "Excluir",
      "Eliminar",
      "Удалить",
      "Usuń",
      "general_delete"
    ],
    general_confirmation: [
      "Confirmation",
      "Confirmation",
      "確認",
      "确认",
      "Bestätigung",
      "Confirmation",
      "Conferma",
      "Confirmação",
      "Confirmación",
      "Подтверждение",
      "Potwierdzenie",
      "general_confirmation"
    ],
    general_confirm: [
      "Confirm",
      "Confirm",
      "確認",
      "确认",
      "Bestätigen",
      "Confirmer",
      "Conferma",
      "Confirmar",
      "Confirmar",
      "Подтвердить",
      "Potwierdź",
      "general_confirm"
    ],
    general_proceed: [
      "Proceed",
      "Proceed",
      "続行",
      "继续",
      "Fortfahren",
      "Procéder",
      "Procedi",
      "Prosseguir",
      "Continuar",
      "Продолжить",
      "Kontynuuj",
      "general_proceed"
    ],
    general_confirmation_help_1: [
      "Please confirm this action before proceeding.",
      "Please confirm this action before proceeding.",
      "続行する前に、このアクションを確認してください。",
      "请在继续之前确认此操作。",
      "Bitte bestätigen Sie diese Aktion, bevor Sie fortfahren.",
      "Veuillez confirmer cette action avant de continuer",
      "Confermare questa azione prima di procedere.",
      "Confirme esta ação antes de prosseguir.",
      "Confirme esta acción antes de continuar",
      "Для продолжения подтвердите это действие.",
      "Potwierdź tę czynność przed kontynuowaniem.",
      "general_confirmation_help_1"
    ],
    general_confirmation_help_2: [
      "This operation cannot be undone.",
      "This operation cannot be undone.",
      "この操作は元に戻せません。",
      "该操作无法撤消。",
      "Diese Aktion kann nicht rückgängig gemacht werden.",
      "Cette opération ne peut pas être annulée",
      "Questa operazione non può essere annullata.",
      "Esta operação não pode ser desfeita.",
      "No se puede deshacer la operación",
      "Эту операцию нельзя отменить.",
      "Tej operacji nie można cofnąć.",
      "general_confirmation_help_2"
    ],
    settings_upload_limitdb: [
      "Upload Limit Database",
      "Upload Limit Database",
      "制限データベースをアップロード",
      "上传限制数据库",
      "Grenzwerte-Datenbank-hochladen",
      "Limite de téléchargement de la base de donnée",
      "Carica limite database",
      "Carregar banco-de-dados de limites",
      "Cargue el límite de carga",
      "Загрузить лимит базы данных",
      "Prześlij informacje o limicie bazy danych",
      "settings_upload_limitdb"
    ],
    settings_upload_cableinfo: [
      "Upload Cable Info",
      "Upload Cable Info",
      "ケーブル情報をアップロード",
      "上传线缆信息",
      "Kabel-Infos hochladen",
      "Télécharger les informations du câble",
      "Carica informazioni sul cavo",
      "Carregar Informações do Cabo",
      "Subir info de cable",
      "Загрузить сведения о кабеле",
      "Prześlij informacje o okablowaniu",
      "settings_upload_cableinfo"
    ],
    settings_upload_connectorinfo: [
      "Upload Connector Info",
      "Upload Connector Info",
      "コネクタ情報をアップロード",
      "上传连接器信息",
      "Verbinder-Infos hochladen",
      "Télécharger les informations du connecteur",
      "Carica informazioni sul connettore",
      "Carregar Informações do Conector",
      "Subir info de conector",
      "ОЗагрузить сведения о разъеме",
      "Prześlij informacje o złączu",
      "settings_upload_connectorinfo"
    ],
    settings_current_version: [
      "Current Version:",
      "Current Version:",
      "現在のバージョン:",
      "当前版本：",
      "Aktuelle Version:",
      "Version actuelle :",
      "Versione attuale:",
      "Versão Atual:",
      "Versión actual:",
      "Текущая версия:",
      "Aktualna wersja:",
      "settings_current_version"
    ],
    settings_date_uploaded: [
      "Date Uploaded:",
      "Date Uploaded:",
      "データをアップロードしました:",
      "上传日期：",
      "Hochgeladen am:",
      "Date téléchargée :",
      "Data di caricamento:",
      "Data de carregamento:",
      "Fecha subida",
      "Дата загрузки:",
      "Data przesłania:",
      "settings_date_uploaded"
    ],
    settings_view_log: [
      "View Log",
      "View Log",
      "ログを表示",
      "查看日志",
      "Protokoll anzeigen",
      "Afficher le journal",
      "Visualizza registro",
      "Visualizar registro",
      "Ver registro",
      "Просмотр журнала",
      "Wyświetl dziennik",
      "settings_view_log"
    ],
    settings_upload: [
      "Upload",
      "Upload",
      "アップロード",
      "上传",
      "Upload",
      "Télécharger",
      "Carica",
      "Carregar",
      "Subir",
      "Загрузить",
      "Prześlij",
      "settings_upload"
    ],
    settings_devicesoftware: [
      "Device Software",
      "Device Software",
      "デバイスソフトウェア",
      "设备软件",
      "Geräte-Software",
      "Logiciel de l'appareil",
      "Software del dispositivo",
      "Software do Dispositivo",
      "SW del equipo",
      "ПО устройства",
      "Oprogramowanie urządzenia",
      "settings_devicesoftware"
    ],
    settings_manufacturerdb: [
      "Manufacturer Database",
      "Manufacturer Database",
      "メーカーデータベース",
      "制造商数据库",
      "Herstellerdatenbank",
      "Fabricant de la base de donnée",
      "Produttore Database",
      "Banco-de-Dados de Fabricantes",
      "Base de datos del fabricante",
      "База данных производителей",
      "Baza danych producenta",
      "settings_manufacturerdb"
    ],
    settings_copperlimitsdb: [
      "LTIII Copper Limits Database",
      "LTIII Copper Limits Database",
      "LTIII (銅線) 制限データベース",
      "LTIII Copper Limits 数据库",
      "LTIII Kupfergrenzwerte Datenbank",
      "LTIII Limites cuivres de la base de donnée",
      "LTIII Database dei limiti di rame",
      "Banco-de-dados de limites de cobre do LTIII",
      "LTIII Base de datos de límites de cobre",
      "LTIII База данных пределов кабелей",
      "Baza danych dot. limitów miedzi LTIII",
      "settings_copperlimitsdb"
    ],
    settings_lt4copperlimitsdb: [
      "LTIV Copper Limits Database",
      "LTIV Copper Limits Database",
      "LTIV (銅線) 制限データベース",
      "LTIV Copper Limits 数据库",
      "LTIV Kupfergrenzwerte Datenbank",
      "LTIV Limites cuivres de la base de donnée",
      "LTIV Database dei limiti di rame",
      "Banco-de-dados de limites de cobre do LTIV",
      "LTIV Base de datos de límites de cobre",
      "LTIV База данных пределов кабелей",
      "Baza danych dot. limitów miedzi LTIV",
      "settings_lt4copperlimitsdb"
    ],
    settings_lt4adapterpolicydb: [
          "Adapter Policy Database",
          "Adapter Policy Database",
          "アダプターポリシーデータベース",
          "适配器策略数据库",
          "Adapterrichtliniendatenbank",
          "Base de données des politiques d’adaptateurs",
          "Database criteri adattatori",
          "Base de dados de políticas de adaptadores",
          "Base de datos de políticas de adaptadores",
          "База данных политик адаптеров",
          "Baza danych zasad adapterów",
          "settings_lt4adapterpolicydb"
    ],
    settings_device_software_label: [
      "Device Software Update File",
      "Device Software Update File",
      "デバイスソフトウェアの更新ファイル",
      "设备软件更新文件",
      "Update-Datei der Geräte-Software",
      "Fichier de mise à jour logicielle de l'appareil",
      "File di aggiornamento del software del dispositivo",
      "Arquivo de Atualização do Software do Dispositivo",
      "Archivo de actualización de SW del equipo",
      "Файл обновления ПО устройства",
      "Plik aktualizacji oprogramowania urządzenia",
      "settings_device_software_label"
    ],
    settings_device_software_release_notes_label: [
      "Device Software Release Notes",
      "Device Software Release Notes",
      "デバイスソフトウェアのリリースノート",
      "设备软件发行说明",
      "Versionshinweise zur Geräte-Software",
      "Notes de version du logiciel de l'appareil",
      "Note informative sul software del dispositivo",
      "Notas de Lançamento do Software do Dispositivo",
      "Notas versión SW del equipo",
      "Заметки о выпуске ПО устройства",
      "Uwagi do wydania oprogramowania urządzenia",
      "settings_device_software_release_notes_label"
    ],
    settings_manufacturerdb_title: [
      "Manufacturer Database Upload",
      "Manufacturer Database Upload",
      "メーカーデータベースのアップロード",
      "制造商数据库上传",
      "Upload der Herstellerdatenbank",
      "Télécharger la base de donnée du fabricant",
      "Caricamento del database del produttore",
      "Carregar banco-de-dados de fabricantes",
      "Carga de la base de datos del fabricante",
      "Загрузка базы данных производителей",
      "Przesyłanie bazy danych producenta",
      "settings_manufacturerdb_title"
    ],
    settings_copper_limitsdb_label: [
      "LTIII Limits Database File",
      "LTIII Limits Database File",
      "LTIII 制限データベースファイル",
      "LTIII 限制数据库文件",
      "LTIII Grenzwerte-Datenbank-Datei",
      "LTIII Limites du fichier de la base de donnée",
      "LTIII Limita il file di database",
      "Arquivo de banco-de-dados de limites do LTIII",
      "LTIII Archivo de base de datos de límites",
      "LTIII Файл базы данных пределов",
      "Plik z bazą danych dot. limitów LTIII",
      "settings_copper_limitsdb_label"
    ],
    settings_lt4copper_limitsdb_label: [
      "LTIV Limits Database File",
      "LTIV Limits Database File",
      "LTIV 制限データベースファイル",
      "LTIV 限制数据库文件",
      "LTIV Grenzwerte-Datenbank-Datei",
      "LTIV Limites du fichier de la base de donnée",
      "LTIV Limita il file di database",
      "Arquivo de banco-de-dados de limites do LTIV",
      "Archivo base de datos de límites LTIV",
      "LTIV Файл базы данных пределов",
      "Plik z bazą danych dot. limitów LTIV",
      "settings_lt4copper_limitsdb_label"
    ],
    settings_lt4adapter_policydb_label: [
          "Adapter Policy Database File",
          "Adapter Policy Database File",
          "アダプターポリシーデータベースファイル",
          "适配器策略数据库文件",
          "Adapterrichtliniendatei",
          "Fichier de base de données des politiques d’adaptateurs",
          "File del database criteri adattatori",
          "Ficheiro da base de dados de políticas de adaptadores",
          "Archivo de base de datos de políticas de adaptadores",
          "Файл базы данных политик адаптеров",
          "Plik bazy danych zasad adapterów",
          "settings_lt4adapter_policydb_label"
    ],
    settings_lt4adapter_policydb_help: [
          "Upload the LanTEK IV adapter policy database file.",
          "Upload the LanTEK IV adapter policy database file.",
          "LanTEK IV アダプターポリシーデータベースファイルをアップロードします。",
          "上传 LanTEK IV 适配器策略数据库文件。",
          "Laden Sie die LanTEK IV-Adapterrichtliniendatei hoch.",
          "Téléchargez le fichier de base de données des politiques d’adaptateurs LanTEK IV.",
          "Caricare il file del database criteri adattatori LanTEK IV.",
          "Carregue o ficheiro da base de dados de políticas de adaptadores LanTEK IV.",
          "Cargue el archivo de base de datos de políticas de adaptadores LanTEK IV.",
          "Загрузите файл базы данных политик адаптеров LanTEK IV.",
          "Prześlij plik bazy danych zasad adapterów LanTEK IV.",
          "settings_lt4adapter_policydb_help"
    ],
    settings_copper_limitsdb_help: [
      "Should be a valid JSON File",
      "Should be a valid JSON File",
      "有効なJSONファイルである必要があります",
      "应该是有效的 JSON 文件",
      "Muss eine gültige JSON-Datei sein",
      "Il faut que le fichier JSON soit valide",
      "Deve essere un File JSON valido",
      "Deve ser um arquivo JSON válido",
      "Debe ser un archivo JSON válido",
      "Должен быть корректным файлом JSON",
      "Powinien to być odpowiedni plik JSON",
      "settings_copper_limitsdb_help"
    ],
    settings_copper_limitsdb_title: [
      "LTIII Copper Limits Database Upload",
      "LTIII Copper Limits Database Upload",
      "LTIII (銅線) 制限データベースのアップロード",
      "LTIII Copper Limits 数据库上传",
      "LTIII Upload der Kupfer-Grenzwerte-Datenbank",
      "LTIII Télécharger les limites de la base de donnée du cuivre",
      "LTIII Caricamento dei Limiti database di rame",
      "Carregar banco-de-dados de limites de cobre do LTIII",
      "Subir base de datos límites cobre LTIII",
      "LTIII Загрузка базы данных пределов кабелей",
      "Prześlij bazę danych dot. limitów miedzi LTIII ",
      "settings_copper_limitsdb_title"
    ],
    settings_devicesoftwareupdatereleasenotes_label: [
      "Device Software Release notes File",
      "Device Software Release notes File",
      "デバイスソフトウェアのリリースノートファイル",
      "设备软件发行说明文件",
      "Versionshinweise-Datei der Geräte-Software",
      "Fichier des notes de version du logiciel de l'appareil",
      "File delle Note informative sul software del dispositivo",
      "Arquivo de Notas de Lançamento do Software do Dispositivo",
      "Archivo notas de versión SW del equipo",
      "Файл заметок о выпуске ПО устройства",
      "Plik z uwagami do wydania oprogramowania urządzenia",
      "settings_devicesoftwareupdatereleasenotes_label"
    ],
    settings_device_software_title: [
      "Device Software Upload",
      "Device Software Upload",
      "デバイスソフトウェアのアップロード",
      "设备软件上传",
      "Upload der Geräte-Software",
      "Télécharger le logiciel de l'appareil",
      "Caricamento del software del dispositivo",
      "Carregar Software do Dispositivo",
      "Subir SW de equipo",
      "Загрузка ПО устройства",
      "Prześlij oprogramowanie urządzenia",
      "settings_device_software_title"
    ],
    settings_device_software_help: [
      "Should be a valid zip File",
      "Should be a valid zip File",
      "有効なZIPファイルである必要があります",
      "应该是有效的 zip 文件",
      "Muss eine gültige ZIP-Datei sein",
      "Le fichier zip doit être valide",
      "Deve essere un File zip valido",
      "Deve ser um arquivo zip válido",
      "Debe ser un archivo ZIP válido",
      "Должен быть корректным файлом ZIP",
      "Powinien to być odpowiedni plik zip",
      "settings_device_software_help"
    ],
    settings_device_software_release_notes_help: [
      "Should be a pdf File",
      "Should be a pdf File",
      "PDFファイルである必要があります",
      "应该是 pdf 文件",
      "Muss eine PDF-Datei sein",
      "Le fichier doit être au format PDF",
      "Deve essere un File pdf",
      "Deve ser um arquivo pdf",
      "Debe ser un archivo PDF",
      "Должен быть файлом PDF",
      "Powinien to być plik pdf",
      "settings_device_software_release_notes_help"
    ],
    settings_cableinfofile_label: [
      "Cable Info File",
      "Cable Info File",
      "ケーブル情報ファイル",
      "线缆信息文件",
      "Kabel-Info-Datei",
      "Fichier d'informations sur le câble",
      "File delle informazioni sul cavo",
      "Arquivo de Informações do Cabo",
      "Archivo info cable",
      "Файл сведения о кабеле",
      "Plik z informacjami o okablowaniu",
      "settings_cableinfofile_label"
    ],
    settings_cableinfofile_help: [
      "Should be a valid JSON File",
      "Should be a valid JSON File",
      "有効なJSONファイルである必要があります",
      "应该是有效的 JSON 文件",
      "Muss eine gültige JSON-Datei sein",
      "Il faut que le fichier JSON soit valide",
      "Deve essere un File JSON valido",
      "Deve ser um arquivo JSON válido",
      "Debe ser un archivo JSON válido",
      "Должен быть корректным файлом JSON",
      "Powinien to być odpowiedni plik JSON",
      "settings_cableinfofile_help"
    ],
    settings_connectorinfofile_label: [
      "Connector Info File",
      "Connector Info File",
      "コネクタ情報ファイル",
      "连接器信息文件",
      "Connector Info Datei",
      "Fichier d'informations sur le connecteur",
      "File delle informazioni sul connettore",
      "Arquivo de Informações do Cabo",
      "Archivo info conector",
      "Файл сведений о разъеме",
      "Plik z informacjami o złączu",
      "settings_connectorinfofile_label"
    ],
    settings_connectorinfofile_help: [
      "Should be a valid JSON File",
      "Should be a valid JSON File",
      "有効なJSONファイルである必要があります",
      "应该是有效的 JSON 文件",
      "Muss eine gültige JSON-Datei sein",
      "Il faut que le fichier JSON soit valide",
      "Deve essere un File JSON valido",
      "Deve ser um arquivo JSON válido",
      "Debe ser un archivo JSON válido",
      "Должен быть корректным файлом JSON",
      "Powinien to być odpowiedni plik JSON",
      "settings_connectorinfofile_help"
    ],
    upload_logo_title: [
      "Upload Logo",
      "Upload Logo",
      "ロゴをアップロード",
      "上传徽标",
      "Logo hochladen",
      "Télécharger le logo",
      "Carica logo",
      "Carregar Logotipo",
      "Subir logo",
      "Загрузить логотип",
      "Prześlij logo",
      "upload_logo_title"
    ],
    upload_logo_org: [
      "To add the organisation logo please click the select logo button to select an image from your drive.",
      "To add the organization logo please click the select logo button to select an image from your drive.",
      "組織のロゴを追加するには [ロゴを選択] ボタンをクリックして、ドライブから画像を選択してください。",
      "要添加组织徽标，请点击选择徽标按钮，以便从驱动器中选择图像。",
      "Zum Hinzufügen eines Firmen-Logos klicken Sie auf die Schaltfläche zur Auswahl des Logos und wählen ein Bild vom Laufwerk aus",
      "Pour ajouter le logo de l'installateur, veuillez cliquer sur le bouton LOGO et sélectionner une image depuis votre ordinateur.",
      "Per aggiungere il logo dell'organizzazione, cliccare sul pulsante di selezione del logo e selezionare un'immagine dalla tua unità disco.",
      "Para incluir o logotipo da organização, clique no botão selecionar e escolha uma imagem na sua unidade de disco.",
      "Agregue logo organización haciendo clic en botón de selección y elija imagen desde disco.",
      "Чтобы добавить логотип организации, нажмите кнопку выбора логотипа и выберите изображение на диске.",
      "Aby dodać logo organizacji, kliknij przycisk wyboru logo, a następnie wybierz obraz z dysku.",
      "upload_logo_org"
    ],
    upload_logo_customer: [
      "To add the customer logo please click the select logo button to select an image from your drive.",
      "To add the customer logo please click the select logo button to select an image from your drive.",
      "カスタマーのロゴを追加するには [ロゴを選択] ボタンをクリックして、ドライブから画像を選択してください。",
      "要添加客户徽标，请点击选择徽标按钮，以便从驱动器中选择图像。",
      "Zum Hinzufügen eines Firmen-Logos klicken Sie auf die Schaltfläche zur Auswahl des Logos und wählen ein Bild vom Laufwerk aus.",
      "Pour ajouter le logo du client, veuillez cliquer sur le bouton LOGO et sélectionner une image depuis votre ordinateur.",
      "Per aggiungere il logo del cliente, cliccare sul pulsante di selezione del logo e selezionare un'immagine dalla tua unità disco.",
      "Para incluir o logotipo do cliente, clique no botão selecionar e escolha uma imagem na sua unidade de disco.",
      "Agregue logo cliente haciendo clic en botón de selección y elija imagen desde disco",
      "Чтобы добавить логотип заказчика, нажмите кнопку выбора логотипа и выберите изображение на диске.",
      "Aby dodać logo klienta, kliknij przycisk wyboru logo, a następnie wybierz obraz z dysku.",
      "upload_logo_customer"
    ],
    select_logo: [
      "Select Logo",
      "Select Logo",
      "ロゴを選択",
      "选择徽标",
      "Logo auswählen",
      "Sélectionner le logo",
      "Seleziona logo",
      "Selecionar Logotipo",
      "Seleccione logo",
      "Выбрать логотип",
      "Wybierz logo",
      "select_logo"
    ],
    save_logo: [
      "Save Logo",
      "Save Logo",
      "ロゴを保存",
      "保存徽标",
      "Logo speichern",
      "Enregistrer le logo",
      "Salva logo",
      "Salvar Logotipo",
      "Guardar logo",
      "Сохранить логотип",
      "Zapisz logo",
      "save_logo"
    ],
    profile_name: [
      "Name",
      "Name",
      "名前",
      "姓名",
      "Name",
      "Nom",
      "Nome",
      "Nome",
      "Nombre",
      "Имя",
      "Nazwa",
      "profile_name"
    ],
    profile_customer: [
      "Customer",
      "Customer",
      "カスタマー",
      "客户",
      "Kunde",
      "Client",
      "Cliente",
      "Cliente",
      "Cliente",
      "Заказчик",
      "Klient",
      "profile_customer"
    ],
    profile_roles: [
      "Roles",
      "Roles",
      "ロール",
      "角色",
      "Rollen",
      "Fonctions",
      "Funzioni",
      "Funções",
      "Roles",
      "Роли",
      "Role",
      "profile_roles"
    ],
    profile_tab_profile: [
      "Profile",
      "Profile",
      "プロフィール",
      "简介",
      "Profil",
      "Profil",
      "Profilo",
      "Perfil",
      "Perfil",
      "Профиль",
      "Profil",
      "profile_tab_profile"
    ],
    profile_tab_organisation: [
      "Organisation",
      "Organization",
      "組織",
      "组织",
      "Firma",
      "Installateur",
      "Organizzazione",
      "Organização",
      "Organización",
      "Организация",
      "Organizacja",
      "profile_tab_organisation"
    ],
    profile_tab_password: [
      "Password",
      "Password",
      "パスワード",
      "密码",
      "Passwort",
      "Mot de passe",
      "Password",
      "Senha",
      "Contraseña",
      "Пароль",
      "Hasło",
      "profile_tab_password"
    ],
    profile_tab_privacy: [
      "Data",
      "Data",
      "データ",
      "数据",
      "Daten",
      "Données",
      "Dati",
      "Dados",
      "Datos",
      "Данные",
      "Dane",
      "profile_tab_privacy"
    ],
    gdpr_data_title: [
      "Your data",
      "Your data",
      "お客様のデータ",
      "您的数据",
      "Ihre Daten",
      "Vos données",
      "I tuoi dati",
      "Os seus dados",
      "Sus datos",
      "Ваши данные",
      "Twoje dane",
      "gdpr_data_title"
    ],
    gdpr_data_description: [
      "You can request a copy of the personal and product data associated with your AnyWARE account.",
      "You can request a copy of the personal and product data associated with your AnyWARE account.",
      "AnyWARE アカウントに関連付けられた個人データおよび製品データのコピーをリクエストできます。",
      "您可以请求获取与您的 AnyWARE 账户关联的个人数据和产品数据副本。",
      "Sie können eine Kopie der mit Ihrem AnyWARE-Konto verknüpften persönlichen Daten und Produktdaten anfordern.",
      "Vous pouvez demander une copie des données personnelles et produit associées à votre compte AnyWARE.",
      "Puoi richiedere una copia dei dati personali e di prodotto associati al tuo account AnyWARE.",
      "Pode solicitar uma cópia dos dados pessoais e de produto associados à sua conta AnyWARE.",
      "Puede solicitar una copia de los datos personales y de producto asociados a su cuenta de AnyWARE.",
      "Вы можете запросить копию персональных данных и данных о продуктах, связанных с вашей учётной записью AnyWARE.",
      "Możesz poprosić o kopię danych osobowych i danych dotyczących produktów powiązanych z Twoim kontem AnyWARE.",
      "gdpr_data_description"
    ],
    gdpr_data_process: [
      "After you submit the request, we will email you confirmation and our GDPR team will prepare your data. You will receive the data, or secure access instructions, within ${days} business days.",
      "After you submit the request, we will email you confirmation and our GDPR team will prepare your data. You will receive the data, or secure access instructions, within ${days} business days.",
      "リクエストの送信後、確認メールをお送りします。GDPR担当チームがデータを準備し、${days}営業日以内にデータまたは安全なアクセス方法をご案内します。",
      "提交请求后，我们会向您发送确认邮件，GDPR 团队将准备您的数据。您将在 ${days} 个工作日内收到数据或安全访问说明。",
      "Nach dem Absenden Ihrer Anfrage erhalten Sie eine Bestätigung per E-Mail und unser Datenschutzteam bereitet Ihre Daten vor. Sie erhalten die Daten oder Anweisungen für den sicheren Zugriff innerhalb von ${days} Werktagen.",
      "Après l’envoi de votre demande, nous vous adresserons un e-mail de confirmation et notre équipe RGPD préparera vos données. Vous recevrez les données, ou les instructions permettant d’y accéder de manière sécurisée, sous ${days} jours ouvrés.",
      "Dopo l’invio della richiesta riceverai un’e-mail di conferma e il nostro team GDPR preparerà i tuoi dati. Riceverai i dati, o le istruzioni per accedervi in modo sicuro, entro ${days} giorni lavorativi.",
      "Após submeter o pedido, enviaremos uma confirmação por e-mail e a nossa equipa de RGPD preparará os seus dados. Receberá os dados, ou instruções para lhes aceder de forma segura, no prazo de ${days} dias úteis.",
      "Después de enviar la solicitud, le enviaremos una confirmación por correo electrónico y nuestro equipo de RGPD preparará sus datos. Recibirá los datos, o las instrucciones para acceder a ellos de forma segura, en un plazo de ${days} días laborables.",
      "После отправки запроса мы пришлём подтверждение по электронной почте, а наша команда по защите данных подготовит ваши данные. Вы получите данные или инструкции по безопасному доступу к ним в течение ${days} рабочих дней.",
      "Po przesłaniu wniosku wyślemy potwierdzenie e-mailem, a nasz zespół ds. RODO przygotuje Twoje dane. Otrzymasz dane lub instrukcje bezpiecznego dostępu do nich w ciągu ${days} dni roboczych.",
      "gdpr_data_process"
    ],
    gdpr_request_button: [
      "Request My Data",
      "Request My Data",
      "自分のデータをリクエストする",
      "请求我的数据",
      "Meine Daten anfordern",
      "Demander mes données",
      "Richiedi i miei dati",
      "Solicitar os meus dados",
      "Solicitar mis datos",
      "Запросить мои данные",
      "Poproś o moje dane",
      "gdpr_request_button"
    ],
    gdpr_confirm_title: [
      "Request a copy of your data?",
      "Request a copy of your data?",
      "データのコピーをリクエストしますか？",
      "请求您的数据副本？",
      "Eine Kopie Ihrer Daten anfordern?",
      "Demander une copie de vos données ?",
      "Richiedere una copia dei tuoi dati?",
      "Solicitar uma cópia dos seus dados?",
      "¿Solicitar una copia de sus datos?",
      "Запросить копию ваших данных?",
      "Poprosić o kopię Twoich danych?",
      "gdpr_confirm_title"
    ],
    gdpr_confirm_text: [
      "Submitting this request will notify our GDPR team. We will send confirmation to ${email} and provide your data within ${days} business days.",
      "Submitting this request will notify our GDPR team. We will send confirmation to ${email} and provide your data within ${days} business days.",
      "このリクエストを送信すると、GDPR担当チームに通知されます。${email} に確認メールを送り、${days}営業日以内にデータを提供します。",
      "提交此请求将通知我们的 GDPR 团队。我们会向 ${email} 发送确认邮件，并在 ${days} 个工作日内提供您的数据。",
      "Mit dem Absenden dieser Anfrage wird unser Datenschutzteam benachrichtigt. Wir senden eine Bestätigung an ${email} und stellen Ihre Daten innerhalb von ${days} Werktagen bereit.",
      "L’envoi de cette demande informera notre équipe RGPD. Nous enverrons une confirmation à ${email} et fournirons vos données sous ${days} jours ouvrés.",
      "L’invio di questa richiesta informerà il nostro team GDPR. Invieremo una conferma a ${email} e forniremo i tuoi dati entro ${days} giorni lavorativi.",
      "Ao submeter este pedido, a nossa equipa de RGPD será notificada. Enviaremos uma confirmação para ${email} e forneceremos os seus dados no prazo de ${days} dias úteis.",
      "Al enviar esta solicitud se notificará a nuestro equipo de RGPD. Enviaremos una confirmación a ${email} y proporcionaremos sus datos en un plazo de ${days} días laborables.",
      "После отправки запроса наша команда по защите данных получит уведомление. Мы отправим подтверждение на адрес ${email} и предоставим данные в течение ${days} рабочих дней.",
      "Przesłanie tego wniosku powiadomi nasz zespół ds. RODO. Wyślemy potwierdzenie na adres ${email} i udostępnimy dane w ciągu ${days} dni roboczych.",
      "gdpr_confirm_text"
    ],
    gdpr_confirm_secondary: [
      "Only submit this request if you want TREND Networks to prepare a copy of the data associated with your account.",
      "Only submit this request if you want TREND Networks to prepare a copy of the data associated with your account.",
      "TREND Networks にアカウント関連データのコピー作成を依頼する場合にのみ、このリクエストを送信してください。",
      "仅当您希望 TREND Networks 准备与您账户关联的数据副本时，才提交此请求。",
      "Senden Sie diese Anfrage nur ab, wenn TREND Networks eine Kopie der mit Ihrem Konto verknüpften Daten erstellen soll.",
      "Envoyez cette demande uniquement si vous souhaitez que TREND Networks prépare une copie des données associées à votre compte.",
      "Invia questa richiesta solo se desideri che TREND Networks prepari una copia dei dati associati al tuo account.",
      "Submeta este pedido apenas se pretender que a TREND Networks prepare uma cópia dos dados associados à sua conta.",
      "Envíe esta solicitud únicamente si desea que TREND Networks prepare una copia de los datos asociados a su cuenta.",
      "Отправляйте этот запрос только в том случае, если вы хотите, чтобы TREND Networks подготовила копию данных, связанных с вашей учётной записью.",
      "Prześlij ten wniosek tylko wtedy, gdy chcesz, aby TREND Networks przygotowała kopię danych powiązanych z Twoim kontem.",
      "gdpr_confirm_secondary"
    ],
    gdpr_submit_request: [
      "Submit request",
      "Submit request",
      "リクエストを送信",
      "提交请求",
      "Anfrage absenden",
      "Envoyer la demande",
      "Invia richiesta",
      "Submeter pedido",
      "Enviar solicitud",
      "Отправить запрос",
      "Prześlij wniosek",
      "gdpr_submit_request"
    ],
    gdpr_request_sending: [
      "Submitting...",
      "Submitting...",
      "送信中...",
      "正在提交...",
      "Wird gesendet...",
      "Envoi en cours...",
      "Invio in corso...",
      "A submeter...",
      "Enviando...",
      "Отправка...",
      "Przesyłanie...",
      "gdpr_request_sending"
    ],
    gdpr_request_success: [
      "Your request has been sent. Check your email for confirmation.",
      "Your request has been sent. Check your email for confirmation.",
      "リクエストが送信されました。確認メールをご確認ください。",
      "您的请求已发送。请查看确认邮件。",
      "Ihre Anfrage wurde gesendet. Bitte prüfen Sie Ihre E-Mails auf die Bestätigung.",
      "Votre demande a été envoyée. Consultez votre e-mail de confirmation.",
      "La tua richiesta è stata inviata. Controlla l’e-mail di conferma.",
      "O seu pedido foi enviado. Consulte o seu e-mail para ver a confirmação.",
      "Su solicitud ha sido enviada. Consulte su correo electrónico para ver la confirmación.",
      "Ваш запрос отправлен. Проверьте электронную почту для подтверждения.",
      "Twój wniosek został wysłany. Sprawdź wiadomość e-mail z potwierdzeniem.",
      "gdpr_request_success"
    ],
    gdpr_request_error: [
      "We could not submit your request. Please try again or contact TREND Networks Support.",
      "We could not submit your request. Please try again or contact TREND Networks Support.",
      "リクエストを送信できませんでした。もう一度お試しいただくか、TREND Networks サポートまでご連絡ください。",
      "无法提交您的请求。请重试或联系 TREND Networks 支持团队。",
      "Ihre Anfrage konnte nicht gesendet werden. Bitte versuchen Sie es erneut oder wenden Sie sich an den Support von TREND Networks.",
      "Nous n’avons pas pu envoyer votre demande. Veuillez réessayer ou contacter l’assistance TREND Networks.",
      "Non è stato possibile inviare la richiesta. Riprova o contatta l’assistenza TREND Networks.",
      "Não foi possível submeter o seu pedido. Tente novamente ou contacte o Apoio da TREND Networks.",
      "No hemos podido enviar su solicitud. Inténtelo de nuevo o contacte con el servicio de asistencia de TREND Networks.",
      "Не удалось отправить запрос. Повторите попытку или обратитесь в службу поддержки TREND Networks.",
      "Nie udało się przesłać wniosku. Spróbuj ponownie lub skontaktuj się z pomocą techniczną TREND Networks.",
      "gdpr_request_error"
    ],
    gdpr_request_impersonation_disabled: [
      "Data requests cannot be submitted while impersonating another user.",
      "Data requests cannot be submitted while impersonating another user.",
      "別のユーザーとして操作している間は、データリクエストを送信できません。",
      "模拟其他用户时无法提交数据请求。",
      "Während der Identitätsübernahme eines anderen Benutzers können keine Datenanfragen gesendet werden.",
      "Les demandes de données ne peuvent pas être envoyées lors de l’emprunt d’identité d’un autre utilisateur.",
      "Non è possibile inviare richieste di dati mentre si opera come un altro utente.",
      "Não é possível submeter pedidos de dados durante a representação de outro utilizador.",
      "No se pueden enviar solicitudes de datos mientras se suplanta a otro usuario.",
      "Нельзя отправлять запросы данных при работе от имени другого пользователя.",
      "Nie można przesyłać wniosków o dane podczas pracy jako inny użytkownik.",
      "gdpr_request_impersonation_disabled"
    ],
    profile_tab_smart_flags: [
      "Smart Flags",
      "Smart Flags",
      "スマートフラグ",
      "智能标记",
      "Smart Flags",
      "Smart Flags",
      "Smart Flag",
      "Smart Flags",
      "Smart Flags",
      "Смарт-флаги",
      "Smart Flags",
      "profile_tab_smart_flags"
    ],
    smart_flag_profile_create_success_toast: [
      "Smart flag profile has been created successfully.",
      "Smart flag profile has been created successfully.",
      "スマートフラグプロファイルが正常に作成されました。",
      "智能标记配置文件已成功创建。",
      "Smart Flag-Profil wurde erfolgreich erstellt.",
      "Le profil Smart Flag a ete cree avec succes.",
      "Profilo Smart Flag creato correttamente.",
      "O perfil Smart Flag foi criado com sucesso.",
      "El perfil de Smart Flag se ha creado correctamente.",
      "Профиль Smart Flag успешно создан.",
      "Profil Smart Flag zostal utworzony pomyslnie.",
      "smart_flag_profile_create_success_toast"
    ],
    smart_flag_profile_create_fail_toast: [
      "Failed to create Smart flag profile.",
      "Failed to create Smart flag profile.",
      "スマートフラグプロファイルを作成できませんでした。",
      "无法创建智能标记配置文件。",
      "Smart Flag-Profil konnte nicht erstellt werden.",
      "Impossible de creer le profil Smart Flag.",
      "Impossibile creare il profilo Smart Flag.",
      "Falha ao criar o perfil Smart Flag.",
      "No se ha podido crear el perfil de Smart Flag.",
      "Не удалось создать профиль Smart Flag.",
      "Nie udalo sie utworzyc profilu Smart Flag.",
      "smart_flag_profile_create_fail_toast"
    ],
    smart_flag_profile_update_success_toast: [
      "Smart flag profile has been updated successfully.",
      "Smart flag profile has been updated successfully.",
      "スマートフラグプロファイルが正常に更新されました。",
      "智能标记配置文件已成功更新。",
      "Smart Flag-Profil wurde erfolgreich aktualisiert.",
      "Le profil Smart Flag a ete mis a jour avec succes.",
      "Profilo Smart Flag aggiornato correttamente.",
      "O perfil Smart Flag foi atualizado com sucesso.",
      "El perfil de Smart Flag se ha actualizado correctamente.",
      "Профиль Smart Flag успешно обновлен.",
      "Profil Smart Flag zostal zaktualizowany pomyslnie.",
      "smart_flag_profile_update_success_toast"
    ],
    smart_flag_profile_update_fail_toast: [
      "Failed to update Smart flag profile.",
      "Failed to update Smart flag profile.",
      "スマートフラグプロファイルを更新できませんでした。",
      "无法更新智能标记配置文件。",
      "Smart Flag-Profil konnte nicht aktualisiert werden.",
      "Impossible de mettre a jour le profil Smart Flag.",
      "Impossibile aggiornare il profilo Smart Flag.",
      "Falha ao atualizar o perfil Smart Flag.",
      "No se ha podido actualizar el perfil de Smart Flag.",
      "Не удалось обновить профиль Smart Flag.",
      "Nie udalo sie zaktualizowac profilu Smart Flag.",
      "smart_flag_profile_update_fail_toast"
    ],
    smart_flag_profile_delete_success_toast: [
      "Smart flag profile has been deleted successfully.",
      "Smart flag profile has been deleted successfully.",
      "スマートフラグプロファイルが正常に削除されました。",
      "智能标记配置文件已成功删除。",
      "Smart Flag-Profil wurde erfolgreich geloescht.",
      "Le profil Smart Flag a ete supprime avec succes.",
      "Profilo Smart Flag eliminato correttamente.",
      "O perfil Smart Flag foi eliminado com sucesso.",
      "El perfil de Smart Flag se ha eliminado correctamente.",
      "Профиль Smart Flag успешно удален.",
      "Profil Smart Flag zostal usuniety pomyslnie.",
      "smart_flag_profile_delete_success_toast"
    ],
    smart_flag_profile_delete_fail_toast: [
      "Failed to delete Smart flag profile.",
      "Failed to delete Smart flag profile.",
      "スマートフラグプロファイルを削除できませんでした。",
      "无法删除智能标记配置文件。",
      "Smart Flag-Profil konnte nicht geloescht werden.",
      "Impossible de supprimer le profil Smart Flag.",
      "Impossibile eliminare il profilo Smart Flag.",
      "Falha ao eliminar o perfil Smart Flag.",
      "No se ha podido eliminar el perfil de Smart Flag.",
      "Не удалось удалить профиль Smart Flag.",
      "Nie udalo sie usunac profilu Smart Flag.",
      "smart_flag_profile_delete_fail_toast"
    ],
    smart_flag_profile_delete_confirm_title: [
      "Confirm Delete",
      "Confirm Delete",
      "削除の確認",
      "确认删除",
      "Löschen bestätigen",
      "Confirmer la suppression",
      "Conferma eliminazione",
      "Confirmar exclusão",
      "Confirmar eliminación",
      "Подтвердите удаление",
      "Potwierdź usunięcie",
      "smart_flag_profile_delete_confirm_title"
    ],
    smart_flag_profile_delete_confirm_text: [
      "Are you sure you want to delete this profile? Any customers or jobs assigned to it will revert to having no profile.",
      "Are you sure you want to delete this profile? Any customers or jobs assigned to it will revert to having no profile.",
      "このプロファイルを削除してもよろしいですか? 割り当てられている顧客またはジョブはプロファイルなしに戻ります。",
      "您确定要删除此配置文件吗？分配给它的任何客户或作业都将恢复为无配置文件。",
      "Sind Sie sicher, dass Sie dieses Profil löschen möchten? Alle ihm zugewiesenen Kunden oder Aufträge werden auf kein Profil zurückgesetzt.",
      "Êtes-vous sûr de vouloir supprimer ce profil ? Tous les clients ou tâches qui lui sont affectés reviendront à aucun profil.",
      "Sei sicuro di voler eliminare questo profilo? Qualsiasi cliente o lavoro assegnato ad esso tornerà a nessun profilo.",
      "Tem certeza de que deseja excluir este perfil? Quaisquer clientes ou trabalhos atribuídos a ele reverterão para nenhum perfil.",
      "¿Está seguro de que desea eliminar este perfil? Cualquier cliente o trabajo asignado a él volverá a no tener perfil.",
      "Вы действительно хотите удалить этот профиль? Все назначенные ему клиенты или задания будут возвращены к состоянию без профиля.",
      "Czy na pewno chcesz usunąć ten profil? Wszyscy przypisani do niego klienci lub zlecenia powrócą do braku profilu.",
      "smart_flag_profile_delete_confirm_text"
    ],
    smart_flag_profile_set_default_success_toast: [
      "Default smart flag profile has been set successfully.",
      "Default smart flag profile has been set successfully.",
      "デフォルトのスマートフラグプロファイルが正常に設定されました。",
      "默认智能标记配置文件已成功设置。",
      "Standard-Smart Flag-Profil wurde erfolgreich festgelegt.",
      "Le profil Smart Flag par defaut a ete defini avec succes.",
      "Profilo Smart Flag predefinito impostato correttamente.",
      "O perfil Smart Flag predefinido foi definido com sucesso.",
      "El perfil de Smart Flag predeterminado se ha establecido correctamente.",
      "Профиль Smart Flag по умолчанию успешно установлен.",
      "Domyslny profil Smart Flag zostal ustawiony pomyslnie.",
      "smart_flag_profile_set_default_success_toast"
    ],
    smart_flag_profile_set_default_fail_toast: [
      "Failed to set Default smart flag profile.",
      "Failed to set Default smart flag profile.",
      "デフォルトのスマートフラグプロファイルを設定できませんでした。",
      "无法设置默认智能标记配置文件。",
      "Standard-Smart Flag-Profil konnte nicht festgelegt werden.",
      "Impossible de definir le profil Smart Flag par defaut.",
      "Impossibile impostare il profilo Smart Flag predefinito.",
      "Falha ao definir o perfil Smart Flag predefinido.",
      "No se ha podido establecer el perfil de Smart Flag predeterminado.",
      "Не удалось установить профиль Smart Flag по умолчанию.",
      "Nie udalo sie ustawic domyslnego profilu Smart Flag.",
      "smart_flag_profile_set_default_fail_toast"
    ],
    smart_flag_profile_clone_success_toast: [
      "Smart flag profile has been cloned successfully.",
      "Smart flag profile has been cloned successfully.",
      "スマートフラグプロファイルが正常に複製されました。",
      "智能标记配置文件已成功克隆。",
      "Smart Flag-Profil wurde erfolgreich dupliziert.",
      "Le profil Smart Flag a ete clone avec succes.",
      "Profilo Smart Flag clonato correttamente.",
      "O perfil Smart Flag foi clonado com sucesso.",
      "El perfil de Smart Flag se ha clonado correctamente.",
      "Профиль Smart Flag успешно скопирован.",
      "Profil Smart Flag zostal sklonowany pomyslnie.",
      "smart_flag_profile_clone_success_toast"
    ],
    smart_flag_profile_clone_fail_toast: [
      "Failed to clone Smart flag profile.",
      "Failed to clone Smart flag profile.",
      "スマートフラグプロファイルを複製できませんでした。",
      "无法克隆智能标记配置文件。",
      "Smart Flag-Profil konnte nicht dupliziert werden.",
      "Impossible de cloner le profil Smart Flag.",
      "Impossibile clonare il profilo Smart Flag.",
      "Falha ao clonar o perfil Smart Flag.",
      "No se ha podido clonar el perfil de Smart Flag.",
      "Не удалось скопировать профиль Smart Flag.",
      "Nie udalo sie sklonowac profilu Smart Flag.",
      "smart_flag_profile_clone_fail_toast"
    ],
    smart_flag_enter_value_between: [
      "Please enter a value between ${min} and ${max}",
      "Please enter a value between ${min} and ${max}",
      "${min} から ${max} の間の値を入力してください",
      "请输入介于 ${min} 和 ${max} 之间的值",
      "Bitte geben Sie einen Wert zwischen ${min} und ${max} ein",
      "Veuillez saisir une valeur entre ${min} et ${max}",
      "Inserire un valore tra ${min} e ${max}",
      "Introduza um valor entre ${min} e ${max}",
      "Introduzca un valor entre ${min} y ${max}",
      "Введите значение от ${min} до ${max}",
      "Wprowadz wartosc od ${min} do ${max}",
      "smart_flag_enter_value_between"
    ],
    customer_smart_flag_profile: [
      "Smart Flag Profile",
      "Smart Flag Profile",
      "スマートフラグプロファイル",
      "智能标记配置文件",
      "Smart Flag-Profil",
      "Profil Smart Flag",
      "Profilo Smart Flag",
      "Perfil Smart Flag",
      "Perfil de Smart Flag",
      "Профиль Smart Flag",
      "Profil Smart Flag",
      "customer_smart_flag_profile"
    ],
    customer_smart_flag_profile_help: [
      "Select a smart flag profile",
      "Select a smart flag profile",
      "スマートフラグプロファイルを選択してください",
      "选择智能标记配置文件",
      "Waehlen Sie ein Smart Flag-Profil aus",
      "Selectionnez un profil Smart Flag",
      "Selezionare un profilo Smart Flag",
      "Selecione um perfil Smart Flag",
      "Seleccione un perfil de Smart Flag",
      "Выберите профиль Smart Flag",
      "Wybierz profil Smart Flag",
      "customer_smart_flag_profile_help"
    ],
    customer_smart_flag_use_org_default: [
      "None",
      "None",
      "なし",
      "无",
      "Keine",
      "Aucun",
      "Nessuno",
      "Nenhum",
      "Ninguno",
      "Нет",
      "Brak",
      "customer_smart_flag_use_org_default"
    ],
    customer_smart_flag_default: [
      "Default",
      "Default",
      "デフォルト",
      "默认",
      "Standard",
      "Par defaut",
      "Predefinito",
      "Predefinido",
      "Predeterminado",
      "По умолчанию",
      "Domyslny",
      "customer_smart_flag_default"
    ],
    job_smart_flag_profile: [
      "Smart Flag Profile",
      "Smart Flag Profile",
      "スマートフラグプロファイル",
      "智能标记配置文件",
      "Smart Flag-Profil",
      "Profil Smart Flag",
      "Profilo Smart Flag",
      "Perfil Smart Flag",
      "Perfil de Smart Flag",
      "Профиль Smart Flag",
      "Profil Smart Flag",
      "job_smart_flag_profile"
    ],
    job_smart_flag_profile_help: [
      "Select a smart flag profile override for this job",
      "Select a smart flag profile override for this job",
      "このジョブ用のスマートフラグプロファイル上書きを選択してください",
      "为此作业选择智能标记配置文件覆盖",
      "Waehlen Sie eine Smart Flag-Profilueberschreibung fuer diesen Job aus",
      "Selectionnez un remplacement de profil Smart Flag pour cette tache",
      "Selezionare una sostituzione del profilo Smart Flag per questo lavoro",
      "Selecione uma substituicao do perfil Smart Flag para este trabalho",
      "Seleccione una anulacion de perfil de Smart Flag para este trabajo",
      "Выберите переопределение профиля Smart Flag для этого задания",
      "Wybierz nadpisanie profilu Smart Flag dla tego zadania",
      "job_smart_flag_profile_help"
    ],
    job_smart_flag_use_default: [
      "Use customer default",
      "Use customer default",
      "顧客のデフォルトを使用",
      "使用客户默认值",
      "Kundenstandard verwenden",
      "Utiliser la valeur par defaut du client",
      "Usa impostazione predefinita del cliente",
      "Utilizar predefinicao do cliente",
      "Usar predeterminado del cliente",
      "Использовать значение клиента по умолчанию",
      "Uzyj domyslnego ustawienia klienta",
      "job_smart_flag_use_default"
    ],
    smart_flag_profiles_intro: [
          "Create profiles to help validate and highlight your test results. Profiles enable you to identify unusual outcomes or filter for specific data within your results set. Select ‘Add Profile’ to get started.",
          "Create profiles to help validate and highlight your test results. Profiles enable you to identify unusual outcomes or filter for specific data within your results set. Select ‘Add Profile’ to get started.",
          "テスト結果の検証と強調表示に役立つプロファイルを作成します。プロファイルにより、異常な結果を特定したり、結果セット内の特定データを絞り込んだりできます。開始するには「プロファイルを追加」を選択してください。",
          "创建配置文件以帮助验证并突出显示测试结果。配置文件可让您识别异常结果，或筛选结果集中的特定数据。选择“添加配置文件”开始。",
          "Erstellen Sie Profile, um Ihre Testergebnisse zu validieren und hervorzuheben. Mit Profilen können Sie ungewöhnliche Ergebnisse erkennen oder bestimmte Daten in Ihrem Ergebnissatz filtern. Wählen Sie „Profil hinzufügen“, um zu beginnen.",
          "Créez des profils pour valider et mettre en évidence vos résultats de test. Les profils vous permettent d’identifier les résultats inhabituels ou de filtrer des données spécifiques dans vos résultats. Sélectionnez « Ajouter un profil » pour commencer.",
          "Creare profili per convalidare ed evidenziare i risultati dei test. I profili consentono di identificare risultati insoliti o filtrare dati specifici nel set di risultati. Selezionare “Aggiungi profilo” per iniziare.",
          "Crie perfis para ajudar a validar e destacar os resultados dos testes. Os perfis permitem identificar resultados invulgares ou filtrar dados específicos no conjunto de resultados. Selecione “Adicionar perfil” para começar.",
          "Cree perfiles para ayudar a validar y resaltar los resultados de las pruebas. Los perfiles permiten identificar resultados inusuales o filtrar datos específicos del conjunto de resultados. Seleccione “Añadir perfil” para comenzar.",
          "Создавайте профили для проверки и выделения результатов тестов. Профили позволяют выявлять необычные результаты или фильтровать определенные данные в наборе результатов. Чтобы начать, выберите «Добавить профиль».",
          "Twórz profile, aby weryfikować i wyróżniać wyniki testów. Profile umożliwiają identyfikowanie nietypowych wyników lub filtrowanie określonych danych w zestawie wyników. Aby rozpocząć, wybierz „Dodaj profil”.",
          "smart_flag_profiles_intro"
    ],
    smart_flag_profiles_suspicious_check_desc: [
          "Suspicious Test Check identifies results that may have been carried out multiple times on the same cable. It checks for results that are unusually close to each other. For example, Length within 1 m and NEXT Margin within 0.4 dB. Tests that meet all selected criteria are flagged red.",
          "Suspicious Test Check identifies results that may have been carried out multiple times on the same cable. It checks for results that are unusually close to each other. For example, Length within 1 m and NEXT Margin within 0.4 dB. Tests that meet all selected criteria are flagged red.",
          "疑わしいテストチェックは、同じケーブルで複数回実施された可能性がある結果を特定します。互いに異常に近い結果を確認します。たとえば、長さが 1 m 以内で、NEXT マージンが 0.4 dB 以内。選択したすべての条件を満たすテストは赤でフラグ付けされます。",
          "可疑测试检查可识别可能在同一根电缆上重复执行的结果。它会检查彼此异常接近的结果。例如，长度在 1 m 以内且 NEXT 余量在 0.4 dB 以内。满足所有选定条件的测试将标记为红色。",
          "Die Prüfung auf verdächtige Tests erkennt Ergebnisse, die möglicherweise mehrfach am selben Kabel durchgeführt wurden. Sie prüft auf Ergebnisse, die ungewöhnlich nahe beieinander liegen. Zum Beispiel Länge innerhalb von 1 m und NEXT-Marge innerhalb von 0,4 dB. Tests, die alle ausgewählten Kriterien erfüllen, werden rot markiert.",
          "Le contrôle des tests suspects identifie les résultats qui ont pu être obtenus plusieurs fois sur le même câble. Il recherche des résultats anormalement proches. Par exemple, longueur à moins de 1 m et marge NEXT à moins de 0,4 dB. Les tests qui remplissent tous les critères sélectionnés sont signalés en rouge.",
          "Il controllo test sospetti identifica risultati che potrebbero essere stati eseguiti più volte sullo stesso cavo. Verifica risultati insolitamente vicini tra loro. Ad esempio, lunghezza entro 1 m e margine NEXT entro 0,4 dB. I test che soddisfano tutti i criteri selezionati sono contrassegnati in rosso.",
          "A verificação de testes suspeitos identifica resultados que podem ter sido obtidos várias vezes no mesmo cabo. Verifica resultados invulgarmente próximos entre si. Por exemplo, comprimento dentro de 1 m e margem NEXT dentro de 0,4 dB. Os testes que cumprem todos os critérios selecionados são assinalados a vermelho.",
          "La comprobación de pruebas sospechosas identifica resultados que pueden haberse realizado varias veces en el mismo cable. Comprueba resultados inusualmente cercanos entre sí. Por ejemplo, longitud dentro de 1 m y margen NEXT dentro de 0,4 dB. Las pruebas que cumplen todos los criterios seleccionados se marcan en rojo.",
          "Проверка подозрительных тестов выявляет результаты, которые могли быть получены несколько раз на одном кабеле. Она проверяет результаты, необычно близкие друг к другу. Например, длина в пределах 1 м и запас NEXT в пределах 0,4 дБ. Тесты, соответствующие всем выбранным критериям, отмечаются красным.",
          "Kontrola podejrzanych testów identyfikuje wyniki, które mogły zostać uzyskane wielokrotnie na tym samym kablu. Sprawdza wyniki, które są do siebie nietypowo zbliżone. Na przykład długość w granicach 1 m i margines NEXT w granicach 0,4 dB. Testy spełniające wszystkie wybrane kryteria są oznaczane na czerwono.",
          "smart_flag_profiles_suspicious_check_desc"
    ],
    smart_flag_suspicious_test_check_help: [
          "Select one or more tests to compare for suspicious activity. When multiple options are selected, all must be true for a test to be flagged red. For example, if Length and NEXT Margin are selected, tests must be within both specified ranges to be flagged.",
          "Select one or more tests to compare for suspicious activity. When multiple options are selected, all must be true for a test to be flagged red. For example, if Length and NEXT Margin are selected, tests must be within both specified ranges to be flagged.",
          "疑わしい動作を比較するテストを 1 つ以上選択します。複数のオプションを選択した場合、テストが赤でフラグ付けされるにはすべてが真である必要があります。たとえば、長さと NEXT マージンを選択した場合、フラグ付けには両方の指定範囲内である必要があります。",
          "选择一项或多项测试以比较可疑活动。选择多个选项时，测试必须全部满足才会标记为红色。例如，选择长度和 NEXT 余量时，测试必须同时在两个指定范围内才会被标记。",
          "Wählen Sie einen oder mehrere Tests aus, um sie auf verdächtige Aktivitäten zu vergleichen. Bei mehreren Optionen müssen alle zutreffen, damit ein Test rot markiert wird. Wenn beispielsweise Länge und NEXT-Marge ausgewählt sind, müssen Tests innerhalb beider Bereiche liegen.",
          "Sélectionnez un ou plusieurs tests à comparer pour détecter une activité suspecte. Lorsque plusieurs options sont sélectionnées, elles doivent toutes être vraies pour qu’un test soit signalé en rouge. Par exemple, si la longueur et la marge NEXT sont sélectionnées, les tests doivent être dans les deux plages spécifiées.",
          "Selezionare uno o più test da confrontare per attività sospette. Quando si selezionano più opzioni, devono essere tutte vere affinché un test sia contrassegnato in rosso. Ad esempio, se si selezionano lunghezza e margine NEXT, i test devono rientrare in entrambi gli intervalli specificati.",
          "Selecione um ou mais testes para comparar atividade suspeita. Quando são selecionadas várias opções, todas têm de ser verdadeiras para que um teste seja assinalado a vermelho. Por exemplo, se forem selecionados Comprimento e Margem NEXT, os testes devem estar em ambos os intervalos especificados.",
          "Seleccione una o más pruebas para comparar actividad sospechosa. Cuando se seleccionan varias opciones, todas deben cumplirse para que una prueba se marque en rojo. Por ejemplo, si se seleccionan Longitud y Margen NEXT, las pruebas deben estar dentro de ambos rangos especificados.",
          "Выберите один или несколько тестов для сравнения на предмет подозрительной активности. Если выбрано несколько параметров, все они должны выполняться, чтобы тест был отмечен красным. Например, при выборе длины и запаса NEXT тесты должны находиться в обоих заданных диапазонах.",
          "Wybierz co najmniej jeden test do porównania pod kątem podejrzanej aktywności. Gdy wybrano kilka opcji, wszystkie muszą być spełnione, aby test został oznaczony na czerwono. Na przykład gdy wybrano długość i margines NEXT, testy muszą mieścić się w obu określonych zakresach.",
          "smart_flag_suspicious_test_check_help"
    ],
    smart_flag_minimum_performance_check_help: [
          "Selecting Minimum Performance options flags any test where the margin is lower than the specified value. When multiple options are selected, a test is flagged red if it is below any selected performance check.",
          "Selecting Minimum Performance options flags any test where the margin is lower than the specified value. When multiple options are selected, a test is flagged red if it is below any selected performance check.",
          "最小パフォーマンスオプションを選択すると、マージンが指定値未満のテストにフラグが付けられます。複数のオプションを選択した場合、選択したパフォーマンスチェックのいずれかを下回るテストは赤でフラグ付けされます。",
          "选择最低性能选项会标记余量低于指定值的任何测试。选择多个选项时，测试低于任一选定性能检查即会标记为红色。",
          "Durch die Auswahl von Mindestleistungsoptionen wird jeder Test markiert, dessen Marge unter dem angegebenen Wert liegt. Bei mehreren Optionen wird ein Test rot markiert, wenn er unter eine der ausgewählten Leistungsprüfungen fällt.",
          "La sélection des options de performance minimale signale tout test dont la marge est inférieure à la valeur spécifiée. Lorsque plusieurs options sont sélectionnées, un test est signalé en rouge s’il est inférieur à l’un des contrôles de performance sélectionnés.",
          "La selezione delle opzioni Prestazioni minime contrassegna qualsiasi test con margine inferiore al valore specificato. Quando si selezionano più opzioni, un test viene contrassegnato in rosso se è inferiore a uno dei controlli delle prestazioni selezionati.",
          "Selecionar opções de Desempenho mínimo assinala qualquer teste cuja margem seja inferior ao valor especificado. Quando são selecionadas várias opções, um teste é assinalado a vermelho se ficar abaixo de qualquer verificação de desempenho selecionada.",
          "Seleccionar opciones de rendimiento mínimo marca cualquier prueba cuyo margen sea inferior al valor especificado. Cuando se seleccionan varias opciones, una prueba se marca en rojo si queda por debajo de cualquiera de las comprobaciones de rendimiento seleccionadas.",
          "Выбор параметров минимальной производительности отмечает любой тест, в котором запас ниже указанного значения. При выборе нескольких параметров тест отмечается красным, если он ниже любого выбранного критерия производительности.",
          "Wybranie opcji minimalnej wydajności oznacza każdy test, w którym margines jest niższy od określonej wartości. Gdy wybrano kilka opcji, test jest oznaczany na czerwono, jeśli nie spełnia któregokolwiek z wybranych kryteriów wydajności.",
          "smart_flag_minimum_performance_check_help"
    ],
    smart_flag_test_standard_help: [
          "Flag tests in the job that do not use the same test limit. For example, if all tests are expected to be Cat 6, any non-Cat 6 test is flagged red. Because there are hundreds of possible test limits, you cannot specify the required limit.",
          "Flag tests in the job that do not use the same test limit. For example, if all tests are expected to be Cat 6, any non-Cat 6 test is flagged red. Because there are hundreds of possible test limits, you cannot specify the required limit.",
          "同じテスト制限を使用していないジョブ内のテストにフラグを付けます。たとえば、すべてのテストが Cat 6 である必要がある場合、Cat 6 以外のテストは赤でフラグ付けされます。可能なテスト制限は数百あるため、必要な制限を指定することはできません。",
          "标记作业中未使用相同测试限值的测试。例如，如果所有测试都应为 Cat 6，则任何非 Cat 6 测试都会标记为红色。由于可能的测试限值有数百种，您无法指定所需限值。",
          "Markiert Tests im Auftrag, die nicht denselben Testgrenzwert verwenden. Wenn beispielsweise alle Tests Cat 6 sein sollen, wird jeder nicht Cat-6-Test rot markiert. Da es Hunderte möglicher Testgrenzwerte gibt, kann der gewünschte Grenzwert nicht angegeben werden.",
          "Signale les tests du travail qui n’utilisent pas la même limite de test. Par exemple, si tous les tests doivent être de catégorie 6, tout test hors Cat 6 est signalé en rouge. En raison des centaines de limites possibles, vous ne pouvez pas spécifier la limite requise.",
          "Contrassegna i test nel lavoro che non usano lo stesso limite di prova. Ad esempio, se tutti i test devono essere Cat 6, qualsiasi test non Cat 6 viene contrassegnato in rosso. Poiché esistono centinaia di possibili limiti, non è possibile specificare quello richiesto.",
          "Assinala os testes do trabalho que não utilizam o mesmo limite de teste. Por exemplo, se todos os testes devem ser Cat 6, qualquer teste que não seja Cat 6 é assinalado a vermelho. Como existem centenas de limites possíveis, não é possível especificar o limite necessário.",
          "Marca las pruebas del trabajo que no usan el mismo límite de prueba. Por ejemplo, si todas las pruebas deben ser Cat 6, cualquier prueba que no sea Cat 6 se marca en rojo. Como hay cientos de límites posibles, no se puede especificar el límite requerido.",
          "Отмечает тесты в задании, которые не используют одинаковый предел тестирования. Например, если все тесты должны быть Cat 6, любой тест не Cat 6 отмечается красным. Поскольку существуют сотни возможных пределов, указать требуемый предел нельзя.",
          "Oznacza testy w zadaniu, które nie używają tego samego limitu testowego. Na przykład, jeśli wszystkie testy powinny być Cat 6, każdy test inny niż Cat 6 jest oznaczany na czerwono. Ze względu na setki możliwych limitów nie można określić wymaganego limitu.",
          "smart_flag_test_standard_help"
    ],
    smart_flag_suspicious_deviation_help: [
          "Flag any test where the measured value is within this deviation of another test and meets the other selected suspicious Smart Flag criteria.",
          "Flag any test where the measured value is within this deviation of another test and meets the other selected suspicious Smart Flag criteria.",
          "測定値が別のテストのこの偏差内にあり、選択した他の疑わしい Smart Flag 条件を満たすテストにフラグを付けます。",
          "标记测量值与另一项测试相差在此偏差范围内且满足其他选定可疑 Smart Flag 条件的任何测试。",
          "Markiert jeden Test, dessen Messwert innerhalb dieser Abweichung von einem anderen Test liegt und der die anderen ausgewählten verdächtigen Smart-Flag-Kriterien erfüllt.",
          "Signale tout test dont la valeur mesurée se situe dans cet écart par rapport à un autre test et qui remplit les autres critères Smart Flag suspects sélectionnés.",
          "Contrassegna qualsiasi test il cui valore misurato rientra in questa deviazione rispetto a un altro test e soddisfa gli altri criteri Smart Flag sospetti selezionati.",
          "Assinala qualquer teste cujo valor medido esteja dentro deste desvio de outro teste e cumpra os outros critérios suspeitos de Smart Flag selecionados.",
          "Marca cualquier prueba cuyo valor medido esté dentro de esta desviación respecto de otra prueba y cumpla los demás criterios de Smart Flag sospechosos seleccionados.",
          "Отмечает любой тест, измеренное значение которого находится в пределах этого отклонения от другого теста и соответствует другим выбранным подозрительным критериям Smart Flag.",
          "Oznacza każdy test, którego zmierzona wartość mieści się w tym odchyleniu od innego testu i spełnia pozostałe wybrane podejrzane kryteria Smart Flag.",
          "smart_flag_suspicious_deviation_help"
    ],
    smart_flag_time_stamp_help: [
          "Flag any test where the test start time is within this deviation of another test and meets the other selected suspicious Smart Flag criteria.",
          "Flag any test where the test start time is within this deviation of another test and meets the other selected suspicious Smart Flag criteria.",
          "テスト開始時刻が別のテストのこの偏差内にあり、選択した他の疑わしい Smart Flag 条件を満たすテストにフラグを付けます。",
          "标记测试开始时间与另一项测试相差在此偏差范围内且满足其他选定可疑 Smart Flag 条件的任何测试。",
          "Markiert jeden Test, dessen Startzeit innerhalb dieser Abweichung von einem anderen Test liegt und der die anderen ausgewählten verdächtigen Smart-Flag-Kriterien erfüllt.",
          "Signale tout test dont l’heure de début se situe dans cet écart par rapport à un autre test et qui remplit les autres critères Smart Flag suspects sélectionnés.",
          "Contrassegna qualsiasi test la cui ora di inizio rientra in questa deviazione rispetto a un altro test e soddisfa gli altri criteri Smart Flag sospetti selezionati.",
          "Assinala qualquer teste cuja hora de início esteja dentro deste desvio de outro teste e cumpra os outros critérios suspeitos de Smart Flag selecionados.",
          "Marca cualquier prueba cuya hora de inicio esté dentro de esta desviación respecto de otra prueba y cumpla los demás criterios de Smart Flag sospechosos seleccionados.",
          "Отмечает любой тест, время начала которого находится в пределах этого отклонения от другого теста и соответствует другим выбранным подозрительным критериям Smart Flag.",
          "Oznacza każdy test, którego czas rozpoczęcia mieści się w tym odchyleniu od innego testu i spełnia pozostałe wybrane podejrzane kryteria Smart Flag.",
          "smart_flag_time_stamp_help"
    ],
    smart_flag_copper_adapter_type_help: [
          "Flag any test where the attached test adapters do not match the type required by the test standard. For example, channel adapters on a Permanent Link test limit are flagged.",
          "Flag any test where the attached test adapters do not match the type required by the test standard. For example, channel adapters on a Permanent Link test limit are flagged.",
          "接続されたテストアダプターがテスト規格で必要なタイプと一致しないテストにフラグを付けます。たとえば、パーマネントリンクのテスト制限でチャネルアダプターが使用されている場合にフラグが付けられます。",
          "标记所连接的测试适配器与测试标准要求类型不匹配的任何测试。例如，在永久链路测试限值上使用通道适配器时将被标记。",
          "Markiert jeden Test, bei dem die angeschlossenen Testadapter nicht dem vom Teststandard geforderten Typ entsprechen. Beispielsweise werden Kanaladapter bei einem Permanent-Link-Testgrenzwert markiert.",
          "Signale tout test dont les adaptateurs de test connectés ne correspondent pas au type requis par la norme de test. Par exemple, des adaptateurs de canal sur une limite de test Permanent Link sont signalés.",
          "Contrassegna qualsiasi test in cui gli adattatori collegati non corrispondono al tipo richiesto dallo standard di prova. Ad esempio, gli adattatori channel su un limite di prova Permanent Link vengono contrassegnati.",
          "Assinala qualquer teste em que os adaptadores de teste ligados não correspondam ao tipo exigido pela norma de teste. Por exemplo, adaptadores de canal num limite de teste Permanent Link são assinalados.",
          "Marca cualquier prueba en la que los adaptadores conectados no coincidan con el tipo exigido por el estándar de prueba. Por ejemplo, se marcan los adaptadores de canal en un límite de prueba de enlace permanente.",
          "Отмечает любой тест, в котором подключенные тестовые адаптеры не соответствуют типу, требуемому стандартом тестирования. Например, отмечаются канальные адаптеры при пределе тестирования Permanent Link.",
          "Oznacza każdy test, w którym podłączone adaptery testowe nie odpowiadają typowi wymaganemu przez standard testu. Na przykład adaptery kanałowe przy limicie testu Permanent Link są oznaczane.",
          "smart_flag_copper_adapter_type_help"
    ],
    smart_flag_copper_calibration_help: [
          "Flag any test where the LanTEK calibration date is older than one year.",
          "Flag any test where the LanTEK calibration date is older than one year.",
          "LanTEK の校正日が 1 年より前のテストにフラグを付けます。",
          "标记 LanTEK 校准日期超过一年的任何测试。",
          "Markiert jeden Test, bei dem das LanTEK-Kalibrierungsdatum älter als ein Jahr ist.",
          "Signale tout test dont la date d’étalonnage LanTEK date de plus d’un an.",
          "Contrassegna qualsiasi test in cui la data di calibrazione LanTEK risale a oltre un anno fa.",
          "Assinala qualquer teste em que a data de calibração LanTEK tenha mais de um ano.",
          "Marca cualquier prueba cuya fecha de calibración LanTEK tenga más de un año.",
          "Отмечает любой тест, в котором дата калибровки LanTEK старше одного года.",
          "Oznacza każdy test, w którym data kalibracji LanTEK jest starsza niż rok.",
          "smart_flag_copper_calibration_help"
    ],
    smart_flag_fiber_calibration_help: [
          "Flag any test where the FiberTEK calibration date is older than one year.",
          "Flag any test where the FiberTEK calibration date is older than one year.",
          "FiberTEK の校正日が 1 年より前のテストにフラグを付けます。",
          "标记 FiberTEK 校准日期超过一年的任何测试。",
          "Markiert jeden Test, bei dem das FiberTEK-Kalibrierungsdatum älter als ein Jahr ist.",
          "Signale tout test dont la date d’étalonnage FiberTEK date de plus d’un an.",
          "Contrassegna qualsiasi test in cui la data di calibrazione FiberTEK risale a oltre un anno fa.",
          "Assinala qualquer teste em que a data de calibração FiberTEK tenha mais de um ano.",
          "Marca cualquier prueba cuya fecha de calibración FiberTEK tenga más de un año.",
          "Отмечает любой тест, в котором дата калибровки FiberTEK старше одного года.",
          "Oznacza każdy test, w którym data kalibracji FiberTEK jest starsza niż rok.",
          "smart_flag_fiber_calibration_help"
    ],
    smart_flag_fiber_type_help: [
          "Flag any test where the tested fiber type differs from the selection and meets the other selected suspicious Smart Flag criteria.",
          "Flag any test where the tested fiber type differs from the selection and meets the other selected suspicious Smart Flag criteria.",
          "テストしたファイバータイプが選択内容と異なり、選択した他の疑わしい Smart Flag 条件を満たすテストにフラグを付けます。",
          "标记所测试的光纤类型与所选类型不同且满足其他选定可疑 Smart Flag 条件的任何测试。",
          "Markiert jeden Test, bei dem der getestete Fasertyp von der Auswahl abweicht und der die anderen ausgewählten verdächtigen Smart-Flag-Kriterien erfüllt.",
          "Signale tout test dont le type de fibre testé diffère de la sélection et qui remplit les autres critères Smart Flag suspects sélectionnés.",
          "Contrassegna qualsiasi test in cui il tipo di fibra testato differisce dalla selezione e soddisfa gli altri criteri Smart Flag sospetti selezionati.",
          "Assinala qualquer teste em que o tipo de fibra testado difira da seleção e cumpra os outros critérios suspeitos de Smart Flag selecionados.",
          "Marca cualquier prueba en la que el tipo de fibra probado difiera de la selección y cumpla los demás criterios de Smart Flag sospechosos seleccionados.",
          "Отмечает любой тест, в котором тип проверяемого волокна отличается от выбранного и соответствует другим выбранным подозрительным критериям Smart Flag.",
          "Oznacza każdy test, w którym badany typ włókna różni się od wybranego i spełnia pozostałe wybrane podejrzane kryteria Smart Flag.",
          "smart_flag_fiber_type_help"
    ],
    smart_flag_test_cord_reference_help: [
          "Flag any test where the tested jumper reference method differs from the selection and meets the other selected suspicious Smart Flag criteria.",
          "Flag any test where the tested jumper reference method differs from the selection and meets the other selected suspicious Smart Flag criteria.",
          "テストしたジャンパー基準方法が選択内容と異なり、選択した他の疑わしい Smart Flag 条件を満たすテストにフラグを付けます。",
          "标记所测试的跳线参考方法与所选方法不同且满足其他选定可疑 Smart Flag 条件的任何测试。",
          "Markiert jeden Test, bei dem die getestete Jumper-Referenzmethode von der Auswahl abweicht und der die anderen ausgewählten verdächtigen Smart-Flag-Kriterien erfüllt.",
          "Signale tout test dont la méthode de référence du cordon de test diffère de la sélection et qui remplit les autres critères Smart Flag suspects sélectionnés.",
          "Contrassegna qualsiasi test in cui il metodo di riferimento del ponticello testato differisce dalla selezione e soddisfa gli altri criteri Smart Flag sospetti selezionati.",
          "Assinala qualquer teste em que o método de referência do jumper testado difira da seleção e cumpra os outros critérios suspeitos de Smart Flag selecionados.",
          "Marca cualquier prueba en la que el método de referencia del latiguillo probado difiera de la selección y cumpla los demás criterios de Smart Flag sospechosos seleccionados.",
          "Отмечает любой тест, в котором метод опорной перемычки отличается от выбранного и соответствует другим выбранным подозрительным критериям Smart Flag.",
          "Oznacza każdy test, w którym metoda odniesienia badanego przewodu połączeniowego różni się od wybranej i spełnia pozostałe wybrane podejrzane kryteria Smart Flag.",
          "smart_flag_test_cord_reference_help"
    ],
    smart_flag_adapter_count_help: [
          "Flag any test where the number of adapters set in the tester differs from the set value and meets the other selected suspicious Smart Flag criteria.",
          "Flag any test where the number of adapters set in the tester differs from the set value and meets the other selected suspicious Smart Flag criteria.",
          "テスターで設定されたアダプター数が設定値と異なり、選択した他の疑わしい Smart Flag 条件を満たすテストにフラグを付けます。",
          "标记测试仪中设置的适配器数量与设定值不同且满足其他选定可疑 Smart Flag 条件的任何测试。",
          "Markiert jeden Test, bei dem die im Tester eingestellte Anzahl von Adaptern vom Sollwert abweicht und der die anderen ausgewählten verdächtigen Smart-Flag-Kriterien erfüllt.",
          "Signale tout test dont le nombre d’adaptateurs défini dans le testeur diffère de la valeur définie et qui remplit les autres critères Smart Flag suspects sélectionnés.",
          "Contrassegna qualsiasi test in cui il numero di adattatori impostato nel tester differisce dal valore impostato e soddisfa gli altri criteri Smart Flag sospetti selezionati.",
          "Assinala qualquer teste em que o número de adaptadores definido no testador difira do valor definido e cumpra os outros critérios suspeitos de Smart Flag selecionados.",
          "Marca cualquier prueba en la que el número de adaptadores configurado en el comprobador difiera del valor establecido y cumpla los demás criterios de Smart Flag sospechosos seleccionados.",
          "Отмечает любой тест, в котором число адаптеров, заданное в тестере, отличается от установленного значения и соответствует другим выбранным подозрительным критериям Smart Flag.",
          "Oznacza każdy test, w którym liczba adapterów ustawiona w testerze różni się od ustawionej wartości i spełnia pozostałe wybrane podejrzane kryteria Smart Flag.",
          "smart_flag_adapter_count_help"
    ],
    smart_flag_splice_count_help: [
          "Flag any test where the number of splices set in the tester differs from the set value and meets the other selected suspicious Smart Flag criteria.",
          "Flag any test where the number of splices set in the tester differs from the set value and meets the other selected suspicious Smart Flag criteria.",
          "テスターで設定されたスプライス数が設定値と異なり、選択した他の疑わしい Smart Flag 条件を満たすテストにフラグを付けます。",
          "标记测试仪中设置的熔接点数量与设定值不同且满足其他选定可疑 Smart Flag 条件的任何测试。",
          "Markiert jeden Test, bei dem die im Tester eingestellte Anzahl von Spleißen vom Sollwert abweicht und der die anderen ausgewählten verdächtigen Smart-Flag-Kriterien erfüllt.",
          "Signale tout test dont le nombre d’épissures défini dans le testeur diffère de la valeur définie et qui remplit les autres critères Smart Flag suspects sélectionnés.",
          "Contrassegna qualsiasi test in cui il numero di giunzioni impostato nel tester differisce dal valore impostato e soddisfa gli altri criteri Smart Flag sospetti selezionati.",
          "Assinala qualquer teste em que o número de fusões definido no testador difira do valor definido e cumpra os outros critérios suspeitos de Smart Flag selecionados.",
          "Marca cualquier prueba en la que el número de empalmes configurado en el comprobador difiera del valor establecido y cumpla los demás criterios de Smart Flag sospechosos seleccionados.",
          "Отмечает любой тест, в котором число сращиваний, заданное в тестере, отличается от установленного значения и соответствует другим выбранным подозрительным критериям Smart Flag.",
          "Oznacza każdy test, w którym liczba spawów ustawiona w testerze różni się od ustawionej wartości i spełnia pozostałe wybrane podejrzane kryteria Smart Flag.",
          "smart_flag_splice_count_help"
    ],
    smart_flag_wavelength_count_help: [
          "Enter 1 or 2 to indicate the number of wavelengths tested. 1 means 850 or 1300 for MM, and 1310 or 1550 for SM. 2 means 850 and 1300 for MM, and 1310 and 1550 for SM.",
          "Enter 1 or 2 to indicate the number of wavelengths tested. 1 means 850 or 1300 for MM, and 1310 or 1550 for SM. 2 means 850 and 1300 for MM, and 1310 and 1550 for SM.",
          "テストした波長数を示すために 1 または 2 を入力します。1 は MM では 850 または 1300、SM では 1310 または 1550 を意味します。2 は MM では 850 と 1300、SM では 1310 と 1550 を意味します。",
          "输入 1 或 2 表示已测试的波长数量。1 表示多模为 850 或 1300，单模为 1310 或 1550。2 表示多模为 850 和 1300，单模为 1310 和 1550。",
          "Geben Sie 1 oder 2 ein, um die Anzahl der getesteten Wellenlängen anzugeben. 1 bedeutet bei MM 850 oder 1300 und bei SM 1310 oder 1550. 2 bedeutet bei MM 850 und 1300 und bei SM 1310 und 1550.",
          "Saisissez 1 ou 2 pour indiquer le nombre de longueurs d’onde testées. 1 signifie 850 ou 1300 pour MM et 1310 ou 1550 pour SM. 2 signifie 850 et 1300 pour MM et 1310 et 1550 pour SM.",
          "Immettere 1 o 2 per indicare il numero di lunghezze d’onda testate. 1 indica 850 o 1300 per MM e 1310 o 1550 per SM. 2 indica 850 e 1300 per MM e 1310 e 1550 per SM.",
          "Introduza 1 ou 2 para indicar o número de comprimentos de onda testados. 1 significa 850 ou 1300 para MM e 1310 ou 1550 para SM. 2 significa 850 e 1300 para MM e 1310 e 1550 para SM.",
          "Introduzca 1 o 2 para indicar el número de longitudes de onda probadas. 1 significa 850 o 1300 para MM y 1310 o 1550 para SM. 2 significa 850 y 1300 para MM y 1310 y 1550 para SM.",
          "Введите 1 или 2, чтобы указать число протестированных длин волн. 1 означает 850 или 1300 для MM и 1310 или 1550 для SM. 2 означает 850 и 1300 для MM и 1310 и 1550 для SM.",
          "Wprowadź 1 lub 2, aby wskazać liczbę przetestowanych długości fali. 1 oznacza 850 lub 1300 dla MM oraz 1310 lub 1550 dla SM. 2 oznacza 850 i 1300 dla MM oraz 1310 i 1550 dla SM.",
          "smart_flag_wavelength_count_help"
    ],
    smart_flag_minimum_margin_help: [
          "A margin lower than the entered value is flagged red.",
          "A margin lower than the entered value is flagged red.",
          "入力値より低いマージンは赤でフラグ付けされます。",
          "低于输入值的余量将标记为红色。",
          "Eine Marge unter dem eingegebenen Wert wird rot markiert.",
          "Une marge inférieure à la valeur saisie est signalée en rouge.",
          "Un margine inferiore al valore immesso viene contrassegnato in rosso.",
          "Uma margem inferior ao valor introduzido é assinalada a vermelho.",
          "Un margen inferior al valor introducido se marca en rojo.",
          "Запас ниже введенного значения отмечается красным.",
          "Margines niższy od wprowadzonej wartości jest oznaczany na czerwono.",
          "smart_flag_minimum_margin_help"
    ],
    profile_update_settings: [
      "Update Settings",
      "Update Settings",
      "設定を更新",
      "更新设置",
      "Update-Einstellungen",
      "Paramètres de la mise à jour",
      "Aggiorna impostazioni",
      "Atualizar configurações",
      "Opciones de actualización",
      "Параметры обновления",
      "Aktualizuj ustawienia",
      "profile_update_settings"
    ],
    profile_update_details: [
      "Update Details",
      "Update Details",
      "詳細を更新",
      "更新详细信息",
      "Update-Angaben",
      "Télécharger les détails",
      "Aggiorna dettagli",
      "Atualizar detalhes",
      "Detalles actualización",
      "Сведения об обновлении",
      "Aktualizuj dane",
      "profile_update_details"
    ],
    profile_oldpassword: [
      "Old Password",
      "Old Password",
      "古いパスワード",
      "旧密码",
      "Altes Passwort",
      "Ancien mot de passe",
      "Password vecchia",
      "Senha Antiga",
      "Contraseña anterior",
      "Старый пароль",
      "Stare hasło",
      "profile_oldpassword"
    ],
    profile_oldpassword_help: [
      "Enter your old password",
      "Enter your old password",
      "古いパスワードを入力してください",
      "输入您的旧密码",
      "Geben Sie das alte Passwort ein",
      "Entrez votre ancien mot de passe",
      "Inserisci la tua password vecchia",
      "Informe sua senha antiga",
      "Introducir contraseña anterior",
      "Введите старый пароль",
      "Wprowadź stare hasło",
      "profile_oldpassword_help"
    ],
    profile_newpassword: [
      "New Password",
      "New Password",
      "新しいパスワード",
      "新密码",
      "Neues Passwort",
      "Nouveau mot de passe",
      "Password nuova",
      "Nova Senha",
      "Nueva contraseña",
      "Новый пароль",
      "Nowe hasło",
      "profile_newpassword"
    ],
    profile_newpassword_help: [
      "Enter your new password",
      "Enter your new password",
      "新しいパスワードを入力してください",
      "输入您的新密码",
      "Geben Sie das neue Passwort ein",
      "Entrez votre nouveau mot de passe",
      "Inserisci la tua password nuova",
      "Informe sua nova senha",
      "Introducir nueva contraseña",
      "Введите новый пароль",
      "Wprowadź nowe hasło",
      "profile_newpassword_help"
    ],
    profile_confpassword: [
      "Confirm New Password",
      "Confirm New Password",
      "新しいパスワードの確認入力",
      "确认新密码",
      "Neues Passwort bestätigen",
      "Confirmez le nouveau mot de passe",
      "Conferma password nuova",
      "Confirmar Nova Senha",
      "Confirmar nueva contraseña",
      "Подтверждение нового пароля",
      "Zatwierdź nowe hasło",
      "profile_confpassword"
    ],
    profile_confpassword_help: [
      "Confirm your new password",
      "Confirm your new password",
      "新しいパスワードを確認入力してください",
      "确认您的新密码",
      "Bestätigen Sie das neue Passwort",
      "Confirmez votre nouveau mot de passe",
      "Conferma la tua password nuova",
      "Confirme sua nova senha",
      "Confirmar nueva contraseña",
      "Подтвердите свой новый пароль",
      "Zatwierdź nowe hasło",
      "profile_confpassword_help"
    ],
    profile_passwords_nomatch: [
      "Passwords did not match",
      "Passwords did not match",
      "パスワードが一致しませんでした",
      "密码不匹配",
      "Die Passwörter stimmen nicht überein",
      "Les deux mots de passe ne correspondaient pas",
      "Le password non corrispondono",
      "As senhas não correspondem",
      "Las contraseñas no coinciden",
      "Пароли не совпали",
      "Hasła nie pasują do siebie",
      "profile_passwords_nomatch"
    ],
    profile_change_password: [
      "Change Password",
      "Change Password",
      "パスワードの変更",
      "更改密码",
      "Passwort ändern",
      "Changer le mot de passe",
      "Modifica password",
      "Alterar senha",
      "Cambiar contraseña",
      "Изменить пароль",
      "Zmień hasło",
      "profile_change_password"
    ],
    profile_error_change_password: [
      "Invalid Credentials",
      "Invalid Credentials",
      "無効な資格情報",
      "凭据无效",
      "Ungültige Zugangsdaten",
      "Identifiants invalides",
      "Credenziali non valide",
      "Credenciais inválidas",
      "Claves inválidas",
      "Некорректные учетные данные",
      "Nieprawidłowe dane logowania",
      "profile_error_change_password"
    ],
    password_change_successfull_toast: [
      "Password successfully updated.",
      "Password successfully updated.",
      "パスワードが正常に更新されました。",
      "已成功更新密码。",
      "Passwort erfolgreich aktualisiert",
      "Le mot de passe à été mis à jour avec succès",
      "Password aggiornata correttamente.",
      "Senha atualizada com sucesso.",
      "Contraseña actualizada",
      "Пароль обновлен.",
      "Aktualizacja hasła powiodła się.",
      "password_change_successfull_toast"
    ],
    name: [
      "Name",
      "Name",
      "名前",
      "姓名",
      "Name",
      "Nom",
      "Nome",
      "Nome",
      "Nombre",
      "Имя",
      "Nazwa",
      "name"
    ],
    contact: [
      "Contact",
      "Contact",
      "連絡先",
      "联系人",
      "Kontakt",
      "Contact",
      "Contatto",
      "Contato",
      "Contacto",
      "Контакт",
      "Osoba do kontaktu",
      "contact"
    ],
    contactfirstname: [
      "Contact First Name",
      "Contact First Name",
      "連絡先の名",
      "联系名字",
      "Kontakt Vorname",
      "Prénom de contact",
      "Nome del contatto",
      "Nome do Contato",
      "Nombre del contacto",
      "Имя контактного лица",
      "Imię osoby do kontaktu",
      "contactfirstname"
    ],
    contactlastname: [
      "Contact Last Name",
      "Contact Last Name",
      "連絡先の姓",
      "联系人姓氏",
      "Kontakt Nachname",
      "Nom de contact",
      "Cognome del contatto",
      "Sobrenome do Contato",
      "Apellido del contacto",
      "Фамилия контактного лица",
      "Nazwisko osoby do kontaktu",
      "contactlastname"
    ],
    city: [
      "City",
      "City",
      "市町村区",
      "城市",
      "Ort",
      "Ville",
      "Città",
      "Cidade",
      "Ciudad",
      "Город",
      "Miasto",
      "city"
    ],
    state: [
      "County",
      "State",
      "都道府県",
      "省",
      "Bundesland",
      "Département",
      "Stato",
      "Estado",
      "Estado",
      "Субъект",
      "Powiat",
      "state"
    ],
    country: [
      "Country",
      "Country",
      "国",
      "国家/地区",
      "Land",
      "Pays",
      "Paese",
      "País",
      "País",
      "Страна",
      "Kraj",
      "country"
    ],
    zipcode: [
      "Postal Code",
      "ZIP",
      "郵便番号",
      "邮政编码",
      "PLZ",
      "Code postal",
      "Codice postale",
      "CEP",
      "Cód. postal",
      "Почтовый индекс",
      "Kod pocztowy",
      "zipcode"
    ],
    contactemail: [
      "Contact Email",
      "Contact Email",
      "連絡先のメール",
      "联系人电子邮件",
      "E-Mail-Kontakt",
      "Email",
      "E-mail di contatto",
      "E-mail de contato",
      "Correo de contacto",
      "Адрес электронной почты",
      "Adres e-mail osoby do kontaktu",
      "contactemail"
    ],
    telephoneno: [
      "Telephone Number",
      "Telephone Number",
      "電話番号",
      "电话号码",
      "Telefonnummer",
      "Numéro de téléphone",
      "Numero di telefono",
      "Telefone",
      "Teléfono",
      "Номер телефона",
      "Numer telefonu",
      "telephoneno"
    ],
    pairname: [
      "Pair",
      "Pair",
      "ペア",
      "配对",
      "Paar",
      "Paire",
      "Coppia",
      "Par",
      "Par",
      "Пара",
      "Para",
      "pairname"
    ],
    worstfrequency: [
      "MHz",
      "MHz",
      "MHz",
      "MHz",
      "MHz",
      "MHz",
      "MHz",
      "MHz",
      "MHz",
      "МГц",
      "MHz",
      "worstfrequency"
    ],
    worstvalue: [
      "dB",
      "dB",
      "dB",
      "dB",
      "dB",
      "dB",
      "dB",
      "dB",
      "dB",
      "дБ",
      "dB",
      "worstvalue"
    ],
    worstvaluedB: [
      "Margin dB",
      "Margin dB",
      "マージン dB",
      "余量 dB",
      "Reserve dB",
      "Marge dB",
      "Margine dB",
      "Margem dB",
      "Margen dB",
      "Запас дБ",
      "Margines dB",
      "worstvaluedB"
    ],
    pairstatus: [
      "Result",
      "Result",
      "結果",
      "结果",
      "Ergebnis",
      "Résultat",
      "Risultato",
      "Resultado",
      "Resultado",
      "Результат",
      "Wynik",
      "pairstatus"
    ],
    file_upload_successfull: [
      "File uploaded successfully",
      "File uploaded successfully",
      "ファイルが正常にアップロードされました",
      "已成功上传文件",
      "Datei erfolgreich hochgeladen",
      "Le fichier a été téléchargé avec succès",
      "File caricato correttamente",
      "Arquivo carregado com sucesso",
      "Archivo subido",
      "Файл отправлен",
      "Przesłanie pliku powiodło się",
      "file_upload_successfull"
    ],
    error_incorrect_file_format: [
      "Incorrect File Format",
      "Incorrect File Format",
      "正しくないファイル形式",
      "文件格式不正确",
      "Falsches Dateiformat",
      "Format de fichier incorrect",
      "Formato del file errato",
      "Formato de arquivo incorreto",
      "Formato de archivo incorrecto",
      "Неверный формат файла",
      "Nieprawidłowy format pliku",
      "error_incorrect_file_format"
    ],
    job_date_time: [
      "Date/Time",
      "Date/Time",
      "日付/時刻",
      "日期/时间",
      "Datum/Uhrzeit",
      "Date/Heure",
      "Data/Ora",
      "Data/Hora",
      "Fecha/hora",
      "Дата и время",
      "Data/godzina",
      "job_date_time"
    ],
    job_engineer: [
      "Engineer",
      "Technician",
      "技術者",
      "工程师",
      "Techniker",
      "Opérateur",
      "Ingegnere",
      "Técnico",
      "Técnico",
      "Инженер",
      "Technik",
      "job_engineer"
    ],
    job_cable_type: [
      "Cable Type",
      "Cable Type",
      "ケーブルのタイプ",
      "线缆类型",
      "Kabeltyp",
      "Type de câble",
      "Tipo di cavo",
      "Tipo de Cabo",
      "Tipo de cable",
      "Тип кабеля",
      "Typ okablowania",
      "job_cable_type"
    ],
    job_test_standard: [
      "Test standard",
      "Test standard",
      "テストの規格",
      "测试标准",
      "Testnorm",
      "Norme de test",
      "Standard test",
      "Norma do Teste",
      "Estándar prueba",
      "Стандарт теста",
      "Standard testu",
      "job_test_standard"
    ],
    job_standard: [
      "Standard",
      "Standard",
      "標準",
      "标准",
      "Standard",
      "Standard",
      "Standard",
      "Norma",
      "Estándar",
      "Стандарт",
      "Standard",
      "job_standard"
    ],
    job_link_model: [
      "Link Model",
      "Link Model",
      "リンクモデル",
      "链接模式",
      "Link-Modell",
      "Modèle du lien",
      "Modello collegamento",
      "Tipo de Link",
      "Modelo enlace",
      "Тип канала",
      "Model połączenia",
      "job_link_model"
    ],
    job_test_adapters: [
      "Test adapters",
      "Test adapters",
      "テストアダプター",
      "测试适配器",
      "Adapter testen",
      "Adaptateurs de test",
      "Testare gli adattatori",
      "Adaptadores de teste",
      "Adaptadores de prueba",
      "Тестовые адаптеры",
      "Adaptery testowe",
      "job_test_adapters"
    ],
    calibration_date: [
      "Calibration Date",
      "Calibration Date",
      "校正日",
      "校准日期",
      "Kalibrierdatum",
      "Date de Calibration",
      "Data della calibrazione",
      "Data de calibração",
      "Fecha de calibracion",
      "Дата калибровки",
      "Data Kalibracji",
      "calibration_date"
    ],
    measurement: [
      "Measurement",
      "Measurement",
      "測定",
      "测量",
      "Messung",
      "Mesure",
      "Misura",
      "Medição",
      "Medida",
      "Измерение",
      "Pomiar",
      "measurement"
    ],
    measurement_result: [
      "Result",
      "Result",
      "結果",
      "结果",
      "Ergebnis",
      "Résultat",
      "Risultato",
      "Resultado",
      "Resultado",
      "Результат",
      "Wynik",
      "measurement_result"
    ],
    measurement_margin_pair: [
      "Margin/Pair",
      "Margin/Pair",
      "マージン/ペア",
      "余量/线对",
      "Reserve/Paar",
      "Marge/Paire",
      "Margine/Coppia",
      "Margem/Par",
      "Margen/Par",
      "Запас/пара",
      "Margines/para",
      "measurement_margin_pair"
    ],
    measurement_value: [
      "Value",
      "Value",
      "値",
      "值",
      "Wert",
      "Valeur",
      "Valore",
      "Valor",
      "Valor",
      "Значение",
      "Wartość",
      "measurement_value"
    ],
    measurement_show_less: [
      "Show Less",
      "Show Less",
      "簡易表示",
      "显示更少",
      "Weniger anzeigen",
      "Afficher moins",
      "Mostra meno",
      "Exibir menos",
      "Mostrar menos",
      "Меньше",
      "Pokaż mniej",
      "measurement_show_less"
    ],
    measurement_show_all: [
      "Show More",
      "Show More",
      "詳細表示",
      "显示更多",
      "Mehr anzeigen",
      "Afficher plus",
      "Mostra più",
      "Exibir mais",
      "Mostrar +",
      "Больше",
      "Pokaż więcej",
      "measurement_show_all"
    ],
    results_chart_display: [
      "Main",
      "Main",
      "メイン",
      "主要",
      "Hauptgerät",
      "Boîtier principal",
      "Principale",
      "Principal",
      "Principal",
      "Основной",
      "Główny",
      "results_chart_display"
    ],
    results_chart_remote: [
      "Remote",
      "Remote",
      "リモート",
      "远程",
      "Endgerät",
      "Boîtier récepteur",
      "Remoto",
      "Remota",
      "Remoto",
      "Удаленный",
      "Zdalny",
      "results_chart_remote"
    ],
    chart_line_style: [
      "Chart line style",
      "Chart line style",
      "グラフ: 線のスタイル",
      "图标线型",
      "Diagramm-Linienstil",
      "Style graphique",
      "Stile delle righe del diagramma",
      "Estilo do Gráfico",
      "Estilo línea de gráfica",
      "Стиль линии диаграммы",
      "Styl wykresu",
      "chart_line_style"
    ],
    chart_line_standard: [
      "Standard",
      "Standard",
      "標準",
      "标准",
      "Standard",
      "Norme",
      "Standard",
      "Padrão",
      "Estándar",
      "Стандарт",
      "Standardowy",
      "chart_line_standard"
    ],
    chart_line_inverted: [
      "Inverted",
      "Inverted",
      "反転",
      "颠倒",
      "Invertiert",
      "Inversé",
      "Invertito",
      "Invertido",
      "Invertido",
      "Инвертированный",
      "Odwrócony",
      "chart_line_inverted"
    ],
    chart_measurements: [
      "Chart measurements",
      "Chart measurements",
      "グラフ: 測定",
      "图表测量",
      "Diagramm-Messungen",
      "Mesures graphiques",
      "Misure del diagramma",
      "Medidas do gráfico",
      "Medidas de gráficos",
      "Измерения диаграммы",
      "Pomiary na wykresie",
      "chart_measurements"
    ],
    chart_measurement_unit: [
      "Chart measurement unit",
      "Chart measurement unit",
      "グラフ: 測定単位",
      "图表测量单位",
      "Diagramm-Maßeinheit",
      "Unité de mesure",
      "Unità di misura del diagramma",
      "Unidade de medida do gráfico",
      "Unidad de medida gráficos",
      "Единица измерения диаграммы",
      "Jednostka miary wykresu",
      "chart_measurement_unit"
    ],
    chart_measurement_unit_meter: [
      "Meter",
      "Meter",
      "メートル",
      "米",
      "Meter",
      "Mètre",
      "Metri",
      "Metros",
      "Metros",
      "Метры",
      "Metry",
      "chart_measurement_unit_meter"
    ],
    chart_measurement_unit_meter_sort: [
      "m",
      "m",
      "m",
      "m",
      "m",
      "m",
      "m",
      "m",
      "m",
      "м",
      "m",
      "chart_measurement_unit_meter_sort"
    ],
    chart_measurement_unit_feet: [
      "Feet",
      "Feet",
      "フィート",
      "英尺",
      "Fuß",
      "Pieds",
      "Piedi",
      "Pés",
      "Pies",
      "Футы",
      "Stopy",
      "chart_measurement_unit_feet"
    ],
    chart_line_logarithmic: [
      "Logarithmic",
      "Logarithmic",
      "対数",
      "对数的",
      "Logarithmisch",
      "Logarithmique",
      "logaritmica",
      "Logarítmico",
      "Logarítmica",
      "логарифмический",
      "Logarytmiczna",
      "chart_line_logarithmic"
    ],
    show_margin_values: [
      "Show margin values",
      "Show margin values",
      "マージン値を表示",
      "显示余量值",
      "Reserve-Werte anzeigen",
      "Afficher les valeurs de marge",
      "Mostra valori del margine",
      "Mostrar valores de margem",
      "Mostrar valor margen",
      "Показать единицы измерения ",
      "Pokaż wartości marginesu",
      "show_margin_values"
    ],
    pair_results: [
      "Pair results",
      "Pair results",
      "ペア結果",
      "线对结果 ",
      "Paar-Ergebnisse",
      "Résultats des paires",
      "Risultati della coppia",
      "Resultados do par",
      "Resultado pares",
      "Результаты пары",
      "Wyniki pary",
      "pair_results"
    ],
    wiremap_mh: [
      "Main",
      "Main",
      "メイン",
      "主要",
      "Hauptgerät",
      "Boîtier principal",
      "Principale",
      "Principal",
      "Principal",
      "Основной",
      "Główny",
      "wiremap_mh"
    ],
    wiremap_rh: [
      "Remote",
      "Remote",
      "リモート",
      "远程",
      "Endgerät",
      "Boîtier récepteur",
      "Remoto",
      "Remota",
      "Remoto",
      "Удаленный",
      "Zdalny",
      "wiremap_rh"
    ],
    wiremap_split: [
      "Split",
      "Split",
      "スプリット",
      "分裂",
      "Split",
      "Mélangées",
      "Diviso",
      "Separado",
      "Dividido",
      "Разделенные пары",
      "Rozdzielone",
      "wiremap_split"
    ],
    wiremap_cross: [
      "Cross",
      "Cross",
      "クロス",
      "交叉",
      "Gekreuzt",
      "Croisées",
      "Incrociato",
      "Cruzado",
      "Cruzado",
      "Перемещенные пары",
      "Krzyżowe (skrosowane)",
      "wiremap_cross"
    ],
    wiremap_reverse: [
      "Reverse",
      "Reverse",
      "リバース",
      "反接",
      "Vertauscht",
      "Inversées",
      "Invertito",
      "Invertido",
      "Revertido",
      "Реверсированные пары",
      "Odwrócone",
      "wiremap_reverse"
    ],
    wiremap_short: [
      "Short",
      "Short",
      "ショート",
      "短路",
      "Kurzschluss",
      "Courts-circuits,",
      "In Corto",
      "Em Curto",
      "Corto",
      "КЗ",
      "Krótki",
      "wiremap_short"
    ],
    wiremap_open: [
      "Open",
      "Open",
      "オープン",
      "开路 ",
      "Unterbrechung",
      "Ouvertes",
      "Aperto",
      "Aberto",
      "Abrir",
      "Разрыв",
      "Otwarty",
      "wiremap_open"
    ],
    wiremap_mainpin: [
      "Main Pin",
      "Main Pin",
      "メインピン",
      "主要 PIN",
      "Hauptgerät-Pin",
      "Fil coté principal",
      "Pin principale",
      "Pino UP",
      "PIN principal",
      "Основной контакт",
      "Główny pin",
      "wiremap_mainpin"
    ],
    wiremap_remotepin: [
      "Remote Pin",
      "Remote Pin",
      "リモートピン",
      "远程 PIN",
      "Endgerät-Pin",
      "Fil coté récepteur",
      "Pin remoto",
      "Pino UR",
      "PIN remoto",
      "Удаленный контакт",
      "Zdalny pin",
      "wiremap_remotepin"
    ],
    wiremap_faultdesc: [
      "Fault Description",
      "Fault Description",
      "障害の説明",
      "故障描述",
      "Fehlerbeschreibung",
      "Description du défaut",
      "Descrizione del guasto",
      "Descrição da Falha",
      "Descripción fallo",
      "Описание неисправности",
      "Opis błędu",
      "wiremap_faultdesc"
    ],
    wiremap_nofault: [
      "No Fault",
      "No Fault",
      "障害なし",
      "无故障",
      "Kein Fehler",
      "Pas de défaut",
      "Nessun guasto",
      "Nenhuma falha",
      "Sin fallos",
      "Нет неисправности",
      "Brak błędu",
      "wiremap_nofault"
    ],
    wiremap_length: [
      "Length",
      "Length",
      "長さ",
      "长度",
      "Länge",
      "Longueur",
      "Lunghezza",
      "Comprimento",
      "Longitud",
      "Длина",
      "Długość",
      "wiremap_length"
    ],
    fibre_test_standard: [
      "Test Standard",
      "Test Standard",
      "テストの規格",
      "测试标准",
      "Testnorm",
      "Norme de test",
      "Standard test",
      "Norma do Teste",
      "Estándar prueba",
      "Стандарт теста",
      "Standard testu",
      "fibre_test_standard"
    ],
    fibre_test_configuration: [
      "Test Configuration",
      "Test Configuration",
      "テストの構成",
      "测试配置",
      "Testkonfiguration",
      "Configuration du test",
      "Configurazione del test",
      "Configuração do teste",
      "Configuración prueba",
      "Конфигурация теста",
      "Konfiguracja testu",
      "fibre_test_configuration"
    ],
    fiber_reference: [
      "Fibre Reference",
      "Fiber Reference",
      "ファイバーリファレンス",
      "光纤参考",
      "Glasfaser-Referenz",
      "Référence fibre",
      "Riferimento fibra",
      "Referência de Fibra",
      "Referencia de fibra",
      "Ссылка на оптоволокно",
      "Odniesienie do światłowodu",
      "fiber_reference"
    ],
    fiber_insertionloss_heading: [
      "Insertion Loss",
      "Insertion Loss",
      "挿入損失",
      "插入损耗",
      "Einfügedämpfung",
      "Perte d'insertion",
      "Perdita d'inserzione",
      "Perda de Inserção",
      "Atenuación",
      "Вносимые потери",
      "Strata wtrąceniowa",
      "fiber_insertionloss_heading"
    ],
    fiber_setreference_heading: [
      "Set Reference Information",
      "Set Reference Information",
      "参照情報の設定",
      "设置参考信息",
      "Referenzinformationen festlegen",
      "Définir les informations de référence",
      "Imposta informazioni di riferimento",
      "Definir informações de referência",
      "Establecer información de referencia",
      "Установить справочную информацию",
      "Informacje referencyjne dotyczące zestawu",
      "fiber_setreference_heading"
    ],
    fiber_setreference_configuration: [
      "Configuration",
      "Configuration",
      "構成",
      "配置",
      "Konfiguration",
      "Configuration",
      "Configurazione",
      "Configuração",
      "Configuración",
      "Конфигурация",
      "Konfiguracja",
      "fiber_setreference_configuration"
    ],
    fiber_setreference_verification: [
      "Verification",
      "Verification",
      "検証",
      "确认",
      "Überprüfung",
      "Vérification",
      "Verifica",
      "Verificação",
      "Verificación",
      "Проверка",
      "Weryfikacja",
      "fiber_setreference_verification"
    ],
    fiber_setreference_refpower_heading: [
      "Reference Power",
      "Reference Power",
      "基準電力",
      "参考功率",
      "Referenzleistung",
      "Puissance de référence",
      "Potenza di riferimento",
      "Potência de referência",
      "Potencia de referencia",
      "Опорная мощность",
      "Moc referencyjna",
      "fiber_setreference_refpower_heading"
    ],
    fiber_setreference_refpower: [
      "Ref Power (dBm)",
      "Ref Power (dBm)",
      "基準電力 (dBm)",
      "参考功率 (dBm)",
      "Referenzleistung (dBm)",
      "Puissance de référence (dBm)",
      "Potenza di riferimento (dBm)",
      "Potência de referência (dBm)",
      "Potencia de referencia (dBm)",
      "Опорная мощность (dBm)",
      "Moc referencyjna (dBm)",
      "fiber_setreference_refpower"
    ],
    fiber_setreference_limit: [
      "Limit (dBm)",
      "Limit (dBm)",
      "制限 (dBm)",
      "限制 (dBm)",
      "Test-Grenzwert (dBm)",
      "Limite du test (dBm)",
      "Limite test (dBm)",
      "Limite do teste (dBm)",
      "Límite Prueba (dBm)",
      "Предел теста (dBm)",
      "Limit testu (dBm)",
      "fiber_setreference_limit"
    ],
    fiber_setreference_reflength_heading: [
      "Reference Length",
      "Reference Length",
      "基準長さ",
      "参考长度",
      "Referenzlänge",
      "Longueur de référence",
      "Lunghezza di riferimento",
      "Comprimento de referência",
      "Longitud de referencia",
      "Справочная длина",
      "Długość odniesienia",
      "fiber_setreference_reflength_heading"
    ],
    fiber_setreference_time: [
      "SetRef Date/Time",
      "SetRef Date/Time",
      "参照日時を設定する",
      "设置参考日期/时间",
      "Referenzdatum/-zeit festlegen",
      "Définir la date/heure de référence",
      "Imposta data/ora di riferimento",
      "Definir data/hora de referência",
      "Establecer fecha/hora de referencia",
      "Установить контрольную дату/время",
      "Ustaw datę/godzinę odniesienia",
      "fiber_setreference_time"
    ],
    fiber_insertionloss: [
      "Insertion Loss (dB)",
      "Insertion Loss (dB)",
      "挿入損失 (dB)",
      "插入损耗 (dB)",
      "Einfügedämpfung (dB)",
      "Perte d'insertion (dB)",
      "Perdita d'inserzione (dB)",
      "Perda de Inserção (dB)",
      "Atenuación (dB)",
      "Вносимые потери (dB)",
      "Strata wtrąceniowa (dB)",
      "fiber_insertionloss"
    ],
    fiber_n: [
      "Fibre No/Dir",
      "Fiber #/Dir",
      "ファイバーの数/方向",
      "光纤编号/目录",
      "FaserNr./Richt.",
      "N° de la fibre/ Sens",
      "N./Dir. fibra",
      "Número/Direção da Fibra",
      "Nº/Sentido fibra",
      "Номер/направление волокна",
      "Nr/kier włókna",
      "fiber_n"
    ],
    fiber_test_direction: [
      "Test Direction",
      "Test Direction",
      "テスト方向",
      "测试方向",
      "Testrichtung",
      "Sens du test",
      "Direzione del test",
      "Direção do Teste",
      "Sentido prueba",
      "Направление теста",
      "Kierunek testu",
      "fiber_test_direction"
    ],
    fiber_wavelength: [
      "Wavelength (nm)",
      "Wavelength (nm)",
      "波長 (nm)",
      "波长 (nm)",
      "Wellenlänge (nm)",
      "Longueur d'onde (nm)",
      "Lunghezza d'onda (nm)",
      "Comprimento de onda (nm)",
      "Longitud de onda (nm)",
      "Длина волны (нм)",
      "Długość fali (nm)",
      "fiber_wavelength"
    ],
    fiber_corediameter: [
      "Core Diameter (&micro;m)",
      "Core Diameter (&micro;m)",
      "コア径 (&micro;m)",
      "芯体直径 (&micro;m)",
      "Kerndurchmesser (&Mikro;m)",
      "Diamètre du cœur (&micro;m)",
      "Diametro interno (µm)",
      "Diâmetro do núcleo (&micro;m))",
      "Diámetro núcleo (&micro;m)",
      "Диаметр сердечника (мкм)",
      "Średnica rdzenia (µm)",
      "fiber_corediameter"
    ],
    fiber_lossbudget_limit: [
      "Loss Budget/Limit (dB)",
      "Loss Budget/Limit (dB)",
      "損失バジェット/制限 (dB)",
      "损耗预算/限值 (dB)",
      "Dämpfungsbudget/Grenzwert (dB)",
      "Budget de perte/limite (dB)",
      "Limite/Budget della perdita (dB)",
      "Provisão de Perda/Limite (dB)",
      "Presupuesto pérdida/límite (dB)",
      "Допустимый предел потерь (дБ)",
      "Budżet strat/limit (dB)",
      "fiber_lossbudget_limit"
    ],
    fiber_margin: [
      "Margin (dB)",
      "Margin (dB)",
      "マージン (dB)",
      "余量 (dB)",
      "Reserve (dB)",
      "Marge (dB)",
      "Margine (dB)",
      "Margem (dB)",
      "Margen (dB)",
      "Запас (дБ)",
      "Margines dB",
      "fiber_margin"
    ],
    fiber_result: [
      "Result",
      "Result",
      "結果",
      "结果",
      "Ergebnis",
      "Résultat",
      "Risultato",
      "Resultado",
      "Resultado",
      "Результат",
      "Wynik",
      "fiber_result"
    ],
    fiber_refractiveindex: [
      "Refractive Index",
      "Refractive Index",
      "屈折率",
      "折射率",
      "Brechungsindex",
      "Indice de réfraction",
      "Indice di rifrazione",
      "Índice de Refração",
      "Índice refracción",
      "Индекс преломления",
      "Współczynnik załamania światła",
      "fiber_refractiveindex"
    ],
    fiber_length: [
      "Length",
      "Length",
      "長さ",
      "长度",
      "Länge",
      "Longueur",
      "Lunghezza",
      "Comprimento",
      "Longitud",
      "Длина",
      "Długość",
      "fiber_length"
    ],
    fiber_lengthlimit: [
      "Length Limit",
      "Length Limit",
      "長さ制限",
      "长度限制",
      "Längengrenzwert",
      "Longueur maximale",
      "Limite della lunghezza",
      "Limite de comprimento",
      "Límite longitud",
      "Предел длины",
      "Limit długości",
      "fiber_lengthlimit"
    ],
    fiber_lengthmargin: [
      "Length Margin",
      "Length Margin",
      "長さマージン",
      "长度余量",
      "Längenreserve",
      "Marge de la longueur",
      "Margine della lunghezza",
      "Margem de comprimento",
      "Margen longitud",
      "Запас длины",
      "Margines długości",
      "fiber_lengthmargin"
    ],
    fiber_lengthdata: [
      "Length",
      "Length",
      "長さ",
      "长度",
      "Länge",
      "Longueur",
      "Lunghezza",
      "Comprimento",
      "Longitud",
      "Длина",
      "Długość",
      "fiber_lengthdata"
    ],
    fiber_remote_to_main: [
      "Remote to Main",
      "Remote to Main",
      "リモートからメインへ",
      "远端到主机",
      "Endgerät zu Hauptgerät",
      "Boîtier récepteur vers principal",
      "Da Remoto a Principale",
      "Remota para Principal",
      "Remoto a principal",
      "Удаленный к основному",
      "Zdalny do głównego",
      "fiber_remote_to_main"
    ],
    fiber_main_to_remote: [
      "Main to Remote",
      "Main to Remote",
      "メインからリモートへ",
      "主机到远端",
      "Hauptgerät zu Endgerät",
      "Boîtier principal vers récepteur",
      "Da Principale a Remoto",
      "Principal para Remota",
      "Principal a remoto",
      "Основной к удаленному",
      "Główny do zdalnego",
      "fiber_main_to_remote"
    ],
    fiber_main_to_main: [
      "Main to Main",
      "Main to Main",
      "メインからメインへ",
      "主机到主机",
      "Hauptgerät zu Hauptgerät",
      "Boîtier principal vers principal",
      "Da Principale a Principale",
      "Principal para Principal",
      "Principal a Principal",
      "Основной к основному",
      "Główny do głównego",
      "fiber_main_to_main"
    ],
    fiber_loop_a_to_b: [
      "A  ->  B",
      "A  ->  B",
      "A  ->  B",
      "A  ->  B",
      "A  ->  B",
      "A  ->  B",
      "A  ->  B",
      "A  ->  B",
      "A  ->  B",
      "A -> B",
      "A  ->  B",
      "fiber_loop_a_to_b"
    ],
    fiber_loop_b_to_a: [
      "B  ->  A",
      "B  ->  A",
      "B  ->  A",
      "B  ->  A",
      "B  ->  A",
      "B  ->  A",
      "B  ->  A",
      "B  ->  A",
      "B  ->  A",
      "B -> A",
      "B  ->  A",
      "fiber_loop_b_to_a"
    ],
    fiber_bi_directional_step: [
      "Bi-directional Normal – STEP ${value}",
      "Bi-directional Normal – STEP ${value}",
      "双方向ノーマル – ステップ${value}",
      "双向正常 - 步进 ${value}",
      "Bidirektional Normal – SCHRITT ${value}",
      "Normal en bidirectionnel - ÉTAPE ${value}",
      "Normale bi-direzionale – FASE ${value}",
      "Bidirecional normal – ETAPA ${value}",
      "”Normal bidireccional – PASO ${value}",
      "Двунаправленный нормальный — ШАГ ${value}",
      "Dwukierunkowy normalny – KROK ${value}",
      "fiber_bi_directional_step"
    ],
    fiber_bi_directional_loop: [
      "Bi-directional Loopback",
      "Bi-directional Loopback",
      "双方向ループバック",
      "双向环回",
      "Bidirektionale Schleife",
      "Bouclage en bidirectionnel",
      "Loopback bi-direzionale",
      "Loopback Bidirecional",
      "Bucle bidireccional",
      "Двунаправленная обратная петля",
      "Dwukierunkowa pętla zwrotna",
      "fiber_bi_directional_loop"
    ],
    fiber_loopback_test: [
      "Single-direction Loopback",
      "Single-direction Loopback",
      "片方向ループバック",
      "单向环回",
      "Unidirektionale Schleife",
      "Bouclage dans une seule direction",
      "Loopback mono-direzionale",
      "Loopback Unidirecional",
      "Bucle unidireccional",
      "Однонаправленная обратная петля",
      "Jednokierunkowa pętla zwrotna",
      "fiber_loopback_test"
    ],
    fiber_unidirectional_test: [
      "Single-direction Normal",
      "Single-direction Normal",
      "片方向ノーマル",
      "单向正常",
      "Unidirektional Normal",
      "Normal dans une seule direction",
      "Normale mono-direzionale",
      "Normal Unidirecional",
      "Normal unidireccional",
      "Однонаправленный нормальный",
      "Jednokierunkowy normalny",
      "fiber_unidirectional_test"
    ],
    fiber_measurement_direction: [
      "Measurement Direction",
      "Measurement Direction",
      "測定方向",
      "测试方向",
      "Messrichtung",
      "Direction de la mesure",
      "Direzione della Misura",
      "Direção de medição",
      "Dirección de la medida",
      "Направление измерения",
      "Kierunek Pomiaru",
      "fiber_measurement_direction"
    ],
    fiber_reference_power: [
      "Reference Power<br />(dBm)",
      "Reference Power<br />(dBm)",
      "参照パワー<br />(dBm)",
      "参考功率值 <br />（dBm)",
      "Referenzleistung<br />(dBm)",
      "Puissance de référence<br />(dBm)",
      "Potenza di Riferimento<br />(dBm)",
      "Poder de referência<br />(dBm)",
      "Potencia de referencia<br />(dBm)",
      "Опорная мощность<br />(дБм)",
      "Moc Odniesienia<br />(dBm)",
      "fiber_reference_power"
    ],
    fiber_rx_power: [
      "Rx Power<br />(dBm)",
      "Rx Power<br />(dBm)",
      "Rx電力 <br />(dBm)",
      "接收功率<br />(dBm)",
      "Rx-Leistung<br />(dBm)",
      "Puissance R<br />(dBm)",
      "Potenza ricevuta<br />(dBm)",
      "Potência Rx<br />(dBm)",
      "Potencia Rx<br />(dBm)",
      "Мощность Rx<br />(дБ/мВт)",
      "Moc Rx<br />(dBm)",
      "fiber_rx_power"
    ],
    fiber_ins_loss: [
      "Insertion Loss<br />(dB)",
      "Insertion Loss<br />(dB)",
      "挿入損失<br />(dB)",
      "插入损耗<br />(dB)",
      "Einfügedämpfung<br />(dB)",
      "Perte d'insertion<br />(dB)",
      "Perdita d'inserzione<br />(dB)",
      "Perda de Inserção<br />(dB)",
      "Atenuación<br />(dB)",
      "Вносимые потери<br />(dB)",
      "Strata wtrąceniowa<br />(dB)",
      "fiber_ins_loss"
    ],
    fiber_loss_limit: [
      "Loss Limit",
      "Loss Limit",
      "損失制限",
      "损耗门限",
      "Verlustgrenze",
      "Limite atténuation",
      "Limite Perdita",
      "Limite de perda",
      "Límite de pérdida",
      "Граничные потери",
      "Strata graniczna",
      "fiber_loss_limit"
    ],
    fiber_loss_margin: [
      "Loss Margin<br />(dB)",
      "Loss Margin<br />(dB)",
      "損失マージン<br />(dB)",
      "损失保证金<br />(dB)",
      "Verlustmarge<br />(dB)",
      "Marge de perte<br />(dB)",
      "Margine di perdita<br />(dB)",
      "Margem de Perda<br />(dB)",
      "Margen de pérdida<br />(dB)",
      "Убыточная маржа<br />(dB)",
      "Margines straty<br />(dB)",
      "fiber_loss_margin"
    ],
    fiber_verify_length: [
      "Verify Length",
      "Verify Length",
      "長さを確認します",
      "检测长度",
      "Länge überprüfen",
      "Vérification de longueur",
      "Verifica Lunghezza",
      "Verifique o comprimento",
      "Verificar longitud",
      "Контрольная длина",
      "Sprawdź długość",
      "fiber_verify_length"
    ],
    test_setup: [
      "Test Setup",
      "Test Setup",
      "テストのセットアップ",
      "测试设置",
      "Testaufbau",
      "Configuration des tests",
      "Prova di configurazione",
      "Configuração de teste",
      "Configuración de prueba",
      "Тестовая установка",
      "Konfiguracja testowa",
      "test_setup"
    ],
    rfsubtest_margin: [
      "Margin",
      "Margin",
      "マージン",
      "余量",
      "Reserve",
      "Marge",
      "Margine",
      "Margem",
      "Margen",
      "Запас",
      "Margines",
      "rfsubtest_margin"
    ],
    rfsubtest_value: [
      "Value",
      "Value",
      "値",
      "值",
      "Wert",
      "Valeur",
      "Valore",
      "Valor",
      "Valor",
      "Значение",
      "Wartość",
      "rfsubtest_value"
    ],
    devicename: [
      "Device Name",
      "Device Name",
      "デバイス名",
      "设备名称",
      "Gerätename",
      "Nom de l'appareil",
      "Nome del dispositivo",
      "Nome do Dispositivo",
      "Nombre del dispositivo",
      "Имя устройства",
      "Nazwa urządzenia",
      "devicename"
    ],
    device_add_title: [
      "Add Device",
      "Add Device",
      "デバイスを追加",
      "添加设备",
      "Gerät hinzufügen",
      "Ajouter un appareil",
      "Aggiungi dispositivo",
      "Incluir dispositivo",
      "Agregar equipo",
      "Добавить устройство",
      "Dodaj urządzenie",
      "device_add_title"
    ],
    device_serialnumber: [
      "Device ID",
      "Device ID",
      "デバイスID",
      "设备ID",
      "Geräte-ID",
      "Numéro de série appareil",
      "ID dispositivo",
      "ID do dispositivo",
      "ID del equipo",
      "Идентификатор устройства",
      "Identyfikator urządzenia",
      "device_serialnumber"
    ],
    device_serialnumber_help: [
      "Device ID should be of format xxxxxxxx/xxxxxxxx",
      "Device ID should be of format xxxxxxxx/xxxxxxxx",
      "デバイスIDのフォーマットは「xxxxxxxx/xxxxxxxx」です",
      "设备ID格式应为 xxxxxxxx/xxxxxxxx",
      "Die Geräte-ID sollte das Format xxxxxxxx / xxxxxxxx haben",
      "Le N° de série doit respecter le format xxxxxxxx/xxxxxxxx",
      "L'ID dispositivo deve essere nel formato xxxxxxxx / xxxxxxxx",
      "O ID do dispositivo deve estar no formato xxxxxxxx/xxxxxxxx",
      "ID del equipo debe ser en formato xxxxxxxx/xxxxxxxx",
      "Идентификатор устройства должен иметь формат xxxxxxxx/xxxxxxxx",
      "Identyfikator urządzenia powinien mieć format xxxxxxxx / xxxxxxxx",
      "device_serialnumber_help"
    ],
    formfield_error_device_general_pattern: [
      "Invalid Device ID. Device ID should be of format xxxxxxxx/xxxxxxxx",
      "Invalid Device ID. Device ID should be of format xxxxxxxx/xxxxxxxx",
      "デバイスIDが無効です。デバイスIDの形式はxxxxxxxx / xxxxxxxxである必要があります",
      "“设备ID无效。设备ID的格式应为xxxxxxxx/xxxxxxxx”",
      "Ungültige Gerätekennung. Gerätekennung hat folgendes Format xxxxxxxx/xxxxxxxx",
      "Le numéro de série n’est pas valide. Il doit être de format : xxxxxxxx/xxxxxxxx",
      "ID dispositivo non valido. L'ID dispositivo deve essere nel formato xxxxxxxx / xxxxxxxx",
      "ID de Dispositivo Inválido. Deve estar no formato xxxxxxxx/xxxxxxxx",
      "ID del equipo inválida, debiera ser de formato xxxxxxxx/xxxxxxxx",
      "Неверный идентификатор устройства. Идентификатор устройства должен иметь формат xxxxxxxx / xxxxxxxx",
      "Nieprawidłowy identyfikator urządzenia. Identyfikator urządzenia powinien mieć format xxxxxxxx / xxxxxxxx",
      "formfield_error_device_general_pattern"
    ],
    device_add_successfull_toast: [
      "Device added successfully",
      "Device added successfully",
      "デバイスが正常に追加されました",
      "设备成功添加",
      "Gerät erfolgreich hinzugefügt",
      "Testeur ajouté avec succès",
      "Dispositivo aggiunto correttamente",
      "Dispositivo incluído com sucesso",
      "Equipo agregado exitosamente",
      "Устройство успешно добавлено",
      "Dodanie urządzenia powiodło się",
      "device_add_successfull_toast"
    ],
    device_add_unsuccessfull_toast: [
      "Device could not be added",
      "Device could not be added",
      "デバイスを追加できませんでした",
      "无法添加设备",
      "Fehler beim Hinzufügen des Gerätes",
      "L'appareil n'a pas pu être ajouté",
      "Non è stato possibile aggiungere il dispositivo",
      "O dispositivo não pôde ser incluído",
      "No se pudo agregar equipo",
      "Не удалось добавить устройство",
      "Dodanie urządzenia nie powiodło się",
      "device_add_unsuccessfull_toast"
    ],
    device_add_duplicate_toast: [
      "Device ID already allocated, please check Device ID",
      "Device ID already allocated, please check Device ID",
      "デバイスIDは既に割り当てられています。デバイスIDを確認してください",
      "设备ID已分配，请检查设备ID",
      " Geräte-ID bereits vergeben, bitte überprüfen Sie die Geräte-ID",
      "N° de série de testeur déjà utilisé, merci de vérifier votre N°",
      "ID dispositivo già assegnato, controllare ID dispositivo",
      "ID de dispositivo já alocado, verifique o ID do dispositivo",
      "ID de equipo ya asignada, por favor verifique la ID",
      "Идентификатор устройства уже выделен, проверьте идентификатор устройства",
      "Identyfikator urządzenia został już przydzielony, sprawdź identyfikator urządzenia",
      "device_add_duplicate_toast"
    ],
    device_delete_confirm_title: [
      "Delete Device",
      "Delete Device",
      "デバイスを削除",
      "删除设备",
      "Gerät löschen",
      "Effacer l'appareil",
      "Elimina dispositivo",
      "Excluir Dispositivo",
      "Eliminar equipo",
      "Удалить устройство",
      "Usuń urządzenie",
      "device_delete_confirm_title"
    ],
    device_delete_confirm_text: [
      "Are you sure you want to delete device <b>${devicename}</b>?",
      "Are you sure you want to delete device <b>${devicename}</b>?",
      "デバイス「<b>${devicename}</b>」を削除してもよろしいですか?",
      "您是否确定要删除设备 <b>${devicename}</b>？",
      "Möchten Sie das Gerät <b>${devicename}</b>? wirklich löschen?",
      "Êtes-vous sûr de vouloir effacer l'appareil <b>${devicename}</b>?",
      "Eliminare il dispositivo <b>${devicename}</b>?",
      "Você tem certeza de que deseja excluir o dispositivo <b>${devicename}</b>?",
      "¿Eliminar equipo <b>${devicename}</b>?",
      "Действительно удалить устройство <b>${devicename}</b>?",
      "Czy na pewno chcesz usunąć urządzenie <b>${devicename}</b>?",
      "device_delete_confirm_text"
    ],
    device_stolen_text: [
      "Do you wish to register this device as stolen?",
      "Do you wish to register this device as stolen?",
      "このデバイスを盗難されたデバイスとして登録しますか?",
      "您是否要将此设备登记为被盗？",
      "Möchten Sie das Gerät als gestohlen eintragen?",
      "Voulez-vous enregistrer cet appareil comme étant volé ?",
      "Registrare questo dispositivo come rubato?",
      "Deseja registrar este dispositivo como furtado?",
      "¿Desea registrar este equipo como robado?",
      "Зарегистрировать это устройство как украденное?",
      "Czy chcesz zarejestrować to urządzenie jako skradzione?",
      "device_stolen_text"
    ],
    device_unstolen_text: [
      "Device marked as stolen. Do you wish to revert to recovered?",
      "Device marked as stolen. Do you wish to revert to recovered?",
      "デバイスが盗難されたとして記録されています。見つかったものとしてステータスを戻しますか?",
      "设备标记为被盗。您是否想要恢复？",
      "Das Gerät ist als gestohlen markiert. Soll es als wiedergefunden eingetragen werden?",
      "L'appareil est marqué comme étant volé. Voulez-vous repasser au statut récupéré ?",
      "Dispositivo contrassegnato come rubato. Ritornare a recuperato?",
      "Dispositivo marcado como furtado. Deseja reverter para recuperado?",
      "Equipo marcado robado. ¿Desea revertir a recuperado?",
      "Устройство отмечено как украденное. Вернуть его в восстановленное состояние?",
      "Urządzenie oznaczone jako skradzione. Czy chcesz, aby oznaczyć je jako odnalezione? ",
      "device_unstolen_text"
    ],
    device_stolen_title: [
      "Stolen device",
      "Stolen device",
      "盗難されたデバイス",
      "被盗设备",
      "Gestohlenes Gerät",
      "Appareil volé",
      "Dispositivo rubato",
      "Dispositivo furtado",
      "Equipo robado",
      "Украденное устройство",
      "Urządzenie skradzione",
      "device_stolen_title"
    ],
    device_unstolen_title: [
      "Stolen device",
      "Stolen device",
      "盗難されたデバイス",
      "被盗设备",
      "Gestohlenes Gerät",
      "Appareil volé",
      "Dispositivo rubato",
      "Dispositivo furtado",
      "Equipo robado",
      "Украденное устройство",
      "Urządzenie skradzione",
      "device_unstolen_title"
    ],
    device_delete_successfull_toast: [
      "Device deleted successfully",
      "Device deleted successfully",
      "デバイスが正常に削除されました",
      "已成功删除设备",
      "Gerät erfolgreich gelöscht",
      "L'appareil a été effacé avec succès",
      "Dispositivo eliminato correttamente",
      "Dispositivo excluído com sucesso",
      "Equipo eliminado",
      "Устройство удалено",
      "Usunięcie urządzenia powiodło się",
      "device_delete_successfull_toast"
    ],
    device_delete_unsuccessfull_toast: [
      "Failed to delete the device",
      "Failed to delete the device",
      "デバイスを削除できませんでした",
      "无法删除设备",
      "Fehler beim Löschen des Gerätes",
      "L'appareil n'a pas pu être effacé",
      "Eliminazione del dispositivo non riuscita",
      "Falha ao excluir o dispositivo",
      "Fallo al eliminar equipo",
      "Не удалось удалить устройство",
      "Usunięcie urządzenia nie powiodło się",
      "device_delete_unsuccessfull_toast"
    ],
    device_locked_status: [
      "Device is locked",
      "Device is locked",
      "デバイスがロックされています",
      "设备已锁定",
      "Das Gerät ist gesperrt",
      "L'appareil est bloqué",
      "Il dispositivo è bloccato",
      "O dispositivo está bloqueado",
      "Equipo bloqueado",
      "Устройство заблокировано",
      "Urządzenie jest zablokowane",
      "device_locked_status"
    ],
    device_stolen_confirm_text: [
      "Registering this device as stolen will permanently remove all data.",
      "Registering this device as stolen will permanently remove all data.",
      "このデバイスを盗難されたデバイスとして登録すると、すべてのデータが完全に削除されます。",
      "将此设备注册为被盗将永久删除所有数据。",
      "Mit der Eintragung als gestohlenes Gerät werden alle Daten dauerhaft gelöscht",
      "Si vous marquez cet appareil comme étant volé, les données seront effacées de manière permanente",
      "La registrazione di questo dispositivo come rubato rimuoverà permanentemente tutti i dati.",
      "Registrar este dispositivo como furtado removerá permanentemente todos os dados.",
      "”Los datos se borrarán permanentemente si registra este equipo como robado",
      "После регистрации этого устройства как украденного все данные будут безвозвратно удалены.",
      "Zarejestrowanie tego urządzenia jako skradzionego spowoduje trwałe usunięcie wszystkich danych.",
      "device_stolen_confirm_text"
    ],
    device_unlock_confirm_text: [
      "Do you wish to unlock this device?",
      "Do you wish to unlock this device?",
      "このデバイスをロック解除しますか?",
      "您想解锁此设备吗？",
      "Möchten Sie das Gerät wieder entsperren?",
      "Voulez-vous débloquer cet appareil ?",
      "Desideri sbloccare questo dispositivo?",
      "Você deseja desbloquear este dispositivo?",
      "¿Desea desbloquear este equipo?",
      "Разблокировать это устройство?",
      "Czy chcesz odblokować to urządzenie?",
      "device_unlock_confirm_text"
    ],
    device_registered_stolen: [
      "Your device has been reported as stolen",
      "Your device has been reported as stolen",
      "デバイスが盗難されたとして報告されました",
      "您的设备被报告为被盗",
      "Ihr Gerät wurde als gestohlen gemeldet",
      "Votre appareil est indiqué comme étant volé",
      "Il tuo dispositivo è stato contrassegnato come rubato",
      "Seu dispositivo foi relatado como furtado",
      "El equipo ha sido reportado como robado",
      "Ваше устройство указано как украденное",
      "Twoje urządzenie zostało zgłoszone jako skradzione",
      "device_registered_stolen"
    ],
    device_lock_toast: [
      "Your device has been locked",
      "Your device has been locked",
      "デバイスがロックされました",
      "您的设备已被锁定",
      "Ihr Gerät wurde gesperrt",
      "Votre appareil est bloqué",
      "Il tuo dispositivo è stato bloccato",
      "Seu dispositivo foi bloqueado",
      "El equipo ha sido bloqueado",
      "Ваше устройство заблокировано",
      "Twoje urządzenie zostało zablokowane",
      "device_lock_toast"
    ],
    device_unlock_toast: [
      "Your device has been unlocked",
      "Your device has been unlocked",
      "デバイスがロック解除されました",
      "您的设备已解锁",
      "Ihr Gerät wurde entsperrt",
      "Votre appareil est débloqué",
      "Il tuo dispositivo è stato sbloccato",
      "Seu dispositivo foi desbloqueado",
      "El equipo ha sido desbloqueado",
      "Ваше устройство разблокировано",
      "Twoje urządzenie zostało odblokowane",
      "device_unlock_toast"
    ],
    device_stolen_toast: [
      "Your device has been marked as stolen",
      "Your device has been marked as stolen",
      "デバイスが盗難されたとして記録されました",
      "您的设备已被标记为被盗",
      "Ihr Gerät wurde als gestohlen markiert",
      "Votre appareil est marqué comme étant volé",
      "Il tuo dispositivo è stato contrassegnato come rubato",
      "Seu dispositivo foi marcado como furtado",
      "El equipo ha sido marcado como robado",
      "Ваше устройство отмечено как украденное",
      "Twoje urządzenie zostało oznaczone jako skradzione",
      "device_stolen_toast"
    ],
    revert_device_stolen_toast: [
      "Your device stolen status has been reverted",
      "Your device stolen status has been reverted",
      "デバイスの盗難ステータスが元の戻されました",
      "您的设备被盗状态已被恢复",
      "Der Status Ihres Gerätes wurde von gestohlen auf wiedergefunden geändert",
      "Le statut d'appareil volé a été retiré",
      "Lo stato di rubato del tuo dispositivo è stato rimosso",
      "O status de furtado do seu dispositivo foi revertido",
      "Estado robado del equipo ha sido revertido",
      "Состояние устройства как украденного отменено",
      "Status o kradzieży Twojego urządzenia został cofnięty",
      "revert_device_stolen_toast"
    ],
    device_reset_pin_toast: [
      "Go to tester to set the PIN",
      "Go to tester to set the PIN",
      "テスターに移動してPINを設定してください",
      "请前往测试机设置密码",
      "Gehen Sie zum Tester, um die PIN einzurichten",
      "Allez sur le testeur pour configurer le PIN",
      "Vai al tester per impostare il PIN",
      "Vá para o testador para definir o PIN",
      "Vaya al probador para configurar el PIN",
      "Перейдите к тестеру, чтобы установить PIN-код",
      "Przejdź do testera, aby ustawić kod PIN",
      "device_reset_pin_toast"
    ],
    device_lock_title: [
      "Device Lock",
      "Device Lock",
      "デバイスのロック",
      "设备锁定",
      "Gerät sperren",
      "Verrouillage de l'appareil",
      "Blocco del dispositivo",
      "Bloqueio do Dispositivo",
      "Bloqueo del equipo",
      "Блокировка устройства",
      "Zablokuj urządzenie",
      "device_lock_title"
    ],
    device_unlock_title: [
      "Device Unlock",
      "Device Unlock",
      "デバイスのロック解除",
      "设备解锁",
      "Gerät entsperren",
      "Déverrouillage de l'appareil",
      "Sblocco del dispositivo",
      "Desbloqueio do Dispositivo",
      "Desbloqueo del equipo",
      "Разблокировка устройства",
      "Odblokuj urządzenie",
      "device_unlock_title"
    ],
    device_lock_confirm_text: [
      "Do you wish to lock this device?",
      "Do you wish to lock this device?",
      "このデバイスをロックしますか?",
      "您想锁定此设备吗？",
      "Möchten Sie dieses Gerät entsperren?",
      "Voulez-vous bloquer cet appareil ?",
      "Bloccare questo dispositivo?",
      "Você deseja bloquear este dispositivo?",
      "¿Desea bloquear este equipo?",
      "Заблокировать это устройство?",
      "Czy chcesz zablokować to urządzenie?",
      "device_lock_confirm_text"
    ],
    device_details_device_id: [
      "Device ID",
      "Device ID",
      "デバイスID",
      "设备 ID",
      "Gerätekennung",
      "N° de série de l’appareil",
      "ID dispositivo",
      "ID do dispositivo",
      "ID de dispositivo",
      "ИД устр-ва",
      "Identyfikator urządzenia",
      "device_details_device_id"
    ],
    device_details_device_type: [
      "LanTEK IV",
      "LanTEK IV",
      "LanTEK IV",
      "LanTEK IV",
      "LanTEK IV",
      "LanTEK IV",
      "LanTEK IV",
      "LanTEK IV",
      "LanTEK IV",
      "LanTEK IV",
      "LanTEK IV",
      "device_details_device_type"
    ],
    device_details_last_online: [
      "Last Online",
      "Last Online",
      "前回オンライン",
      "上次在线",
      "Zuletzt online",
      "Dernière version en ligne",
      "Ultimo online",
      "Última vez online",
      "Última conexión",
      "Последнее подключение к сети",
      "Ostatnio online",
      "device_details_last_online"
    ],
    device_details_location: [
      "Location",
      "Location",
      "位置",
      "位置",
      "Standort",
      "Emplacement",
      "Posizione",
      "Local",
      "Ubicación",
      "Расположение",
      "Lokalizacja",
      "device_details_location"
    ],
    device_details_engineer: [
      "Engineer",
      "Technician",
      "技術者",
      "工程师",
      "Techniker",
      "Opérateur",
      "Ingegnere",
      "Técnico",
      "Técnico",
      "Инженер",
      "Technik",
      "device_details_engineer"
    ],
    device_details_software_version: [
      "Software Version",
      "Software Version",
      "ソフトウェアのバージョン",
      "软件版本",
      "Softwareversion",
      "Version du logicielle",
      "Versione del software",
      "Versão do Software",
      "Versión de SW",
      "Версия ПО",
      "Wersja oprogramowania",
      "device_details_software_version"
    ],
    device_details_calibration_due_date: [
      "Calibration Due Date",
      "Calibration Due Date",
      "校正時期の日付",
      "校准到期日",
      "Nächster Kalibriertermin",
      "Date requise d'étalonnage usine",
      "Data di scadenza della taratura",
      "Calibração válida até",
      "Vencimiento de calibración",
      "Срок калибровки",
      "Termin następnej kalibracji",
      "device_details_calibration_due_date"
    ],
    device_details_copper_tests: [
      "Copper Tests",
      "Copper Tests",
      "銅線テスト",
      "铜测试",
      "Kupfer-Tests",
      "Tests Cuivre",
      "Test del rame",
      "Testes de Cobre",
      "Tests cobre",
      "Тесты медных кабелей",
      "Testy miedzi",
      "device_details_copper_tests"
    ],
    device_details_fiber_tests: [
      "Fibre Tests",
      "Fiber Tests",
      "ファイバーテスト",
      "光纤测试仪",
      "Glasfaser-Tests",
      "Tests Fibre",
      "Test della fibra",
      "Testes de Fibra",
      "Tests fibra",
      "Тесты оптоволоконных кабелей",
      "Testy włókna",
      "device_details_fiber_tests"
    ],
    device_details_total_tests: [
      "Total Tests",
      "Total Tests",
      "合計テスト",
      "测试总计",
      "Tests gesamt",
      "Tous les tests",
      "Test totali",
      "Total de Testes",
      "Tests total",
      "Всего тестов",
      "Suma testów",
      "device_details_total_tests"
    ],
    device_details_total_tests_run: [
      "Run",
      "Run",
      "実行",
      "运行",
      "Ausgeführt",
      "Lancer",
      "Esegui",
      "Executar",
      "Ejecutar",
      "Выполнить",
      "Uruchom",
      "device_details_total_tests_run"
    ],
    device_details_payt_count: [
      "PAYT",
      "PAYT",
      "PAYT",
      "PAYT",
      "PAYT",
      "PAYT",
      "PAYT",
      "PAYT",
      "PAYT",
      "PAYT",
      "PAYT",
      "device_details_payt_count"
    ],
    device_details_credits_remaining: [
      "Credits Remaining",
      "Credits Remaining",
      "クレジット残高",
      "剩余点数",
      "Restguthaben",
      "Crédits restants",
      "Crediti restanti",
      "Créditos Restantes",
      "Créditos restantes",
      "Осталось тестов ",
      "Pozostałe kredyty",
      "device_details_credits_remaining"
    ],
    device_details_license_number: [
      "License No",
      "License No",
      "ライセンス番号",
      "许可证编号",
      "Lizenznummer",
      "Licence N°",
      "N. di licenza",
      "Número da Licença",
      "Nº de licencia",
      "№ лицензии",
      "Nr licencji",
      "device_details_license_number"
    ],
    device_details_license_description: [
      "Feature Description",
      "Feature Description",
      "機能の説明",
      "功能描述",
      "Lizenzierte Funktionen",
      "Description des fonctionnalités",
      "Descrizione della funzione",
      "Descrição dos Recursos",
      "Descripción de funciones",
      "Описание функции",
      "Opis funkcji",
      "device_details_license_description"
    ],
    device_details_request_service: [
      "Request Service",
      "Request Service",
      "サービスをリクエストする",
      "请求服务",
      "Service anfordern",
      "Demander un service",
      "Richiedi Servizio",
      "Solicitar Serviço",
      "Solicitar servicio",
      "Запросить услугу",
      "Poproś o usługę",
      "device_details_service_request"
    ],
    error_enter_value: [
      "Please enter a value",
      "Please enter a value",
      "値を入力してください",
      "请输入一个值",
      "Bitte geben Sie einen Wert ein",
      "Veuillez saisir une valeur",
      "Inserisci un valore",
      "Insira um valor",
      "Por favor introduzca un valor",
      "Пожалуйста, введите значение",
      "Proszę wpisać wartość",
      "error_enter_value"
    ],
    error_select_value: [
      "Please select a value",
      "Please select a value",
      "値を選択してください",
      "请选择一个值",
      "Bitte wählen Sie einen Wert aus",
      "Veuillez choisir une valeur",
      "Seleziona un valore",
      "Selecione um valor",
      "Por favor seleccione un valor",
      "Пожалуйста, выберите значение",
      "Proszę wybrać wartość",
      "error_select_value"
    ],
    error_check_box: [
      "Please check this box",
      "Please check this box",
      "このボックスにチェックを入れてください",
      "请勾选此框",
      "Bitte kreuzen Sie dieses Kästchen an",
      "Veuillez cocher cette case",
      "Seleziona questa casella",
      "Marque esta caixa",
      "Por favor, marque esta casilla",
      "Пожалуйста, установите этот флажок",
      "Proszę zaznaczyć to pole",
      "error_check_box"
    ],
    device_create_rma_success_toast: [
      "Service request has been created successfully",
      "Service request has been created successfully",
      "サービスリクエストが正常に作成されました",
      "服务请求已成功创建",
      "Serviceanfrage wurde erfolgreich erstellt",
      "La demande de service a été créée avec succès",
      "La richiesta di assistenza è stata creata con successo",
      "A solicitação de serviço foi criada com sucesso",
      "La solicitud de servicio se ha creado correctamente",
      "Запрос на обслуживание успешно создан",
      "Zgłoszenie serwisowe zostało pomyślnie utworzone",
      "device_create_rma_success_toast"
    ],
    device_create_rma_error_toast: [
      "Service request could not be created",
      "Service request could not be created",
      "サービスリクエストを作成できませんでした",
      "无法创建服务请求",
      "Serviceanfrage konnte nicht erstellt werden",
      "La demande de service n'a pas pu être créée",
      "Impossibile creare la richiesta di assistenza",
      "Não foi possível criar a solicitação de serviço",
      "No se pudo crear la solicitud de servicio",
      "Не удалось создать запрос на обслуживание",
      "Nie można utworzyć zgłoszenia serwisowego",
      "device_create_rma_error_toast"
    ],
    device_rma_reason: [
      "Reason",
      "Reason",
      "理由",
      "原因",
      "Grund",
      "Raison",
      "Motivo",
      "Motivo",
      "Motivo",
      "Причина",
      "Powód",
      "device_rma_reason"
    ],
    device_rma_reason_calibration: [
      "Calibration",
      "Calibration",
      "校正",
      "校准",
      "Kalibrierung",
      "Étalonnage",
      "Calibrazione",
      "Calibração",
      "Calibración",
      "Калибровка",
      "Kalibracja",
      "device_rma_reason_calibration"
    ],
    device_rma_reason_repair: [
      "Repair",
      "Repair",
      "修理",
      "维修",
      "Reparatur",
      "Réparation",
      "Riparazione",
      "Reparação",
      "Reparación",
      "Ремонт",
      "Naprawa",
      "device_rma_reason_repair"
    ],
    device_rma_battery_agreement: [
      "Battery Agreement",
      "Battery Agreement",
      "バッテリーに関する合意事項",
      "电池协议",
      "Batterie-Vereinbarung",
      "Accord sur la batterie",
      "Accordo sulla batteria",
      "Acordo da bateria",
      "Acuerdo sobre la batería",
      "Соглашение об аккумуляторе",
      "Umowa dotycząca baterii",
      "device_rma_battery_agreement"
    ],
    device_rma_accept_battery_agreement: [
      "I agree to the Battery Agreement",
      "I agree to the Battery Agreement",
      "バッテリーに関する合意事項に同意します",
      "我同意电池协议",
      "Ich stimme der Batterie-Vereinbarung zu",
      "J'accepte l'accord sur la batterie",
      "Accetto l'accordo sulla batteria",
      "Eu concordo com o acordo da bateria",
      "Estoy de acuerdo con el acuerdo sobre la batería",
      "Я согласен с соглашением об аккумуляторе",
      "Zgadzam się na umowę dotyczącą baterii",
      "device_rma_accept_battery_agreement"
    ],
    generate_report_title: [
      "Create a Report",
      "Create a Report",
      "レポートを作成",
      "创建报告",
      "Bericht erstellen",
      "Créer un rapport",
      "Crea un rapporto",
      "Criar um Relatório",
      "Crear informe",
      "Создать отчет",
      "Utwórz raport",
      "generate_report_title"
    ],
    generate_report_tab_reportdetails: [
      "Report Details",
      "Report Details",
      "レポートの詳細",
      "报告详情",
      "Berichtsangaben",
      "Détails du rapport",
      "Dettagli del rapporto",
      "Detalhes do Relatório",
      "Detalles informe",
      "Сведения об отчете",
      "Szczegóły raportu",
      "generate_report_tab_reportdetails"
    ],
    generate_report_tab_customerdetails: [
      "Customer Details",
      "Customer Details",
      "カスタマーの詳細",
      "客户详细信息",
      "Kunden-Angaben",
      "Détails du client",
      "Dettagli del cliente",
      "Informações do Cliente",
      "Detalles cliente",
      "Сведения о заказчике",
      "Szczegóły dot. klienta",
      "generate_report_tab_customerdetails"
    ],
    generate_report_tab_reportoptions: [
      "Report Options",
      "Report Options",
      "レポートのオプション",
      "报告选项",
      "Berichtsoptionen",
      "Options du rapport",
      "Opzioni del rapporto",
      "Opções do Relatório",
      "Opciones informe",
      "Параметры отчета",
      "Opcje raportu",
      "generate_report_tab_reportoptions"
    ],
    generate_report_generate: [
      "Generate",
      "Generate",
      "生成",
      "生成",
      "Erstellen",
      "Générer",
      "Genera",
      "Gerar",
      "Generar",
      "Создать",
      "Generuj",
      "generate_report_generate"
    ],
    generate_report_report_name: [
      "Report Name",
      "Report Name",
      "レポート名",
      "报告名称",
      "Berichtsname",
      "Nom du rapport",
      "Nome del rapporto",
      "Nome do Relatório",
      "Nombre informe",
      "Имя отчета",
      "Nazwa raportu",
      "generate_report_report_name"
    ],
    generate_report_report_name_help: [
      "Please Enter Report Name",
      "Please Enter Report Name",
      "レポート名を入力してください",
      "请输入报告名称",
      "Bitte tragen Sie den Berichtsnamen ein",
      "Veuillez entrer un nom de rapport",
      "Inserire il nome del rapporto",
      "Informe o nome do relatório",
      "Introducir nombre de informe",
      "Введите имя отчета",
      "Wprowadź nazwę raportu",
      "generate_report_report_name_help"
    ],
    generate_report_report_type: [
      "Report Type",
      "Report Type",
      "レポートのタイプ",
      "报告类型",
      "Berichtstyp",
      "Type de rapport",
      "Tipo di rapporto",
      "Tipo de Relatório",
      "Tipo informe",
      "Тип отчета",
      "Typ raportu",
      "generate_report_report_type"
    ],
    generate_report_type_singleline: [
      "Single-line Report",
      "Single-line Report",
      "1行表示のレポート",
      "单行报告",
      "Übersicht",
      "Rapport de Synthèse",
      "Rapporto a linea singola",
      "Relatório Simples",
      "Informe de una línea",
      "Отчет одной строкой",
      "Raport jednowierszowy",
      "generate_report_type_singleline"
    ],
    generate_report_type_brief: [
      "Brief Report",
      "Brief Report",
      "簡易表示のレポート",
      "简报",
      "Vollständiger Bericht",
      "Rapport Classique",
      "Rapporto breve",
      "Relatório Breve",
      "Informe breve",
      "Краткий отчет",
      "Krótki raport",
      "generate_report_type_brief"
    ],
    generate_report_type_detail: [
      "Detailed Report",
      "Detailed Report",
      "詳細表示のレポート",
      "详细报告",
      "Vollständiger Bericht ",
      "Rapport Complet",
      "Rapporto dettagliato",
      "Relatório Detalhado",
      "Informe detallado",
      "Подробный отчет",
      "Raport szczegółowy",
      "generate_report_type_detail"
    ],
    generate_report_report_type_help: [
      "Please Select Report Type",
      "Please Select Report Type",
      "レポートのタイプを選択してください",
      "请选择报告类型",
      "Bitte wählen Sie einen Berichtstyp aus",
      "Veuillez sélectionner le type de rapport",
      "Selezionare il tipo di rapporto",
      "Selecione o tipo de relatório",
      "Seleccione tipo de informe",
      "Выберите тип отчета",
      "Wybierz typ raportu",
      "generate_report_report_type_help"
    ],
    generate_report_report_jobname: [
      "Job Name",
      "Job Name",
      "ジョブ名",
      "作业名称 ",
      "Projektname",
      "Nom du dossier",
      "Nome lavoro",
      "Nome do Trabalho",
      "Nombre del trabajo",
      "Имя задания",
      "Nazwa zlecenia",
      "generate_report_report_jobname"
    ],
    generate_report_report_tests: [
      "Report Tests",
      "Report Tests",
      "レポートテスト",
      "报告测试",
      "Test berichten",
      "Rapport de tests",
      "Test del Rapporto",
      "Testes do Relatório",
      "Создать отчет по тестам",
      "Testy raportu",
      "generate_report_report_tests"
    ],
    generate_report_report_selected: [
      "Tests Selected",
      "Tests Selected",
      "選択済みテスト",
      "所选测试",
      "Ausgewählte Tests",
      "Tests sélectionnés",
      "Test selezionati",
      "Testes Selecionados",
      "Pruebas seleccionadas",
      "Выбранные тесты",
      "Wybrano testy",
      "generate_report_report_selected"
    ],
    generate_report_select_customer: [
      "Customer",
      "Customer",
      "カスタマー",
      "客户",
      "Kunde",
      "Client",
      "Cliente",
      "Cliente",
      "Cliente",
      "Заказчик",
      "Klient",
      "generate_report_select_customer"
    ],
    generate_report_select_customer_help: [
      "Select a Customer",
      "Select a Customer",
      "カスタマーを選択してください",
      "选择客户",
      "Kunden auswählen",
      "Sélectionnez un client",
      "Seleziona un cliente",
      "Selecione um cliente",
      "Seleccionar cliente",
      "Выберите заказчика",
      "Wybierz klienta",
      "generate_report_select_customer_help"
    ],
    generate_report_include_coverpage: [
      "Include Summary Page",
      "Include Summary Page",
      "サマリーページを含める",
      "包括汇总页",
      "Mit Zusammenfassung",
      "Comprend une page de Résumé",
      "Includi pagina del riepilogo",
      "Incluir página de resumo",
      "pruebas del informe",
      "Включить сводную страницу",
      "Dołącz stronę z podsumowaniem",
      "generate_report_include_coverpage"
    ],
    generate_report_include_summary_table: [
      "Include Summary Table",
      "Include Summary Table",
      "サマリー表を含める",
      "包括汇总表",
      "Mit Tabellenübersicht",
      "Comprend un tableau Résumé",
      "Includi tabella del riepilogo",
      "Incluir tabela de resumo",
      "Incluir tabla resumen",
      "Включить сводную таблицу",
      "Dołącz tabelę z podsumowaniem",
      "generate_report_include_summary_table"
    ],
    generate_report_include_length: [
      "Display Length",
      "Display Length",
      "表示の長さ",
      "显示长度",
      "Länge anzeigen",
      "Afficher la longueur",
      "Mostra lunghezza",
      "Mostrar comprimento",
      "Mostrar longitud",
      "Показать длину",
      "Długość wyświetlenia",
      "generate_report_include_length"
    ],
    generate_report_jobnotes: [
      "Job Notes",
      "Job Notes",
      "ジョブのメモ",
      "作业说明 ",
      "Projekt-Kommentar",
      "Notes du dossier",
      "Note del lavoro",
      "Notas do Trabalho",
      "Notas del trabajo",
      "Примечания к заданию",
      "Notatki dot. zlecenia",
      "generate_report_jobnotes"
    ],
    generate_report_jobnotes_help: [
      "Please Enter Job Notes",
      "Please Enter Job Notes",
      "ジョブのメモを入力してください",
      "请输入作业说明 ",
      "Bitte tragen Sie einen Kommentar zum Projekt ein",
      "Veuillez entrer les notes du dossier",
      "Inserisci le note del lavoro",
      "Informe as notas do trabalho",
      "Introducir notas del trabajo",
      "Введите примечания к заданию",
      "Wprowadź notatki dot. zlecenia",
      "generate_report_jobnotes_help"
    ],
    tests_generate_report_successfull_toast: [
      "Report is being generated. This may take several minutes",
      "Report is being generated. This may take several minutes",
      "レポートが生成されています。これには数分かかることがあります",
      "正在生成报告。这可能需要几分钟",
      "Der Bericht wird erstellt. Diese Aktion kann mehrere Minuten in Anspruch nehmen",
      "Le rapport est en cours de création : cette opération peut prendre plusieurs minutes.",
      "Generazione del rapporto in corso. Questa operazione potrebbe richiedere vari minuti",
      "O relatório está sendo gerado. Isso pode demorar alguns minutos",
      "Se está creando el informe. Esto puede tardar unos minutos",
      "Идет создание отчета. Это может занять несколько минут",
      "Trwa generowanie raportu. Może to zająć kilka minut.",
      "tests_generate_report_successfull_toast"
    ],
    tests_generate_report_unsuccessfull_toast: [
      "Report generation unsuccessful ${errors}",
      "Report generation unsuccessful ${errors}",
      "レポートの生成に失敗しました: ${errors}",
      "报告生成失败 ${errors}",
      "Fehler bei Berichterstellung ${errors}",
      "Le rapport n'a pas pu être généré ${errors}",
      "Generazione del rapporto non riuscita ${errors}",
      "Falha na geração do relatório ${errors}",
      "Errores al crear informe: ${errors}",
      "Не удалось создать отчет: ${errors}",
      "Wygenerowanie raportu nie powiodło się ${errors}",
      "tests_generate_report_unsuccessfull_toast"
    ],
    tests_generate_report_no_test_toast: [
      "Report can not be generated as there is no result",
      "Report can not be generated as there is no result",
      "結果が存在しないため、レポートを生成できません",
      "无结果，因此无法生成报告",
      "Der Bericht kann nicht erstellt werden, da kein Testergebnis vorhanden ist",
      "Le rapport ne peut pas être généré car il n'y a aucun résultat",
      "Il rapporto non può essere generato in quanto non sono presenti i risultati",
      "O relatório não foi gerado pois não existem resultados",
      "No se puede crear el informe - no hay resultados",
      "Не удалось создать отчет, так как результаты отсутствуют",
      "Nie można wygenerować raportu, gdyż nie ma wyniku",
      "tests_generate_report_no_test_toast"
    ],
    send_report_title: [
      "Email Report",
      "Email Report",
      "レポートをメール送信",
      "电子邮件报告",
      "E-Mail-Bericht",
      "Envoyer le rapport par email",
      "Invia rapporto per e-mail",
      "Enviar relatório por e-mail",
      "Informe correo-e",
      "Отправить отчет по электронной почте",
      "Raport e-mailowy",
      "send_report_title"
    ],
    email_addressess: [
      "Email",
      "Email",
      "メール",
      "电子邮件",
      "E-Mail",
      "Email",
      "E-mail",
      "E-mail",
      "Correo-e",
      "Электронная почта",
      "E-mail",
      "email_addressess"
    ],
    email_addressess_help: [
      "Multiple email recipients should be separated by ';'. Sending to multiple recipients the email will be visible to all recipients.",
      "Multiple email recipients should be separated by ';'. Sending to multiple recipients the email will be visible to all recipients.",
      "複数の電子メール受信者を指定するにはセミコロン「;」で区切ります。複数の受信者に送信するメールは、すべての受信者に表示されるようになります。",
      "多个电子邮件收件人应以 ';' 分隔",
      "Mehrere Empfänger sind mit ';' zu trennen",
      "Si plusieurs destinataires, merci de séparer les adresses emails par un ';'",
      "I diversi destinatari dell'e-mail dovrebbero essere separati da ';'",
      "Destinatários de e-mail devem ser separados por ';'. Enviar para múltiplos destinatários tornará o e-mail visível a todos os destinatários.",
      "Introduzca múltiples destinatarios separados por ';'",
      "Получателей следует разделять символом ';'",
      "Wielu adresatów wiadomości e-mail należy rozdzielić znakiem ';'. Wiadomość e-mail wysyłana do wielu odbiorców będzie widoczna przez wszystkich odbiorców.",
      "email_addressess_help"
    ],
    send_email_report_successfull_taost: [
      "Email sent successfully",
      "Email sent successfully",
      "メールが正常に送信されました",
      "已成功发送电子邮件",
      "E-Mail erfolgreich versandt",
      "L'email a été envoyé avec succès",
      "E-mail inviata correttamente",
      "E-mail enviado com sucesso",
      "Correo-e enviado",
      "Сообщение отправлено",
      "Przesłanie e-maila powiodło się.",
      "send_email_report_successfull_taost"
    ],
    send_email_report_unsuccessfull_taost: [
      "Email could not be sent",
      "Email could not be sent",
      "メールを送信できませんでした",
      "无法发送电子邮件",
      "E-Mail konnte nicht versandt werden",
      "L'email n'a pas pu être envoyé",
      "Non è stato possibile inviare l'e-mail",
      "Não foi possível enviar o e-mail",
      "No se pudo enviar correo-e",
      "Не удалось отправить сообщение",
      "Przesłanie e-maila nie powiodło się",
      "send_email_report_unsuccessfull_taost"
    ],
    softwareversion: [
      "Software Version",
      "Software Version",
      "ソフトウェアのバージョン",
      "软件版本",
      "Softwareversion",
      "Version du logicielle",
      "Versione del software",
      "Versão do Software",
      "Versión de SW",
      "Версия ПО",
      "Wersja oprogramowania",
      "softwareversion"
    ],
    deviceserialno: [
      "Device ID",
      "Device ID",
      "デバイスID",
      "设备ID",
      "Geräte-ID",
      "Numéro de série appareil",
      "ID dispositivo",
      "ID do dispositivo",
      "ID del equipo",
      "Идентификатор устройства",
      "Identyfikator urządzenia",
      "deviceserialno"
    ],
    lastonline: [
      "Last Online",
      "Last Online",
      "前回オンライン",
      "上次在线",
      "Zuletzt online",
      "Dernière version en ligne",
      "Ultimo online",
      "Última vez online",
      "Última conexión",
      "Последнее подключение к сети",
      "Ostatnio online",
      "lastonline"
    ],
    engineer: [
      "Engineer",
      "Technician",
      "技術者",
      "工程师",
      "Techniker",
      "Opérateur",
      "Ingegnere",
      "Técnico",
      "Técnico",
      "Инженер",
      "Technik",
      "engineer"
    ],
    calibrationdue: [
      "Calibration Due",
      "Calibration Due",
      "校正期日",
      "校准到期",
      "Kalibriertermin",
      "Etalonnage usine requis",
      "Taratura in scadenza",
      "Calibração válida até",
      "Vencimiento calibración",
      "Срок калибровки",
      "Termin następnej kalibracji",
      "calibrationdue"
    ],
    paytstatus: [
      "PAYT status",
      "PAYT status",
      "PAYTステータス",
      "PAYT 状态",
      "PAYT-Status",
      "Statut du paiement PAYT",
      "Stato PAYT",
      "Status PAYT",
      "Estado PAYT",
      "Состояние PAYT",
      "Status PAYT",
      "paytstatus"
    ],
    tooltip_my_account: [
      "My Account",
      "My Account",
      "マイアカウント",
      "我的帐户",
      "Mein Konto",
      "Mon compte",
      "Il mio account",
      "Minha Conta",
      "Mi cuenta",
      "Мой аккаунт",
      "Moje konto",
      "tooltip_my_account"
    ],
    tooltip_settings: [
      "Settings",
      "Settings",
      "設定",
      "设置",
      "Einstellungen",
      "Paramètres",
      "Impostazioni",
      "Configurações",
      "Ajustes",
      "Настройки",
      "Ustawienia",
      "tooltip_settings"
    ],
    tooltip_log_out: [
      "Log Out",
      "Log Out",
      "ログアウト",
      "注销",
      "Abmelden",
      "Se déconnecter",
      "Chiudi sessione",
      "Encerrar sessão",
      "Cerrar sesión",
      "Выйти",
      "Wyloguj",
      "tooltip_log_out"
    ],
    tooltip_add: [
      "Add",
      "Add",
      "追加",
      "添加",
      "Hinzufügen",
      "Ajouter",
      "Aggiungi",
      "Incluir",
      "Añadir",
      "Добавить",
      "Dodaj",
      "tooltip_add"
    ],
    tooltip_edit: [
      "Edit",
      "Edit",
      "編集",
      "编辑",
      "Bearbeiten",
      "Modifier",
      "Modifica",
      "Editar",
      "Editar",
      "Изменить",
      "Edytuj",
      "tooltip_edit"
    ],
    tooltip_delete: [
      "Delete",
      "Delete",
      "削除",
      "删除",
      "Löschen",
      "Supprimer",
      "Elimina",
      "Excluir",
      "Eliminar",
      "Удалить",
      "Usuń",
      "tooltip_delete"
    ],
    tooltip_filter: [
      "Filter",
      "Filter",
      "フィルタ",
      "筛选",
      "Filtern",
      "Filtrer",
      "Filtra",
      "Filtrar",
      "Filtrar",
      "Фильтр",
      "Filtruj",
      "tooltip_filter"
    ],
    tooltip_view_columns: [
      "View Columns",
      "View Columns",
      "列を表示",
      "查看列",
      "Spalten anzeigen",
      "Afficher les colonnes",
      "Visualizza colonne",
      "Exibir Colunas",
      "Ver columnas",
      "Просмотреть столбцы",
      "Wyświetl kolumny",
      "tooltip_view_columns"
    ],
    tooltip_create_report: [
      "Create Report",
      "Create Report",
      "レポートを作成",
      "创建报告",
      "Bericht erstellen",
      "Créer un rapport",
      "Crea rapporto",
      "Criar Relatório",
      "Crear informe",
      "Создать отчет",
      "Utwórz raport",
      "tooltip_create_report"
    ],
    tooltip_attach_files: [
      "Attach Files",
      "Attach Files",
      "ファイルを添付",
      "附加文件",
      "Dateien anhängen",
      "Joindre des fichiers",
      "Allega file",
      "Anexar Arquivos",
      "Adjuntar archivos",
      "Прикрепить файлы",
      "Załącz pliki",
      "tooltip_attach_files"
    ],
    tooltip_chart_settings: [
      "Chart Settings",
      "Chart Settings",
      "グラフの設定",
      "图表设置",
      "Diagramm-Einstellungen",
      "Paramètres du graphique",
      "Impostazioni diagramma",
      "Configuração do Gráfico",
      "Ajustes de gráficos",
      "Настройки графика",
      "Ustawienia wykresu",
      "tooltip_chart_settings"
    ],
    tooltip_team_viewer: [
      "Team Viewer",
      "Team Viewer ",
      "TeamViewer ",
      "Team Viewer 应用",
      "Team Viewer",
      "Team Viewer",
      "Team Viewer",
      "Team Viewer",
      "Team Viewer",
      "Team Viewer",
      "Przeglądarka zespołu",
      "tooltip_team_viewer"
    ],
    tooltip_create_job: [
      "Create Job",
      "Create Job",
      "ジョブを作成",
      "创建作业",
      "Projekt erstellen",
      "Créer un dossier",
      "Crea lavoro",
      "Criar Trabalho",
      "Crear trabajo",
      "Создать задание",
      "Utwórz zlecenie",
      "tooltip_create_job"
    ],
    tooltip_import_lantek: [
      "Import LanTEK III Test Files (.lt3)",
      "Import LanTEK III Test Files (.lt3)",
      "LanTEK IIIテストファイル (.lt3) のインポート",
      "导入LanTEK III测试文件(.lt3)",
      "Importieren von LanTEK III Testdateien (.lt3)",
      "Importer les tests du LanTEK III (.lt3)",
      "Importa i File test LanTEK III (.lt3)",
      "Importar testes do LanTEK III (.lt3)",
      "Importar archivos de prueba LanTEK III (.lt3)",
      "Импортировать файлы тестов LanTEK III (.lt3)",
      "Importuj pliki testowe LanTEK III (.lt3)",
      "tooltip_import_lantek"
    ],
    tooltip_search: [
      "Search",
      "Search",
      "検索",
      "搜索",
      "Suchen",
      "Rechercher",
      "Ricerca",
      "Procurar",
      "Buscar",
      "Поиск",
      "Szukaj",
      "tooltip_search"
    ],
    tooltip_create_tests: [
      "Create Tests",
      "Create Tests",
      "テストを作成",
      "创建测试",
      "Tests erstellen",
      "Créer des tests",
      "Crea test",
      "Criar Testes",
      "Crear pruebas",
      "Создать тесты",
      "Utwórz testy",
      "tooltip_create_tests"
    ],
    tooltip_recertify: [
      "Recertify",
      "Recertify",
      "再認証",
      "重新认证",
      "Erneut zertifizieren",
      "Recertifier",
      "Certifica nuovamente",
      "Recertificar",
      "Recertificar",
      "Выполнить сертификацию повторно",
      "Ponownie certyfikuj",
      "tooltip_recertify"
    ],
    tooltip_move_tests: [
      "Move Tests",
      "Move Tests",
      "テストを移動",
      "移动测试",
      "Tests verschieben",
      "Déplacer les tests",
      "Sposta test",
      "Mover Testes",
      "Mover pruebas",
      "Переместить тесты",
      "Przenieś testy",
      "tooltip_move_tests"
    ],
    tooltip_back: [
      "Back",
      "Back",
      "戻る",
      "返回",
      "Zurück",
      "Retour",
      "Indietro",
      "Voltar",
      "Atrás",
      "Назад",
      "Wstecz",
      "tooltip_back"
    ],
    tooltip_check_smart_flags: [
      "Check Smart Flags",
      "Check Smart Flags",
      "スマートフラグを確認",
      "检查智能标记",
      "Smart Flags pruefen",
      "Verifier les Smart Flags",
      "Controlla Smart Flag",
      "Verificar Smart Flags",
      "Comprobar Smart Flags",
      "Проверить Smart Flags",
      "Sprawdz Smart Flags",
      "tooltip_check_smart_flags"
    ],
    tooltip_edit_smart_flag_profile: [
      "Edit Smart Flag profile",
      "Edit Smart Flag profile",
      "スマートフラグプロファイルを編集",
      "编辑智能标记配置文件",
      "Smart Flag-Profil bearbeiten",
      "Modifier le profil Smart Flag",
      "Modifica profilo Smart Flag",
      "Editar perfil Smart Flag",
      "Editar perfil de Smart Flag",
      "Редактировать профиль Smart Flag",
      "Edytuj profil Smart Flag",
      "tooltip_edit_smart_flag_profile"
    ],
    smart_flags_checking: [
      "Checking Smart Flags",
      "Checking Smart Flags",
      "スマートフラグを確認中",
      "正在检查智能标记",
      "Smart Flags werden geprueft",
      "Verification des Smart Flags",
      "Controllo Smart Flag",
      "A verificar Smart Flags",
      "Comprobando Smart Flags",
      "Проверка Smart Flags",
      "Sprawdzanie Smart Flags",
      "smart_flags_checking"
    ],
    smart_flags_profile_not_selected: [
      "No Smart Flag profile selected",
      "No Smart Flag profile selected",
      "スマートフラグプロファイルが選択されていません",
      "未选择智能标记配置文件",
      "Kein Smart Flag-Profil ausgewaehlt",
      "Aucun profil Smart Flag selectionne",
      "Nessun profilo Smart Flag selezionato",
      "Nenhum perfil Smart Flag selecionado",
      "No se ha seleccionado ningun perfil de Smart Flag",
      "Профиль Smart Flag не выбран",
      "Nie wybrano profilu Smart Flag",
      "smart_flags_profile_not_selected"
    ],
    smart_flags_no_matching_tests: [
      "Current Smart Flag profile rules do not match any tests. Please check the profile setup.",
      "Current Smart Flag profile rules do not match any tests. Please check the profile setup.",
      "現在のスマートフラグプロファイルルールに一致するテストがありません。プロファイル設定を確認してください。",
      "当前智能标记配置文件规则未匹配任何测试。请检查配置文件设置。",
      "Die aktuellen Smart Flag-Profilregeln passen zu keinen Tests. Bitte pruefen Sie die Profileinrichtung.",
      "Les regles du profil Smart Flag actuel ne correspondent a aucun test. Veuillez verifier la configuration du profil.",
      "Le regole del profilo Smart Flag corrente non corrispondono ad alcun test. Controllare la configurazione del profilo.",
      "As regras do perfil Smart Flag atual nao correspondem a nenhum teste. Verifique a configuracao do perfil.",
      "Las reglas del perfil de Smart Flag actual no coinciden con ninguna prueba. Compruebe la configuracion del perfil.",
      "Правила текущего профиля Smart Flag не соответствуют ни одному тесту. Проверьте настройку профиля.",
      "Reguly biezacego profilu Smart Flag nie pasuja do zadnych testow. Sprawdz konfiguracje profilu.",
      "smart_flags_no_matching_tests"
    ],
    smart_flag_customer_default: [
      "Customer Default",
      "Customer Default",
      "顧客のデフォルト",
      "客户默认值",
      "Kundenstandard",
      "Valeur par defaut du client",
      "Predefinito cliente",
      "Predefinicao do cliente",
      "Predeterminado del cliente",
      "Клиент по умолчанию",
      "Domyslny klienta",
      "smart_flag_customer_default"
    ],
    smart_flag_organisation_default: [
      "Organisation Default",
      "Organisation Default",
      "組織のデフォルト",
      "组织默认值",
      "Organisationsstandard",
      "Valeur par defaut de l'organisation",
      "Predefinito organizzazione",
      "Predefinicao da organizacao",
      "Predeterminado de la organizacion",
      "Организация по умолчанию",
      "Domyslny organizacji",
      "smart_flag_organisation_default"
    ],
    notifications: [
      "Notifications",
      "Notifications",
      "通知",
      "通知",
      "Benachrichtigungen",
      "Notifications",
      "Notifiche",
      "Notificações",
      "Notificaciones",
      "Уведомления",
      "Powiadomienia",
      "notifications"
    ],
    archive_jobs_success_toast: [
      "Jobs have been archived successfully",
      "Jobs have been archived successfully",
      "ジョブは正常にアーカイブされました",
      "作业已成功归档",
      "Aufträge wurden erfolgreich archiviert",
      "Les tâches ont été archivées avec succès",
      "I lavori sono stati archiviati correttamente",
      "Os trabalhos foram arquivados com sucesso",
      "Los trabajos se han archivado correctamente",
      "Задания успешно архивированы",
      "Zlecenia zostały pomyślnie zarchiwizowane",
      "archive_jobs_success_toast"
    ],
    archive_jobs_fail_toast: [
      "Failed to archive jobs",
      "Failed to archive jobs",
      "ジョブのアーカイブに失敗しました",
      "作业归档失败",
      "Archivieren der Aufträge fehlgeschlagen",
      "Échec de l’archivage des tâches",
      "Archiviazione dei lavori non riuscita",
      "Falha ao arquivar os trabalhos",
      "Error al archivar los trabajos",
      "Не удалось архивировать задания",
      "Nie udało się zarchiwizować zleceń",
      "archive_jobs_fail_toast"
    ],
    archive_reports_success_toast: [
      "Reports have been archived successfully",
      "Reports have been archived successfully",
      "レポートは正常にアーカイブされました",
      "报告已成功归档",
      "Berichte wurden erfolgreich archiviert",
      "Les rapports ont été archivés avec succès",
      "I report sono stati archiviati correttamente",
      "Os relatórios foram arquivados com sucesso",
      "Los informes se han archivado correctamente",
      "Отчеты успешно архивированы",
      "Raporty zostały pomyślnie zarchiwizowane",
      "archive_reports_success_toast"
    ],
    archive_reports_fail_toast: [
      "Failed to archive reports",
      "Failed to archive reports",
      "レポートのアーカイブに失敗しました",
      "报告归档失败",
      "Archivieren der Berichte fehlgeschlagen",
      "Échec de l’archivage des rapports",
      "Archiviazione dei report non riuscita",
      "Falha ao arquivar os relatórios",
      "Error al archivar los informes",
      "Не удалось архивировать отчеты",
      "Nie udało się zarchiwizować raportów",
      "archive_reports_fail_toast"
    ],
    search: [
      "Search",
      "Search",
      "検索",
      "搜索",
      "Suche",
      "Rechercher",
      "Ricerca",
      "Procurar",
      "Buscar",
      "Поиск",
      "Szukaj",
      "search"
    ],
    select_columns: [
      "Select Columns",
      "Select Columns",
      "列を選択",
      "选择列",
      "Wählen Sie Spalten",
      "Sélectionner les colonnes",
      "Seleziona colonne",
      "Selecionar Colunas",
      "Seleccionar columnas",
      "Выбрать столбцы",
      "Wybierz kolumny",
      "select_columns"
    ],
    no_test_data: [
      "To create a test, press the plus button above",
      "To create a test, press the plus button above",
      "テストを作成するには上のプラスボタンを押します",
      "创建测试，请按上方的加号按钮",
      "Um einen Test zu erstellen, drücken Sie oben auf die Plus-Schaltfläche.",
      "Pour créer un test, appuyez sur le bouton Plus ci-dessus",
      "Per creare un test, premi il pulsante più qui sopra",
      "Para criar um teste, pressione o botão + acima",
      "Para crear una prueba, pulse el botón de arriba “más”",
      "Чтобы создать тест, нажмите на кнопку «плюс» выше",
      "Aby utworzyć test, naciśnij powyższy przycisk plus ",
      "no_test_data"
    ],
    no_job_data: [
      "To create a job, press the plus button above",
      "To create a job, press the plus button above",
      "ジョブを作成するには上のプラスボタンを押します",
      "创建作业，请按上方的加号按钮",
      "Um ein Projekt zu erstellen, drücken Sie oben auf die Plus-Schaltfläche.",
      "Pour créer une tâche, appuyez sur le bouton Plus ci-dessus",
      "Per creare un lavoro, premi il pulsante più qui sopra",
      "Para criar um trabalho, pressione o botão + acima",
      "Para crear un trabajo, pulse el botón de arriba “más”",
      "Чтобы создать задание, нажмите кнопку «плюс» выше",
      "Aby utworzyć zlecenie, naciśnij powyższy przycisk plus ",
      "no_job_data"
    ],
    no_customer_data: [
      "To create a customer, press the plus button above",
      "To create a customer, press the plus button above",
      "カスタマーを作成するには上のプラスボタンを押します",
      "创建客户，请按上方的加号按钮",
      "Um einen Kunden zu erstellen, drücken Sie oben auf die Plus-Schaltfläche.",
      "Pour créer un client, appuyez sur le bouton Plus ci-dessus",
      "Per creare un cliente, premi il pulsante più qui sopra",
      "Para criar um cliente, pressione o botão + acima",
      "Para crear un cliente, pulse el botón de arriba “más”",
      "Чтобы создать клиента, нажмите на кнопку «плюс» выше",
      "Aby utworzyć klienta, naciśnij powyższy przycisk plus ",
      "no_customer_data"
    ],
    no_devices_data: [
      "To create a device, press the plus button above",
      "To create a device, press the plus button above",
      "デバイスを作成するには上のプラスボタンを押します",
      "创建设备，请按上方的加号按钮",
      "Um ein Gerät zu erstellen, drücken Sie oben auf die Plus-Schaltfläche.",
      "Pour créer un appareil, appuyez sur le bouton Plus ci-dessus",
      "Per creare un dispositivo, premi il pulsante più qui sopra",
      "Para criar um dispositivo, pressione o botão + acima",
      "Para crear un dispositivo, presione el botón de arriba “más”",
      "Чтобы создать устройство, нажмите на кнопку «плюс» выше",
      "Aby utworzyć urządzenie, naciśnij powyższy przycisk plus ",
      "no_devices_data"
    ],
    no_users_data: [
      "To create a user, press the plus button above",
      "To create a user, press the plus button above",
      "ユーザーを作成するには上のプラスボタンを押します",
      "创建用户，请按上方的加号按钮",
      "Um einen Benutzer zu erstellen, drücken Sie oben auf die Plus-Schaltfläche.",
      "Pour créer un utilisateur, appuyez sur le bouton Plus ci-dessus",
      "Per creare un utente, premi il pulsante più qui sopra",
      "Para criar um usuário, pressione o botão + acima",
      "Para crear un usuario, presione el botón de arriba “más”",
      "Чтобы создать пользователя, нажмите на кнопку «плюс» выше",
      "Aby utworzyć użytkownika, naciśnij powyższy przycisk plus ",
      "no_users_data"
    ],
    no_reports_data: [
      "To create a report, go to the jobs and test details page",
      "To create a report, go to the jobs and test details page",
      "レポートを作成するにはジョブとテストの詳細ページに移動します",
      "创建报告，请转到作业和测试结果详情页面",
      "Um einen Bericht zu erstellen, gehen Sie auf die Seite mit den Angaben zu Projekten und Tests.",
      "Pour créer un rapport, rendez-vous sur la page de tâches et tests",
      "Per creare un rapporto, vai alla pagina dei dettagli di test e lavori",
      "Para criar um relatório, vá para as páginas de trabalhos e detalhes do teste",
      "Para crear un informe, vaya a la página de detalles de trabajos y pruebas",
      "Чтобы создать отчет, перейдите на страницу задания и сведений о тестировании",
      "Aby utworzyć raport, przejdź do strony ze szczegółami zleceń i testów",
      "no_reports_data"
    ],
    password_helper_text: [
      "Password should have at least 8 characters with one uppercase, one lower case and one numeric value",
      "Password should have at least 8 characters with one uppercase, one lower case and one numeric value",
      "パスワードは8文字以上で、少なくとも1個の大文字と1個の小文字、さらに1個の数字を含める必要があります",
      "密码必须至少为 8 个字符，并且包含 1 个大写字母、1 个小写字母和 1 个数字",
      "Passwort sollte aus mindestens 8 Zeichen bestehen, darunter ein Großbuchstabe, ein Kleinbuchstabe und eine Ziffer.",
      "Le mot de passe doit comporter au moins 8 caractères avec une majuscule, une minuscule et une valeur numérique",
      "La password deve essere di almeno 8 caratteri, con una lettera maiuscola, una lettera minuscola e un valore numerico",
      "A senha deve conter 8 caracteres, com pelo menos uma letra maiúscula, uma letra minúscula e um número",
      "La contraseña debe tener 8 caracteres con al menos una mayúscula, una minúscula y un valor numérico",
      "Пароль должен состоять минимум из 8 символов и содержать не менее одной строчной, одной прописной буквы и одного числового значения",
      "Hasło powinno mieć co najmniej 8 znaków, w tym jedną dużą literę, jedną małą literę i jedną wartość numeryczną",
      "password_helper_text"
    ],
    job_delete_failed_toast: [
      "Job can't be deleted",
      "Job can't be deleted",
      "ジョブを削除できません",
      "无法删除作业",
      "Projekt kann nicht gelöscht werden.",
      "La tâche ne peut pas être supprimée",
      "Impossibile eliminare il lavoro",
      "O trabalho não pode ser excluído",
      "No se puede eliminar el trabajo",
      "Невозможно удалить задание",
      "Nie można usunąć zlecenia",
      "job_delete_failed_toast"
    ],
    general_help: [
      "Help",
      "Help",
      "ヘルプ",
      "帮助",
      "Hilfe",
      "Aide",
      "Guida",
      "Ajuda",
      "Ayuda",
      "Справка",
      "Pomoc",
      "general_help"
    ],
    user_delete_permission_failure_toast: [
      "Don't have enough permission to delete the user",
      "Don't have enough permission to delete the user",
      "ユーザーを削除するための権限がありません",
      "无足够权限删除用户",
      "Berechtigungsstufe nicht ausreichend, um den Benutzer zu löschen.",
      "Permission insuffisante pour supprimer l’utilisateur",
      "Autorizzazione insufficiente per eliminare l’utente",
      "Não possui permissão suficiente para excluir o usuário",
      "No tiene permisos suficientes para eliminar al usuario",
      "Недостаточно прав для удаления пользователя",
      "Nie masz wystarczających uprawnień, aby usunąć użytkownika",
      "user_delete_permission_failure_toast"
    ],
    user_edit_permission_failure_toast: [
      "Don't have enough permission to edit the user",
      "Don't have enough permission to edit the user",
      "ユーザーを編集するための権限がありません",
      "无足够权限编辑用户",
      "Berechtigungsstufe nicht ausreichend, um den Benutzer zu bearbeiten.",
      "Permission insuffisante pour modifier l’utilisateur",
      "Autorizzazione insufficiente per modificare l’utente",
      "Não possui permissão suficiente para editar o usuário",
      "No tiene permisos suficientes para editar el usuario",
      "Недостаточно прав для редактирования пользователя",
      "Nie masz wystarczających uprawnień, aby edytować użytkownika",
      "user_edit_permission_failure_toast"
    ],
    user_disable_permission_failure_toast: [
      "Don't have enough permission to disable the user",
      "Don't have enough permission to disable the user",
      "ユーザーを無効化するための権限がありません",
      "无足够权限禁用用户",
      "Berechtigungsstufe nicht ausreichend, um den Benutzer zu deaktivieren.",
      "Permission insuffisante pour désactiver l’utilisateur",
      "Autorizzazione insufficiente per disabilitare l’utente",
      "Não possui permissão suficiente para desabilitar o usuário",
      "No tiene permisos suficientes para deshabilitar al usuario",
      "Недостаточно прав для отключения пользователя",
      "Nie masz wystarczających uprawnień, aby wyłączyć użytkownika",
      "user_disable_permission_failure_toast"
    ],
    general_show_all_rows: [
      "Show All Rows",
      "Show All Rows",
      "すべての行を表示",
      "显示所有行",
      "Alle Zeilen anzeigen",
      "Afficher toutes les rangées",
      "Mostra tutte le righe",
      "Mostrar Todas as Linhas",
      "Mostrar todas las filas",
      "Показать все строки",
      "Pokaż wszystkie rzędy",
      "general_show_all_rows"
    ],
    job_disablesync: [
      "Disable Sync",
      "Disable Sync",
      "同期を無効化",
      "禁用同步",
      "Sync deaktivieren",
      "Désactiver la synchronisation",
      "Disabilita sincronizzazione",
      "Desabilitar Sincronização",
      "Deshabilitar sincronización",
      "Отключить синхронизацию",
      "Wyłącz synchronizację",
      "job_disablesync"
    ],
    device_resetpin_request: [
      "Select CONFIRM to reset the device PIN. Once complete, on the device select Settings > System > Check for PIN reset.",
      "Select CONFIRM to reset the device PIN. Once complete, on the device select Settings > System > Check for PIN reset.",
      "「確定」を選択してデバイスのPINをリセットします。完了後、デバイスで「設定」>「システム」>「PINリセットの確認」の順に選択してください。",
      "选择“确认”以重置设备密码。完成后，在设备上选择“设置”>“系统”>“检查密码重置”。",
      "Wählen Sie BESTÄTIGEN, um die Geräte-PIN zurückzusetzen. Wählen Sie nach dem Vorgang auf dem Gerät Einstellungen > System > Auf PIN-Zurücksetzung prüfen.",
      "Sélectionnez CONFIRMER pour réinitialiser le PIN de l'appareil. Une fois l'opération terminée, sélectionnez Paramètres > Système > Vérifier la réinitialisation du PIN sur l'appareil.",
      "Seleziona CONFERMA per reimpostare il PIN del dispositivo. Una volta completato, sul dispositivo seleziona Impostazioni > Sistema > Verifica reimpostazione PIN.",
      "Selecione CONFIRMAR para redefinir o PIN do dispositivo. Assim que concluir, no dispositivo selecione Definições > Sistema > Verificar redefinição de PIN.",
      "Seleccione CONFIRMAR para restablecer el PIN del dispositivo. Una vez completado, en el dispositivo seleccione Ajustes > Sistema > Comprobar restablecimiento de PIN.",
      "Выберите ПОДТВЕРДИТЬ, чтобы сбросить PIN-код устройства. После завершения выберите на устройстве Настройки > Система > Проверить сброс PIN-кода.",
      "Wybierz POTWIERDŹ, aby zresetować kod PIN urządzenia. Po zakończeniu wybierz na urządzeniu Ustawienia > System > Sprawdź resetowanie kodu PIN.",
      "device_resetpin_request"
    ],
    test_maximum_allowed_range: [
      "Maximum 2000 tests can be added at a time",
      "Maximum 2000 tests can be added at a time",
      "一度に最大2000個のテストを追加できます",
      "一次最多可以添加 2000 个测试",
      "Es können maximal 2000 Tests auf einmal hinzugefügt werden.",
      "Vous pouvez ajouter un maximum de 2 000 tests à la fois",
      "È possibile aggiungere un massimo di 2000 test alla volta",
      "No máximo 2000 testes podem ser adicionados por vez",
      "Se pueden añadir un máximo de 2000 pruebas a la vez",
      "Допускается одновременное добавление не более 2000 тестов",
      "Jednorazowo można dodać maksymalnie 2000 testów",
      "test_maximum_allowed_range"
    ],
    test_maximum_15_digits_allowed: [
      "Maximum 15 consecutive digits allowed",
      "Maximum 15 consecutive digits allowed",
      "最大15桁の連続した数字が許可されます",
      "最多允许输入15个连续数字",
      "Maximal 15 aufeinanderfolgende Ziffern erlaubt",
      "Maximum de 15 chiffres consécutifs autorisés",
      "Massimo 15 cifre consecutive consentite",
      "Máximo de 15 dígitos consecutivos permitidos",
      "Máximo de 15 dígitos consecutivos permitidos",
      "Разрешено не более 15 подряд идущих цифр",
      "Maksymalnie 15 kolejnych cyfr dozwolonych",
      "test_maximum_15_digits_allowed"
    ],
    tooltip_reload_tests: [
      "Reload Tests",
      "Reload Tests",
      "テストを再読み込み",
      "重新加载测试",
      "Tests erneut laden",
      "Recharger les tests",
      "Ricarica test",
      "Recarregar Testes",
      "Volver a cargar las pruebas",
      "Перезагрузить тесты",
      "Ponownie załaduj testy",
      "tooltip_reload_tests"
    ],
    default_user_role_degradation_not_allowed: [
      "Cannot edit role for default user",
      "Cannot edit role for default user",
      "デフォルトユーザーのロールを編集できません",
      "无法编辑默认用户的角色",
      "Funktion kann für Standardbenutzer nicht bearbeitet werden.",
      "Impossible de modifier la fonction pour un utilisateur par défaut",
      "Impossibile modificare il ruolo dell’utente predefinito",
      "Não é possível editar a função do usuário padrão",
      "No se puede editar el rol para los usuarios predeterminados",
      "Невозможно изменить роль для пользователя по умолчанию",
      "Nie można edytować roli dla domyślnego użytkownika",
      "default_user_role_degradation_not_allowed"
    ],
    logo_helper_text: [
      "Following characters are not allowed in Logo name",
      "Following characters are not allowed in Logo name",
      "ロゴ名に次の文字を使用することはできません",
      "Logo名称不可使用以下字符",
      "Die folgenden Zeichen sind im Logo-Namen nicht zulässig:",
      "Les caractères suivants ne sont pas autorisés dans le logo",
      "I seguenti caratteri non sono consentiti nel nome del logo",
      "Os seguintes caracteres não são permitidos no nome do logotipo",
      "Los siguientes caracteres no están permitidos en el nombre del logotipo",
      "Следующие символы недопустимы в названии логотипа",
      "Następujące znaki nie są dozwolone w nazwie logo",
      "logo_helper_text"
    ],
    report_delete_successfull_toast: [
      "Report successfully deleted.",
      "Report successfully deleted.",
      "レポートが正常に削除されました。",
      "已成功删除报告。",
      "Bericht erfolgreich gelöscht.",
      "Rapport supprimé avec succès.",
      "Rapporto eliminato correttamente.",
      "Relatório excluído com sucesso.",
      "Informe borrado con éxito.",
      "Отчет успешно удален.",
      "Usunięcie raportu powiodło się.",
      "report_delete_successfull_toast"
    ],
    report_delete_unsuccessfull_toast: [
      "Failed to delete the report",
      "Failed to delete the report",
      "レポートを削除できませんでした",
      "无法删除报告",
      "Löschen des Berichts fehlgeschlagen",
      "Échec de la suppression du rapport",
      "Eliminazione del rapporto non riuscita",
      "Falha ao excluir o relatório",
      "No se pudo borrar el informe",
      "Не удалось удалить отчет",
      "Usunięcie raportu nie powiodło się",
      "report_delete_unsuccessfull_toast"
    ],
    report_delete_confirm_title: [
      "Delete Report",
      "Delete Report",
      "レポートを削除",
      "删除报告",
      "Bericht löschen",
      "Supprimer le rapport",
      "Elimina rapporto",
      "Excluir Relatório",
      "Borrar informe",
      "Удалить отчет",
      "Usuń raport",
      "report_delete_confirm_title"
    ],
    report_delete_confirm_text: [
      "Are you sure you want to delete the report <b>${name}</b>?",
      "Are you sure you want to delete the report <b>${name}</b>?",
      "レポート「<b>${name}</b>」を削除してもよろしいですか?",
      "您是否确定要删除报告<b>${name}</b>？",
      "Sind Sie sicher, dass Sie den Bericht <b>${name}</b> löschen möchten?",
      "Voulez-vous vraiment supprimer le rapport <b>${name}</b> ?",
      "Eliminare il rapporto <b>${name}</b>?",
      "Você tem certeza de que deseja excluir o relatório <b>${name}</b>?",
      "¿Seguro que quiere borrar el informe <b>${name}</b>?",
      "Действительно удалить отчет <b>${name}</b>?",
      "Czy na pewno chcesz usunąć raport <b>${name}</b>?",
      "report_delete_confirm_text"
    ],
    password_reset_invalid_toast: [
      "Password is invalid",
      "Password is invalid",
      "パスワードが無効です",
      "密码无效",
      "Passwort ist ungültig.",
      "Mot de passe invalide ",
      "La password non è valida",
      "Senha inválida",
      "La contraseña no es válida",
      "Неверный пароль R",
      "Nieprawidłowe hasło",
      "password_reset_invalid_toast"
    ],
    report_generate_help: [
      "We are still processing all the images needed to create your reports for these tests. This can take a little time to complete. Please try again later.",
      "We are still processing all the images needed to create your reports for these tests. This can take a little time to complete. Please try again later.",
      "これらのテストレポートを作成するために必要なすべての画像をまだ処理しています。完了するまでもう少し時間がかかります。後でもう一度試みてください。",
      "我们仍在处理创建您的这些测试报告所需的全部图片。可能会需要一些时间才能完成。请稍后重试。",
      "Wir bearbeiten derzeit noch alle Bilder, die benötigt werden, um Ihren Bericht für diese Tests zu erstellen. Dies kann eine Weile dauern. Bitte versuchen Sie es später noch einmal.",
      "Nous traitons actuellement les informations pour créer les rapports pour ces tests. Ce processus peut prendre un peu de temps. Veuillez réessayer plus tard.",
      "Stiamo ancora elaborando tutte le immagini necessarie per creare i rapporti per questi test. Il completamento dell’operazione potrebbe richiedere qualche istante. Riprova più tardi.",
      "Ainda estamos processando todas as imagens necessárias para criar seus relatórios para esses testes. Isso pode levar algum tempo para ser concluído. Tente novamente mais tarde.",
      "Todavía estamos procesando todas las imágenes necesarias para crear sus informes para estas pruebas. Esta acción puede tardar un tiempo en completarse. Inténtelo más tarde.",
      "Мы все еще обрабатываем все изображения, необходимые для создания отчетов для этих тестов. Для завершения может потребоваться некоторое время. Повторите попытку позже.",
      "Nadal przetwarzamy wszystkie obrazy potrzebne do stworzenia raportów dla tych testów. Może to zająć trochę czasu. Spróbuj ponownie później.",
      "report_generate_help"
    ],
    report_generate_empty: [
      "For the tests without result files, Report can not be generated. Please update your selection",
      "For the tests without result files, Report can not be generated. Please update your selection",
      "結果ファイルのないテストの場合、レポートを生成できません。 選択を更新してください",
      "没有数据的测试结果不能生成测试报告。请重新选取测试数据",
      "Für die Tests ohne Ergebnisdateien kann kein Bericht erstellt werden. Bitte aktualisieren Sie Ihre Auswahl",
      "Pour les tests sans fichiers de résultats, le rapport ne peut pas être généré. Veuillez mettre à jour votre sélection",
      "Per i test senza file di risultati, il rapporto non può essere generato. Si prega di aggiornare la selezione",
      "Não é possível gerar relatórios para testes que não possuem arquivos de resultado. Por favor, atualize sua escolha",
      "No se pueden generar Reportes con Pruebas sin archivos de Prueba. Por favor modifique su selección",
      "Для тестов без файлов результата отчет не может быть сгенерирован. Пожалуйста, обновите свой выбор",
      "W przypadku testów bez plików z wynikami, nie można wygenerować raportu. Zaktualizuj swój wybór",
      "report_generate_empty"
    ],
    report_generate_failed_help: [
      "Image generation failed for these tests. Please re-generate them",
      "Image generation failed for these tests. Please re-generate them",
      "これらのテストの画像生成に失敗しました。画像を再生成してください",
      "这些测试的图片生成失败。请重新生成",
      "Bilderstellung für diese Tests fehlgeschlagen. Bitte neu erstellen.",
      "Les données n’ont pas pu être générées pour ces tests. Veuillez les générer à nouveau",
      "Generazione dell’immagine non riuscita per questi test. Genera di nuovo",
      "A geração da imagem destes testes falhou. Tente gera-las novamente",
      "Error al generar imágenes para estas pruebas. Intente generarlas de nuevo",
      "Не удалось сгенерировать изображения для этих тестов. Пожалуйста, сгенерируйте их заново",
      "Generowanie obrazu dla tych testów nie powiodło się. Wygeneruj je ponownie",
      "report_generate_failed_help"
    ],
    tooltip_reload: [
      "Reload",
      "Reload",
      "再読み込み",
      "重新加载",
      "Erneut laden",
      "Recharger",
      "Ricarica",
      "Recarregar",
      "Volver a cargar",
      "Перезагрузить",
      "Ponownie załaduj",
      "tooltip_reload"
    ],
    uploaded_tests_status: [
      "Tests Processed out of",
      "Tests Processed out of",
      "個のテストを処理済み。総数: ",
      "已处理的测试总数",
      "Tests verarbeitet von",
      "tests traités sur",
      "Test elaborati su",
      "Testes processados de",
      "Pruebas procesadas de",
      "Обработаны тесты из",
      "Przetworzone testy z",
      "uploaded_tests_status"
    ],
    uploaded_tests_process_total_status: [
      "Uploaded",
      "Uploaded",
      "アップロードしました",
      "已上传",
      "Hochgeladen",
      "Téléchargé",
      "Caricati",
      "Carregados",
      "Cargado",
      "Загружено",
      "Przesłane",
      "uploaded_tests_process_total_status"
    ],
    uploaded_tests_process_failed_status: [
      "Process Failed",
      "Process Failed",
      "処理に失敗しました",
      "进程未通过",
      "Prozess fehlgeschlagen",
      "Le processus a échoué",
      "Processo non riuscito",
      "Processar Reprovados",
      "El proceso ha fallado",
      "Сбой процесса",
      "Proces nie powiódł się",
      "uploaded_tests_process_failed_status"
    ],
    uploaded_tests_process_passed_status: [
      "Process Passed",
      "Process Passed",
      "処理に成功しました",
      "进程已通过",
      "Prozess erfolgreich",
      "Le processus a fonctionné",
      "Processo superato",
      "Processar Aprovados",
      "El proceso ha funcionado",
      "Процесс пройден",
      "Proces powiódł się",
      "uploaded_tests_process_passed_status"
    ],
    test_create_invalid_identifier: [
      "The field must be a string or array type with a maximum length of '12'.",
      "The field must be a string or array type with a maximum length of '12'.",
      "フィールドは、最大の長さが12の文字列型または配列型でなければなりません。",
      "该字段必须为字符串或阵列类型，且最大长度为“12”。",
      "Der String oder die Datengruppe in diesem Feld darf eine Maximallänge von „12“ haben.",
      "Le champ doit avoir une longueur maximal de « 12 ».",
      "Il campo deve essere tipo stringa o matrice con lunghezza massima pari a “12”.",
      "O campo deve ser de tipo texto ou matriz com um comprimento máximo de '12'.",
      "El campo debe ser de tipo cadena o matriz con una longitud máxima de “12”.",
      "Поле должно иметь тип строки или массива с максимальной длиной «12».",
      "Pole musi być ciągiem lub tablicą o maksymalnej długości ‘12’.",
      "test_create_invalid_identifier"
    ],
    result_cablemanufacturer: [
      "LanTEKIII Cable Manufacturer",
      "LanTEKIII Cable Manufacturer",
      "LanTEKIII ケーブルのメーカー",
      "LanTEKIII 线缆制造商",
      "LanTEKIII-Kabelhersteller",
      "Fabricant du câble dans le LanTEK III",
      "Produttore di cavi LanTEKIII",
      "Lantek III - Fabricante do Cabo",
      "Lantek III - Fabricante del cable",
      "Производитель кабеля LanTEKIII",
      "Producent okablowania LanTEKIII ",
      "result_cablemanufacturer"
    ],
    result_loading: [
      "loading",
      "loading",
      "読み込み中",
      "正在加载",
      "lädt",
      "chargement",
      "caricamento in corso…",
      "carregando",
      "cargando",
      "загрузка",
      "Ładowanie",
      "result_loading"
    ],
    idc_beta_trial_version: [
      "Beta Trial version",
      "Beta Trial version",
      "ベータ試用版",
      "测试版",
      "Beta-Testversion",
      "Version d’essai bêta",
      "Versione beta di valutazione",
      "Versão Beta de teste",
      "Versión beta de prueba",
      "Пробная бета-версия",
      "Wersja próbna beta",
      "idc_beta_trial_version"
    ],
    send_report: [
      "Send Report",
      "Send Report",
      "レポートを送信",
      "发送报告",
      "Bericht senden",
      "Envoyer le rapport",
      "Invia rapporto",
      "Enviar Relatório",
      "Enviar informe",
      "Отправить отчет",
      "Prześlij raport",
      "send_report"
    ],
    delete_report: [
      "Delete Report",
      "Delete Report",
      "レポートを削除",
      "删除报告",
      "Bericht löschen",
      "Supprimer le rapport",
      "Elimina rapporto",
      "Excluir Relatório",
      "Borrar informe",
      "Удалить отчет",
      "Usuń raport",
      "delete_report"
    ],
    report_stolen_device: [
      "Report Stolen Device",
      "Report Stolen Device",
      "盗難されたデバイスをレポート",
      "报告被盗设备",
      "Gestohlenes Gerät melden",
      "Signaler un appareil volé",
      "Segnala il furto di un dispositivo",
      "Reportar Dispositivo Furtado",
      "Informar de un dispositivo robado",
      "Сообщить о краже устройства",
      "Zgłoś skradzione urządzenie",
      "report_stolen_device"
    ],
    unlock_device: [
      "Unlock Device",
      "Unlock Device",
      "デバイスをロック解除",
      "解锁设备",
      "Gerät entsperren",
      "Déverrouiller l’appareil",
      "Sblocca dispositivo",
      "Desbloquear Dispositivo",
      "Desbloquear dispositivo",
      "Разблокировать устройство",
      "Odblokuj urządzenie",
      "unlock_device"
    ],
    lock_device: [
      "Lock Device",
      "Lock Device",
      "デバイスをロック",
      "锁定设备",
      "Gerät sperren",
      "Verrouiller l’appareil",
      "Blocca dispositivo",
      "Bloquear Dispositivo",
      "Bloquear dispositivo",
      "Заблокировать устройство",
      "Zablokuj urządzenie",
      "lock_device"
    ],
    tooltip_reload_reports: [
      "Reload Reports",
      "Reload Reports",
      "レポートを再読み込み",
      "重新加载报告",
      "Berichte neu laden",
      "Recharger les rapports",
      "Ricarica rapporti",
      "Recarregar Relatórios",
      "Volver a cargar informes",
      "Перезагрузить отчеты",
      "Ponownie załaduj raporty",
      "tooltip_reload_reports"
    ],
    job_notes_maxCharacter_help: [
      "( Maximum 1500 Characters Allowed )",
      "( Maximum 1500 Characters Allowed )",
      "(最大1500文字まで許可)",
      "（最多允许 1500 个字符）",
      "(Maximal 1.500 Zeichen erlaubt)",
      "(Limite de 1 500 caractères autorisée)",
      "(Massimo 1500 caratteri consentiti)",
      "(máximo 1.500 caracteres permitidos)",
      "(Máximo de 1500 caracteres permitidos)",
      "( Максимум 1500 символов )",
      "(Dozwolone maksymalnie 1500 znaków)",
      "job_notes_maxCharacter_help"
    ],
    formfield_error_jobnotes_length: [
      "Job Notes length should not be more than 1500 characters",
      "Job Notes length should not be more than 1500 characters",
      "ジョブのメモの長さは、1500文字を越えてはいけません",
      "作业说明长度不应超过 1500 个字符",
      "Länge der Projekt-Kommentare sollte nicht mehr als 1.500 Zeichen betragen.",
      "Les notes de tâches ne doivent pas excéder 1 500 caractères",
      "La lunghezza delle note del lavoro non deve superare i 1500 caratteri",
      "O campo Notas do Trabalho não pode ultrapassar 1.500 caracteres",
      "La longitud de las notas de trabajos no debe superar los 1500 caracteres",
      "Длина примечаний к заданию не должна превышать 1500 символов",
      "Długość notatek dot. zlecenia nie powinny przekraczać 1500 znaków",
      "formfield_error_jobnotes_length"
    ],
    header_terms_condition: [
      "Terms & Conditions",
      "Terms & Conditions",
      "利用規定",
      "条款与条件",
      "Allgemeine Geschäftsbedingungen",
      "Conditions générales",
      "Termini e condizioni",
      "Termos e Condições",
      "Términos y condiciones",
      "Условия и положения",
      "Zasady i warunki",
      "header_terms_condition"
    ],
    customer_delete_fail_toast: [
      "Failed to delete the customer",
      "Failed to delete the customer",
      "カスタマーを削除できませんでした",
      "无法删除该客户",
      "Löschung des Kunden fehlgeschlagen",
      "Échec de la suppression du client",
      "Eliminazione del cliente non riuscita",
      "Falha ao excluir o cliente",
      "No se ha podido eliminar al cliente",
      "Не удалось удалить клиента",
      "Usunięcie klienta nie powiodło się",
      "customer_delete_fail_toast"
    ],
    org_delete_fail_toast: [
      "Failed to delete the organisation",
      "Failed to delete the organisation",
      "組織を削除できませんでした",
      "无法删除该组织",
      "Löschung der Firma fehlgeschlagen",
      "Échec de la suppression de l’organisation",
      "Eliminazione dell’organizzazione non riuscita",
      "Falha ao excluir a organização",
      "No se ha podido eliminar la organización",
      "Не удалось удалить организацию",
      "Usunięcie organizacji nie powiodło się",
      "org_delete_fail_toast"
    ],
    tooltip_download_csv: [
      "Print label CSV",
      "Print label CSV",
      "ラベルを印刷 (CSV)",
      "打印标签 CSV",
      "Etikett drucken CSV",
      "Imprimer l'étiquette CSV",
      "Stampa etichetta CSV",
      "CSV de etiquetas de impressão",
      "Etiqueta de impresión CSV",
      "Распечатать этикетку CSV",
      "Wydrukuj etykietę CSV",
      "tooltip_download_csv"
    ],
    general_na: [
      "n/a",
      "n/a",
      "n/a",
      "n/a",
      "n/a",
      "n/a",
      "n/a",
      "n/d",
      "n/a",
      "n/a",
      "nie dotyczy",
      "general_na"
    ],
    general_limit: [
      "Limit",
      "Limit",
      "Limit",
      "极限值",
      "Limit",
      "Limite",
      "Limite",
      "Limite",
      "Límite",
      "Предел",
      "Limit",
      "general_limit"
    ],
    general_pairs: [
      "Pairs",
      "Pairs",
      "ペア",
      "线对",
      "Paare",
      "Paires",
      "Coppie",
      "Pares",
      "Pares",
      "Пары",
      "Pary",
      "general_pairs"
    ],
    general_values: [
      "Values",
      "Values",
      "値",
      "测试值",
      "Werte",
      "Valeurs",
      "Valori",
      "Valores",
      "Valores",
      "Значения",
      "Wartości",
      "general_values"
    ],
    regenerate_image: [
      "Re-Generate Image",
      "Re-Generate Image",
      "画像を再生成",
      "重新生成图片",
      "Bild erneut erstellen",
      "Générer à nouveau l’image",
      "Rigenera immagine",
      "Regenerar imagem",
      "Volver a generar imagen",
      "Восстановить изображение",
      "Wygeneruj ponownie",
      "regenerate_image"
    ],
    image_regeneration_inprogress_help_text: [
      "Failed image re-generation is in progress.Please Wait",
      "Failed image re-generation is in progress.Please Wait",
      "失敗になった画像の生成を再び行っています。お待ちください",
      "未生成的图片正在重新生成。请稍候",
      "Neuerstellung des fehlgeschlagenen Bildes läuft. Bitte warten.",
      "Génération de l’image en cours. Veuillez patienter",
      "Rigenerazione dell’immagine non riuscita in corso. Attendi",
      "A regeneração da imagem está em andamento. Por favor, aguarde",
      "Se está volviendo a generar la imagen errónea. Espere.",
      "Идет повторное создание изображения. Пожалуйста, подождите",
      "Trwa ponowne generowanie obrazu. Proszę czekać",
      "image_regeneration_inprogress_help_text"
    ],
    no_job_data_lt3: [
      "To add a job, click the above upload button",
      "To add a job, click the above upload button",
      "ジョブを追加するには、上のアップロードボタンをクリックします",
      "如需添加作业，请点击上方的上传按钮",
      "Um ein Projekt hinzuzufügen, klicken Sie oben auf die Schaltfläche „Upload“.",
      "Pour ajouter une tâche, cliquez sur le bouton de téléchargement ci-dessus",
      "Per aggiungere un lavoro, fai clic sul pulsante di caricamento qui sopra",
      "Para incluir um trabalho, clique no botão carregar acima",
      "Para añadir un trabajo, haga clic en el botón de carga situado arriba",
      "Чтобы добавить задание, нажмите кнопку загрузки выше ",
      "Aby dodać zlecenie, kliknij powyższy przycisk przesyłania (upload)",
      "no_job_data_lt3"
    ],
    administration: [
      "ADMINISTRATION",
      "ADMINISTRATION",
      "管理",
      "管理",
      "ADMINISTRATION",
      "ADMINISTRATION",
      "AMMINISTRAZIONE",
      "ADMINISTRAÇÃO",
      "ADMINISTRACIÓN",
      "АДМИНИСТРИРОВАНИЕ",
      "ADMINISTRACJA",
      "administration"
    ],
    jobs_upload_lantek_files_concurrency_exception: [
      "The record you are working on has been modified by another user.",
      "The record you are working on has been modified by another user.",
      "作業中のレコードは、他のユーザーによって変更が加えられました。",
      "您正在处理的记录已被另一用户修改。",
      "Der Datensatz, den Sie erstellt haben, wurde von einem anderen Benutzer geändert.",
      "L’enregistrement sur lequel vous travaillez a été modifié par un autre utilisateur.",
      "Il record a cui stai lavorando è stato modificato da un altro utente.",
      "O registro no qual você está trabalhando foi modificado por outro usuário.",
      "El registro en el que está trabajando ha sido modificado por otro usuario.",
      "Запись, над которой вы работаете, была изменена другим пользователем.",
      "Zapis, nad którym pracujesz, został zmodyfikowany przez innego użytkownika.",
      "jobs_upload_lantek_files_concurrency_exception"
    ],
    job_header_selected: [
      "Selected",
      "Selected",
      "選択済み",
      "已选择",
      "Ausgewählt",
      "Sélectionné",
      "Selezionati",
      "Selecionado",
      "Seleccionado",
      "Выбранный",
      "Wybrano",
      "job_header_selected"
    ],
    jobs_upload_lantek_files_large_filesize_unsuccessfull_toast: [
      "Upload files size exceeds 250 MB , File will not be uploaded !",
      "Upload files size exceeds 250 MB , File will not be uploaded !",
      "アップロードのファイルサイズが250 MBを越えています。ファイルはアップロードされません。",
      "待上传数据超过250MB，文件将不会被上传！@",
      "Datei wird nicht hochgeladen, überschreitet die 250 MB Grenze !",
      "Taille fichiers dépasse 250MB. Mise à jour impossible !",
      "La dimensione dei file di caricamento supera i 250 MB, il file non viene caricato !",
      "O tamanho do arquivo excede 250 MB, e ele não será carregado!",
      "Archivo supera 250MB, no puede ser transferido !",
      "Загрузка файлов размер превышает 250 МБ , файл не будет загружен !",
      "Rozmiar przesyłanych plików przekracza 250 MB, plik nie zostanie przesłany!",
      "jobs_upload_lantek_files_large_filesize_unsuccessfull_toast"
    ],
    impedence_min: [
      "Min",
      "Min",
      "最小",
      "最小值",
      "Min",
      "Min",
      "Min",
      "Mín",
      "Min",
      "Мин",
      "Min.",
      "impedence_min"
    ],
    impedence_max: [
      "Max",
      "Max",
      "最大",
      "最大值",
      "Max",
      "Max",
      "Max",
      "Máx",
      "Max",
      "Макс",
      "Maks.",
      "impedence_max"
    ],
    no_fiberpower_meter_data: [
      "Sorry, No Data",
      "Sorry, No Data",
      "申し訳ありません。データがありません",
      "抱歉，没有相应数据",
      "Entschuldigung , keine Daten",
      "Pas de données",
      "Spiacenti nessun dato",
      "Desculpe, sem dados",
      "Lo siento, sin datos",
      "К сожалению нет данных",
      "Przepraszamy, brak danych",
      "no_fiberpower_meter_data"
    ],
    settings_lt4copper_limitsdb_title: [
      "LT4 COPPER LIMITS DB UPLOAD",
      "LT4 COPPER LIMITS DB UPLOAD",
      "LanTEK IV (銅線) 制限DBのアップロード",
      "LanTEK IV铜缆极限值上传",
      "LT4 KUPFER LIMITS DB HOCHLADEN",
      "LT4 KUPFER LIMITS DB HOCHLADEN",
      "LT4 Limiti di rame Caricamento DB",
      "CARREGAR BD DE LIMITES DE COBRE DO LT4",
      "CARGA LIMITES LT4 COBRE DB",
      "LT4 медь пределы DB загрузить",
      "LT4 LIMITY MIEDZI DB PRZESYŁANIE",
      "settings_lt4copper_limitsdb_title"
    ],
    settings_lt4adapter_policydb_title: [
          "LanTEK IV Adapter Policy Database",
          "LanTEK IV Adapter Policy Database",
          "LanTEK IV アダプターポリシーデータベース",
          "LanTEK IV 适配器策略数据库",
          "LanTEK IV-Adapterrichtliniendatenbank",
          "Base de données des politiques d’adaptateurs LanTEK IV",
          "Database criteri adattatori LanTEK IV",
          "Base de dados de políticas de adaptadores LanTEK IV",
          "Base de datos de políticas de adaptadores LanTEK IV",
          "База данных политик адаптеров LanTEK IV",
          "Baza danych zasad adapterów LanTEK IV",
          "settings_lt4adapter_policydb_title"
    ],
    test_cable_model: [
      "Cable Type",
      "Cable Type",
      "ケーブルのタイプ",
      "线缆类型",
      "Kabeltyp",
      "Type de câble",
      "Tipo di cavo",
      "Tipo de Cabo",
      "Tipo de cable",
      "Тип кабеля",
      "Typ okablowania",
      "test_cable_model"
    ],
    test_cable_model_help: [
      "Cable Type",
      "Cable Type",
      "ケーブルのタイプ",
      "线缆类型",
      "Kabeltyp",
      "Type de câble",
      "Tipo di cavo",
      "Tipo de Cabo",
      "Tipo de cable",
      "Тип кабеля",
      "Typ okablowania",
      "test_cable_model_help"
    ],
    uploaded_tests_pending_process_count: [
      "PENDING PROCESSING",
      "PENDING PROCESSING",
      "保留処理中",
      "进程中",
      "ANHÄNGIGE VERARBEITUNG ",
      "TRAITEMENT EN ATTENTE",
      "ELABORAZIONE IN ATTESA",
      "PROCESSAMENTO PENDENTE",
      "PRECESAMIENTO PENDIENTE",
      "отложенная обработка",
      "W oczekiwaniu na przetwarzanie",
      "uploaded_tests_pending_process_count"
    ],
    no_lt3_test_data: [
      "To create a test, upload the test from jobs page.",
      "To create a test, upload the test from jobs page.",
      "テストを作成するには、ジョブページからテストをアップロードしてください。",
      "要创建一个测试，请从作业页面上传测试数据。",
      "Laden Sie den Test von der Jobseite hoch, um einen Test zu erstellen.",
      "Pour créer un test, téléchargez le test à partir de la page des travaux.",
      "Per creare un test, caricare il test dalla pagina processi",
      "Para criar um teste, carregue-o a partir da página de trabalhos",
      "Para crear una Prueba, carguela desde la página de Trabajos.",
      "Чтобы создать тест, загрузите тест со страницы заданий",
      "Aby utworzyć test, prześlij go ze strony ze zleceniami.",
      "no_lt3_test_data"
    ],
    devices_licenses: [
      "DEVICE LICENSES",
      "DEVICE LICENSES",
      "デバイスのライセンス",
      "设备许可证书",
      "GERÄTE LIZENZEN",
      "LICENCES DE L’APPAREIL",
      "LICENZE PER DISPOSITIVI",
      "LICENÇAS DO DISPOSITIVO",
      "LICENCIAS DEL EQUIPO",
      "лицензии на устройства",
      "LICENCJE URZĄDZENIA",
      "devices_licenses"
    ],
    "10_g": [
      "10G",
      "10G",
      "10G",
      "10G",
      "10G",
      "10G",
      "10G",
      "10G",
      "10G",
      "10G",
      "10G",
      "10_g"
    ],
    comet_copper: [
      "LanTEK-IV Twisted Pair",
      "LanTEK-IV Twisted Pair",
      "LanTEK-IV ツイストペア",
      "LanTEK-IV 双绞线",
      "LanTEK-IV Twisted Pair",
      "LanTEK IV Paires torsadées",
      "LanTEK IV Doppino intrecciato",
      "LanTEK-IV Par trançado",
      "LanTEK-IV Par trenzado",
      "LanTEK-IV Витая параr",
      "LanTEK-IV Skrętka",
      "comet_copper"
    ],
    comet_fiber: [
      "LanTEK IV-Fiber",
      "LanTEK IV-Fiber",
      "LanTEK IV-Fiber",
      "LanTEK IV-纤维",
      "LanTEK IV-Faser",
      "LanTEK IV Fiber",
      "LanTEK IV-Fibra",
      "LanTEK IV-Fibra",
      "LanTEK IV-Fibra",
      "LanTEK IV-волокно",
      "LanTEK IV-Włókno",
      "comet_fiber"
    ],
    general_intra_pair: [
      "Intra-Pair",
      "Intra-Pair",
      "ペア内",
      "线对内",
      "Intra-Paar",
      "Entre paires",
      "Intra-Paio",
      "Intra-Par",
      "Intra-Par",
      "Intra-Пара",
      "Wewnątrz pary",
      "general_intra_pair"
    ],
    general_pair_to_pair: [
      "Pair-Pair",
      "Pair-Pair",
      "ペア間",
      "线对间",
      "Paar-Paar",
      "Paire à paire",
      "Paio-Paio",
      "Par-Par",
      "Par-Par",
      "Пара-Пара",
      "Para-para",
      "general_pair_to_pair"
    ],
    general_pass_fail_header: [
      "Pass/Fail",
      "Pass/Fail",
      "成功/失敗",
      "通过/失败",
      "Bestanden/Fehler",
      "Passe/Echec",
      "Passare/non superare",
      "Aprovado/Reprovado",
      "Pasa/Falla",
      "Пройти/Не",
      "Zaliczone/Nie zaliczone",
      "general_pass_fail_header"
    ],
    limitmethodtypename: [
      "Limit Method Type Name",
      "Limit Method Type Name",
      "制限方法タイプの名前",
      "限制方法类型名称",
      "Bregenzungsmethode Typname",
      "Nom du type de méthode des limites",
      "Limita nome tipo di metodo",
      "Nome de tipo de método de limite",
      "Tipo Nombre Método límite",
      "Имя типа метода ограничения",
      "Limit Metoda Typ Nazwa",
      "limitmethodtypename"
    ],
    test_types: [
      "Test Types",
      "Test Types",
      "テストタイプ",
      "测试类型",
      "Testtypen",
      "Types de test",
      "Testa tipi",
      "Tipos de teste",
      "Tipos de prueba",
      "Типы тестов",
      "Typy testów",
      "test_types"
    ],
    create_comet_fiber: [
      "FiberTEK IV MM/SM",
      "FiberTEK IV MM/SM",
      "FiberTEK IV MM/SM",
      "FiberTEK IV MM/SM",
      "FiberTEK IV MM/SM",
      "FiberTEK IV Multimode/Monomode",
      "FiberTEK IV MM/SM",
      "FiberTEK IV MM/SM",
      "FiberTEK IV MM/SM",
      "FiberTEK IV (для многомодовых/одномодовых кабелей)",
      "FiberTEK IV MM/SM",
      "create_comet_fiber"
    ],
    test_settings: [
      "Test Settings",
      "Test Settings",
      "テストの設定",
      "测试设置",
      "Testeinstellungen",
      "Paramètres du test",
      "Impostazioni test",
      "Definições do teste",
      "Ajustes de prueba",
      "Настройки теста",
      "Ustawienia testu",
      "test_settings"
    ],
    test_budget_loss: [
      "Budget Loss",
      "Budget Loss",
      "バジェット損失",
      "预算损失",
      "Budgetverlust",
      "Perte de budget",
      "Perdita budget",
      "Provisão de Perda",
      "Pérdida presupuestada",
      "Потери по бюджету",
      "Budżet strat",
      "test_budget_loss"
    ],
    test_range_created: [
      "Test range to be created",
      "Test range to be created",
      "テスト範囲を作成する必要があります",
      "待创建的测试范围",
      "Zu erstellender Testbereich ",
      "Gamme de tests à créer",
      "Testa gamma da creare",
      "Faixa de testes a ser criada",
      "Rango de prueba que se creará",
      "Создаваемый тестовый диапазон",
      "Przedział testu do utworzenia",
      "test_range_created"
    ],
    cable_brand: [
      "Cable Brand",
      "Cable Brand",
      "ケーブルブランド",
      "电缆品牌",
      "Kabelmarke",
      "Marque de câble",
      "Marchio del cavo",
      "Marca do cabo",
      "Marca del cable",
      "Бренд кабеля",
      "Marka okablowania",
      "cable_brand"
    ],
    fiber_test_cable_type: [
      "Cable Type",
      "Cable Type",
      "ケーブルのタイプ",
      "线缆类型",
      "Kabeltyp",
      "Type de câble",
      "Tipo di cavo",
      "Tipo de Cabo",
      "Tipo de cable",
      "Тип кабеля",
      "Typ okablowania",
      "fiber_test_cable_type"
    ],
    test_cable_part_number: [
      "Cable Part Number",
      "Cable Part Number",
      "ケーブルの部品番号",
      "电缆部件号",
      "Kabel-Teilenummer",
      "Référence du câble",
      "Numero parte cavo",
      "Código do cabo",
      "Número de pieza del cable",
      "Артикул кабеля",
      "Part Numer kabla",
      "test_cable_part_number"
    ],
    test_refractive_index: [
      "Refractive Index",
      "Refractive Index",
      "屈折率",
      "折射率",
      "Brechungsindex",
      "Indice de réfraction",
      "Indice di rifrazione",
      "Índice de Refração",
      "Índice refracción",
      "Индекс преломления",
      "Współczynnik załamania światła",
      "test_refractive_index"
    ],
    test_loss_budget: [
      "Loss Budget",
      "Loss Budget",
      "損失バジェット",
      "损耗预算",
      "Verlustbudget",
      "Budget de perte",
      "Budget perdita",
      "Provisão de Perda",
      "Presupuesto de pérdida",
      "Потери по бюджету",
      "Budżet strat",
      "test_loss_budget"
    ],
    test_wave_length: [
      "Wave Length",
      "Wave Length",
      "波長",
      "波长",
      "Wellenlänge",
      "Longueur d'onde",
      "Lunghezza d’onda",
      "Comprimento de onda",
      "Longitud de onda",
      "Длина волны",
      "Długość fali",
      "test_wave_length"
    ],
    test_cord_type: [
      "Test Cord Type",
      "Test Cord Type",
      "テストコードタイプ",
      "测试线缆类型",
      "Prüfleitungstyp",
      "Type de cordon de test",
      "Testa tipo di corda",
      "Tipo do cordão de teste",
      "Probar tipo de cable",
      "Тип тестового шнура",
      "Typ przewodu testującego",
      "test_cord_type"
    ],
    test_length: [
      "Length",
      "Length",
      "長さ",
      "长度",
      "Länge",
      "Longueur",
      "Lunghezza",
      "Comprimento",
      "Longitud",
      "Длина",
      "Długość",
      "test_length"
    ],
    test_connector_type: [
      "Connector Type",
      "Connector Type",
      "コネクタタイプ",
      "接头类型",
      "Anschlusstyp",
      "Type de connecteur",
      "Tipo di connettore",
      "Tipo de conector",
      "Tipo de conector",
      "Тип соединителя",
      "Typ złącza",
      "test_connector_type"
    ],
    test_encircled_flux: [
      "Encircled Flux",
      "Encircled Flux",
      "エンサークルドフラックス",
      "环型通量",
      "Encircled Flux",
      "Flux entouré",
      "Flusso circondato",
      "Encircled Flux",
      "Flujo restringido",
      "Круговая схема тестирования",
      "Test Encircled Flux (EF)",
      "test_encircled_flux"
    ],
    test_cord_reference: [
      "Test Cord Reference",
      "Test Cord Reference",
      "テストコード基準",
      "测试线缆参照项",
      "Prüfleitungsreferenz",
      "Référence du cordon de test",
      "Testa riferimento corda",
      "Referência do cordão de teste",
      "Referencia del latiguillo de prueba",
      "Идентификационный номер тестового шнура",
      "Referencja przewodu testującego",
      "test_cord_reference"
    ],
    test_direction: [
      "Direction",
      "Direction",
      "方向",
      "方向",
      "Richtung",
      "Sens",
      "Direzione",
      "Direção",
      "Dirección",
      "Направление",
      "Kierunek",
      "test_direction"
    ],
    test_mode: [
      "Mode",
      "Mode",
      "モード",
      "模式",
      "Modus",
      "Mode",
      "Modalità",
      "Modo",
      "Modo",
      "Режим",
      "Tryb",
      "test_mode"
    ],
    test_length_limit: [
      "Length Limit (m)",
      "Length Limit (m)",
      "長さ制限 (m)",
      "长度限制(m) ",
      "Längenbegrenzung (m)",
      "Limite de longueur (m)",
      "Limite lunghezza(m) ",
      "Limite de comprimento (m)",
      "Límite de longitud (m)",
      "Ограничение длины (м)",
      "Limit długości (metry)",
      "test_length_limit"
    ],
    test_length_limit_feet: [
      "Length Limit",
      "Length Limit",
      "長さ制限",
      "长度限制",
      "Längenbegrenzung",
      "Limite de longueur",
      "Limite lunghezza",
      "Limite de comprimento",
      "Límite de longitud",
      "Ограничение длины",
      "Limit długości",
      "test_length_limit"
    ],
    use_length_from_the_results: [
      "Use length from the test results",
      "Use length from the test results",
      "テスト結果の長さを使用",
      "使用测试结果给出的长度",
      "Länge von den Testergebnissen verwenden",
      "Utilisez la longueur provenant des résultats de test",
      "Usa lunghezza dai risultati dei test",
      "Usar comprimento do resultado do teste",
      "Usar la longitud de los resultados de la prueba",
      "Использовать длину из результатов теста",
      "Użyj długości z wyników testu",
      "use_length_from_the_results"
    ],
    apply_length_limit_to_the_test_results: [
      "Apply length limit to the test results",
      "Apply length limit to the test results",
      "テスト結果に長さ制限を適用",
      "对测试结果应用测试长度",
      "Längenbegrenzung für Testergebnisse verwenden",
      "Appliquez une limite de longueur aux résultats de test",
      "Applica limite di lunghezza ai risultati dei test",
      "Aplicar limite de comprimento ao resultado do teste",
      "Aplicar límite de longitud a los resultados de la prueba",
      "Применять ограничение длины к результатам теста",
      "Zastosuj limit długości do wyników testu",
      "apply_length_limit_to_the_test_results"
    ],
    should_be_atmost_two_place_decimal_digit: [
      "Should be a number and has atmost two decimal digit",
      "Should be a number and has atmost two decimal digit",
      "小数点以下2桁までの数値である必要があります",
      "应为数字，且最多具有两位十进制数",
      "Sollte eine Zahl sein und höchstens zwei Dezimalziffern haben",
      "Doit être un chiffre à deux décimales au maximum",
      "Dovrebbe essere un numero con massimo due cifre decimali",
      "Deve ser um número e ter um máximo de duas casas decimais",
      "Debe ser un número y tiene un máximo de dos dígitos decimales",
      "В качестве значения должно указываться число не более чем с двумя десятичными разрядами",
      "Powinna to być liczba i mieć co najwyżej dwie cyfry po przecinku",
      "should_be_atmost_two_place_decimal_digit"
    ],
    test_no_of_splices: [
      "No. Of Splices",
      "No. Of Splices",
      "スプライスの数",
      "接头数量",
      "Anzahl der Spleiße",
      "Nb d’épissures",
      "N. di giunzioni",
      "Nº de emendas",
      "Número de empalmes",
      "Кол-во сращиваний",
      "Liczba splotów",
      "test_no_of_splices"
    ],
    test_splice_loss_value: [
      "Splice Loss Value (dB)",
      "Splice Loss Value (dB)",
      "スプライス損失値 (dB)",
      "接头损耗值(dB)",
      "Spleißverlust (dB)",
      "Valeur des pertes aux épissures (dB)",
      "Valore perdita giunzione (dB)",
      "Valor de perda da emenda (dB)",
      "Valor de pérdida de empalme (dB)",
      "Значение потерь на сращиваниях (дБ)",
      "Wartość straty splotu (dB)",
      "test_splice_loss_value"
    ],
    test_no_of_adapters: [
      "No. Of Adapters",
      "No. Of Adapters",
      "アダプターの数",
      "适配器数量",
      "Anzahl der Adapter",
      "Nb d’adaptateurs",
      "N. di adattatori",
      "Nº de adaptadores",
      "Número de adaptadores",
      "Кол-во адаптеров",
      "Liczba adaptorów",
      "test_no_of_adapters"
    ],
    test_adapter_loss_value: [
      "Adapter Loss Value (dB)",
      "Adapter Loss Value (dB)",
      "アダプター損失値 (dB)",
      "适配器损耗值(dB)",
      "Adapterverlust (dB)",
      "Valeur des pertes d’adaptateur (dB)",
      "Valore perdita adattatore (dB)",
      "Valor de perda do adaptador (dB)",
      "Valor de pérdida de adaptador (dB)",
      "Значение потерь на адаптере (дБ)",
      "Wartość strat adaptora (dB)",
      "test_adapter_loss_value"
    ],
    test_group: [
      "Group",
      "Group",
      "グループ",
      "组别",
      "Gruppe",
      "Groupe",
      "Gruppo",
      "Grupo",
      "Grupo",
      "Группа",
      "Grupa",
      "test_group"
    ],
    test_application: [
      "Application",
      "Application",
      "Application",
      "应用程序",
      "Anwendung",
      "Application",
      "Applicazione",
      "Aplicação",
      "Aplicación",
      "Область применения",
      "Aplikacja",
      "test_application"
    ],
    test_manual: [
      "Manual",
      "Manual",
      "マニュアル",
      "手动的",
      "Manuell",
      "Manuel",
      "Manuale",
      "Manual",
      "Manual",
      "Руководство",
      "Podręcznik",
      "test_manual"
    ],
    test_max_length: [
      "Max Length (m)",
      "Max Length (m)",
      "最大の長さ (m)",
      "最大长度(m)",
      "Max. Länge (m)",
      "Longueur max (m)",
      "Lunghezza max(m) ",
      "Comprimento máx (m)",
      "Longitud máx. (m)",
      "Макс. длина (м)",
      "Maks. długość (metry)",
      "test_max_length"
    ],
    test_max_length_feet: [
      "Max Length",
      "Max Length",
      "最大の長さ",
      "最大长度",
      "Max. Länge",
      "Longueur max",
      "Lunghezza max",
      "Comprimento máx",
      "Longitud máx.",
      "Макс. длина",
      "Maks. długość",
      "test_max_length"
    ],
    test_directionid: [
      "Direction ID",
      "Direction ID",
      "方向ID",
      "方向 ID",
      "Richtung-ID",
      "ID sens",
      "Direction ID",
      "ID de direção",
      "ID de la dirección",
      "Ид. направления",
      "Identyfikator kierunku",
      "test_directionid"
    ],
    settings_lt4_fiber_limit: [
      "LanTEK IV FIBRE LIMITS DB",
      "LanTEK IV FIBER LIMITS DB",
      "LanTEK IV (ファイバー) 制限DB",
      "LanTEK IV 光纤限制 DB",
      "LanTEK IV FASERBEGRENZUNGEN DB",
      "LIMITES DE LA FIBRE LanTEK IV DB",
      "FIBRA LanTEK IV LIMITA DB",
      "BD DE LIMITES DE FIBRA DO LT4",
      "LÍMITES DE FIBRA LanTEK IV DB",
      "БД ОГРАНИЧЕНИЙ ДЛЯ ВОЛОКНА LanTEK IV",
      "LanTEK IV LIMITY WŁÓKNA DB",
      "settings_lt4_fiber_limit"
    ],
    settings_fiber_limitsdb_label: [
      "Fibre Limits DB File",
      "Fiber Limits DB File",
      "ファイバー制限DBファイル",
      "光纤限制 DB 文件",
      "Faserbegrenzungen DB Datei",
      "Fichier des limites de la fibre DB",
      "Fibra limita file DB",
      "BD de limites de fibra",
      "Archivo límites de fibra DB",
      "Файл БД ограничений для волокна",
      "Plik z limitami włókna DB",
      "settings_fiber_limitsdb_label"
    ],
    settings_fiberdb_title: [
      "LanTEK IV FIBRE LIMITS DB UPLOAD",
      "LanTEK IV FIBER LIMITS DB UPLOAD",
      "LanTEK IV (ファイバー) 制限DBのアップロード",
      "LanTEK IV 光纤限制 DB 上传",
      "LanTEK IV FASERBEGRENZUNGEN DB UPLOAD",
      "TÉLÉCHARGEMENT DES LIMITES DE LA FIBRE LanTEK IV DB",
      "FIBRA LanTEK IV LIMITA UPLOAD DB",
      "CARREGAR BD DE LIMITES DE FIBRA DO LT4",
      "CARGA DE LÍMITES DE FIBRA LanTEK IV DB",
      "ЗАГРУЗКА БД ОГРАНИЧЕНИЙ ДЛЯ ВОЛОКНА LanTEK IV",
      "LanTEK IV LIMITY WŁÓKNA DB PRZESYŁANIE",
      "settings_fiberdb_title"
    ],
    settings_fiber_cable_label: [
      "Fibre cable",
      "Fiber cable",
      "ファイバーケーブル",
      "光纤电缆",
      "LWL Kabel",
      "Câble à fibres optiques",
      "Cavo fibra",
      "Cabo de fibra",
      "Cable de fibra",
      "Волоконный кабель",
      "Światłowód",
      "settings_fiber_cable_label"
    ],
    settings_fiber_standard_label: [
      "Fibre Standard",
      "Fiber Standard",
      "ファイバー規格",
      "光纤标准",
      "Glasfaser Standard",
      "Norme des fibres",
      "Standard fibra",
      "Norma de fibra",
      "Estándar de fibra",
      "Стандарт волокна",
      "Standard włókna",
      "settings_fiber_standard_label"
    ],
    settings_fiber_application_label: [
      "Fibre Application",
      "Fiber Application",
      "ファイバーアプリケーション",
      "光纤应用",
      "Glasfaser Anwendung",
      "Application fibre",
      "Applicazione fibra",
      "Aplicação da fibra",
      "Aplicación de fibra",
      "Область применения волокна",
      "Aplikacja włókna",
      "settings_fiber_application_label"
    ],
    registered: [
      "Status",
      "Status",
      "ステータス",
      "状态",
      "Status",
      "Statut",
      "Stato",
      "Status",
      "Estado",
      "Состояние",
      "Status",
      "registered"
    ],
    general_registered: [
      "Registered",
      "Registered",
      "登録済み",
      "已注册",
      "Registriert",
      "Enregistré",
      "Registrato",
      "Registado",
      "Registrado",
      "Зарегистрировано",
      "Zarejestrowany",
      "general_registered"
    ],
    general_unregistered: [
      "Un-Registered",
      "Un-Registered",
      "登録解除済み",
      "未注册",
      "Nicht registriert",
      "Non enregistré",
      "De-registrato",
      "Não registado",
      "No registrado",
      "Регистрация отменена",
      "Wyrejestrowany",
      "general_unregistered"
    ],
    fiber_test_noofslice_out_of_range_desc: [
      "No. of splice should be in range of 0-8",
      "No. of splice should be in range of 0-8",
      "スプライスの数は0-8の範囲である必要があります",
      "接头编号应在 0 - 8 的范围内",
      "Kein Spleiß sollte im Bereich 0-8 liegen",
      "Le nombre d’épissures doit être entre 0 et 8",
      "N. di giunzioni dovrebbe essere nell’intervallo fra 0 e 8",
      "O nº de emendas deve estar entre 0 e 8",
      "El número de empalmes debe estar en el rango de 0-8",
      "Кол-во сращиваний должно быть от 0 до 8",
      "Liczba splotów powinna zawierać się w przedziale 0-8",
      "fiber_test_noofslice_out_of_range_desc"
    ],
    fiber_test_noofadapter_out_of_range_desc: [
      "No. of adapter should be in range of 2-8",
      "No. of adapter should be in range of 2-8",
      "アダプターの数は2-8の範囲である必要があります",
      "适配器编号应在 2 - 8 的范围内",
      "Kein Adapter sollte im Bereich 2-8 liegen",
      "Le nombre d’adaptateurs doit être entre 2 et 8",
      "N. di adattatori dovrebbe essere nell’intervallo fra 2 e 8",
      "O nº de adaptadores deve estar entre 2 e 8",
      "El número de adaptadores debe estar en el rango de 2-8",
      "Кол-во адаптеров должно быть от 2 до 8",
      "Liczba adapterów powinna zawierać się w przedziale 2-8",
      "fiber_test_noofadapter_out_of_range_desc"
    ],
    fiber_test_maxlength_out_of_range_desc: [
      "Max length should be in range of 0-40000m",
      "Max length should be in range of 0-40000m",
      "最大の長さは0-40000メートルの範囲である必要があります",
      "最大长度应在 0 - 40000 m 的范围内",
      "Max. Länge sollte im Bereich 0-40000m liegen",
      "La longueur max. doit être entre 0 à 40000 m",
      "La lunghezza max dovrebbe essere nell’intervallo fra 0 e 40000 m",
      "O comprimento máximo deve estar entre 0 e 40.000 metros",
      "La longitud máx. debe estar en el rango de 0-40000 m",
      "Макс. длина должна быть от 0 до 40 000 м",
      "Maks. długość powinna zawierać się w przedziale 0-40000 metrów",
      "fiber_test_maxlength_out_of_range_desc"
    ],
    fiber_test_maxlength_out_of_range_desc_feet: [
      "Max length should be in range of 0-131233.6ft",
      "Max length should be in range of 0-131233.6ft",
      "最大の長さは0-131233.6フィートの範囲である必要があります",
      "最大长度应在 0 -131233.6 ft 的范围内",
      "Max. Länge sollte im Bereich 0-131233.6ft liegen",
      "La longueur max. doit être entre 0 à 131233.6 ft",
      "La lunghezza max dovrebbe essere nell’intervallo fra 0 e 131233.6 ft",
      "O comprimento máximo deve estar entre 0 e 131233,6 pés",
      "La longitud máx. debe estar en el rango de 0-131233.6 ft",
      "Макс. длина должна быть от 0 до 131233.6 ft",
      "Maks. długość powinna zawierać się w przedziale 0-131233.6 ft",
      "fiber_test_maxlength_out_of_range_desc_feet"
    ],
    fiber_test_spliceloss_out_of_range_desc: [
      "Value of splice loss should be in range of 0-5",
      "Value of splice loss should be in range of 0-5",
      "スプライス損失値は0-5の範囲である必要があります",
      "接头损耗值应在 0 - 5 的范围内",
      "Wert des Spleißverlustes sollte im Bereich 0-5 liegen",
      "La valeur de la perte aux épissures doit être entre 0 et 5",
      "Il valore di perdita giunzione dovrebbe essere nell’intervallo fra 0 e 5",
      "O valor da perda por emenda deve estar entre 0 e 5",
      "El valor de pérdida de empalme debe estar en el rango de 0-5",
      "Значение потерь на сращиваниях должно быть от 0 до 5",
      "Wartość straty splotu powinna zawierać się w przedziale 0-5",
      "fiber_test_spliceloss_out_of_range_desc"
    ],
    fiber_test_loss_limit_range_desc: [
      "Value of loss limit should be in range of 0-18",
      "Value of loss limit should be in range of 0-18",
      "損失制限の値は0～18の範囲でなければなりません",
      "损失限额的值应在 0-18 范围内",
      "Der Wert des Verlustlimits sollte im Bereich von 0-18 liegen",
      "La valeur de la limite de perte doit être comprise entre 0 et 18",
      "Il valore del limite di perdita dovrebbe essere compreso tra 0 e 18",
      "O valor do limite de perda deve estar no intervalo de 0-18",
      "El valor del límite de pérdida debe estar en el rango de 0 a 18",
      "Значение лимита убытков должно быть в диапазоне 0-18",
      "Wartość limitu strat powinna mieścić się w przedziale 0-18",
      "fiber_test_loss_limit_range_desc"
    ],
    fiber_test_iloss_out_of_range_desc: [
      "Value should be in range of 0-5",
      "Value should be in range of 0-5",
      "値は0-5の範囲である必要があります",
      "值应在 0 - 5 的范围内",
      "Wert sollte sich im Bereich 0-5 befinden",
      "La valeur doit être entre 0 et 5",
      "Il valore dovrebbe essere nell’intervallo fra 0 e 5",
      "O valor deve estar entre 0 e 5",
      "El valor debe estar en el rango de 0-5",
      "Значение должно быть от 0 до 5",
      "Wartość powinna zawierać się w przedziale 0-5",
      "fiber_test_iloss_out_of_range_desc"
    ],
    loss_budget_unit: [
      "(dB/km)",
      "(dB/km)",
      "(dB/km)",
      "(dB/km)",
      "(dB/km)",
      "(dB/km)",
      "(dB/km)",
      "(dB/km)",
      "(dB/km)",
      "(дБ/км)",
      "(dB/km)",
      "loss_budget_unit"
    ],
    fiber_test_refractiveindex_out_of_range_desc: [
      "Value of refractiveindex should be in range of 1.3 - 1.55",
      "Value of refractiveindex should be in range of 1.3 - 1.55",
      "屈折率の値は1.3-1.55の範囲である必要があります",
      "折射率的值应在 1.3 - 1.55 的范围内",
      "Brechungsindex sollte im Bereich 1,3 – 1,55 liegen",
      "La valeur de l’indice de réfraction devrait être dans la plage 1,3 - 1,55",
      "Il valore dell’indice di rifrazione dovrebbe essere nell’intervallo fra 1,3 e 1,55",
      "O valor do índice de refração deve estar entre 1,3 e 1,55",
      "El valor del índice de refracción debe estar en el rango de 1,3 – 1,55",
      "Значение показателя преломления (refractiveindex) должно быть в диапазоне от 1,3 до 1,55",
      "Wartość współczynnika załamania światła powinna zawierać się w przedziale 1,3-1,55",
      "fiber_test_refractiveindex_out_of_range_desc"
    ],
    pass: [
      "Pass",
      "Pass",
      "合格",
      "通过",
      "Pass",
      "Réussite",
      "Riuscito",
      "Aprovado",
      "Superado",
      "Удовлетворение",
      "Zaliczone",
      "pass"
    ],
    fail: [
      "Fail",
      "Fail",
      "不合格",
      "失败",
      "Fail",
      "Échec",
      "Fallito",
      "Reprovado",
      "No superado",
      "Неудовлетворение",
      "Nie zaliczone",
      "fail"
    ],
    marginalpass: [
      "MarginalPass",
      "MarginalPass",
      "マージン合格",
      "边际通过",
      "MarginalPass",
      "Réussite marginale",
      "Marginale riuscito",
      "AprovadoMarginal",
      "Superado Marginal",
      "Удовлетворение погрешности",
      "Marginalnie zaliczone",
      "marginalpass"
    ],
    marginalfail: [
      "MarginalFail",
      "MarginalFail",
      "マージン不合格",
      "边际失败",
      "MarginalFail",
      "Échec marginal",
      "Marginale fallito",
      "ReprovadoMarginal",
      "No Superado Marginal",
      "Неудовлетворение погрешности",
      "Marginalnie nie zaliczone",
      "marginalfail"
    ],
    null: [
      "-",
      "-",
      "-",
      "-",
      "-",
      "-",
      "-",
      "-",
      "-",
      "-",
      "-",
      "null"
    ],
    general_of: [
      "of",
      "of",
      "/",
      "/",
      "von",
      "de",
      "di",
      "de",
      "de",
      "из",
      "z",
      "general_of"
    ],
    meters: [
      "meters",
      "meters",
      "メートル",
      "米",
      "Meter",
      "mètres",
      "metri",
      "metros",
      "metros",
      "метры",
      "metry",
      "meters"
    ],
    feet: [
      "feet",
      "feet",
      "フィート",
      "英尺",
      "Fuß",
      "pieds",
      "piedi",
      "pés",
      "pies",
      "футы",
      "stopy",
      "feet"
    ],
    ns: [
      "ns",
      "ns",
      "ns",
      "ns",
      "ns",
      "ns",
      "ns",
      "ns",
      "ns",
      "ns",
      "ns",
      "ns"
    ],
    ohms: [
      "ohms",
      "ohms",
      "オーム",
      "欧姆",
      "Ohm",
      "ohms",
      "ohm",
      "ohms",
      "ohms",
      "омы",
      "omy",
      "ohms"
    ],
    "pF/ft": [
      "pF/ft",
      "pF/ft",
      "pF/ft",
      "pF/ft",
      "pF/ft",
      "pF/ft",
      "pF/ft",
      "pF/ft",
      "pF/ft",
      "pF/ft",
      "pF/ft",
      "pF/ft"
    ],
    "pF/m": [
      "pF/m",
      "pF/m",
      "pF/m",
      "pF/m",
      "pF/m",
      "pF/m",
      "pF/m",
      "pF/m",
      "pF/m",
      "pF/м",
      "pF/m",
      "pF/m"
    ],
    m: ["m", "m", "m", "m", "m", "m", "m", "m", "m", "м", "m", "m"],
    ft: [
      "ft",
      "ft",
      "ft",
      "ft",
      "ft",
      "ft",
      "ft",
      "ft",
      "ft",
      "ft",
      "ft",
      "ft"
    ],
    dB: [
      "dB",
      "dB",
      "dB",
      "dB",
      "dB",
      "dB",
      "dB",
      "dB",
      "dB",
      "dB",
      "дБ",
      "dB"
    ],
    nm: [
      "nm",
      "nm",
      "nm",
      "nm",
      "nm",
      "nm",
      "nm",
      "nm",
      "nm",
      "nm",
      "nm",
      "nm"
    ],
    µm: [
      "µm",
      "µm",
      "µm",
      "µm",
      "µm",
      "µm",
      "µm",
      "µm",
      "µm",
      "µm",
      "µm",
      "µm"
    ],
    general_fiber: [
      "Fibre",
      "Fiber",
      "ファイバー",
      "光纤",
      "Glasfaser",
      "Fibre",
      "Fibra",
      "Fibra",
      "Fibra",
      "Волокно",
      "Włókno",
      "general_fiber"
    ],
    TERA: [
      "TERA",
      "TERA",
      "TERA",
      "TERA",
      "TERA",
      "TERA",
      "TERA",
      "TERA",
      "TERA",
      "TERA",
      "TERA",
      "TERA"
    ],
    "568-A": [
      "568A",
      "568A",
      "568A",
      "568A",
      "568A",
      "568A",
      "568A",
      "568A",
      "568A",
      "568A",
      "568A",
      "568-A"
    ],
    "568-B": [
      "568B",
      "568B",
      "568B",
      "568B",
      "568B",
      "568B",
      "568B",
      "568B",
      "568B",
      "568B",
      "568B",
      "568-B"
    ],
    "Frequency (MHz)": [
      "Frequency (MHz)",
      "Frequency (MHz)",
      "周波数 (MHz)",
      "频率(MHz)",
      "Frequenz (MHz)",
      "Fréquences (MHz)",
      "Frequenza (MHz)",
      "Frequência (MHz)",
      "Frecuencia (MHz)",
      "Частота (МГц)",
      "Częstotliwość  (MHz)",
      "Frequency (MHz)"
    ],
    "All Pairs": [
      "All Pairs",
      "All Pairs",
      "すべてのペア",
      "所有线对",
      "Alle Paare",
      "Toutes les paires",
      "Tutte le coppie",
      "Todos os pares",
      "Todos los pares",
      "Все пары",
      "Wszystkie pary",
      "All Pairs"
    ],
    Pairs: [
      "Pairs",
      "Pairs",
      "ペア",
      "线对",
      "Paare",
      "Paires",
      "Coppie",
      "Pares",
      "Pares",
      "Пары",
      "Pary",
      "Pairs"
    ],
    limit: [
      "Limit",
      "Limit",
      "制限",
      "极限值",
      "Limit",
      "Limite",
      "Limite",
      "Limite",
      "Límite",
      "Предел",
      "Limit",
      "limit"
    ],
    Distance: [
      "Distance",
      "Distance",
      "距離",
      "距离",
      "Entfernung",
      "Distance",
      "Distanza",
      "Distância",
      "Distancia",
      "Расстояние",
      "Odległość",
      "Distance"
    ],
    info: [
      "Info",
      "Info",
      "情報",
      "信息",
      "Info",
      "Info",
      "Informazioni",
      "Info",
      "Info",
      "Информация",
      "Informacje",
      "info"
    ],
    pending: [
      "Pending",
      "Pending",
      "保留中",
      "多模光纤",
      "Ausstehend",
      "En attente",
      "In attesa",
      "Pendente",
      "Pendiente",
      "В ожидании",
      "W oczekiwaniu",
      "pending"
    ],
    retestrequested: [
      "Retest Requested",
      "Retest Requested",
      "再テスト要求済み",
      "要求重新测设",
      "Erneuter Test angefordert",
      "Retester svp",
      "Nuovo test richiesto",
      "Repetição de teste solicitada",
      "Repetición de prueba solicitada",
      "Запрошен повторный тест",
      "Poproszono o ponowny test",
      "retestrequested"
    ],
    syncd: [
      "Synced",
      "Synced",
      "同期済み",
      "已同步",
      "Synchronisiert",
      "Synchronisé",
      "Sincronizzazione effettuata",
      "Sincronizado",
      "Sincronizado",
      "Синхронизировано",
      "Zsynchronizowano",
      "syncd"
    ],
    fiber_test_adapterloss_out_of_range_desc: [
      "Value of adapter loss should be in range of 0-5",
      "Value of adapter loss should be in range of 0-5",
      "アダプター損失値は0-5の範囲である必要があります",
      "适配器损耗值应在 0 - 5 的范围内",
      "Pro Adapter sollte der Signalverlust im Bereich zwischen 0 und 5 liegen",
      "La valeur de perte de l'adaptateur doit être comprise entre 0 et 5",
      "Il valore della perdita dell’adattatore dovrebbe essere compreso tra 0 e 5",
      "O valor da perda do adaptador deve estar entre 0 e 5",
      "El valor de la pérdida del adaptador debería situarse entre 0-5",
      "Значение потерь на адаптере должно быть от 0 до 5",
      "Wartość straty adaptora powinna zawierać się  w przedziale 0-5",
      "fiber_test_adapterloss_out_of_range_desc"
    ],
    export_job: [
      "Export Job",
      "Export Job",
      "エクスポートジョブ",
      "导出作业",
      "Job exportieren",
      "Exporter le travail",
      "Esporta lavoro",
      "Trabalho de exportação",
      "Exportar trabajo",
      "Экспорт задания",
      "Eksportuj zadanie",
      "export_job"
    ],
    download_job: [
      "Download Job",
      "Download Job",
      "ダウンロードジョブ",
      "下载作业",
      "Job herunterladen",
      "Télécharger le travail",
      "Scarica Lavoro",
      "Baixar trabalho",
      "Descargar trabajo",
      "Скачать работу",
      "Pobierz zadanie",
      "download_job"
    ],
    download: [
      "Download",
      "Download",
      "ダウンロード",
      "下载",
      "Herunterladen",
      "Télécharger",
      "Scarica",
      "Descarregar",
      "Descargar",
      "Загрузить",
      "Ściągnij",
      "download"
    ],
    error_file_not_found: [
      "No ${value} file found",
      "No ${value} file found",
      "${value} ファイルが見つかりません",
      "未找到 ${value} 文件",
      "Keine ${value}-Datei gefunden",
      "Aucun fichier ${value} trouvé",
      "Nessun file ${value} trovato",
      "Nenhum arquivo ${value} encontrado",
      "No se encontró ningún archivo ${value}",
      "${value}-файл не найден",
      "Nie znaleziono pliku ${value}",
      "error_file_not_found"
    ],

    select_file_type: [
      "Select file type",
      "Select file type",
      "ファイルの種類を選択してください",
      "选择文件类型",
      "Dateityp auswählen",
      "Sélectionnez le type de fichier",
      "Seleziona il tipo di file",
      "Selecione o tipo de arquivo",
      "Seleccionar tipo de archivo",
      "Выберите тип файла",
      "Wybierz typ pliku",
      "select_file_type"
    ],

    tooltip_export_job_in_progress: [
      "Export job is in progress, please wait!",
      "Export job is in progress, please wait!",
      "ジョブのエクスポートを行っています。お待ちください。",
      "正在导出作业，请稍候！",
      "Der Job wird exportiert, bitte warten!",
      "L’exportation du dossier est en cours, veuillez patienter svp.",
      "Esportazione in corso, attendere!",
      "Exportação em andamento, aguarde.",
      "La exportación del trabajo está en marcha. Espere, por favor.",
      "Выполняется экспорт задания, пожалуйста, подождите!",
      "Trwa eksportowanie, proszę czekać!",
      "tooltip_export_job_in_progress"
    ],
    export_job_success: [
      "The job export is in progress, you will receive an email once job export is completed then you can download the file.",
      "The job export is in progress, you will receive an email once job export is completed then you can download the file.",
      "ジョブのエクスポートを行っています。ジョブのエクスポートが完了したら、メール通知が届き、ファイルをダウンロードできるようになります。",
      "作业导出正在进行中，一旦作业导出完成，您会收到一封电子邮件，然后就可以下载文件。",
      "Der Job wird exportiert. Sie erhalten eine E-Mail, sobald der Job-Export abgeschlossen ist. Anschließend können Sie die Datei herunterladen.",
      "L’exportation du dossier est en cours -quand elle sera achevée vous recevrez un email d’avertissement, et vous pourrez alors récupérer le fichier.",
      "Esportazione del lavoro in corso, al termine riceverai una e - mail e potrai scaricare il file.",
      "Exportação em andamento. Você receberá um e-mail assim que estiver concluída, e então poderá descarregar o arquivo.",
      "La exportación del trabajo está en marcha, recibirá un correo en cuanto se complete. Luego, podrá descargar el archivo.",
      "Выполняется экспорт задания, вы получите электронное письмо по его завершении, после чего вы сможете скачать файл.",
      "Eksport zlecenia jest w toku. Po zakończeniu eksportu otrzymasz wiadomość e-mail, po której możesz pobrać plik.",
      "export_job_success"
    ],
    job_upload_comet_title: [
      "Import LanTEK IV Archive (.zip)",
      "Import LanTEK IV Archive (.zip)",
      "LanTEK IVアーカイブ (.zip) のインポート",
      "导入LanTEK IV存档文件(.zip)",
      "Importieren von LanTEK IV Archive (.zip)",
      "Importer l'archive du LanTEK IV (.zip)",
      "Importa l’archivio LanTEK IV (.zip)",
      "Importar arquivo do LanTEK IV (.zip)",
      "Importar archivo LanTEK IV (.zip)",
      "Импортировать архив LanTEK IV (.zip)",
      "Importuj archiwum LanTEK IV (.zip)",
      "job_upload_comet_title"
    ],
    job_upload_comet_helptext: [
      "Please Select Exported Zip File.",
      "Please Select Exported Zip File.",
      "エクスポートされたZIPファイルを選択してください。",
      "请选择导出的 Zip 文件。",
      "Bitte wählen Sie die exportierte Zip-Datei aus.",
      "Veuillez sélectionner le fichier Zip exporté.",
      "Selezionare il file Zip esportato.",
      "Selecione o arquivo ZIP exportado.",
      "Seleccione un archivo .zip exportado.",
      "Пожалуйста, выберите экспортируемый файл Zip.",
      "Wybierz wyeksportowany plik zip.",
      "job_upload_comet_helptext"
    ],
    tooltip_export_job_failed: [
      "The Export Job process has failed, please click on Export Job again",
      "The Export Job process has failed, please click on Export Job again",
      "ジョブのエクスポート処理に失敗しました。[ジョブをエクスポート] を再びクリックしてください",
      "导出作业失败，请再点击导出作业",
      "Der Job konnte nicht exportiert werden. Bitte klicken Sie erneut auf „Job exportieren.",
      "Le processus d'exportation du dossier a échoué, veuillez cliquer à nouveau sur Exporter le dossier",
      "Esportazione non riuscita, cliccare nuovamente su Esporta lavoro",
      "O processo Exportar Trabalho falhou. Clique em Exportar Trabalho novamente",
      "Se ha producido un error durante la exportación del trabajo. Por favor, haga clic otra vez en Exportar trabajo.",
      "Не удалось выполнить Экспорт задания, пожалуйста, кликните на Экспорт задания еще раз",
      "Proces eksportu zlecenia nie powiódł się, kliknij ponownie Eksportuj Zlecenie",
      "tooltip_export_job_failed"
    ],
    comet_job_upload_is_duplicate_job: [
      "The same job is already exists for this organisation, please change the jobname.",
      "The same job is already exists for this organization, please change the jobname.",
      "この組織には同じジョブが既に存在しています。ジョブ名を変更してください。",
      "该组织已存在相同的工作，请更改作业名称。",
      "Dieser Job existiert bereits für diese Organisation. Bitte ändern Sie den Jobnamen.",
      "Le même dossier existe déjà pour cet installateur, veuillez changer le nom du dossier.",
      "Questo lavoro esiste già per l’organizzazione scelta, cambiare il nome del lavoro.",
      "O mesmo trabalho já existe para esta organização. Altere o nome do trabalho.",
      "Ya existe el mismo trabajo en esta organización. Cambie el nombre del trabajo.",
      "Такое же задание уже существует для этой организации, пожалуйста, измените название задания.",
      "To samo zlecenie już istnieje w tej organizacji, zmień nazwę zlecenia.",
      "comet_job_upload_is_duplicate_job"
    ],
    brief_report_too_many_tests: [
      "Too many tests selected. Brief report limited to ${value} tests",
      "Too many tests selected. Brief report limited to ${value} tests",
      "選択したテストの数が多すぎます。簡易表示のレポートでは、テストの数は${value}個までに制限されます",
      "选择的测试太多。简要报告仅限于${value}个测试",
      "Zu viele Tests ausgewählt. Vollständiger Bericht auf ${value} Tests begrenzt",
      "Trop de tests sélectionnés. Le rapport de synthèse est limité à ${value} tests",
      "Troppi test selezionati. Breve rapporto limitato a ${value} test",
      "Testes excessivos selecionados. Relatório breve limitado a ${value} testes",
      "Demasiadas pruebas seleccionadas. Informe Breve limitado a ${value} pruebas.",
      "Слишком много тестов выбрано. Краткий отчет ограничен ${value} тестами",
      "Wybrano zbyt wiele testów. Krótki raport ograniczony do ${value} testów",
      "brief_report_too_many_tests"
    ],
    "Job title: A-Z (default)": [
      "Job title: A-Z",
      "Job title: A-Z",
      "Jジョブタイトル:  A-Z",
      "职称：A-Z",
      "Projekttitel: A-Z",
      "Tri nom dossier : de A vers Z",
      "Qualifica: dalla A alla Z",
      "Trabalho: A-Z",
      "Trabajo A-Z",
      "Название задания: A-Z",
      "Opis zlecenia: A-Z",
      "Job title: A-Z"
    ],
    "Job title Z-A": [
      "Job title Z-A",
      "Job title Z-A",
      "ジョブタイトル A-Z",
      "职称Z-A",
      "Projekttitel Z-A",
      "Tri nom dossier : de Z vers A",
      "Qualifiche dalla Z alla A",
      "Trabalho: Z-A",
      "Trabajo Z-A",
      "Название задания: Z-A",
      "Opis zlecenia Z-A",
      "Job title Z-A"
    ],
    "Date: New to old": [
      "Date: New to old",
      "Date: New to old",
      "日付:   新しい順",
      "日期：从新到旧",
      "Datum: Neu nach Alt",
      "Tri ancienneté dossier: récent vers ancien",
      "Data: Dal più recente al meno recente",
      "Data: Recente-Antigo",
      "Fecha Reciente-Antigua",
      "Дата: От новых к старым",
      "Data: Od nowego do starego",
      "Date: New to old"
    ],
    "Date: Old to new": [
      "Date: Old to new",
      "Date: Old to new",
      "日付:  古い順",
      "日期：从旧到新",
      "Datum: Alt nach Neu",
      "Tri ancienneté dossier: ancien vers récent",
      "Data: Dal meno recente al più recente",
      "Data: Antigo-Recente",
      "Date: Fecha Antigua-Reciente",
      "Дата: От старых к новым",
      "Data: Od starego do nowego",
      "Date: Old to new"
    ],
    "Customer title: A-Z": [
      "Customer title: A-Z",
      "Customer title: A-Z",
      "カスタマータイトル:  A-Z",
      "客户称谓： A-Z",
      "Kundentitel: A-Z",
      "Tri nom client: de A vers Z",
      "Titolo cliente: dalla A alla Z",
      "Cliente: A-Z",
      "Cliente A-Z",
      "Название заказчика: A-Z",
      "Klient: A-Z",
      "Customer title: A-Z"
    ],
    "Customer title: Z-A": [
      "Customer title: Z-A",
      "Customer title: Z-A",
      "カスタマータイトル:  Z-A",
      "客户称谓： Z-A",
      "Kundentitel: Z-A",
      "Tri nom client: de Z vers A",
      "Titolo cliente: dalla Z alla A",
      "Cliente: A-Z",
      "Cliente A-Z",
      "Название заказчика: Z-A",
      "Klient: Z-A",
      "Customer title: Z-A"
    ],
    include_tcl_eltctl: [
      "Print Info Only results for TCL & ELTCTL (Page 2)",
      "Print Info Only results for TCL & ELTCTL (Page 2)",
      "TCL & ELTCTL用の情報のみの結果を印刷 (ページ2)",
      "TCL & ELTCTL的仅打印信息结果（第2页）",
      "Nur Info für TCL- und ELTCTL-Ergebnisse (Seite 2) drucken",
      "Deuxième page de rapport avec les mesures TCL & ELTCL pour normes MAX",
      "Stampa solo i risultati per TCL ed ELTCTL (Pagina 2)",
      "Imprimir resultados somente informativos de TCL e ELTCTL (página 2)",
      "Imprimir resultados informativos de TCL y ELTCL (página 2)",
      "Распечатать информацию только о результатах TCL и ELTCTL (Страница 2)",
      "Drukuj informacje tylko o wynikach dla TCL i ELTCTL (strona 2)",
      "include_tcl_eltctl"
    ],
    download_desktop_link: [
      'Prefer to use desktop software? <a href="https://www.trend-networks.com/support/downloads/software/" target="_blank">Click Here</a> to download the TREND <u>AnyWARE</u> desktop software.',
      'Prefer to use desktop software? <a href="https://www.trend-networks.com/us/support/downloads/software/" target="_blank">Click Here</a> to download the TREND <u>AnyWARE</u> desktop software.',
      'デスクトップソフトウェアの使用をご希望ですか?  <a href="https://www.trend-networks.com/us/support/downloads/software/" target="_blank">ここをクリック</a>してTREND <u>AnyWARE</u>のデスクトップソフトウェアをダウンロードできます。',
      '喜欢使用桌面软件？<a href="https://www.trend-networks.com/cn/support/downloads/software/" target="_blank">单击此处</a>下载TREND AnyWARE桌面软件',
      'Sie arbeiten lieber mit Desktop-Software? Dann klicken <a href="https://www.trend-networks.com/de/support/downloads/software/" target="_blank">Sie hier</a>, um die TREND <u>AnyWARE</u> Desktop-Software herunterzuladen.',
      'Si vous préférez utiliser la version PC du logiciel, <a href="https://www.trend-networks.com/fr/support/telechargements/logiciels/" target="_blank">svp cliquez ici</a> pour télécharger TREND <u>AnyWARE</u> Desktop ("bureau" en français - à l\'inverse donc de la version "Cloud")',
      'Preferisci usare il software desktop? <a href="https://www.trend-networks.com/support/downloads/software/" target="_blank">Fare clic qui per</a> scaricare il software desktop TREND <u>AnyWARE</u>.',
      'Prefere usar a versão desktop do software? <a href="https://www.trend-networks.com/support/downloads/software/" target="_blank">Clique aqui</a> para descarregar a versão desktop do TREND <u>AnyWARE</u>.',
      'Prefiere utilizar el Software de en su ordenador ? <a href="https://www.trend-networks.com/es/support/downloads/software/" target="_blank">Haga click aqui para</a> descargarse el Software de Ordenador TREND <u>AnyWARE</u>',
      'Предпочитаете использовать настольное программное обеспечение? <a href="https://www.trend-networks.com/support/downloads/software/" target="_blank"> Нажмите здесь </a> , чтобы загрузить программное обеспечение TREND <u>AnyWARE</u> для настольных ПК',
      'Wolisz używać oprogramowania komputerowego? <a href="https://www.trend-networks.com/support/downloads/software/" target="_blank">Kliknij tutaj</a> aby pobrać oprogramowanie komputerowe TREND <u>AnyWARE</u>.',
      "download_desktop_link"
    ],
    general_created_by: [
      "Created By",
      "Created By",
      "作成者",
      "制作者",
      "Erstellt von",
      "Créé par",
      "Creato da",
      "Criado por",
      "Creado por",
      "Создал(а)",
      "Utworzone przez",
      "general_created_by"
    ],
    device_not_found: [
      "No device found",
      "No device found",
      "デバイスは見つかりませんでした",
      "未找到设备",
      "Kein Gerät gefunden",
      "Aucun appareil trouvé",
      "Nessun dispositivo trovato",
      "Nenhum dispositivo encontrado",
      "Ninguna unidad encontrada",
      "Устройство не найдено",
      "Nie znaleziono urządzenia",
      "device_not_found"
    ],
    tests_export_csv_no_test_toast: [
      "LanTEK CSV cannot be generated as there are no test files",
      "LanTEK CSV cannot be generated as there are no test files",
      "テストファイルがないため、LanTEK CSV を生成できません",
      "由于没有测试文件，无法生成 LanTEK CSV",
      "LanTEK CSV kann nicht generiert werden, da keine Testdateien vorhanden sind",
      "LanTEK CSV ne peut pas être généré car il n'y a pas de fichiers de test",
      "LanTEK CSV non può essere generato perché non ci sono file di test",
      "LanTEK CSV não pode ser gerado porque não há arquivos de teste",
      "LanTEK CSV no se puede generar porque no hay archivos de prueba",
      "LanTEK CSV не может быть создан из-за отсутствия тестовых файлов",
      "Nie można wygenerować LanTEK CSV, ponieważ nie ma plików testowych",
      "tests_export_csv_no_test_toast"
    ],
    tests_export_archive_no_test_toast: [
      "LanTEK Zip cannot be generated as there are no test files",
      "LanTEK Zip cannot be generated as there are no test files",
      "テスト ファイルがないため、アーカイブを生成できません",
      "因为没有测试文件无法生成文档",
      "Das Archiv kann nicht erzeugt werden da keine Tests enthalten sind",
      "L’Archive ne peut pas être générée car il n’y a pas de test",
      "Impossibile generare l'archivio poiché non esiste un file di test",
      "Arquivo não pode ser criado porque não há testes",
      "El archivo no se puede generar porque no hay archivos de prueba",
      "Невозможно сгенерировать архив из-за отсутствия файлов тестов",
      "Nie można wygenerować archiwum, ponieważ nie ma pliku testowego",
      "tests_export_archive_no_test_toast"
    ],
    tests_export_archive_only_recerts_toast: [
      "LanTEK Zip cannot be generated as there are only recertified results",
      "LanTEK Zip cannot be generated as there are only recertified results",
      "再認定された結果しかないため、LanTEK Zip を生成できません",
      "无法生成 LanTEK Zip，因为只有重新认证的结果",
      "LanTEK Zip kann nicht generiert werden, da nur rezertifizierte Ergebnisse vorliegen",
      "LanTEK Zip ne peut pas être généré car il n'y a que des résultats recertifiés",
      "LanTEK Zip non può essere generato in quanto vi sono solo risultati ricertificati",
      "LanTEK Zip não pode ser gerado porque há apenas resultados recertificados",
      "LanTEK Zip no se puede generar ya que solo hay resultados recertificados",
      "LanTEK Zip не может быть сгенерирован, так как есть только переаттестованные результаты",
      "LanTEK Zip nie może zostać wygenerowany, ponieważ dostępne są tylko wyniki ponownie certyfikowane",
      "tests_export_archive_only_recerts_toast"
    ],
    restore_jobs: [
      "Restore Jobs",
      "Restore Jobs",
      "ジョブを復元",
      "恢复作业",
      "Projekte wiederherstellen",
      "Restaurer les dossiers",
      "Ripristina lavori",
      "Restaurar trabalhos",
      "Restaurar trabajos",
      "Восстановить задания",
      "Przywróć zlecenia",
      "restore_jobs"
    ],
    tooltip_restore_recover_jobs: [
      "Reload Jobs",
      "Reload Jobs",
      "ジョブを再読み込み",
      "重载作业",
      "Projekte neu laden",
      "Recharger les dossiers",
      "Ricarica lavori",
      "Recarregar trabalhos",
      "Volver a cargar trabajos",
      "Перезагрузить задания",
      "Ponownie załaduj zlecenia",
      "tooltip_restore_recover_jobs"
    ],
    restore_job: [
      "Restore Job",
      "Restore Job",
      "ジョブを復元",
      "恢复作业",
      "Projekt wiederherstellen",
      "Restaurer le dossier",
      "Ripristina lavoro",
      "Restaurar trabalho",
      "Restaurar trabajo",
      "Восстановить задание",
      "Przywróć zlecenie",
      "restore_job"
    ],
    restore_job_confirm_text: [
      "Are you sure you want to restore the job <b>${name}</b>?",
      "Are you sure you want to restore the job <b>${name}</b>?",
      "ジョブ「<b>${name}</b>」を復元してもよろしいですか?",
      "您确定要恢复此作业<b>${name}</b>吗？",
      "Wollen Sie das Projekt <b>${name}</b> wirklich wiederherstellen?",
      "Êtes-vous sûr de vouloir restaurer le dossier <b>${name}</b> ?",
      "Sei sicuro di voler ripristinar il lavoro <b>${name}</b>?",
      "Tem certeza de que quer restaurar o trabalho <b>${name}</b>?",
      "¿Seguro que desea restaurar el trabajo <b>${name}</b>?",
      "Вы уверены, что хотите восстановить задание <b>${name}</b>?",
      "Czy na pewno chcesz przywrócić zlecenie <b>${name}</b>?",
      "Are you sure you want to restore the job <b>${name}</b>?_ru-RU"
    ],
    no_data_restore_job: [
      "No job found to be restored",
      "No job found to be restored",
      "復元する対象のジョブが見つかりません",
      "找不到要恢复的作业",
      "Kein Projekt zum Wiederherstellen gefunden",
      "Aucun dossier trouvé",
      "Non sono stati trovati lavori da ripristinare",
      "Nenhum trabalho encontrado para ser restaurado",
      "No se ha encontrado ningún trabajo que restaurar",
      "Заданий для восстановления не найдено",
      "Nie znaleziono zlecenia do przywrócenia",
      "no_data_restore_job"
    ],
    restore_job_confirm_title: [
      "Restore Job",
      "Restore Job",
      "ジョブを復元",
      "恢复作业",
      "Projekt wiederherstellen",
      "Restaurer le dossier",
      "Ripristina lavoro",
      "Restaurar trabalho",
      "Restaurar trabajo",
      "Восстановить задание",
      "Przywróć zlecenie",
      "restore_job_confirm_title"
    ],
    recover_job_failed_toast: [
      "Failed to restore job",
      "Failed to restore job",
      "ジョブを復元できませんでした",
      "无法恢复作业",
      "Fehler beim Wiederherstellen des Projektes",
      "Échec de la restauration du dossier",
      "Ripristino lavoro fallito",
      "Falha ao restaurar trabalho",
      "Error al restaurar trabajo",
      "Не удалось восстановить задание",
      "Przywrócenie zlecenia nie powiodło się",
      "recover_job_failed_toast"
    ],
    restore_job_success_toast: [
      "Job restoration successful",
      "Job restoration successful",
      "ジョブの復元に成功しました",
      "作业恢复成功",
      "Projekt erfolgreich wiederhergestellt",
      "Le dossier a été restauré avec succès",
      "Ripristino lavoro riuscito",
      "Trabalho restaurado com sucesso",
      "Restauración de trabajo satisfactoria",
      "Задание успешно восстановлено",
      "Przywrócenie zlecenia powiodło się",
      "restore_job_success_toast"
    ],
    orgcust_name_not_valid: [
      "Name can not be more than 63 char",
      "Name can not be more than 63 char",
      "名前の長さの制限は63文字です",
      "名称不得超过63个字符",
      "Der Name darf nicht mehr als 63 Zeichen enthalten",
      "Le nom ne peut pas dépasser plus de 63 caract.",
      "Il nome può contenere al massimo 63 caratteri",
      "O nome não pode ter mais de 63 caracteres",
      "El nombre no puede tener más de 63 caracteres",
      "Длина названия не может превышать 63 знака",
      "Nazwa nie może zawierać więcej niż 63 znaków",
      "orgcust_name_not_valid"
    ],
    job_duplicate_error: [
      "Duplicate job found",
      "Duplicate job found",
      "ジョブの重複が見つかりました",
      "找到复制的作业",
      "Doppeltes Projekt gefunden",
      "Dupliquer le dossier trouvé",
      "Trovato lavoro duplicato",
      "Trabalho duplicado encontrado",
      "Se ha encontrado un trabajo duplicado",
      "Найдено дублирующееся задание",
      "Znaleziono duplikat zlecenia",
      "job_duplicate_error"
    ],
    job_duplicate_error_desc: [
      "Jobs with this name already exist",
      "Jobs with this name already exist",
      "この名前のジョブは既に存在します",
      "已存在相同名称的作业",
      "Es sind bereits Projekte mit diesem Namen vorhanden",
      "Des dossiers sous ce nom existent déjà",
      "Esistono già lavori con questo nome",
      "Já existem trabalhos com esse nome",
      "Ya hay trabajos con este nombre",
      "Задания с таким названием уже существуют",
      "Zlecenia o tej nazwie już istnieją",
      "job_duplicate_error_desc"
    ],
    test_edit_details: [
      "Edit details",
      "Edit details",
      "詳細を編集",
      "编辑详细资料",
      "Angaben bearbeiten",
      "Modifier les détails",
      "Modifica dettagli",
      "Editar detalhes",
      "Editar datos",
      "Изменить данные",
      "Edytuj szczegóły",
      "test_edit_details"
    ],
    find_and_replace_test_name: [
      "Find and replace test names",
      "Find and replace test names",
      "テスト名の検索と置換",
      "查找并替换测试名称",
      "Testnamen suchen und ersetzen",
      "Chercher et remplacer les noms de test",
      "Trova e sostituisci nomi prove",
      "Encontrar e substituir nomes de testes",
      "Buscar y reemplazar nombres de pruebas",
      "Найти и заменить названия тестов",
      "Znajdź i zamień nazwy testów",
      "find_and_replace_test_name"
    ],
    add_or_change_engineer: [
      "Add or change engineer",
      "Add or change engineer",
      "技術者を追加または変更",
      "添加或更改工程师",
      "Techniker hinzufügen oder bearbeiten",
      "Ajouter ou modifier le nom du technicien",
      "Aggiungi o modifica tecnico",
      "Adicionar ou alterar técnico",
      "Añadir o cambiar ingeniero",
      "Добавить или изменить инженера",
      "Dodaj lub zmień technika",
      "add_or_change_engineer"
    ],
    update_near_far_end_connector: [
      "Update near-end and far-end connector manufacturer",
      "Update near-end and far-end connector manufacturer",
      "近端および遠端コネクタのメーカーを更新",
      "更新近端和远端连接器制造商",
      "Hersteller der Verbinder am nahen und fernen Ende aktualisieren",
      "Mettre à jour le fabricant des connecteurs proches et distants",
      "Aggiorna produttore connettore prossimo e terminale",
      "Atualizar fabricante dos conectores das extremidades local e remota",
      "Actualizar fabricante de conector de extremo cercano y extremo lejano",
      "Обновить марку разъема ближнего и дальнего концов",
      "Aktualizuj informacje na temat producenta złącza zbliżnego i zdalnego",
      "update_near_far_end_connector"
    ],
    test_name_find: [
      "Find",
      "Find",
      "検索",
      "查找",
      "Suchen",
      "Chercher",
      "Trova",
      "Encontrar",
      "Buscar",
      "Найти",
      "Znajdź",
      "test_name_find"
    ],
    test_name_replace: [
      "Replace",
      "Replace",
      "置換",
      "替换",
      "Ersetzen",
      "Remplacer",
      "Sostituisci",
      "Substituir",
      "Reemplazar",
      "Заменить",
      "Zamień",
      "test_name_replace"
    ],
    test_name_find_helper: [
      "Please type the name of the test you would like to replace",
      "Please type the name of the test you would like to replace",
      "置換したいテスト名を入力してください",
      "请输入您要替换的测试名称",
      "Bitte tragen Sie den Namen des zu ersetzenden Tests ein",
      "Veuillez saisir le nom du test que vous souhaitez remplacer",
      "Digita il nome della prova che desideri sostituire",
      "Informe o nome do teste que quer substituir",
      "Escriba el nombre de la prueba que desea reemplazar",
      "Введите название теста, который хотите заменить",
      "Wpisz nazwę testu, który chcesz zamienić",
      "test_name_find_helper"
    ],
    test_name_replace_helper: [
      "Please type the replacement name",
      "Please type the replacement name",
      "置換後の名前を入力してください",
      "请输入替换名称",
      "Bitte tragen Sie den neuen Namen ein",
      "Veuillez saisir le nouveau nom",
      "Digita il nome della prova sostitutiva",
      "Informe o nome para substituição",
      "Escriba el nombre de reemplazo",
      "Введите новое название",
      "Wpisz nazwę zastępczą",
      "test_name_replace_helper"
    ],
    test_engineer_name: [
      "Engineer Name",
      "Engineer Name",
      "技術者の名前",
      "工程师姓名",
      "Name des Technikers",
      "Nom du technicien",
      "Nome tecnico",
      "Nome do técnico",
      "Nombre del ingeniero",
      "Имя инженера",
      "Nazwisko technika",
      "test_engineer_name"
    ],
    test_engineer_name_helper: [
      "Engineer",
      "Engineer",
      "技術者",
      "工程师",
      "Techniker",
      "Technicien",
      "Tecnico",
      "Técnico",
      "Ingeniero",
      "Инженер",
      "Technik",
      "test_engineer_name_helper"
    ],
    test_connector_brand_far_helper: [
      "Far-end Connector Manufacturer",
      "Far-end Connector Manufacturer",
      "遠端コネクタのメーカー",
      "远端连接器制造商",
      "Hersteller des fernen Steckverbinders",
      "Fabricant du connecteur distant",
      "Produttore connettore terminale",
      "Fabricante do conector da extremidade remota",
      "Fabricante del conector de extremo lejano",
      "Марка разъема дальнего конца",
      "Producent złącza zdalnego",
      "test_connector_brand_far_helper"
    ],
    testlist_couldnot_be_updated: [
      "Test ${tests} could not be updated",
      "Test ${tests} could not be updated",
      "テスト「${tests}」を更新できませんでした",
      "无法更新测试${tests}",
      "Test ${tests} konnte nicht aktualisiert werden",
      "Le test ${tests} n'a pas pu être mis à jour",
      "Non è stato possibile aggiornare la prova ${tests}",
      "O teste  ${tests} não pôde ser atualizado",
      "La prueba ${tests} no se ha podido actualizar",
      "Не удалось обновить тест ${tests}",
      "Aktualizacja testu ${tests} nie powiodła się",
      "testlist_couldnot_be_updated"
    ],
    test_name_couldnot_be_blanck: [
      "Test name could not be blank",
      "Test name could not be blank",
      "テスト名を空白にできません",
      "测试名称不能为空",
      "Es muss ein Testname angegeben werden",
      "Le nom du test ne peut pas être laissé vide",
      "Il campo nome prova non può essere vuoto",
      "O nome do teste não pode estar em branco",
      "El nombre de la prueba no puede estar en blanco",
      "Название теста не может быть пустым",
      "Nazwa testu nie może być pusta",
      "test_name_couldnot_be_blanck"
    ],
    systemdevicetype: [
      "Device Type",
      "Device Type",
      "デバイスタイプ",
      "设备类型",
      "Gerätetyp",
      "Type d'appareil",
      "Tipo dispositivo",
      "Tipo do Dispositivo",
      "Tipo de dispositivo",
      "Тип устройства",
      "Typ urządzenia",
      "systemdevicetype"
    ],
    "LanTEK IV": [
      "LanTEK IV",
      "LanTEK IV",
      "LanTEK IV",
      "LanTEK IV",
      "LanTEK IV",
      "LanTEK IV",
      "LanTEK IV",
      "LanTEK IV",
      "LanTEK IV",
      "LanTEK IV",
      "LanTEK IV",
      "LanTEK IV"
    ],
    "SignalTEK 10G": [
      "SignalTEK 10G",
      "SignalTEK 10G",
      "SignalTEK 10G",
      "SignalTEK 10G",
      "SignalTEK 10G",
      "SignalTEK 10G",
      "SignalTEK 10G",
      "SignalTEK 10G",
      "SignalTEK 10G",
      "SignalTEK 10G",
      "SignalTEK 10G",
      "SignalTEK 10G"
    ],
    "SignalTEK 1G": [
      "SignalTEK 1G",
      "SignalTEK 1G",
      "SignalTEK 1G",
      "SignalTEK 1G",
      "SignalTEK 1G",
      "SignalTEK 1G",
      "SignalTEK 1G",
      "SignalTEK 1G",
      "SignalTEK 1G",
      "SignalTEK 1G",
      "SignalTEK 1G",
      "SignalTEK 1G"
    ],
    "SignalTEK QT": [
      "SignalTEK QT",
      "SignalTEK QT",
      "SignalTEK QT",
      "SignalTEK QT",
      "SignalTEK QT",
      "SignalTEK QT",
      "SignalTEK QT",
      "SignalTEK QT",
      "SignalTEK QT",
      "SignalTEK QT",
      "SignalTEK QT",
      "SignalTEK QT"
    ],
    "SignalTEK QT Pro": [
      "SignalTEK QT PRO",
      "SignalTEK QT PRO",
      "SignalTEK QT PRO",
      "SignalTEK QT PRO",
      "SignalTEK QT PRO",
      "SignalTEK QT PRO",
      "SignalTEK QT PRO",
      "SignalTEK QT PRO",
      "SignalTEK QT PRO",
      "SignalTEK QT PRO",
      "SignalTEK QT PRO",
      "SignalTEK QT Pro"
    ],
    "NaviTEK III": [
      "NaviTEK III",
      "NaviTEK III",
      "NaviTEK III",
      "NaviTEK III",
      "NaviTEK III",
      "NaviTEK III",
      "NaviTEK III",
      "NaviTEK III",
      "NaviTEK III",
      "NaviTEK III",
      "NaviTEK III",
      "NaviTEK III"
    ],
    "NaviTEK III Pro": [
      "NaviTEK III PRO",
      "NaviTEK III PRO",
      "NaviTEK III PRO",
      "NaviTEK III PRO",
      "NaviTEK III PRO",
      "NaviTEK III PRO",
      "NaviTEK III PRO",
      "NaviTEK III PRO",
      "NaviTEK III PRO",
      "NaviTEK III PRO",
      "NaviTEK III PRO",
      "NaviTEK III Pro"
    ],
    "NaviTEK": [
      "NaviTEK III",
      "NaviTEK III",
      "NaviTEK III",
      "NaviTEK III",
      "NaviTEK III",
      "NaviTEK III",
      "NaviTEK III",
      "NaviTEK III",
      "NaviTEK III",
      "NaviTEK III",
      "NaviTEK III",
      "NaviTEK"
    ],
    "NaviTEK Pro": [
      "NaviTEK III PRO",
      "NaviTEK III PRO",
      "NaviTEK III PRO",
      "NaviTEK III PRO",
      "NaviTEK III PRO",
      "NaviTEK III PRO",
      "NaviTEK III PRO",
      "NaviTEK III PRO",
      "NaviTEK III PRO",
      "NaviTEK III PRO",
      "NaviTEK III PRO",
      "NaviTEK Pro"
    ],
    device_type: [
      "Select Device",
      "Select Device",
      "デバイスを選択",
      "选择设备",
      "Gerät auswählen",
      "Sélectionner l'équipement",
      "Seleziona dispositivo",
      "Selecionar dispositivo",
      "Seleccionar dispositivo",
      "Выберите устройство",
      "Wybierz urządzenie",
      "device_type"
    ],
    device_serialnumber_help1: [
      "Please enter the remaining serial number after ",
      "Please enter the remaining serial number after ",
      "シリアル番号の残りを入力してください：",
      "请在之后输入剩余的序列号 ",
      "Bitte geben Sie die restliche Seriennummer ein nach ",
      "Veuillez saisir le numéro de série restant après ",
      "Inserisci il numero di serie rimanente dopo ",
      "Informe o restante do número de série após ",
      "Introduzca el número de serie restante después de ",
      "Введите часть серийного номера после ",
      "Wpisz pozostały numer seryjny po ",
      "device_serialnumber_help1"
    ],
    device_serialnumber_help2: [
      "Device ID should be of format xxxxxxxx/xxxxxxxx",
      "Device ID should be of format xxxxxxxx/xxxxxxxx",
      "デバイスIDのフォーマットは「xxxxxxxx/xxxxxxxx」です",
      "设备ID的格式应为 xxxxxxxx/xxxxxxxx",
      "Die Geräte-ID muss das Format xxxxxxxx/xxxxxxxx besitzen",
      "L'ID de l'appareil doit être dans le format suivant xxxxxxxx/xxxxxxxx",
      "L’ID dispositivo deve essere nel formato xxxxxxxx/xxxxxxxx",
      "O ID do dispositivo deve estar no formato xxxxxxxx/xxxxxxxx",
      "La ID del dispositivo tiene que tener el formato xxxxxxxx/xxxxxxxx",
      "Идентификатор устройства должен иметь формат xxxxxxxx/xxxxxxxx",
      "Identyfikator urządzenia powinien mieć format xxxxxxxx / xxxxxxxx",
      "device_serialnumber_help2"
    ],
    signaltek10g: [
      "SignalTEK 10G",
      "SignalTEK 10G",
      "SignalTEK 10G",
      "SignalTEK 10G",
      "SignalTEK 10G",
      "SignalTEK 10G",
      "SignalTEK 10G",
      "SignalTEK 10G",
      "SignalTEK 10G",
      "SignalTEK 10G",
      "SignalTEK 10G",
      "signaltek10g"
    ],
    signaltekqt: [
      "SignalTEK QT",
      "SignalTEK QT",
      "SignalTEK QT",
      "SignalTEK QT",
      "SignalTEK QT",
      "SignalTEK QT",
      "SignalTEK QT",
      "SignalTEK QT",
      "SignalTEK QT",
      "SignalTEK QT",
      "SignalTEK QT",
      "signaltekqt"
    ],
    signaltekqtpro: [
      "SignalTEK QT Pro",
      "SignalTEK QT Pro",
      "SignalTEK QT Pro",
      "SignalTEK QT Pro",
      "SignalTEK QT Pro",
      "SignalTEK QT Pro",
      "SignalTEK QT Pro",
      "SignalTEK QT Pro",
      "SignalTEK QT Pro",
      "SignalTEK QT Pro",
      "SignalTEK QT Pro",
      "signaltekqtpro"
    ],
    signaltekqtorpro: [
      "SignalTEK QT / SignalTEK QT Pro",
      "SignalTEK QT / SignalTEK QT Pro",
      "SignalTEK QT / SignalTEK QT Pro",
      "SignalTEK QT / SignalTEK QT Pro",
      "SignalTEK QT / SignalTEK QT Pro",
      "SignalTEK QT / SignalTEK QT Pro",
      "SignalTEK QT / SignalTEK QT Pro",
      "SignalTEK QT / SignalTEK QT Pro",
      "SignalTEK QT / SignalTEK QT Pro",
      "SignalTEK QT / SignalTEK QT Pro",
      "SignalTEK QT / SignalTEK QT Pro",
      "signaltekqtorpro"
    ],
    navitekiii: [
      "NaviTEK III",
      "NaviTEK III",
      "NaviTEK III",
      "NaviTEK III",
      "NaviTEK III",
      "NaviTEK III",
      "NaviTEK III",
      "NaviTEK III",
      "NaviTEK III",
      "NaviTEK III",
      "NaviTEK III",
      "navitekiii"
    ],
    navitekiiipro: [
      "NaviTEK III Pro",
      "NaviTEK III Pro",
      "NaviTEK III Pro",
      "NaviTEK III Pro",
      "NaviTEK III Pro",
      "NaviTEK III Pro",
      "NaviTEK III Pro",
      "NaviTEK III Pro",
      "NaviTEK III Pro",
      "NaviTEK III Pro",
      "NaviTEK III Pro",
      "navitekiiipro"
    ],
    navitek: [
      "NaviTEK III",
      "NaviTEK III",
      "NaviTEK III",
      "NaviTEK III",
      "NaviTEK III",
      "NaviTEK III",
      "NaviTEK III",
      "NaviTEK III",
      "NaviTEK III",
      "NaviTEK III",
      "NaviTEK III",
      "navitek"
    ],
    navitekpro: [
      "NaviTEK III Pro",
      "NaviTEK III Pro",
      "NaviTEK III Pro",
      "NaviTEK III Pro",
      "NaviTEK III Pro",
      "NaviTEK III Pro",
      "NaviTEK III Pro",
      "NaviTEK III Pro",
      "NaviTEK III Pro",
      "NaviTEK III Pro",
      "NaviTEK III Pro",
      "navitekpro"
    ],
    navitekorpro: [
      "NaviTEK III",
      "NaviTEK III",
      "NaviTEK III",
      "NaviTEK III",
      "NaviTEK III",
      "NaviTEK III",
      "NaviTEK III",
      "NaviTEK III",
      "NaviTEK III",
      "NaviTEK III",
      "NaviTEK III",
      "navitekorpro"
    ],
    jobs_context_filter_device_type_panel: [
      "Device Type",
      "Device Type",
      "デバイスタイプ",
      "设备类型",
      "Gerätetyp",
      "Type d'appareil",
      "Tipo dispositivo",
      "Tipo do Dispositivo",
      "Tipo de dispositivo",
      "Тип устройства",
      "Typ urządzenia",
      "jobs_context_filter_device_type_panel"
    ],
    lantekIII: [
      "LanTEK-III",
      "LanTEK-III",
      "LanTEK-III",
      "LanTEK-III",
      "LanTEK-III",
      "LanTEK III",
      "LanTEK-III",
      "LanTEK-III",
      "LanTEK-III",
      "LanTEK-III",
      "LanTEK-III",
      "lantekIII"
    ],
    Comet: [
      "LanTEK IV-Fibre",
      "LanTEK IV-Fiber",
      "LanTEK IV-Fiber",
      "LanTEK IV-纤维",
      "LanTEK IV-Faser",
      "LanTEK IV Fibre",
      "LanTEK IV-Fibra",
      "LanTEK IV-Fibra",
      "LanTEK IV-Fibra",
      "LanTEK IV-волокно",
      "LanTEK IV-Włókno",
      "Comet"
    ],
    lantekiii: [
      "LanTEK-III",
      "LanTEK-III",
      "LanTEK-III",
      "LanTEK-III",
      "LanTEK-III",
      "LanTEK III",
      "LanTEK-III",
      "LanTEK-III",
      "LanTEK-III",
      "LanTEK-III",
      "LanTEK-III",
      "lantekiii"
    ],
    general_default_sub_test_settings: [
      "Default Sub Test Settings",
      "Default Sub Test Settings",
      "デフォルトのSubテスト設定",
      "默认子测试设置",
      "Untertest-Standardeinstellungen",
      "Paramètres du test secondaire par défaut",
      "Impostazioni predefinite subtest",
      "Configuração do subteste padrão",
      "Ajustes de subpruebas predeterminados",
      "Параметры подтеста по умолчанию",
      "Domyślne ustawienia testu podrzędnego",
      "general_default_sub_test_settings"
    ],
    general_sub_set_settings: [
      "SignalTEK 10G Defaul Sub Test Settings",
      "SignalTEK 10G Defaul Sub Test Settings",
      "SignalTEK 10G デフォルトのSubテスト設定",
      "SignalTEK 10G默认子测试设置",
      "Untertest-Standardeinstellungen für SignalTEK 10G",
      "Paramètres du test secondaire par défaut du SignalTEK 10G ",
      "Impostazioni predefinite subtest SignalTEK 10G",
      "Configuração do subteste padrão do SignalTEK 10G",
      "Ajustes de subpruebas predeterminados de SignalTEK 10G",
      "Параметры подтеста SignalTEK 10G по умолчанию",
      "Domyślne ustawienia testu podrzędnego SignalTEK 10G",
      "general_sub_set_settings"
    ],
    sub_set_network_tests: [
      "Network Tests",
      "Network Tests",
      "ネットワークテスト",
      "网络测试",
      "Netzwerktests",
      "Tests réseau",
      "Prova di rete",
      "Testes de Rede",
      "Pruebas de red",
      "Сетевые тесты",
      "Testy Sieciowe",
      "sub_set_network_tests"
    ],
    sub_set_transmission_tests: [
      "Transmission Tests",
      "Transmission Tests",
      "伝送テスト",
      "传输测试",
      "Übertragungstests",
      "Tests transmission",
      "Prova di trasmissione",
      "Testes de Transmissão",
      "Pruebas de transmisión",
      "Тесты параметров передачи",
      "Testy Transmisji",
      "sub_set_transmission_tests"
    ],
    sub_set_wiremap_st_tests: [
      "Cable Tests (SignalTEK 10G)",
      "Cable Tests (SignalTEK 10G)",
      "ケーブルテスト (SignalTEK 10G)",
      "电缆测试 (SignalTEK 10G)",
      "Kabeltests (SignalTEK 10G)",
      "Tests de câbles (SignalTEK 10G)",
      "Test dei cavi (SignalTEK 10G)",
      "Testes de cabos (SignalTEK 10G)",
      "Pruebas de cable (SignalTEK 10G)",
      "Тестирование кабеля (SignalTEK 10G)",
      "Testy kabli (SignalTEK 10G)",
      "sub_set_wiremap_st_tests"
    ],
    sub_set_poe_tests: [
      "PoE Tests",
      "PoE Tests",
      "PoEテスト",
      "PoE测试",
      "PoE-Tests",
      "Tests PoE",
      "Prova PoE",
      "Testes de PoE",
      "Pruebas PoE",
      "Тесты PoE",
      "Testy PoE",
      "sub_set_poe_tests"
    ],
    sub_set_fiber_st_tests: [
      "Fibre Tests (SignalTEK 10G)",
      "Fiber Tests (SignalTEK 10G)",
      "光ファイバーテスト (SignalTEK 10G)",
      "光纤测试 (SignalTEK 10G)",
      "Glasfasertests (SignalTEK 10G)",
      "Tests de fibre (SignalTEK 10G)",
      "Test della fibra (SignalTEK 10G)",
      "Testes de fibra (SignalTEK 10G)",
      "Pruebas de fibra (SignalTEK 10G)",
      "Тестирование оптоволокна (SignalTEK 10G)",
      "Testy światłowodów (SignalTEK 10G)",
      "sub_set_fiber_st_tests"
    ],
    sub_set_wiremap_nt_tests: [
      "Cable Tests (NaviTEK III)",
      "Cable Tests (NaviTEK III)",
      "ケーブルテスト (NaviTEK III)",
      "电缆测试 (NaviTEK III)",
      "Kabeltests (NaviTEK III)",
      "Tests de câbles (NaviTEK III)",
      "Test dei cavi (NaviTEK III)",
      "Testes de cabos (NaviTEK III)",
      "Pruebas de cable (NaviTEK III)",
      "Тестирование кабеля (NaviTEK III)",
      "Testy kabli (NaviTEK III)",
      "sub_set_wiremap_nt_tests"
    ],
    sub_set_fiber_nt_tests: [
      "Fibre Tests (NaviTEK III)",
      "Fiber Tests (NaviTEK III)",
      "光ファイバーテスト (NaviTEK III)",
      "光纤测试 (NaviTEK III)",
      "Glasfasertests (NaviTEK III)",
      "Tests de fibre (NaviTEK III)",
      "Test della fibra (NaviTEK III)",
      "Testes de fibra (NaviTEK III)",
      "Pruebas de fibra (NaviTEK III)",
      "Тестирование оптоволокна (NaviTEK III)",
      "Testy światłowodów (NaviTEK III)",
      "sub_set_fiber_nt_tests"
    ],
    sub_set_edit: [
      "Edit",
      "Edit",
      "編集",
      "编辑",
      "Bearbeiten",
      "Éditer",
      "Modifica",
      "Editar",
      "Editar",
      "Изменить",
      "Edytuj",
      "sub_set_edit"
    ],
    fiberlength_setup: [
      "Fibre Length Settings",
      "Fiber Length Settings",
      "繊維長設定",
      "纤维长度设置",
      "Faserlängeneinstellungen",
      "Paramètres de longueur des fibres",
      "Impostazioni della lunghezza della fibra",
      "Definições do comprimento da fibra",
      "Configuración de la longitud de la fibra",
      "Настройки длины волокна",
      "Ustawienia długości włókna"

    ],
    fiberlengthloss_setup: [
      "Fibre Length & Loss Settings",
      "Fiber Length & Loss Settings",
      "ファイバーの長さと損失設定",
      "光纤长度和损耗设置",
      "Einstellungen für Faserlänge und Verluste",
      "Paramètres de longueur et perte fibre",
      "Impostazioni per Lunghezza & Perdita della Fibra",
      "Configuração de Perda e Comprimento",
      "Configuración de longitud y pérdida de fibra",
      "Настройки длины волокна и потерь",
      "Ustawienia długości i straty w światłowodzie",
      "fiberlengthloss_setup"
    ],
    fiber_test_unidir: [
      "Uni-Directional",
      "Uni-Directional",
      "単方向",
      "单向",
      "Unidirektional",
      "Unidirectionnel",
      "Uni-direzionale",
      "Unidirecional",
      "Unidireccional",
      "Однонаправленный",
      "Jednokierunkowy",
      "fiber_test_unidir"
    ],
    fiber_test_bidir: [
      "Bi-Directional",
      "Bi-Directional",
      "双方向",
      "双向",
      "Bidirektional",
      "Bidirectionnel",
      "Bi-direzionale",
      "Bidirecional",
      "Bidireccional",
      "Двунаправленный",
      "Wielokierunkowy",
      "fiber_test_bidir"
    ],
    single_fiber: [
      "Single Fibre / WDM SFP",
      "Single Fiber / WDM SFP",
      "単一繊維 / WDM SFP",
      "单光纤 / WDM SFP",
      "Einzelfaser / WDM SFP",
      "Fibre Simplex / SFP WDM",
      "Fibra Singola / SFP WDM",
      "Fibra Única / SFP WDM",
      "Fibra única / SFP WDM ",
      "Одно волокно / WDM SFP",
      "Pojedynczy światłowód / WDM SFP",
      "single_fiber"
    ],
    dual_fiber: [
      "Dual Fibre / Duplex SFP",
      "Dual Fiber / Duplex SFP",
      "デュアルファイバー /デュプレックスSFP",
      "双光纤 /双工SFP",
      "Dual Faser / Duplex SFP",
      "Fibre duplex / SFP duplex",
      "Fibra Doppia / SFP duplex",
      "Fibra Dupla / SFP Duplex",
      "Fibra doble / SFP dúplex",
      "Два волокна / дуплекс SFP",
      "Podwójne włókno / Duplex SFP",
      "dual_fiber"
    ],
    sfp_type: [
      "SFP Type",
      "SFP Type",
      "SFPタイプ",
      "SFP类型",
      "SFP Typ",
      "Type de SFP",
      "Tipo SFP",
      "Tipo do SFP",
      "Tipo de SFP",
      "Тип SFP",
      "Typ SFP",
      "sfp_type"
    ],
    sfp_info: [
      "SFP Info",
      "SFP Info",
      "SFP 情報",
      "SFP信息",
      "SFP-Info",
      "Informations SFP",
      "Informazioni SFP",
      "Informações SFP",
      "Información SFP",
      "Информация о SFP",
      "Informacje o SFP",
      "sfp_info"
    ],
    fiber_type: [
      "Fibre Type",
      "Fiber Type",
      "ファイバータイプ",
      "光纤类型",
      "Glasfasertyp",
      "Type de fibre",
      "Tipo di Fibra",
      "Tipo de fibra",
      "Tipo de fibra",
      "Тип волокна",
      "Typ włókna",
      "fiber_type"
    ],
    speed_type: [
      "Speed",
      "Speed",
      "スピード",
      "速度",
      "Geschwindigkeit",
      "Vitesse",
      "Velocità",
      "Velocidade",
      "Velocidad",
      "Скорость",
      "Prędkość",
      "speed_type"
    ],
    "2_fibers_pair": [
      "2-Fibres/Pair",
      "2-Fibers/Pair",
      "2ファイバー/ペア",
      "2 根光纤/对",
      "2-Fasern/Paar",
      "2-fibres/paire",
      "2-fibre/coppia",
      "2-fibras/par",
      "2 fibras/par",
      "2-волокна/пара",
      "2-włókna/para",
      "2_fibers_pair"
    ],
    "1_fiber_loop": [
      "1-Fibre/Loop",
      "1-Fiber/Loop",
      "1ファイバー/ループ",
      "1 光纤/环路",
      "1-Faser/Loop",
      "1-fibre/boucle",
      "1-fibra/loop",
      "1-fibra/loop",
      "1 fibra/bucle",
      "1-волокно/петля",
      "1-błonnik/pętla",
      "1_fiber_loop"
    ],
    test_method: [
      "Test Method",
      "Test Method",
      "試験方法",
      "测试方法",
      "Testmethode",
      "Méthode de test",
      "Metodo di prova",
      "Método de teste",
      "Método de prueba",
      "Метод испытания",
      "Metoda testowa",
      "test_method"
    ],
    one_jumper: [
      "1 Jumper",
      "1 Jumper",
      "1 ジャンパー",
      "跳线1",
      "1 Jumper",
      "1 jarretière",
      "Jumper 1",
      "1-Jumper",
      "1-Jumper",
      "1 перемычка",
      "Patchcord 1",
      "one_jumper",
    ],
    two_jumper: [
      "2 Jumper",
      "2 Jumper",
      "2 ジャンパー",
      "跳线2",
      "2 Jumper",
      "2 jarretière",
      "Jumper 2",
      "2-Jumper",
      "2-Jumper",
      "2 перемычка",
      "Patchcord 2",
      "two_jumper",
    ],
    three_jumper: [
      "3 Jumper",
      "3 Jumper",
      "3 ジャンパー",
      "跳线3",
      "3 Jumper",
      "3 jarretière",
      "Jumper 3",
      "3-Jumper",
      "3-Jumper",
      "3 перемычка",
      "Patchcord 3",
      "three_jumper",
    ],
    fiber_test_method_info: [
      "1 Jumper: the most accurate measurement but limit on LC connector test<br/> \
      2 Jumper: the most convenient and common measurement but with extra loss error introduced<br/> \
      3 Jumper: the universal connectors supported with worst loss error introduced",
      "1 Jumper: the most accurate measurement but limit on LC connector test<br/> \
      2 Jumper: the most convenient and common measurement but with extra loss error introduced<br/> \
      3 Jumper: the universal connectors supported with worst loss error introduced",
      "1 ジャンパー: 最も正確な測定ですが、LC コネクタ テストの限界です<br/> \
      2 ジャンパー: 最も便利で一般的な測定ですが、余分な損失誤差が生じます<br/> \
      3 ジャンパー: 最悪の損失エラーが導入されたユニバーサル コネクタがサポートされています",
      "跳线1：最准确的测量，但对 LC 连接器测试有限制<br/> \
      跳线2：最方便和常用的测量，但引入了额外的损耗误差<br/> \
      跳线3：支持的通用连接器，引入了最严重的损耗错误",
      "1 Jumper: die genaueste Messung, aber Einschränkung beim LC-Anschlusstest<br/> \
      2 Jumper: Die bequemste und gebräuchlichste Messung, aber mit zusätzlichem Verlustfehler<br/> \
      3 Jumper: Die universellen Anschlüsse, die mit dem Worst-Loss-Fehler unterstützt werden, wurden eingeführt",
      "1 jarretière : la mesure la plus précise mais limite le test du connecteur LC<br/> \
      2 jarretière : la mesure la plus pratique et la plus courante, mais avec une erreur de perte supplémentaire introduite<br/> \
      3 jarretière : les connecteurs universels pris en charge avec la pire erreur de perte introduite",
      "Jumper 1: la misurazione più accurata ma limite nel test del connettore LC<br/> \
      Jumper 2: la misura più comoda e comune ma con l'introduzione di un errore di perdita extra<br/> \
      Jumper 3: i connettori universali supportati con il peggior errore di perdita introdotto",
      "1-Jumper: a medição mais precisa, mas limita o teste do conector LC<br/> \
      2-Jumper: a medição mais conveniente e comum, mas com erro de perda extra introduzido<br/> \
      3-Jumper: os conectores universais suportados com o pior erro de perda introduzido",
      "1-Jumper: la medida más precisa pero límite en la prueba del conector LC<br/> \
      2-Jumper: la medida más conveniente y común pero con error de pérdida adicional introducido<br/> \
      3-Jumper: los conectores universales admitidos con el peor error de pérdida introducido",
      "1 перемычка: наиболее точное измерение, но ограничение при тестировании разъема LC<br/> \
      2 перемычка: наиболее удобное и распространенное измерение, но с дополнительной ошибкой потерь<br/> \
      3 перемычка: введены универсальные разъемы, поддерживаемые с наибольшей ошибкой потерь",
      "Patchcord 1: najdokładniejszy pomiar, ale ograniczenie testu złącza LC<br/> \
      Patchcord 2: najwygodniejszy i najbardziej powszechny pomiar, ale z dodatkowym błędem strat<br/> \
      Patchcord 3: obsługiwane uniwersalne złącza z wprowadzonym najgorszym błędem utraty",
      "fiber_test_method_info"
    ],
    fiber_std_attenuation_limit_info: [
      "Attenuation @ 850nm MM&Tab;&#8804; 3.0 dB/km<br/> \
      Attenuation @ 1300/1310nm MM<br/> \
      &Tab;&Tab;&Tab;&#8804; 1.5 dB/km<br/> \
      Attenuation @ 1270/1310/1330nm SM<br/> \
      &Tab;&Tab;&Tab;&#8804; 1.0 dB/km @OS1<br/> \
      &Tab;&Tab;&Tab;&#8804; 0.4 dB/km @OS2<br/> \
      Attenuation @ 1490/1550nm SM<br/> \
      &Tab;&Tab;&Tab;&#8804; 1.0 dB/km @OS1<br/> \
      &Tab;&Tab;&Tab;&#8804; 0.3 dB/km @OS2",

      "Attenuation @ 850nm MM&Tab;&#8804; 3.0 dB/km<br/> \
      Attenuation @ 1300/1310nm MM<br/> \
      &Tab;&Tab;&Tab;&#8804; 1.5 dB/km<br/> \
      Attenuation @ 1270/1310/1330nm SM<br/> \
      &Tab;&Tab;&Tab;&#8804; 1.0 dB/km @OS1<br/> \
      &Tab;&Tab;&Tab;&#8804; 0.4 dB/km @OS2<br/> \
      Attenuation @ 1490/1550nm SM<br/> \
      &Tab;&Tab;&Tab;&#8804; 1.0 dB/km @OS1<br/> \
      &Tab;&Tab;&Tab;&#8804; 0.3 dB/km @OS2",

      "減衰 @ 850nm MM&Tab;&#8804; 3.0 dB/km<br/> \
      減衰 @ 1300/1310nm MM<br/> \
      &Tab;&Tab;&Tab;&#8804; 1.5 dB/km<br/> \
      減衰 @ 1270/1310/1330nm SM<br/> \
      &Tab;&Tab;&Tab;&#8804; 1.0 dB/km @OS1<br/> \
      &Tab;&Tab;&Tab;&#8804; 0.4 dB/km @OS2<br/> \
      減衰 @ 1490/1550nm SM<br/> \
      &Tab;&Tab;&Tab;&#8804; 1.0 dB/km @OS1<br/> \
      &Tab;&Tab;&Tab;&#8804; 0.3 dB/km @OS2",

      "衰减 @ 850nm MM&Tab;&#8804; 3.0 分贝/千米<br/> \
      衰减 @ 1300/1310nm MM<br/> \
      &Tab;&Tab;&Tab;&#8804; 1.5 分贝/千米<br/> \
      衰减 @ 1270/1310/1330nm SM<br/> \
      &Tab;&Tab;&Tab;&#8804; 1.0 分贝/千米 @OS1<br/> \
      &Tab;&Tab;&Tab;&#8804; 0.4 分贝/千米 @OS2<br/> \
      衰减 @ 1490/1550nm SM<br/> \
      &Tab;&Tab;&Tab;&#8804; 1.0 分贝/千米 @OS1<br/> \
      &Tab;&Tab;&Tab;&#8804; 0.3 分贝/千米 @OS2",

      "Dämpfung @ 850nm MM&Tab;&#8804; 3.0 dB/km<br/> \
      Dämpfung @ 1300/1310nm MM<br/> \
      &Tab;&Tab;&Tab;&#8804; 1.5 dB/km<br/> \
      Dämpfung @ 1270/1310/1330nm SM<br/> \
      &Tab;&Tab;&Tab;&#8804; 1.0 dB/km @OS1<br/> \
      &Tab;&Tab;&Tab;&#8804; 0.4 dB/km @OS2<br/> \
      Dämpfung @ 1490/1550nm SM<br/> \
      &Tab;&Tab;&Tab;&#8804; 1.0 dB/km @OS1<br/> \
      &Tab;&Tab;&Tab;&#8804; 0.3 dB/km @OS2",

      "Atténuation @ 850nm MM&Tab;&#8804; 3.0 dB/km<br/> \
      Atténuation @ 1300/1310nm MM<br/> \
      &Tab;&Tab;&Tab;&#8804; 1.5 dB/km<br/> \
      Atténuation @ 1270/1310/1330nm SM<br/> \
      &Tab;&Tab;&Tab;&#8804; 1.0 dB/km @OS1<br/> \
      &Tab;&Tab;&Tab;&#8804; 0.4 dB/km @OS2<br/> \
      Atténuation @ 1490/1550nm SM<br/> \
      &Tab;&Tab;&Tab;&#8804; 1.0 dB/km @OS1<br/> \
      &Tab;&Tab;&Tab;&#8804; 0.3 dB/km @OS2",

      "Attenuazione @ 850nm MM&Tab;&#8804; 3.0 dB/km<br/> \
      Attenuazione @ 1300/1310nm MM<br/> \
      &Tab;&Tab;&Tab;&#8804; 1.5 dB/km<br/> \
      Attenuazione @ 1270/1310/1330nm SM<br/> \
      &Tab;&Tab;&Tab;&#8804; 1.0 dB/km @OS1<br/> \
      &Tab;&Tab;&Tab;&#8804; 0.4 dB/km @OS2<br/> \
      Attenuazione @ 1490/1550nm SM<br/> \
      &Tab;&Tab;&Tab;&#8804; 1.0 dB/km @OS1<br/> \
      &Tab;&Tab;&Tab;&#8804; 0.3 dB/km @OS2",

      "Atenuação @ 850nm MM&Tab;&#8804; 3.0 dB/km<br/> \
      Atenuação @ 1300/1310nm MM<br/> \
      &Tab;&Tab;&Tab;&#8804; 1.5 dB/km<br/> \
      Atenuação @ 1270/1310/1330nm SM<br/> \
      &Tab;&Tab;&Tab;&#8804; 1.0 dB/km @OS1<br/> \
      &Tab;&Tab;&Tab;&#8804; 0.4 dB/km @OS2<br/> \
      Atenuação @ 1490/1550nm SM<br/> \
      &Tab;&Tab;&Tab;&#8804; 1.0 dB/km @OS1<br/> \
      &Tab;&Tab;&Tab;&#8804; 0.3 dB/km @OS2",

      "Atenuación @ 850nm MM&Tab;&#8804; 3.0 dB/km<br/> \
      Atenuación @ 1300/1310nm MM<br/> \
      &Tab;&Tab;&Tab;&#8804; 1.5 dB/km<br/> \
      Atenuación @ 1270/1310/1330nm SM<br/> \
      &Tab;&Tab;&Tab;&#8804; 1.0 dB/km @OS1<br/> \
      &Tab;&Tab;&Tab;&#8804; 0.4 dB/km @OS2<br/> \
      Atenuación @ 1490/1550nm SM<br/> \
      &Tab;&Tab;&Tab;&#8804; 1.0 dB/km @OS1<br/> \
      &Tab;&Tab;&Tab;&#8804; 0.3 dB/km @OS2",

      "затухание @ 850nm MM&Tab;&#8804; 3.0 дБ/км<br/> \
      затухание @ 1300/1310nm MM<br/> \
      &Tab;&Tab;&Tab;&#8804; 1.5 дБ/км<br/> \
      затухание @ 1270/1310/1330nm SM<br/> \
      &Tab;&Tab;&Tab;&#8804; 1.0 дБ/км @OS1<br/> \
      &Tab;&Tab;&Tab;&#8804; 0.4 дБ/км @OS2<br/> \
      затухание @ 1490/1550nm SM<br/> \
      &Tab;&Tab;&Tab;&#8804; 1.0 дБ/км @OS1<br/> \
      &Tab;&Tab;&Tab;&#8804; 0.3 дБ/км @OS2",

      "Attenuation @ 850nm MM&Tab;&#8804; 3.0 dB/km<br/> \
      Attenuation @ 1300/1310nm MM<br/> \
      &Tab;&Tab;&Tab;&#8804; 1.5 dB/km<br/> \
      Attenuation @ 1270/1310/1330nm SM<br/> \
      &Tab;&Tab;&Tab;&#8804; 1.0 dB/km @OS1<br/> \
      &Tab;&Tab;&Tab;&#8804; 0.4 dB/km @OS2<br/> \
      Attenuation @ 1490/1550nm SM<br/> \
      &Tab;&Tab;&Tab;&#8804; 1.0 dB/km @OS1<br/> \
      &Tab;&Tab;&Tab;&#8804; 0.3 dB/km @OS2",

      "fiber_std_attenuation_limit_info"
    ],
    maximum_length: [
      "Maximum Length",
      "Maximum Length",
      "最大長",
      "最大长度",
      "Maximale Länge",
      "Longueur maximale",
      "Lunghezza Massima",
      "Comprimento máximo",
      "Longitud máxima",
      "Максимальная длина",
      "Maksymalna Długość",
      "maximum_length"
    ],
    splice_count: [
      "Number of splices",
      "Number of splices",
      "スプライスの数",
      "熔接数量",
      "Anzahl der Verbindungen",
      "Nombre de soudures",
      "Numero di giunzioni",
      "Número de Emendas",
      "Número de empalmes",
      "Количество сращиваний",
      "Liczba spawów",
      "splice_count"
    ],
    splice_loss: [
      "Loss per splice (dB)",
      "Loss per splice (dB)",
      "スプライスあたりの損失 (dB)",
      "每个熔接点损耗 （dB)",
      "Verlust pro Spleiß (dB)",
      "Perte par soudure (dB)",
      "Perdita per giunzione (dB)",
      "Perda por emenda (dB)",
      "Pérdida por empalme (dB)",
      "Потеря на сплайс (дБ)",
      "Strata na spawie (dB)",
      "splice_loss"
    ],
    adapter_count: [
      "Number of adapters",
      "Number of adapters",
      "アダプターの数",
      "适配器数量",
      "Anzahl der Adapter",
      "Nombre de connexions",
      "Numero di adattatori",
      "Número de Adaptadores",
      "Número de adaptadores",
      "Количество адаптеров",
      "Liczba adapterów",
      "adapter_count"
    ],
    adapter_loss: [
      "Loss per adapter (dB)",
      "Loss per adapter (dB)",
      "アダプターあたりの損失 (dB)",
      "每个适配器损耗 (dB)",
      "Verlust pro Adapter (dB)",
      "Perte par connecteur (dB)",
      "Perdita per Adattatore (dB)",
      "Perda do Adaptador (dB)",
      "Pérdida por adaptador (dB)",
      "Потери в адаптере (дБ)",
      "Strata na adapter (dB)",
      "adapter_loss"
    ],
    apply_standard_attenuation_limit: [
      "Apply Standard Attenuation Limit",
      "Apply Standard Attenuation Limit",
      "標準の減衰制限を適用します",
      "应用标准衰减门限",
      "Wenden Sie eine Standarddämpfungsgrenze an",
      "Appliquer la limite d&apos;atténuation de la norme",
      "Applicare Limite di Attenuazione Standard",
      "Aplicar Limite de Atenuação da Norma",
      "Aplicar límite de atenuación estándar",
      "Применить стандартные лимиты затухания",
      "Zastosuj limit tłumienia ze standardem",
      "apply_standard_attenuation_limit"
    ],
    fiber_attenuation_limit: [
      "Fibre Attenuation Limit (dB/km)",
      "Fiber Attenuation Limit (dB/km)",
      "ファイバー減衰限界 (dB/km)",
      "光纤衰减限值 (dB/km)",
      "Faserdämpfungsgrenze (dB/km)",
      "Limite d'atténuation de la fibre (dB/km)",
      "Limite di attenuazione della fibra (dB/km)",
      "Limite de Atenuação de Fibra (dB/km)",
      "Límite de atenuación de fibra (dB/km)",
      "Предел затухания волокна (дБ/км)",
      "Limit tłumienia światłowodu (dB/km)",
      "fiber_attenuation_limit"
    ],
    fiber_length_loss_limit_type: [
      "Length & Loss Limit Type",
      "Length & Loss Limit Type",
      "長さと損失制限タイプ",
      "长度和损耗门限类型",
      "Typ der Längen- und Dämpfungslimits",
      "Type de limite de longueur et perte",
      "Tipo di limite per Lunghezza e Perdita",
      "Tipo de Limite de Comprimento e Perda",
      "Tipo de límite de longitud y pérdida",
      "Тип лимита длины и потери",
      "Rodzaj limitu długości i strat",
      "fiber_length_loss_limit_type",
    ],
    length_or_wiremap: [
      "Length (Fibre) / Wiremap (Copper)",
      "Length (Fiber) / Wiremap (Copper)",
      "長さ（光ファイバー）/ ワイヤーマップ（銅線）",
      "长度（光纤）/ 线序图（铜缆）",
      "Länge (Glasfaser) / Wiremap (Kupfer)",
      "Longueur (Fibre) / Schéma de câblage (Cuivre)",
      "Lunghezza (Fibra) / Mappa dei collegamenti (Rame)",
      "Comprimento (Fibra) / Mapa de Cablagem (Cobre)",
      "Longitud (Fibra) / Mapa de cableado (Cobre)",
      "Длина (Оптоволокно) / Схема разводки (Медь)",
      "Długość (Światłowód) / Mapa okablowania (Miedź)",
      "length_or_wiremap"
    ],
    cable: [
      "Cable",
      "Cable",
      "ケーブル",
      "电缆",
      "Kabel",
      "Câble",
      "Cavo",
      "Cabo",
      "Cable",
      "Кабель",
      "Kabel",
      "cable"
    ],
    network: [
      "Network",
      "Network",
      "ネットワーク",
      "网络",
      "Netzwerk",
      "Réseau",
      "Rete",
      "Rede",
      "Red",
      "Сеть",
      "Sieć",
      "network"
    ],
    subset_ping_count: [
      "Count",
      "Count",
      "数",
      "计数",
      "Zähler",
      "Décompter",
      "Conteggio",
      "Contagem",
      "Contar",
      "Счетчик",
      "Licz",
      "subset_ping_count"
    ],
    subset_ping_count_help: [
      "Placeholder",
      "Placeholder",
      "プレースホルダ―",
      "占位符",
      "Platzhalter",
      "Caractère générique",
      "Segnaposto",
      "Marcador",
      "Marcador",
      "Заполнитель",
      "Symbol zastępczy",
      "subset_ping_count_help"
    ],
    subset_ping_pause: [
      "Pause (ms)",
      "Pause (ms)",
      "一時停止 (ms)",
      "暂停（毫秒）",
      "Pause (ms)",
      "Pause (ms)",
      "Pausa (ms)",
      "Pausa (ms)",
      "Pausa (ms)",
      "Пауза (мс)",
      "Pauza (ms)",
      "subset_ping_pause"
    ],
    subset_ping_length: [
      "Length",
      "Length",
      "長さ",
      "长度",
      "Länge",
      "Longueur",
      "Lunghezza",
      "Comprimento",
      "Longitud",
      "Длина",
      "Długość",
      "subset_ping_length"
    ],
    subset_ping_length_help: [
      "Placeholder",
      "Placeholder",
      "プレースホルダ―",
      "占位符",
      "Platzhalter",
      "Placeholder",
      "Segnaposto",
      "Marcador",
      "Marcador",
      "Заполнитель",
      "Symbol zastępczy",
      "subset_ping_length_help"
    ],
    sub_set_ping_targets: [
      "Targets",
      "Targets",
      "ターゲット",
      "目标",
      "Ziele",
      "Cibles",
      "Target",
      "Destinos",
      "Destinos",
      "Целевые адреса",
      "Cele",
      "sub_set_ping_targets"
    ],
    sub_set_ping_target: [
      "Target",
      "Target",
      "ターゲット",
      "目标",
      "Ziel",
      "Cible",
      "Target",
      "Destino",
      "Destino",
      "Целевой адрес",
      "Cel",
      "sub_set_ping_target"
    ],
    subset_ping_add_target: [
      "Add a Target",
      "Add a Target",
      "ターゲットを追加",
      "添加目标",
      "Ziel hinzufügen",
      "Ajouter une cible",
      "Aggiungi un target",
      "Adicionar um destino",
      "Añadir un destino",
      "Добавить целевой адрес",
      "Dodaj cel",
      "subset_ping_add_target"
    ],
    sub_set_ping_save_target: [
      "Save",
      "Save",
      "保存",
      "保存",
      "Speichern",
      "Sauvegarder",
      "Salva",
      "Salvar",
      "Ahorrar",
      "Сохранить",
      "Zapisz",
      "sub_set_ping_save_target"
    ],
    sub_set_ping_select_target: [
      "Select",
      "Select",
      "選択",
      "选择",
      "Auswählen",
      "Sélectionner",
      "Seleziona",
      "Selecionar",
      "Seleccionar",
      "Выбрать",
      "Wybierz",
      "sub_set_ping_save_target"
    ],
    general_sub_test_settings: [
      "Default Sub Test Settings",
      "Default Sub Test Settings",
      "デフォルトのSubテスト設定",
      "默认子测试设置",
      "Untertest-Standardeinstellungen",
      "Paramètres par défaut du sous-test",
      "Impostazioni predefinite subtest",
      "Configuração do subteste padrão",
      "Ajustes de subpruebas predeterminados",
      "Параметры подтеста по умолчанию",
      "Domyślne ustawienia testu podrzędnego",
      "general_sub_test_settings"
    ],
    general_sub_test_qualification: [
      "Qualification Settings",
      "Qualification Settings",
      "資格設定",
      "资质设置",
      "Qualifikationseinstellungen",
      "Paramètres de qualification",
      "Impostazioni di qualificazione",
      "Configurações de qualificação",
      "Configuración de calificación",
      "Настройки квалификации",
      "Ustawienia kwalifikacji",
      "general_sub_test_qualification"
    ],
    general_sub_test_fiber_qualification: [
      "Fibre Qualification Settings",
      "Fiber Qualification Settings",
      "ファイバー適格性設定",
      "光纤鉴定设置",
      "Einstellungen zur Faserqualifikation",
      "Paramètres de qualification de la fibre",
      "Impostazioni di qualificazione della fibra",
      "Configurações de qualificação de fibra",
      "Configuración de calificación de fibra",
      "Настройки квалификации волокна",
      "Ustawienia kwalifikacji włókien",
      "general_sub_test_fiber_qualification"
    ],
    link_qualification: [
      "Link Qualification",
      "Link Qualification",
      "リンク資格",
      "链接资质",
      "Link-Qualifikation",
      "Qualification du lien",
      "Qualificazione del collegamento",
      "Qualificação de ligação",
      "Calificación del enlace",
      "Ссылка Квалификация",
      "Kwalifikacja łącza",
      "link_qualification"
    ],
    length_only: [
      "Length Only",
      "Length Only",
      "長さのみ",
      "仅长度",
      "Nur Länge",
      "Longueur seule",
      "Solo lunghezza",
      "Apenas comprimento",
      "Solo longitud",
      "Только длина",
      "Tylko długość",
      "length_only"
    ],
    shield_test: [
      "Shield Test",
      "Shield Test",
      "シールドテスト",
      "屏蔽测试",
      "Schirmtest",
      "Test de blindage",
      "Prova di schermatura",
      "Teste de blindagem",
      "Prueba de blindaje",
      "Тест щита",
      "Próba tarczy",
      "shield_test"
    ],
    general_sub_test_ping4: [
      "Ping4 Settings",
      "Ping4 Settings",
      "Ping4設定",
      "Ping4设置",
      "Ping4-Einstellungen",
      "Paramètres Ping IpV4",
      "Impostazioni Ping4",
      "Configuração Ping4",
      "Ajustes de Ping4",
      "Параметры Ping4",
      "Ustawienia Ping4 ",
      "general_sub_test_ping4"
    ],
    general_sub_test_ping6: [
      "Ping6 Settings",
      "Ping6 Settings",
      "Ping6設定",
      "Ping6设置",
      "Ping6-Einstellungen",
      "Paramètres Ping IpV6",
      "Impostazioni Ping6",
      "Configuração Ping6",
      "Ajustes de Ping6",
      "Параметры Ping6",
      "Ustawienia Ping6",
      "general_sub_test_ping6"
    ],
    sub_test_ping_validation_range: [
      "${name} should be in the range of ${value1} to ${value2}",
      "${name} should be in the range of ${value1} to ${value2}",
      "${name}の値は${value1}～${value2}の範囲である必要があります",
      "${name}应该在${value1}至${value2}之间的范围内",
      "${name} muss im Bereich von ${value1} bis ${value2} liegen",
      "${name} doit se situer entre ${value1} et ${value2}",
      "${name} deve essere compreso tra ${value1} e ${value2}",
      "${name} deve estar entre ${value1} e ${value2}",
      "${name} debe estar entre ${value1} y ${value2}",
      "${name} должно быть в пределах от ${value1} до ${value2}",
      "${name} powinna mieścić się w przedziale od ${value1} do ${value2}",
      "sub_test_ping_validation_range"
    ],
    sub_set_ipv_targets: [
      "IP Targets",
      "IP Targets",
      "IPターゲット",
      "IP目标",
      "IP-Ziele",
      "Cibles IP",
      "Target IP",
      "Destinos IP",
      "Destinos IP",
      "Целевые IP",
      "Cele IP",
      "sub_set_ipv_targets"
    ],
    sub_test_ping_delete_confirm_title: [
      "${name} SETTINGS",
      "${name} SETTINGS",
      "${name}の設定",
      "${name}设置",
      "${name} EINSTELLUNGEN",
      "${name} PARAMÈTRES",
      "IMPOSTAZIONI ${name}",
      "CONFIGURAÇÃO DE ${name}",
      "AJUSTES DE ${name}",
      "ПАРАМЕТРЫ ${name}",
      "USTAWIENIA ${name} ",
      "sub_test_ping_delete_confirm_title"
    ],
    sub_test_ipv_delete_confirm_title: [
      "DELETE ${name} TARGET",
      "DELETE ${name} TARGET",
      "${name}ターゲットを削除",
      "删除${name}目标",
      "ZIEL ${name} LÖSCHEN",
      "SUPPRIMER ${name} la CIBLE",
      "ELIMINA ${name} TARGET",
      "EXCLUIR DESTINO ${name}",
      "ELIMINAR DESTINO ${name}",
      "УДАЛИТЬ ЦЕЛЕВОЙ АДРЕС ${name}",
      "USUŃ ${name} CEL",
      "sub_test_ipv_delete_confirm_title"
    ],
    sub_test_delete_confirm_title: [
      "${name} SETTINGS",
      "${name} SETTINGS",
      "${name}の設定",
      "${name}设置",
      "${name} EINSTELLUNGEN",
      "${name} PARAMÈTRES",
      "IMPOSTAZIONI ${name}",
      "CONFIGURAÇÃO DE ${name}",
      "AJUSTES DE ${name}",
      "ПАРАМЕТРЫ ${name}",
      "USTAWIENIA ${name}",
      "sub_test_delete_confirm_title"
    ],
    sub_test_delete_confirm_text: [
      "Are you sure you would like to delete the target <b>${url}</b>?",
      "Are you sure you would like to delete the target <b>${url}</b>?",
      "ターゲット「<b>${url}</b>」を削除してもよろしいですか?",
      "您确定要删除目标<b>${url}</b>吗？",
      "Wollen Sie das Ziel <b>${url}</b> wirklich löschen?",
      "Êtes-vous sûr de vouloir supprimer la cible <b>${url}</b>?",
      "Sei sicuro di voler eliminare il target <b>${url}</b>?",
      "Tem certeza de que quer excluir o destino <b>${url}</b>?",
      "¿Seguro que desea eliminar el destino <b>${url}</b>?",
      "Вы уверены, что хотите удалить целевой адрес <b>${url}</b>?",
      "Czy na pewno chcesz usunąć cel <b>${url}</b>?",
      "sub_test_delete_confirm_text"
    ],
    sub_test_delete_empty_confirm_text: [
      "Are you sure you would like to delete the target?",
      "Are you sure you would like to delete the target?",
      "ターゲットを削除してもよろしいですか?",
      "您确定要删除目标吗？",
      "Wollen Sie dieses Ziel wirklich löschen?",
      "Êtes-vous sûr de vouloir supprimer la cible ?",
      "Sei sicuro di voler eliminare il target?",
      "Tem certeza de que quer excluir o destino?",
      "¿Seguro que desea eliminar el destino?",
      "Вы уверены, что хотите удалить целевой адрес?",
      "Czy na pewno chcesz usunąć cel:",
      "sub_test_delete_empty_confirm_text"
    ],
    cust_tab_details: [
      "Customer Details",
      "Customer Details",
      "カスタマーの詳細",
      "顾客信息",
      "Kunden-Angaben",
      "Détails du client",
      "Informazioni cliente",
      "Detalhes do Cliente",
      "Datos del cliente",
      "Сведения о заказчике",
      "Szczegóły dot. klienta",
      "cust_tab_details"
    ],
    cust_tab_ipv4: [
      "IPv4 Targets",
      "IPv4 Targets",
      "IPv4ターゲット",
      "IPv4目标",
      "IPv4-Ziele",
      "Cibles IPV4",
      "Target IPv4",
      "Destinos IPv4",
      "DestinosIPv4",
      "Целевые адреса IPv4",
      "Cele IPv4",
      "cust_tab_ipv4"
    ],
    cust_tab_ipv6: [
      "IPv6 Targets",
      "IPv6 Targets",
      "IPv6ターゲット",
      "IPv6目标",
      "IPv6-Ziele",
      "Cibles IPV6",
      "Target IPv6",
      "Destinos IPv6",
      "Destinos IPv6",
      "Целевые адреса IPv6",
      "Cele IPv6",
      "cust_tab_ipv6"
    ],
    cust_tab_wiremap: [
      "Wiremap Custom Cables",
      "Wiremap Custom Cables",
      "ワイヤーマップカスタムケーブル",
      "接线图定制电缆",
      "Verdrahtungsplan für kundenspez. Kabel",
      "Schéma de câblage personnalisés",
      "Cavi personalizzati mappatura fili",
      "Cabos personalizados para mapa de fios",
      "Cables personalizados del diagrama de cables",
      "Разводка пользовательских кабелей",
      "Niestandardowa Mapa Okablowania",
      "cust_tab_wiremap"
    ],
    cust_tab_target_head: [
      "Targets",
      "Targets",
      "ターゲット",
      "目标",
      "Ziele",
      "Cibles",
      "Target",
      "Destinos",
      "Destinos",
      "Целевые адреса",
      "Cele",
      "cust_tab_target_head"
    ],
    cust_tab_target_sub_head: [
      "These settings may not be applicable for all test devices",
      "These settings may not be applicable for all test devices",
      "これらの設定はすべてのテストデバイスに該当するわけではありません",
      "这些设置可能不适用于所有测试设备",
      "Diese Einstellungen sind möglicherweise nicht auf alle Geräte anwendbar",
      "Ces paramètres peuvent ne pas être compatibles avec tous les appareils",
      "Queste impostazioni potrebbero non essere applicabili a tutti i dispositivi di prova",
      "Estas definições podem não ser aplicáveis a todos os dispositivos de teste",
      "Estos ajustes pueden no ser aplicables a todos los dispositivos de prueba",
      "Эти параметры могут быть не применимы на всех тестовых устройствах",
      "Te ustawienia mogą nie mieć zastosowania do wszystkich urządzeń testujących",
      "cust_tab_target_sub_head"
    ],
    targets_update_successfully_toast: [
      "Targets successfully updated.",
      "Targets successfully updated.",
      "ターゲットが正常に更新されました。",
      "已成功更新目标。",
      "Ziele erfolgreich aktualisiert.",
      "Les cibles ont été mises à jour avec succès.",
      "Target aggiornati con successo.",
      "Destinos atualizados com sucesso.",
      "Destinos actualizados correctamente.",
      "Целевые адреса успешно обновлены.",
      "Aktualizacja celów powiodła się.",
      "targets_update_successfully_toast"
    ],
    general_sub_test_ipv4: [
      "IPV4 Settings",
      "IPV4 Settings",
      "IPV4設定",
      "IPV4设置",
      "IPV4-Einstellungen",
      "Paramètres IPv4",
      "Impostazioni IPV4",
      "Configuração IPv4",
      "Ajustes de IPV4",
      "Параметры IPV4",
      "Ustawienia IPV4",
      "general_sub_test_ipv4"
    ],
    general_sub_test_ipv6: [
      "IPV6 Settings",
      "IPV6 Settings",
      "IPV6設定",
      "IPV6设置",
      "IPV6-Einstellungen",
      "Paramètres IPv6",
      "Impostazioni IPV6",
      "Configuração IPv6",
      "Ajustes de IPV6",
      "Параметры IPV6",
      "Ustawienia IPV6",
      "general_sub_test_ipv6"
    ],
    general_sub_test_no_data_target_text: [
      "No Targets Found",
      "No Targets Found",
      "ターゲットは見つかりませんでした",
      "找不到目标",
      "Keine Ziele gefunden",
      "Aucune cible trouvée",
      "Nessun target trovato",
      "Nenhum destino encontrado",
      "No se han encontrado destinos",
      "Целевые адреса не найдены",
      "Nie znaleziono celów",
      "general_sub_test_no_data_target_text"
    ],
    general_sub_test_ipv4_breadcrumb: [
      "IPv4 Targets",
      "IPv4 Targets",
      "IPv4ターゲット",
      "IPv4目标",
      "IPv4-Ziele",
      "Cibles IPv4",
      "Target IPv4",
      "Destinos IPv4",
      "Destinos IPv4",
      "Целевые адреса IPv4",
      "Cele IPv4",
      "general_sub_test_ipv4_breadcrumb"
    ],
    general_sub_test_ipv6_breadcrumb: [
      "IPv6 Targets",
      "IPv6 Targets",
      "IPv6ターゲット",
      "IPv6目标",
      "IPv6-Ziele",
      "Cibles IPv6",
      "Target IPv6",
      "Destinos IPv6",
      "Destinos IPv6",
      "Целевые адреса IPv6",
      "Cele IPv6",
      "general_sub_test_ipv6_breadcrumb"
    ],
    no_job_data_undeveloped: [
      "This page is under construction. Come back in next sprint. :)",
      "This page is under construction. Come back in next sprint. :)",
      "このページは現在作成中です。次のスプリントで確認してください。:)",
      "本页面正在建设中。请下次再回来。 :)",
      "Diese Seite befindet sich im Aufbau. Beim nächsten Mal ist sie sicherlich fertig-:)",
      "Cette page est en cours de développement Revenez lors de la prochaine publication svp.",
      "Questa pagina è in costruzione. Ritorna al prossimo sprint. :)",
      "Página em construção. Volte no próximo sprint. :)",
      "Esta página está en construcción. Vuelva en el siguiente sprint. :)",
      "Эта страница находится на стадии разработки. Возвращайтесь в следующем забеге. :)",
      "Ta strona jest w trakcie tworzenia. Wróc do nas wkrótce. :)",
      "no_job_data_undeveloped"
    ],
    subtest_ping4_update_successfully_toast: [
      "The default settings for Ping4 have been updated.",
      "The default settings for Ping4 have been updated.",
      "Ping4のデフォルト設定が更新されました。",
      "已更新Ping4的默认设置。",
      "Die Standardeinstellungen für Ping4 wurden aktualisiert.",
      "Les paramètres par défaut pour le Ping4 ont été mis à jour.",
      "Le impostazioni predefinite per Ping4 sono state aggiornate.",
      "A configuração padrão do Ping4 foi atualizada.",
      "Se han actualizado los ajustes predeterminados para Ping4.",
      "Параметры по умолчанию для Ping4 обновлены.",
      "Zaktualizowano ustawienia domyślne dla Ping4",
      "subtest_ping4_update_successfully_toast"
    ],
    subtest_ping6_update_successfully_toast: [
      "The default settings for Ping6 have been updated.",
      "The default settings for Ping6 have been updated.",
      "Ping6のデフォルト設定が更新されました。",
      "已更新Ping6的默认设置。",
      "Die Standardeinstellungen für Ping6 wurden aktualisiert.",
      "Les paramètres par défaut pour le Ping6 ont été mis à jour.",
      "Le impostazioni predefinite per Ping6 sono state aggiornate.",
      "A configuração padrão do Ping6 foi atualizada.",
      "Se han actualizado los ajustes predeterminados para Ping6.",
      "Параметры по умолчанию для Ping6 обновлены.",
      "Zaktualizowano ustawienia domyślne dla Ping6",
      "subtest_ping6_update_successfully_toast"
    ],
    target_limit_validation_text: [
      "The maximum of ${limit} targets have been added.",
      "The maximum of ${limit} targets have been added.",
      "最大数${limit}個のターゲットが追加されました。",
      "已添加最多10个目标。",
      "Die größtmögliche Anzahl von ${limit} Zielen wurde hinzugefügt.",
      "La quantité maximum de ${limit} cibles a été atteinte.",
      "È stato aggiunto il numero massimo di ${limit} target.",
      "O máximo de ${limit} destinos foi adicionado.",
      "Se ha añadido el máximo de ${limit} destinos.",
      "Добавлено макс. кол-во целевых адресов – ${limit}.",
      "Dodano maksymalnie ${limit} celów.",
      "target_limit_validation_text"
    ],
    sub_test_go_back_confirm_text: [
      "Would you like to save the changes you just made?",
      "Would you like to save the changes you just made?",
      "いま行った変更を保存しますか?",
      "您要保存所做的更改吗？",
      "Möchten Sie die gerade vorgenommenen Änderungen speichern?",
      "Souhaitez-vous sauvegarder ces modifications ?",
      "Desideri salvare le modifiche apportate?",
      "Você quer salvar as alterações realizadas?",
      "¿Desea guardar los cambios que acaba de hacer?",
      "Сохранить внесенные изменения?",
      "Czy chcesz zapisać wprowadzone zmiany?",
      "sub_test_go_back_confirm_text"
    ],
    back_btn_yes: [
      "Yes",
      "Yes",
      "はい",
      "是",
      "Ja",
      "Oui",
      "Sì",
      "Sim",
      "Sí",
      "Да",
      "Tak",
      "back_btn_yes"
    ],
    back_btn_no: [
      "No",
      "No",
      "いいえ",
      "否",
      "Nein",
      "Non",
      "No",
      "Não",
      "No",
      "Нет",
      "Nie",
      "back_btn_yes"
    ],
    back_btn_go_back: [
      "Go back",
      "Go back",
      "戻る",
      "返回",
      "Zurück",
      "Retour",
      "Indietro",
      "Voltar",
      "Volver",
      "Назад",
      "Wróć",
      "back_btn_yes"
    ],
    general_sub_test_poeload: [
      "PoE Load Settings",
      "PoE Load Settings",
      "PoE負荷の設定",
      "PoE负载设置",
      "PoE-Lasteinstellungen",
      "Paramètres de charge PoE",
      "Impostazioni carico PoE",
      "Configuração de Carga PoE",
      "Ajustes de la prueba de carga PoE",
      "Параметры нагрузки PoE",
      "Ustawienia obciążenia PoE",
      "general_sub_test_poeload"
    ],
    subtest_poeload_poestd: [
      "PoE Standard",
      "PoE Standard",
      "PoE規格",
      "PoE标准",
      "PoE-Standard",
      "Norme PoE",
      "Standard PoE",
      "Padrão PoE",
      "Estándar PoE",
      "Стандарт PoE",
      "Standard PoE",
      "subtest_poeload_poestd"
    ],
    subtest_poeload_powerlimit: [
      "Power Limit (W)",
      "Power Limit (W)",
      "電力制限 (W)",
      "功率极限（W）",
      "Leistungsgrenze (W)",
      "Limite de puissance (W)",
      "Limite di potenza (W)",
      "Limite de potência (W)",
      "Límite de potencia (W)",
      "Предел мощности (Вт)",
      "Limit mocy (W)",
      "subtest_poeload_powerlimit"
    ],
    poeload_update_successfully_toast: [
      "PoE Load details successfully updated.",
      "PoE Load details successfully updated.",
      "PoE負荷の詳細が正常に更新されました。",
      "已成功更新PoE负载的详细信息。",
      "Die PoE-Lastangaben wurden erfolgreich aktualisiert.",
      "Détails de charge PoE mis à jour avec succès.",
      "Informazioni di carico PoE aggiornate con successo.",
      "A configuração de carga PoE foi atualizada com sucesso.",
      "Datos de la carga PoE actualizados correctamente.",
      "Сведения о нагрузке PoE успешно обновлены.",
      "Szczegóły obciążenia PoE zostały pomyślnie zaktualizowane.",
      "poeload_update_successfully_toast"
    ],
    general_sub_test_tr4: [
      "TraceRoute4 Settings",
      "TraceRoute4 Settings",
      "TraceRoute4設定",
      "TraceRoute4设置",
      "TraceRoute4-Einstellungen",
      "Paramètres TraceRoute4",
      "Impostazioni TraceRoute4",
      "Definições TraceRoute4",
      "Ajustes de TraceRoute4",
      "Параметры TraceRoute4",
      "Ustawienia TraceRoute4",
      "general_sub_test_tr4"
    ],
    general_sub_test_tr6: [
      "TraceRoute6 Settings",
      "TraceRoute6 Settings",
      "TraceRoute6設定",
      "TraceRoute6设置",
      "TraceRoute6-Einstellungen",
      "Paramètres TraceRoute6",
      "Impostazioni TraceRoute6",
      "Definições TraceRoute6",
      "Ajustes de TraceRoute6",
      "Параметры TraceRoute6",
      "Ustawienia TraceRoute6",
      "general_sub_test_tr4"
    ],
    subset_tr_target: [
      "Target",
      "Target",
      "ターゲット",
      "目标",
      "Ziel",
      "Cible",
      "Target",
      "Destino",
      "Destino",
      "Целевой адрес",
      "Cel",
      "subset_tr_target"
    ],
    subset_tr_hops: [
      "Max Hops",
      "Max Hops",
      "最大ホップ",
      "最大跃点数",
      "Max. Hops",
      "Nombre de sauts max.",
      "Salti massimi",
      "Máximos de saltos",
      "Saltos máx.",
      "Макс. транзитных участков",
      "Maks. liczba HOP-ów",
      "subset_tr_hops"
    ],
    subset_tr_timeout: [
      "Timeout (s)",
      "Timeout (s)",
      "タイムアウト (s)",
      "超时（秒）",
      "Timeout (s)",
      "Temporisation(s)",
      "Timeout (s)",
      "Limite de tempo (s)",
      "Tiempo(s) inactivo(s)",
      "Тайм-аут (ы)",
      "Czas przerwy (s)",
      "subset_tr_timeout"
    ],
    subset_tr_type: [
      "Type",
      "Type",
      "タイプ",
      "类型",
      "Typ",
      "Type",
      "Tipo",
      "Tipo",
      "Tipo",
      "Тип",
      "Typ",
      "subset_tr_type"
    ],
    subset_tr_name_lookup: [
      "Name Lookup",
      "Name Lookup",
      "名前ルックアップ",
      "名称查询",
      "Namensuche",
      "Voir le nom",
      "Ricerca nome",
      "Pesquisa de nome",
      "Búsqueda de nombre",
      "Поиск имени",
      "Wyszukiwanie nazwy",
      "subset_tr_name_lookup"
    ],
    general_sub_test_no_data_text: [
      "No Data Found",
      "No Data Found",
      "データは見つかりませんでした",
      "没有找到数据",
      "Keine Daten gefunden",
      "Aucune donnée trouvée",
      "Nessun dato trovato",
      "Nenhum dado encontrado",
      "No se han encontrado datos",
      "Данные не найдены",
      "Nie znaleziono danych",
      "general_sub_test_no_data_text"
    ],
    subtest_tr4_update_successfully_toast: [
      "The default settings for TraceRoute4 have been updated.",
      "The default settings for TraceRoute4 have been updated.",
      "TraceRoute4のデフォルト設定が更新されました。",
      "已更新TraceRoute4的默认设置。",
      "Die Standardeinstellungen für TraceRoute4 wurden aktualisiert.",
      "Les paramètres par défaut du TraceRoute4 ont été mis à jour.",
      "Le impostazioni predefinite per TraceRoute4 sono state aggiornate.",
      "A configuração padrão de TraceRoute4 foi atualizada.",
      "Se han actualizado los ajustes predeterminados para TraceRoute4.",
      "Параметры по умолчанию для TraceRoute4 обновлены.",
      "Zaktualizowano ustawienia domyślne dla TraceRoute4",
      "subtest_tr4_update_successfully_toast"
    ],
    subtest_tr6_update_successfully_toast: [
      "The default settings for TraceRoute6 have been updated.",
      "The default settings for TraceRoute6 have been updated.",
      "TraceRoute6のデフォルト設定が更新されました。",
      "已更新TraceRoute6的默认设置。",
      "Die Standardeinstellungen für TraceRoute6 wurden aktualisiert.",
      "Les paramètres par défaut du  TraceRoute6 ont été mis à jour.",
      "Le impostazioni predefinite per TraceRoute6 sono state aggiornate.",
      "A configuração padrão de TraceRoute6 foi atualizada.",
      "Se han actualizado los ajustes predeterminados para TraceRoute6.",
      "Параметры по умолчанию для TraceRoute6 обновлены.",
      "Zaktualizowano ustawienia domyślne dla TraceRoute6",
      "subtest_tr6_update_successfully_toast"
    ],
    subtest_no_target_message: [
      "No Targets available to choose from.",
      "No Targets available to choose from.",
      "選択できるターゲットがありません。",
      "没有可供选择的目标。",
      "Keine Ziele zum Auswählen vorhanden.",
      "Aucune cible disponible.",
      "Non vi sono target tra cui scegliere.",
      "Não há destinos disponíveis para escolher.",
      "No hay destinos disponibles para elegir.",
      "Нет целевых адресов для выбора.",
      "Brak dostępnych celów do wyboru.",
      "subtest_no_target_message"
    ],
    sub_set_search_heading: [
      "${name} Targets",
      "${name} Targets",
      "${name}ターゲット",
      "${name}目标",
      "${name}-Ziele",
      "${name} CIBLES",
      "${name} Target",
      "Destinos de ${name}",
      "Destinos ${name}",
      "Целевые адреса ${name}",
      "Ustawienia ${name}",
      "sub_set_search_heading"
    ],
    sub_test_ipv_back_confirm_title: [
      "${name} TARGETS",
      "${name} TARGETS",
      "${name}ターゲット",
      "${name}目标",
      "${name}-ZIELE",
      "${name} CIBLES",
      "${name} TARGET",
      "DESTINOS DE ${name}",
      "DESTINOS ${name}",
      "ЦЕЛЕВЫЕ АДРЕСА ${name}",
      "CELE ${name}",
      "sub_test_ipv_back_confirm_title"
    ],
    sub_test_empty_target_search_t1: [
      "There are currently no ${type} targets saved.",
      "There are currently no ${type} targets saved.",
      "現在、保存された${type}ターゲットはありません。",
      "当前没有保存${type}的目标。",
      "Aktuell sind keine ${type}-Ziele gespeichert.",
      "Aucune cible ${type} n'a été enregistrée jusqu'à présent.",
      "Non vi sono target ${type} salvati al momento.",
      "Não há destinos ${type} salvos.",
      "No hay destinos ${type} guardados actualmente.",
      "Сейчас нет сохраненных целевых адресов ${type}.",
      "Obecnie nie ma zapisanych ${type} celów.",
      "sub_test_empty_target_search_t1"
    ],
    sub_test_empty_target_search_t2: [
      "You can save targets by adding them in ",
      "You can save targets by adding them in ",
      "ターゲットは追加して保存することができます",
      "您可以在......添加目标来保存目标\n ",
      "Sie können Ziele speichern, indem Sie diese hinzufügen zu ",
      "Vous pouvez enregistrer des cibles en les ajoutant dans ",
      "Puoi salvare target aggiungendoli in ",
      "Você pode salvar destinos adicionando-os em ",
      "Puede guardar destinos añadiéndolos en ",
      "Вы можете сохранять целевые адреса, добавляя их ",
      "Możesz zapisać cele dodając je ",
      "sub_test_empty_target_search_t2"
    ],
    sub_test_empty_target_search_t3: [
      "${name} Settings",
      "${name} Settings",
      "${name}の設定",
      "${name}设置",
      "${name}-Einstellungen",
      "${name} PARAMÈTRES",
      "Impostazioni ${name}",
      "Configuração de ${name}",
      "Ajustes ${name}",
      "Параметры ${name}",
      "Ustawienia ${name}",
      "sub_test_empty_target_search_t3"
    ],
    netscan_setup: [
      "NetScan Settings",
      "NetScan Settings",
      "ネットスキャンの設定",
      "NetScan设置",
      "NetScan-Einstellungen",
      "Paramètres NetScan",
      "Impostazioni NetScan",
      "Configuração de NetScan",
      "Ajustes de NetScan",
      "Параметры NetScan",
      "Ustawienia NetScan",
      "netscan_setup"
    ],
    ipv4_netscan_setup: [
      "IPv4 NetScan Setup",
      "IPv4 NetScan Setup",
      "IPv4ネットスキャンのセットアップ",
      "IPv4 NetScan设置",
      "IPv4 NetScan-Setup",
      "Configurer NetScan IPv4",
      "Configurazione NetScan IPv4",
      "Configurar NetScan IPv4",
      "Configuración de IPv4 NetScan",
      "Настройка NetScan для IPv4",
      "Konfiguracja IPv4 NetScan",
      "ipv4_netscan_setup"
    ],
    ipv6_netscan_setup: [
      "IPv6 NetScan Setup",
      "IPv6 NetScan Setup",
      "IPv6ネットスキャンのセットアップ",
      "IPv6 NetScan设置",
      "IPv6 NetScan-Setup",
      "Configurer NetScan IPv6",
      "Configurazione NetScan IPv6",
      "Configurar NetScan IPv6",
      "Configuración de IPv6 NetScan",
      "Настройка NetScan для IPv6",
      "Konfiguracja IPv6 NetScan",
      "ipv6_netscan_setup"
    ],
    none_constant: [
      "None",
      "None",
      "なし",
      "无",
      "Keine",
      "Aucun",
      "Nessuno",
      "Nenhum",
      "Ninguno",
      "Отсутствует",
      "Brak",
      "none_constant"
    ],
    ip_address: [
      "IP Address",
      "IP Address",
      "IPアドレス",
      "IP地址",
      "IP-Adresse",
      "Adresse IP",
      "Indirizzo IP",
      "Endereço IP",
      "Dirección IP",
      "IP-Адрес",
      "Adres IP",
      "ip_address"
    ],
    scan_range: [
      "Scan Range",
      "Scan Range",
      "スキャン範囲",
      "扫描范围",
      "Scan-Bereich",
      "Intervalle de balayage",
      "Range di scansione",
      "Alcance da pesquisa",
      "Rango de la detección",
      "Диапазон сканирования",
      "Zakres skanowania",
      "scan_range"
    ],
    start_address: [
      "Start Address",
      "Start Address",
      "開始アドレス",
      "起始地址",
      "Start-Adresse",
      "Adresse de départ",
      "Indirizzo iniziale",
      "Endereço inicial",
      "Dirección de inicio",
      "Начальный адрес",
      "Adres początkowy",
      "start_address"
    ],
    end_address: [
      "End Address",
      "End Address",
      "終了アドレス",
      "结束地址",
      "Ende-Adresse",
      "Adresse d'arrivée",
      "Indirizzo finale",
      "Endereço final",
      "Dirección final",
      "Конечный адрес",
      "Adres końcowy",
      "end_address"
    ],
    valid_ip_address: [
      "Please provide a valid IP Address",
      "Please provide a valid IP Address",
      "有効なIPアドレスを指定してください",
      "请提供有效的IP地址。",
      "Bitte geben Sie eine gültige IP-Adresse an",
      "Veuillez fournir une adresse IP valide",
      "Fornisci un indirizzo IP valido",
      "Informe um endereço IP válido",
      "Escriba una dirección IP válida",
      "Введите действительный IP-Адрес",
      "Podaj poprawny adres IP",
      "valid_ip_address"
    ],
    general_sub_test_uptime_head: [
      "Uptime",
      "Uptime",
      "アップタイム",
      "正常运行时间",
      "Betriebszeit ",
      "Disponibilité",
      "Uptime",
      "Tempo de atividade",
      "Tiempo de actividad",
      "Время работы",
      "Czas pracy bez przestojów",
      "general_sub_test_uptime_head"
    ],
    general_sub_test_uptime: [
      "Uptime Settings",
      "Uptime Settings",
      "アップタイムの設定",
      "正常运行时间设置",
      "Betriebszeit-Einstellungen",
      "Réglages de la disponibilité ",
      "Impostazioni uptime",
      "Configuração do tempo de atividade",
      "Ajustes de tiempo de actividad",
      "Параметры времени работы",
      "Ustawienia czasu pracy bez przestojów",
      "general_sub_test_uptime"
    ],
    uptime_bandwidth: [
      "Bandwidth Type",
      "Bandwidth Type",
      "帯域幅タイプ",
      "带宽类型",
      "Bandbreiten-Typ",
      "Type de bande passante",
      "Tipo di larghezza di banda",
      "Tipo de largura de banda",
      "Tipo de banda ancha",
      "Тип пропускной полосы",
      "Typ przepustowości",
      "uptime_bandwidth"
    ],
    uptime_linkspeed: [
      "Link Speed (Gb/s)",
      "Link Speed (Gb/s)",
      "リンク速度 (Gb/s)",
      "链接速度（Gb/s）",
      "Link-Rate (Gbit/s)",
      "Vitesse du lien (Go/s)",
      "Velocità di collegamento (Gb/s)",
      "Velocidade do link (Gb/s)",
      "Velocidad del vínculo (Gb/s)",
      "Скорость канала (Гб/с)",
      "Szybkość łącza (Gb/s)",
      "uptime_linkspeed"
    ],
    uptime_desired_bandwidth: [
      "Desired Bandwidth Mb/s",
      "Desired Bandwidth Mb/s",
      "目的の帯域幅 Mb/s",
      "所需带宽Mb/s",
      "Gewünschte Bandbreite Mbit/s",
      "Bande passante souhaitée Mo/s",
      "Larghezza di banda desiderata (Mb/s)",
      "Largura de banda desejada Mb/s",
      "Ancho de banda deseado Mb/s",
      "Желаемая пропускная способность Мб/с",
      "Pożądana przepustowość Mb/s",
      "uptime_desired_bandwidth"
    ],
    uptime_bandwidth_per: [
      "Desired Bandwidth %",
      "Desired Bandwidth %",
      "目的の帯域幅 %",
      "所需带宽％",
      "Gewünschte Bandbreite %",
      "Bande passante souhaitée %",
      "Larghezza di banda desiderata (%)",
      "Largura de banda desejada %",
      "Ancho de banda deseado %",
      "Желаемая пропускная способность %",
      "Pożądana przepustowość %",
      "uptime_bandwidth_per"
    ],
    uptime_duration: [
      "Duration (hh:mm:ss)",
      "Duration (hh:mm:ss)",
      "期間 (hh:mm:ss)",
      "持续时间（时：分：秒）",
      "Dauer (hh:mm:ss)",
      "Durée (hh:mm:ss)",
      "Durata (hh:mm:ss)",
      "Duração (hh:mm:ss)",
      "Duración (hh:mm:ss)",
      "Длительность (чч:мм:сс)",
      "Czas trwania (gg: mm: ss)",
      "uptime_duration"
    ],
    uptime_certainty: [
      "Certainty",
      "Certainty",
      "確実性",
      "确定性",
      "Sicherheit",
      "Certitude",
      "Attendibilità",
      "Certeza",
      "Certeza",
      "Достоверность",
      "Pewność",
      "uptime_certainty"
    ],
    uptime_limit_per: [
      "Pass/Fail Limit %",
      "Pass/Fail Limit %",
      "成功/失敗の制限 %",
      "通过/失败限制％",
      "Bestanden/Fehler-Grenze %",
      "Limite passe/échec %",
      "Limite % esito positivo/negativo",
      "Limite para Aprovar/Reprovar %",
      "Límite superado/no superado %",
      "Предел соответствия/несоответствия %",
      "Limit zaliczenia/niezaliczenia %",
      "uptime_limit_per"
    ],
    uptime_frame_size: [
      "Frame Size",
      "Frame Size",
      "フレームサイズ",
      "帧大小",
      "Frame Size",
      "Taille de trame",
      "Dimensione frame",
      "Tamanho do quadro",
      "Tamaño de trama",
      "Размер кадра",
      "Rozmiar ramki",
      "uptime_frame_size"
    ],
    uptime_total_bandwidth: [
      "Exp Total Bandwidth (Gb/s)",
      "Exp Total Bandwidth (Gb/s)",
      "期待される合計帯域幅 (Gb/s)",
      "预期总带宽（Gb/s）",
      "Erwart. Gesamtbandbreite (Gbit/s)",
      "Bande passante totale max disponible (Gb/s)",
      "Larghezza di banda totale att. (Gb/s)",
      "Largura de banda total esperada (Gb/s)",
      "Ancho de banda total previsto (Gb/s)",
      "Ожидаемая полная пропускная способность (Гб/с)",
      "Oczekiwana przepustowość całkowita (Gb/s)",
      "uptime_total_bandwidth"
    ],
    uptime_usuable_bandwidth: [
      "Exp Usuable Bandwidth (Gb/s)",
      "Exp Usuable Bandwidth (Gb/s)",
      "期待される使用可能帯域幅 (Gb/s)",
      "预期可用带宽（Gb/s）",
      "Erwart. nutzbare Bandbreite (Gbit/s)",
      "Bande passante max disponible (Gb/s)",
      "Larghezza di banda totale utilizzabile att. (Gb/s)",
      "Largura de banda utilizável esperada (Gb/s)",
      "Ancho de banda total utilizable (Gb/s)",
      "Ожидаемая полезная пропускная способность (Гб/с)",
      "Oczekiwana przepustowość użyteczna (Gb/s)",
      "uptime_usuable_bandwidth"
    ],
    uptime_nw_overhead: [
      "Network Overhead (Gb/s)",
      "Network Overhead (Gb/s)",
      "ネットワークオーバーヘッド (Gb/s)",
      "网络架构（Gb/s）",
      "Netzwerk-Overhead (Gbit/s)",
      "En-tête trames du test de disponibilité  (Go/s)",
      "Sovraccarico di rete (Gb/s)",
      "Sobrecarga de rede (Gb/s)",
      "Sobrecarga de red (Gb/s)",
      "Непроизводительная передача сети (Гб/с)",
      "Obciążenie sieci (Gb/s)",
      "uptime_nw_overhead"
    ],
    subtest_uptime_update_successfully_toast: [
      "The default settings for Uptime have been updated.",
      "The default settings for Uptime have been updated.",
      "アップタイムのデフォルト設定が更新されました。",
      "已更新正常运行时间的默认设置。",
      "Die Standardeinstellungen für die Betriebszeit wurden aktualisiert.",
      "Les paramètres par défaut du test disponibilité ont été mis à jour.",
      "Le impostazioni predefinite per Uptime sono state aggiornate.",
      "A configuração padrão de tempo de atividade foram atualizadas.",
      "Se han actualizado los ajustes predeterminados para el tiempo de actividad.",
      "Параметры по умолчанию для Времени работы обновлены.",
      "Zaktualizowano ustawienia domyślne dla czasu pracy bez przestojów.",
      "subtest_uptime_update_successfully_toast"
    ],
    uptime_duration_error: [
      "Duration should be in the range of 00:00:10 to 72:00:00",
      "Duration should be in the range of 00:00:10 to 72:00:00",
      "期間は00:00:10～72:00:00の範囲である必要があります",
      "持续时间应在00:00:10至72:00:00的范围内",
      "Die Dauer muss im Bereich von 00:00:10 bis 72:00:00 liegen",
      "La durée doit se trouver entre 00:00:10 et 72:00:00",
      "La durata deve essere compresa tra 00:00:10 e 72:00:00",
      "A duração deve estar entre 00:00:10 e 72:00:00",
      "La duración debe estar entre 00:00:10 y 72:00:00",
      "Длительность должна быть в пределах от 00:00:10 до 72:00:00",
      "Czas trwania powinien zawierać się w przedziale od 00:00:10 do 72:00:00",
      "uptime_duration_error"
    ],
    link_ability: [
      "Link Ability",
      "Link Ability",
      "リンク機能",
      "链接能力",
      "Verbindungsfähigkeit",
      "Capacité de liaison",
      "Capacità di collegamento",
      "Habilidade de link",
      "Capacidad de enlace",
      "Ссылка на способность",
      "Zdolność łącza",
      "link_ability"
    ],
    sub_test_link_speed: [
      "Link Speed",
      "Link Speed",
      "リンク速度",
      "链接速度",
      "Link-Rate",
      "Vitesse du lien",
      "Velocità di collegamento",
      "Velocidade do Link",
      "Velocidad del vínculo",
      "Скорость канала",
      "Szybkość łącza",
      "sub_test_link_speed"
    ],
    sub_test_test_template: [
      "Test Frame Size",
      "Test Frame Size",
      "フレームサイズをテスト",
      "测试帧大小",
      "Test Frame Größe",
      "Taille trame de test",
      "Dimensioni del frame di test",
      "Tamanho do Quadro de Teste",
      "Tamaño trama de prueba",
      "Размер тестового кадра",
      "Rozmiar ramki testowej",
      "sub_test_test_template"
    ],
    sub_test_auto_adjust_speed: [
      "Auto-adjust speed",
      "Auto-adjust speed",
      "速度の自動調整",
      "自动调整速度",
      "Auto-Einstellung Rate",
      "Vitesse auto-ajustée",
      "Velocità di regolazione automatica",
      "Ajuste automático de velocidade",
      "Autoajustar velocidad",
      "Автокорректировка скорости",
      "Automatyczna regulacja prędkości",
      "sub_test_auto_adjust_speed"
    ],
    sub_test_pass_fail_limit: [
      "Test Standard",
      "Test Standard",
      "規格をテスト",
      "测试标准",
      "Test Standard",
      "Norme du test",
      "Standard di Test",
      "Padrão do Teste",
      "Estándar de prueba",
      "Стандарт теста",
      "Standard testowy",
      "sub_test_pass_fail_limit"
    ],
    sub_test_frame_loss_limit: [
      "Frame Loss Limit",
      "Frame Loss Limit",
      "フレーム損失の制限",
      "丢帧限制",
      "Frame Size Verlust -Grenzwert",
      "Limite de la perte de trame",
      "Limite di perdita frame",
      "Limite de perda de quadros",
      "Límite de pérdida de marco",
      "Предел потери кадров",
      "Limit utraty ramki",
      "sub_test_frame_loss_limit"
    ],
    sub_test_percent: [
      "Percent %",
      "Percent %",
      "パーセント%",
      "百分比％",
      "Prozent %",
      "Pourcentage %",
      "Percentuale %",
      "Porcentagem %",
      "Porcentaje %",
      "Процент %",
      "Procent %",
      "sub_test_percent"
    ],
    subtest_test_standard: [
      "Test Standard",
      "Test Standard",
      "Test Standard",
      "Test Standard",
      "Test Standard",
      "Test Standard",
      "Test Standard",
      "Test Standard",
      "Test Standard",
      "Test Standard",
      "Test Standard",
      "subtest_test_standard"
    ],
    sub_test_propagation_delay_limit: [
      "Propagation Delay (RTT) Limit (ms)",
      "Propagation Delay (RTT) Limit (ms)",
      "伝搬遅延（RTT）制限 (ms)",
      "传输时延（RTT）门限 (ms)",
      "Propagation Delay (RTT) Grenze  (ms)",
      "Limite du temps de propagation (RTT) (ms)",
      "Limite del ritardo di propagazione (RTT) (ms)",
      "Limite do Atraso de Propagação (RTT) (ms)",
      "Límite de Retardo de Propagación (RTT) (ms)",
      "Предел задержки распространения (RTT) (ms)",
      "Propagation Delay (RTT) Limit (ms)",
      "sub_test_propagation_delay_limit"
    ],
    sub_test_jitter_limit: [
      "Jitter Limit (ms)",
      "Jitter Limit (ms)",
      "ジッタの制限 (ms)",
      "抖动限制（毫秒）",
      "Jitter-Grenzwert (ms)",
      "Limite de la gigue (ms)",
      "Limite di instabilità (ms)",
      "Limite de jitter (ms)",
      "Límite de Jitter (ms)",
      "Предел джиттера (мс)",
      "Limit jittera (ms)",
      "sub_test_jitter_limit"
    ],
    subtest_maxthroughput_update_successfully_toast: [
      "The default settings for Max Throughput have been updated",
      "The default settings for Max Throughput have been updated",
      "最大スループットのデフォルト設定が更新されました。",
      "已更新最大吞吐量的默认设置",
      "Die Standardeinstellungen für den max. Durchsatz wurden aktualisiert.",
      "Les paramètres par défaut du débit maximal ont été mis à jour.",
      "Le impostazioni predefinite per Velocità trasmissione max sono state aggiornate",
      "A configuração padrão de rendimento máximo foi atualizada.",
      "Se han actualizado los ajustes predeterminados para rendimiento máx.",
      "Параметры по умолчанию для Макс. пропускной способности обновлены",
      "Zaktualizowano ustawienia domyślne dla maksymalnej przepustowości",
      "subtest_maxthroughput_update_successfully_toast"
    ],
    subtest_maxthroughput_update_unsuccessfully_toast: [
      "The default settings for Max Throughput have not been updated",
      "The default settings for Max Throughput have not been updated",
      "最大スループットのデフォルト設定が更新されませんでした。",
      "尚未更新最大吞吐量的默认设置",
      "Die Standardeinstellungen für den max. Durchsatz wurden nicht aktualisiert.",
      "Les paramètres par défaut du débit maximal n'ont pas été mis à jour.",
      "Le impostazioni predefinite per Velocità trasmissione max non sono state aggiornate",
      "A configuração padrão de rendimento máximo não foi atualizada.",
      "No se han actualizado los ajustes predeterminados para rendimiento máx.",
      "Параметры по умолчанию для Макс. пропускной способности не обновлены",
      "Nie zaktualizowano ustawień domyślnych dla maksymalnej przepustowości",
      "subtest_maxthroughput_update_unsuccessfully_toast"
    ],
    subtest_number_range: [
      "Entered number must be between ${start} and ${end}",
      "Entered number must be between ${start} and ${end}",
      "入力した数値は${start}～${end}の間である必要があります",
      "输入数字必须在${start}和${end}之间",
      "Die eingegebene Zahl muss zwischen ${start} und ${end} liegen",
      "Le numéro saisi doit se trouver entre ${start} et ${end}",
      "Il numero inserito deve essere compreso tra ${start} e ${end}",
      "O número informado deve estar entre ${start} e ${end}",
      "El número introducido debe estar entre ${start} y ${end}",
      "Введенное значение должно быть между ${start} и ${end}",
      "Podana liczba musi mieścić się w przedziale od ${start} do ${end}",
      "subtest_number_range"
    ],
    uptime_desired_title: [
      "Desired Uptime Certainty",
      "Desired Uptime Certainty",
      "目的のアップタイム確実性",
      "所需正常运行时间确定性",
      "Gewünschte Uptime-Sicherheit",
      "Seuil temps de montée ",
      "Attendibilità uptime desiderata",
      "Certeza desejada de tempo de atividade",
      "Certeza de tiempo de actividad deseado",
      "Желаемая достоверность времени работы",
      "Pożądana pewność czasu pracy bez przestojów",
      "uptime_desired_title"
    ],
    subtest_netscan_update_successfully_toast: [
      "The default settings for NetScan have been updated.",
      "The default settings for NetScan have been updated.",
      "ネットスキャンのデフォルト設定が更新されました。",
      "已更新NetScan的默认设置。",
      "Die Standardeinstellungen für NetScan wurden aktualisiert.",
      "Les paramètres par défaut de NetScan ont été mis à jour.",
      "Le impostazioni predefinite per NetScan sono state aggiornate.",
      "A configuração padrão de NetScan foi atualizada.",
      "Se han actualizado los ajustes predeterminados para NetScan.",
      "Параметры по умолчанию для NetScan обновлены.",
      "Zaktualizowano ustawienia domyślne dla NetScan",
      "subtest_netscan_update_successfully_toast"
    ],
    uptime_limit_percentage_numeric_error: [
      "Limit % can only be a number with up to 3 decimal places.",
      "Limit % can only be a number with up to 3 decimal places.",
      "制限 % は小数点第3位までの数値である必要があります。",
      "限制％只能是最多3个小数位的数字。",
      "Grenzwert % muss eine Zahl mit maximal 3 Dezimalstellen sein.",
      "La limite en % doit se composée d'un chiffre avec 3 décimales maximum.",
      "Il limite % può essere solo un numero con al massimo 3 cifre decimali.",
      "O limite em % pode ter no máximo 3 casas decimais.",
      "El límite en % solo puede ser un número con hasta 3 decimales.",
      "Предел % может быть только числом не более чем с 3 знаками после запятой.",
      "Limit % może być liczbą do 3 miejsc po przecinku.",
      "uptime_limit_percentage_numeric_error"
    ],
    subtest_numeric_validation: [
      "${name} can only be an Integer.",
      "${name} can only be an Integer.",
      "${name}は整数である必要があります。",
      "${name}只能是整数。",
      "${name} muss ganzzahlig sein.",
      "${name} peut uniquement être un entier relatif. ",
      "${name} può essere solo un numero intero.",
      "${name} pode ser somente um número inteiro.",
      "${name} solo puede ser un número entero.",
      "${name} может быть только целым числом.",
      "${name} może być tylko liczbą całkowitą.",
      "subtest_numeric_validation"
    ],
    subtest_target_length_validation: [
      "This field is limited to ${value} characters",
      "This field is limited to ${value} characters",
      "このフィールドの制限は${value}文字です",
      "此字段仅限${value}个字符",
      "Dieses Feld ist auf ${value} Zeichen beschränkt",
      "Ce champ est limité à ${value} caractères",
      "Questo campo può contenere al massimo ${value} caratteri",
      "Este campo é limitado a ${value} caracteres",
      "Este campo tiene un límite de ${value} caracteres",
      "Это поле ограничено ${value} знаками",
      "To pole jest ograniczone do ${value} znaków ",
      "subtest_target_length_validation"
    ],
    general_sub_test_wiremap_head: [
      "Wiremap Settings",
      "Wiremap Settings",
      "ワイヤーマップの設定",
      "接线图设置",
      "Verdrahtungsplan-Einstellungen",
      "Paramètres du câblage",
      "Impostazioni mappatura fili",
      "Configuração do Mapa de Fios",
      "Ajustes del Mapeado de Hilos",
      "Параметры разводки проводов",
      "Ustawienia mapy okablowania",
      "general_sub_test_wiremap_head"
    ],
    general_sub_test_wiremap_cable_type_label: [
      "Cable Type",
      "Cable Type",
      "ケーブルのタイプ",
      "电缆类型",
      "Kabeltyp",
      "Type de câble",
      "Tipo di cavo",
      "Tipo de cabo",
      "Tipo de cable",
      "Тип кабеля",
      "Typ okablowania",
      "general_sub_test_wiremap_cable_type_label"
    ],
    general_sub_test_wiremap_shield_type_label: [
      "Shield Type",
      "Shield Type",
      "シールドのタイプ",
      "屏蔽类型",
      "Schirmung",
      "Type de blindage",
      "Tipo di schermatura",
      "Tipo de blindagem",
      "Tipo de protección",
      "Тип экрана",
      "Typ osłony",
      "general_sub_test_wiremap_shield_type_label"
    ],
    general_sub_test_wiremap_disp_pref_label: [
      "Display Preference",
      "Display Preference",
      "ディスプレイ設定",
      "显示偏好",
      "Anzeige-Einstellungen",
      "Préférence d'affichage",
      "Preferenza di visualizzazione",
      "Preferências de exibição",
      "Preferencia de presentación",
      "Показать предпочтения",
      "Preferencje wyświetlania",
      "general_sub_test_wiremap_disp_pref_label"
    ],
    general_sub_test_wiremap_nvp_per_label: [
      "Custom NVP %",
      "Custom NVP %",
      "カスタムNVP %",
      "自定义NVP％",
      "Eigener NVP %",
      "NVP personnalisée (en %)",
      "NVP % personalizzata",
      "NVP personalizado %",
      "NVP % personalizado",
      "Пользовательский NVP %",
      "Dopasowane NVP %",
      "general_sub_test_wiremap_nvp_per_label"
    ],
    general_sub_test_wiremap_split_pair_label: [
      "Detect Split Pair",
      "Detect Split Pair",
      "スプリットペアを検出",
      "检测劈分线对",
      "Split-Pair erkennen",
      "Détecter les paires mélangées (split)",
      "Individua coppia divisa",
      "Detectar par dividido",
      "Detectar par dividido",
      "Обнаружить разделение пар",
      "Wykryj rozdzieloną parę ",
      "general_sub_test_wiremap_split_pair_label"
    ],
    general_sub_test_wiremap_cross_over_label: [
      "Crossover Allowed",
      "Crossover Allowed",
      "クロスオーバーの許可",
      "允许交叉",
      "Crossover erlaubt",
      "Croisement autorisé",
      "Crossover consentito",
      "Permitir crossover",
      "Se permiten cruces",
      "Перекрещивание допускается",
      "Połączenie skrosowane dozwolone",
      "general_sub_test_wiremap_cross_over_label"
    ],
    general_sub_test_wiremap_add_cust_cable: [
      "Add a custom cable",
      "Add a custom cable",
      "カスタムケーブルを追加",
      "添加自定义电缆",
      "Ein kundenspez. Kabel hinzufügen",
      "Ajouter un câble personnalisé",
      "Aggiungi un cavo personalizzato",
      "Adicionar cabo personalizado",
      "Añadir un cable personalizado",
      "Добавить пользовательский кабель",
      "Dodaj dopasowane okablowanie",
      "general_sub_test_wiremap_add_cust_cable"
    ],
    general_sub_test_wiremap_modal_add_cust_cable_head: [
      "Add Custom Cable",
      "Add Custom Cable",
      "カスタムケーブルを追加",
      "添加自定义电缆",
      "Kundenspez. Kabel hinzufügen",
      "Ajouter câble personnalisé",
      "Aggiungi cavo personalizzato",
      "Adicionar cabo personalizado",
      "Añadir cable personalizado",
      "Добавить Пользовательский Кабель",
      "Dodaj dopasowane okablowanie",
      "general_sub_test_wiremap_modal_add_cust_cable_head"
    ],
    general_sub_test_wiremap_modal_add_a_cust_cable_head: [
      "ADD A CUSTOM CABLE",
      "ADD A CUSTOM CABLE",
      "カスタムケーブルを追加",
      "添加自定义电缆",
      "KUNDENSPEZ. KABEL HINZUFÜGEN",
      "AJOUTER UN CÂBLE PERSONNALISÉ",
      "AGGIUNGI UN CAVO PERSONALIZZATO",
      "ADICIONAR CABO PERSONALIZADO",
      "AÑADIR UN CABLE PERSONALIZADO",
      "ДОБАВИТЬ ПОЛЬЗОВАТЕЛЬСКИЙ КАБЕЛЬ",
      "DODAJ DOPASOWANE OKABLOWANIE",
      "general_sub_test_wiremap_modal_add_a_cust_cable_head"
    ],
    wiremap_cust_cab_header: [
      "Cable Name",
      "Cable Name",
      "ケーブルの名前",
      "电缆名称",
      "Kabelname",
      "Nom du câble",
      "Nome cavo",
      "Nome do cabo",
      "Nombre del cable",
      "Название кабеля",
      "Nazwa okablowania",
      "wiremap_cust_cab_header"
    ],
    wiremap_custom_cable_update_successfully_toast: [
      "The Custom Cable List has been updated.",
      "The Custom Cable List has been updated.",
      "カスタムケーブルのリストが更新されました。",
      "已更新自定义电缆列表。\n",
      "Die Liste mit den kundenspez. Kabeln wurde aktualisiert.",
      "La liste des câbles personnalisés a été mise à jour.",
      "L’elenco Cavi personalizzati è stato aggiornato.",
      "A lista de cabos personalizados foi atualizada.",
      "La lista de cables personalizados se ha actualizado.",
      "Список пользовательских кабелей обновлен.",
      "Lista z dopasowanym okablowaniem została zaktualizowana.",
      "wiremap_custom_cable_update_successfully_toast"
    ],
    general_sub_test_wiremap_modal_edit_a_cust_cable_head: [
      "EDIT A CUSTOM CABLE",
      "EDIT A CUSTOM CABLE",
      "カスタムケーブルを編集",
      "编辑自定义电缆",
      "KUNDENSPEZ. KABEL BEARBEITEN",
      "ÉDITER UN CÂBLE PERSONNALISÉ",
      "MODIFICA UN CAVO PERSONALIZZATO",
      "EDIAR CABO PESONALIZADO",
      "EDITAR UN CABLE PERSONALIZADO",
      "ИЗМЕНИТЬ ПОЛЬЗОВАТЕЛЬСКИЙ КАБЕЛЬ",
      "EDYTUJ DOPASOWANE OKABLOWANIE",
      "general_sub_test_wiremap_modal_edit_a_cust_cable_head"
    ],
    general_sub_test_wiremap_modal_delete_s_cust_cable_head: [
      "Custom Cable deleted",
      "Custom Cable deleted",
      "カスタムケーブルが削除されました",
      "已删除自定义电缆",
      "Kundenspez. Kabel gelöscht",
      "Le câble personnalisé a été supprimé",
      "Cavo personalizzato rilevato",
      "Cabo personalizado excluído",
      "Cable personalizado eliminado",
      "Пользовательский кабель удален",
      "Usunięto dopasowane okablowanie",
      "general_sub_test_wiremap_modal_delete_s_cust_cable_head"
    ],
    general_sub_test_wiremap_modal_delete_f_cust_cable_head: [
      "Custom Cable did not get deleted",
      "Custom Cable did not get deleted",
      "カスタムケーブルが削除されませんでした",
      "未删除自定义电缆",
      "Fehler beim Löschen des kundenspez. Kabels",
      "Le câble personnalisé n'a pas été supprimé",
      "Cavo personalizzato non rilevato",
      "O cabo personalizado não foi excluído",
      "El cable personalizado no se ha eliminado",
      "Пользовательский кабель не был удален",
      "Nie usunięto dopasowanego okablowania",
      "general_sub_test_wiremap_modal_delete_f_cust_cable_head"
    ],
    subtest_traffic_bandwidth: [
      "Traffic Bandwidth",
      "Traffic Bandwidth",
      "トラフィック帯域幅",
      "流量带宽",
      "Traffic Bandbreite",
      "Bande passante du trafic",
      "Larghezza di banda traffico",
      "Largura de banda de tráfego",
      "Ancho de banda de tráfico",
      "Пропускная способность трафика",
      "Przepustowość ruchu sieciowego",
      "subtest_traffic_bandwidth"
    ],
    subtest_traffic_rate: [
      "Traffic Rate (Gb/s)",
      "Traffic Rate (Gb/s)",
      "トラフィックレート (Gb/s)",
      "流量速率（Gb/s）",
      "Traffic Rate (Gbit/s)",
      "Débit du trafic (Go/s)",
      "Frequenza traffico (Gb/s)",
      "Taxa de tráfego (Gb/s)",
      "Flujo de tráfico (Gb/S)",
      "Интенсивность трафика (Гб/с)",
      "Wskaźnik ruchu sieciowego (Gb/s)",
      "subtest_traffic_rate"
    ],
    subtest_info_rate: [
      "Info Rate (Mb/s)",
      "Info Rate (Mb/s)",
      "情報レート (Mb/s)",
      "信息速率（Mb/s）",
      "Info-Rate (Mbit/s)",
      "Débit des infos (Mo/s)",
      "Frequenza informazioni (Mb/s)",
      "Taxa de informação (Mb/s)",
      "Flujo de Datos (Mb/S)",
      "Скорость передачи информации (Мб/с)",
      "Wskaźnik informacji (Mb/s)",
      "subtest_info_rate"
    ],
    subtest_frame_fill: [
      "Frame Fill",
      "Frame Fill",
      "フレームフィル",
      "帧填充",
      "Frame-Größe",
      "Remplissage de trame",
      "Riempimento frame",
      "Preenchimento de quadro",
      "Llenado de la trama",
      "Заполнение кадра",
      "Wypełnienie ramki",
      "subtest_frame_fill"
    ],
    subtest_ieee802_3: [
      "IEEE802.3",
      "IEEE802.3",
      "IEEE802.3",
      "IEEE802.3",
      "IEEE802.3",
      "IEEE802.3",
      "IEEE802.3",
      "IEEE802.3",
      "IEEE802.3",
      "IEEE802.3",
      "IEEE802.3",
      "subtest_ieee802_3"
    ],
    subtest_expected_line_rate: [
      "Expected Line Rate",
      "Expected Line Rate",
      "期待されるラインレート",
      "预期线速",
      "Erwartete Leitungsrate",
      "Débit de la ligne attendu",
      "Frequenza linea attesa",
      "Taxa de linha esperada",
      "Nivel de tráfico esperado",
      "Ожидаемая пропускная способность линии",
      "Oczekiwana prędkość łącza",
      "subtest_expected_line_rate"
    ],
    subtest_customdata_update_successfully_toast: [
      "The default settings for Custom Data have been updated",
      "The default settings for Custom Data have been updated",
      "カスタムデータのデフォルト設定が更新されました。",
      "已更新自定义数据的默认设置",
      "Die Standardeinstellungen für die kundenspez. Daten wurden aktualisiert",
      "Les paramètres par défaut des données personnalisées ont été mis à jour.",
      "Le impostazioni predefinite per Dati personalizzati sono state aggiornate",
      "A configuração padrão de dados personalizados foi atualizada.",
      "Se han actualizado los ajustes predeterminados para datos personalizados",
      "Параметры по умолчанию для Пользовательских данных обновлены",
      "Zaktualizowano ustawienia domyślne dla dopasowanych danych ",
      "subtest_customdata_update_successfully_toast"
    ],
    subtest_cabledata_update_successfully_toast: [
      "The default settings for Cable Data have been updated",
      "The default settings for Cable Data have been updated",
      "ケーブルデータのデフォルト設定が更新されました。",
      "已更新电缆数据的默认设置",
      "Die Standardeinstellungen für Kabeldaten wurden aktualisiert",
      "Les paramètres par défaut des données du câble ont été mis à jour.",
      "Le impostazioni predefinite per Cavo personalizzato sono state aggiornate",
      "A configuração padrão de dados de cabo foi atualizada.",
      "Se han actualizado los ajustes predeterminados para datos de cables",
      "Параметры по умолчанию для Данных кабеля обновлены",
      "Zaktualizowano ustawienia domyślne dla danych okablowania",
      "subtest_cabledata_update_successfully_toast"
    ],
    subtest_number_of_sessions: [
      "No. of Sessions",
      "No. of Sessions",
      "セッションの数",
      "会话次数",
      "Anzahl der Sitzungen",
      "N° de sessions",
      "N. di sessioni",
      "Nº de sessões",
      "N.º de sesiones",
      "Кол-во Сессий",
      "Ilość sesji",
      "subtest_number_of_sessions"
    ],
    subtest_webdata_update_successfully_toast: [
      "The default settings for Web Data have been updated",
      "The default settings for Web Data have been updated",
      "Webデータのデフォルト設定が更新されました。",
      "已更新Web数据的默认设置",
      "Die Standardeinstellungen für Web-Daten wurden aktualisiert",
      "Les paramètres par défaut des données Internet ont été mis à jour.",
      "Le impostazioni predefinite per Dati web sono state aggiornate",
      "A configuração padrão de dados web foi atualizada.",
      "Se han actualizado los ajustes predeterminados para datos web",
      "Параметры по умолчанию для Данных Интернета обновлены",
      "Zaktualizowano ustawienia domyślne dla danych internetowych",
      "subtest_webdata_update_successfully_toast"
    ],
    subtest_wiremap_custom_cable_empty: [
      "No Custom Cables added.",
      "No Custom Cables added.",
      "カスタムケーブルは追加されていません。",
      "未添加自定义电缆。",
      "Keine kundenspez. Kabel hinzugefügt.",
      "Aucun câble personnalisé ajouté.",
      "Nessun Cavo personalizzato aggiunto.",
      "Nenhum cabo personalizado incluído.",
      "No se han añadido cables personalizados.",
      "Пользовательские кабели не добавлены.",
      "Nie dodano dopasowanego okablowania",
      "subtest_wiremap_custom_cable_empty"
    ],
    cable_limit_validation_text: [
      "The maximum of 20 cables have been added.",
      "The maximum of 20 cables have been added.",
      "最大数20個のケーブルが追加されました。",
      "已添加最多20条电缆。",
      "Die maximale Anzahl von 20 Kabeln wurde hinzugefügt.",
      "La quantité maximum de 20 câbles a été ajoutée.",
      "È stato aggiunto il numero massimo di 20 cavi.",
      "O máximo de 20 cabos foi adicionado.",
      "Se ha añadido el máximo de 20 cables.",
      "Добавлено макс. кол-во кабелей – 20.",
      "Dodano maksymalnie 20 kabli.",
      "cable_limit_validation_text"
    ],
    general_sub_test_wiremap_cust_head: [
      "Wiremap Custom Cables",
      "Wiremap Custom Cables",
      "ワイヤーマップカスタムケーブル",
      "接线图定制电缆",
      "Verdrahtungsplan für kundenspez. Kabel",
      "Schéma de câblage câbles personnalisés",
      "Cavi personalizzati mappatura fili",
      "Cabos personalizados para mapa de fios",
      "Cables personalizados del Mapeado de hilos",
      "Разводка пользовательских кабелей",
      "Mapa okablowania Okablowanie dopasowane",
      "general_sub_test_wiremap_cust_head"
    ],
    cust_cable_delete_confirm_text: [
      "Are you sure you would like to delete the <b>${name}</b> Cable?",
      "Are you sure you would like to delete the <b>${name}</b> Cable?",
      "「<b>${name}</b>」ケーブルを削除してもよろしいですか?",
      "您确定要删除<b>${name}</ b>电缆吗？",
      "Wollen Sie das Kabel <b>${name}</b> wirklich löschen?",
      "Êtes-vous sûr de vouloir supprimer le câble  <b>${name}</b>?",
      "Sei sicuro di voler eliminare il Cavo <b>${name}</b>?",
      "Tem certeza de que quer excluir o cabo <b>${name}</b>?",
      "¿Seguro que desea eliminar el cable <b>${name}</b>?",
      "Вы уверены, что хотите удалить Кабель <b>${name}</b>?",
      "Czy na pewno chcesz usunąć okablowanie <b>${name}</b>?",
      "cust_cable_delete_confirm_text"
    ],
    general_sub_test_wiremap_rem_cust_cable: [
      "Remove custom cable",
      "Remove custom cable",
      "カスタムケーブルを削除",
      "移除自定义电缆",
      "Kundenspezifisches Kabel entfernen",
      "Retirer le câble personnalisé",
      "Rimuovi cavo personalizzato",
      "Remover cabo personalizado",
      "Borrar cable personalizado",
      "Удалить пользовательский кабель",
      "Usuń dopasowane okablowanie",
      "general_sub_test_wiremap_rem_cust_cable"
    ],
    wiremap_update_successfully_toast: [
      "The Wiremap has been updated.",
      "The Wiremap has been updated.",
      "ワイヤーマップが更新されました。",
      "已更新接线图",
      "Der Verdrahtungsplan wurde aktualisiert.",
      "Le schéma de câblage a été mis à jour.",
      "La mappatura cavi è stata aggiornata.",
      "O mapa de fios foi atualizado.",
      "Se ha actualizado el Mapeado de Hilos",
      "Разводка проводов была обновлена.",
      "Mapa okablowania została zaktualizowana.",
      "wiremap_update_successfully_toast"
    ],
    sub_test_empty_cable_list_t1: [
      "There are currently no custom cables saved.",
      "There are currently no custom cables saved.",
      "現在、保存されたカスタムケーブルはありません。",
      "当前没有保存自定义电缆。",
      "Aktuell sind keine kundenspezifischen Kabel gespeichert.",
      "Aucun câble personnalisé n'a été enregistré jusqu'à présent.",
      "Non vi sono cavi personalizzati salvati al momento.",
      "Não há nenhum cabo personalizado salvo.",
      "No hay cables personalizados guardados actualmente.",
      "Сейчас нет сохраненных пользовательских кабелей.",
      "Obecnie nie ma zapisanego okablowania dopasowanego",
      "sub_test_empty_cable_list_t1"
    ],
    sub_test_empty_cable_list_t2: [
      "You can save custom cables by adding them in ",
      "You can save custom cables by adding them in ",
      "カスタムケーブルは追加して保存することができます",
      "您可以在......添加自定义电缆来保存电缆 ",
      "Sie können kundenspezifische Kabel speichern, indem Sie diese hinzufügen zu ",
      "Vous pouvez enregistrer des câbles en les ajoutant dans ",
      "Puoi salvare i cavi personalizzati aggiungendoli in ",
      "Você pode salvar cabos personalizados adicionando-os em ",
      "Puede guardar cables personalizados añadiéndolos en ",
      "Вы можете сохранять пользовательские кабели, добавляя их ",
      "Możesz zapisać okablowanie dopasowane dodając je ",
      "sub_test_empty_cable_list_t2"
    ],
    sub_test_cable_list_search_t3: [
      "Wiremap Custom Cables",
      "Wiremap Custom Cables",
      "ワイヤーマップカスタムケーブル",
      "接线图定制电缆",
      "Verdrahtungsplan für kundenspez. Kabel",
      "Schéma de câblages des câbles personnalisés",
      "Cavi personalizzati mappatura fili",
      "Cabos personalizados para mapa de fios",
      "Cables personalizados del Mapeado de Hilos",
      "Разводка пользовательских кабелей",
      "Mapa okablowania Okablowanie dopasowane",
      "sub_test_cable_list_search_t3"
    ],
    subtest_voipdata_update_successfully_toast: [
      "The default settings for VoIP Data have been updated",
      "The default settings for VoIP Data have been updated",
      "VoIPデータのデフォルト設定が更新されました",
      "已更新VoIP数据的默认设置",
      "Die Standardeinstellungen für VoIP-Daten wurden aktualisiert",
      "Les paramètres par défaut des données VoIP ont été mis à jour.",
      "Le impostazioni predefinite per Dati VoIP sono state aggiornate",
      "A configuração padrão de dados VoIP foi atualizada.",
      "Se han actualizado los ajustes predeterminados para datos VoIP",
      "Параметры по умолчанию для Данных VoIP обновлены",
      "Zaktualizowano ustawienia domyślne dla danych VoIP",
      "subtest_voipdata_update_successfully_toast"
    ],
    subtest_videodata_update_successfully_toast: [
      "The default settings for Video Data have been updated",
      "The default settings for Video Data have been updated",
      "ビデオデータのデフォルト設定が更新されました",
      "已更新视频数据的默认设置",
      "Die Standardeinstellungen für Video-Daten wurden aktualisiert",
      "Les paramètres par défaut des données Vidéo ont été mis à jour.",
      "Le impostazioni predefinite per Dati video sono state aggiornate",
      "A configuração padrão de dados de vídeo foi atualizada.",
      "Se han actualizado los ajustes predeterminados para datos de vídeo",
      "Параметры по умолчанию для Видео-Данных обновлены",
      "Zaktualizowano ustawienia domyślne dla danych wideo",
      "subtest_videodata_update_successfully_toast"
    ],
    subtest_cctvdata_update_successfully_toast: [
      "The default settings for CCTV Data have been updated",
      "The default settings for CCTV Data have been updated",
      "CCTVデータのデフォルト設定が更新されました",
      "已更新CCTV数据的默认设置",
      "Die Standardeinstellungen für CCTV-Daten wurden aktualisiert",
      "Les paramètres par défaut des données de caméras IP ont été mis à jour.",
      "Le impostazioni predefinite per Dati CCTV sono state aggiornate",
      "A configuração padrão de dados CFTV foi atualizada.",
      "Se han actualizado los ajustes predeterminados para datos CCTV",
      "Параметры по умолчанию для Данных Видеонаблюдения обновлены",
      "Zaktualizowano ustawienia domyślne dla danych CCTV",
      "subtest_cctvdata_update_successfully_toast"
    ],
    subtest_fiberlengthloss_update_successfully_toast: [
      "The default settings for Fibre Length & Loss have been updated",
      "The default settings for Fiber Length & Loss have been updated",
      "ファイバー長と損失のデフォルト設定が更新されました",
      "光纤长度和损耗的默认设置已更新",
      "Die Standardeinstellungen für Fiber Length & Loss wurden aktualisiert",
      "Les paramètres par défaut pour la longueur et la perte de fibre ont été mis à jour",
      "Le impostazioni predefinite per Lunghezza e perdita fibra sono state aggiornate",
      "As configurações padrão para comprimento e perda da fibra foram atualizadas",
      "Se han actualizado los ajustes predeterminados de longitud y pérdida de fibra",
      "Настройки по умолчанию для длины волокна и потерь были обновлены.",
      "Zaktualizowano ustawienia domyślne długości i strat światłowodu",
      "subtest_fiberlengthloss_update_successfully_toast"
    ],
    subtest_qualification_update_successfully_toast: [
      "The default settings for Qualification have been updated",
      "The default settings for Qualification have been updated",
      "資格のデフォルト設定が更新されました",
      "资格资格的默认设置已更新",
      "Die Standardeinstellungen für die Qualifikation wurden aktualisiert",
      "Les paramètres par défaut de qualification ont été mis à jour",
      "Le impostazioni predefinite per la qualifica sono state aggiornate",
      "As configurações padrão para qualificação foram atualizadas",
      "Se han actualizado la configuración predeterminada para la calificación",
      "Настройки по умолчанию для квалификации были обновлены",
      "Domyślne ustawienia kwalifikacji zostały zaktualizowane",
      "subtest_qualification_update_successfully_toast"
    ],
    subtest_traffic_type: [
      "Traffic Type",
      "Traffic Type",
      "トラフィックタイプ",
      "流量类型",
      "Traffic Typ",
      "Type de trafic",
      "Tipo di traffico",
      "Tipo de tráfego",
      "Tipo de tráfico",
      "Тип трафика",
      "Typ ruchu sieciowego",
      "subtest_traffic_type"
    ],
    subtest_number_of_calls: [
      "No. of Calls",
      "No. of Calls",
      "コールの数",
      "通话次数",
      "Anzahl der Anrufe",
      "N° d'appels",
      "N. di chiamate",
      "Nº de chamadas",
      "N.º de llamadas",
      "Кол-во Звонков",
      "Ilość połączeń",
      "subtest_number_of_calls"
    ],
    subtest_number_of_streams: [
      "No. of Streams",
      "No. of Streams",
      "ストリームの数",
      "数据流数量",
      "Anzahl der Ströme",
      "N° de flux",
      "N. di flussi",
      "Nº de fluxos",
      "N.º de secuencias",
      "Кол-во Потоков",
      "Ilość przesyłów strumieniowych",
      "subtest_number_of_streams"
    ],
    subtest_definition: [
      "Definition",
      "Definition",
      "定義",
      "定义",
      "Definition",
      "Définition",
      "Definizione",
      "Definição",
      "Definición",
      "Определение",
      "Definicja",
      "subtest_definition"
    ],
    subtest_number_of_cameras: [
      "No. of Cameras",
      "No. of Cameras",
      "カメラの数",
      "相机数量",
      "Anzahl der Kameras",
      "N° de caméras",
      "N. di telecamere",
      "Nº de câmeras",
      "N.º de cámaras",
      "Кол-во Камер",
      "Ilość kamer",
      "subtest_number_of_cameras"
    ],
    subtest_resolution: [
      "Resolution",
      "Resolution",
      "解決",
      "解析度",
      "Auflösung",
      "Résolution",
      "Risoluzione",
      "Resolução",
      "Resolución",
      "Разрешение",
      "Rozdzielczość",
      "subtest_resolution"
    ],
    subtest_codec: [
      "Codec",
      "Codec",
      "Codec",
      "编解码器",
      "Codec",
      "Codec",
      "Codec",
      "Codec",
      "Códec",
      "Кодек",
      "Kodek",
      "subtest_codec"
    ],
    result_network: [
      "Network",
      "Network",
      "ネットワーク",
      "网络",
      "Netzwerk",
      "Réseau",
      "Rete",
      "Rede",
      "Red",
      "Сеть",
      "Sieć",
      "result_network"
    ],
    result_transmission: [
      "Transmission",
      "Transmission",
      "伝送",
      "传播",
      "Übertragung",
      "Transmission",
      "Trasmissione",
      "Transmissão",
      "Transmisión",
      "Передача",
      "Transmisja",
      "result_transmission"
    ],
    result_wiremap: [
      "Wiremap",
      "Wiremap",
      "ワイヤーマップ",
      "接线图",
      "Verdrahtungsplan",
      "Câblage",
      "Mappatura fili",
      "Mapa de fios",
      "Diagrama de cables",
      "Схема разводки кабеля",
      "Mapa okablowania",
      "result_wiremap"
    ],
    result_poeload: [
      "PoE Load",
      "PoE Load",
      "PoE負荷",
      "PoE负载",
      "PoE-Last",
      "Chargement PoE",
      "Carico PoE",
      "Carga de PoE",
      "Carga PoE",
      "Нагрузка PoE",
      "Ładowanie PoE",
      "result_poeload"
    ],
    result_fiber: [
      "Fibre Length & Loss",
      "Fiber Length & Loss",
      "繊維の長さと損失",
      "光纤长度和损耗",
      "Faserlänge und Dämpfung",
      "Longueur et perte fibre",
      "Lunghezza &amp; Perdita della Fibra",
      "Perda e Comprimento da Fibra",
      "Longitud y pérdida de la fibra",
      "Длина волокна и потери",
      "Długość i strata włókna",
      "result_fiber"
    ],
    testinterface: [
      "Interface",
      "Interface",
      "インターフェース",
      "接口",
      "Schnittstelle",
      "Interface",
      "Interfaccia",
      "Interface",
      "Interfaz",
      "Интерфейс",
      "Interfejs",
      "testinterface"
    ],
    operationmode: [
      "Operation Mode",
      "Operation Mode",
      "動作モード",
      "操作模式",
      "Betriebsmodus",
      "Mode de fonctionnement",
      "Modalità di funzionamento",
      "Modo de Operação",
      "Modo de operación",
      "Режим работы",
      "Tryb pracy",
      "operationmode"
    ],
    basicmode: [
      "Basic Mode",
      "Basic Mode",
      "基本モード",
      "基本模式",
      "Grundmodus",
      "Mode simple",
      "Modalità di base",
      "Modo Básico",
      "Modo básico",
      "Основной режим",
      "Tryb podstawowy",
      "basicmode"
    ],
    advancedmode: [
      "Advanced Mode",
      "Advanced Mode",
      "アドバンストモード",
      "高级模式",
      "Fortgeschrittener Modus",
      "Mode avancé",
      "Modalità avanzata",
      "Modo Avançado",
      "Modo avanzado",
      "Расширенный режим",
      "Tryb zaawansowany",
      "advancedmode"
    ],
    qualifycable: [
      "Qualify-Cable",
      "Qualify-Cable",
      "資格のあるケーブル",
      "检验电缆",
      "Kabel qualifizieren",
      "Qualifier le câble",
      "Qualifica Cavo",
      "Qualificar Cabos",
      "Calificar cable",
      "Квалификация кабеля",
      "Kwalifikacja okablowania",
      "qualifycable"
    ],
    networktest: [
      "Network-Test",
      "Network-Test",
      "通信網テスト",
      "网络测试",
      "Netzwerktest",
      "Test réseau",
      "Test di rete",
      "Testar Redes",
      "Prueba de red",
      "Сетевой тест",
      "Test sieci",
      "networktest"
    ],
    bandwidth: [
      "Bandwidth",
      "Bandwidth",
      "帯域幅",
      "带宽",
      "Bandbreite",
      "Bande passante",
      "Larghezza di banda",
      "Largura de Banda",
      "Ancho de banda",
      "Пропускная способность",
      "Przepustowość",
      "bandwidth"
    ],
    ip_bandwidth: [
      "IP & Bandwidth",
      "IP & Bandwidth",
      "IPおよび帯域幅",
      "IP和带宽",
      "IP und Bandbreite",
      "IP et bande passante",
      "IP e larghezza di banda",
      "Largura de Banda e IP",
      "IP y ancho de banda",
      "IP и полосы пропускания",
      "IP i przepustowość",
      "ip_bandwidth"
    ],
    autotest: [
      "Auto Test",
      "Auto Test",
      "自動テスト",
      "自动测试",
      "Automatischer Test",
      "Test automatique",
      "Auto test",
      "Auto teste",
      "Auto prueba",
      "Авто-тест",
      "Test automatyczny",
      "autotest"
    ],
    manualtest: [
      "Manual Test",
      "Manual Test",
      "手動テスト",
      "手动测试",
      "Manueller Test",
      "Test manuel",
      "Test manuale",
      "Teste manual",
      "Prueba manual",
      "Ручной тест",
      "Test ręczny",
      "manualtest"
    ],
    result_panel: [
      "Panel:",
      "Panel:",
      "パネル:",
      "面板：",
      "Verteiler:",
      "Panneau :",
      "Pannello:",
      "Painel:",
      "Panel:",
      "Панель:",
      "Panel:",
      "result_panel"
    ],
    create_signaltek_fiber: [
      "Fibre",
      "Fiber",
      "ファイバー",
      "光纤",
      "Faser:",
      "Fibre",
      "Fibra",
      "Fibra",
      "Fibra",
      "Волокно",
      "Włókno",
      "create_signaltek_fiber"
    ],
    create_signaltek_copper: [
      "Copper",
      "Copper",
      "銅線",
      "铜",
      "Kupfer",
      "Cuivre",
      "Rame",
      "Cobre",
      "Cobre",
      "Медь",
      "Miedź",
      "create_signaltek_copper"
    ],
    "WiFi": [
      "Wi-Fi",
      "Wi-Fi",
      "Wi-Fi",
      "Wi-Fi",
      "Wi-Fi",
      "Wi-Fi",
      "Wi-Fi",
      "Wi-Fi",
      "Wi-Fi",
      "Wi-Fi",
      "Wi-Fi",
      "WiFi"
    ],
    hidden_ssid: [
      "Hidden SSID",
      "Hidden SSID",
      "非公開SSID",
      "隐藏SSID",
      "Versteckte SSID",
      "SSID caché",
      "SSID nascosto",
      "SSID oculto",
      "SSID oculto",
      "Скрытый SSID",
      "Ukryty SSID",
      "hidden_ssid"
    ],
    channel_frequency: [
      "Channel / Frequency (GHz) / Channel width (MHz)",
      "Channel / Frequency (GHz) / Channel width (MHz)",
      "チャネル /  周波数 (GHz) / チャネル幅 (MHz)",
      "信道 / 频率 (GHz) / 信道宽度 (MHz)",
      "Kanal / Frequenz (GHz) / Kanalbreite (MHz)",
      "Canal / Fréquence (GHz) / Largeur de canal (MHz)",
      "Canale / Frequenza (GHz) / Larghezza del canale (MHz)",
      "Canal / Frequência (GHz) / Largura do canal (MHz)",
      "Canal / Frecuencia (GHz) / Ancho del canal (MHz)",
      "Канал / Частота (ГГц) / Ширина канала (МГц)",
      "Kanał / Częstotliwość (GHz) / Szerokość kanału (MHz)",
      "channel_frequency"
    ],
    channel_frequency_no_units: [
      "Channel / Frequency / Channel width",
      "Channel / Frequency / Channel width",
      "チャネル /  周波数 / チャネル幅",
      "信道 / 频率 / 信道宽度",
      "Kanal / Frequenz / Kanalbreite",
      "Canal / Fréquence / Largeur de canal",
      "Canale / Frequenza / Larghezza del canale",
      "Canal / Frequência / Largura do canal",
      "Canal / Frecuencia / Ancho del canal",
      "Канал / Частота / Ширина канала",
      "Kanał / Częstotliwość / Szerokość kanału",
      "channel_frequency_no_units"
    ],
    bit_rate: [
      "Bit Rate",
      "Bit Rate",
      "ビットレート",
      "比特率",
      "Bitrate",
      "Tarif binaire",
      "Bit tasso",
      "Taxa de bits",
      "Tasa de bits",
      "Скорость бита",
      "Tapetność",
      "bit_rate"
    ],
    wifi_device: [
      "Wi-Fi Device",
      "Wi-Fi Device",
      "Wi-Fiデバイス",
      "Wi-Fi设备",
      "Wi-Fi-Gerät",
      "Dispositif Wi-Fi",
      "Dispositivo Wi-Fi",
      "Dispositivo Wi-Fi",
      "Dispositivo Wi-Fi",
      "Wi-Fi устройство",
      "Urządzenie Wi-Fi",
      "wifi_device"
    ],
    "Internal Antenna": [
      "Internal Antenna",
      "Internal Antenna",
      "内部アンテナ",
      "内部天线",
      "Interne Antenne",
      "Antenne interne",
      "Antenna interna",
      "Antena interna",
      "Antena interna",
      "Внутренняя антенна",
      "Antena wewnętrzna",
      "Internal Antenna"
    ],
    "External Antenna": [
      "External Antenna",
      "External Antenna",
      "外部アンテナ",
      "外部天线",
      "Externe Antenne",
      "Antenne externe",
      "Antenna esterna",
      "Antena externa",
      "Antena externa",
      "Внешняя антенна",
      "Antena zewnętrzna",
      "External Antenna"
    ],
    "USB Adapter": [
      "USB Adapter",
      "USB Adapter",
      "USBアダプタ",
      "USB适配器",
      "USB-Adapter",
      "Adaptateur USB",
      "Adattatore USB",
      "Adaptador USB",
      "Adaptador USB",
      "USB-адаптер",
      "Adapter USB",
      "USB Adapter"
    ],
    wifi_status: [
      "Wi-Fi Status",
      "Wi-Fi Status",
      "Wi-Fiステータス",
      "Wi-Fi状态",
      "Wi-Fi-Status",
      "Statut Wi-Fi",
      "Stato Wi-Fi",
      "Status Wi-Fi",
      "Estado de Wi-Fi",
      "Статус Wi-Fi",
      "Status Wi-Fi",
      "wifi_status"
    ],
    signal_strength: [
      "Signal Strength",
      "Signal Strength",
      "信号強度",
      "信号强度",
      "Signalstärke",
      "Force du signal",
      "Tenna del segnale",
      "Força do sinal",
      "Resistencia a la señal",
      "Прочность сигнала",
      "Siła sygnału",
      "signal_strength"
    ],
    security: [
      "Security",
      "Security",
      "安全",
      "安全",
      "Sicherheit",
      "Sécurité",
      "Sicurezza",
      "Segurança",
      "Seguridad",
      "Безопасность",
      "Bezpieczeństwo",
      "security"
    ],
    hidden_network: [
      "Hidden Network",
      "Hidden Network",
      "隠されたネットワーク",
      "隐藏网络",
      "Verstecktes Netzwerk",
      "Réseau caché",
      "Rete nascosta",
      "Rede oculta",
      "Red oculta",
      "Скрытая сеть",
      "Ukryta sieć",
      "hidden_network"
    ],
    web_login_required: [
      "Web Login Required",
      "Web Login Required",
      "Webログインが必要です",
      "需要Web登录",
      "Web -Login erforderlich",
      "Connexion Web requise",
      "Accesso Web richiesto",
      "Login da web necessário",
      "Se requiere inicio de sesión web",
      "Требуется веб -логин",
      "Wymagane logowanie internetowe",
      "web_login_required"
    ],
    wifi_connection_info: [
      "Wi-Fi Connection Info",
      "Wi-Fi Connection Info",
      "Wi-Fi接続情報",
      "Wi-Fi连接信息",
      "Wi-Fi-Verbindungsinformationen",
      "Informations sur la connexion Wi-Fi",
      "Informazioni sulla connessione Wi-Fi",
      "Informações de conexão Wi-Fi",
      "Información de conexión Wi-Fi",
      "Информация о подключении Wi-Fi",
      "Informacje o połączeniu Wi-Fi",
      "wifi_connection_info"
    ],
    eth_link_info: [
      "Ethernet Link Info",
      "Ethernet Link Info",
      "イーサネットリンク情報",
      "以太网链接信息",
      "Ethernet -Link -Info",
      "Informations sur le lien Ethernet",
      "Informazioni sul collegamento Ethernet",
      "Informações do link Ethernet",
      "Información de enlace de Ethernet",
      "Информация о ссылке Ethernet",
      "Informacje o linku Ethernet",
      "eth_link_info"
    ],
    optical_link_info: [
      "Optical Link Info",
      "Optical Link Info",
      "光リンク情報",
      "光学链接信息",
      "Optische Linkinfo",
      "Informations sur le lien optique",
      "Informazioni sul collegamento ottico",
      "Informações do link óptico",
      "Información de enlace óptico",
      "Информация о оптической ссылке",
      "Informacje o linku optycznym",
      "optical_link_info"
    ],
    wifi_scanned_aps: [
      "Wi-Fi Scanned Access Points",
      "Wi-Fi Scanned Access Points",
      "Wi-Fiスキャンされたアクセスポイント",
      "Wi-Fi扫描访问点",
      "Wi-Fi-Access-Punkte",
      "Points d'accès numérisés Wi-Fi",
      "Punti di accesso scansionati con Wi-Fi",
      "Pontos de acesso digitalizados Wi-Fi",
      "Puntos de acceso escaneados de Wi-Fi",
      "Wi-Fi Сканированные точки доступа",
      "Wi-Fi zeskanowane punkty dostępu",
      "wifi_scanned_aps"
    ],
    channel_analysis: [
      "Channel Analysis",
      "Channel Analysis",
      "チャネル分析",
      "信道分析",
      "Kanalanalyse",
      "Analyse des canaux",
      "Analisi del canale",
      "Análise de Canal",
      "Análisis del canal",
      "Анализ канала",
      "Analiza kanału",
      "channel_analysis"
    ],
    channel_utilization: [
      "Channel Utilisation",
      "Channel Utilization",
      "チャネル使用率",
      "信道利用率",
      "Kanalauslastung",
      "Utilisation des canaux",
      "Utilizzo del canale",
      "Utilização do Canal",
      "Utilización del canal",
      "Использование канала",
      "Wykorzystanie kanału",
      "channel_utilization"
    ],
    devices_per_channel: [
      "Devices per Channel",
      "Devices per Channel",
      "チャネルごとのデバイス数",
      "每个信道的设备数",
      "Geräte pro Kanal",
      "Appareils par canal",
      "Dispositivi per canale",
      "Dispositivos por Canal",
      "Dispositivos por canal",
      "Устройства по каналам",
      "Urządzenia na kanał",
      "devices_per_channel"
    ],
    add_cust_tab_details: [
      "Details",
      "Details",
      "詳細",
      "详细信息",
      "Details",
      "Détails",
      "Dettagli",
      "Detalhes",
      "Datos",
      "Подробности",
      "Szczegóły",
      "add_cust_tab_details"
    ],
    add_cust_tab_network: [
      "Network Tests",
      "Network Tests",
      "ネットワークテスト",
      "网络测试",
      "Netzwerktests",
      "Tests du réseau",
      "Prove di rete",
      "Testes de rede",
      "Pruebas de red",
      "Сетевые тесты",
      "Testy sieci",
      "add_cust_tab_network"
    ],
    add_cust_tab_transmission: [
      "Transmission Tests",
      "Transmission Tests",
      "伝送テスト",
      "传输测试",
      "Übertragungstests",
      "Tests de la transmission",
      "Prove di trasmissione",
      "Testes de transmissão",
      "Pruebas de transmisión",
      "Тесты параметров передачи",
      "Testy transmisji",
      "add_cust_tab_transmission"
    ],
    add_cust_tab_wiremap: [
      "Wiremap Tests",
      "Wiremap Tests",
      "ワイヤーマップテスト",
      "接线图测试",
      "Verdrahtungsplan",
      "Tests du câblage",
      "Prove di mappatura fili",
      "Testes de mapa de fios",
      "Pruebas de diagrama de cables",
      "Тесты разводки проводов",
      "Testy mapy okablowania",
      "add_cust_tab_wiremap"
    ],
    add_cust_tab_poe: [
      "POE Tests",
      "POE Tests",
      "PoEテスト",
      "POE测试",
      "POE-Tests",
      "Tests du PoE",
      "Prove POE",
      "Testes de POE",
      "Pruebas PoE",
      "Тесты POE",
      "Testy POE",
      "add_cust_tab_poe"
    ],
    add_cust_subtest_required: [
      "No subtest selected",
      "No subtest selected",
      "Subテストが選択されていません",
      "未选择子测试",
      "Kein Untertest ausgewählt",
      "Aucun sous-test sélectionné",
      "Nessun subtest selezionato",
      "Nenhum subteste selecionado",
      "No se han seleccionado subpruebas",
      "Подтест не выбран",
      "Nie wybrano testu podrzędnego",
      "add_cust_subtest_required"
    ],
    restore_default_settings: [
      "Restore default settings",
      "Restore default settings",
      "デフォルト設定を復元",
      "恢复默认设置",
      "Standardeinst. wiederherstellen",
      "Restaurer les paramètres par défaut",
      "Ripristina impostazioni predefinite",
      "Restaurar configuração padrão",
      "Restaurar ajustes predeterminados",
      "Восстановить исх. настр-ки",
      "Przywróć ustawienia domyślne",
      "restore_default_settings"
    ],
    restore_go_back_confirm_text: [
      "Are you sure you want to restore the default settings",
      "Are you sure you want to restore the default settings",
      "デフォルト設定を復元してもよろしいですか",
      "您确定要恢复默认设置吗",
      "Wollen Sie die Standardeinstellungen wirklich wiederherstellen?",
      "Êtes-vous sûr de vouloir restaurer les paramètres par défaut ?",
      "Sei sicuro di voler ripristinare le impostazioni predefinite?",
      "Tem certeza de que quer restaurar a configuração padrão",
      "¿Seguro que desea restaurar los ajustes predeterminados?",
      "Вы уверены, что хотите восстановить исходные настройки",
      "Czy na pewno chcesz przywrócić ustawienia domyślne",
      "restore_go_back_confirm_text"
    ],
    test_types_signaltek: [
      "Interface Type",
      "Interface Type",
      "インターフェースタイプ",
      "接口类型",
      "Schnittstellentyp",
      "Type d'interface",
      "Tipo di interfaccia",
      "Tipo de interface",
      "Tipo de interfaz",
      "Тип Интерфейса",
      "Typ interfejsu",
      "test_types_signaltek"
    ],
    subtest_type: [
      "Subtest Type",
      "Subtest Type",         
      "サブテストの種類",          
      "子测试类型",              
      "Untertesttyp",         
      "Type de sous-test",    
      "Tipo di sottotest",    
      "Tipo de Subteste",     
      "Tipo de subprueba",    
      "Тип подтеста",         
      "Typ podtestu",
      "subtest_type"
    ],
    subtest_modified: [
      "Modified",
      "Modified",
      "修正済み",
      "已修改",
      "Geändert",
      "Modifié",
      "Modificata",
      "Modificada",
      "Modificada",
      "Изменено",
      "Zmodyfikowano",
      "subtest_modified"
    ],
    st_test_go_back_confirm_text: [
      "Are you sure you want to exit? You will lose any unsaved changes.",
      "Are you sure you want to exit? You will lose any unsaved changes.",
      "終了してもよろしいですか? 保存されていない変更内容は失われます。",
      "您确定要退出吗？所有未保存更改将丢失。",
      "Möchten Sie das Fenster wirklich verlassen? Alle nicht gespeicherten Änderungen gehen verloren.",
      "Êtes-vous sûr de vouloir quitter ? Vous perdrez toutes les modifications non sauvegardées.",
      "Sei sicuro di voler uscire? Perderai tutte le modifiche non salvate.",
      "Quer mesmo sair? Você perderá todas as alterações não foram salvas.",
      "¿Seguro que desea salir? Perderá los cambios sin guardar.",
      "Вы уверены, что хотите выйти? Несохраненные изменения будут потеряны.",
      "Czy na pewno chcesz wyjść? Utracisz wszystkie niezapisane zmiany.",
      "st_test_go_back_confirm_text"
    ],
    edit_sub_test_empty_target_search_t1: [
      "There are no default targets for this customer.",
      "There are no default targets for this customer.",
      "このカスタマーにはデフォルトのターゲットがありません。",
      "此客户没有默认目标。",
      "Für diesen Kunden gibt es keine Standard-Ziele.",
      "Aucune cible par défaut n'a été sélectionné pour ce client.",
      "Non vi sono target predefiniti per questo cliente.",
      "Não há destinos padrão para este cliente.",
      "No hay destinos predeterminados para este cliente.",
      "Для этого клиента нет целевых адресов по умолчанию.",
      "Nie ma domyślnych celów dla tego klienta.",
      "edit_sub_test_empty_target_search_t1"
    ],
    edit_sub_test_empty_target_search_t2: [
      "You can add default targets under Customer settings.",
      "You can add default targets under Customer settings.",
      "カスタマー設定でデフォルトのターゲットを追加できます。",
      "您可以在客户设置下添加默认目标。",
      "Standardziele können in den Kunden-Einstellungen hinzugefügt werden.",
      "Vous pouvez ajouter des cibles par défaut dans les paramètres client.",
      "Puoi aggiungere target predefiniti sotto Impostazioni cliente.",
      "Você pode adicionar destinos padrão na configuração do cliente.",
      "Puede añadir destinos predeterminados en los ajustes del cliente.",
      "Вы можете добавить целевые адреса в настройках Клиента.",
      "Możesz dodać domyślne cele w ustawieniach klienta.",
      "edit_sub_test_empty_target_search_t2"
    ],
    aborted: [
      "ABORTED",
      "ABORTED",
      "中断",
      "已中止",
      "ABGEBROCHEN",
      "INTERROMPU",
      "INTERROTTA",
      "ABORTADO",
      "ABORTADO",
      "ПРЕРВАНО",
      "WSTRZYMANO",
      "aborted"
    ],
    measurement_unit: [
      "Measurement Units",
      "Measurement Units",
      "測定単位",
      "计量单位",
      "Masseinheiten",
      "Unités de mesure",
      "Unità di misurazione",
      "Unidades de Medida",
      "Unidades de medida",
      "Ед-цы измерения",
      "Jednostki miary",
      "measurement_unit"
    ],
    passed: [
      "Pass",
      "Pass",
      "成功",
      "已通过",
      "Bestanden",
      "Succès",
      "Superata",
      "Aprovado",
      "Superado",
      "Пройдено",
      "Powiodło się",
      "passed"
    ],
    failed: [
      "Fail",
      "Fail",
      "失敗",
      "已失败",
      "Fehler",
      "Échec",
      "Fallita",
      "Reprovado",
      "No superado",
      "Не пройдено",
      "Nie zaliczone",
      "failed"
    ],
    result_test_started: [
      "TEST STARTED",
      "TEST STARTED",
      "開始されたテスト",
      "测试开始",
      "TEST GESTARTET",
      "LE TEST A DÉMARRÉ",
      "PROVA INIZIATA",
      "TESTE INICIADO",
      "PRUEBA INICIADA",
      "ТЕСТ НАЧАЛСЯ",
      "TEST ROZPOCZĘTY",
      "result_test_started"
    ],
    result_test_exec_time: [
      "TEST EXECUTION TIME",
      "TEST EXECUTION TIME",
      "テスト実行時間",
      "测试执行时间",
      "Testzeit testen",
      "Temps d'exécution de test",
      "Tempo di esecuzione del test",
      "Teste de tempo de execução",
      "Tiempo de ejecución de la prueba",
      "Время выполнения теста",
      "Czas wykonania testu",
      "result_test_exec_time"
    ],
    result_test_duration: [
      "TEST DURATION",
      "TEST DURATION",
      "テスト期間",
      "测试时间\n",
      "TESTDAUER",
      "DURÉE DU TEST",
      "DURATA PROVA",
      "DURAÇÃO DO TESTE",
      "DURACIÓN DE LA PRUEBA",
      "ДЛИТЕЛЬНОСТЬ ТЕСТА",
      "CZAS TRWANIA TESTU",
      "result_test_duration"
    ],
    //Chinese, English, French, German, Italian, Japanese, Polish, Portuguese, Russian, Spanish,
    result_supported_standards: [
      "SUPPORTED STANDARDS",
      "SUPPORTED STANDARDS",
      "サポートされた規格",
      "支持的标准",
      "UNTERSTÜTZTE STANDARDS",
      "NORMES PRISES EN CHARGE",
      "STANDARD SUPPORTATI",
      "PADRÕES SUPORTADOS",
      "ESTÁNDARES COMPATIBLES",
      "ПОДДЕРЖИВАЕМЫЕ СТАНДАРТЫ",
      "WSPÓŁPRACUJĄCE STANDARDY",
      "result_supported_standards"
    ],
    result_length_limit: [
      "LENGTH / LIMIT",
      "LENGTH / LIMIT",
      "長さ / 限界",
      "长度 / 限制",
      "LÄNGE / LIMIT",
      "LONGUEUR / LIMITE",
      "LUNGHEZZA / LIMITE",
      "COMPRIMENTO / LIMITE",
      "LONGITUD / LÍMITE",
      "ДЛИНА / ЛИМИТ",
      "DŁUGOŚĆ / LIMIT",
      "result_length_limit"
    ],
    result_insloss_limit: [
      "INSERTION LOSS / LIMIT",
      "INSERTION LOSS / LIMIT",
      "挿入損失（インサーションロス） / 限界",
      "插入损耗 / 限制",
      "Einfügedämpfung / Limit",
      "Attenuation / Limite",
      "Perdita d'inserzione / Limite",
      "Perda de Inserção / Limite",
      "Pérdida de inserción / Limite",
      "Вносимые потери / Предел",
      "Straty / Limit",
      "result_insloss_limit"
    ],
    result_test_limit_standard: [
      "TEST LIMIT / STANDARD",
      "TEST LIMIT / STANDARD",
      "テストリミット / 標準",
      "测试限制/标准",
      "PRÜFGRENZE / STANDARD",
      "LIMITE D'ESSAI / NORME",
      "LIMITE DI PROVA / STANDARD",
      "LIMITE DE TESTE / PADRÃO",
      "PRUEBA LÍMITE / ESTÁNDAR",
      "ИСПЫТАТЕЛЬНЫЙ ПРЕДЕЛ / СТАНДАРТ",
      "LIMIT TESTOWY / STANDARD",
      "result_test_limit_standard"
    ],
    result_total_targets: [
      "TOTAL TARGETS",
      "TOTAL TARGETS",
      "ターゲット合計",
      "总目标",
      "ZIELE - GESAMT",
      "CIBLES TOTALES",
      "TARGET TOTALI",
      "DESTINOS TOTAIS",
      "DESTINOS TOTALES",
      "ВСЕГО ЦЕЛЕВЫХ АДРЕСОВ",
      "SUMA CELÓW",
      "result_total_targets"
    ],
    result_passed_targets: [
      "TARGETS PASSED",
      "TARGETS PASSED",
      "成功したターゲット",
      "已通过目标",
      "ZIELE - BESTANDEN",
      "CIBLES en SUCCÈS",
      "TARGET SUPERATI",
      "DESTINOS APROVADOS",
      "DESTINOS SUPERADOS",
      "ПРОШЕДШИХ ЦЕЛЕВЫХ АДРЕСОВ",
      "CELE ZALICZONE",
      "result_passed_targets"
    ],
    result_failed_targets: [
      "TARGETS FAILED",
      "TARGETS FAILED",
      "失敗したターゲット",
      "已失败目标",
      "ZIELE - FEHLER",
      "CIBLES en ECHEC",
      "TARGET FALLITI",
      "DESTINOS REPROVADOS",
      "DESTINOS NO SUPERADOS",
      "НЕ ПРОШЕДШИХ ЦЕЛЕВЫХ АДРЕСОВ",
      "CELE NIE ZALICZONE",
      "result_failed_targets"
    ],
    result_info: [
      "Info",
      "Info",
      "情報",
      "信息",
      "Info",
      "Info",
      "Informazioni",
      "Informação",
      "Información",
      "Информация",
      "Informacje",
      "result_info"
    ],
    result_tx: [
      "Tx Count",
      "Tx Count",
      "Tx数",
      "发射数",
      "Tx-Zähler",
      "Nombre Tx",
      "Conteggio trasmessi",
      "Contagem Tx",
      "Recuento Tx",
      "Счетчик Tx",
      "Ilość Tx",
      "result_tx"
    ],
    result_rx: [
      "Rx Count",
      "Rx Count",
      "Rx数",
      "接收数",
      "Rx-Zähler",
      "Nombre Rx",
      "Conteggio ricevuti",
      "Contagem Rx",
      "Recuento Rx",
      "Счетчик Rx",
      "Ilość Rx",
      "result_rx"
    ],
    result_delay: [
      "Delay(ms)",
      "Delay(ms)",
      "遅延(ms)",
      "延迟（毫秒）",
      "Laufzeit (ms)",
      "Délai (ms)",
      "Ritardo (ms)",
      "Atraso(ms)",
      "Retardo (ms)",
      "Задержка (мс)",
      "Opóźnienie (ms)",
      "result_delay"
    ],
    result_min: [
      "Min",
      "Min",
      "最小",
      "最小",
      "Min",
      "Min.",
      "Min",
      "Mín",
      "Mín.",
      "Мин",
      "Min.",
      "result_min"
    ],
    result_avg: [
      "Avg",
      "Avg",
      "平均",
      "平均",
      "Mittl",
      "Moy.",
      "Media",
      "Méd",
      "Media",
      "Средн",
      "Średnio",
      "result_avg"
    ],
    result_max: [
      "Max",
      "Max",
      "最大",
      "最大",
      "Max",
      "Max.",
      "Max",
      "Máx",
      "Máx.",
      "Макс",
      "Maks.",
      "result_max"
    ],
    ready: [
      "READY",
      "READY",
      "準備完了",
      "准备就绪",
      "BEREIT",
      "PRÊT",
      "PRONTO",
      "PRONTO",
      "LISTO",
      "ГОТОВО",
      "GOTOWE",
      "ready"
    ],
    unknown: [
      "UNKNOWN",
      "UNKNOWN",
      "不明",
      "未知",
      "UNBEKANNT",
      "INCONNU",
      "SCONOSCIUTO",
      "DESCONHECIDO",
      "DESCONOCIDO",
      "НЕИЗВЕСТНО",
      "NIEZNANY",
      "unknown"
    ],
    noaddress: [
      "NO ADDRESS",
      "NO ADDRESS",
      "アドレスがありません",
      "没有地址",
      "KEINE ADRESSE",
      "AUCUNE ADRESSE",
      "NESSUN INDIRIZZO",
      "SEM ENDEREÇO",
      "SIN DIRECCIÓN",
      "НЕТ АДРЕСА",
      "BRAK ADRESU",
      "noaddress"
    ],
    dns2: [
      "DNS2 UNAVAILABLE",
      "DNS2 UNAVAILABLE",
      "DNS2利用不可",
      "DNS2不可用",
      "DNS2 NICHT VERFÜGBAR",
      "DNS2 NON DISPONIBLE",
      "DNS2 NON DISPONIBILE",
      "DNS2 INDISPONÍVEL",
      "DNS2 NO DISPONIBLE",
      "DNS2 НЕДОСТУПЕН",
      "DNS2 NIEDOSTĘPNY",
      "dns2"
    ],
    unlicenced: [
      "UNLICENCED",
      "UNLICENCED",
      "アンライセンス",
      "未经许可",
      "NICHT LIZENZIERT",
      "SANS LICENCE",
      "NON AUTORIZZATO",
      "SEM LICENÇA",
      "SIN LICENCIA",
      "НЕЗАРЕГИСТРИРОВАННЫЙ",
      "BEZ LICENCJI",
      "unlicenced"
    ],
    inprogress: [
      "IN PROGRESS",
      "IN PROGRESS",
      "実行中",
      "进行中",
      "IN ARBEIT",
      "EN COURS",
      "IN CORSO",
      "EM ANDAMENTO",
      "EN CURSO",
      "ВЫПОЛНЯЕТСЯ",
      "W TRAKCIE",
      "inprogress"
    ],
    badargs: [
      "BAD ARGS",
      "BAD ARGS",
      "不正な引数",
      "错误消息",
      "FALSCHE ARG",
      "ERREURS MAUVAIS ARGS",
      "ARG. NON VALIDI",
      "ARGUMENTOS INCORRETOS",
      "ARGUMENTOS ERRÓNEOS",
      "НЕВЕРНЫЕ АРГУМЕНТЫ",
      "ZŁE ARGUMENTY",
      "badargs"
    ],
    sendfailed: [
      "SEND FAILED",
      "SEND FAILED",
      "送信に失敗しました",
      "发送失败",
      "FEHLER BEIM SENDEN",
      "ÉCHEC DE L'ENVOI",
      "INVIO FALLITO",
      "O ENVIO FALHOU",
      "FALLO EN ENVÍO",
      "ОТПРАВКА НЕ УДАЛАСЬ",
      "WYSYŁANIE NIE POWIODŁO SIĘ",
      "sendfailed"
    ],
    networkunreachable: [
      "NETWORK UNREACHABLE",
      "NETWORK UNREACHABLE",
      "ネットワークに到達不能",
      "网络无法连接",
      "NETZWERK NICHT ERREICHBAR",
      "RÉSEAU INACCESSIBLE",
      "RETE NON RAGGIUNGIBILE",
      "REDE INACESSÍVEL",
      "NO SE PUEDE ACCEDER A LA RED",
      "СЕТЬ НЕДОСТУПНА",
      "SIEĆ NIEDOSTĘPNA",
      "networkunreachable"
    ],
    responsetimeouts: [
      "RESPONE TIMEOUTS",
      "RESPONE TIMEOUTS",
      "応答タイムアウト",
      "响应超时",
      "ANTWORT-TIMEOUT",
      "DÉLAIS DE RÉPONSE",
      "TIMEOUT RISPOSTA",
      "LIMITES DE ESPERA DE RESPOSTA",
      "INACTIVIDAD DE RESPUESTA",
      "ТАЙМ-АУТЫ ОТВЕТА",
      "CZAS NA UDZIELENIE ODPOWIEDZI",
      "responsetimeouts"
    ],
    noresponse: [
      "NO RESPONSE",
      "NO RESPONSE",
      "応答はありません",
      "没有反应",
      "KEINE ANTWORT",
      "PAS DE RÉPONSE",
      "NESSUNA RISPOSTA",
      "SEM RESPOSTA",
      "SIN RESPUESTA",
      "НЕТ ОТВЕТА",
      "BRAK ODPOWIEDZI",
      "noresponse"
    ],
    unknownhost: [
      "UNKNOWN HOST",
      "UNKNOWN HOST",
      "不明なホスト",
      "未知主机",
      "UNBEKANNTER HOST",
      "HÔTE INCONNU",
      "HOST SCONOSCIUTO",
      "HOST DESCONHECIDO",
      "HOST DESCONOCIDO",
      "НЕИЗВЕСТНЫЙ ХОСТ",
      "NIEZNANY HOST",
      "unknownhost"
    ],
    unknownaddresstype: [
      "UNKNOWN ADDRESS TYPE",
      "UNKNOWN ADDRESS TYPE",
      "不明なアドレスのタイプ",
      "未知的地址类型",
      "UNBEKANNTER ADRESSTYP",
      "TYPE D’ADRESSE INCONNU",
      "TIPO DI INDIRIZZO SCONOSCIUTO",
      "TIPO DE ENDEREÇO DESCONHECIDO",
      "TIPO DE DIRECCIÓN DESCONOCIDA",
      "НЕИЗВЕСТНЫЙ ТИП АДРЕСА",
      "NIEZNANY TYP ADRESU",
      "unknownaddresstype"
    ],
    min_pin_selected_validation: [
      "Minimum two pins required",
      "Minimum two pins required",
      "少なくとも2つのピンが必要です",
      "至少需要两个引脚",
      "Mindestens 2 Pins erforderlich",
      "Au moins deux broches requises",
      "Sono necessari almeno due pin",
      "São exigidos dois pinos no mínimo",
      "Se necesitan dos pin como mínimo",
      "Необходимо не менее двух штырей",
      "Wymagane minimum dwa piny",
      "min_pin_selected_validation"
    ],
    general_sub_test_wiremap: [
      "Wiremap Settings",
      "Wiremap Settings",
      "ワイヤーマップの設定",
      "接线图设置",
      "Verdrahtungsplan-Einstellungen",
      "Paramètres du câblage",
      "Impostazioni mappatura fili",
      "Configuração do Mapa de Fios",
      "Ajustes del diagrama de cables",
      "Параметры разводки проводов",
      "Ustawienia mapy okablowania",
      "general_sub_test_wiremap"
    ],
    sub_test_empty_cable_list_t1_create: [
      "There are no custom cables for this customer.",
      "There are no custom cables for this customer.",
      "このカスタマーにはカスタムケーブルがありません。",
      "此客户没有自定义电缆。",
      "Für diesen Kunden gibt es keine kundenspezifischen Kabel.",
      "Aucun câble personnalisé n'a été sélectionné pour ce client.",
      "Non vi sono cavi personalizzati per questo cliente.",
      "Não há cabos personalizados para este cliente.",
      "No hay cables predeterminados para este cliente.",
      "Для этого клиента нет пользовательских кабелей.",
      "Nie ma dopasowanego okablowania dla tego klienta.",
      "sub_test_empty_cable_list_t1_create"
    ],
    sub_test_empty_cable_list_t2_create: [
      "You can add custom cables under Customer settings. ",
      "You can add custom cables under Customer settings. ",
      "カスタマー設定でカスタムケーブルを追加できます。",
      "您可以在客户设置下添加自定义电缆。 ",
      "Kundenspezifische Kabel können in den Kunden-Einstellungen hinzugefügt werden. ",
      "Vous pouvez ajouter des câbles personnalisés dans les paramètres Client. ",
      "Puoi aggiungere cavi personalizzati sotto Impostazioni cliente. ",
      "Você pode adicionar cabos personalizados na configuração do cliente.",
      "Puede añadir cables predeterminados en los ajustes del cliente. ",
      "Вы можете добавить пользовательские кабели в настройках Клиента. ",
      "Możesz dodać dopasowane okablowanie w ustawieniach klienta. ",
      "sub_test_empty_cable_list_t2_create"
    ],
    general_sub_test_maxthroughput: [
      "Max Throughput Settings",
      "Max Throughput Settings",
      "最大スループットの設定",
      "最大吞吐量设置",
      "Einstellungen für Maximalen Durchsatz",
      "Réglages du débit max",
      "Impostazioni Velocità trasmissione max",
      "Configuração de Rendimento Máximo",
      "Ajustes de rendimiento máx.",
      "Параметры Макс. пропускной способности",
      "Ustawienia maksymalnej przepustowości",
      "general_sub_test_maxthroughput"
    ],
    general_sub_test_customdata: [
      "Custom Data Settings",
      "Custom Data Settings",
      "カスタムデータの設定",
      "自定义数据设置",
      "Einstellungen für kundenspez. Daten",
      "Réglages des données personnalisées",
      "Impostazioni Dati personalizzati",
      "Configuração de Dados Personalizados",
      "Ajustes de datos personalizados",
      "Параметры пользовательских данных",
      "Ustawienia dopasowanych danych ",
      "general_sub_test_customdata"
    ],
    general_sub_test_cabledata: [
      "Cable Data Settings",
      "Cable Data Settings",
      "ケーブルデータの設定",
      "电缆数据设置",
      "Einstellungen für Kabeldaten",
      "Réglages des données de câble",
      "Impostazioni Dati cavo",
      "Configuração de Dados do Cabo",
      "Ajustes de datos de cables",
      "Параметры данных кабеля",
      "Ustawienia danych okablowania",
      "general_sub_test_cabledata"
    ],
    general_sub_test_webdata: [
      "Web Data Settings",
      "Web Data Settings",
      "Webデータの設定",
      "网络数据设置",
      "Einstellungen für Web-Daten",
      "Réglages des données Internet",
      "Impostazioni Dati web",
      "Configuração de Dados Web",
      "Ajustes de datos web",
      "Параметры данных интернета",
      "Ustawienia danych internetowych",
      "general_sub_test_webdata"
    ],
    general_sub_test_voipdata: [
      "VoIP Data Settings",
      "VoIP Data Settings",
      "VoIPデータの設定",
      "VoIP数据设置",
      "Einstellungen für VoIP-Daten",
      "Réglages des données VoIP",
      "Impostazioni Dati VoIP",
      "Configuração de Dados VoIP",
      "Ajustes de datos VoIP",
      "Параметры данных VoIP",
      "Ustawienia danych VoIP",
      "general_sub_test_voipdata"
    ],
    general_sub_test_videodata: [
      "Video Data Settings",
      "Video Data Settings",
      "ビデオデータの設定",
      "视频数据设置",
      "Einstellungen für Videodaten",
      "Réglages des données vidéo",
      "Impostazioni Dati video",
      "Configuração de Dados de Vídeo",
      "Ajustes de datos de vídeo",
      "Параметры видео-данных",
      "Ustawienia danych wideo",
      "general_sub_test_videodata"
    ],
    general_sub_test_cctvdata: [
      "CCTV Data Settings",
      "CCTV Data Settings",
      "CCTVデータの設定",
      "CCTV数据设置",
      "Einstellungen für CCTV-Daten",
      "Réglages des données de vidéoprotection",
      "Impostazioni Dati CCTV",
      "Configuração de Dados CFTV",
      "Ajustes de datos de CCTV",
      "Параметры данных Видеонаблюдения",
      "Ustawienia danych CCTV",
      "general_sub_test_cctvdata"
    ],
    result_target: [
      "TARGET",
      "TARGET",
      "ターゲット",
      "目标",
      "ZIEL",
      "CIBLE",
      "TARGET",
      "DESTINO",
      "DESTINO",
      "ЦЕЛЕВОЙ АДРЕС",
      "CEL",
      "result_target"
    ],
    result_no_of_hops: [
      "NUMBER OF HOPS",
      "NUMBER OF HOPS",
      "ホップの数",
      "跃点数量：",
      "ANZAHL DER HOPS",
      "NOMBRE DE SAUTS",
      "NUMERO DI SALTI",
      "NÚMERO DE SALTOS",
      "NÚMERO DE SALTOS",
      "КОЛ-ВО ТРАНЗИТНЫХ УЧАСТКОВ",
      "ILOŚĆ HOP",
      "result_no_of_hops"
    ],
    result_info_status: [
      "INFO",
      "INFO",
      "情報",
      "信息",
      "INFO",
      "Info",
      "INFORMAZIONI",
      "INFORMAÇÃO",
      "INFORMACIÓN",
      "ИНФОРМАЦИЯ",
      "INFORMACJE",
      "result_info_status"
    ],
    result_head_hop: [
      "Hop",
      "Hop",
      "ホップ",
      "跃点",
      "Hop",
      "Saut",
      "Salto",
      "Salto",
      "Salto",
      "ТРАНЗИТНЫЙ УЧАСТОК",
      "Przeskok",
      "result_head_hop"
    ],
    result_head_ip: [
      "IP address",
      "IP address",
      "IPアドレス",
      "IP地址",
      "IP-Adresse",
      "Adresse IP",
      "Indirizzo IP",
      "Endereço IP",
      "Dirección IP",
      "IP-адрес",
      "Adres IP",
      "result_head_ip"
    ],
    result_head_host: [
      "Hostname",
      "Hostname",
      "ホスト名",
      "主机名称",
      "Host-Name",
      "Nom de domaine",
      "Nome host",
      "Nome do host",
      "Nombre de host",
      "ИМЯ ХОСТА",
      "Nazwa hosta",
      "result_head_host"
    ],
    result_head_probe1: [
      "Probe 1",
      "Probe 1",
      "プローブ1",
      "探针1",
      "Probe 1",
      "Message 1",
      "Probe 1",
      "Sonda 1",
      "Sonda 1",
      "Зонд 1",
      "Sonda 1",
      "result_head_probe1"
    ],
    result_head_probe2: [
      "Probe 2",
      "Probe 2",
      "プローブ2",
      "探针2",
      "Probe 2",
      "Message 2",
      "Probe 2",
      "Sonda 2",
      "Sonda 2",
      "Зонд 2",
      "Sonda 2",
      "result_head_probe2"
    ],
    result_head_probe3: [
      "Probe 3",
      "Probe 3",
      "プローブ3",
      "探针3",
      "Probe 3",
      "Message 3",
      "Probe 3",
      "Sonda 3",
      "Sonda 3",
      "Зонд 3",
      "Sonda 3",
      "result_head_probe3"
    ],
    badargrange: [
      "BAD ARG RANGE",
      "BAD ARG RANGE",
      "不正な引数範囲",
      "错误消息范围",
      "FALSCHER ARG-BEREICH",
      "Message erreur suite à mauvaise gamme",
      "RANGE ARG. NON VALIDO",
      "FAIXA ARG INCORRETA",
      "RANGO DE ARGUMENTOS ERRÓNEOS",
      "НЕВЕРНЫЙ ДИАПАЗОН АРГУМЕНТОВ",
      "ZŁY PRZEDZIAŁ ARGUMENTÓW",
      "badargrange"
    ],
    badargsource: [
      "BAD ARG SOURCE ADDRESS",
      "BAD ARG SOURCE ADDRESS",
      "不正な引数ソースアドレス",
      "错误消息源地址",
      "FALSCHE ARG DER QUELLADRESSE",
      "Message erreur suite à mauvaises sources",
      "INDIRIZZO ORIGINE ARG. NON VALIDO",
      "ENDEREÇO DE ORIGEM ARG INCORRETO",
      "DIRECCIÓN DE ORIGEN DE ARGUMENTOS ERRÓNEOS",
      "НЕВЕРНЫЙ АДРЕС ИСТОЧНИКА АРГУМЕНТОВ",
      "ZŁY ADRES ŹRÓDŁOWY ARGUMENTÓW",
      "badargsource"
    ],
    badparameter: [
      "BAD PARAMETERS",
      "BAD PARAMETERS",
      "不正なパラメータ",
      "错误参数",
      "FALSCHE PARAMETER",
      "MAUVAIS PARAMÈTRES",
      "PARAMETRI ERRATI",
      "PARÂMETROS INCORRETOS",
      "PARÁMETROS ERRÓNEOS",
      "НЕВЕРНЫЕ ПАРАМЕТРЫ",
      "ZŁE PARAMETRY",
      "badparameter"
    ],
    maxttlexceeded: [
      "MAX TTL EXCEEDED",
      "MAX TTL EXCEEDED",
      "最大TTL超過",
      "超过最大TTL",
      "MAX TTL ÜBERSCHRITTEN",
      "TLL MAX DÉPASSÉ",
      "TTL MAX  SUPERATO",
      "TTL MÁXIMO EXCEDIDO",
      "TTL MÁX. EXCEDIDO",
      "ПРЕВЫШЕН МАКС. TTL",
      "PRZEKROCZONO MAKS. TTL",
      "maxttlexceeded"
    ],
    hopunreachable: [
      "HOP UNREACHABLE",
      "HOP UNREACHABLE",
      "ホップに到達不能",
      "达不到跃点",
      "HOP NICHT ERREICHBAR",
      "SAUT INACCESSIBLE ",
      "SALTO NON RAGGIUNGIBILE",
      "SALTO INACESSÍVEL",
      "SALTO NO ALCANZABLE",
      "ТРАНЗИТНЫЙ УЧАСТОК НЕДОСТУПЕН",
      "PRZESKOK NIEOSIĄGALNY",
      "hopunreachable"
    ],
    dnsfailed: [
      "DNS FAILED",
      "DNS FAILED",
      "DNS失敗",
      "DNS失败",
      "DNS-FEHLER",
      "ÉCHEC DU DNS",
      "DNS FALLITO",
      "DNS FALHOU",
      "FALLO DE DNS",
      "ОШИБКА DNS",
      "DNS NIE POWIÓDŁ SIĘ",
      "dnsfailed"
    ],
    result_scan_range: [
      "SCAN RANGE",
      "SCAN RANGE",
      "スキャン範囲",
      "扫描范围",
      "SCAN-BEREICH",
      "INTERVALLE DE SCAN",
      "RANGE DI SCANSIONE",
      "FAIXA DE PESQUISA",
      "RANGO DE DETECCIÓN",
      "ДИАПАЗОН СКАНИРОВАНИЯ",
      "ZAKRES SKANOWANIA",
      "result_scan_range"
    ],
    result_ipv4_hosts: [
      "IPv4 HOSTS",
      "IPv4 HOSTS",
      "IPv4 HOSTS",
      "IPv4主机",
      "IPv4 HOSTS",
      "HÔTES IPv4",
      "HOST IPv4",
      "HOSTS IPv4",
      "IPv4 HOSTS",
      "ХОСТЫ IPv4",
      "HOSTY IPv4 ",
      "result_ipv4_hosts"
    ],
    result_ipv6_hosts: [
      "IPv6 HOSTS",
      "IPv6 HOSTS",
      "IPv6 HOSTS",
      "IPv6主机",
      "IPv6 HOSTS",
      "HÔTES IPv6",
      "HOST IPv6",
      "HOSTS IPv6",
      "IPv6 HOSTS",
      "ХОСТЫ IPv6",
      "HOSTY IPv6",
      "result_ipv6_hosts"
    ],
    result_add_conflicts: [
      "ADDRESSS CONFLICTS",
      "ADDRESSS CONFLICTS",
      "アドレスの競合",
      "地址冲突",
      "ADRESSENKONFLIKTE",
      "CONFLITS ENTRE LES ADRESSES",
      "CONFLITTI DI INDIRIZZO",
      "CONFLITOS DE ENDEREÇO",
      "CONFLICTOS DE DIRECCIÓN",
      "АДРЕСНЫЕ КОНФЛИКТЫ",
      "KONFLIKTY ADRESÓW",
      "result_add_conflicts"
    ],
    badaddrrange: [
      "BAD ADDR RANGE",
      "BAD ADDR RANGE",
      "不正なアドレス範囲",
      "错误地址范围",
      "FALSCHER ADRESSBEREICH",
      "MAUVAISE GAMME D'ADRESSES",
      "RANGE IND. NON VALIDO",
      "FAIXA DE ENDEREÇO INCORRETA",
      "RANGO DE DIRECCIONES ERRÓNEAS",
      "НЕВЕРНЫЙ ДИАПАЗОН АДРЕСОВ",
      "ZŁY PRZEDZIAŁ ADRESÓW",
      "badaddrrange"
    ],
    internalerror: [
      "INTERNAL ERROR",
      "INTERNAL ERROR",
      "内部エラー",
      "内部错误",
      "INTERNER FEHLER",
      "ERREUR INTERNE",
      "ERRORE INTERNO",
      "ERRO INTERNO",
      "ERROR INTERNO",
      "ВНУТРЕННЯЯ ОШИБКА",
      "BŁĄD WEWNĘTRZNY",
      "internalerror"
    ],
    conflictsfound: [
      "CONFLICTS FOUND",
      "CONFLICTS FOUND",
      "競合が見つかりました",
      "发现冲突",
      "KONFLIKTE ERKANNT",
      "CONFLITS TROUVÉS",
      "TROVATI CONFLITTI",
      "CONFLITOS ENCONTRADOS",
      "SE HAN ENCONTRADO CONFLICTOS",
      "ОБНАРУЖЕНЫ КОНФЛИКТЫ",
      "WYKRYTO KONFLIKTY",
      "conflictsfound"
    ],
    wiremapfailed: [
      "WIREMAP FAILED",
      "WIREMAP FAILED",
      "Wiremapは失敗しました",
      "无线形失败",
      "Wiremap scheiterte",
      "Échoué",
      "Wiremap non è riuscito",
      "Wiremap falhou",
      "Wiremap falló",
      "WireMap не удалась",
      "WireMap nie powiodła się",
      "wiremapfailed"
    ],
    speedtestinprogress: [
      "SPEED TEST IN PROGRESS",
      "SPEED TEST IN PROGRESS",
      "進行中の速度テスト",
      "速度测试正在进行",
      "Geschwindigkeitstest in Arbeit",
      "Test de vitesse en cours",
      "Test di velocità in corso",
      "Teste de velocidade em andamento",
      "Prueba de velocidad en progreso",
      "Скорость теста",
      "Test prędkości w toku",
      "speedtestinprogress"
    ],
    speedtestfailednext: [
      "SPEED TEST FAILED (NEXT)",
      "SPEED TEST FAILED (NEXT)",
      "速度テストが失敗した（NEXT）",
      "速度测试失败（NEXT）",
      "Geschwindigkeitstest fehlgeschlagen (NEXT)",
      "Le test de vitesse a échoué (NEXT)",
      "Test di velocità non riuscita (NEXT)",
      "Teste de velocidade falhou (NEXT)",
      "Falló la prueba de velocidad (NEXT)",
      "Тест скорости не удался (NEXT)",
      "Test prędkości nie powiódł się (NEXT)",
      "speedtestfailednext"
    ],
    speedtestfailedil: [
      "SPEED TEST FAILED (IL)",
      "SPEED TEST FAILED (IL)",
      "速度テストが失敗した（IL）",
      "速度测试失败（IL）",
      "Geschwindigkeitstest fehlgeschlagen (IL)",
      "Le test de vitesse a échoué (IL)",
      "Test di velocità non riuscita (IL)",
      "Falha no teste de velocidade (IL)",
      "Falló en la prueba de velocidad (IL)",
      "Столовый тест на скорость (IL)",
      "Test prędkości nie powiódł się (IL)",
      "speedtestfailedil"
    ],
    speedtestfailedrl: [
      "SPEED TEST FAILED (RL)",
      "SPEED TEST FAILED (RL)",
      "速度テストが失敗した（RL）",
      "速度测试失败（RL）",
      "Geschwindigkeitstest fehlgeschlagen (RL)",
      "Le test de vitesse a échoué (RL)",
      "Test di velocità non riuscita (RL)",
      "Falha no teste de velocidade (RL)",
      "Falló la prueba de velocidad (RL)",
      "Столовый тест на скорость (RL)",
      "Test prędkości nie powiódł się (RL)",
      "speedtestfailedrl"
    ],
    result_cable_info: [
      "CABLE INFO",
      "CABLE INFO",
      "ケーブル情報",
      "电缆信息",
      "KABEL-INFO",
      "INFO CÂBLE",
      "INFORMAZIONI CAVO",
      "INFORMAÇÃO DO CABO",
      "INFORMACIÓN DEL CABLE",
      "ИНФОРМАЦИЯ О КАБЕЛЕ",
      "INFORMACJE NT. OKABLOWANIA",
      "result_cable_info"
    ],
    result_length_1: [
      "LENGTH (m)",
      "LENGTH (m)",
      "長さ (m)",
      "长度（米）",
      "LÄNGE (m)",
      "LONGUEUR (m)",
      "LUNGHEZZA (m)",
      "COMPRIMENTO (m)",
      "LONGITUD (m)",
      "ДЛИНА (м)",
      "DŁUGOŚĆ (m)",
      "result_length_1"
    ],
    result_length_2: [
      "LENGTH",
      "LENGTH",
      "長さ",
      "长度",
      "LÄNGE",
      "LONGUEUR",
      "LUNGHEZZA",
      "COMPRIMENTO",
      "LONGITUD",
      "ДЛИНА",
      "DŁUGOŚĆ",
      "result_length_2"
    ],
    result_nvpper: [
      "NVP (%)",
      "NVP (%)",
      "NVP (%)",
      "NVP (%)",
      "NVP (%)",
      "NVP (%)",
      "NVP (%)",
      "NVP (%)",
      "NVP (%)",
      "NVP (%)",
      "NVP (%)",
      "result_nvpper"
    ],
    result_remote_2: [
      "REMOTE ID",
      "REMOTE ID",
      "リモートID",
      "远程ID",
      "REMOTE-ID",
      "ID DISTANT",
      "ID REMOTO",
      "ID REMOTO",
      "ID REMOTA",
      "ID УДАЛЕННОГО УСТРОЙСТВА",
      "IDENTYFIKATOR ZDALNY",
      "result_remote_2"
    ],
    result_pins: [
      "Pins",
      "Pins",
      "ピン",
      "针",
      "Pins",
      "Broches",
      "Pin",
      "Pinos",
      "Pins",
      "Штыри",
      "Piny",
      "result_pins"
    ],
    result_voltage: [
      "Voltage",
      "Voltage",
      "電圧",
      "电压",
      "Spannung",
      "Tension",
      "Tensione",
      "Tensão",
      "Voltaje",
      "Напряжение",
      "Napięcie",
      "result_voltage"
    ],
    result_polarity: [
      "Polarity PoE Voltage",
      "Polarity PoE Voltage",
      "極性PoE電圧",
      "极性PoE电压",
      "Polarität der PoE-Spannung",
      "Polarité de la tension PoE",
      "Tensione PoE polarità",
      "Polaridade PoE Tensão",
      "Polaridad voltaje PoE",
      "Полярность напряжения PoE",
      "Napięcie polaryzacji PoE",
      "result_polarity"
    ],
    qualification_speed: [
      "Qualification Speed",
      "Qualification Speed",
      "資格速度",
      "资格速度",
      "Qualifikationsgeschwindigkeit",
      "Vitesse de qualification",
      "Velocità di qualificazione",
      "Velocidade de qualificação",
      "Velocidad de calificación",
      "Квалификационная скорость",
      "Prędkość kwalifikacji",
      "qualification_speed"
    ],
    expected: [
      "Expected",
      "Expected",
      "予想される",
      "预期的",
      "Erwartet",
      "Attendu",
      "Previsto",
      "Esperado",
      "Esperado",
      "Ожидаемый",
      "Oczekiwany",
      "expected"
    ],
    measured: [
      "Measured",
      "Measured",
      "測定された",
      "测量的",
      "Gemessen",
      "Mesuré",
      "Misurato",
      "Medido",
      "Medido",
      "Измеренный",
      "Zmierzony",
      "measured"
    ],
    "Wiremap Only": [
      "Wiremap Only",
      "Wiremap Only",
      "ワイヤーマップのみ",
      "仅接线图",
      "Nur Wiremap",
      "Wiremap uniquement",
      "Solo wiremap",
      "SOMENTE WIREMAP",
      "WIRMAP solo",
      "Только Wiremap",
      "Tylko Wiremap",
      "Wiremap Only"
    ],
    "4-Pair": [
      "4-Pair",
      "4-Pair",
      "4ペア",
      "4对",
      "4-Pair",
      "À 4 paires",
      "4 coppie",
      "4 par",
      "4 pares",
      "4-пар",
      "4-par",
      "4-Pair"
    ],
    "2-Pair (12-36)": [
      "2-Pair (12-36)",
      "2-Pair (12-36)",
      "2ペア（12-36）",
      "2对（12-36）",
      "2-Pair (12-36)",
      "2 paires (12-36)",
      "2 copi (12-36)",
      "2 par (12-36)",
      "2 pares (12-36)",
      "2-пар (12-36)",
      "2 par (12-36)",
      "2-Pair (12-36)"
    ],
    "2-Pair (12-78)": [
      "2-Pair (12-78)",
      "2-Pair (12-78)",
      "2ペア（12-78）",
      "2对（12-78）",
      "2-Pair (12-78)",
      "2 paires (12-78)",
      "2 copi (12-78)",
      "2 par (12-78)",
      "2 pares (12-78)",
      "2-пар (12-78)",
      "2 par (12-78)",
      "2-Pair (12-78)"
    ],
    "2-Pair (45-36)": [
      "2-Pair (45-36)",
      "2-Pair (45-36)",
      "2ペア（45-36）",
      "2对（45-36）",
      "2-Pair (45-36)",
      "2 paires (45-36)",
      "2 copi (45-36)",
      "2 par (45-36)",
      "2 pares (45-36)",
      "2-пар (45-36)",
      "2 par (45-36)",
      "2-Pair (45-36)"
    ],
    "1-Pair (45)": [
      "1-Pair (45)",
      "1-Pair (45)",
      "1ペア（45）",
      "1对（45）",
      "1-Pair (45)",
      "1 paire (45)",
      "1 coppia (45)",
      "1 par (45)",
      "1 par (45)",
      "1-пар (45)",
      "1 par (45)",
      "1-Pair (45)"
    ],
    aborting: [
      "ABORTING",
      "ABORTING",
      "中断",
      "正在中止",
      "ABBRECHEN...",
      "INTERRUPTION",
      "INTERRUZIONE IN CORSO",
      "ABORTANDO",
      "ABORTANDO",
      "ОСТАНОВКА",
      "WSTRZYMYWANIE",
      "aborting"
    ],
    open: [
      "OPEN",
      "OPEN",
      "オープン",
      "打开",
      "UNTERBRECHUNG",
      "OUVERT",
      "APERTO",
      "ABERTO",
      "ABRIR",
      "ОТКРЫТЫЙ",
      "OTWARTY",
      "open"
    ],
    short: [
      "SHORT",
      "SHORT",
      "ショート",
      "短",
      "KURZSCHLUSS",
      "COURT-CIRCUIT",
      "CORTO",
      "EM CURTO",
      "CORTO",
      "КЗ",
      "KRÓTKI",
      "short"
    ],
    remoteshort: [
      "REMOTE SHORT",
      "REMOTE SHORT",
      "リモートショート",
      "远程短",
      "KURZSCHLUSS FERNES ENDE",
      "COURT-CIRCUIT DISTANT",
      "CORTO REMOTO",
      "EM CURTO NA REMOTA",
      "CORTO REMOTO",
      "УДАЛЕННОЕ КЗ",
      "KRÓTKI ZDALNY",
      "remoteshort"
    ],
    straight: [
      "STRAIGHT",
      "STRAIGHT",
      "ストレート",
      "直",
      "GERADE",
      "DROIT",
      "DIRITTO",
      "DIRETO",
      "DIRECTO",
      "ПРЯМАЯ",
      "PROSTY",
      "straight"
    ],
    crossover: [
      "CROSSOVER",
      "CROSSOVER",
      "クロスオーバー",
      "交叉",
      "CROSSOVER/GEKREUZT ",
      "CROISEMENT",
      "CROSSOVER",
      "CROSSOVER",
      "CRUCE",
      "ПЕРЕКРЕЩИВАНИЕ",
      "SKROSOWANY",
      "crossover"
    ],
    crossover1000bt: [
      "CROSSOVER 1000BT",
      "CROSSOVER 1000BT",
      "クロスオーバー1000BT",
      "交叉1000BT",
      "CROSSOVER 1000BT",
      "CROISEMENT 1000BT",
      "CROSSOVER 1000BT",
      "CROSSOVER 1000BT",
      "CRUCE 1000BT",
      "ПЕРЕКРЕЩИВАНИЕ 1000BT",
      "KABEL SKROSOWANY 1000BT",
      "crossover1000bt"
    ],
    xover: [
      "XOVER",
      "XOVER",
      "XOVER",
      "XOVER",
      "XOVER",
      "XOVER Croisé",
      "XOVER",
      "XOVER",
      "CRUCE",
      "ПЕРЕКРЕЩ.",
      "SKROSOWANY",
      "xover"
    ],
    xover1000bt: [
      "XOVER 1000BT",
      "XOVER 1000BT",
      "XOVER 1000BT",
      "XOVER 1000BT",
      "XOVER 1000BT",
      "XOVER Croisé 1000BT",
      "XOVER 1000BT",
      "XOVER 1000BT",
      "CRUCE 1000BT",
      "ПЕРЕКРЕЩ. 1000BT",
      "KABEL SKROSOWANY 1000BT",
      "xover1000bt"
    ],
    xoverincomplete: [
      "XOVER INCOMPLETE",
      "XOVER INCOMPLETE",
      "XOVER 不完全",
      "XOVER未完成",
      "XOVER UNVOLLSTÄNDIG",
      "XOVER croisé INACHEVÉ",
      "XOVER INCOMPLETO",
      "XOVER INCOMPLETO",
      "CRUCE INCOMPLETO",
      "ПЕРЕКРЕЩ. НЕ ЗАВЕРШЕНО",
      "SKROSOWANY NIEKOMPLETNY",
      "xoverincomplete"
    ],
    miswired: [
      "MISWIRED",
      "MISWIRED",
      "誤配線",
      "接线错误",
      "VERDRAHTUNGSFEHLER",
      "MAUVAIS RACCORDEMENT",
      "CABLAGGIO ERRONEO",
      "MAL CONECTADO",
      "MAL CABLEADO",
      "НЕПРАВИЛЬНАЯ СХЕМА РАЗВОДКИ",
      "NIEPRAWIDŁOWE OKABLOWANIE",
      "miswired"
    ],
    splitpair: [
      "SPLIT PAIR",
      "SPLIT PAIR",
      "スプリットペア",
      "劈分线对",
      "SPLIT-PAIR",
      "PAIRE SÉPARÉE",
      "COPPIA DIVISA",
      "PAR DIVIDIDO",
      "PAR DIVIDIDO",
      "РАЗДЕЛЕНИЕ ПАР",
      "ROZDZIELONA PARA",
      "splitpair"
    ],
    tdrinprogress: [
      "TDR IN PROGRESS",
      "TDR IN PROGRESS",
      "TDR実行中",
      "长度测量进行中",
      "TDR LÄUFT",
      "TDR EN COURS",
      "TDR IN CORSO",
      "TDR EM ANDAMENTO",
      "MEDICIÓN DE LONG. EN CURSO",
      "ВЫПОЛНЯЕТСЯ РЕФЛЕКТОМЕТРИЯ",
      "TDR W TRAKCIE",
      "tdrinprogress"
    ],
    tdrcomplete: [
      "TDR COMPLETE",
      "TDR COMPLETE",
      "TDR完了",
      "TDR已完成",
      "TDR ABGESCHLOSSEN",
      "TDR ACHEVÉ",
      "TDR COMPLETO",
      "TDR CONCLUÍDO",
      "MEDICIÓN DE LONG. COMPLETA",
      "РЕФЛЕКТОМЕТРИЯ ЗАВЕРШЕНА",
      "TDR ZAKOŃCZONO",
      "tdrcomplete"
    ],
    tdrfailed: [
      "TDR FAILED",
      "TDR FAILED",
      "TDR失敗",
      "TDR已失败",
      "TDR-FEHLER",
      "ÉCHEC DU TDR",
      "TDR FALLITO",
      "TDR FALHOU",
      "ERROR DE MED. LONG.",
      "ОШИБКА РЕФЛЕКТОМЕТРИИ",
      "TDR NIE POWIÓDŁ SIĘ",
      "tdrfailed"
    ],
    abortedpoe: [
      "ABORTED PoE",
      "ABORTED PoE",
      "中断されたPoE",
      "PoE已中止",
      "PoE ABGEBROCHEN",
      "PoE INTERROMPU",
      "PoE INTERROTTO",
      "PoE ABORTADO",
      "PoE ABORTADO",
      "PoE ПРЕКРАЩЕНО",
      "WSTRZYMANO PoE",
      "abortedpoe"
    ],
    wiremapinprogress: [
      "WIREMAP IN PROGRESS",
      "WIREMAP IN PROGRESS",
      "ワイヤーマップ実行中",
      "接线图进行中",
      "VERDRAHTUNGSTEST LÄUFT",
      "CÂBLAGE EN COURS",
      "MAPPATURA FILI IN CORSO",
      "MAPA DE FIOS EM ANDAMENTO",
      "MAPEADO DE HILOS EN CURSO",
      "ВЫПОЛНЯЕТСЯ СХЕМА РАЗВОДКИ",
      "MAPA OKABLOWANIA W TRAKCIE",
      "wiremapinprogress"
    ],
    splitpairinprogress: [
      "SPLIT PAIR IN PROGRESS",
      "SPLIT PAIR IN PROGRESS",
      "スプリットペア実行中",
      "劈分线对进行中",
      "SPLIT-PAIR LÄUFT",
      "PAIRE SÉPARÉE EN COURS",
      "COPPIA DIVISA IN CORSO",
      "PAR DIVIDIDO EM ANDAMENTO",
      "PAR DIVIDIDO EN CURSO",
      "ВЫПОЛНЯЕТСЯ РАЗДЕЛЕНИЕ ПАР",
      "ROZDZIELONA PARA W TRAKCIE",
      "splitpairinprogress"
    ],
    notavailable: [
      "NOT AVAILABLE",
      "NOT AVAILABLE",
      "利用不可",
      "不可用",
      "NICHT VERFÜGBAR",
      "NON DISPONIBLE",
      "NON DISPONIBILE",
      "INDISPONÍVEL",
      "NO DISPONIBLE",
      "НЕДОСТУПНО",
      "NIEDOSTĘPNE",
      "notavailable"
    ],
    failednopoe: [
      "FAILED NO POE DETECTED",
      "FAILED NO POE DETECTED",
      "PoE未検出のために失敗",
      "失败，无法检测到POE",
      "FEHLER - KEIN POE ERKANNT",
      "ÉCHEC AUCUN POE DÉTECTÉ",
      "FALLITA: NESSUN POE RILEVATO",
      "FALHOU, POE NÃO DETECTADO",
      "ERROR, NO SE HA DETECTADO POE",
      "ОШИБКА - POE НЕ ОБНАРУЖЕНО",
      "NIE POWIODŁO SIĘ - NIE WYKRYTO POE",
      "failednopoe"
    ],
    failednopower: [
      "FAILED NO POWER",
      "FAILED NO POWER",
      "電力がないために失敗",
      "失败，没有功率",
      "FEHLER - KEINE LEISTUNG",
      "ÉCHEC AUCUNE ALIMENTATION",
      "FALLITA: MANCANZA DI POTENZA",
      "FALHOU, SEM ALIMENTAÇÃO",
      "ERROR, SIN ALIMENTACIÓN",
      "ОШИБКА - НЕТ ПИТАНИЯ",
      "NIE POWIODŁO SIĘ - BRAK MOCY",
      "failednopower"
    ],
    failedlowpower: [
      "FAILED POWER TOO LOW",
      "FAILED POWER TOO LOW",
      "電力が低すぎるために失敗",
      "失败，功率过低",
      "FEHLER - ZU GERINGE LEISTUNG",
      "ÉCHEC PUISSANCE TROP FAIBLE",
      "FALLITA: POTENZA TROPPO BASSA",
      "FALHOU, ALIMENTAÇÃO MUITO BAIXA",
      "ERROR, ALIMENTACIÓN DEMASIADO BAJA",
      "ОШИБКА - СЛИШКОМ СЛАБОЕ ПИТАНИЕ",
      "NIE POWIODŁO SIĘ - ZBYT NISKA MOC",
      "failedlowpower"
    ],
    unknown2: [
      "Unknown",
      "Unknown",
      "不明",
      "未知",
      "Unbekannt",
      "Inconnu",
      "Sconosciuto",
      "Desconhecido",
      "Desconocido",
      "Неизвестно",
      "Nieznany",
      "unknown2"
    ],
    at: [
      "802.3at",
      "802.3at",
      "802.3at",
      "802.3at",
      "802.3at",
      "802.3at",
      "802.3at",
      "802.3at",
      "802.3at",
      "802.3at",
      "802.3at",
      "at"
    ],
    af: [
      "802.3af",
      "802.3af",
      "802.3af",
      "802.3af",
      "802.3af",
      "802.3af",
      "802.3af",
      "802.3af",
      "802.3af",
      "802.3af",
      "802.3af",
      "af"
    ],
    bt: [
      "802.3bt",
      "802.3bt",
      "802.3bt",
      "802.3bt",
      "802.3bt",
      "802.3bt",
      "802.3bt",
      "802.3bt",
      "802.3bt",
      "802.3bt",
      "802.3bt",
      "bt"
    ],
    c0: [
      "Class 0",
      "Class 0",
      "クラス 0",
      "0级",
      "Klasse 0",
      "Classe 0",
      "Classe 0",
      "Classe 0",
      "Clase 0",
      "Класс 0",
      "Klasa 0",
      "c0"
    ],
    c1: [
      "Class 1",
      "Class 1",
      "クラス 1",
      "1级",
      "Klasse 1",
      "Classe 1",
      "Classe 1",
      "Classe 1",
      "Clase 1",
      "Класс 1",
      "Klasa 1",
      "c1"
    ],
    c2: [
      "Class 2",
      "Class 2",
      "クラス 2",
      "2级",
      "Klasse 2",
      "Classe 2",
      "Classe 2",
      "Classe 2",
      "Clase 2",
      "Класс 2",
      "Klasa 2",
      "c2"
    ],
    c3: [
      "Class 3",
      "Class 3",
      "クラス 3",
      "3级",
      "Klasse 3",
      "Classe 3",
      "Classe 3",
      "Classe 3",
      "Clase 3",
      "Класс 3",
      "Klasa 3",
      "c3"
    ],
    c4: [
      "Class 4",
      "Class 4",
      "クラス 4",
      "4级",
      "Klasse 4",
      "Classe 4",
      "Classe 4",
      "Classe 4",
      "Clase 4",
      "Класс 4",
      "Klasa 4",
      "c4"
    ],
    c5: [
      "Class 5",
      "Class 5",
      "クラス 5",
      "5级",
      "Klasse 5",
      "Classe 5",
      "Classe 5",
      "Classe 5",
      "Clase 5",
      "Класс 5",
      "Klasa 5",
      "c5"
    ],
    c6: [
      "Class 6",
      "Class 6",
      "クラス 6",
      "6级",
      "Klasse 6",
      "Classe 6",
      "Classe 6",
      "Classe 6",
      "Clase 6",
      "Класс 6",
      "Klasa 6",
      "c6"
    ],
    c7: [
      "Class 7",
      "Class 7",
      "クラス 7",
      "7级",
      "Klasse 7",
      "Classe 7",
      "Classe 7",
      "Classe 7",
      "Clase 7",
      "Класс 7",
      "Klasa 7",
      "c7"
    ],
    c8: [
      "Class 8",
      "Class 8",
      "クラス 8",
      "8级",
      "Klasse 8",
      "Classe 8",
      "Classe 8",
      "Classe 8",
      "Clase 8",
      "Класс 8",
      "Klasa 8",
      "c8"
    ],
    c8p: [
      "Class 8+",
      "Class 8+",
      "クラス 8+",
      "8+级",
      "Klasse 8+",
      "Classe 8+",
      "Classe 8+",
      "Classe 8+",
      "Clase 8+",
      "Класс 8+",
      "Klasa 8+",
      "c8p"
    ],
    poestd: [
      "PoE Std",
      "PoE Std",
      "PoE規格",
      "PoE标准",
      "PoE-Std",
      "Standard PoE",
      "St. PoE",
      "Padrão PoE",
      "PoE estándar",
      "Стандарт PoE",
      "PoE Std",
      "poestd"
    ],
    poeclass: [
      "PoE Class",
      "PoE Class",
      "PoEクラス",
      "PoE级别",
      "PoE-Klasse",
      "Classe de la PoE",
      "Classe PoE",
      "Classe PoE",
      "Clase de PoE",
      "Класс PoE",
      "PoE Klasa",
      "poeclass"
    ],
    power: [
      "Power (W)",
      "Power (W)",
      "電力 (W)",
      "功率（W）",
      "Leistung (W)",
      "Puissance (W)",
      "Potenza (W)",
      "Potência (W)",
      "Potencia (W)",
      "Мощность (Вт)",
      "Moc (W)",
      "power"
    ],
    voltage: [
      "Voltage (V)",
      "Voltage (V)",
      "電圧 (V)",
      "电压（V）",
      "Spannung (V)",
      "Tension (V)",
      "Tensione (V)",
      "Tensão (V)",
      "Voltaje (V)",
      "Напряжение (В)",
      "Napięcie (V)",
      "voltage"
    ],
    maxpowerloss: [
      "Max Power Cable Loss (W)",
      "Max Power Cable Loss (W)",
      "最大電力ケーブル損失 (W)",
      "最大电缆损耗功率（W)",
      "Max. Kabel Verlustleistung (W)",
      "Perte max. du câble (W)",
      "Perdita massima del cavo di potenza (W)",
      "Perda Máxima de Potência no Cabo (W)",
      "Max Pérdida de Potencia del Cable (W)",
      "Макс. Потери мощности в кабеле (Вт)",
      "Maks. Strata Mocy w Kablu (W)",
      "maxpowerloss"
    ],
    current: [
      "Current (mA)",
      "Current (mA)",
      "電流 (mA)",
      "电流（mA）",
      "Strom (mA)",
      "Courant (mA)",
      "Corrente (mA)",
      "Corrente (mA)",
      "Corriente (mA)",
      "Ток (мА)",
      "Prąd (mA)",
      "current"
    ],
    result_link_speed: [
      "LINK SPEED",
      "LINK SPEED",
      "リンク速度",
      "链接速度",
      "LINK-RATE",
      "VITESSE DU LIEN",
      "VELOCITÀ DI COLLEGAMENTO",
      "VELOCIDADE DO LINK",
      "VELOCIDAD DEL VÍNCULO",
      "СКОРОСТЬ КАНАЛА",
      "SZYBKOŚĆ ŁĄCZA",
      "result_link_speed"
    ],
    result_total_bandwidth: [
      "Total Bandwidth",
      "Total Bandwidth",
      "合計帯域幅",
      "总带宽",
      "Gesamt-Bandbreite",
      "Bande passante totale",
      "Larghezza di banda totale",
      "Largura de banda total",
      "Ancho de banda total",
      "Полная пропускная способность",
      "Przepustowość całkowita",
      "result_total_bandwidth"
    ],
    result_errors: [
      "Errors",
      "Errors",
      "エラー",
      "错误",
      "Fehler",
      "Erreurs",
      "Errori",
      "Erros",
      "Errores",
      "Ошибки",
      "Błędy",
      "result_errors"
    ],
    uptime_linkspeed2: [
      "Link speed",
      "Link speed",
      "リンク速度",
      "链接速度",
      "Link-Rate",
      "Vitesse du lien",
      "Velocità di collegamento",
      "Velocidade do link",
      "Velocidad del vínculo",
      "Скорость канала",
      "Szybkość łącza",
      "uptime_linkspeed2"
    ],
    result_total_bandwidth2: [
      "Total Bandwidth",
      "Total Bandwidth",
      "合計帯域幅",
      "总带宽",
      "Gesamt-Bandbreite",
      "Bande passante totale",
      "Larghezza di banda totale",
      "Largura de banda total",
      "Ancho de banda total",
      "Полная пропускная способность",
      "Przepustowość całkowita",
      "result_total_bandwidth2"
    ],
    result_usable_bandwidth: [
      "Usable Bandwidth",
      "Usable Bandwidth",
      "使用可能帯域幅",
      "可用带宽",
      "Nutzbare Bandbreite",
      "Bande passante accessible",
      "Larghezza di banda utilizzabile",
      "Largura de banda utilizável",
      "Ancho de banda utilizable",
      "Полезная пропускная способность",
      "Przepustowość użytkowa",
      "result_usable_bandwidth"
    ],
    uptime_nw_overhead2: [
      "Network Overhead",
      "Network Overhead",
      "ネットワークオーバーヘッド",
      "网络架构",
      "Netzwerk-Overhead",
      "En-tête trame réseau",
      "Sovraccarico di rete",
      "Sobrecarga de rede",
      "Sobrecarga de red",
      "Непроизводительная передача сети",
      "Obciążenie sieci ",
      "uptime_nw_overhead2"
    ],
    result_line_utilization: [
      "Line Utilization",
      "Line Utilization",
      "ライン利用率",
      "线路利用率",
      "Leitungsnutzung",
      "Utilisation de la ligne",
      "Utilizzazione linea",
      "Utilização da linha",
      "Utilización de la línea",
      "Использование линии",
      "Wykorzystanie linii",
      "result_line_utilization"
    ],
    result_test_duration2: [
      "Duration",
      "Duration",
      "期間",
      "持续时间",
      "Dauer",
      "Durée",
      "Durata",
      "Duração",
      "Duración",
      "Длительность",
      "Czas trwania",
      "result_test_duration2"
    ],
    result_tx2: [
      "Tx Frame Count",
      "Tx Frame Count",
      "Txフレーム数",
      "发射帧数",
      "Tx-Frame-Zählung",
      "Nombre de trames Tx ",
      "Conteggio frame trasmessi",
      "Contagem de quadros Tx",
      "Recuento de Tramas Tx",
      "Счетчик кадров Tx",
      "Ilość ramek Tx",
      "result_tx2"
    ],
    result_rx2: [
      "Rx Frame Count",
      "Rx Frame Count",
      "Rxフレーム数",
      "接收帧数",
      "Rx-Frame-Zählung",
      "Nombre de trames Rx",
      "Conteggio frame ricevuti",
      "Contagem de quadros Rx",
      "Recuento de Tramas Rx",
      "Счетчик кадров Rx",
      "Ilość ramek Rx",
      "result_rx2"
    ],
    result_error_count: [
      "Error Count",
      "Error Count",
      "エラー数",
      "错误数",
      "Fehlerzählung",
      "Nombre d'erreurs",
      "Conteggio errori",
      "Contagem de erros",
      "Error de recuento",
      "Счетчик ошибок",
      "Ilość błędów",
      "result_error_count"
    ],
    result_error_ratio: [
      "Error Ratio",
      "Error Ratio",
      "エラー率",
      "错误率",
      "Fehlerverhältnis",
      "Taux d'erreur",
      "Frequenza errori",
      "Razão de erro",
      "Error de relación",
      "Коэффициент ошибок",
      "Współczynnik błędów",
      "result_error_ratio"
    ],
    result_propagation_delay: [
      "Propagation Delay (µs)",
      "Propagation Delay (µs)",
      "伝播遅延 (µs)",
      "传播延迟（微秒）",
      "Laufzeit (µs)",
      "Temps de propagation (µs)",
      "Ritardo propagazione (µs)",
      "Atraso de propagação (µs)",
      "Retardo de propagación (µs)",
      "Задержка распространения (мкс)",
      "Opóźnienie propagacji (µs)",
      "result_propagation_delay"
    ],
    passed2: [
      "PASS",
      "PASS",
      "成功",
      "通过的",
      "BESTANDEN",
      "SUCCÈS",
      "SUPERATA",
      "APROVADO",
      "SUPERADO",
      "СООТВЕТСТВИЕ",
      "POWIODŁO SIĘ",
      "passed2"
    ],
    failed2: [
      "FAIL",
      "FAIL",
      "失敗",
      "已失败",
      "FEHLER",
      "ÉCHEC",
      "FALLITA",
      "REPROVADO",
      "NO SUPERADO",
      "НЕСООТВЕТСТВИЕ",
      "NIE POWIODŁO SIĘ",
      "failed2"
    ],
    txfailed: [
      "Tx FAILED",
      "Tx FAILED",
      "Tx失敗",
      "发射失败",
      "Tx-FEHLER",
      "ÉCHEC Tx",
      "TRASMISSIONE FALLITA",
      "Tx FALHOU",
      "TRANSMITIDO NO SUPERADO",
      "НЕСООТВЕТСТВИЕ Tx",
      "Tx (nadawanie) NIE POWIODŁO SIĘ",
      "txfailed"
    ],
    rxfailed: [
      "Rx FAILED",
      "Rx FAILED",
      "Rx失敗",
      "接收失败",
      "Rx-FEHLER",
      "ÉCHEC Rx",
      "RICEZIONE FALLITA",
      "Rx FALHOU",
      "RECIBIDO NO SUPERADO",
      "НЕСООТВЕТСТВИЕ Rx",
      "Rx (odbieranie) NIE POWIODŁO SIĘ",
      "rxfailed"
    ],
    configerror: [
      "CONFIG ERROR",
      "CONFIG ERROR",
      "構成エラー",
      "配置错误",
      "KONFIG-FEHLER",
      "ERREUR CONFIG",
      "ERRORE DI CONFIG.",
      "ERRO DE CONFIGURAÇÃO",
      "ERROR DE CONFIG.",
      "ОШИБКА КОНФИГУРАЦИИ",
      "BŁĄD KONFIGURACJI",
      "configerror"
    ],
    errinforate: [
      "ERR: INFO RATE",
      "ERR: INFO RATE",
      "ERR: 情報レート",
      "错误：信息率",
      "FEHL: INFO-RATE",
      "ERR : INFOS DEBITS",
      "ERR.: FREQUENZA INFORMAZIONI",
      "ERRO: TAXA DE INFORMAÇÃO",
      "ERROR: FLUJO DE DATOS",
      "ОШИБК: СКОРОСТЬ ПЕРЕДАЧИ ИНФОРМАЦИИ",
      "BŁĄD: WSKAŹNIK INFORMACJI",
      "errinforate"
    ],
    errlinerate: [
      "ERR: LINE RATE",
      "ERR: LINE RATE",
      "ERR: ラインレート",
      "错误：线速",
      "FEHL: LEITUNGSRATE",
      "ERR : DÉBIT DE LA LIGNE",
      "ERR.: FREQUENZA LINEA",
      "ERRO: TAXA DE LINHA",
      "ERROR: VELOCIDAD DE LÍNEA",
      "ОШИБК: ПРОПУСКНАЯ СПОСОБНОСТЬ ЛИНИИ",
      "BŁĄD: WSKAŹNIK LINII",
      "errlinerate"
    ],
    blocked: [
      "BLOCKED",
      "BLOCKED",
      "ブロック済み",
      "已封锁",
      "BLOCKIERT",
      "BLOQUÉ",
      "BLOCCATO",
      "BLOQUEADO",
      "BLOQUEADO",
      "ЗАБЛОКИРОВАНО",
      "ZABLOKOWANE",
      "blocked"
    ],
    chart_measurement: [
      "Chart Measurement",
      "Chart Measurement",
      "測定グラフ",
      "图表测量",
      "Diagramm-Messung",
      "Mesure graphique",
      "Misurazione grafico",
      "Medição de gráficos",
      "Medición gráfica",
      "Измерение диаграммы",
      "Pomiar na wykresie",
      "chart_measurement"
    ],
    chart_measurement_unit_events: [
      "No. of Events",
      "No. of Events",
      "イベントの数",
      "活动数量",
      "Anz. der Ereignisse",
      "Nombre d'événements",
      "N. di eventi",
      "Nº de eventos",
      "N.º de Eventos",
      "Кол-во Событий",
      "Ilość zdarzeń",
      "chart_measurement_unit_events"
    ],
    chart_measurement_unit_errors: [
      "No. of Errored Seconds",
      "No. of Errored Seconds",
      "エラー秒数の数",
      "错误秒数",
      "Anz. der Fehler-Sekunden",
      "Nombre de secondes erronées",
      "N. di secondi con errore",
      "Nº de segundos com erro",
      "N.º de segundos con error",
      "Кол-во секунд с ошибкой",
      "Ilość błędnych sekund",
      "chart_measurement_unit_errors"
    ],
    chart_measurement_unit_frame_errors: [
      "No. of Frame Errors",
      "No. of Frame Errors",
      "フレームエラーの数",
      "帧错误数",
      "Anz. der Rahmenfehler",
      "Nombre d'erreurs de trames",
      "N. di errori frame",
      "Nº de erros de quadro",
      "N.º de Tramas con errores",
      "Кол-во кадровых ошибок",
      "Ilość błędów ramki",
      "chart_measurement_unit_frame_errors"
    ],
    chart_measurement_unit_events2: [
      "Events",
      "Events",
      "イベント",
      "活动",
      "Ereignisse",
      "Événements",
      "Eventi",
      "Eventos",
      "Eventos",
      "События",
      "Zdarzenia",
      "chart_measurement_unit_events2"
    ],
    result_efficiency: [
      "EFFICIENCY",
      "EFFICIENCY",
      "効率性",
      "效率",
      "EFFIZIENZ",
      "EFFICACITÉ",
      "EFFICIENZA",
      "EFICIÊNCIA",
      "EFICIENCIA",
      "ЭФФЕКТИВНОСТЬ",
      "WYDAJNOŚĆ",
      "result_efficiency"
    ],
    result_utilization: [
      "UTILIZATION",
      "UTILIZATION",
      "利用率",
      "使用率",
      "NUTZUNG",
      "UTILISATION",
      "UTILIZZAZIONE",
      "UTILIZAÇÃO",
      "UTILIZACIÓN",
      "ИСПОЛЬЗОВАНИЕ",
      "WYKORZYSTANIE",
      "result_utilization"
    ],
    result_detail: [
      "DETAIL",
      "DETAIL",
      "詳細",
      "详细信息",
      "DETAIL",
      "DÉTAIL",
      "DETTAGLIO",
      "DETALHE",
      "DETALLE",
      "ДЕТАЛЬ",
      "SZCZEGÓŁ",
      "result_detail"
    ],
    uptime_efficiency: [
      "Uptime Efficiency",
      "Uptime Efficiency",
      "アップタイム効率性",
      "正常运行时间效率",
      "Betriebszeit-Effizienz",
      "Efficacité de la disponibilité",
      "Efficienza uptime",
      "Eficiência do tempo de atividade",
      "Eficiencia de tiempo en activo",
      "Эффективность времени работы",
      "Wydajność czasu pracy bez przestojów",
      "uptime_efficiency"
    ],
    result_link_down: [
      "Link Down Time (hh:mm:ss)",
      "Link Down Time (hh:mm:ss)",
      "リンクダウンタイム (hh:mm:ss)",
      "链接中断时间（时：分：秒）",
      "Link-Down-Zeit (hh:mm:ss)",
      "Temps d'arrêt du lien (hh:mm:ss)",
      "Durata indisponibilità collegamento (hh:mm:ss)",
      "Período de inatividade do link (hh:mm:ss)",
      "Tiempo de vínculo inactivo (hh:mm:ss)",
      "Время простоя канала (чч:мм:сс)",
      "Czas przestoju łącza (gg:mm:ss)",
      "result_link_down"
    ],
    result_error_time: [
      "Error Time (hh:mm:ss)",
      "Error Time (hh:mm:ss)",
      "エラータイム (hh:mm:ss)",
      "错误时间（时：分：秒）",
      "Fehlerzeit (hh:mm:ss)",
      "Durée de l'erreur (hh:mm:ss)",
      "Durata errore (hh:mm:ss)",
      "Tempo de erro (hh:mm:ss)",
      "Tiempo con error (hh:mm:ss)",
      "Время ошибки (чч:мм:сс)",
      "Czas błędu (gg:mm:ss)",
      "result_error_time"
    ],
    jitter: [
      "Jitter (ns)",
      "Jitter (ns)",
      "ジッタ (ns)",
      "抖动（ns）",
      "Jitter (ns)",
      "Gigue (ns)",
      "Instabilità (ns)",
      "Jitter (ns)",
      "Jitter (ns)",
      "Джиттер (нс)",
      "Jitter (ns)",
      "jitter"
    ],
    frame_errors: [
      "Frame Errors",
      "Frame Errors",
      "フレームエラー",
      "帧错误",
      "Frame Fehler",
      "Erreurs de trame",
      "Errori di frame",
      "Erros de quadro",
      "Errores de Trama",
      "Ошибки кадра",
      "Błędy ramki",
      "frame_errors"
    ],
    result_jitter: [
      "Jitter (ns)",
      "Jitter (ns)",
      "ジッタ (ns)",
      "抖动（ns）",
      "Jitter (ns)",
      "Gigue (ns)",
      "Instabilità (ns)",
      "Jitter (ns)",
      "Jitter (ns)",
      "Джиттер (нс)",
      "Jitter (ns)",
      "result_jitter"
    ],
    result_error_limil: [
      "Errors / Limit:",
      "Errors / Limit:",
      "エラー / 制限:",
      "错误/限制：",
      "Fehler / Grenzwert:",
      "Erreur / Limite :",
      "Errori / Limite:",
      "Erros/limite:",
      "Errores/límite:",
      "Ошибки / Предел:",
      "Błędy / limit:",
      "result_error_limil"
    ],
    result_info_rate: [
      "Info Rate:",
      "Info Rate:",
      "情報レート:",
      "信息率：",
      "Info-Rate:",
      "Débit de l'info :",
      "Frequenza informazioni:",
      "Taxa de informação:",
      "Tasa de Datos",
      "Скорость передачи информации:",
      "Wskaźnik informacji:",
      "result_info_rate"
    ],
    result_tx_frames: [
      "Tx Frames:",
      "Tx Frames:",
      "Txフレーム:",
      "发射帧：",
      "Tx-Rahmen:",
      "Trames Tx :",
      "Frame trasmessi:",
      "Quadros Tx:",
      "Tramas Tx:",
      "Кадры Tx:",
      "Ramki Tx:",
      "result_tx_frames"
    ],
    result_rx_frames: [
      "Rx Frames:",
      "Rx Frames:",
      "Rxフレーム:",
      "接收帧：",
      "Rx-Rahmen:",
      "Trames Rx :",
      "Frame ricevuti:",
      "Quadros Rx:",
      "tramas Rx:",
      "Кадры Rx:",
      "Ramki Rx:",
      "result_rx_frames"
    ],
    result_no_of_web_sessions: [
      "No. of Web Sessions:",
      "No. of Web Sessions:",
      "Webセッションの数:",
      "网络会话次数：",
      "Anzahl der Web Sitzungen:",
      "N° de sessions Internet :",
      "N. di sessioni web:",
      "Nº de sessões web",
      "N.º de sesiones web:",
      "Кол-во Веб-сессий:",
      "Ilość sesji internetowych:",
      "result_no_of_web_sessions"
    ],
    result_no_of_voip_calls: [
      "No. of VoIP Calls:",
      "No. of VoIP Calls:",
      "VoIPコールの数:",
      "VoIP呼叫次数：",
      "Anzahl der VoIP-Anrufe:",
      "N° d'appels VoIP :",
      "N. di chiamate VoIP:",
      "Nº de chamadas VoIP:",
      "N.º de llamadas VoIP:",
      "Кол-во Звонков VoIP:",
      "Ilość połączeń ViOP",
      "result_no_of_voip_calls"
    ],
    result_no_of_video_streams: [
      "No. of Video Streams:",
      "No. of Video Streams:",
      "ビデオストリームの数:",
      "视频流量数：",
      "Anzahl der Video-Streams:",
      "N° de flux vidéo :",
      "N. di flussi video:",
      "Nº de fluxos de vídeo:",
      "N.º de Canales de vídeo:",
      "Кол-во Потоков Видео:",
      "Ilość przesyłów strumieniowych wideo:",
      "result_no_of_video_streams"
    ],
    result_no_of_cctv_cameras: [
      "No. of CCTV Cameras:",
      "No. of CCTV Cameras:",
      "CCTVカメラの数:",
      "CCTV相机数量:",
      "Anzahl der CCTV Kameras:",
      "N° de caméras de vidéoprotection :",
      "N. di telecamere CCTV:",
      "Nº de câmeras CFTV:",
      "N.º de cámaras CCTV:",
      "Кол-во Камер Видеонаблюдения:",
      "Ilość kamer CCTV:",
      "result_no_of_cctv_cameras"
    ],
    result_main: [
      "Main",
      "Main",
      "メイン",
      "主",
      "Hauptgerät",
      "Principal",
      "Principale",
      "Principal",
      "Principal",
      "Главный",
      "Główny",
      "result_main"
    ],
    result_remote: [
      "Remote",
      "Remote",
      "リモート",
      "远端",
      "Endgerät",
      "Distant",
      "Remoto",
      "Remota",
      "Remoto",
      "Удаленный",
      "Zdalny",
      "result_remote"
    ],
    result_macadd: [
      "MAC ADDRESS",
      "MAC ADDRESS",
      "MACアドレス",
      "MAC地址",
      "MAC-ADRESSE",
      "ADRESSE MAC",
      "INDIRIZZO MAC",
      "ENDEREÇO MAC",
      "DIRECCIÓN MAC",
      "MAC-АДРЕС",
      "ADRES MAC",
      "result_macadd"
    ],
    result_ipv4: [
      "IPv4",
      "IPv4",
      "IPv4",
      "IPv4",
      "IPv4",
      "IPv4",
      "IPv4",
      "IPv4",
      "IPv4",
      "IPv4",
      "IPv4",
      "result_ipv4"
    ],
    result_ipv6: [
      "IPv6",
      "IPv6",
      "IPv6",
      "IPv6",
      "IPv6",
      "IPv6",
      "IPv6",
      "IPv6",
      "IPv6",
      "IPv6",
      "IPv6",
      "result_ipv6"
    ],
    result_ip: [
      "IP",
      "IP",
      "IP",
      "IP",
      "IP",
      "IP",
      "IP",
      "IP",
      "IP",
      "IP",
      "IP",
      "result_ip"
    ],
    result_vlan: [
      "VLAN",
      "VLAN",
      "VLAN",
      "VLAN",
      "VLAN",
      "VLAN",
      "VLAN",
      "VLAN",
      "VLAN",
      "VLAN",
      "VLAN",
      "result_vlan"
    ],
    result_mac: [
      "MAC",
      "MAC",
      "MAC",
      "MAC",
      "MAC",
      "MAC",
      "MAC",
      "MAC",
      "MAC",
      "MAC",
      "MAC",
      "result_mac"
    ],
    result_interface: [
      "INTERFACE",
      "INTERFACE",
      "インターフェース",
      "接口",
      "SCHNITTSTELLE",
      "INTERFACE",
      "INTERFACCIA",
      "INTERFACE",
      "INTERFAZ",
      "ИНТЕРФЕЙС",
      "INTERFEJS",
      "result_interface"
    ],
    result_discovery: [
      "DISCOVERY",
      "DISCOVERY",
      "ディスカバリ",
      "发现",
      "ERKENNUNG",
      "DECOUVERTE",
      "INDIVIDUAZIONE",
      "DESCOBERTA",
      "DESCUBRIMIENTO",
      "ОБНАРУЖЕНИЕ",
      "DISCOVERY (ODKRYCIE)",
      "result_discovery"
    ],
    result_disclaimer: [
      "This info is from the Main Device only",
      "This info is from the Main Device only",
      "この情報はメインデバイスからのみです",
      "此信息仅来自主设备",
      "Diese Infos stammen nur vom Hauptgerät",
      "Cette info vient uniquement du boitier principal",
      "Queste informazioni provengono solo dal Dispositivo principale",
      "Esta informação é apenas do dispositivo principal",
      "Esta información es del dispositivo principal solamente",
      "Эта информация только из Главного устройства",
      "Te informacje pochodzą tylko z urządzenia głównego",
      "result_disclaimer"
    ],
    result_address: [
      "Address",
      "Address",
      "アドレス",
      "地址",
      "Adresse",
      "Adresse",
      "Indirizzo",
      "Endereço",
      "Dirección",
      "Адрес",
      "Adres ",
      "result_address"
    ],
    result_netmask: [
      "Netmask",
      "Netmask",
      "ネットマスク",
      "网路遮罩",
      "Netzwerkmaske",
      "Masque de sous-réseau",
      "Netmask",
      "Máscara de rede",
      "Máscara de red",
      "Маска сети",
      "Maska sieciowa",
      "result_netmask"
    ],
    result_gateway: [
      "Gateway",
      "Gateway",
      "ゲートウェイ",
      "网关",
      "Gateway",
      "Passerelle",
      "Gateway",
      "Gateway",
      "Puerta de enlace",
      "Шлюз",
      "Brama",
      "result_gateway"
    ],
    result_dnsprim: [
      "DNS Primary",
      "DNS Primary",
      "DNSプライマリ",
      "主要DNS",
      "DNS Primär",
      "DNS principal",
      "DNS primario",
      "DNS primário",
      "DNS principal",
      "Первичный DNS",
      "DNS Pierwszorzędny",
      "result_dnsprim"
    ],
    result_dnssec: [
      "DNS Secondary",
      "DNS Secondary",
      "DNSセカンダリ",
      "备用DNS",
      "DNS Sekundär",
      "DNS secondaire",
      "DNS secondario",
      "DNS secundário",
      "DNS secundario",
      "Вторичный DNS",
      "DNS Drugorzędny",
      "result_dnssec"
    ],
    result_dhcp: [
      "DHCP Server",
      "DHCP Server",
      "DHCPサーバー",
      "DHCP服务器",
      "DHCP-Server",
      "Serveur DHCP",
      "Server DHCP",
      "Servidor DHCP",
      "Servidor DHCP",
      "Сервер DHCP",
      "Serwer DHCP",
      "result_dhcp"
    ],
    result_nw_prefix: [
      "Network Prefix",
      "Network Prefix",
      "ネットワークプレフィックス",
      "网络前缀",
      "Netzwerk-Präfix",
      "Préfixe du réseau",
      "Prefisso di rete",
      "Prefixo de rede",
      "Prefijo de red",
      "Сетевой префикс",
      "Prefiks sieci",
      "result_nw_prefix"
    ],
    result_link_add: [
      "Link Address",
      "Link Address",
      "リンクアドレス",
      "链接地址",
      "Link-Adresse",
      "Adresse du lien",
      "Indirizzo di collegamento",
      "Endereço do link",
      "Dirección del vínculo",
      "Адрес канала",
      "Adres łącza",
      "result_link_add"
    ],
    result_vlan_setup: [
      "VLAN Setup:",
      "VLAN Setup:",
      "VLANセットアップ:",
      "VLAN设置：",
      "VLAN-Setup:",
      "Configuration VLAN :",
      "Configurazione VLAN:",
      "Configuração VLAN:",
      "Configuración VLAN:",
      "Настройка VLAN:",
      "Konfiguracja VLAN:",
      "result_vlan_setup"
    ],
    result_vlan_tag: [
      "VLAN Tag",
      "VLAN Tag",
      "VLANタグ",
      "VLAN标签",
      "VLAN-Tag",
      "Étiquette VLAN",
      "Tag VLAN",
      "Tag VLAN",
      "Etiqueta VLAN",
      "Тег VLAN",
      "Znacznik sieci VLAN",
      "result_vlan_tag"
    ],
    result_priority: [
      "Priority",
      "Priority",
      "優先度",
      "优先",
      "Priorität",
      "Priorité",
      "Priorità",
      "Prioridade",
      "Prioridad",
      "Приоритет",
      "Pierwszeństwo",
      "result_priority"
    ],
    result_protocolid: [
      "Protocol ID",
      "Protocol ID",
      "プロトコルID",
      "协议ID",
      "Protokoll-ID",
      "ID du protocol VLAN",
      "ID protocollo",
      "ID do protocolo",
      "ID del protocolo",
      "Ид. Протокола",
      "Identyfikator protokołu",
      "result_protocolid"
    ],
    result_lvl1: [
      "Level 1",
      "Level 1",
      "レベル 1",
      "1级",
      "Stufe 1",
      "Niveau 1",
      "Livello 1",
      "Nível 1",
      "Nivel 1",
      "Уровень 1",
      "Poziom 1",
      "result_lvl1"
    ],
    result_lvl2: [
      "Level 2",
      "Level 2",
      "レベル 2",
      "2级",
      "Stufe 2",
      "Niveau 2",
      "Livello 2",
      "Nível 2",
      "Nivel 2",
      "Уровень 2",
      "Poziom 2",
      "result_lvl2"
    ],
    result_lvl3: [
      "Level 3",
      "Level 3",
      "レベル 3",
      "3级",
      "Stufe 3",
      "Niveau 3",
      "Livello 3",
      "Nível 3",
      "Nivel 3",
      "Уровень 3",
      "Poziom 3",
      "result_lvl3"
    ],
    result_vlan_tags: [
      "VLAN Tags",
      "VLAN Tags",
      "VLANタグ",
      "VLAN标签",
      "VLAN-Tags",
      "Étiquettes VLAN",
      "Tag VLAN",
      "Tags VLAN",
      "Etiquetas VLAN",
      "Теги VLAN",
      "Znaczniki sieci VLAN",
      "result_vlan_tags"
    ],
    result_lvl1id: [
      "Level 1 ID",
      "Level 1 ID",
      "レベル 1 ID",
      "1级ID",
      "Stufe 1 ID",
      "ID du Niveau 1",
      "Livello 1D",
      "ID Nível 1",
      "ID del nivel 1",
      "Ид. Уровня 1",
      "Identyfikator poziomu 1",
      "result_lvl1id"
    ],
    result_lvl2id: [
      "Level 2 ID",
      "Level 2 ID",
      "レベル 2 ID",
      "2级ID",
      "Stufe 2 ID",
      "ID du Niveau 2",
      "Livello 2D",
      "ID Nível 2",
      "ID del nivel 2",
      "Ид. Уровня 2",
      "Identyfikator poziomu 2",
      "result_lvl2id"
    ],
    result_lvl3id: [
      "Level 3 ID",
      "Level 3 ID",
      "レベル 3 ID",
      "3级ID",
      "Stufe 3 ID",
      "ID du Niveau 3",
      "Livello 3D",
      "ID Nível 3",
      "ID del nivel 3",
      "Ид. Уровня 3",
      "Identyfikator poziomu 3",
      "result_lvl3id"
    ],
    result_cur_util: [
      "Current Utilization(%)",
      "Current Utilization(%)",
      "現在の利用率 (%)",
      "当前利用率（％）",
      "Aktuelle Nutzung (%)",
      "Utilisation en cours (%)",
      "Utilizzazione attuale (%)",
      "Utilização atual(%)",
      "Utilización actual (%)",
      "Текущее использование(%)",
      "Bieżące wykorzystanie (%)",
      "result_cur_util"
    ],
    result_avg_util: [
      "Average Utilization(%)",
      "Average Utilization(%)",
      "平均利用率 (%)",
      "平均利用率（％）",
      "Mittlere Nutzung (%)",
      "Utilisation moyenne (%)",
      "Utilizzazione media (%)",
      "Utilização média(%)",
      "Utilización media (%)",
      "Среднее использование(%)",
      "Średnie wykorzystanie (%)",
      "result_avg_util"
    ],
    result_max2_util: [
      "Max Utilization(%)",
      "Max Utilization(%)",
      "最大使用率 (%)",
      "最大利用率（％）",
      "Max. Nutzung (%)",
      "Utilisation max (%)",
      "Utilizzazione max (%)",
      "Utilização máxima(%)",
      "Utilización máx. (%)",
      "Макс. использование(%)",
      "Maks. wykorzystanie (%)",
      "result_max2_util"
    ],
    result_max_util: [
      "Maximum Utilization(%)",
      "Maximum Utilization(%)",
      "最大使用率 (%)",
      "最大利用率（％）",
      "Maximale Nutzung (%)",
      "Utilisation maximum (%)",
      "Utilizzazione massima (%)",
      "Utilização máxima(%)",
      "Utilización máxima (%)",
      "Максимальное использование(%)",
      "Maksymalne wykorzystanie (%)",
      "result_max_util"
    ],
    result_unicast: [
      "Unicast:",
      "Unicast:",
      "ユニキャスト:",
      "单播：",
      "Unicast:",
      "Unicast :",
      "Unicast:",
      "Unicast:",
      "Unidireccional:",
      "Одноадресная передача:",
      "Unicast:",
      "result_unicast"
    ],
    result_broadcast: [
      "Broadcast:",
      "Broadcast:",
      "ブロードキャスト:",
      "广播：",
      "Broadcast:",
      "Broadcast :",
      "Broadcast:",
      "Broadcast:",
      "Broadcast:",
      "Широковещательная передача:",
      "Broadcast:",
      "result_broadcast"
    ],
    result_multicasts: [
      "Multicast:",
      "Multicast:",
      "マルチキャスト:",
      "组播：",
      "Multicast:",
      "Multicast :",
      "Multicast:",
      "Multicast:",
      "Multicast:",
      "Многоадресная передача:",
      "Multicast:",
      "result_multicasts"
    ],
    result_tot_rx_fr: [
      "Total Rx Frames:",
      "Total Rx Frames:",
      "合計Rxフレーム:",
      "总接收帧数：",
      "Rx-Frames gesamt:",
      "Total des trames RX :",
      "Frame ricevuti totali:",
      "Total de quadros Rx:",
      "Total tramas Rx:",
      "Всего кадров Rx:",
      "Całkowita liczba ramek Rx:",
      "result_tot_rx_fr"
    ],
    result_tot_rx_byt: [
      "Total Rx Bytes:",
      "Total Rx Bytes:",
      "合計Rxバイト:",
      "总接收字节数：",
      "Rx-Bytes gesamt:",
      "Total des Bits RX :",
      "Byte ricevuti totali:",
      "Total de bytes Rx:",
      "Total Bytes Rx:",
      "Всего байтов Rx:",
      "Całkowita liczba bitów Rx:",
      "result_tot_rx_byt"
    ],
    result_max_fr_per_sec: [
      "Max Frames per seconds:",
      "Max Frames per seconds:",
      "最大最大フレーム/秒:",
      "每秒最大帧数：",
      "Max. Frames pro Sekunde:",
      "Trames max par secondes :",
      "Frame max al secondo:",
      "Máx de quadros por segundo:",
      "Max tramas por segundo:",
      "Макс кадров в секунду:",
      "Maks. liczba ramek na sekundę:",
      "result_max_fr_per_sec"
    ],
    result_cur_data_rate: [
      "Current Data Rate:",
      "Current Data Rate:",
      "現在のデータレート:",
      "当前数据速率:",
      "Aktuelle Datenrate :",
      "Débit en cours des données :",
      "Frequenza dati attuale:",
      "Taxa de dados atual:",
      "Tasa de datos actual:",
      "Текущая скорость передачи информации:",
      "Bieżąca szybkość transmisji danych:",
      "result_cur_data_rate"
    ],
    result_avg_data_rate: [
      "Average Data Rate:",
      "Average Data Rate:",
      "平均データレート:",
      "平均数据速率:",
      "Mittlere Datenrate :",
      "Débit moyen des données :",
      "Frequenza dati media:",
      "Taxa de dados média:",
      "Flujo de Datos medio:",
      "Средняя скорость передачи информации:",
      "Średnia szybkość transmisji danych:",
      "result_avg_data_rate"
    ],
    result_max_data_rate: [
      "Max Data Rate:",
      "Max Data Rate:",
      "最大データレート:",
      "最大数据速率:",
      "Maximale Datenrate :",
      "Débit max des données :",
      "Frequenza dati max:",
      "Taxa de dados máxima:",
      "Flujo de Datos máx:",
      "Макс. скорость передачи информации:",
      "Maks. szybkość transmisji danych:",
      "result_max_data_rate"
    ],
    result_fr_len: [
      "Frame Length",
      "Frame Length",
      "フレーム長",
      "帧长度",
      "Rahmenlänge",
      "Longueur de trame",
      "Lunghezza frame",
      "Comprimento do quadro",
      "Longitud de trama",
      "Длина кадра",
      "Długość ramki",
      "result_fr_len"
    ],
    result_l64: [
      "<64:",
      "<64:",
      "64未満:",
      "<64:",
      "<64:",
      "<64 :",
      "<64:",
      "<64:",
      "<64:",
      "<64:",
      "<64:",
      "result_l64"
    ],
    result_l127: [
      "64 - 127:",
      "64 - 127:",
      "64～127:",
      "64 - 127:",
      "64 - 127:",
      "64 - 127 :",
      "64 - 127:",
      "64 - 127:",
      "64 - 127:",
      "64 - 127:",
      "64 - 127:",
      "result_l127"
    ],
    result_l255: [
      "128 - 255:",
      "128 - 255:",
      "128～255:",
      "128 - 255:",
      "128 - 255:",
      "128 - 255 :",
      "128 - 255:",
      "128 - 255:",
      "128 - 255:",
      "128 - 255:",
      "128 - 255:",
      "result_l255"
    ],
    result_l511: [
      "256 - 511:",
      "256 - 511:",
      "256～511:",
      "256 - 511:",
      "256 - 511:",
      "256 - 511 :",
      "256 - 511:",
      "256 - 511:",
      "256 - 511:",
      "256 - 511:",
      "256 - 511:",
      "result_l511"
    ],
    result_l1023: [
      "512 - 1023:",
      "512 - 1023:",
      "512～1023:",
      "512 - 1023:",
      "512 - 1023:",
      "512 - 1023 :",
      "512 - 1023:",
      "512 - 1023:",
      "512 - 1023:",
      "512 - 1023:",
      "512 - 1023:",
      "result_l1023"
    ],
    result_l1279: [
      "1024 - 1279:",
      "1024 - 1279:",
      "1024～1279:",
      "1024 - 1279:",
      "1024 - 1279:",
      "1024 - 1279 :",
      "1024 - 1279:",
      "1024 - 1279:",
      "1024 - 1279:",
      "1024 - 1279:",
      "1024 - 1279:",
      "result_l1279"
    ],
    result_l1518: [
      "1280 - 1518:",
      "1280 - 1518:",
      "1280～1518:",
      "1280 - 1518:",
      "1280 - 1518:",
      "1280 - 1518 :",
      "1280 - 1518:",
      "1280 - 1518:",
      "1280 - 1518:",
      "1280 - 1518:",
      "1280 - 1518:",
      "result_l1518"
    ],
    result_l1522: [
      "1519 - 1522:",
      "1519 - 1522:",
      "1519～1522:",
      "1519 - 1522:",
      "1519 - 1522:",
      "1519 - 1522 :",
      "1519 - 1522:",
      "1519 - 1522:",
      "1519 - 1522:",
      "1519 - 1522:",
      "1519 - 1522:",
      "result_l1522"
    ],
    result_m1522: [
      ">1522:",
      ">1522:",
      "1522超:",
      ">1522:",
      ">1522:",
      ">1522 :",
      ">1522:",
      ">1522:",
      "<1522:",
      ">1522:",
      ">1522:",
      "result_m1522"
    ],
    result_frame_error: [
      "Frame Error",
      "Frame Error",
      "フレームエラー",
      "帧错误",
      "Frame Fehler",
      "Erreur de trame",
      "Errore frame",
      "Erro de quadro",
      "Error de trama",
      "Ошибка кадра",
      "Błąd ramki",
      "result_frame_error"
    ],
    result_fcs: [
      "Bad FCS:",
      "Bad FCS:",
      "Bad FCS:",
      "错误FCS:",
      "Falsche FCS:",
      "Mauvais FCS :",
      "FCS non valido:",
      "FCS incorreto:",
      "FCS erróneo:",
      "Неверная контрольная последовательность кадров:",
      "Zły FCS:",
      "result_fcs"
    ],
    result_un_fr: [
      "Undersized Frames:",
      "Undersized Frames:",
      "アンダーサイズフレーム:",
      "过小的帧：",
      "Zu kleine Framegröße:",
      "Trames trop petites :",
      "Frame di dimensioni insufficienti:",
      "Quadros subdimensionados:",
      "Tramas demasiado pequeñas:",
      "Короткие кадры:",
      "Niewymiarowe ramki:",
      "result_un_fr"
    ],
    result_ov_fr: [
      "Oversized Frames:",
      "Oversized Frames:",
      "オーバーサイズフレーム:",
      "过大的帧：",
      "Zu große Framegröße:",
      "Trames trop grandes :",
      "Frame di dimensioni eccessive:",
      "Quadros superdimensionados:",
      "Tramas sobre-medida:",
      "Длинные кадры:",
      "Ponadwymiarowe ramki:",
      "result_ov_fr"
    ],
    sub_test_link_status: [
      "Link Status",
      "Link Status",
      "リンクステータス",
      "链接状态",
      "Link-Status",
      "Statut du lien",
      "Stato collegamento",
      "Status do link",
      "Estado del vínculo",
      "Статус канала",
      "Status łącza",
      "sub_test_link_status"
    ],
    result_duplex: [
      "Duplex:",
      "Duplex:",
      "デュプレックス:",
      "双工：",
      "Duplex:",
      "Duplex :",
      "Duplex:",
      "Duplex:",
      "Dúplex",
      "Дуплекс:",
      "Dupleks:",
      "result_duplex"
    ],
    subtest_poeload_poestatus: [
      "PoE Status:",
      "PoE Status:",
      "PoEステータス:",
      "PoE状态：",
      "PoE-Status:",
      "Statut du PoE :",
      "Stato PoE:",
      "Status PoE:",
      "Estado de PoE:",
      "Статус PoE:",
      "Status PoE:",
      "subtest_poeload_poestatus"
    ],
    result_poe_pow: [
      "PoE Power(W):",
      "PoE Power(W):",
      "PoE電源 (W):",
      "PoE功率（W）：",
      "PoE-Leistung (W):",
      "Puissance PoE (W) :",
      "Potenza PoE (W):",
      "Potência PoE(W):",
      "Potencia de PoE (W):",
      "Мощность PoE (Вт):",
      "Moc PoE (W):",
      "result_poe_pow"
    ],
    result_poe_vol: [
      "PoE Voltage(V):",
      "PoE Voltage(V):",
      "PoE電圧(V):",
      "PoE电压（V）：",
      "PoE-Spannung (V):",
      "Tension PoE (V) :",
      "Tensione PoE (V):",
      "Tensão PoE(V):",
      "Voltaje de PoE (V):",
      "Напряжение PoE (В):",
      "Napięcie PoE (V):",
      "result_poe_vol"
    ],
    result_p1236: [
      "Pair<br />12-36",
      "Pair<br />12-36",
      "ペア<br />12-36",
      "12-36对",
      "Paar<br />12-36",
      "Paire<br />12-36",
      "Coppia<br />12-36",
      "Par<br />12-36",
      "Par<br />12-36",
      "Пара<br />12-36",
      "Pary<br />12-36",
      "result_p1236"
    ],
    result_p4578: [
      "Pair<br />45-78",
      "Pair<br />45-78",
      "ペア<br />45-78",
      "45-78对",
      "Paar<br />45-78",
      "Paire<br />45-78",
      "Coppia<br />45-78",
      "Par<br />45-78",
      "Par<br />45-78",
      "Пара<br />45-78",
      "Pary<br />45-78",
      "result_p4578"
    ],
    result_skew: [
      "Skew (ns)",
      "Skew (ns)",
      "スキュー (ns)",
      "偏斜（ns）",
      "Skew (ns)",
      "Skew (ns)",
      "Sfasamento (ns)",
      "Desvio (ns)",
      "Desvío de Retardo (s)",
      "Смещение (нс)",
      "Odchylenie opóźnienia (ns)",
      "result_skew"
    ],
    result_snr: [
      "SNR Margin (dB)",
      "SNR Margin (dB)",
      "SNR Margin (dB)",
      "信噪比 余量（dB）",
      "SNR Margin (dB)",
      "SNR Margin (dB)",
      "SNR Margin (dB)",
      "SNR Margin (dB)",
      "SNR Margin (dB)",
      "Отношение сигнал/шум Запас (дБ)",
      "SNR Margin (dB)",
      "result_snr"
    ],

    result_pr1: [
      "Pair 1-2",
      "Pair 1-2",
      "ペア 1-2",
      "1-2对",
      "Paar 1-2",
      "Paire 1-2",
      "Coppia 1-2",
      "Par 1-2",
      "Par 1-2",
      "Пара 1-2",
      "Pary 1-2",
      "result_pr1"
    ],
    result_pr2: [
      "Pair 3-6",
      "Pair 3-6",
      "ペア 3-6",
      "3-6对",
      "Paar 3-6",
      "Paire 3-6",
      "Coppia 3-6",
      "Par 3-6",
      "Par 3-6",
      "Пара 3-6",
      "Pary 3-6",
      "result_pr2"
    ],
    result_pr3: [
      "Pair 4-5",
      "Pair 4-5",
      "ペア 4-5",
      "4-5对",
      "Paar 4-5",
      "Paire 4-5",
      "Coppia 4-5",
      "Par 4-5",
      "Par 4-5",
      "Пара 4-5",
      "Pary 4-5",
      "result_pr3"
    ],
    result_pr4: [
      "Pair 7-8",
      "Pair 7-8",
      "ペア 7-8",
      "7-8对",
      "Paar 7-8",
      "Paire 7-8",
      "Coppia 7-8",
      "Par 7-8",
      "Par 7-8",
      "Пара 7-8",
      "Pary 7-8",
      "result_pr4"
    ],
    result_pr_status: [
      "Port Status:",
      "Port Status:",
      "ポートステータス:",
      "端口状态：",
      "Port-Status:",
      "Statut du port :",
      "Stato porta:",
      "Status da porta:",
      "Estado del puerto:",
      "Статус порта:",
      "Status portu:",
      "result_pr_status"
    ],
    result_module: [
      "Module:",
      "Module:",
      "モジュール:",
      "模块：",
      "Modul:",
      "Module :",
      "Modulo:",
      "Módulo:",
      "Módulo:",
      "Модуль:",
      "Moduł:",
      "result_module"
    ],
    result_vendor: [
      "Vendor",
      "Vendor",
      "ベンダー",
      "供应商",
      "Anbieter",
      "Fabriquant",
      "Fornitore",
      "Fornecedor",
      "Fabricante",
      "Поставщик",
      "Dostawca",
      "result_vendor"
    ],
    result_prt_num: [
      "Part Number:",
      "Part Number:",
      "部品番号:",
      "零件号：",
      "Bestellnummer:",
      "Référence produit :",
      "Numero parte:",
      "Código:",
      "Número de pieza:",
      "Номер детали:",
      "Numer części:",
      "result_prt_num"
    ],
    result_rx_pow: [
      "Rx Power (dBm)",
      "Rx Power (dBm)",
      "Rx電力 (dBm)",
      "接收功率（dBm",
      "Rx-Leistung (dBm)",
      "Puissance R (dBm)",
      "Potenza ricevuta (dBm)",
      "Potência Rx(dBm)",
      "Potencia Rx (dBm)",
      "Мощность Rx (дБ/мВт)",
      "Moc Rx (dBm)",
      "result_rx_pow"
    ],
    result_tx_pow: [
      "Tx Power(dBm):",
      "Tx Power(dBm):",
      "Tx電力 (dBm):",
      "发射功率（dBm）：",
      "Tx-Leistung (dBm):",
      "Puissance Tx (dBm) :",
      "Potenza trasmessa (dBm):",
      "Potência Tx(dBm):",
      "Potencia Tx (dBm):",
      "Мощность Tx (дБ/мВт):",
      "Moc Tx (dBm):",
      "result_tx_pow"
    ],
    result_temp: [
      "Temperature(<sup>o</sup>C / <sup>o</sup>F):",
      "Temperature(<sup>o</sup>C / <sup>o</sup>F):",
      "温度 (<sup>o</sup>C / <sup>o</sup>F):",
      "温度（<sup>o</sup>C / <sup>o</sup>F）：",
      "Temperatur(<sup>o</sup>C / <sup>o</sup>F):",
      "Température (<sup>o</sup>C / <sup>o</sup>F):",
      "Temperatura (<sup>o</sup>C / <sup>o</sup>F):",
      "Temperatura(<sup>o</sup>C / <sup>o</sup>F):",
      "Temperatura (<sup>o</sup>C / <sup>o</sup>F):",
      "Температура(<sup>o</sup>C / <sup>o</sup>F):",
      "Temperatura (<sup>o</sup>C / <sup>o</sup>F):",
      "result_temp"
    ],
    result_protocol_tab: [
      "Protocol",
      "Protocol",
      "プロトコル",
      "协议",
      "Protokoll",
      "Protocole",
      "Protocollo",
      "Protocolo",
      "Protocolo",
      "Протокол",
      "Protokół",
      "result_protocol_tab"
    ],
    result_host: [
      "Host",
      "Host",
      "ホスト",
      "主机",
      "Host",
      "Hôte",
      "Host",
      "Host",
      "Host",
      "Хост",
      "Host",
      "result_host"
    ],
    result_port: [
      "Port",
      "Port",
      "ポート",
      "端口",
      "Port",
      "Port",
      "Porta",
      "Porta",
      "Puerto",
      "Порт",
      "Port",
      "result_port"
    ],
    result_system: [
      "System",
      "System",
      "システム",
      "系统",
      "System",
      "Système",
      "Sistema",
      "Sistema",
      "Sistema",
      "Система",
      "System",
      "result_system"
    ],
    result_poe_device: [
      "PoE Device",
      "PoE Device",
      "PoEデバイス",
      "PoE设备",
      "PoE-Gerät",
      "Equipement PoE",
      "Dispositivo PoE",
      "Dispositivo PoE",
      "Dispositivo PoE",
      "Устройство PoE",
      "Urządzenie PoE",
      "result_poe_device"
    ],
    result_model: [
      "Model",
      "Model",
      "モデル",
      "模型",
      "Modell",
      "Modèle",
      "Modello",
      "Modelo",
      "Modelo",
      "Модель",
      "Model",
      "result_model"
    ],
    result_vlan_info: [
      "VLAN Info",
      "VLAN Info",
      "VLAN情報",
      "VLAN信息",
      "VLAN-Info",
      "Info VLAN",
      "Informazioni VLAN",
      "Informação VLAN",
      "Información VLAN",
      "Информация VLAN",
      "Informacje o VLAN",
      "result_vlan_info"
    ],
    result_capabilities: [
      "Capabilities",
      "Capabilities",
      "性能",
      "能力",
      "Eigenschaften",
      "Capacités",
      "Capacità",
      "Capacidades",
      "Capacidades",
      "Возможности",
      "Możliwości",
      "result_capabilities"
    ],
    result_optical: [
      "Optical",
      "Optical",
      "光回線",
      "光学",
      "Optisch",
      "Optique",
      "Ottico",
      "Óptica",
      "Óptico",
      "Оптический",
      "Optyczny",
      "result_optical"
    ],
    ping4: [
      "Ping4",
      "Ping4",
      "Ping4",
      "Ping4",
      "Ping4",
      "Ping 4",
      "Ping4",
      "Ping4",
      "Ping4",
      "Ping4",
      "Ping4",
      "ping4"
    ],
    ping6: [
      "Ping6",
      "Ping6",
      "Ping6",
      "Ping6",
      "Ping6",
      "Ping 6",
      "Ping6",
      "Ping6",
      "Ping6",
      "Ping6",
      "Ping6",
      "ping6"
    ],
    traceroute4: [
      "TraceRoute4",
      "TraceRoute4",
      "TraceRoute4",
      "TraceRoute4",
      "TraceRoute4",
      "TraceRoute 4",
      "TraceRoute4",
      "TraceRoute4",
      "TraceRoute4",
      "TraceRoute4",
      "TraceRoute4",
      "traceroute4"
    ],
    traceroute6: [
      "TraceRoute6",
      "TraceRoute6",
      "TraceRoute6",
      "TraceRoute6",
      "TraceRoute6",
      "TraceRoute 6",
      "TraceRoute6",
      "TraceRoute6",
      "TraceRoute6",
      "TraceRoute6",
      "TraceRoute6",
      "traceroute6"
    ],
    cabledata: [
      "Cable Data",
      "Cable Data",
      "ケーブルデータ",
      "电缆数据",
      "Kabeldaten",
      "Données du câble",
      "Dati cavo",
      "Dados do cabo",
      "Datos del cable",
      "Данные кабеля",
      "Dane okablowania",
      "cabledata"
    ],
    poeload: [
      "PoE Load",
      "PoE Load",
      "PoE負荷",
      "PoE负载",
      "PoE-Last",
      "Chargement PoE",
      "Carico PoE",
      "Carga de PoE",
      "Carga PoE",
      "Нагрузка PoE",
      "Obciążenie PoE",
      "poeload"
    ],
    webdata: [
      "Web Data",
      "Web Data",
      "Webデータ",
      "网络数据",
      "Web-Daten",
      "Données Internet",
      "Dati web",
      "Dados web",
      "Datos web",
      "Данные Интернета",
      "Dane Web",
      "webdata"
    ],
    voipdata: [
      "VoIP Data",
      "VoIP Data",
      "VoIPデータ",
      "VoIP数据",
      "VoIP-Daten",
      "Données VoIP",
      "Dati VoIP",
      "Dados VoIP",
      "Datos VoIP",
      "Данные VoIP",
      "Dane VoIP",
      "voipdata"
    ],
    videodata: [
      "Video Data",
      "Video Data",
      "ビデオデータ",
      "视频数据",
      "Video-Daten",
      "Données vidéo IP",
      "Dati video",
      "Dados de vídeo",
      "Datos de vídeo",
      "Видео-данные",
      "Dane Wideo",
      "videodata"
    ],
    cctvdata: [
      "CCTV Data",
      "CCTV Data",
      "CCTVデータ",
      "CCTV数据",
      "CCTV-Daten",
      "Données caméras IP",
      "Dati CCTV",
      "Dados CFTV",
      "Datos de CCTV",
      "Данные видеонаблюдения",
      "Dane CCTV",
      "cctvdata"
    ],
    netscan: [
      "NetScan",
      "NetScan",
      "ネットスキャン",
      "NetScan",
      "Netscan",
      "NetScan",
      "NetScan",
      "NetScan",
      "NetScan",
      "NetScan",
      "NetScan",
      "netscan"
    ],
    customdata: [
      "Custom Data",
      "Custom Data",
      "カスタムデータ",
      "自定义数据",
      "Kundenspez. Daten",
      "Données personnalisées",
      "Dati personalizzati",
      "Dados personalizados",
      "Datos personalizados",
      "Пользовательские данные",
      "Niestandardowe dane",
      "customdata"
    ],
    wiremap: [
      "Wiremap",
      "Wiremap",
      "ワイヤーマップ",
      "接线图",
      "Verdrahtungsplan",
      "Câblage",
      "Mappatura fili",
      "Mapa de Fios",
      "Diagrama de cables",
      "Схема разводки кабеля",
      "Mapa okablowania",
      "wiremap"
    ],
    wiremapnt: [
      "Wiremap",
      "Wiremap",
      "ワイヤーマップ",
      "接线图",
      "Verdrahtungsplan",
      "Câblage",
      "Mappatura fili",
      "Mapa de Fios",
      "Diagrama de cables",
      "Схема разводки кабеля",
      "Mapa okablowania",
      "wiremapnt"
    ],
    fiberlength: [
      "Fiber Length",
      "Fiber Length",
      "Fiber Length",
      "Fiber Length",
      "Fiber Length",
      "Fiber Length",
      "Fiber Length",
      "Fiber Length",
      "Fiber Length",
      "Fiber Length",
      "Fiber Length",
      "fiberlength"
    ],
    maxthroughput: [
      "Max Throughput",
      "Max Throughput",
      "最大スループット",
      "最大吞吐量",
      "Maximaler Durchsatz",
      "Débit max",
      "Velocità di trasmissione max",
      "Rendimento Máximo",
      "Rendimiento máx.",
      "Макс. пропускная способность",
      "Maks. przepustowośś",
      "maxthroughput"
    ],
    uptime: [
      "Uptime",
      "Uptime",
      "アップタイム",
      "正常运行时间",
      "Betriebszeit",
      "Disponibilité",
      "Uptime",
      "Tempo de atividade",
      "Tiempo en activo",
      "Время работы",
      "Czas pracy bez przestojów",
      "uptime"
    ],
    fiberlengthloss: [
      "Fibre Length & Loss",
      "Fiber Length & Loss",
      "繊維の長さと損失",
      "光纤长度和损耗",
      "Faserlänge und Dämpfung",
      "Longueur et perte fibre",
      "Lunghezza &amp; Perdita della Fibra",
      "Perda e Comprimento da Fibra",
      "Longitud y pérdida de la fibra",
      "Длина волокна и потери",
      "Długość i strata włókna",
      "fiberlengthloss"
    ],
    qualification: [
      "Copper Qualification",
      "Copper Qualification",
      "銅の資格",
      "铜材资质",
      "Kupferqualifikation",
      "Qualification du cuivre",
      "Qualificazione del rame",
      "Qualificação de Cobre",
      "Calificación de cobre",
      "Медная квалификация",
      "Kwalifikacja miedzi",
      "qualification"
    ],
    fiberqualification: [
      "Fibre Qualification",
      "Fiber Qualification",
      "ファイバーの資格",
      "纤维资格",
      "Faserqualifikation",
      "Qualification des fibres",
      "Qualificazione in fibra",
      "Qualificação da fibra",
      "Calificación de fibra",
      "Квалификация волокна",
      "Kwalifikacja światłowodowa",
      "fiberqualification"
    ],
    stats: [
      "Stats",
      "Stats",
      "統計",
      "统计",
      "Statistik",
      "Statistiques",
      "Statistiche",
      "Estatísticas",
      "Estadísticas",
      "Статистика",
      "Statystyki",
      "stats"
    ],
    class: [
      "CLASS",
      "CLASS",
      "クラス",
      "分级",
      "KLASSE",
      "Classe",
      "CLASSE",
      "CLASSE",
      "CLASE",
      "КЛАСС",
      "KLASA",
      "class"
    ],
    result_no_of_web_sessions2: [
      "No. of Web Sessions",
      "No. of Web Sessions",
      "Webセッションの数",
      "网络会话次数：",
      "Anzahl der Web Sitzungen",
      "Nombre de sessions Internet",
      "N. di sessioni web",
      "Nº de sessões web",
      "N.º de sesiones web",
      "Кол-во Веб-сессий",
      "Ilość sesji internetowych:",
      "result_no_of_web_sessions2"
    ],
    result_no_of_voip_calls2: [
      "No. of VoIP Calls",
      "No. of VoIP Calls",
      "VoIPコールの数",
      "VoIP呼叫次数：",
      "Anzahl der VoIP-Anrufe",
      "Nombre d'appels VoIP",
      "N. di chiamate VoIP",
      "Nº de chamadas VoIP:",
      "N.º de llamadas VoIP",
      "Кол-во Звонков VoIP",
      "Ilość połączeń ViOP",
      "result_no_of_voip_calls2"
    ],
    result_no_of_video_streams2: [
      "No. of Video Streams",
      "No. of Video Streams",
      "ビデオストリームの数",
      "视频流量数：",
      "Anzahl der Video-Streams:",
      "Nombre de flux vidéo",
      "N. di flussi video",
      "Nº de fluxos de vídeo:",
      "N.º de secuencias de vídeo",
      "Кол-во Потоков Видео",
      "Ilość przesyłów strumieniowych wideo",
      "result_no_of_video_streams2"
    ],
    subtest_number_of_cameras2: [
      "NO. OF CCTV Cameras",
      "NO. OF CCTV Cameras",
      "CCTVカメラの数",
      "CCTV相机数量",
      "ANZ. DER CCTV-Kameras",
      "Nombre de caméras IP",
      "N. DI telecamere CCTV",
      "Nº de câmeras CFTV:",
      "N.º DE CÁMARAS CCTV",
      "КОЛ-ВО Камер Видеонаблюдения",
      "Ilość kamer CCTV",
      "subtest_number_of_cameras2"
    ],
    address_conflicts2: [
      "ADDRESS CONFLICTS",
      "ADDRESS CONFLICTS",
      "アドレスの競合",
      "地址冲突",
      "ADRESSKONFLIKTE",
      "CONFLITS D'ADRESSE",
      "CONFLITTI DI INDIRIZZO",
      "CONFLITOS DE ENDEREÇO",
      "CONFLICTOS DE DIRECCIÓN",
      "АДРЕСНЫЕ КОНФЛИКТЫ",
      "KONFLIKTY ADRESÓW",
      "address_conflicts2"
    ],
    error_limit: [
      "ERROR / LIMIT",
      "ERROR / LIMIT",
      "エラー / 制限",
      "错误/限制",
      "FEHLER / GRENZWERT",
      "ERREUR / LIMITE",
      "ERRORE / LIMITE",
      "ERRO/LIMITE",
      "ERROR/LÍMITE",
      "ОШИБКА / ПРЕДЕЛ",
      "BŁĘDY/ LIMIT:",
      "error_limit"
    ],
    link_speed_m_r: [
      "LINK SPEED (MAIN - REMOTE)",
      "LINK SPEED (MAIN - REMOTE)",
      "リンク速度 (メイン - リモート)",
      "链接速度（主要-远程）",
      "LINK-RATE (HAUPT - ENDGERÄT)",
      "VITESSE DU LIEN (PRINCIPAL - RECEPTEUR)",
      "VELOCITÀ DI COLLEGAMENTO (PRINCIPALE - REMOTO)",
      "VELOCIDADE DO LINK (PRINCIPAL - REMOTA)",
      "VELOCIDAD DEL VÍNCULO (PRINCIPAL - REMOTO)",
      "СКОРОСТЬ КАНАЛА (ОСНОВНОЕ - УДАЛЕННОЕ)",
      "SZYBKOŚĆ ŁĄCZA (GŁÓWNY - ZDALNY)",
      "link_speed_m_r"
    ],
    inprogress2: [
      "In Progress",
      "In Progress",
      "実行中",
      "进行中",
      "In Arbeit",
      "EN COURS",
      "In corso",
      "Em andamento",
      "En curso",
      "Выполняется",
      "W trakcie",
      "inprogress2"
    ],
    Eth: [
      "Copper",
      "Copper",
      "銅線",
      "铜",
      "Kupfer",
      "Cuivre",
      "Rame",
      "Cobre",
      "Cobre",
      "Медь",
      "Miedź",
      "Eth"
    ],
    Optical: [
      "Optical",
      "Optical",
      "光回線",
      "光学",
      "Optisch",
      "Optique",
      "Ottico",
      "Óptica",
      "Óptico",
      "Оптический",
      "Optyka",
      "Optical"
    ],
    pin: [
      "Pin ",
      "Pin ",
      "ピン",
      "针 ",
      "Pin ",
      "Broche ",
      "Pin ",
      "Pino",
      "PIN ",
      "Штырь ",
      "Pin ",
      "pin"
    ],
    tab_details: [
      "Details",
      "Details",
      "詳細",
      "详细信息",
      "Details",
      "Détails",
      "Dettagli",
      "Detalhes",
      "Datos",
      "Подробности",
      "Szczegóły",
      "tab_details"
    ],
    tab_identifiers: [
      "Identifiers",
      "Identifiers",
      "識別子",
      "识别码",
      "Kennungen",
      "Identifiants",
      "Identificatori",
      "Identificadores",
      "Identificadores",
      "Идентификаторы",
      "Identyfikatory",
      "tab_identifiers"
    ],
    tab_qualification: [
      "Copper Qualification Test",
      "Copper Qualification Test",
      "銅資格試験",
      "铜资格测试",
      "Kupfer-Qualifikationstest",
      "Test de qualification du cuivre",
      "Test di qualificazione del rame",
      "Teste de qualificação do cobre",
      "Prueba de calificación del cobre",
      "Тест на квалификацию по меди",
      "Test kwalifikacyjny miedzi",
      "tab_qualification"
    ],
    tab_fiber_qualification: [
      "Fibre Qualification Test",
      "Fiber Qualification Test",
      "ファイバーの資格テスト",
      "光纤资格测试",
      "Faserqualifikationstest",
      "Test de qualification des fibres",
      "Test di qualificazione in fibra",
      "Teste de qualificação de fibra",
      "Prueba de calificación de fibra",
      "Квалификационный тест волокна",
      "Test kwalifikacyjny światłowodowy",
      "tab_fiber_qualification"
    ],
    tab_network: [
      "Network Tests",
      "Network Tests",
      "ネットワークテスト",
      "网络测试",
      "Netzwerktests",
      "Tests Réseau",
      "Prove di rete",
      "Testes de rede",
      "Pruebas de red",
      "Сетевые тесты",
      "Testy Sieciowe",
      "tab_network"
    ],
    tab_transmission: [
      "Transmission Tests",
      "Transmission Tests",
      "伝送テスト",
      "传输测试",
      "Übertragungstests",
      "Tests Transmission",
      "Prove di trasmissione",
      "Testes de transmissão",
      "Pruebas de transmisión",
      "Тесты параметров передачи",
      "Testy Transmisji",
      "tab_transmission"
    ],
    tab_wiremap: [
      "Wiremap Tests",
      "Wiremap Tests",
      "ワイヤーマップテスト",
      "接线图测试",
      "Verdrahtungsplan",
      "Tests Câblage",
      "Prove di mappatura fili",
      "Testes de mapa de fios",
      "Pruebas de diagrama de cables",
      "Тесты разводки проводов",
      "Testy Mapy Okablowania",
      "tab_wiremap"
    ],
    tab_poe: [
      "POE Tests",
      "POE Tests",
      "PoEテスト",
      "POE测试",
      "POE-Tests",
      "Tests PoE",
      "Prove POE",
      "Testes de POE",
      "Pruebas PoE",
      "Тесты POE",
      "Testy POE",
      "tab_poe"
    ],
    tab_fiber: [
      "Fibre Tests",
      "Fiber Tests",
      "ファイバーテスト",
      "光纤测试仪",
      "Glasfaser-Tests",
      "Tests Fibre",
      "Test della fibra",
      "Testes de Fibra",
      "Tests fibra",
      "Тесты оптоволоконных кабелей",
      "Testy włókna",
      "tab_fiber"
    ],
    no_data_sg: [
      "No Data to Display",
      "No Data to Display",
      "表示するデータはありません",
      "没有数据显示",
      "Keine Daten anzuzeigen",
      "Aucune donnée à afficher",
      "Nessun dato da visualizzare",
      "Sem dados para exibir",
      "No hay datos que mostrar",
      "Нет данных для отображения",
      "Brak danych do wyświetlenia",
      "no_data_sg"
    ],
    mac_addr: [
      "MAC Address",
      "MAC Address",
      "MACアドレス",
      "MAC地址",
      "MAC-Adresse",
      "ADRESSE MAC",
      "Indirizzo MAC",
      "Endereço MAC",
      "Dirección MAC",
      "MAC-Адрес",
      "Adres MAC",
      "mac_addr"
    ],
    host_name: [
      "Host Name",
      "Host Name",
      "ホスト名",
      "主机名",
      "Host-Name",
      "Nom de l'hôte",
      "Nome host",
      "Nome do host",
      "Nombre de host",
      "Имя хоста",
      "Nazwa hosta",
      "host_name"
    ],
    ipv4: [
      "IPv4",
      "IPv4",
      "IPv4",
      "IPv4",
      "IPv4",
      "IPv4",
      "IPv4",
      "IPv4",
      "IPv4",
      "IPv4",
      "IPv4",
      "ipv4"
    ],
    ipv6: [
      "IPv6",
      "IPv6",
      "IPv6",
      "IPv6",
      "IPv6",
      "IPv6",
      "IPv6",
      "IPv6",
      "IPv6",
      "IPv6",
      "IPv6",
      "ipv6"
    ],
    wiremapcustomcables: [
      "Wiremap Custom Cables",
      "Wiremap Custom Cables",
      "ワイヤーマップカスタムケーブル",
      "接线图定制电缆",
      "Verdrahtungsplan für kundenspez. Kabel",
      "Schéma de câblage des câbles personnalisés",
      "Cavi personalizzati mappatura fili",
      "Cabos personalizados para mapa de fios",
      "Cables personalizados del Mapeado de Hilos",
      "Разводка пользовательских кабелей",
      "Niestandardowa Mapa Okablowania",
      "wiremapcustomcables"
    ],
    configured_tests: [
      "Configured tests:",
      "Configured tests:",
      "構成されたテスト：",
      "配置的测试:",
      "Konfigurierte Tests:",
      "Tests configurés :",
      "Test configurati:",
      "Testes configurados:",
      "Pruebas configuradas:",
      "Настроенные тесты:",
      "Konfigurowane testy:",
      "configured_tests"
    ],
    highvoltagealarm: [
      "HIGH VOLTAGE ALARM",
      "HIGH VOLTAGE ALARM",
      "高電圧警報",
      "高电压告警",
      "HOCHSPANNUNGSALARM",
      "ALARME HAUTE TENSION",
      "ALLARME ALTA TENSIONE",
      "ALARME DE ALTA TENSÃO",
      "ALARMA ALTO VOLTAJE",
      "СИГНАЛИЗАЦИЯ ВЫСОКОГО НАПРЯЖЕНИЯ",
      "ALARM WYSOKIEGO NAPIĘCIA",
      "highvoltagealarm"
    ],
    unknownvoltagedetected: [
      "UNKNOWN VOLTAGE DETECTED",
      "UNKNOWN VOLTAGE DETECTED",
      "不明な電圧を検出",
      "检测到未知电压",
      "UNBEKANNTE SPANNUNG ERKANNT",
      "TENSION INCUNUE DÉTECTÉE",
      "RILEVATA TENSIONE SCONOSCIUTA",
      "TENSÃO DESCONHECIDA DETECTADA",
      "VOLTAJE DESCONOCIDO DETECTADO",
      "ОБНАРУЖЕНО НЕИЗВЕСТНОЕ НАПРЯЖЕНИЕ",
      "WYKRYTE NIEZNANE NAPIĘCIE",
      "unknownvoltagedetected"
    ],
    poevoltagedetected: [
      "PoE VOLTAGE DETECTED",
      "PoE VOLTAGE DETECTED",
      "PoE電圧を検出",
      "检测到PoE电压",
      "PoE SPANNUNG ERKANNT",
      "TENSION PoE DÉTECTÉE",
      "RILEVATA TENSIONE PoE",
      "TENSÃO POE DETECTADA",
      "VOLTAJE PoE DETECTADO",
      "ОБНАРУЖЕНО НАПРЯЖЕНИЕ PoE",
      "WYKRYTE NAPIĘCIE PoE",
      "poevoltagedetected"
    ],
    isdnvoltagedetected: [
      "ISDN VOLTAGE DETECTED",
      "ISDN VOLTAGE DETECTED",
      "ISDN電圧を検出",
      "检测到ISDN电压",
      "ISDN SPANNUNG ERKANNT",
      "TENSION RNIS DÉTECTÉE",
      "RILEVATA TENSIONE ISDN",
      "TENSÃO ISDN DETECTADA",
      "VOLTAJE ISDN DETECTADO",
      "ОБНАРУЖЕНО НАПРЯЖЕНИЕ",
      "ISDN	WYKRYTE NAPIĘCIE ISDN",
      "isdnvoltagedetected"
    ],
    pbxvoltagedetected: [
      "PBX VOLTAGE DETECTED",
      "PBX VOLTAGE DETECTED",
      "PBX電圧を検出",
      "检测到PBX电压",
      "PBX SPANNUNG ERKANNT",
      "TENSION PABX DÉTECTÉE",
      "RILEVATA TENSIONE PBX",
      "TENSÃO DE TELEFONIA DETECTADA",
      "VOLTAJE PBX DETECTADO",
      "ОБНАРУЖЕНО НАПРЯЖЕНИЕ АТС",
      "WYKRYTE NAPIĘCIE PBX",
      "pbxvoltagedetected"
    ],
    piv6_scan_enabled: [
      "IPv6 Scan Enabled",
      "IPv6 Scan Enabled",
      "IPv6スキャンが有効",
      "启动IPv6扫描",
      "IPv6 Scan aktiviert",
      "Scan IPv6 activé",
      "Scansione IPV6 Abilitata",
      "Varredura IPv6 Habilitada",
      "Escaneo IPv6 habilitado",
      "Сканирование IPv6 вкл.",
      "Włączone skanowanie IPv6",
      "piv6_scan_enabled"
    ],
    min_pin_pair_selected_validation: [
      "Minimum one pair required",
      "Minimum one pair required",
      "少なくとも1つのペアが必要です",
      "最小需要一对线",
      "Mindestens ein Paar erforderlich",
      "Une paire requise minimum",
      "È richiesta almeno una copia",
      "Mínimo um par exigido",
      "Mínimo un par requerido",
      "Требуется минимум одна пара",
      "Wymagana minimum jedna para",
      "min_pin_pair_selected_validation"
    ],
    poe_subtest_info: [
      "Auto maximum PoE load test standards are used to check the compliance on one of the following PoE standards:",
      "Auto maximum PoE load test standards are used to check the compliance on one of the following PoE standards:",
      "自動最大PoE負荷テスト規格は、次のPoE規格のいずれかへの準拠を確認するために使用されます。",
      "自动最大PoE负载测试标准用于检查是否符合以下PoE标准之一：",
      "Automatische maximale PoE-Lastteststandards werden verwendet, um die Konformität mit einem der folgenden PoE-Standards zu überprüfen:",
      "Les normes PoE de détection maximale sont utilisées pour vérifier la conformité avec un des standards PoE suivants :",
      "Gli standard di test di carico PoE massimo automatico sono usati per verificare la conformità a uno dei seguenti standard PoE:",
      "Os padrões automáticos de teste de carga PoE são usados para verificar a conformidade com um dos seguintes padrões PoE:",
      "Se utilizan Estándares de prueba Automática de carga máxima de PoE para verificar cumplimiento de los siguientes Estándares PoE:",
      "Требования максимального нагрузочного автотеста PoE используются для проверки соответствия стандартам PoE:",
      "Automatyczne normy badania obciążenia maksymalnego PoE są wykorzystywane do sprawdzania zgodności z jednym z poniższych norm PoE:",
      "poe_subtest_info"
    ],
    poe_standard_ieee_af: [
      "IEEE802.3af(max 15.4W PoE)",
      "IEEE802.3af(max 15.4W PoE)",
      "IEEE802.3af(最大 15.4W PoE)",
      "IEEE802.3af(最大 15.4W PoE)",
      "IEEE802.3af(max 15.4W PoE)",
      "IEEE802.3af (max 15.4W PoE)",
      "IEEE802.3af(max 15.4W PoE)",
      "IEEE802.3af (máx 15,4W/PoE)",
      "IEEE802.3af(max 15.4W PoE)",
      "IEEE802. 3af (макс 15,4 Вт PoE)",
      "IEEE802.3af(max 15.4W PoE)",
      "poe_standard_ieee_af"
    ],
    poe_standard_ieee_at: [
      "IEEE802.3at(max 30W PoE +)",
      "IEEE802.3at(max 30W PoE +)",
      "IEEE802.3at(最大 30W PoE +)",
      "IEEE802.3at(最大  30W PoE +)",
      "IEEE802.3at(max 30W PoE +)",
      "IEEE802.3at (max 30W PoE +)",
      "IEEE802.3at(max 30W PoE +)",
      "IEEE802.3at(máx 30W/PoE+)",
      "IEEE802.3at(max 30W PoE +)",
      "IEEE802. 3at (макс 30 Вт PoE +)",
      "IEEE802.3at(max 30W PoE +)",
      "poe_standard_ieee_at"
    ],
    poe_standard_ieee_bt: [
      "IEEE802.3bt(max 90W PoE++)",
      "IEEE802.3bt(max 90W PoE++)",
      "IEEE802.3bt(最大  90W PoE++)",
      "IEEE802.3bt(最大  90W PoE++)",
      "IEEE802.3bt(max 90W PoE++)",
      "IEEE802.3bt (max 90W PoE++)",
      "IEEE802.3bt(max 90W PoE++)",
      "IEEE802.3bt(máx 90W/PoE++)",
      "IEEE802.3bt(max 90W PoE++)",
      "IEEE802.3bt(макс 90 Вт Рое++)",
      "IEEE802.3bt(max 90W PoE++)",
      "poe_standard_ieee_bt"
    ],
    test_standard: [
      "Test Standard",
      "Test Standard",
      "試験基準",
      "测试标准",
      "Test Standard",
      "Norme du test",
      "Standard di Test",
      "Padrão do Teste",
      "Estándar de prueba",
      "Стандарт теста",
      "Standard testowy",
      "test_standard"
    ],
    test_standard_custom: [
      "Custom",
      "Custom",
      "カスタム",
      "特定",
      "Benutzerdefiniert",
      "Personnalisé",
      "Personalizzato",
      "Personalizado",
      "Customizar",
      "Заказ",
      "Niestandardowy",
      "test_standard_custom"
    ],
    indicates_quick_test: [
      "* indicates quick test",
      "* indicates quick test",
      "*クイックテストを示します",
      "* 快速测试指示",
      "* zeigt einen Schnelltest an",
      "* indique un Test Rapide",
      "* indica test veloce",
      "* indica teste rápido",
      "* Indica prueba rápida",
      "* указывает на быстрый тест",
      "* wskazuje na szybki test",
      "*indicates_quick_test"
    ],
    test_mixed_identifiers_cannot_edit: [
      "Selected tests include identifiers that span multiple levels and cannot be edited. Select a range of tests that have identical identifiers (same level) to allow group editing.",
      "Selected tests include identifiers that span multiple levels and cannot be edited. Select a range of tests that have identical identifiers (same level) to allow group editing.",
      "選択したテストには複数のレベルにまたがる識別子が含まれているため編集できません。グループ編集を許可するには、同一の識別子（同じレベル）を持つテスト範囲を選択してください。",
      "所选测试包含跨多个级别的标识符，无法编辑。请选择具有相同标识符（同一级别）的测试范围以允许批量编辑。",
      "Die ausgewählten Tests enthalten Kennungen über mehrere Ebenen und können nicht bearbeitet werden. Wählen Sie einen Testbereich mit identischen Kennungen (gleiche Ebene), um die Gruppenbearbeitung zu ermöglichen.",
      "Les tests sélectionnés contiennent des identifiants répartis sur plusieurs niveaux et ne peuvent pas être modifiés. Sélectionnez une plage de tests avec des identifiants identiques (même niveau) pour autoriser la modification groupée.",
      "I test selezionati includono identificatori su più livelli e non possono essere modificati. Selezionare un intervallo di test con identificatori identici (stesso livello) per consentire la modifica di gruppo.",
      "Os testes selecionados incluem identificadores que abrangem vários níveis e não podem ser editados. Selecione um intervalo de testes com identificadores idênticos (mesmo nível) para permitir a edição em grupo.",
      "Las pruebas seleccionadas incluyen identificadores que abarcan varios niveles y no se pueden editar. Seleccione un rango de pruebas con identificadores idénticos (mismo nivel) para permitir la edición en grupo.",
      "Выбранные тесты содержат идентификаторы на нескольких уровнях и не могут быть отредактированы. Выберите диапазон тестов с одинаковыми идентификаторами (один уровень), чтобы разрешить групповое редактирование.",
      "Wybrane testy zawierają identyfikatory obejmujące wiele poziomów i nie można ich edytować. Wybierz zakres testów z identycznymi identyfikatorami (ten sam poziom), aby umożliwić edycję grupową.",
      "test_mixed_identifiers_cannot_edit"
    ],
    result_macadd_mr: [
      " (MAIN - REMOTE)",
      " (MAIN - REMOTE)",
      " (MAIN - REMOTE)",
      " (MAIN - REMOTE)",
      " (MAIN - REMOTE)",
      " (MAIN - REMOTE)",
      " (MAIN - REMOTE)",
      " (MAIN - REMOTE)",
      " (MAIN - REMOTE)",
      " (MAIN - REMOTE)",
      " (MAIN - REMOTE)",
      "result_macadd_mr"
    ],
    result_wavelength: [
      "Wavelength",
      "Wavelength",
      "Wavelength",
      "Wavelength",
      "Wavelength",
      "Wavelength",
      "Wavelength",
      "Wavelength",
      "Wavelength",
      "Wavelength",
      "Wavelength",
      "result_wavelength"
    ],
    copper: [
      "Copper",
      "Copper",
      "銅線",
      "铜",
      "Kupfer",
      "Cuivre",
      "Rame",
      "Cobre",
      "Cobre",
      "Медь",
      "Miedź",
      "copper"
    ],
    fiber: [
      "Fibre",
      "Fiber",
      "ファイバー",
      "光纤",
      "Faser",
      "Fibre",
      "Fibra",
      "Fibra",
      "Fibra",
      "Волокно",
      "Włókno",
      "fiber"
    ],
    tests_delete_choice_text: [
      "You have selected <b>${number}</b> test(s)",
      "You have selected <b>${number}</b> test(s)",
      "選択しました <b>${number}</b> test(s)",
      "您已选择 <b>${number}</b> test(s)",
      "Es wurde ausgewählt",
      "Vous avez sélectionné <b>${number}</b> test(s)",
      "Hai selezionato <b> ${number} </b> test",
      "Você selecionou <b>${number}</b> testes",
      "Ha seleccionado <b>${número}</b> prueba(s)",
      "Вы выбрали <b>${number}< / b> test (s)",
      "Wybrałeś <b>${number}</b> test(y)",
      "tests_delete_choice_text"
    ],
    tests_delete_subtest_confirm: [
      "Delete Only Specific Subtests",
      "Delete Only Specific Subtests",
      "特定のサブテストのみを削除",
      "仅删除特定子测试",
      "Nur bestimmte Untertests löschen",
      "Effacer uniquement certains tests",
      "Elimina solo sottotest specifici",
      "Excluir Somente Subtestes Específicos",
      "Elimine solo Sub-pruebas específicas",
      "Удалить только определенные подтесты",
      "Usuń tylko niektóre pod-testy",
      "tests_delete_subtest_confirm"
    ],
    delete_specific_subtests: [
      "Delete Specific Subtests",
      "Delete Specific Subtests",
      "特定のサブテストを削除",
      "删除特定子测试",
      "Löschen von bestimmten Untertests",
      "Effacer les tests",
      "Elimina sottotest specifici",
      "Excluir Subtestes Específicos",
      "Elimine Sub-pruebas específicas",
      "Удалить определенные подтесты",
      "Skreślić Pod-testy specjalne",
      "delete_specific_subtests"
    ],
    select_subtests_delete: [
      "Select the subtests to delete",
      "Select the subtests to delete",
      "削除するサブテストを選択",
      "删除所选子测试",
      "Auswahl von Untertests zum löschen",
      "Sélectionner les tests à effacer",
      "Seleziona i sottotest da eliminare",
      "Selecione os subtestes para excluir",
      "Seleccione las Sub-pruebas a eliminar",
      "Выберите подтесты для удаления",
      "Wybierz podtesty do usunięcia",
      "select_subtests_delete"
    ],
    subtests_delete_confirm_text: [
      "Are you sure you want to delete selected subtests?",
      "Are you sure you want to delete selected subtests?",
      "選択したサブテストを削除しますか?",
      "请确定您是否要删除所选子测试？",
      "Sollen die ausgewählten Untertests wirklich gelöscht werden ?",
      "Etes-vous certain de vouloir supprimer les tests sélectionnés ?",
      "Eliminare i test secondario selezionati?",
      "Você tem certeza de que quer excluir os subtestes selecionados?",
      "Esta seguro que desea eliminar las Sub-pruebas seleccionadas ?",
      "Вы уверены, что хотите удалить выбранные подтесты?",
      "Czy na pewno chcesz usunąć wybrane podtesty",
      "subtests_delete_confirm_text"
    ],
    settings_version_number: [
      "Version:",
      "Version:",
      "バージョン:",
      "版本:",
      "Version:",
      "Version:",
      "Versione:",
      "Versão:",
      "Version:",
      "Версия:",
      "Wersja:",
      "settings_version_number"
    ],
    create_comet_coax: [
      "LanTEK IV Coax",
      "LanTEK IV Coax",
      "ランテックIV同軸",
      "LanTEK IV 同轴",
      "LanTEK IV Koaxial",
      "LanTEK IV Coaxial",
      "LanTEK IV Coassiale",
      "LanTEK IV Coaxial",
      "LanTEK IV Coax",
      "LanTEK IV коакс.",
      "LanTEK IV Coax",
      "create_comet_coax"
    ],
    survey_btn_text: [
      "Create your own user feedback survey",
      "Create your own user feedback survey",
      "自分のユーザーフィードバック測定を作成する",
      "创建您自己的用户反馈调查",
      "Erstellen Sie Ihre eigene Benutzer-Feedback-Umfrage",
      "Crééer votre propre enquète",
      "Crea il tuo sondaggio sul resoconto degli utenti",
      "Crie sua própria pesquisa de opinião de usuário",
      "Cree su propia encuesta de opinión",
      "Создайте опрос пользователей",
      "Stwórz własną ankietę opinii użytkowników",
      "survey_btn_text"
    ],
    sequential_test_ids: [
      "Sequential Test IDs",
      "Sequential Test IDs",
      "シーケンシャルテストID",
      "顺序测试ID",
      "Sequenzielle Test-IDs",
      "ID des tests séquentiels",
      "ID di prova sequenziali",
      "IDs Sequenciais",
      "ID de pruebas secuenciales",
      "Последовательные ID тестов",
      "Identyfikatory testów sekwencyjnych",
      "sequential_test_ids"
    ],
    import_test_ids: [
      "Import Test IDs",
      "Import Test IDs",
      "テストIDのインポート",
      "导入测试ID",
      "Test-IDs importieren",
      "Importer les ID de test",
      "Importa ID di prova",
      "Importar IDs de Teste",
      "Importar ID de pruebas",
      "Импортировать ID тестов",
      "Importuj identyfikatory testów",
      "import_test_ids"
    ],
    test_ids_tooltip_1: [
      "Up to 2500 test IDs may be imported.",
      "Up to 2500 test IDs may be imported.",
      "最大2500個のテストIDをインポートできます。",
      "最多可以导入2500个测试ID。",
      "Bis zu 2500 Test-IDs können importiert werden",
      "Vous pouvez importer jusqu'à 2500 ID de test.",
      "È possibile importare fino a 2.500 ID di prova",
      "Até 2.500 IDs podem ser importados.",
      "Se pueden importar hasta 2500 ID de pruebas.",
      "Можно импортировать до 2500 ID тестов.",
      "Można zaimportować do 2500 identyfikatorów testów.",
      "test_ids_tooltip_1"
    ],
    test_ids_tooltip_2: [
      "Test ID name length must be no more than 40 characters.",
      "Test ID name length must be no more than 40 characters.",
      "テストID名の長さは40文字を超えてはいけません。",
      "测试ID名称长度不得超过40个字符。",
      "Die Länge der Test-ID darf höchstens 40 Zeichen betragen",
      "La longeur de l'ID de test ne doit pas dépasser 40 caractères.",
      "Il nome dell’ID di prova non deve contenere più di 40 caratteri",
      "O ID de teste não pode ter mais de 40 caracteres.",
      "La longitud del nombre del ID de prueba no debe superar los 40 caracteres.",
      "Длина названия ID теста не должна превышать 40 символа.",
      "Długość nazwy identyfikatora testu nie może przekraczać 40 znaków.",
      "test_ids_tooltip_2"
    ],
    test_ids_tooltip_3: [
      "The characters allowed are: a-z A-Z 0-9 - . ~ $ £ ” ( ) +_",
      "The characters allowed are: a-z A-Z 0-9 - . ~ $ £ ” ( ) +_",
      "次の文字を使用できます： a-z A-Z 0-9 - .  ~ $ £ ” ( ) + _ ",
      "允许使用的字符有:a-z A-Z 0-9 - . ~ $ £ ” ( ) +_",
      "Die erlaubten Zeichen sind: a-z A-Z 0-9 - . ~ $ £ ” ( ) +_",
      "Les caractères autorisés sont : a-z A-Z 0-9 - . ~ $ £ ” ( ) +_",
      "I caratteri consentiti sono: a-z A-Z 0-9 - . ~ $ £ ” ( ) +_",
      "Os caracteres permitidos são: a-z A-Z 0-9 -. ~ $ £ ” ( ) +_",
      "Los caracteres permitidos son: a-z A-Z 0-9 - . ~ $ £ ” ( ) +_",
      "Разрешенные символы: a-z A-Z 0-9 - . ~ $ £ ” ( ) +_",
      "Dozwolone znaki to: a-z A-Z 0-9 -. ~ $ £ ” ( ) +_",
      "test_ids_tooltip_3"
    ],
    import_test_ids_invalid_header: [
      "Error in importing Test IDs",
      "Error in importing Test IDs",
      "テストIDのインポートエラー",
      "导入测试ID时出错",
      "Fehler beim Importieren der Test-IDs",
      "Erreur dans l'importation des ID de test",
      "Errore durante l’importazione delle ID di prova",
      "Erro ao importar IDs de teste",
      "Error al importar los ID de prueba",
      "Ошибка импорта ID тестов",
      "Błąd w importowaniu identyfikatorów testów",
      "import_test_ids_invalid_header"
    ],
    import_test_ids_invalid_char: [
      "Invalid characters in Test ID",
      "Invalid characters in Test ID",
      "テストIDに無効な文字が含まれます",
      "测试ID中含有无效字符",
      "Ungültige Zeichen in der Test-ID",
      "Caractères non valides dans l'ID de test",
      "Caratteri dell’ID di prova non validi",
      "Caracteres inválidos no ID de teste",
      "Caracteres no válidos en el ID de prueba",
      "Недопустимые символы в ID теста",
      "Nieprawidłowe znaki w identyfikatorze testu",
      "import_test_ids_invalid_char"
    ],
    import_test_ids_invalid_length: [
      "Test ID exceeds maximum length",
      "Test ID exceeds maximum length",
      "テストIDが最大文字数を超えています",
      "测试ID超过最长字符限制",
      "Test-ID übersteigt die maximal zulässige Länge",
      "L'ID de test dépasse la longueur maximale",
      "L’ID di prova supera la lunghezza massima",
      "O ID de teste excede o comprimento máximo",
      "El ID de prueba excede el número máximo de caracteres",
      "ID теста превышает макс. длину",
      "Identyfikator testu przekracza maksymalną długość",
      "import_test_ids_invalid_length"
    ],
    import_test_ids_invalid_numbers: [
      "Too many test to import",
      "Too many test to import",
      "インポートするテストが多すぎます",
      "测试过多，无法导入",
      "Zu viele Tests zum importieren",
      "Trop de tests à importer",
      "Troppi test da importare",
      "Há testes demais para importar",
      "Hay demasiadas pruebas para importar",
      "Слишком много тестов для импорта",
      "Za dużo testów do zaimportowania",
      "import_test_ids_invalid_numbers"
    ],
    import_test_ids_invalid_type: [
      "Invalid file type uploaded",
      "Invalid file type uploaded",
      "アップロードされたファイルタイプが無効です",
      "上传的文件类型无效",
      "Ungültiger Dateityp wurde hochgeladen",
      "Type de fichier non valide chargé",
      "Si è caricato un tipo di file non valido",
      "Tipo de arquivo inválido carregado",
      "El tipo de archivo cargado no es válido",
      "Выгружен недопустимый тип файла",
      "Przesłano nieprawidłowy typ pliku",
      "import_test_ids_invalid_type"
    ],
    import_test_ids_required: [
      "Import Test IDs is required",
      "Import Test IDs is required",
      "テストIDのインポートが必要です",
      "需要导入测试ID",
      "Importieren von Test-IDs ist erforderlich",
      "L'importation des ID de test est requise",
      "È necessario importare le ID di prova",
      "A importação de IDs de teste é exigida",
      "Es necesario importar los ID de prueba",
      "Необходимо импортировать ID тестов",
      "Wymagany import identyfikatorów testów",
      "import_test_ids_required"
    ],
    import_test_ids_limit_exceeded: [
      "Total exceeds 2000. Please reduce test range.",
      "Total exceeds 2000. Please reduce test range.",
      "合計が2000を超えています。テスト範囲を減らしてください。",
      "总数超过2000。请减少测试范围。",
      "Die Gesamtzahl übersteigt 2000. Bitte reduzieren Sie den Testbereich.",
      "Le total dépasse 2000. Veuillez réduire la plage de tests.",
      "Il totale supera i 2000. Si prega di ridurre l'intervallo di test.",
      "O total excede 2000. Reduza a faixa de testes.",
      "El total supera 2000. Reduzca el rango de pruebas.",
      "Общая сумма превышает 2000. Пожалуйста, уменьшите диапазон теста.",
      "Całkowita liczba przekracza 2000. Proszę zmniejszyć zakres testu."
    ],
    report_delete_confirm_text2: [
      "Are you sure you want to delete selected <b>${name}</b> report(s)?",
      "Are you sure you want to delete selected <b>${name}</b> report(s)?",
      "選択した<b>${name}</b>レポートを削除してもよろしいですか?",
      "您确定要删除所选择的<b>${name}</b> 报告吗？",
      "Sind Sie sicher, dass Sie die(den) markierte(n) <b>${name}</b> Bericht(e) löschen möchten?",
      "Voulez-vous vraiment supprimer le (les) rapport(s) <b>${name}</b> sélectionné(s) ?",
      "Vuoi davvero cancellare il(i) report <b>${name}</b> selezionato(i)?",
      "Tem certeza de que deseja excluir o(s) relatório(s)  <b>${name}</b> selecionado(s)?",
      "¿Seguro que desea eliminar el/los informe/s <b>${name}</b> seleccionado/s?",
      "Вы уверены, что хотите удалить выбранный(е) отчет(ы) <b>${name}</b>?",
      "Czy na pewno chcesz usunąć wybrane <b>${name}</b>raport(y)?",
      "report_delete_confirm_text2"
    ],
    report_email_confirm_title: [
      "Email Report",
      "Email Report",
      "レポートをメール送信",
      "通过邮件发送报告",
      "E-Mail Bericht",
      "Envoyer par email le rapport",
      "Report e-mail	Enviar relatório por e-mail	",
      "Informe de correo electrónico",
      "Отправить отчет на эл. почту",
      "Raport e-mailowy",
      "report_email_confirm_title"
    ],
    report_email_confirm_text: [
      "One or more of the reports you have selected failed to generate, therefore it will not be included in your email ",
      "One or more of the reports you have selected failed to generate, therefore it will not be included in your email ",
      "1つ以上の選択したレポートの生成に失敗しました。それらのレポートは電子メールには含まれません",
      "您选择的一个或多个报告无法生成，因此这个（些）不会包含在您的电子邮件中",
      "Ein oder mehrere der Berichte, die von Ihnen ausgewählt wurden, konnte nicht erzeugt werden und werden daher nicht in Ihrer E-Mail enthalten sein",
      "Un ou plusieurs rapports que vous avez sélectionnés n'ont pu être générés ; ils ne seront pas inclus dans votre e-mail",
      "Non è stato possibile generare uno o più dei report selezionati. Quindi non saranno allegati all’e-mail.",
      "A geração de um ou mais relatórios selecionados falhou, portanto não serão incluídos no seu e-mail",
      "Se ha producido un fallo al generar uno o más de los informes seleccionados, por lo que no se incluirá en tu mensaje de correo electrónico",
      "Один или более выбранных вами отчетов не сформировались, поэтому они не будут включены в ваше эл. письмо",
      "Nie udało się wygenerować jednego lub więcej z wybranych raportów, dlatego nie zostanie on dołączony do wiadomości e-mail",
      "report_email_confirm_text"
    ],
    select_spreadsheet_to_import: [
      "Select spreadsheet to import (.csv, .xlsx)",
      "Select spreadsheet to import (.csv, .xlsx)",
      "インポートするスプレッドシートを選択 (.csv, .xlsx)",
      "选择要导入的电子表格（.csv，.xlsx）",
      "Tabellenkalkulation zum Importieren auswählen (.csv, .xlsx)",
      "Sélectionnez la feuille de calcul à importer (.csv, .xlsx)",
      "Selezionare il foglio di lavoro da importare (.csv, .xlsx)",
      "Selecione a planilha para importar (.csv, .xlsx)",
      "Seleccionar hoja de cálculo para importar (.csv, .xlsx)",
      "Выберите таблицу для импорта (.csv, .xlsx)",
      "Wybierz arkusz kalkulacyjny do zaimportowania (.csv, .xlsx)",
      "select_spreadsheet_to_import"
    ],
    test_ids_tooltip_4: [
      "Imports from column A of Excel files",
      "Imports from column A of Excel files",
      "ExcelファイルのA列からインポートします",
      "从Excel文件的A列导入",
      "Import aus Spalte A von Excel-Dateien",
      "Importations depuis la colonne A des fichiers Excel",
      "Dati importati dalla colonna A dei file Excel",
      "Importa a coluna A de arquivos Excel",
      "Importa a partir de la columna A de los archivos de Excel",
      "Импорт из столбца A файлов Excel",
      "Import z kolumny A plików Excel",
      "test_ids_tooltip_4"
    ],

    organisation_wiremap_display_pref: [
      "LanTEK Wiremap Display Preference",
      "LanTEK Wiremap Display Preference",
      "LanTEKワイヤーマップディスプレイ設定",
      "LanTEK接线图显示首选项",
      "LanTEK Wiremap Anzeigepräferenz",
      "Préférence d'affichage du schéma de câblage du LanTEK",
      "Preferenza LanTEK Wiremap Display",
      "Preferência de exibição do mapa de fios do LanTEK",
      "Preferencias de visualización de mapa de cableado LanTEK",
      "Предпочтения отображения схемы разводки кабелей LanTEK",
      "Preferencje wyświetlania Mapy Połączeń LanTEK",
      "organisation_wiremap_display_pref"
    ],
    organisation_wiremap_display_pref_help: [
      "Please select wiremap display preference",
      "Please select wiremap display preference",
      "ワイヤーマップディスプレイ設定を選択してください",
      "请选择接线图显示首选项",
      "Bitte wählen Sie Ihre Wiremap Anzeigepräferenz",
      "Sélectionnez la préférence d'affichage du schéma de câblage",
      "Selezionare la preferenza wiremap display",
      "Selecione o padrão preferido",
      "Selecciona las preferencias de visualización de mapa de cableado",
      "Выберите предпочтения отображения схемы разводки кабелей",
      "Wybierz preferencje wyświetlania mapy połączeń",
      "organisation_wiremap_display_pref_help"
    ],
    report_type_standard: [
      "Standard",
      "Standard",
      "標準",
      "标准",
      "Standard",
      "Norme",
      "Standard",
      "Padrão",
      "Estándar",
      "Стандарт",
      "Standardowy",
      "report_type_standard"
    ],
    generate_report_type_standard: [
      "Standard Report",
      "Standard Report",
      "標準レポート",
      "标准报告",
      "Standardbericht",
      "Rapport norme",
      "Report standard",
      "Relatório Padrão",
      "Informe estándar",
      "Стандартный отчет",
      "Raport standardowy",
      "generate_report_type_standard"
    ],

    generate_report_include_margin: [
      "Display Margin",
      "Display Margin",
      "マージンの表示",
      "显示余量",
      "Anzeige Reserve",
      "Afficher la marge",
      "Margine display",
      "Mostrar Margem",
      "Mostrar margen",
      "Показать запас",
      "Wyświetl margines",
      "generate_report_include_margin"
    ],
    report_next: [
      "NEXT Margin",
      "NEXT Margin",
      "NEXTマージン",
      "NEXT 余量",
      "NEXT Reserve",
      "Marge NEXT",
      "Margine NEXT",
      "Margem NEXT",
      "Margen NEXT",
      "Запас NEXT",
      "Margines NEXT",
      "report_next"
    ],
    report_il: [
      "IL Margin",
      "IL Margin",
      "ILマージン",
      "IL 余量",
      "IL Reserve",
      "Marge IL",
      "Margine IL",
      "Margem IL",
      "Margen IL",
      "Запас вносимых потерь (IL)",
      "Margines IL",
      "report_il"
    ],
    report_psnext: [
      "PSNEXT Margin",
      "PSNEXT Margin",
      "PSNEXTマージン",
      "PSNEXT 余量",
      "PSNEXT Reserve",
      "Marge PSNEXT",
      "Margine PSNEXT",
      "Margem PSNEXT",
      "Margen PSNEXT",
      "Запас PSNEXT",
      "Margines PSNEXT",
      "report_psnext"
    ],
    report_acrn: [
      "ACRN Margin",
      "ACRN Margin",
      "ACRNマージン",
      "ACRN 余量",
      "ACRN Reserve",
      "Marge ACRN",
      "Margine ACRN",
      "Margem ACRN",
      "Margen ACRN",
      "Запас ACRN",
      "Margines ACRN",
      "report_acrn"
    ],

    multiple_pdf_checkbox: [
      "Create separate .pdf file for each test result",
      "Create separate .pdf file for each test result",
      "テスト結果ごとに個別のPDFファイルを作成する",
      "为每个测试结果创建单独的.pdf文件",
      "Separate .pdf-Datei für jedes Testergebnis erstellen",
      "Créer un fichier .pdf séparé pour chaque résultat de test",
      "Crea un file .pdf separato per ogni risultato del test",
      "Criar arquivos pdf separados para cada teste",
      "Crear archivo .pdf separado para cada resultado de prueba",
      "Создать отдельный файл .pdf для каждого результата теста",
      "Utwórz osobny plik .pdf dla każdego wyniku testu",
      "multiple_pdf_checkbox"
    ],
    customer_state_county_help2: [
      "Please select the state / county",
      "Please select the state / county",
      "都道府県を入力してください",
      "请选择州/县",
      "Bitte wählen Sie das Bundesland / den Bezirk",
      "Sélectionnez l'état/le département",
      "Seleziona lo Stato / il Paese",
      "Selecione o estado / região",
      "Selecciona el estado / provincia",
      "Выберите штат / округ",
      "Wybierz stan / hrabstwo",
      "customer_state_county_help2"
    ],
    report_rtnloss: [
      "Return Loss Margin",
      "Return Loss Margin",
      "反射損失マージン",
      "回波损耗余量",
      "RL-Reserve",
      "Marge de la perte par retour",
      "Margine di perdita del ritorno",
      "Margem de Perda de Retorno",
      "Margen Pérdida Retorno",
      "Запас обратных потерь",
      "Margines straty powrotu",
      "report_rtnloss"
    ],
    logo_upload_type_validation: [
      "Upload failed. Unsupported file type.",
      "Upload failed. Unsupported file type.",
      "アップロードに失敗しました。サポートされていないファイル タイプです。",
      "上传失败。不支持的文件类型。",
      "Upload fehlgeschlagen. Nicht unterstütztes Dateiformat.",
      "Le téléchargement a échoué. Type de fichier non pris en charge.",
      "Caricamento fallito. Tipo di file non supportato.",
      "O carregamento falhou. Tipo de arquivo não suportado.",
      "Subida fallida. Tipo de archivo no soportado.",
      "Загрузка не удалась. Неподдерживаемый тип файла.",
      "Przesyłanie nie powiodło się. Nieobsługiwany typ pliku.",
      "logo_upload_type_validation"
    ],
    logo_upload_char_validation: [
      "Upload failed. Unsupported character in file name.",
      "Upload failed. Unsupported character in file name.",
      "アップロードに失敗しました。ファイル名に使用できない文字が含まれています。",
      "上传失败。文件名中包含不支持的字符。",
      "Upload fehlgeschlagen. Nicht unterstütztes Zeichen im Dateinamen.",
      "Le téléchargement a échoué. Caractère non pris en charge dans le nom de fichier.",
      "Caricamento fallito. Carattere non supportato nel nome del file.",
      "O carregamento falhou. Caractere não suportado no nome do ficheiro.",
      "Subida fallida. Carácter no admitido en el nombre del archivo.",
      "Загрузка не удалась. Недопустимый символ в имени файла.",
      "Przesyłanie nie powiodło się. Niedozwolony znak w nazwie pliku.",
      "logo_upload_char_validation"
    ],
    logo_upload_size_validation: [
      "Upload failed. File size > 1 mb.",
      "Upload failed. File size > 1 mb.",
      "アップロードに失敗しました。 ファイルサイズ> 1mb。",
      "上传失败。 文件大小 > 1 mb。",
      "Upload fehlgeschlagen. Dateigröße > 1 MB.",
      "Échec du téléchargement. Taille du fichier > 1 Mo.",
      "Caricamento fallito. Dimensione del file > 1 MB.",
      "Falha no upload. Tamanho do arquivo> 1 MB.",
      "Subida fallida. Tamaño de archivo> 1 mb.",
      "Загрузка не удалась. Размер файла> 1 мб.",
      "Przesyłanie nie powiodło się. Rozmiar pliku > 1 mb.",
      "logo_upload_size_validation"
    ],
    building: [
      "Building",
      "Building",
      "建物",
      "楼",
      "Gebäude",
      "Bâtiment",
      "Edificio",
      "Edifício",
      "Edificio",
      "Здание",
      "Budynek",
      "building"
    ],
    floor: [
      "Floor",
      "Floor",
      "フロア",
      "层",
      "Etage",
      "Niveau",
      "Piano",
      "Andar",
      "Piso",
      "Пол",
      "Piętro",
      "floor"
    ],
    room: [
      "Room",
      "Room",
      "部屋",
      "房间",
      "Raum",
      "Piece",
      "Stanza",
      "Sala",
      "Sala",
      "Номер",
      "Pokój",
      "room"
    ],
    rack: [
      "Rack",
      "Rack",
      "棚",
      "支架",
      "Rack",
      "Rack",
      "Scaffale",
      "Rack",
      "Rack",
      "Шкаф",
      "Szafa",
      "rack"
    ],
    panel: [
      "Panel",
      "Panel",
      "パネル",
      "面板",
      "Panel",
      "Panneau",
      "Pannello",
      "Painel",
      "Panel",
      "Панель",
      "Panel",
      "panel"
    ],
    rename: [
      "Rename",
      "Rename",
      "名前の変更",
      "重命名",
      "Umbenennen",
      "Renommer",
      "Rinomina",
      "Renomear",
      "Renombrar",
      "Переименовать",
      "Zmień nazwę",
      "rename"
    ],
    delete: [
      "Delete",
      "Delete",
      "削除",
      "删除",
      "Löschen",
      "Effacer",
      "Elimina",
      "Excluir",
      "Eliminar",
      "Удалить",
      "Usuń",
      "delete"
    ],
    lowerlevels: [
      "Include lower-level-records",
      "Include lower-level-records",
      "下位レベルのレコードを含む",
      "包括下级记录",
      "Untergeordnete Datensätze einbinden",
      "Inclure les enregistrements inférieurs",
      "Includere record di livello inferiore",
      "Incluir registros de nível inferior",
      "Incluir registros de nivel inferior",
      "Включить записи более низкого уровня",
      "Uwzględnij rekordy dolnego poziomu",
      "lowerlevels"
    ],
    newitem: [
      "Enter the name of the new item",
      "Enter the name of the new item",
      "新しいアイテム名を入力",
      "输入新项目的名称",
      "Geben Sie den Namen des neuen Elements ein",
      "Entrer le nom du nouvel élément",
      "Inserire il nome del nuovo elemento",
      "Informe o nome do novo item",
      "Introduzca el nombre del nuevo ítem",
      "Введите новое название элемента",
      "Wprowadź nazwę nowego elementu",
      "newitem"
    ],
    newname: [
      "Enter the new name",
      "Enter the new name",
      "新しい名前を入力",
      "输入新的名称",
      "Geben Sie den neuen Namen ein",
      "Entrer un nouveau nom",
      "Inserire il nuovo nome",
      "Informe o novo nome",
      "Introduzca el nuevo nombre",
      "Введите новое имя",
      "Wprowadź nową nazwę",
      "newname"
    ],
    deleteconfirmation: [
      "Are you sure you want to delete?",
      "Are you sure you want to delete?",
      "本当に削除してもよろしいですか？",
      "您确定要删除吗？",
      "Sind Sie sicher, dass Sie das löschen möchten?",
      "Etes-vous certain de vouloir effacer ?",
      "Sei sicuro di voler eliminare?",
      "Tem certeza de que quer excluir?",
      "¿Estás seguro de que quieres eliminar?",
      "Вы уверены, что хотите удалить?",
      "Czy na pewno chcesz usunąć?",
      "deleteconfirmation"
    ],
    archive: [
      "Archive",
      "Archive",
      "アーカイブ",
      "存档",
      "Archiv",
      "Archive",
      "Archivio",
      "Arquivar",
      "Archivar",
      "Archive",
      "Archiwum",
      "archive"
    ],
    properties: [
      "Properties",
      "Properties",
      "プロパティ",
      "属性",
      "Eigenschaften",
      "Propriétés",
      "Proprietà",
      "Propriedades",
      "Propiedades",
      "Properties",
      "Nieruchomości",
      "properties"
    ],
    del_records: [
      "Deleting records is permanent and cannot be undone",
      "Deleting records is permanent and cannot be undone",
      "一度記録を削除すると、元に戻すことはできません。",
      "删除记录是永久性的，无法撤消",
      "Das Löschen von Daten ist permanent und kann nicht rückgängig gemacht werden",
      "L’effacement des données sera définitif et il ne sera pas possible de revenir en arrière !",
      "L'eliminazione dei record è permanente e non può essere annullata",
      "A exclusão de registros é permanente e não pode ser desfeita",
      "La eliminación de registros es permanente y no se puede deshacer",
      "Deleting records is permanent and cannot be undone",
      "Usunięcie rekordów jest trwałe i nie można go cofnąć",
      "del_records"
    ],
    notes_for: [
      "Notes for",
      "Notes for",
      "注意事項",
      "注意事项",
      "Notizen für",
      "Notes pour",
      "Note per",
      "Observações para",
      "Notas para",
      "Notes for",
      "Uwagi dla",
      "notes_for"
    ],
    mobiletest_mode: [
      "Mode",
      "Mode",
      "モード",
      "模式",
      "Modus",
      "Mode",
      "Modalità",
      "Modo",
      "Modo",
      "Режим",
      "Tryb",
      "mobiletest_mode",
    ],
    mobiletest_linkpulse: [
      "Link Speed",
      "Link Speed",
      "リンク速度",
      "链接速度",
      "Link-Rate",
      "Vitesse du lien",
      "Velocità di collegamento",
      "Velocidade do Link",
      "Velocidad del vínculo",
      "Скорость канала",
      "Szybkość łącza",
      "mobiletest_linkpulse",
    ],
    mobiletest_poeclass: [
      "PoE Class",
      "PoE Class",
      "PoEクラス",
      "PoE级别",
      "PoE-Klasse",
      "Classe de la PoE",
      "Classe PoE",
      "Classe PoE",
      "Clase de PoE",
      "Класс PoE",
      "PoE Klasa",
      "mobiletest_poeclass",
    ],
    mobiletest_offloadvoltageinvolts: [
      "PoE Volts (Offload)",
      "PoE Volts (Offload)",
      "PoE ボルト (オフロード)",
      "PoE Volts (无负载)",
      "PoE Spannung (ohne Last)",
      "Tension du PoE en Volts (hors charge)",
      "Volt PoE (scarica)",
      "Volts PoE (sem carga)",
      "Voltios PoE (sin carga)",
      "PoE [В] (без нагрузки)",
      "PoE [V] (Bez obciążenia)",
      "mobiletest_offloadvoltageinvolts",
    ],
    mobiletest_poepowerinwatts: [
      "PoE Watts",
      "PoE Watts",
      "PoE ワット",
      "PoE 功率",
      "PoE Leistung",
      "Puissance PoE en Watts",
      "Watt PoE",
      "Watts PoE",
      "Vatios PoE",
      "PoE [Вт] (Мощность)",
      "PoE [W] (Moc)",
      "mobiletest_poepowerinwatts",
    ],
    mobiletest_onloadvoltageinvolts: [
      "PoE Volts (Onload)",
      "PoE Volts (Onload)",
      "PoE ボルト (オンロード)",
      "PoE 电压 (有负载)",
      "PoE Spannung (unter Last)",
      "Tension du PoE en Volts (en charge)",
      "Volt PoE (sotto carico)",
      "Volts PoE (com carga)",
      "Voltios PoE (en carga)",
      "PoE [В] (Под нагрузкой)",
      "PoE [V] (Obciążenie)",
      "mobiletest_onloadvoltageinvolts",
    ],
    mobiletest_cableinformation: [
      "Cable Information",
      "Cable Information",
      "ケーブル情報",
      "电缆信息",
      "Kabel Informationen",
      "Nom du câble",
      "Informazioni sui cavi",
      "Dados do Cabo",
      "Datos del Cable",
      "Информация о кабеле",
      "Informacje o kablu",
      "mobiletest_cableinformation",
    ],
    mobiletest_operatorname: [
      "Operator Name",
      "Operator Name",
      "オペレーター名",
      "操作人姓名",
      "Techniker Name",
      "Nom de l'opérateur",
      "Nome operatore",
      "Operador",
      "Operador",
      "Имя оператора",
      "Nazwa operatora",
      "mobiletest_operatorname",
    ],
    mobiletest_systemdevicetype: [
      "Device Type",
      "Device Type",
      "デバイスタイプ",
      "设备类型",
      "Gerätetyp",
      "Type d'appareil",
      "Tipo dispositivo",
      "Tipo de dispositivo",
      "Tipo equipo",
      "Тип устройства",
      "Typ urządzenia",
      "mobiletest_systemdevicetype"
    ],
    vdviipoepro: [
      "VDV II / PoE Pro",
      "VDV II / PoE Pro",
      "VDV II / PoE Pro",
      "VDV II / PoE Pro",
      "VDV II / PoE Pro",
      "VDV II / PoE Pro",
      "VDV II / PoE Pro",
      "VDV II / PoE Pro",
      "VDV II / PoE Pro",
      "VDV II / PoE Pro",
      "VDV II / PoE Pro",
      "vdviipoepro"
    ],
    "VDV II": [
      "VDV II",
      "VDV II",
      "VDV II",
      "VDV II",
      "VDV II",
      "VDV II",
      "VDV II",
      "VDV II",
      "VDV II",
      "VDV II",
      "VDV II",
      "VDV II"
    ],
    vdvii: [
      "VDV II",
      "VDV II",
      "VDV II",
      "VDV II",
      "VDV II",
      "VDV II",
      "VDV II",
      "VDV II",
      "VDV II",
      "VDV II",
      "VDV II",
      "vdvii"
    ],
    "VDV II Plus": [
      "VDV II Plus",
      "VDV II Plus",
      "VDV II Plus",
      "VDV II Plus",
      "VDV II Plus",
      "VDV II Plus",
      "VDV II Plus",
      "VDV II Plus",
      "VDV II Plus",
      "VDV II Plus",
      "VDV II Plus",
      "VDV II Plus"
    ],
    vdviiplus: [
      "VDV II Plus",
      "VDV II Plus",
      "VDV II Plus",
      "VDV II Plus",
      "VDV II Plus",
      "VDV II Plus",
      "VDV II Plus",
      "VDV II Plus",
      "VDV II Plus",
      "VDV II Plus",
      "VDV II Plus",
      "vdviiplus"
    ],
    "PoE PRO": [
      "PoE PRO",
      "PoE PRO",
      "PoE PRO",
      "PoE PRO",
      "PoE PRO",
      "PoE PRO",
      "PoE PRO",
      "PoE PRO",
      "PoE PRO",
      "PoE PRO",
      "PoE PRO",
      "PoE PRO"
    ],
    "VDV II Pro": [
      "VDV II Pro",
      "VDV II Pro",
      "VDV II Pro",
      "VDV II Pro",
      "VDV II Pro",
      "VDV II Pro",
      "VDV II Pro",
      "VDV II Pro",
      "VDV II Pro",
      "VDV II Pro",
      "VDV II Pro",
      "VDV II Pro"
    ],
    vdviipro: [
      "VDV II Pro",
      "VDV II Pro",
      "VDV II Pro",
      "VDV II Pro",
      "VDV II Pro",
      "VDV II Pro",
      "VDV II Pro",
      "VDV II Pro",
      "VDV II Pro",
      "VDV II Pro",
      "VDV II Pro",
      "vdviipro"
    ],
    poepro: [
      "PoE PRO",
      "PoE PRO",
      "PoE PRO",
      "PoE PRO",
      "PoE PRO",
      "PoE PRO",
      "PoE PRO",
      "PoE PRO",
      "PoE PRO",
      "PoE PRO",
      "PoE PRO",
      "poepro"
    ],
    poe_standard: [
      "Standard",
      "Standard",
      "標準",
      "标准",
      "Standard",
      "Standard",
      "Standard",
      "Norma",
      "Estándar",
      "Стандарт",
      "Standard",
      "poe_standard"
    ],
    voltage_load: [
      "Voltage (load)",
      "Voltage (load)",
      "電圧（負荷）",
      "电压 (有负载)",
      "PoE Spannung (unter Last)",
      "Tension (en charge)",
      "Tensione (carico)",
      "Tensão (com carga)",
      "Voltaje (en carga)",
      "Напряжение (под нагрузкой)",
      "Napięcie (obciążenie)",
      "voltage_load"
    ],
    voltage_offload: [
      "Voltage (off load)",
      "Voltage (off load)",
      "電圧（オフロード）",
      "电压 (无负载)",
      "PoE Spannung (ohne Last)",
      "Tension (hors charge)",
      "Tensione (a vuoto)",
      "Tensão (sem carga)",
      "Voltaje (sin carga)",
      "Напряжение (без нагрузки)",
      "Napięcie (bez obciążenia)",
      "voltage_offload"
    ],
    service_detected: [
      "Service Detected",
      "Service Detected",
      "サービスが検出されました",
      "检测业务",
      "Service Erkannt",
      "Service détecté",
      "Servizio rilevato",
      "Serviço Detectado",
      "Servicio Detectado",
      "Обнаруженная услуга",
      "Wykryta usługa",
      "service_detected"
    ],
    remote_id: [
      "Remote ID",
      "Remote ID",
      "リモート ID",
      "远端 ID",
      "Remote ID",
      "Identifiant unité distante",
      "ID remoto",
      "ID do Remoto",
      "ID Remoto",
      "Удаленный идентификатор",
      "Identyfikator zdalny",
      "remote_id"
    ],
    generate_report_type_mobile: [
      "VDV / PoE",
      "VDV / PoE",
      "VDV / PoE",
      "VDV / PoE",
      "VDV / PoE",
      "VDV / PoE",
      "VDV / PoE",
      "VDV / PoE",
      "VDV / PoE",
      "VDV / PoE",
      "VDV / PoE",
      "generate_report_type_mobile",
    ],
    report_type_mobile: [
      "VDV / PoE",
      "VDV / PoE",
      "VDV / PoE",
      "VDV / PoE",
      "VDV / PoE",
      "VDV / PoE",
      "VDV / PoE",
      "VDV / PoE",
      "VDV / PoE",
      "VDV / PoE",
      "VDV / PoE",
      "report_type_mobile",
    ],
    auto_refresh_enabled: [
      "Auto-Refresh Enabled",
      "Auto-Refresh Enabled",
      "自動更新有効",
      "启动自动刷新",
      "Auto-Refresh Aktiviert",
      "Auto-rafraichissement activé",
      "Abilitato Auto-Refresh",
      "Auto-Atualizar Habilitado",
      "Autorefresco hab.",
      "Автообновление включено",
      "Auto odświeżanie włączone",
      "Auto-Refresh Enabled",
    ],
    device_update_respositories: [
      "Device Update Repositories",
      "Device Update Repositories",
      "Device Update Repositories",
      "Device Update Repositories",
      "Device Update Repositories",
      "Device Update Repositories",
      "Device Update Repositories",
      "Device Update Repositories",
      "Device Update Repositories",
      "Device Update Repositories",
      "Device Update Repositories",
      "Device Update Repositories",
    ],
    device_update_releases: [
      "Device Update Releases",
      "Device Update Releases",
      "Device Update Releases",
      "Device Update Releases",
      "Device Update Releases",
      "Device Update Releases",
      "Device Update Releases",
      "Device Update Releases",
      "Device Update Releases",
      "Device Update Releases",
      "Device Update Releases",
      "Device Update Releases",
    ],
    device_repository_create_successfull_toast: [
      "Device update repository successfully created.",
      "Device update repository successfully created.",
      "Device update repository successfully created.",
      "Device update repository successfully created.",
      "Device update repository successfully created.",
      "Device update repository successfully created.",
      "Device update repository successfully created.",
      "Device update repository successfully created.",
      "Device update repository successfully created.",
      "Device update repository successfully created.",
      "Device update repository successfully created.",
      "device_repository_create_successfull_toast"
    ],
    device_repository_update_successfull_toast: [
      "Device update repository successfully updated.",
      "Device update repository successfully updated.",
      "Device update repository successfully updated.",
      "Device update repository successfully updated.",
      "Device update repository successfully updated.",
      "Device update repository successfully updated.",
      "Device update repository successfully updated.",
      "Device update repository successfully updated.",
      "Device update repository successfully updated.",
      "Device update repository successfully updated.",
      "Device update repository successfully updated.",
      "device_repository_update_successfull_toast"
    ],
    device_repository_delete_successfull_toast: [
      "Device update repository successfully deleted.",
      "Device update repository successfully deleted.",
      "Device update repository successfully deleted.",
      "Device update repository successfully deleted.",
      "Device update repository successfully deleted.",
      "Device update repository successfully deleted.",
      "Device update repository successfully deleted.",
      "Device update repository successfully deleted.",
      "Device update repository successfully deleted.",
      "Device update repository successfully deleted.",
      "Device update repository successfully deleted.",
      "device_repository_delete_successfull_toast"
    ],
    device_repository_delete_fail_toast: [
      "Failed to delete the device update repository.",
      "Failed to delete the device update repository.",
      "Failed to delete the device update repository.",
      "Failed to delete the device update repository.",
      "Failed to delete the device update repository.",
      "Failed to delete the device update repository.",
      "Failed to delete the device update repository.",
      "Failed to delete the device update repository.",
      "Failed to delete the device update repository.",
      "Failed to delete the device update repository.",
      "Failed to delete the device update repository.",
      "device_repository_delete_fail_toast"
    ],
    isdefault: [
      "Is Default",
      "Is Default",
      "Is Default",
      "Is Default",
      "Is Default",
      "Is Default",
      "Is Default",
      "Is Default",
      "Is Default",
      "Is Default",
      "Is Default",
      "isdefault"
    ],
    device_repository_delete_confirm_text: [
      "Are you sure you want to delete device update repository <b>${name}</b>?",
      "Are you sure you want to delete device update repository <b>${name}</b>?",
      "Are you sure you want to delete device update repository <b>${name}</b>?",
      "Are you sure you want to delete device update repository <b>${name}</b>?",
      "Are you sure you want to delete device update repository <b>${name}</b>?",
      "Are you sure you want to delete device update repository <b>${name}</b>?",
      "Are you sure you want to delete device update repository <b>${name}</b>?",
      "Are you sure you want to delete device update repository <b>${name}</b>?",
      "Are you sure you want to delete device update repository <b>${name}</b>?",
      "Are you sure you want to delete device update repository <b>${name}</b>?",
      "Are you sure you want to delete device update repository <b>${name}</b>?",
      "device_repository_delete_confirm_text"
    ],
    device_update_repository_delete_title: [
      "Delete Device Update Repository",
      "Delete Device Update Repository",
      "Delete Device Update Repository",
      "Delete Device Update Repository",
      "Delete Device Update Repository",
      "Delete Device Update Repository",
      "Delete Device Update Repository",
      "Delete Device Update Repository",
      "Delete Device Update Repository",
      "Delete Device Update Repository",
      "Delete Device Update Repository",
      "device_update_repository_delete_title"
    ],
    error_duplicate_repository: [
      "Duplicate Device Update Repository Found",
      "Duplicate Device Update Repository Found",
      "Duplicate Device Update Repository Found",
      "Duplicate Device Update Repository Found",
      "Duplicate Device Update Repository Found",
      "Duplicate Device Update Repository Found",
      "Duplicate Device Update Repository Found",
      "Duplicate Device Update Repository Found",
      "Duplicate Device Update Repository Found",
      "Duplicate Device Update Repository Found",
      "Duplicate Device Update Repository Found",
      "error_duplicate_repository"
    ],
    edit_repository: [
      "Edit Device Update Repository",
      "Edit Device Update Repository",
      "Edit Device Update Repository",
      "Edit Device Update Repository",
      "Edit Device Update Repository",
      "Edit Device Update Repository",
      "Edit Device Update Repository",
      "Edit Device Update Repository",
      "Edit Device Update Repository",
      "Edit Device Update Repository",
      "Edit Device Update Repository",
      "edit_repository"
    ],
    add_repository: [
      "Add Device Update Repository",
      "Add Device Update Repository",
      "Add Device Update Repository",
      "Add Device Update Repository",
      "Add Device Update Repository",
      "Add Device Update Repository",
      "Add Device Update Repository",
      "Add Device Update Repository",
      "Add Device Update Repository",
      "Add Device Update Repository",
      "Add Device Update Repository",
      "add_repository"
    ],
    repository_name: [
      "Repository Name",
      "Repository Name",
      "Repository Name",
      "Repository Name",
      "Repository Name",
      "Repository Name",
      "Repository Name",
      "Repository Name",
      "Repository Name",
      "Repository Name",
      "Repository Name",
      "repository_name"
    ],
    repository_name_help: [
      "Please enter the repository name",
      "Please enter the repository name",
      "Please enter the repository name",
      "Please enter the repository name",
      "Please enter the repository name",
      "Please enter the repository name",
      "Please enter the repository name",
      "Please enter the repository name",
      "Please enter the repository name",
      "Please enter the repository name",
      "Please enter the repository name",
      "repository_name_help"
    ],
    device_software_create_successfull_toast: [
      "Device software release successfully created.",
      "Device software release successfully created.",
      "Device software release successfully created.",
      "Device software release successfully created.",
      "Device software release successfully created.",
      "Device software release successfully created.",
      "Device software release successfully created.",
      "Device software release successfully created.",
      "Device software release successfully created.",
      "Device software release successfully created.",
      "Device software release successfully created.",
      "device_software_create_successfull_toast"
    ],
    device_software_update_successfull_toast: [
      "Device software release successfully updated.",
      "Device software release successfully updated.",
      "Device update software release successfully updated.",
      "Device update software release successfully updated.",
      "Device update software release successfully updated.",
      "Device update software release successfully updated.",
      "Device update software release successfully updated.",
      "Device update software release successfully updated.",
      "Device update software release successfully updated.",
      "Device update software release successfully updated.",
      "Device update software release successfully updated.",
      "device_software_update_successfull_toast"
    ],
    device_software_delete_successfull_toast: [
      "Device software release successfully deleted.",
      "Device software release successfully deleted.",
      "Device software release successfully deleted.",
      "Device software release successfully deleted.",
      "Device software release successfully deleted.",
      "Device software release successfully deleted.",
      "Device software release successfully deleted.",
      "Device software release successfully deleted.",
      "Device software release successfully deleted.",
      "Device software release successfully deleted.",
      "Device software release successfully deleted.",
      "device_software_delete_successfull_toast"
    ],
    device_software_delete_fail_toast: [
      "Failed to delete the device software release.",
      "Failed to delete the device software release.",
      "Failed to delete the device software release.",
      "Failed to delete the device software release.",
      "Failed to delete the device software release.",
      "Failed to delete the device software release.",
      "Failed to delete the device software release.",
      "Failed to delete the device software release.",
      "Failed to delete the device software release.",
      "Failed to delete the device software release.",
      "Failed to delete the device software release.",
      "device_software_delete_fail_toast"
    ],
    error_duplicate_software: [
      "Duplicate Device Software Release Found",
      "Duplicate Device Software Release Found",
      "Duplicate Device Software Release Found",
      "Duplicate Device Software Release Found",
      "Duplicate Device Software Release Found",
      "Duplicate Device Software Release Found",
      "Duplicate Device Software Release Found",
      "Duplicate Device Software Release Found",
      "Duplicate Device Software Release Found",
      "Duplicate Device Software Release Found",
      "Duplicate Device Software Release Found",
      "error_duplicate_software"
    ],
    edit_software: [
      "Edit Device Software Release",
      "Edit Device Software Release",
      "Edit Device Software Release",
      "Edit Device Software Release",
      "Edit Device Software Release",
      "Edit Device Software Release",
      "Edit Device Software Release",
      "Edit Device Software Release",
      "Edit Device Software Release",
      "Edit Device Software Release",
      "Edit Device Software Release",
      "edit_software"
    ],
    add_software: [
      "Add Device Software Release",
      "Add Device Software Release",
      "Add Device Software Release",
      "Add Device Software Release",
      "Add Device Software Release",
      "Add Device Software Release",
      "Add Device Software Release",
      "Add Device Software Release",
      "Add Device Software Release",
      "Add Device Software Release",
      "Add Device Software Release",
      "add_software"
    ],
    isfullsystemupdate: [
      "Full System Update",
      "Full system update",
      "Full system update",
      "Full system update",
      "Full system update",
      "Full system update",
      "Full system update",
      "Full system update",
      "Full system update",
      "Full system update",
      "Full system update",
      "isfullsystemupdate"
    ],
    deviceupdaterepositoryname: [
      "Repository",
      "Repository",
      "Repository",
      "Repository",
      "Repository",
      "Repository",
      "Repository",
      "Repository",
      "Repository",
      "Repository",
      "Repository",
      "deviceupdaterepositoryname"
    ],
    enabledevicetypes: [
      "Additional Device Types Enabled",
      "Additional Device Types Enabled",
      "Additional Device Types Enabled",
      "Additional Device Types Enabled",
      "Additional Device Types Enabled",
      "Additional Device Types Enabled",
      "Additional Device Types Enabled",
      "Additional Device Types Enabled",
      "Additional Device Types Enabled",
      "Additional Device Types Enabled",
      "Additional Device Types Enabled",
      "enabledevicetypes"
    ],
    systemdevicetypename: [
      "Device Type",
      "Device Type",
      "Device Type",
      "Device Type",
      "Device Type",
      "Device Type",
      "Device Type",
      "Device Type",
      "Device Type",
      "Device Type",
      "Device Type",
      "systemdevicetypename"
    ],
    minimumsystemversion: [
      "Minimum System Version",
      "Minimum System Version",
      "Minimum System Version",
      "Minimum System Version",
      "Minimum System Version",
      "Minimum System Version",
      "Minimum System Version",
      "Minimum System Version",
      "Minimum System Version",
      "Minimum System Version",
      "Minimum System Version",
      "minimumsystemversion"
    ],
    version: [
      "Version",
      "Version",
      "Version",
      "Version",
      "Version",
      "Version",
      "Version",
      "Version",
      "Version",
      "Version",
      "Version",
      "version"
    ],
    software_version_available1: [
      "Software Version available for one or more",
      "Software Version available for one or more",
      "Software Version available for one or more",
      "Software Version available for one or more",
      "Software Version available for one or more",
      "Software Version available for one or more",
      "Software Version available for one or more",
      "Software Version available for one or more",
      "Software Version available for one or more",
      "Software Version available for one or more",
      "Software Version available for one or more",
      "software_version_available1"
    ],
    software_version_available2: [
      "units in your organisation!",
      "units in your organization!",
      "units in your organisation!",
      "units in your organisation!",
      "units in your organisation!",
      "units in your organisation!",
      "units in your organisation!",
      "units in your organisation!",
      "units in your organisation!",
      "units in your organisation!",
      "units in your organisation!",
      "software_version_available2"
    ],
    error_devicesoftwarereleaseexists: [
      "Can not delete repository due to existing device software release",
      "Can not delete repository due to existing device software release",
      "Can not delete repository due to existing device software release",
      "Can not delete repository due to existing device software release",
      "Can not delete repository due to existing device software release",
      "Can not delete repository due to existing device software release",
      "Can not delete repository due to existing device software release",
      "Can not delete repository due to existing device software release",
      "Can not delete repository due to existing device software release",
      "Can not delete repository due to existing device software release",
      "Can not delete repository due to existing device software release",
      "error_devicesoftwarereleaseexists"
    ],
    error_customerdevicesoftwarereleaseexists: [
      "Can not delete repository due to existing customer",
      "Can not delete repository due to existing customer",
      "Can not delete repository due to existing customer",
      "Can not delete repository due to existing customer",
      "Can not delete repository due to existing customer",
      "Can not delete repository due to existing customer",
      "Can not delete repository due to existing customer",
      "Can not delete repository due to existing customer",
      "Can not delete repository due to existing customer",
      "Can not delete repository due to existing customer",
      "Can not delete repository due to existing customer",
      "error_customerdevicesoftwarereleaseexists"
    ],
    // copper: [
    //   "Copper",
    //   "Copper",
    //   "銅線",
    //   "铜",
    //   "Kupfer",
    //   "Cuivre",
    //   "Rame",
    //   "Cobre",
    //   "Cobre",
    //   "Медь",
    //   "Miedź",
    //   "copper"
    // ]

    error_saving_settings: [
      "Error saving settings",
      "Error saving settings",
      "設定の保存中にエラーが発生しました",
      "保存设置时出错",
      "Fehler beim Speichern der Einstellungen",
      "Erreur lors de l'enregistrement des paramètres",
      "Errore durante il salvataggio delle impostazioni",
      "Erro ao salvar as configurações",
      "Error al guardar la configuración",
      "Ошибка при сохранении настроек",
      "Błąd podczas zapisywania ustawień",
      "error_saving_settings"
    ],
    success_saving_settings: [
      "Settings saved successfully",
      "Settings saved successfully",
      "設定が正常に保存されました",
      "设置已成功保存",
      "Einstellungen erfolgreich gespeichert",
      "Paramètres enregistrés avec succès",
      "Impostazioni salvate con successo",
      "Configurações salvas com sucesso",
      "Configuración guardada con éxito",
      "Настройки успешно сохранены",
      "Ustawienia zostały pomyślnie zapisane",
      "success_saving_settings"
    ],
    security_file_upload_settings_tab: [
      "File Upload Settings",
      "File Upload Settings",
      "ファイルアップロード設定",
      "文件上传设置",
      "Datei-Upload-Einstellungen",
      "Paramètres de téléchargement de fichiers",
      "Impostazioni di caricamento file",
      "Configurações de upload de arquivos",
      "Configuración de carga de archivos",
      "Настройки загрузки файлов",
      "Ustawienia przesyłania plików",
      "security_file_upload_settings_tab"
    ],
    security_account_lockout_settings_tab: [
      "Account Lockout",
      "Account Lockout",
      "アカウントロック",
      "帐户锁定",
      "Kontosperrung",
      "Verrouillage de compte",
      "Blocco dell'account",
      "Bloqueio de conta",
      "Bloqueo de cuenta",
      "Блокировка учетной записи",
      "Blokada konta",
      "security_account_lockout_settings_tab"
    ],
    security_file_upload_settings_allowed_comet_extensions: [
      "Allowed LanTEK IV File Extensions",
      "Allowed LanTEK IV File Extensions",
      "許可されたファイル拡張子",
      "允许的文件扩展名",
      "Erlaubte Dateierweiterungen",
      "Extensions de fichiers autorisées",
      "Estensioni di file consentite",
      "Extensões de arquivo permitidas",
      "Extensiones de archivo permitidas",
      "Разрешенные расширения файлов",
      "Dozwolone rozszerzenia plików",
      "security_file_upload_settings_allowed_extensions"
    ],
    security_file_upload_settings_allowed_comet_extensions_help: [
      "Specify the file extensions that are allowed for upload.",
      "Specify the file extensions that are allowed for upload.",
      "アップロードを許可する��ァイル拡張子を指定してください。",
      "指定允许上传的文件扩展名。",
      "Geben Sie die Dateierweiterungen an, die für den Upload zulässig sind.",
      "Spécifiez les extensions de fichiers autorisées pour le téléchargement.",
      "Specifica le estensioni di file consentite per il caricamento.",
      "Especifique as extensões de arquivo permitidas para upload.",
      "Especifique las extensiones de archivo permitidas para la carga.",
      "Укажите расширения файлов, разрешенные для загрузки.",
      "Określ rozszerzenia plików dozwolone do przesyłania.",
      "security_file_upload_settings_allowed_extensions_help"
    ],
    security_file_upload_settings_allowed_lantek_extensions: [
      "Allowed LanTEK III File Extensions",
      "Allowed LanTEK III File Extensions",
      "許可されたファイル拡張子",
      "允许的文件扩展名",
      "Erlaubte Dateierweiterungen",
      "Extensions de fichiers autorisées",
      "Estensioni di file consentite",
      "Extensões de arquivo permitidas",
      "Extensiones de archivo permitidas",
      "Разрешенные расширения файлов",
      "Dozwolone rozszerzenia plików",
      "security_file_upload_settings_allowed_extensions"
    ],
    security_file_upload_settings_allowed_lantek_extensions_help: [
      "Specify the file extensions that are allowed for upload.",
      "Specify the file extensions that are allowed for upload.",
      "アップロードを許可する��ァイル拡張子を指定してください。",
      "指定允许上传的文件扩展名。",
      "Geben Sie die Dateierweiterungen an, die für den Upload zulässig sind.",
      "Spécifiez les extensions de fichiers autorisées pour le téléchargement.",
      "Specifica le estensioni di file consentite per il caricamento.",
      "Especifique as extensões de arquivo permitidas para upload.",
      "Especifique las extensiones de archivo permitidas para la carga.",
      "Укажите расширения файлов, разрешенные для загрузки.",
      "Określ rozszerzenia plików dozwolone do przesyłania.",
      "security_file_upload_settings_allowed_extensions_help"
    ],
    security_file_upload_settings_allowed_attachment_extensions: [
      "Allowed Attachment File Extensions",
      "Allowed Lantek File Extensions",
      "許可されたファイル拡張子",
      "允许的文件扩展名",
      "Erlaubte Dateierweiterungen",
      "Extensions de fichiers autorisées",
      "Estensioni di file consentite",
      "Extensões de arquivo permitidas",
      "Extensiones de archivo permitidas",
      "Разрешенные расширения файлов",
      "Dozwolone rozszerzenia plików",
      "security_file_upload_settings_allowed_attachment_extensions"
    ],
    security_file_upload_settings_allowed_attachment_extensions_help: [
      "Specify the file extensions that are allowed for Attachment upload.",
      "Specify the file extensions that are allowed for upload.",
      "アップロードを許可する��ァイル拡張子を指定してください。",
      "指定允许上传的文件扩展名。",
      "Geben Sie die Dateierweiterungen an, die für den Upload zulässig sind.",
      "Spécifiez les extensions de fichiers autorisées pour le téléchargement.",
      "Specifica le estensioni di file consentite per il caricamento.",
      "Especifique as extensões de arquivo permitidas para upload.",
      "Especifique las extensiones de archivo permitidas para la carga.",
      "Укажите расширения файлов, разрешенные для загрузки.",
      "Określ rozszerzenia plików dozwolone do przesyłania.",
      "security_file_upload_settings_allowed_attachment_extensions_help"
    ],
    security_file_upload_settings_max_file_size: [
      "Max File Size (MB)",
      "Allowed File Size (MB)",
      "許可されたファイルサイズ (MB)",
      "允许的文件大小 (MB)",
      "Erlaubte Dateigröße (MB)",
      "Taille de fichier autorisée (MB)",
      "Dimensione file consentita (MB)",
      "Tamanho de arquivo permitido (MB)",
      "Tamaño de archivo permitido (MB)",
      "Разрешенный размер файла (MB)",
      "Dozwolony rozmiar pliku (MB)",
      "security_file_upload_settings_max_file_size"
    ],
    security_file_upload_settings_max_file_size_help: [
      "Specify the maximum file size allowed for upload.",
      "Specify the maximum file size allowed for upload.",
      "アップロードを許可する最大ファイルサイズを指定してください。",
      "指定允许上传的最大文件大小。",
      "Geben Sie die maximale Dateigröße an, die für den Upload zulässig ist.",
      "Spécifiez la taille maximale de fichier autorisée pour le téléchargement.",
      "Specifica la dimensione massima del file consentita per il caricamento.",
      "Especifique o tamanho máximo de arquivo permitido para upload.",
      "Especifique el tamaño máximo de archivo permitido para la carga.",
      "Укажите максимальный размер файла, разрешенный для загрузки.",
      "Określ maksymalny rozmiar pliku dozwolony do przesyłania.",
      "security_file_upload_settings_max_file_size_help"
    ],
    security_file_upload_settings_max_attachment_file_size: [
      "Max Attachment File Size (MB)",
      "Allowed File Size (MB)",
      "許可されたファイルサイズ (MB)",
      "允许的文件大小 (MB)",
      "Erlaubte Dateigröße (MB)",
      "Taille de fichier autorisée (MB)",
      "Dimensione file consentita (MB)",
      "Tamanho de arquivo permitido (MB)",
      "Tamaño de archivo permitido (MB)",
      "Разрешенный размер файла (MB)",
      "Dozwolony rozmiar pliku (MB)",
      "security_file_upload_settings_max_attachment_file_size"
    ],
    security_file_upload_settings_max_attachment_file_size_help: [
      "Specify the maximum file size allowed for upload.",
      "Specify the maximum file size allowed for Attachment upload.",
      "アップロードを許可する最大ファイルサイズを指定してください。",
      "指定允许上传的最大文件大小。",
      "Geben Sie die maximale Dateigröße an, die für den Upload zulässig ist.",
      "Spécifiez la taille maximale de fichier autorisée pour le téléchargement.",
      "Specifica la dimensione massima del file consentita per il caricamento.",
      "Especifique o tamanho máximo de arquivo permitido para upload.",
      "Especifique el tamaño máximo de archivo permitido para la carga.",
      "Укажите максимальный размер файла, разрешенный для загрузки.",
      "Określ maksymalny rozmiar pliku dozwolony do przesyłania.",
      "security_file_upload_settings_max_attachment_file_size_help"
    ],
    security_file_upload_settings_max_file_size_range_description: [
      "Max File size should be in range of ${min}-${max}",
      "Max File size should be in range of ${min}-${max}",
      "最大ファイルサイズは、${min}-${max}の範囲内である必要があります",
      "最大文件大小应在${min}-${max}范围内",
      "Die maximale Dateigröße sollte im Bereich von ${min}-${max} liegen",
      "La taille maximale du fichier doit être comprise entre ${min} et ${max}",
      "La dimensione massima del file deve essere compresa tra ${min} e ${max}",
      "O tamanho máximo do arquivo deve estar na faixa de ${min}-${max}",
      "El tamaño máximo del archivo debe estar en el rango de ${min}-${max}",
      "Максимальный размер файла должен быть в диапазоне от ${min} до ${max}",
      "Maksymalny rozmiar pliku powinien mieścić się w zakresie ${min}-${max}",
      "security_file_upload_settings_max_file_size_range_description"
    ],
    security_account_lockout_settings_failed_attempts: [
      "Failed Attempts",
      "Failed Attempts",
      "失敗した試行",
      "失败的尝试",
      "Fehlgeschlagene Versuche",
      "Tentatives échouées",
      "Tentativi falliti",
      "Tentativas falhadas",
      "Intentos fallidos",
      "Неудачные попытки",
      "Nieudane próby",
      "security_account_lockout_settings_failed_attempts"
    ],
    security_account_lockout_settings_failed_attempts_help: [
      "Specify the maximum number of failed attempts (within threshold) allowed before triggering an account lockout.",
      "Specify the maximum number of failed attempts (within threshold) allowed before triggering an account lockout.",
      "アカウントロックをトリガーする前に許可される最大の失敗した試行回数を指定してください。",
      "指定触发帐户锁定之前允许的最大失败尝试次数。",
      "Geben Sie die maximale Anzahl fehlgeschlagener Versuche an, die zulässig sind, bevor eine Kontosperrung ausgelöst wird.",
      "Spécifiez le nombre maximal de tentatives échouées autorisées avant de déclencher un verrouillage de compte.",
      "Specifica il numero massimo di tentativi non riusciti consentiti prima di attivare un blocco dell'account.",
      "Especifique o número máximo de tentativas com falha permitidas antes de acionar um bloqueio de conta.",
      "Especifique el número máximo de intentos fallidos permitidos antes de activar un bloqueo de cuenta.",
      "Укажите максимальное количество неудачных попыток, разрешенных перед блокировкой учетной записи.",
      "Określ maksymalną liczbę nieudanych prób, które można wykonać przed zablokowaniem konta.",
      "security_account_lockout_settings_failed_attempts_help"
    ],
    security_account_lockout_settings_threshold: [
      "Threshold",
      "Threshold",
      "しきい値",
      "阈值",
      "Schwellenwert",
      "Seuil",
      "Soglia",
      "Limite",
      "Umbral",
      "Порог",
      "Próg",
      "security_account_lockout_settings_threshold"
    ],
    security_account_lockout_settings_threshold_help: [
      "Specify the threshold value in minutes for the maximum number of failed attempts allowed before triggering an account lockout.",
      "Specify the threshold value in minutes for the maximum number of failed attempts allowed before triggering an account lockout.",
      "アカウントロックをトリガーする前に許可される最大の失敗した試行回数のしきい値を指定してください。",
      "指定触发帐户锁定之前允许的最大失败尝试次数的阈值。",
      "Geben Sie den Schwellenwert in Minuten für die maximale Anzahl fehlgeschlagener Versuche an, die zulässig sind, bevor eine Kontosperrung ausgelöst wird.",
      "Spécifiez la valeur de seuil en minutes pour le nombre maximal de tentatives échouées autorisées avant de déclencher un verrouillage de compte.",
      "Specifica il valore di soglia in minuti per il numero massimo di tentativi non riusciti consentiti prima di attivare un blocco dell'account.",
      "Especifique o valor de limite em minutos para o número máximo de tentativas com falha permitidas antes de acionar um bloqueio de conta.",
      "Especifique el valor de umbral en minutos para el número máximo de intentos fallidos permitidos antes de activar un bloqueo de cuenta.",
      "Укажите пороговое значение в минутах для максимального количества неудачных попыток, разрешенных перед блокировкой учетной записи.",
      "Określ wartość progową w minutach dla maksymalnej liczby nieudanych prób, które można wykonać przed zablokowaniem konta.",
      "security_account_lockout_settings_threshold_help"
    ],
    security_account_lockout_settings_duration: [
      "Duration",
      "Duration",
      "期間",
      "持续时间",
      "Dauer",
      "Durée",
      "Durata",
      "Duração",
      "Duración",
      "Продолжительность",
      "Czas trwania",
      "security_account_lockout_settings_duration"
    ],
    security_account_lockout_settings_duration_help: [
      "Specify the duration for which the account will remain locked after exceeding the failed attempts threshold in minutes.",
      "Specify the duration for which the account will remain locked after exceeding the failed attempts threshold in minutes.",
      "失敗した試行回数のしきい値を超えた後、アカウントがロックされたままになる期間を指定してください。",
      "指定超过失败尝试阈值后帐户将保持锁定的持续时间（以分钟为单位）。",
      "Geben Sie die Dauer an, für die das Konto nach Überschreiten des Schwellenwerts für fehlgeschlagene Versuche gesperrt bleibt (in Minuten).",
      "Spécifiez la durée pendant laquelle le compte restera verrouillé après avoir dépassé le seuil des tentatives échouées en minutes.",
      "Specifica la durata per cui l'account rimarrà bloccato dopo aver superato la soglia dei tentativi non riusciti in minuti.",
      "Especifique a duração pela qual a conta permanecerá bloqueada após exceder o limite de tentativas com falha em minutos.",
      "Especifique la duración durante la cual la cuenta permanecerá bloqueada después de exceder el umbral de intentos fallidos en minutos.",
      "Укажите продолжительность, в течение которой учетная запись останется заблокированной после превышения порога неудачных попыток в минутах.",
      "Określ czas trwania, przez jaki konto pozostanie zablokowane po przekroczeniu progu nieudanych prób w minutach.",
      "security_account_lockout_settings_duration_help"
    ],
    jobs_upload_file_size_error: [
      "File size exceeds the maximum limit of ${value} (MB)",
      "File size exceeds the maximum limit of ${value} (MB)",
      "ファイルサイズが最大制限の ${value} を超えています。",
      "文件大小超过最大限制 ${value}。",
      "Die Dateigröße überschreitet das Maximum von ${value} MB.",
      "La taille du fichier dépasse la limite maximale de ${value}.",
      "La dimension del file supera il limite massimo di ${value}.",
      "O tamanho do arquivo excede o limite de ${value}(MB)",
      "El tamaño del archivo excede el límite de ${value} (MB)",
      "Размер файла превышает максимальный лимит ${value}.",
      "Rozmiar pliku przekracza maksymalny limit ${value}.",
      "jobs_upload_file_size_error"
    ],
    jobs_upload_file_extension_error: [
      "File extension is not allowed. Allowed extensions are: ${value}.",
      "File extension is not allowed. Allowed extensions are: ${value}.",
      "ファイル拡張子は許可されていません。許可されている拡張子は: ${value}。",
      "文件扩展名不允许。允许的扩展名是: ${value}。",
      "Die Dateierweiterung ist nicht zulässig. Zulässige Erweiterungen sind: ${value}.",
      "L'extension de fichier n'est pas autorisée. Les extensions autorisées sont : ${value}.",
      "L'estensione del file non è consentita. Le estensioni consentite sono: ${value}.",
      "Extensão de arquivo não permitida. As extensões permitidas são: ${value}.",
      "Extensión de archivo no permitida. Las extensiones permitidas son: ${value}.",
      "Расширение файла не разрешено. Разрешенные расширения: ${value}.",
      "Rozszerzenie pliku nie jest dozwolone. Dozwolone rozszerzenia to: ${value}.",
      "jobs_upload_file_extension_error"
    ],
    mfa_verify_account: [
      "Verify Account",
      "Verify Account",
      "アカウントを確認",
      "验证帐户",
      "Konto verifizieren",
      "Vérifier le compte",
      "Verifica account",
      "Verificar Conta",
      "Verificar Cuenta",
      "Проверить учетную запись",
      "Zweryfikuj konto",
      "mfa_verify_account"
    ],
    mfa_verified: [
      "Account Verified",
      "Account Verified",
      "アカウントが確認されました",
      "帐户已验证",
      "Konto verifiziert",
      "Compte vérifié",
      "Account verificato",
      "Conta verificada",
      "Cuenta verificada",
      "Учетная запись проверена",
      "Konto zweryfikowane",
      "mfa_verified"
    ],
    mfa_dialog_title: [
      "Verify Your Identity",
      "Verify Your Identity",
      "あなたの身元を確認してください",
      "验证您的身份",
      "Verifizieren Sie Ihre Identität",
      "Vérifiez votre identité",
      "Verifica la tua identità",
      "Verificar  Identidade",
      "Verificar  Identidad",
      "Проверьте свою личность",
      "Zweryfikuj swoją tożsamość",
      "mfa_dialog_title"
    ],
    mfa_instruction: [
      "To verify your identity, please enter the one-time password sent to your email.",
      "To verify your identity, please enter the one-time password sent to your email.",
      "要验证您的身份，请输入发送到您的电子邮件的一次性密码。",
      "要验证您的身份，请输入发送到您的电子邮件的一次性密码。",
      "Um Ihre Identität zu verifizieren, geben Sie bitte das Einmalpasswort ein, das an Ihre E-Mail gesendet wurde.",
      "Pour vérifier votre identité, veuillez saisir le mot de passe à usage unique qui vous a été envoyé par courrier électronique.",
      "Per verificare la tua identità, inserisci la password usa e getta inviata alla tua email.",
      "Para verificar sua identidade, informe a senha de uso único enviada para seu e-mail.",
      "Para verificar su identidad, ingrese la contraseña de un solo uso enviada a su correo electrónico.",
      "Чтобы подтвердить свою личность, введите одноразовый пароль, отправленный на вашу электронную почту.",
      "Aby zweryfikować swoją tożsamość, wprowadź jednorazowe hasło wysłane na Twój e-mail.",
      "mfa_instruction"
    ],
    mfa_send_via_email: [
      "Email",
      "Email",
      "メール",
      "电子邮件",
      "E-Mail",
      "E-mail",
      "E-mail",
      "E-mail",
      "E-mail",
      "Электронная почта",
      "E-mail",
      "mfa_send_via_email"
    ],
    mfa_send_via_text: [
      "SMS",
      "SMS",
      "SMS",
      "短信",
      "SMS",
      "SMS",
      "SMS",
      "SMS",
      "SMS",
      "SMS",
      "SMS",
      "mfa_send_via_text"
    ],
    mfa_verify_otp: [
      "Verify",
      "Verify",
      "確認",
      "验证",
      "Verifizieren",
      "Vérifier",
      "Verifica",
      "Verificar",
      "Verificar",
      "Проверить",
      "Zweryfikuj",
      "mfa_verify_otp"
    ],
    mfa_send_otp: [
      "Send",
      "Send",
      "送信",
      "发送",
      "Senden",
      "Envoyer",
      "Invia",
      "Enviar",
      "Enviar",
      "Отправить",
      "Wyślij",
      "mfa_send_otp"
    ],
    mfa_send_via: [
      "Send One-Time Password using:",
      "Send One-Time Password using:",
      "ワンタイムパスワードを送信する方法：",
      "一次性密码发送使用：",
      "Einmalpasswort senden mit:",
      "Envoyer le mot de passe à usage unique en utilisant :",
      "Invia password usa e getta utilizzando:",
      "Enviar senha de uso único usando:",
      "Enviar contraseña de un solo uso utilizando:",
      "Отправить одноразовый пароль с помощью:",
      "Wyślij jednorazowe hasło za pomocą:",
      "mfa_send_via"
    ],
    mfa_enter_otp: [
      "Enter One-Time Password",
      "Enter One-Time Password",
      "ワンタイムパスワードを入力してください",
      "输入一次性密码",
      "Einmalpasswort eingeben",
      "Entrez le mot de passe à usage unique",
      "Inserisci la password usa e getta",
      "Informe a senha de uso único",
      "Ingrese la contraseña de un solo uso",
      "Введите одноразовый пароль",
      "Wprowadź jednorazowe hasło",
      "mfa_enter_otp"
    ],
    mfa_invalid_otp: [
      "OTP verification failed: The entered code is incorrect or expired.",
      "OTP verification failed: The entered code is incorrect or expired.",
      "OTP検証に失敗しました：入力されたコードが正しくないか、期限切れです。",
      "OTP验证失败：输入的代码不正确或已过期。",
      "OTP-Überprüfung fehlgeschlagen: Der eingegebene Code ist falsch oder abgelaufen.",
      "Échec de la vérification OTP : le code saisi est incorrect ou a expiré.",
      "Verifica OTP non riuscita: il codice inserito è errato o scaduto.",
      "Falha na verificação do OTP: o código inserido está incorreto ou expirou.",
      "La verificación del OTP falló: el código ingresado es incorrecto o ha expirado.",
      "Проверка OTP не удалась: введенный код неверен или истек.",
      "Weryfikacja OTP nie powiodła się: wprowadzony kod jest nieprawidłowy lub wygasł.",
      "mfa_invalid_otp"
    ],
    error_sending_otp: [
      "There was an error sending the OTP. Please try again.",
      "There was an error sending the OTP. Please try again.",
      "OTPの送信中にエラーが発生しました。もう一度やり直してください。",
      "发送 一次性密码 时出错。请再试一次。",
      "Beim Senden des OTP ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
      "Une erreur s'est produite lors de l'envoi du mot de passe à usage unique. Veuillez réessayer.",
      "Si è verificato un errore durante l'invio dell'OTP. Riprova.",
      "Ocorreu um erro ao enviar o OTP. Tente novamente.",
      "Se ha producido un error al enviar el OTP. Inténtalo de nuevo.",
      "При отправке OTP произошла ошибка. Пожалуйста, попробуйте еще раз.",
      "Wystąpił błąd podczas wysyłania OTP. Proszę spróbować ponownie.",
      "error_sending_otp"
    ],
    error_verifying_otp: [
      "There was an error verifying the OTP. Please try again.",
      "There was an error verifying the OTP. Please try again.",
      "OTPの検証中にエラーが発生しました。もう一度やり直してください。",
      "验证 一次性密码 时出错。请再试一次。",
      "Beim Überprüfen des OTP ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
      "Une erreur s'est produite lors de la vérification du mot de passe à usage unique. Veuillez réessayer.",
      "Si è verificato un errore durante la verifica dell'OTP. Riprova.",
      "Ocorreu um erro ao verificar o OTP. Tente novamente.",
      "Se ha producido un error al verificar el OTP. Inténtalo de nuevo.",
      "При проверке OTP произошла ошибка. Пожалуйста, попробуйте еще раз.",
      "Wystąpił błąd podczas weryfikacji OTP. Proszę spróbować ponownie.",
      "error_verifying_otp"
    ],
    user_mfa_enabled: [
      "Enable Multi-Factor Authentication",
      "Enable Multi-Factor Authentication",
      "多要素認証を有効にする",
      "启用多种身份验证",
      "Multi-Faktor-Authentifizierung aktivieren",
      "Activer l'authentification multifacteur",
      "Abilita l'Autenticazione Multifattore",
      "Habilitar Autenticação Multifator",
      "Habilitar Autenticación Multifactor",
      "Включить многофакторную аутентификацию",
      "Włącz uwierzytelnianie wieloskładnikowe",
      "user_enable_mfa"
    ],
    mfa_suggestion_toast: [
      "We recommend enabling multi-factor authentication for better security. Edit your user profile to enable it.",
      "We recommend enabling multi-factor authentication for better security. Edit your user profile to enable it.",
      "セキュリティを強化するために多要素認証を有効にすることをお勧めします。ユーザープロフィールを編集して有効にしてください。",
      "我们建议启用多种身份验证以提高安全性。编辑您的用户配置文件以启用它。",
      "Wir empfehlen, die Multi-Faktor-Authentifizierung zu aktivieren, um die Sicherheit zu verbessern. Bearbeiten Sie Ihr Benutzerprofil, um sie zu aktivieren.",
      "Nous vous recommandons d'activer l'authentification multifacteur pour une sécurité accrue. Modifiez votre profil utilisateur pour l'activer.",
      "Ti consigliamo di abilitare l'Autenticazione Multifattore per una maggiore sicurezza. Modifica il tuo profilo utente per abilitarlo.",
      "Recomendamos habilitar a autenticação multifator para maior segurança. Edite seu perfil de usuário para habilitá-la.",
      "Recomendamos habilitar la autenticación multifactor para mayor seguridad. Edite su perfil de usuario para habilitarla.",
      "Мы рекомендуем включить многофакторную аутентификацию для повышения безопасности. Отредактируйте свой профиль пользователя, чтобы включить его.",
      "Zalecamy włączenie uwierzytelniania wieloskładnikowego w celu zwiększenia bezpieczeństwa. Edytuj swój profil użytkownika, aby go włączyć.",
      "mfa_suggestion_toast"
    ],
    find_device: [
      "Find Device",
      "Find Device",
      "デバイスを探す",
      "查找设备",
      "Gerät finden",
      "Trouver l’appareil",
      "Trova dispositivo",
      "Encontrar dispositivo",
      "Encontrar dispositivo",
      "Найти устройство",
      "Znajdź urządzenie",
      "find_device"
    ],
    device_registered: [
      "Device Registered",
      "Device Registered",
      "デバイスが登録されました",
      "设备已注册",
      "Gerät registriert",
      "Appareil enregistré",
      "Dispositivo registrato",
      "Dispositivo registado",
      "Dispositivo registrado",
      "Устройство зарегистрировано",
      "Urządzenie zarejestrowane",
      "device_registered"
    ],
    reset_pin: [
      "Reset PIN",
      "Reset PIN",
      "PINをリセット",
      "重置密码",
      "PIN zurücksetzen",
      "Réinitialiser le PIN",
      "Reimposta PIN",
      "Redefinir PIN",
      "Restablecer PIN",
      "Сбросить PIN-код",
      "Resetuj PIN",
      "reset_pin"
    ],
    all_users: [
      "All Users",
      "All Users",
      "すべてのユーザー",
      "所有用户",
      "Alle Benutzer",
      "Tous les utilisateurs",
      "Tutti gli utenti",
      "Todos os utilizadores",
      "Todos los usuarios",
      "Все пользователи",
      "Wszyscy użytkownicy",
      "all_users"
    ],
    home_welcome: [
      "Welcome to Trend AnyWARE",
      "Welcome to Trend AnyWARE",
      "ようこそ Trend AnyWARE",
      "欢迎来到 Trend AnyWARE",
      "Willkommen bei Trend AnyWARE",
      "Bienvenue à Trend AnyWARE",
      "Benvenuto a Trend AnyWARE",
      "Bem-vindo a Trend AnyWARE",
      "Bienvenido a Trend AnyWARE",
      "Добро пожаловать в Trend AnyWARE",
      "Witamy w Trend AnyWARE",
      "home_welcome"
    ],
    home_all_jobs: [
      "All Jobs",
      "All Jobs",
      "すべての仕事",
      "所有工作",
      "Alle Jobs",
      "Tous les emplois",
      "Tutti i lavori",
      "Todos os Empregos",
      "Todos los trabajos",
      "Все вакансии",
      "Wszystkie prace",
      "home_all_jobs"
    ],
    registered_devices: [
      "Registered Devices",
      "Registered Devices",
      "登録済みデバイス",
      "已注册设备",
      "Registrierte Geräte",
      "Appareils enregistrés",
      "Dispositivi registrati",
      "Dispositivos registados",
      "Dispositivos registrados",
      "Зарегистрированные устройства",
      "Zarejestrowane urządzenia",
      "registered_devices"
    ],
    home_tests: [
      "Tests",
      "Tests",
      "テスト",
      "测试",
      "Tests",
      "Tests",
      "Test",
      "Testes",
      "Pruebas",
      "Тесты",
      "Testy",
      "home_tests"
    ],
    performed_tests: [
      "Performed Tests",
      "Performed Tests",
      "実行済みテスト",
      "已执行测试",
      "Durchgeführte Tests",
      "Tests effectués",
      "Test eseguiti",
      "Testes realizados",
      "Pruebas realizadas",
      "Выполненные тесты",
      "Wykonane testy",
      "performed_tests"
    ],
    performed_total_tests: [
      "Performed/Total Tests",
      "Performed/Total Tests",
      "実行済み/総テスト数",
      "已执行/测试总数",
      "Durchgeführte/Gesamtzahl Tests",
      "Tests effectués/total",
      "Test eseguiti/totali",
      "Testes realizados/totais",
      "Pruebas realizadas/totales",
      "Выполнено/всего тестов",
      "Wykonane/wszystkie testy",
      "performed_total_tests"
    ],
    success_test_rate: [
      "Success Test Rate",
      "Success Test Rate",
      "テスト成功率",
      "测试成功率",
      "Erfolgsrate der Tests",
      "Taux de réussite des tests",
      "Tasso di successo dei test",
      "Taxa de sucesso dos testes",
      "Tasa de éxito de pruebas",
      "Процент успешных тестов",
      "Wskaźnik pomyślnych testów",
      "success_test_rate"
    ],
    home: [
      "Home",
      "Home",
      "ホーム",
      "家",
      "Zuhause",
      "Accueil",
      "Casa",
      "Página Inicial",
      "Inicio",
      "Дом",
      "Dom",
      "home"
    ],
    metrics_date_range: [
          "Date Range",
          "Date Range",
          "日付範囲",
          "日期范围",
          "Datumsbereich",
          "Plage de dates",
          "Intervallo di date",
          "Intervalo de datas",
          "Rango de fechas",
          "Диапазон дат",
          "Zakres dat",
          "metrics_date_range"
    ],
    metrics_tester_type: [
          "Tester Type",
          "Tester Type",
          "テスターの種類",
          "测试仪类型",
          "Testertyp",
          "Type de testeur",
          "Tipo di tester",
          "Tipo de testador",
          "Tipo de comprobador",
          "Тип тестера",
          "Typ testera",
          "metrics_tester_type"
    ],
    metrics_technician: [
          "Technician",
          "Technician",
          "技術者",
          "技术人员",
          "Techniker",
          "Technicien",
          "Tecnico",
          "Técnico",
          "Técnico",
          "Техник",
          "Technik",
          "metrics_technician"
    ],
    metrics_apply: [
          "Apply",
          "Apply",
          "適用",
          "应用",
          "Anwenden",
          "Appliquer",
          "Applica",
          "Aplicar",
          "Aplicar",
          "Применить",
          "Zastosuj",
          "metrics_apply"
    ],
    metrics_clear: [
          "Clear",
          "Clear",
          "クリア",
          "清除",
          "Löschen",
          "Effacer",
          "Cancella",
          "Limpar",
          "Borrar",
          "Очистить",
          "Wyczyść",
          "metrics_clear"
    ],
    metrics_select_date_range_first: [
          "Please select a date range first.",
          "Please select a date range first.",
          "最初に日付範囲を選択してください。",
          "请先选择日期范围。",
          "Bitte wählen Sie zuerst einen Datumsbereich aus.",
          "Veuillez d’abord sélectionner une plage de dates.",
          "Selezionare prima un intervallo di date.",
          "Selecione primeiro um intervalo de datas.",
          "Seleccione primero un rango de fechas.",
          "Сначала выберите диапазон дат.",
          "Najpierw wybierz zakres dat.",
          "metrics_select_date_range_first"
    ],
    metrics_all: [
          "All",
          "All",
          "すべて",
          "全部",
          "Alle",
          "Tous",
          "Tutti",
          "Todos",
          "Todos",
          "Все",
          "Wszystkie",
          "metrics_all"
    ],
    metrics_filters: [
          "Filters",
          "Filters",
          "フィルター",
          "筛选器",
          "Filter",
          "Filtres",
          "Filtri",
          "Filtros",
          "Filtros",
          "Фильтры",
          "Filtry",
          "metrics_filters"
    ],
    metrics_organisation_metrics: [
          "Organisation Metrics",
          "Organization Metrics",
          "組織メトリクス",
          "组织指标",
          "Organisationsmetriken",
          "Indicateurs de l’organisation",
          "Metriche dell’organizzazione",
          "Métricas da organização",
          "Métricas de la organización",
          "Показатели организации",
          "Metryki organizacji",
          "metrics_organisation_metrics"
    ],
    metrics_test_count: [
          "Test Count",
          "Test Count",
          "テスト数",
          "测试数量",
          "Anzahl der Tests",
          "Nombre de tests",
          "Numero di test",
          "Número de testes",
          "Número de pruebas",
          "Количество тестов",
          "Liczba testów",
          "metrics_test_count"
    ],
    metrics_test_count_tooltip: [
      "Test Count metric includes tests that meet the requirements for the selected date range and filters. Only relevant and available test results are shown.",
      "Test Count metric includes tests that meet the requirements for the selected date range and filters. Only relevant and available test results are shown.",
      "テスト数の指標には、選択した日付範囲とフィルターの条件を満たすテストが含まれます。関連する利用可能なテスト結果のみが表示されます。",
      "测试计数指标包括符合所选日期范围和筛选条件要求的测试。仅显示相关且可用的测试结果。",
      "Die Kennzahl „Testanzahl“ umfasst Tests, die die Anforderungen des ausgewählten Datumsbereichs und der Filter erfüllen. Es werden nur relevante und verfügbare Testergebnisse angezeigt.",
      "La métrique Nombre de tests inclut les tests qui répondent aux critères de la plage de dates et des filtres sélectionnés. Seuls les résultats de test pertinents et disponibles sont affichés.",
      "La metrica Conteggio test include i test che soddisfano i requisiti dell'intervallo di date e dei filtri selezionati. Vengono mostrati solo i risultati dei test pertinenti e disponibili.",
      "A métrica Contagem de testes inclui os testes que cumprem os requisitos do intervalo de datas e dos filtros selecionados. Apenas são apresentados resultados de teste relevantes e disponíveis.",
      "La métrica Recuento de pruebas incluye las pruebas que cumplen los requisitos del intervalo de fechas y los filtros seleccionados. Solo se muestran los resultados de pruebas relevantes y disponibles.",
      "Показатель количества тестов включает тесты, соответствующие выбранному диапазону дат и фильтрам. Отображаются только релевантные и доступные результаты тестов.",
      "Metryka liczby testów obejmuje testy spełniające wymagania wybranego zakresu dat i filtrów. Wyświetlane są tylko istotne i dostępne wyniki testów.",
      "metrics_test_count_tooltip"
    ],
    metrics_chart_total: [
          "Total",
          "Total",
          "合計",
          "总计",
          "Gesamt",
          "Total",
          "Totale",
          "Total",
          "Total",
          "Всего",
          "Łącznie",
          "metrics_chart_total"
    ],
    metrics_chart_passed: [
          "Passed",
          "Passed",
          "合格",
          "通过",
          "Bestanden",
          "Réussi",
          "Superato",
          "Aprovado",
          "Aprobado",
          "Пройдено",
          "Zaliczono",
          "metrics_chart_passed"
    ],
    metrics_chart_average: [
          "Average",
          "Average",
          "平均",
          "平均值",
          "Durchschnitt",
          "Moyenne",
          "Media",
          "Média",
          "Promedio",
          "Среднее",
          "Średnia",
          "metrics_chart_average"
    ],
    health_check_title: [
          "Device Health Check",
          "Device Health Check",
          "デバイス健全性チェック",
          "设备健康检查",
          "Gerätezustandsprüfung",
          "Vérification de l’état de l’appareil",
          "Controllo dello stato del dispositivo",
          "Verificação do estado do dispositivo",
          "Comprobación del estado del dispositivo",
          "Проверка состояния устройства",
          "Kontrola stanu urządzenia",
          "health_check_title"
    ],
    health_check_col_name: [
          "Check",
          "Check",
          "チェック",
          "检查项",
          "Prüfung",
          "Vérification",
          "Controllo",
          "Verificação",
          "Comprobación",
          "Проверка",
          "Kontrola",
          "health_check_col_name"
    ],
    health_check_tipwear_passed: [
          "Tip wear is within the acceptable range.",
          "Tip wear is within the acceptable range.",
          "チップ摩耗は許容範囲内です。",
          "探头磨损在可接受范围内。",
          "Der Spitzenverschleiß liegt im zulässigen Bereich.",
          "L’usure de la pointe est dans la plage acceptable.",
          "L’usura della punta rientra nell’intervallo accettabile.",
          "O desgaste da ponta está dentro do intervalo aceitável.",
          "El desgaste de la punta está dentro del rango aceptable.",
          "Износ наконечника находится в допустимом диапазоне.",
          "Zużycie końcówki mieści się w dopuszczalnym zakresie.",
          "health_check_tipwear_passed"
    ],
    health_check_tipwear_failed: [
          "Tip wear exceeds the acceptable range.",
          "Tip wear exceeds the acceptable range.",
          "チップ摩耗が許容範囲を超えています。",
          "探头磨损超出可接受范围。",
          "Der Spitzenverschleiß überschreitet den zulässigen Bereich.",
          "L’usure de la pointe dépasse la plage acceptable.",
          "L’usura della punta supera l’intervallo accettabile.",
          "O desgaste da ponta excede o intervalo aceitável.",
          "El desgaste de la punta supera el rango aceptable.",
          "Износ наконечника превышает допустимый диапазон.",
          "Zużycie końcówki przekracza dopuszczalny zakres.",
          "health_check_tipwear_failed"
    ],
    health_check_software_no_device_version: [
          "No device software version is available.",
          "No device software version is available.",
          "デバイスソフトウェアバージョンがありません。",
          "没有可用的设备软件版本。",
          "Keine Gerätesoftwareversion verfügbar.",
          "Aucune version du logiciel de l’appareil n’est disponible.",
          "Nessuna versione software del dispositivo disponibile.",
          "Não está disponível uma versão do software do dispositivo.",
          "No hay disponible una versión de software del dispositivo.",
          "Версия программного обеспечения устройства недоступна.",
          "Brak dostępnej wersji oprogramowania urządzenia.",
          "health_check_software_no_device_version"
    ],
    health_check_software_no_version: [
          "No latest software version is configured.",
          "No latest software version is configured.",
          "最新のソフトウェアバージョンが設定されていません。",
          "未配置最新软件版本。",
          "Keine aktuelle Softwareversion konfiguriert.",
          "Aucune version logicielle récente n’est configurée.",
          "Nessuna versione software più recente configurata.",
          "Não está configurada uma versão mais recente do software.",
          "No se ha configurado una versión de software más reciente.",
          "Не настроена последняя версия программного обеспечения.",
          "Nie skonfigurowano najnowszej wersji oprogramowania.",
          "health_check_software_no_version"
    ],
    health_check_software_passed: [
          "Device software is up to date.",
          "Device software is up to date.",
          "デバイスソフトウェアは最新です。",
          "设备软件为最新版本。",
          "Die Gerätesoftware ist aktuell.",
          "Le logiciel de l’appareil est à jour.",
          "Il software del dispositivo è aggiornato.",
          "O software do dispositivo está atualizado.",
          "El software del dispositivo está actualizado.",
          "Программное обеспечение устройства актуально.",
          "Oprogramowanie urządzenia jest aktualne.",
          "health_check_software_passed"
    ],
    health_check_software_failed: [
          "Device software is out of date.",
          "Device software is out of date.",
          "デバイスソフトウェアが最新ではありません。",
          "设备软件不是最新版本。",
          "Die Gerätesoftware ist nicht aktuell.",
          "Le logiciel de l’appareil n’est pas à jour.",
          "Il software del dispositivo non è aggiornato.",
          "O software do dispositivo está desatualizado.",
          "El software del dispositivo no está actualizado.",
          "Программное обеспечение устройства устарело.",
          "Oprogramowanie urządzenia jest nieaktualne.",
          "health_check_software_failed"
    ],
    health_check_calibration_no_date: [
          "No calibration date is available.",
          "No calibration date is available.",
          "校正日がありません。",
          "没有可用的校准日期。",
          "Kein Kalibrierungsdatum verfügbar.",
          "Aucune date d’étalonnage n’est disponible.",
          "Nessuna data di calibrazione disponibile.",
          "Não está disponível uma data de calibração.",
          "No hay disponible una fecha de calibración.",
          "Дата калибровки недоступна.",
          "Brak dostępnej daty kalibracji.",
          "health_check_calibration_no_date"
    ],
    health_check_calibration_passed: [
          "Calibration is valid until ${expectedValue}.",
          "Calibration is valid until ${expectedValue}.",
          "校正は ${expectedValue} まで有効です。",
          "校准有效期至 ${expectedValue}。",
          "Die Kalibrierung ist bis ${expectedValue} gültig.",
          "L’étalonnage est valide jusqu’au ${expectedValue}.",
          "La calibrazione è valida fino al ${expectedValue}.",
          "A calibração é válida até ${expectedValue}.",
          "La calibración es válida hasta ${expectedValue}.",
          "Калибровка действительна до ${expectedValue}.",
          "Kalibracja jest ważna do ${expectedValue}.",
          "health_check_calibration_passed"
    ],
    health_check_calibration_failed: [
          "Calibration expired on ${expectedValue}.",
          "Calibration expired on ${expectedValue}.",
          "校正の有効期限は ${expectedValue} に切れました。",
          "校准已于 ${expectedValue} 到期。",
          "Die Kalibrierung ist am ${expectedValue} abgelaufen.",
          "L’étalonnage a expiré le ${expectedValue}.",
          "La calibrazione è scaduta il ${expectedValue}.",
          "A calibração expirou em ${expectedValue}.",
          "La calibración venció el ${expectedValue}.",
          "Срок действия калибровки истек ${expectedValue}.",
          "Kalibracja wygasła ${expectedValue}.",
          "health_check_calibration_failed"
    ],
    health_check_lastsync_never: [
          "This device has never synced.",
          "This device has never synced.",
          "このデバイスは一度も同期されていません。",
          "此设备从未同步。",
          "Dieses Gerät wurde noch nie synchronisiert.",
          "Cet appareil n’a jamais été synchronisé.",
          "Questo dispositivo non è mai stato sincronizzato.",
          "Este dispositivo nunca foi sincronizado.",
          "Este dispositivo nunca se ha sincronizado.",
          "Это устройство никогда не синхронизировалось.",
          "To urządzenie nigdy nie zostało zsynchronizowane.",
          "health_check_lastsync_never"
    ],
    health_check_lastsync_passed: [
          "Last synced ${currentValue} days ago",
          "Last synced ${currentValue} days ago",
          "${currentValue} 日前に最後に同期されました",
          "${currentValue} 天前最后一次同步",
          "Zuletzt vor ${currentValue} Tagen synchronisiert",
          "Dernière synchronisation il y a ${currentValue} jours",
          "Ultima sincronizzazione ${currentValue} giorni fa",
          "Última sincronização há ${currentValue} dias",
          "Última sincronización hace ${currentValue} días",
          "Последняя синхронизация ${currentValue} дней назад",
          "Ostatnia synchronizacja ${currentValue} dni temu",
          "health_check_lastsync_passed"
    ],
    health_check_lastsync_failed: [
          "Last synced ${currentValue} days ago, exceeds ${expectedValue} day threshold",
          "Last synced ${currentValue} days ago, exceeds ${expectedValue} day threshold",
          "最後の同期は ${currentValue} 日前で、${expectedValue} 日のしきい値を超えています",
          "最后一次同步在 ${currentValue} 天前，超过了 ${expectedValue} 天的阈值",
          "Zuletzt vor ${currentValue} Tagen synchronisiert; der Schwellenwert von ${expectedValue} Tagen wurde überschritten",
          "Dernière synchronisation il y a ${currentValue} jours, dépasse le seuil de ${expectedValue} jours",
          "Ultima sincronizzazione ${currentValue} giorni fa; supera la soglia di ${expectedValue} giorni",
          "Última sincronização há ${currentValue} dias; excede o limite de ${expectedValue} dias",
          "Última sincronización hace ${currentValue} días; supera el umbral de ${expectedValue} días",
          "Последняя синхронизация ${currentValue} дней назад, превышен порог в ${expectedValue} дней",
          "Ostatnia synchronizacja ${currentValue} dni temu; przekracza próg ${expectedValue} dni",
          "health_check_lastsync_failed"
    ],
    eap_method: [
      "EAP Method",
      "EAP Method",
      "EAP方式",
      "EAP 方法",
      "EAP-Methode",
      "Méthode EAP",
      "Metodo EAP",
      "Método EAP",
      "Método EAP",
      "Метод EAP",
      "Metoda EAP",
      "eap_method"
    ],
    phase2_method: [
      "Phase2 Method",
      "Phase2 Method",
      "フェーズ2方式",
      "第二阶段方法",
      "Phase-2-Methode",
      "Méthode de phase 2",
      "Metodo fase 2",
      "Método da fase 2",
      "Método de fase 2",
      "Метод фазы 2",
      "Metoda fazy 2",
      "phase2_method"
    ],
    key_mgmt_used: [
      "Key Management Used",
      "Key Management Used",
      "使用中のキー管理",
      "使用的密钥管理",
      "Verwendete Schlüsselverwaltung",
      "Gestion des clés utilisée",
      "Gestione delle chiavi utilizzata",
      "Gestão de chaves utilizada",
      "Gestión de claves utilizada",
      "Используемое управление ключами",
      "Używane zarządzanie kluczami",
      "key_mgmt_used"
    ],
    logs: [
      "Logs",
      "Logs",
      "ログ",
      "日志",
      "Protokolle",
      "Journaux",
      "Log",
      "Registos",
      "Registros",
      "Журналы",
      "Dzienniki",
      "logs"
    ],
    event: [
      "Event",
      "Event",
      "イベント",
      "事件",
      "Ereignis",
      "Événement",
      "Evento",
      "Evento",
      "Evento",
      "Событие",
      "Zdarzenie",
      "event"
    ],
    "Authorized": [
      "Authorized",
      "Authorized",
      "認証済み",
      "已授权",
      "Autorisiert",
      "Autorisé",
      "Autorizzato",
      "Autorizado",
      "Autorizado",
      "Авторизован",
      "Autoryzowano",
      "Authorized"
    ],
    "Auth Completed Successfully": [
      "Authentication Completed",
      "Authentication Completed",
      "認証完了",
      "身份验证已完成",
      "Authentifizierung abgeschlossen",
      "Authentification terminée",
      "Autenticazione completata",
      "Autenticação concluída",
      "Autenticación completada",
      "Аутентификация завершена",
      "Uwierzytelnianie zakończone",
      "Auth Completed Successfully"
    ],
    region: [
      "Region",
      "Region",
      "地域",
      "地区",
      "Region",
      "Région",
      "Regione",
      "Região",
      "Región",
      "Регион",
      "Region",
      "region"
    ],
    "lldpNoPoe": [
      "Not enabled or detected",
      "Not enabled or detected",
      "有効化されていないか、検出されていません",
      "未启用或未检测到",
      "Nicht aktiviert oder nicht erkannt",
      "Non activé ou non détecté",
      "Non abilitato o non rilevato",
      "Não ativado ou não detetado",
      "No habilitado o no detectado",
      "Не включено или не обнаружено",
      "Nie włączono lub nie wykryto",
      "lldpNoPoe"
    ],
    "asn_org": [
      "ASN Organisation",
      "ASN Organization",
      "ASN組織",
      "ASN 组织",
      "ASN-Organisation",
      "Organisation ASN",
      "Organizzazione ASN",
      "Organização ASN",
      "Organización ASN",
      "Организация ASN",
      "Organizacja ASN",
      "asn_org"
    ],
    "Unavailable": [
      "Unavailable",
      "Unavailable",
      "利用不可",
      "不可用",
      "Nicht verfügbar",
      "Non disponible",
      "Non disponibile",
      "Indisponível",
      "No disponible",
      "Недоступно",
      "Niedostępne",
      "Unavailable"
    ],
    "requested": [
      "Requested",
      "Requested",
      "要求済み",
      "已请求",
      "Angefordert",
      "Demandé",
      "Richiesto",
      "Solicitado",
      "Solicitado",
      "Запрошено",
      "Żądane",
      "Requested"
    ],
    "allocated": [
      "Allocated",
      "Allocated",
      "割り当て済み",
      "已分配",
      "Zugewiesen",
      "Alloué",
      "Assegnato",
      "Atribuído",
      "Asignado",
      "Выделено",
      "Przydzielone",
      "Allocated"
    ],
  }
};

export default languagePack;
